'use strict';

export function appMessages () {
        return {
            restrict: 'EA',
            templateUrl: 'ktdirectivetemplates/appmsg.html',
            //replace: true,
           // transclude:true,
            scope: {
               messageList : '='

            },
            controller: function($scope,$sce,MessagingService)
            {
                 $scope.msvc = MessagingService;
                  $scope.messageList = $scope.msvc.getMessages();
            
            $scope.showMessageList= false;
            
           
            
            $scope.closeAllClicked = function(){
             
                $scope.closeAllClickedVar = true;
                $scope.msvc.removeAllMessages();
               setTimeout(function(){$scope.closeAllClickedVar=false},2000);
        
            };
            
             $scope.closeAlert = function(id){
             
                $scope.messageList[id].show = false;
             
                var visible = $scope.msvc.checkForVisibleMessages();
             
                if (visible==0) $scope.msvc.removeAllMessages();
        
            };
            
            $scope.countVisible = function(){
              
                var countVisibleMsg=0;
                for (var i=0;i< $scope.messageList.length;i++)
                {
                  if ($scope.messageList[i].show) countVisibleMsg++;
                  
                }
                return countVisibleMsg;
            }
            
            
             $scope.convertToHtml = function(msg){
               return $sce.trustAsHtml(msg);
            };
            },
            link: function (scope, element, attrs) {
            
            
          
            
           


            }
        };
};

'use strict';


export function ktActionButtons (dragulaService,$rootScope) {

        return {
            restrict: 'A',
            
            controller: function($scope,UserService,ResourcesDataService,TaskDataService,MessagingService,WidgetDataExchangeService,$rootScope,GridsterService,UtilityService,CODES_CONST,$stateParams,$state,KatalyoStateManager,$templateCache,$compile,$element,$timeout,$window)
            {
                $scope.gsrvc= GridsterService;
                $scope.CTRLNAME="ktActionButtons"
                if ($scope.fd.localVars===undefined) $scope.fd.localVars = {}
                
                $scope.fd.localVars.wdes = WidgetDataExchangeService

                $scope.fd.localVars.actionTypes = [
                 // {id:2,name: "Process widgets", value: "procwidgets"},
                  {id:5,name: "Widget action",  value: "widgetaction"},
                  {id:8, name: "Open Page", value: "openpage"},
                   {id:9, name: "Go to previous page", value: "backbutton"},
                // {id:0,name: "Execute task", value: "executetask"},
                //  {id:1,name: "Start task", value: "runtask"},
                //  {id:3,name: "Refresh task",  value: "refreshtask"},
                //  {id:4, name: "Complete task", value: "completetask"},
                //  {id:6, name: "Close form", value: "closeform"},
                //  {id:7, name: "Clear form", value: "clearform"},
                //  {id:10, name: "Initiate task", value: "initiatetask"}
                ]
                
                $scope.fd.localVars.actionButtonClass=['btn-xs','btn-sm','','btn-lg']
                $scope.fd.localVars.actionButtonSize=['Extra Small','Small','Normal','Large']
                        
                
                $scope.fd.localVars.actionsExecuted={}
				$scope.fd.localVars.actionScope={}
            
                $scope.fd.localVars.showMenu = false
                $scope.taskId=$scope.resourceDefinition.ResourceDefId

                if ($scope.fd.FormDef===undefined || $scope.fd.FormDef===null || $scope.fd.FormDef==="") $scope.fd.FormDef=[];
      
                
                  $scope.fd.localVars.toggleDropdown = function(){
                    $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
                    }
                
                 if ($scope.resourceDefinition!=undefined)
                {
                  $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
                  $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
                  $scope.fd.localVars.resourceDefinition = $scope.resourceDefinition;
                  $scope.fd.localVars.previousTask = $scope.taskExecuteId;
                  if ($scope.fd.localVars.previousTask==undefined) $scope.fd.localVars.previousTask = $scope.taskInitiateId;
                }else $scope.resourceDefinition = $scope.fd.localVars.resourceDefinition;

                
                
                if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
                $scope.fd.Parameters.UuidRef = $scope.fd.UuidRef
                let w_actions=[
                    {id:0,name:'toggleVisibility'},
                    {id:1,name:'showField'},
                    {id:2,name:'hideField'},
                    {id:3,name:'hideButton'},
                ]
                let widgetDefinition = {widgetLabel: 'Action buttons',widgetName: 'actionBtns',widgetId: $scope.fd.UuidRef,fd:$scope.fd,actions:w_actions,dataSource:true, task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,parentResourceId:$scope.fd.localVars.resourceDefinition.uid};
                $scope.fd.localVars.LocalId=WidgetDataExchangeService.registerWidget(widgetDefinition);
               

                /*********** SETUP KATALYO STATE MANAGER *************************/
                $scope.ksm = KatalyoStateManager;
                let initiatedTaskId=null;
                let initiateTaskState= $scope.ksm.addSubject("initiateTaskState"+$scope.fd.UuidRef,initiatedTaskId);
                let initiateTaskStateName = initiateTaskState.subject.name;
                
                let task_initiated = function(data)
                {
                    initiateTaskState.subject.setStateChanges = data;
                    initiateTaskState.subject.notifyObservers("task_initiated");
                    
                };
                
                let action_task_initiated = $scope.ksm.addAction(initiateTaskStateName,"task_initiated",task_initiated);
               
      
                
                const subjectActBtn= $scope.resourceDefinition.page_state_id+"-"+$scope.fd.UuidRef

                let valueStateActBtn= $scope.ksm.addSubject(subjectActBtn,null);
                const valueStateActBtnName = valueStateActBtn.subject.name;
        
                let show_field = function(data)
                {
                    $scope.fd.ShowField = true
                    let state = data
                    state['val'] = true
                    valueStateActBtn.subject.setStateChanges = state
                    valueStateActBtn.subject.notifyObservers("showField",state);
                }
                let hide_field = function(data)
                {
                    $scope.fd.ShowField = false
                    let state = data
                    state['val'] = false
                    valueStateActBtn.subject.setStateChanges = state
                    valueStateActBtn.subject.notifyObservers("hideField",state);
                }

                let toggle_visibility = function(data)
                {
                    $scope.fd.ShowField = !$scope.fd.ShowField
                    let state = data
                    state['val'] = $scope.fd.ShowField
                    valueStateActBtn.subject.setStateChanges = state
                    valueStateActBtn.subject.notifyObservers("toggleVisibility",state);
                }

                
                let action_show = $scope.ksm.addAction(valueStateActBtnName,"showField",show_field);
                let action_hide = $scope.ksm.addAction(valueStateActBtnName,"hideField",hide_field);
                let action_toggle = $scope.ksm.addAction(valueStateActBtnName,"toggleVisibility",toggle_visibility);



                 $scope.fd.localVars.onSelectFn = function(item,model,index) {
                    //debugger  
                     $scope.fd.localVars.selectedButton.actions[index].action = item
                 }
    
                
                $scope.GetOutcomes = function(){
                                
                              var lang=$rootScope.globals.currentUser.lang;               
                              var outcomeId = 0                /*MIGOR provjeriti jos*/  
                             
                              if ($scope.fd.localVars.resourceDefinition?.TaskOutcomeHeadId !=undefined) outcomeId = $scope.fd.localVars.resourceDefinition.TaskOutcomeHeadId;
                              

                              if (!$scope.outcomesDownloaded && outcomeId>0)
                               {   
                                    TaskDataService.GetTaskOutcomes( $scope.fd.localVars.resourceDefinition?.ResourceDefId,outcomeId,lang).then(function(data) {            
                                               
                                            $scope.fd.localVars.outcomes = data.data;
                                            $scope.outcomesDownloaded = true;
                                             
                                             
                                    },function(error){
                                             
                                             MessagingService.addMessage(error.msg,'error');
                                    });
                               }
                               else
                               {
                                $scope.loadingActions=false;      
                               }
                 
                }//GetOutcomes
                
                if ($scope.fd.localVars.outcomes==undefined)  {
                    $scope.GetOutcomes();   
                }
                
                $scope.fd.localVars.loadedTasks = [];
                if ($scope.fd.localVars.actionButtonProps==undefined)
                {
                    $scope.fd.localVars.actionButtonProps={};
                }
                
                $scope.fd.localVars.actionButtonProps[$scope.fd.UuidRef]=0;  

                $scope.fd.localVars.formType=$scope.resourceDefinition?.form_type;
                //var taskDefId = $stateParams.id;
                var lang=$rootScope.globals.currentUser.lang;
                $scope.fd.localVars.taskListParameters = {placeholder:'Select or search task...',label:$scope.fd.placeholder,name:'task',
                  paddingLeft:true,selectedItem:null,hideLabel:true,columnSizeLabel:'col-lg-24',dropdownSize:'col-lg-24',onSelectFunction:''};
              
                $scope.fd.localVars.selectedTaskIndex=-1;
                
                
                let process_event_task_action = function(data)
                {
                    
                    if (data?.state?.error==true) $scope.stopExecutingActions=true

                    if ($scope.fd.localVars.clickedButton!==undefined && $scope.fd.FormDef.length>$scope.fd.localVars.clickedButton && !$scope.stopExecutingActions){

                        for (let j=0;j<$scope.fd.FormDef[$scope.fd.localVars.clickedButton].visibilityAfterAction.length;j++)
                        {
                            $scope.fd.FormDef[j].hideButton = !$scope.fd.FormDef[$scope.fd.localVars.clickedButton].visibilityAfterAction[j].visible;
                        }
                    

                    
                        if (data?.state?.action_index!=undefined) 
                        {
                                $scope.fd.localVars.actionsExecuted[$scope.fd.localVars.clickedButton+'-'+data?.state?.action_index] = true
                                $scope.fd.localVars.processExecutionQueue(data?.state?.action_index)
                        }

                    }
                }

                let process_after_widget_action = function(data)
                {
                    if (data?.state?.error==true) $scope.stopExecutingActions=true

                    
                    if ($scope.fd.localVars.clickedButton!==undefined && $scope.fd.FormDef.length>$scope.fd.localVars.clickedButton && !$scope.stopExecutingActions){

                        for (let j=0;j<$scope.fd.FormDef[$scope.fd.localVars.clickedButton].visibilityAfterAction.length;j++)
                        {
                            $scope.fd.FormDef[j].hideButton = !$scope.fd.FormDef[$scope.fd.localVars.clickedButton].visibilityAfterAction[j].visible;
                        }
                    

                    
                        if (data?.state?.action_index!=undefined) 
                        {
                                $scope.fd.localVars.actionsExecuted[$scope.fd.localVars.clickedButton+'-'+data?.state?.action_index] = true
                                $scope.fd.localVars.processExecutionQueue(data?.state?.action_index)
                        }

                    }
                    
                }
                  
                let dependent_field1 = "Field"+$scope.fd.PresentationId;
                let subscribedSubject1 = "task"+$scope.resourceDefinition?.transaction_id
                let observer1 = $scope.ksm.subscribe(initiateTaskStateName,dependent_field1,"task_initiated",process_event_task_action);
                let subscribedSubject2 = "executeTaskStateName"+$scope.resourceDefinition?.transaction_id
                let observer2 = $scope.ksm.subscribe(subscribedSubject2,dependent_field1,"task_executed",process_event_task_action);

                let subscribedSubject3 = "processWidgetsStateName"+$scope.resourceDefinition?.page_state_id
                let observer3 = $scope.ksm.subscribe(subscribedSubject3,dependent_field1,"widgets_processed",process_event_task_action);

                
                                            
                  $scope.$on('InlineTaskClosed',function(event,data){
                    //var index=data;
                    //$scope.fd.loadedTasks.splice(index,1);
                    var taskId=data;
                    var pos = $scope.fd.localVars.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (pos>=0)
                    {
                      $scope.fd.localVars.loadedTasks.splice(pos,1);  
                    }
                });
                  
                  
                $scope.fd.localVars.LoadTask=function(taskId,outcomeId,previousTask,openTaskType,button)
                {
                    
                    var localVars = {'isInlineTask':$scope.fd.isInlineTask,'OpenTaskType':openTaskType,'taskIndex':$scope.fd.localVars.loadedTasks.length,'loadTaskDirect' : true,'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,};
                    
                    localVars.ShowCloseBtn = button.ShowCloseTaskBtn;
                    var pos = $scope.fd.localVars.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (pos<0 && openTaskType=="current")
                    {
                        $scope.fd.localVars.loadedTasks.splice(0,0,{'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                        $scope.ksm.executeAction(initiateTaskStateName,"task_initiated", {'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                         
                        
                    }else if (openTaskType=="inline")
                    {
                        $scope.fd.localVars.loadedTasks.length=0;
                        $scope.fd.localVars.loadedTasks.push({'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                        $scope.ksm.executeAction(initiateTaskStateName,"task_initiated", {'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                                
               
                    }else if (openTaskType=="container")
                    {
                        localVars = {'isInlineTask':$scope.fd.isInlineTask,'OpenTaskType':'current','taskIndex':0,'loadTaskDirect' : true,'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,};
                    
                         $scope.ksm.executeAction(initiateTaskStateName,"task_initiated", {'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                                
                    }
                    $scope.gsrvc.setOpenTaskType(openTaskType);
                    
                }
                  
                
                $scope.fd.localVars.copyToClipboard = function(text){
                    $scope.fd.localVars.copyUuid = true;

                    navigator.clipboard.writeText(text).then( 
                        () => {
                            $timeout(function(){$scope.fd.localVars.copyUuid = false;},1000);
                        },
                        () => {    /* clipboard write failed */
                            MessagingService.addMessage('Copy to clipboard failed','error');
                            $timeout(function(){$scope.fd.localVars.copyUuid = false;},1000);
                    });
                                    
                }

                $scope.fd.localVars.addButtonAction = function(){
                    
                    if ($scope.fd.localVars.selectedButton.actions==undefined) $scope.fd.localVars.selectedButton.actions=[]
                    $scope.fd.localVars.selectedButton.actions.push({id:$scope.fd.localVars.selectedButton.actions.length+1,widgetRef:'',widgetActionName:''})
                }
                $scope.fd.localVars.delButtonAction = function(index){
                    $scope.fd.localVars.selectedButton.actions.splice(index,1)
                }
                $scope.fd.localVars.insertButtonAction = function(index){
                    $scope.fd.localVars.selectedButton.actions.splice(index,0,{id:$scope.fd.localVars.selectedButton.actions.length+1,widgetRef:'',widgetActionName:''})
                }
                $scope.fd.localVars.ProcessOutcome = function (outcome,form){
                
                    for (var i=0;i<outcome.actions.length;i++) {
                      if (outcome.actions[i].type==1 || outcome.actions[i].type==2)
                      {
                         $scope.fd.localVars.InitiateTaskFromOutcome(outcome.actions[i].taskId,outcome.id1,outcome.actions[i].type,outcome.actions[i].actionParams,$scope.formData,outcome.actions[i].actionParams.OpenTaskType);
                             
                      }
                     
                    }
                    if (outcome.actions.length==0)
                    {
                       $scope.$emit("ExecuteTask"+$scope.resourceDefinition?.task_execute_id,{form:form,outcomeId:outcome.id1}); 
                      
                    }
                     
                };
                 
                 
                 
              $scope.fd.localVars.InitiateTaskFromOutcome = function (taskDefId,outcomeId,type,actionParams,exeForm,openInNewPage){
                      //save task instance form for later processing
                     
                      if (openInNewPage==undefined) openInNewPage='inline';
                      if ($scope.resourceDefinition?.task_execute_id!=undefined)
                      {
                      TaskDataService.saveTaskFormData($scope.resourceDefinition?.id,exeForm).then(function(data) {
                               if (type==2)
                               {
                                       $state.go('app.navbar.tasks.proc',{id: taskDefId,fromStateName:$state.current.name,
                                      fromStateParams:$state.params,prev_task_execute_id:$scope.resourceDefinition?.task_execute_id,outcome_id:outcomeId,presentation_id:0});
                               }
                               if (type==1)
                               {
                
                                
                                  $scope.fd.localVars.fromOutcome=true;
                                  if (taskDefId!=undefined &&  taskDefId>0) $scope.fd.localVars.LoadTask(taskDefId,outcomeId,$scope.resourceDefinition?.task_execute_id,openInNewPage);          
                               }
                                 },function(error){
                                   MessagingService.addMessage(error.msg,'error');

                             });

                      }else
                      {
                         MessagingService.addMessage("Invalid task data --> Task execution object is undefined",'error');
                      }
                };
                 

                
                $scope.fd.localVars.ProcessSingleAction=function(button,action,event,previousTask,index,action_idx,old_clicked_btn){
                    
                    $scope.fd.localVars.actionsExecuted[$scope.fd.localVars.clickedButton+'-'+action_idx] = false

                        if (action.action.value=='completetask')
                        {
                         
                          $scope.fd.localVars.ProcessOutcome(action.outcome,event.target.form);
                         // $scope.$emit("ExecuteTask"+$scope.resourceDefinition.task_execute_id,{form:event.target.form,outcomeId:button.outcome.id1}); 
                        }
                        else if (action.action.value=='runtask')
                        {
                           if (old_clicked_btn!==$scope.fd.localVars.clickedButton) $scope.fd.localVars.LoadTask(action.task.id,0,previousTask,action.OpenTaskType,action);
                        }
                        else if (action.action.value=='closeform')
                        {
                           
                             
                           $scope.ksm.executeAction(taskStateName,"task_closed");
                           $scope.$emit("CloseTaskForm"+$scope.resourceDefinition?.transaction_id,$scope.resourceDefinition?.ResourceDefId);
                           
                            
                        }
                        else if (action.action.value=='refreshtask')
                        {
                           $scope.fd.localVars.taskInitiated=false;
                           $scope.$emit("RefreshTask"+$scope.resourceDefinition?.ResourceDefId,$scope.resourceDefinition?.ResourceDefId); 
                        }
                        else if (action.action.value=='executetask')
                        {
                           let taskStateName = "task"+$scope.resourceDefinition?.prev_task_transaction_id
                           $scope.fd.localVars.taskInitiated=false;
                           $scope.$emit("ExecuteTask"+$scope.resourceDefinition?.task_execute_id,{form:event.target.form,outcomeId:null}); 
                        }
                        else if (action.action.value=='taskstatus')
                        {
                            
                        }
                        else if (action.action.value=='procwidgets')
                        {
                           
                           $scope.$emit("ProcessWidgets"+$scope.resourceDefinition?.page_state_id,{form:event.target.form,action_index:action_idx});  
                        }
                         
                        else if (action.action.value=='widgetaction')
                        {
                          
                            //ToDo - create workflow with conditions (execute action based on condition) 
                            if (action.dependsOn>0){

                            
                                if ($scope.fd.localVars.actionsExecuted[$scope.fd.localVars.clickedButton+'-'+(action.dependsOn-1)]==true)  
                                {
                                    let observer_widget_action = $scope.ksm.subscribe($scope.resourceDefinition?.page_state_id+'-'+action.widgetRef,dependent_field1,action.widgetActionName,process_after_widget_action)
                                    $scope.ksm.executeAction($scope.resourceDefinition?.page_state_id+'-'+action.widgetRef,action.widgetActionName,{'action_index':action_idx})
                                    
                                }
                                else $scope.fd.localVars.executionQueue.push({button:button,action:action,event:event,previousTask:previousTask,index:index,action_idx:action_idx,depends_idx:action.dependsOn-1,old_clicked_btn:old_clicked_btn}) //put in execution queue
                          
                            }else{
                                let observer_widget_action = $scope.ksm.subscribe($scope.resourceDefinition?.page_state_id+'-'+action.widgetRef,dependent_field1,action.widgetActionName,process_after_widget_action)
                            
                                $scope.ksm.executeAction($scope.resourceDefinition?.page_state_id+'-'+action.widgetRef,action.widgetActionName,{'action_index':action_idx})
                            }
                        }
                         else if (action.action.value=='clearform')
                        {
                           
                           
                           let widgetStateName = "taskWidget"+action.widgetId;
                           $scope.ksm.executeAction(widgetStateName,action.action.value);
  
                        }
                        else if (action.action.value=='openpage')
                        {
                            let page_version 
                            
                            if (action.SelectVersionDirect) page_version = action.selectedPublishedResource?.Version
                            else page_version=0

                            $state.go(action.page_def.ResourceExtended.Target,{pageid: action.page.id,rinstance:0,version:page_version,parameters:{prev_page_state_id:$scope.resourceDefinition.page_state_id,prev_task:$scope.resourceDefinition,use_state:action.use_state}});
                        }
                        else if (action.action.value=='backbutton')
                        {
                            $window.history.back();
                        }
                    

                }

                $scope.fd.localVars.processExecutionQueue=function(action_idx)
                {
                    

                       for (let l=0;l<$scope.fd.localVars.executionQueue.length;l++)
                        {
                            if ($scope.fd.localVars.executionQueue[l].depends_idx==action_idx && !$scope.fd.localVars.executionQueue[l].processed)
                            {
                                $scope.fd.localVars.ProcessSingleAction($scope.fd.localVars.executionQueue[l].button,$scope.fd.localVars.executionQueue[l].action,$scope.fd.localVars.executionQueue[l].event,$scope.fd.localVars.executionQueue[l].previousTask,$scope.fd.localVars.executionQueue[l].index,$scope.fd.localVars.executionQueue[l].action_idx,$scope.fd.localVars.executionQueue[l].old_clicked_btn)
                                $scope.fd.localVars.executionQueue[l].processed = true
                            }
                        }
                }
            $scope.fd.localVars.getPublishedResources=function(pageId,isChecked)
            {
                
                if (isChecked){
                    if ($scope.fd.localVars.publishedResourceList==undefined)  $scope.fd.localVars.publishedResourceList={}
                      
                    ResourcesDataService.GetPublishedResourcesByTypeId(pageId,'form').then(
                    function (data) {       
                  
                    $scope.fd.localVars.publishedResourceList[pageId] = data.data;
                    
                   
                   },function(error){    
                        MessagingService.addMessage(error.msg,'error');
                    });
                }
            
            }  
                $scope.fd.localVars.ProcessButtonAction=function(button,event,previousTask,index)
                {
                    
                    let old_clicked_btn = $scope.fd.localVars.clickedButton
                    $scope.fd.localVars.clickedButton = index
                    $scope.fd.localVars.executionQueue=[]
                    if (button.actions==undefined)
                    {
                        button.actions=[]
                        let action = angular.copy(button)
                        action.action=button.action
                        if (button.action!=undefined) button.actions.push(action)
                    
                    }
                    
                    $scope.stopExecutingActions = false

                    for (let i=0;i<button.actions?.length;i++)
                    {
                        
                        $scope.fd.localVars.ProcessSingleAction(button,button.actions[i],event,previousTask,index,i,old_clicked_btn)
                    }
                    //if (button.processButtonVisibility) process_event_task_action()
                };
                
                
                $scope.fd.localVars.onSelectWidgetCallback = function(item,model,actionButton)
                {
                   item.loaded = false
                   // debugger
                    $timeout(function(){ 
                            actionButton.widgetRef = item?.id
							actionButton.widgetRefObj = item
                            item.loaded = true
                    })
                    

                }

                 $scope.fd.localVars.onSelectActionCallback = function(item,model,action)
                {
                    action.widgetActionName = item?.name
                }

                $scope.fd.localVars.onSelectPageCallback=function(item,model,idx)
                {
                    
                    if (item?.id!=undefined && $scope.fd.localVars.selectedButton!=undefined)
                    {
                        ResourcesDataService.getResourceDefAll(item.id).then(function(data) { 
							//debugger
                                    //$scope.fd.localVars.selectedButton.actions[idx].page_def = data.data;   page_def?.ResourceExtended?.Target, page_def?.uid,
									   $scope.fd.localVars.selectedButton.actions[idx].page_def = {
										   uid: data.data.uid,
										   ResourceExtended : {
											   Target: 	data.data.ResourceExtended.Target
										   }
									   }
                                  
                        })
                    }
                }

                 $scope.fd.localVars.getNewActionButton = function()
                 {
                    var newButton = {
                        /*action: $scope.fd.localVars.actionTypes[0],*/
						actions: [],
                        btnLabel: "New button",
                        btnClass: "btn-outline-primary",
                        size:"Normal",
                        textAlign:"left",
                        sizeIndex:2,
                        visibilityAfterAction:$scope.fd.localVars.populateButtons(),
                    }
                    
                    return newButton
                    
                 
                 };

                 $scope.fd.localVars.populateButtons = function()
                {
                        let btns = []
                        for (let i=0;i<$scope.fd.FormDef.length;i++)
                        {
                            btns.push({'index':i,'visible':true})
                        }
                        return btns
                }
                    

                $scope.fd.localVars.addShowHideVars = function(index)
                {
                        for (let i=0;i<$scope.fd.FormDef.length;i++)
                        {
                        $scope.fd.FormDef[i].visibilityAfterAction.push({'index':index,'visible':true})
                        }
                }
                  
                  
                  $scope.fd.localVars.taskSelected = function(item,model)
                  {
                    $scope.fd.localVars.taskListParameters.selectedItem = item;
                    $scope.fd.localVars.selectedTask={};
                  };
                  
                   $scope.fd.localVars.taskIsOpen = function(taskId)
                  {
                    var isOpenPos = $scope.fd.localVars.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (isOpenPos>=0) return true;
                    else return false;
                  };
                  
                   $scope.fd.localVars.showButtonDefinition = function (index,noShow){
                    
                        //debugger  //showButtonDefinition
                        $scope.fd.localVars.loadingActions=true
                        $scope.fd.localVars.selectedButton=undefined

                        $scope.fd.localVars.selectedButtonIndex=index;
                        
                        $scope.fd.localVars.selectedButton = $scope.fd.FormDef[index];
                        
                        if ($scope.fd.localVars.selectedButton?.action && !$scope.fd.localVars.selectedButton?.actions)

                        {

                          
                            let subaction = $scope.fd.localVars.selectedButton.action
                            subaction['page'] = $scope.fd.localVars.selectedButton.page
                            subaction['SelectVersionDirect'] = $scope.fd.localVars.selectedButton.SelectVersionDirect
                            subaction['selectedPublishedResource'] = $scope.fd.localVars.selectedButton.selectedPublishedResource
                            
                            let action = {id:1,widgetRef:'',widgetActionName:$scope.fd.localVars.selectedButton.action.name,action:subaction}
                            action['page'] = $scope.fd.localVars.selectedButton.page
                            action['SelectVersionDirect'] = $scope.fd.localVars.selectedButton.SelectVersionDirect
                            action['selectedPublishedResource'] = $scope.fd.localVars.selectedButton.selectedPublishedResource
                            
                            $scope.fd.localVars.selectedButton.actions=[action]
                        }

         
                            
                        for (let i =0;i<$scope.fd.localVars.actionButtonClass.length;i++)
                        {
                            if($scope.fd.localVars.actionButtonClass[i]===$scope.fd.localVars.selectedButton?.size)
                            {

                                $scope.fd.localVars.selectedButtonSizeIndex = i
                                if ($scope.fd.localVars.selectedButton!=undefined) $scope.fd.localVars.selectedButton.sizeIndex= i
                            }
                        }
                        if ($scope.fd.localVars.selectedButtonSizeIndex==undefined && $scope.fd.localVars.selectedButton!=undefined)
                        {
                                    $scope.fd.localVars.selectedButtonSizeIndex=2
                                    $scope.fd.localVars.selectedButton.sizeIndex = 2
                                    $scope.fd.localVars.selectedButton.size= $scope.fd.localVars.actionButtonClass[$scope.fd.localVars.selectedButtonSizeIndex]
                        }

                        if (!noShow) $scope.fd.localVars.actionButtonProps[$scope.fd.UuidRef] = 1
                        
                        $scope.fd.localVars.setupDragula($scope.fd.localVars.selectedButtonIndex)
                        
                        $timeout(function(){
                            $scope.fd.localVars.loadingActions=false
                        })
                   };
                   


                    $scope.fd.localVars.toggleButtonDefinition = function (index){
                    
                        
                            $scope.fd.localVars.showButtonDefinition(index,true)

                            if ($scope.fd.localVars.actionButtonProps[$scope.fd.UuidRef] !=1)
                                $scope.fd.localVars.actionButtonProps[$scope.fd.UuidRef] = 1
                            else    
                                $scope.fd.localVars.actionButtonProps[$scope.fd.UuidRef] = 0 //toggle



                   };
                   
                  
                  $scope.fd.localVars.addButtonToList = function (){
                 
                     
                            $scope.fd.FormDef.push( $scope.fd.localVars.getNewActionButton()) 
                            $scope.fd.localVars.addShowHideVars($scope.fd.FormDef.length-1)
                            $scope.fd.localVars.showButtonDefinition($scope.fd.FormDef.length-1);
               
                     
                 };
                  
                  $scope.fd.localVars.clearVisibilityParams=function(index)

                  {
					//remove items with specific index 
					for (let i = 0; i < $scope.fd.FormDef.length; i++) {
						$scope.fd.FormDef[i].visibilityAfterAction = $scope.fd.FormDef[i].visibilityAfterAction.filter(action => action.index !== index);
					}


                  
                        

                  }
                     
                   $scope.fd.localVars.RemoveButtonFromList = function (index)
                   { 
                                     
                      $scope.fd.localVars.clearVisibilityParams(index)
					  
					  if (index>=0)       
						  $scope.fd.FormDef.splice(index,1);
					  
                      if ($scope.fd.FormDef.length > 0) 
                            $scope.fd.localVars.showButtonDefinition($scope.fd.FormDef.length - 1)

                      
                    }
          
          
                 $scope.fd.localVars.saveTaskToResource = function(tdid,tei,datasetDefId,datasetRecordId){
                          TaskDataService.saveTaskToResource(tei,datasetDefId,datasetRecordId,$scope.fd.presentationId).then(function(data) {
                                                    
                              $state.go('app.navbar.tasks.initiate',{id: tdid,fromStateName:$state.current.name,fromStateParams:$state.params,outcome_id:0,prev_task_execute_id:tei});
                                                             
                                
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
             }
             
             if   ($scope.gsrvc.getFormViewType()==1 || $scope.fd.ElementType=='itask')
             {
            
                ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
                                                    
                                $scope.fd.localVars.taskList = data.data;
                                $scope.fd.localVars.tasksLoaded=true;
                                
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
                 }
        if ($scope.resourceDefinition?.form_definition) 
        {
              ResourcesDataService.getResourceDefListByType(lang,'page').then(function(data) {
                                                    
                                  $scope.fd.localVars.pageList = data.data;
                                                               
                                $scope.fd.localVars.pagesLoaded=true;
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
        }
              
			  
			  
			 $scope.fd.localVars.prepareActionScope = function( btn, index) {
				 			 
				 
				if ($scope.fd.localVars.actionScope[$scope.fd.localVars.selectedButtonIndex]==undefined)
							$scope.fd.localVars.actionScope[$scope.fd.localVars.selectedButtonIndex]= { }
				if ($scope.fd.localVars.actionScope[$scope.fd.localVars.selectedButtonIndex][index] == undefined) 
						$scope.fd.localVars.actionScope[$scope.fd.localVars.selectedButtonIndex][index] = {}
				
				let wregistryList = $scope.fd.localVars.wdes.widgetRegistryList[$scope.resourceDefinition.uid]
				
				if (btn?.widgetRef) {
						btn.widgetRefObj = wregistryList.find(obj => obj.id === btn.widgetRef)	
				}
											 
	 
				 if (btn?.widgetRefObj?.id) { 
				 
				 	    let item = wregistryList.find(obj => obj.id === btn?.widgetRefObj?.id)
						
						btn.widgetRefObj.loaded = true
				 
						if ( !btn.widgetRefObj.actions ) {
							 if (item?.actions) btn.widgetRefObj.actions = item?.actions							 
						}
				
				
						$scope.fd.localVars.actionScope[$scope.fd.localVars.selectedButtonIndex][index]= { widgetRefObj :  Object.assign( {}, btn.widgetRefObj )  } 
						delete btn.widgetRefObj.loaded
						//delete btn.widgetRefObj.actions
						
				}
				return 	$scope.fd.localVars.actionScope[$scope.fd.localVars.selectedButtonIndex][index]
			 }
			 
			  
			  
            let template;
            if ($scope.resourceDefinition?.form_definition) template = $templateCache.get('ktdirectivetemplates/ktActionButtons.html');
            else template = $templateCache.get('ktdirectivetemplates/ktActionButtonsExe.html');
          
            $element.append($compile(template)($scope));  

                },
            link: function (scope, elem, attrs) {

                
                scope.fd.localVars.setupDragula=function (index) {
                    
                    if (!index) index = 0
                   
                    let actionHandle = 'action-drag-handle'
                    let bag = dragulaService.find($rootScope, 'bag-action-'+scope.fd.UuidRef+'-'+index);
                    
                    /* 
                    if (bag) {
                        dragulaService.destroy($rootScope, 'bag-action-'+scope.fd.UuidRef+'-'+index);
                    }
                    */
                    if (!bag)
                    {
                    dragulaService.options($rootScope, 'bag-action-'+scope.fd.UuidRef+'-'+index, {
                            revertOnSpill: true,
                            removeOnSpill: false,
                            direction:'vertical',
                          //  copy:function(el,target, source){
                          //      return false
                          //  },
                            accept:function (el,target, source) {
                                return false;
                            },
                            moves: function (el, container, handle) {
                                
                                return handle.classList.contains(actionHandle);
                            }
                     });
                    }
                }
                scope.fd.localVars.actionsFinished= function(actions){
                    for (let i=0;i<actions.length;i++)
                    {
                        if (actions[i].id==undefined) actions[i].id = i+1
                    }
                }

                //scope.fd.localVars.showButtonDefinition(0)

                if (scope.fd.localVars.selectedButton!=undefined) scope.fd.localVars.setupDragula(scope.fd.localVars.selectedButtonIndex)
                
                
                /*
                 if (bag) bag.drake.on('drop-model',function(el,target,source){

                    target.id=scope.fd.localVars.selectedButton.actions.length+1
                    
                });
                */
        }
    }
              
};
'use strict';

export function ktActionInitiateTask () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktActionInitiateTask.html',
             
             controller: function($scope,$rootScope,ResourcesDataService,MessagingService){
              
              $scope.taskListParameters = {placeholder:'Select or search task...',label:'Initiate task',name:'task',
              paddingLeft:false,selectedItem:null,hideLabel:false,columnSizeLabel:'col-auto',dropdownSize:'col',selectedItem:null};
              
              $scope.taskListParameters.label = $scope.act.name1;
                        
               
              $scope.setInitiateTaskAction = function(item,model)
                        {
                      //  $scope.taskListParameters.label = $scope.$parent.act.name;
                        //$scope.$parent.act.taskId = item.id;
                        
                        $scope.act.taskId = item.id;
                        $scope.taskListParameters.selectedItem = item;
                        
 
                        };
                        
              
                var lang = $rootScope.globals.currentUser.lang;
               
               $scope.setTask = function(){
                if ($scope.act!=null && $scope.act!=undefined)
                {
                if ($scope.act.taskId!=null) {
                                  var pos = $scope.taskList.map(function(e) { return e.id; }).indexOf($scope.$parent.act.taskId);
                                  if (pos>-1) {
                                     $scope.taskListParameters.selectedItem = $scope.taskList[pos];
                                         
                                   }
                                  
                  }
                }
             };
             
             $scope.getTaskList = function()
             {
                if ($scope.taskList==undefined)
                {
                   ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
                                   
                                     $scope.taskList = data.data;
                                     $scope.setTask();
                                  
                                    
                                  },function(error){
                                   
                                     MessagingService.addMessage(error.msg,'error');
                               });
                }else  $scope.setTask();
                
              }; 
                
                 $scope.$watch('act.taskId', function(oldValue,newValue){
                     
                     $scope.getTaskList();
                   });
               
            
             
             $scope.getTaskList(); 
             
             },
             link: function (scope, elem, attrs) {
            
     
        }
    }
};

//export {ktActionInitiateTask};
'use strict';

export function ktActionSendNotification () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktActionSendNotification.html',
             
             controller: function($scope,$rootScope,ResourcesDataService,KatalyoStateManager,MessagingService){
              
              $scope.notificationSelected = function(item,model)
                        {
                            $scope.act.actionParams.notificationId = item.id;
                            
                        };
                        
              $scope.ksm = KatalyoStateManager
                var lang = $rootScope.globals.currentUser.lang;
               
                let dependent_field_pid = $scope.fd.LocalId;
                let subscribedSubjectPid = "formDefinitionState"+$scope.taskId+$scope.resourceDefinition.form_type;
                let dependent_field_pid2
                let update_presentation_id2 = function(data) {
                    let presentation_id = angular.copy($scope.fd.PresentationId)
                    if (data[presentation_id]!==undefined)
                    {
                        $scope.fd.PresentationId = data[presentation_id];
                    //unsubscribe here later after implementing unsubscribe - ToDo
                    dependent_field_pid2 = $scope.fd.PresentationId
                    let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
                    }
                }
                let update_presentation_id = function(data) {
                    if (data[$scope.fd.LocalId]>0 && $scope.fd.PresentationId==0 && data[$scope.fd.LocalId]!==undefined) $scope.fd.PresentationId = data[$scope.fd.LocalId];
                  
                    let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
                    //unsubscribe here later after implementing unsubscribe - ToDo
                }
                
                
                if ($scope.fd.PresentationId===null || $scope.fd.PresentationId===0)
                {
                    let observerPid = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid,"formSaved",update_presentation_id);
                } else{
                    dependent_field_pid2 = $scope.fd.PresentationId
                    let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
                }

               $scope.setNotification = function(){
                if ($scope.act!=null && $scope.act!=undefined)
                {
                if ($scope.act.actionParams.notificationId!=null) {
                                  var pos = $scope.notificationList.map(function(e) { return e.id; }).indexOf($scope.act.actionParams.notificationId);
                                  if (pos>-1) {
                                     $scope.act.actionParams.notification = $scope.notificationList[pos];
                                         
                                   }
                                  
                  }
                }
             }; 
             $scope.getNotificationList = function()
             {
                if ($scope.notificationList==undefined)
                {
                   ResourcesDataService.getResourceDefListByType(lang,'notification').then(function(data) {
                                   
                                     $scope.notificationList = data.data;
                                     $scope.act.notificationsLoaded = true;
                                     $scope.setNotification();
                                  
                                    
                                  },function(error){
                                   
                                     MessagingService.addMessage(error.msg,'error');
                               });
                }else $scope.setNotification();
                
              }; 
                
                /*
                 $scope.$watch('act.notificationId', function(oldValue,newValue){
                     
                     $scope.getNotificationList();
                   });
               */
            
             
             $scope.getNotificationList(); 
             
             },
             link: function (scope, elem, attrs) {
            
     
        }
    }
};

//export {ktActionInitiateTask};

'use strict';

export function ktActivity() {
       
                return {
                    restrict: 'EA',
                    controller: function(){},
                    templateUrl: 'ktdirectivetemplates/processing.html',
                    scope: {
                        message: '=',
                        //showMsg: '=',
                    },
                     controller: function($scope,PROCESSING_CONST){
                                $scope.showMsg=false;
                                $scope.showMsgObj={};     
                                $scope.$on(PROCESSING_CONST._START_REQUEST_, function (event,data) {
                                // got the request start notification, show the element
                                $scope.showMsgObj[data] = true;
                                $scope.showMsg=true;
                                });
             
                         $scope.$on(PROCESSING_CONST._END_REQUEST_, function (event,data) {
                             // got the request end notification, hide the element
                             delete $scope.showMsgObj[data];
                             var ol = Object.keys($scope.showMsgObj);
                             if (ol.length==0) $scope.showMsg=false;
                         });
                     },
                   link: function (scope, element, attrs) {
        
                       
             
                        
                        }
                   }
        
};
'use strict';

export function ktAdjustContentToNavbar(){
   
   var directive = {
		restrict 	: 'EA',
        link: function (scope, element, attrs) {
            
                
        },
        controller: function ($scope,$element,GridsterService)
        {
			/*
           $scope.gsrvc = GridsterService;
           
		   $scope.$watch(function(){
               if ($element[0].offsetHeight>0 && $scope.gsrvc.navbarHeight!=$element[0].offsetHeight)
               {
                $scope.gsrvc.setNavbarHeight($element[0].offsetHeight);
               }
            }); */
            
        }
	};
	return directive;

};
'use strict';

export function ktAppNavbar ($rootScope, dragulaService) {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktAppNavbar.html',
            scope:{
                localVars:'=',
                navbarItemsLeft:'=',
                navbarItemsRight:'=',
                resource:'=',
            },
            controller: ['$scope','$timeout','dragulaService','$rootScope','MenuService','ResourcesDataService','MessagingService','GridsterService','$state',
          
            function($scope,$timeout,dragulaService,$rootScope,MenuService,ResourcesDataService,MessagingService,GridsterService,$state){
               
               $scope.gsrvc = GridsterService;   
               $scope.CTRL='ktAppNavbar'
                
               $scope.$on("$destroy", function() {
                    dragulaService.destroy($rootScope, dragula_bag)
                });
             
               let currentUser=$rootScope.globals.currentUser;
 
               if ($rootScope.globals.navbars==undefined)  //for debugging purposes (if multiple navbars are there - not good)
                    $rootScope.globals.navbars=[$scope]
               else {
                        $rootScope.globals.navbars.push($scope)
               }
                
                if ($scope.localVars == undefined) $scope.localVars={};
                $scope.localVars.pagesLoaded=false;    
                let lang = $rootScope.globals.currentUser.lang;
                
                if ($scope.navbarItemsLeft==undefined) $scope.navbarItemsLeft = [];
                if ($scope.navbarItemsRight==undefined) $scope.navbarItemsRight = [];
                
                let widgetHandle = 'element-drag-handle';
                let setupDragula = $scope.gsrvc.setupDragula('app-menu-bag','app-menu-task-list',widgetHandle);
                let dragula_bag="app-menu-bag";
                let source_container_page = 'app-menu-page-list';
                
                let bag = dragulaService.find($rootScope, dragula_bag);
                
                if (!bag)  dragulaService.options($rootScope, dragula_bag, {
                          revertOnSpill: true,
                          removeOnSpill: false,
                          direction:'horizontal',
                          copy:function (el,source){
                            return source.id==source.id==source_container_page;
                           },
                          accept:function (el,target, source) {
                              return target.id!= source_container_page;     
                          },
                          moves: function (el, container, handle) {
                                    return handle.classList.contains(drag_handle);
                          }  
                   });
                    
               
                if (bag)  bag.drake.on('drop',
					function(el,target,source,sibling){
						let index;
						if (target.id==="navbarLeft" || target.id==="navbarRight"){
							if (sibling!==null) index = parseInt(sibling.id);
							else{
								if (target.id==="navbarLeft") index = $scope.navbarItemsLeft.length;
								else index = $scope.navbarItemsRight.length;
							}
							MenuService.setCurrentNavbarId(index);
							$scope.lastIndex = index;
							if ($scope.localVars.selectedNavbar!==undefined && $scope.localVars.selectedNavbar!==null){
								if ($scope.localVars.selectedNavbar?.index<index) $scope.localVars.selectedNavbar.index=index-1;
								else $scope.localVars.selectedNavbar.index=index;
							}
						
						} else {
							if (sibling!==null) index = parseInt(sibling.id);
							else index = $scope.localVars.selectedNavbar.layout.length;
							$scope.lastIndex = index;
							if ($scope.localVars.selectedMenu!==undefined && $scope.localVars.selectedMenu!==null)
							{
								if ($scope.localVars.selectedMenu?.index<index) $scope.localVars.selectedMenu.index=index-1;
								else $scope.localVars.selectedMenu.index=index;
							}
						}
					});
                
                if (bag) bag.drake.on('drop-model',function(el,target,source){
                    if (target.id==="navbarLeft") $scope.localVars.getNavbarDetails($scope.navbarItemsLeft,$scope.lastIndex); 
                    if (target.id==="navbarRight")  $scope.localVars.getNavbarDetails($scope.navbarItemsRight,$scope.lastIndex);
                    if (target.id==="sideMenu") $scope.localVars.getMenuDetails($scope.localVars.selectedNavbar.layout,$scope.lastIndex);
                });
                                
                 
                if (bag) bag.drake.on('$destroy', function() {
					 // debugger
                    dragulaService.destroy($rootScope, dragula_bag);
                });
        
                $scope.showModal = function (p_type) {
                    $('#menuPublish').modal('show'); 
                    $scope.modalAction=p_type
                    $scope.newPublishVersion = $scope.resource.NewVersion
                }
                                
				$scope.get_published_resource_forms=function(){               
					ResourcesDataService.GetPublishedResources($scope.resource.uid).then(function (data) {       
					   $scope.localVars.publishedResources = data.data;
					});
				}
			
            $scope.get_published_resource_forms();


            $scope.localVars.getNavbarDetails = function(navbar,index)
            {
                  if (navbar.length===index && navbar.length>0)   index--;
                  $scope.localVars.showNavbarDetails = false;
                  $scope.localVars.showMenuDetails = false;
                  $scope.localVars.selectedNavbar  = navbar[index];
                  
                  if ($scope.localVars.selectedNavbar != undefined)    {   
                      $scope.localVars.selectedNavbar.index=index;
                      $scope.localVars.selectedMenu = null;
                    
					// rebuild Target object
                    if ($scope.localVars.selectedNavbar.Target==undefined)	$scope.localVars.selectedNavbar.Target = {id:navbar[index].id,name:navbar[index].name}
                    //rebuild s_menu_Target
					if ($scope.localVars.selectedNavbar.s_menus_Target == undefined)    $scope.localVars.selectedNavbar.s_menus_Target = navbar[index].id	  
					if ($scope.localVars.selectedNavbar.s_menus_Name == undefined) 	$scope.localVars.selectedNavbar.s_menus_Name = navbar[index].name  
                    if ($scope.localVars.selectedNavbar.layout==undefined) 	$scope.localVars.selectedNavbar.layout = [];
                    
                        $timeout(function(){
									$scope.localVars.selectedNavbar.UsersGroupsDownloaded = true;
									$scope.localVars.showNavbarDetails = true;
									$scope.localVars.showNavbarDetailsFirst = true;
									$scope.selectedUsers =[]
									 $scope.selectedGroups =[]
                         })          
                      
                  }
                };
                
                
                $scope.localVars.getMenuDetails = function(menu,index)
                {
                  $scope.localVars.showMenuDetails = false;
                  if (menu.length===index) index--;
                  $scope.localVars.selectedMenu  = menu[index];
                  $scope.localVars.selectedMenu.index=index;
                  $scope.localVars.showMenuDetails = false;
                  $scope.localVars.showNavbarDetails = false;
                  if ($scope.localVars.selectedMenu.Target==undefined) $scope.localVars.selectedMenu.Target = {id:menu[index].id,name:menu[index].name};
                  if ($scope.localVars.selectedMenu.s_menus_Name==undefined) $scope.localVars.selectedMenu.s_menus_Name = menu[index].name;   
					   $timeout(function(){    
							$scope.localVars.showMenuDetails = true;
						})   
                };
                
                $scope.localVars.deleteNavbar = function(navbar,index,type) {
                   
                   if (type==="left") {
                        if (navbar.s_menus_id!==null && navbar.s_menus_id!==undefined) {
                            if (navbar.deleteItem) 
                                    navbar.deleteItem = false;
                            else navbar.deleteItem = true;                     
                        }
                        else {
                            $scope.navbarItemsLeft.splice(index,1);
                            $scope.localVars.selectedNavbar = null;
                        }
                           
                   }   else // not left
                   {
                    if (navbar.s_menus_id!==null) 
                        navbar.deleteItem = true;
                    else  {
                        $scope.navbarItemsRight.splice(index,1);
                        $scope.localVars.selectedNavbar = null;
                        $scope.localVars.showNavbarDetails = false;
                    }
                    
                   }
                  };
                  
                  $scope.localVars.deleteMenu = function(menu,index) {
                   
                    if (menu.s_menus_id!==null && menu.s_menus_id!==undefined)  {
                       if (menu.deleteItem) menu.deleteItem = false;
                       else menu.deleteItem = true;
                    }
                    else  {
                        $scope.localVars.selectedNavbar.layout.splice(index,1);
                        $scope.localVars.selectedMenu = null;
                        $scope.localVars.showMenuDetails = false;
                    }
                  };
                  
                $scope.activeLinkEditNavbarLeft = function(index) {
                   
                   for (let i=0;i<$scope.navbarItemsLeft.length;i++){
                    if (i==index)    return "active";
                    else "";
                   }
                   
                };
                

            $scope.newVersion = function()
            {
                $scope.creatingNewVersion=true

                ResourcesDataService.SetNewResourceVersion($scope.resource.uid)
                        .then(function(data) {
                            if (data.status==200)
                            {
                            $scope.resource.NewVersion = data.data
                            $scope.resource.Published=false
                            $scope.localVars.updateResource($scope.resource)
                            }else MessagingService.addMessage(data.data,'error');
                            $scope.creatingNewVersion=false
                            $scope.hasChanges=false
                 
                           },function(error){
                                          MessagingService.addMessage(error.msg,'error');
                                          $scope.creatingNewVersion=false
                                         
                                     });
            };

                $scope.buildDataset = function(e)
                {
                    $state.go("'app.navbar.resources.new",{'resource_type':'dataset'});
                };
                
                 $scope.buildPage = function(e)
                {
                    $state.go("'app.navbar.resources.new",{'resource_type':'page'});
                };
                
                $scope.$watch('navbarItemsLeft',function(newValue,oldValue){
                   let a=newValue
                }, true)
                
				
                $scope.saveMenu = function(is_valid) 
                {
                    if (is_valid)
                    {
                        let navbarLeft = angular.copy($scope.navbarItemsLeft);
                        let navbarRight = angular.copy($scope.navbarItemsRight); 
                        
                        $scope.localVars.showNavbarDetails = false;
                        $scope.localVars.showMenuDetails = false;
                        $scope.localVars.selectedNavbar = null;
                        $scope.savingMenu = true
                        
                        MenuService.saveFullAppMenu($scope.resource.uid, navbarLeft, navbarRight,null,$scope.localVars.newDescription,$scope.gsrvc.resourceFormVersion[$scope.resource.uid].Version).then(function(data) {
                             $timeout(function(){
                                    $scope.navbarItemsLeft.length = 0 
                                    $scope.navbarItemsRight.length = 0
                                    for (const item of data.navbarItemsLeft)    $scope.navbarItemsLeft.push(item);
                                    for (const item of data.navbarItemsRight)   $scope.navbarItemsRight.push(item);
                                    $('#menuPublish').modal('hide')
                                })
                                  $scope.savingMenu = false
                                 
                                  if (data.count_changes>0) $scope.resource.Published=true
                            MessagingService.addMessage(data.msg,'success');

                            
                        },
                        function(error){    
                            MessagingService.addMessage(error.msg,'error');
                              $scope.savingMenu = false
                        });
                     
                    }
                };
				
                //get pages
                ResourcesDataService.getResourceDefListByType(lang,'page').then(function(data) {					
					$scope.localVars.pageList = data.data;
                    for (let i=0;i<$scope.localVars.pageList.length;i++)
                    {
                       $scope.localVars.pageList[i].s_menus_PopulateType="navbar"; 
                    }
                    $scope.localVars.pagesLoaded=true;    
											 
                    },function(error){    
                    MessagingService.addMessage(error.msg,'error');
				});
            
            }],
            link: function (scope, elem, attrs) {
              
				  if (scope.navbarItemsRight.length==0) {
					let settings = {id:null,name:"Settings",s_menus_id:null,s_menus_Name:"Settings",s_menus_MenuPosition:"navbarright",s_menus_Icon:"fa fa-cog",s_menus_MenuType:2};
					scope.navbarItemsRight.push(settings);
					
				  }

				  let bag2 = dragulaService.find($rootScope, "app-menu-bag");
			
            }
        }
  
};

'use strict';

export function ktBasicTable() {
       
    return {
        restrict: 'EA',
        templateUrl: 'ktdirectivetemplates/ktBasicTable.html',
        scope: {
            columns: '=',
            data: '=',
            mapping:'='
        },
        controller: function($scope){
            
            $scope.getMapping = function(map)
      
            {
                
                return $scope.mapping[map]
            };

         },
       link: function (scope, element, attrs) {

           
 
            
            }
    }
        
};
'use strict';

export function ktBoolean () {
        return {
                restrict: 'A',
                controller: function ($scope,GridsterService,KatalyoStateManager) {
                        
                        $scope.gsrvc = GridsterService;
                        if (!$scope.fd.localVars) $scope.fd.localVars={} 
                         $scope.showProperties = function(event)
                          {
                             $scope.gsrvc.setFieldProperties($scope.fd, event);
                          };
                          
                          
                        let itemValue = null;
                        if ($scope.formData!=undefined)
                        {
                                if ($scope.formData.length==0) $scope.formData=[{}];
                                itemValue=$scope.formData[0][$scope.fd.FieldName]
                                
                        }else $scope.formData=[{}];

                        

                         $scope.fd.localVars.search=[{id:1,filter:'eq',code_name:'eq',name:"Equals",icon:"fa fa-bars"} ];
                
                         if (!$scope.fd.Search) $scope.fd.Search =  $scope.fd.localVars.search[0]
                        if ($scope.formData[0][$scope.fd.FieldName] ===undefined) $scope.formData[0][$scope.fd.FieldName] = false;
                        
                        let itemValueState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+'-boolValueStateName'+$scope.fd.PresentationId,itemValue);
                        let itemValueStateName = itemValueState.subject.name;
                        
                        
                        let value_changed = function(data)
                        {
                            itemValueState.subject.setStateChanges = data;
                            itemValueState.subject.notifyObservers("valueChanged");
                        };
                        
                        let action_value_changed = $scope.ksm.addAction(itemValueState,"valueChanged",value_changed);
                       
                        $scope.on_blur_action=function()
                        {
                                
                                $scope.ksm.executeAction(itemValueState,"valueChanged", $scope.formData[0][$scope.fd.FieldName]);
                                //$scope.fd.DefaultValue = $scope.formData[0][$scope.fd.FieldName];
                        };
                       
                        
                        
                        let apply_value = function(data) {
                                if (data!=undefined) $scope.formData[0][$scope.fd.FieldName] = data;
                        };


                        $scope.fd.SetDefault = function()
                        {
                                $scope.fd.DefaultValue = {value:$scope.formData[0][$scope.fd.FieldName]};
                        }
                        
                        if ($scope.fd?.Parameters?.DependentFieldId!=undefined && $scope?.fd.Parameters?.DependentFieldId!=null)   
                        {
                            if ($scope.fd.Parameters.DependentFieldId!="")
                            {
                                let dependent_field = "Field"+$scope.fd.PresentationId;
                                let subscribedSubject = $scope.resourceDefinition.page_state_id+'-'+$scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId;
                                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
                                let state = $scope.ksm.getState(subscribedSubject);
                                if (state.status=="ok") $scope.formData[0][$scope.fd.FieldName] = state.state;
                            }
                        }
                        
                        
                         if (itemValueState.subject.currentStateIndex>=0)
                        {
                               
                                $scope.formData[0][$scope.fd.FieldName] = itemValueState.subject.getState;
                    
                        }   
                        
                        if ($scope.formData[0][$scope.fd.FieldName]!=undefined) $scope.ksm.executeAction(itemValueStateName,"valueChanged", $scope.formData[0][$scope.fd.FieldName]);
                
                          
                          
                          
                      
                        },
        templateUrl: 'ktdirectivetemplates/ktBoolean.html',
        link: function (scope, elem, attrs) {
				
           if (scope.formData===undefined) scope.formData = [{'Field':0}];
          if (scope.formParams===undefined) scope.formParams = {formViewType:1};
          if (scope.formParamsParent===undefined) scope.formParamsParent = {formViewType:1};
 
         
        
        }
    };

}

'use strict';

export function ktBootstrapTooltip () {

        return {
            restrict: 'A',
         
            link: function (scope, elem, attrs) {
                
                 attrs.$observe('title',function(title){
					
                    // Destroy any existing tooltips (otherwise new ones won't get initialized)
                    elem.tooltip('dispose');
                    // Only initialize the tooltip if there's text (prevents empty tooltips)

					if (jQuery.trim(title)) elem.tooltip();
					
					//elem.tooltip("show");
					//setTimeout( ()=> {elem.tooltip("hide"); } , 3000)
	  
	  
                  });
              
                  elem.on('$destroy', function() {
					
                    elem.tooltip('dispose');
                    delete attrs.$$observers['title'];
                  });
    
              
               
            
            }
        }
  
};
'use strict';

export function ktBroadcastLastRepeaterElement () {
  
  return{
  
            priority: -1000, // a low number so this directive loads after all other directives have loaded. 
            restrict: "A", // attribute only
            controller: function($rootScope)
            {},
            link: function(scope, elem, attrs) {
              if (scope.$last){
    
                  setTimeout(function(){
                  $rootScope.$broadcast('LastRepeaterElement');
                });
    
      }
    }
  }
};
'use strict';

export function ktCalculatedField () {
        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktCalculatedField.html',
             controller: function($scope,GridsterService)
                {
                         $scope.gsrvc = GridsterService;
        if ($scope.localVars==undefined) $scope.localVars={};
        if ($scope.fd==undefined) $scope.fd={};
        if ($scope.formData==undefined) $scope.formData = [{}];
			             
              $scope.showProperties = function(event)
                {
                  $scope.gsrvc.setFieldProperties($scope.fd,event);
       
                };
             //$scope.formData[0]={Field256:2,Field257:3};
             $scope.localVars.Calculate=function(){
              var scopeVar = $scope.formData[0];
            $scope.fd.sItemValue=math.eval($scope.fd.Label,scopeVar);
              
              };
                        
                        },
             link: function (scope, elem, attrs) {
				
       
             
              
            }
        };
    };
'use strict';


export function ktCalendar () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktCalendar.html',

             controller: function($scope,$rootScope,$timeout,UserService,ResourcesDataService,TaskDataService,MessagingService,GridsterService, UtilityService) {
                 
                 const numFormat = new Intl.NumberFormat("de-DE", {
                      maximumFractionDigits:  $scope.fd.Parameters.chartFractionDigits || 2,
                      minimumFractionDigits:  $scope.fd.Parameters.chartFractionDigits || 2
                    });


                
                 $scope.gsrvc= GridsterService;
                 if (!Array.isArray($scope.fd.selectedTasks)) $scope.fd.selectedTasks=[];
                if ($scope.resourceDefinition!=undefined)  {
                  $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
                }
                if ($scope.localVars == undefined) $scope.localVars={};
                 
                $scope.localObj={loadedTasks : []};
                $scope.localVars.taskItem = null;   
                $scope.localVars.selectedTask = {};
                $scope.localVars.showMenu = false
                if ($scope.fd.localVars == undefined) $scope.fd.localVars={};
                
                $scope.fd.localVars.dashboard = {
                    id: '1',
                    name: 'Home',
                    widgets: {}
				} ;
                 $scope.fd.localVars.taskItem = null;
                 $scope.fd.localVars.selectedTask = {};
                
                //MIGOR - PREBACIO IZ TASK ADD RESOURCE, TODO - IZBACITI VISAK
                $scope.taskId=$scope.resourceDefinition.ResourceDefId;
                if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
                if ($scope.taskId==undefined) $scope.taskId=0;
                $scope.fd.localVars.taskId=$scope.taskId;
                $scope.fd.ParentDatasetDefId=$scope.fd.Related;
                $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
                $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;
                $scope.source_type=$scope.resourceDefinition.source_type;
                $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
                $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
                $scope.formDefinition = $scope.resourceDefinition.form_definition;
                $scope.fd.localVars.resourceRecordId=0;
				
				if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4();
				$scope.fd.Parameters.UuidRef = $scope.fd.UuidRef;
                
                $scope.formDefinition = $scope.formDefinition || false
                $scope.taskInitiateId = $scope.taskInitiateId || 0
                $scope.taskExecuteId = $scope.taskExecuteId || 0
                $scope.prevTaskExeId = $scope.prevTaskExeId || 0
                    

                let hsvtorgb = function (h,s,v)   {                              
                          let f= (n,k=(n+h/60)%6) => v - v*s*Math.max( Math.min(k,4-k,1), 0);     
                          return   "#" + Math.round(f(5) * 255).toString(16) +  Math.round(f(3) * 255).toString(16) + Math.round(f(1) * 255) .toString(16) 
                }  

                let HSV2RGB = function(h, s, v) {
                    var r, g, b, i, f, p, q, t;
                    if (arguments.length === 1) {
                        s = h.s, v = h.v, h = h.h;
                    }
                    i = Math.floor(h * 6);
                    f = h * 6 - i;
                    p = v * (1 - s);
                    q = v * (1 - f * s);
                    t = v * (1 - (1 - f) * s);
                    switch (i % 6) {
                        case 0: r = v, g = t, b = p; break;
                        case 1: r = q, g = v, b = p; break;
                        case 2: r = p, g = v, b = t; break;
                        case 3: r = p, g = q, b = v; break;
                        case 4: r = t, g = p, b = v; break;
                        case 5: r = v, g = p, b = q; break;
                    }
                 return    "#" + Math.round(r * 255).toString(16) +    Math.round(g * 255).toString(16) + Math.round(b * 255) .toString(16) 
                }


                $scope.fd.localVars.toggleDropdown = function(){
                    $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
                }
                
                
                $scope.fd.localVars.copyToClipboard = function(text){
                    $scope.fd.localVars.copyUuid = true;
                    navigator.clipboard.writeText(text).then( 
                        () => {
                            $timeout(function(){$scope.fd.localVars.copyUuid = false;},1000);
                        },
                        () => {    /* clipboard write failed */
                            MessagingService.addMessage('Copy to clipboard failed','error');
                            $timeout(function(){$scope.fd.localVars.copyUuid = false;},1000);
                    });                    
                }
        
                
                
                var  process_observed_data = function(data) // called by datasetList (via KSM)
                {     
                    $scope.fd.localVars.errormsg =''
                  
                    if (data==undefined || data?.state?.sharedData?.analytics==undefined)
                        return       
                    if ($scope.fd.Parameters.CalculateFunction?.name==undefined)  
                        $scope.fd.localVars.errormsg='Calculate Function not defined!'
      
                    if ($scope.fd.Parameters.chartType==undefined) 
                            $scope.fd.Parameters.chartType='counter'
                    
                    $scope.fd.localVars.SelectedChartAnalytics = $scope.fd.Parameters.SelectedChartAnalytics || 0     
                    $scope.fd.localVars.analytics =  data?.state?.sharedData?.analytics[$scope.fd.localVars.SelectedChartAnalytics][$scope.fd.Parameters.CalculateFunction.name]
                    let analytics =  $scope.fd.localVars.analytics 
                     
                    //find minvalue and maxvalue of current Anaytics data
                    $scope.fd.localVars.maxvalue=-1
                    $scope.fd.localVars.minvalue=-1
                    Object.keys(analytics).forEach(function(key,index) { //must use inverse logic (undefined == number is always false)
                            if (!( analytics[key] < analytics[$scope.fd.localVars.maxvalue]))   $scope.fd.localVars.maxvalue = key
                            if (!( analytics[key] > analytics[$scope.fd.localVars.minvalue]))   $scope.fd.localVars.minvalue = key      
                    })
 
        
                        
                        
                    $scope.fd.localVars.data = Object.values(analytics)
                    $scope.fd.localVars.labels = Object.keys(analytics)
                    
                    if ($scope.fd.Parameters?.chartType?.name == 'pie' || $scope.fd.Parameters?.chartType?.name == 'doughnut' || $scope.fd.Parameters?.chartType?.name == 'polarArea') { 
                            let colors=[] 
                            let golden_ratio = 0.618033988749895
                            let h = Math.random() // use random start value
                             
                            for (let item of $scope.fd.localVars.data) { 
                                 h += golden_ratio
                                 h %= 1  
                                 colors.push( HSV2RGB( h, 0.5, 0.95) )   
                            }  
                            //convert colors to array 
                            $scope.fd.localVars.chartColors = [   { backgroundColor: colors }        ]
                            $scope.fd.localVars.data =     [    $scope.fd.localVars.data    ]                                   
                    }
                    
                    if ($scope.fd.Parameters?.chartType?.name!=undefined) 
                        $scope.fd.localVars.chartType =  $scope.fd.Parameters.chartType.name 
                    else 
                        $scope.fd.localVars.chartType =  $scope.fd.Parameters.chartType //counter does not have .name
                  
                    
                    $scope.fd.localVars.chartLabel =  $scope.fd.Parameters.chartLabel
                    $scope.fd.localVars.sharedData = data?.sharedData
                    //summing all values for counter
                    $scope.fd.localVars.countAll = $scope.fd.localVars.data.reduce((partialSum, a) => partialSum + a, 0); 
					
					
					// **** JSONE SCRIPTING ***** //
					//var template = {a: {$eval: "foo.bar"}};
                    //var template = "${foo.bar}"
                    //var template = "${minvalue} ${analytics[minvalue]}"   
                    //var context = {foo: {bar: "zoo"}}    
                    //$scope.fd.localVars.testjsone  = jsone(template, $scope.fd.localVars)  
					
                    $scope.fd.localVars.scriptValue  = jsone($scope.fd.Parameters.script || '',  $scope.fd.localVars)
                
                }; 
    
            $scope.fd.localVars.formatNumber = function(num)  {
                  let newFormat , useGrouping;
                  
                  useGrouping = $scope.fd.Parameters.useGroupingSeparator ;         
                  if ($scope.fd.Parameters.chartFractionDigits)
                         newFormat = new Intl.NumberFormat("de-DE", { useGrouping: useGrouping,  maximumFractionDigits: $scope.fd.Parameters.chartFractionDigits ,  minimumFractionDigits: $scope.fd.Parameters.chartFractionDigits  });
                    else 
                       newFormat = new Intl.NumberFormat("de-DE", { useGrouping: useGrouping });               

               try {
                    if ($scope.fd.Parameters.disableFormatting) 
                        return num          
                      else  
                        return newFormat.format(num)
                    
                    } catch (err) {
                            MessagingService.addMessage(error.msg,'error');
                            return 'Error!'
                    }
                    
            }
            
    
            $scope.fd.localVars.setSelectedDataset = function(id,saved)  {
            //debugger
              if ($scope.fd.localVars.selectedResourceItem==undefined) $scope.fd.localVars.selectedResourceItem={}
              //pick orher parameters from database
              $scope.fd.localVars.getPublishedResourceById(id,saved);
              
		}
        
        
        $scope.fd.localVars.getPublishedResourceById = function(id,saved) 
        {
            let pos
            if (saved && $scope.fd.FormDef!==undefined && $scope.fd.FormDef!==null)
              { 
                    pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                    if (pos>=0){
                        $scope.fd.localVars.selectedResourceItem.name = $scope.fd.localVars.publishedResourceList[pos].name;
                        $scope.fd.localVars.selectedDataset = $scope.fd.localVars.publishedResourceList[pos]
                    }
                    $scope.fd.localVars.selectedResourceItem.id = id;
                    $scope.fd.localVars.selectedResourceItem.name_confirmed = $scope.fd.localVars.selectedResourceItem.name +' ('+$scope.fd.localVars.selectedResourceItem.id +')'
                    $scope.fd.localVars.selectedResourceItem_c=$scope.fd.localVars.selectedResourceItem;
                    $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
                    $scope.fd.localVars.formLoaded=true;

              }else{
                  pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                  if (pos>=0){
                    ResourcesDataService.GetPublishedResourceById(id).then(function (data) {

                            $scope.fd.localVars.selectedDataset = $scope.fd.localVars.publishedResourceList[pos];
                            $scope.fd.localVars.dashboard.widgets.layout = data.data.Form
                            $scope.fd.FormDef = $scope.fd.localVars.dashboard.widgets.layout
                            if ($scope.fd.localVars.selectedResourceItem_c!==undefined)
                            {
                                $scope.fd.Parameters.PublishedResourceId=$scope.fd.localVars.selectedResourceItem_c.id;
                                $scope.fd.Parameters.PublishedResourceVersion=$scope.fd.localVars.selectedResourceItem_c.Version;
                                $scope.fd.Related=$scope.fd.localVars.selectedResourceItem_c.ResourceDefId; 
                                $scope.fd.localVars.freshForm=angular.copy($scope.fd.localVars.selectedResourceItem_c.Form)
                                $scope.fd.Related = $scope.fd.localVars.publishedResourceList[pos].ResourceDefId

                            }else MessagingService.addMessage('Error - published dataset not selected ktTAskAdd','error')
          
                            $scope.fd.localVars.formLoaded=true;

                        },function(error){    
                          MessagingService.addMessage(error.msg,'error');
                    });

                }
            }
                   
}
       

       $scope.fd.localVars.calculateFunctions= [ {id:1,name:'sum'},{id:2,name:'mean'},{id:3,name:'min'},{id:4,name:'max'},{id:5,name:'count'} ]     



         $scope.fd.localVars.chartOptions= {
                    scale: {
                        ticks: {
                          //precision:  defined as parameter
                        }
                      }  ,
                         plugins: {  
                                    legend: {
                                        display: true,
                                        position: 'bottom',
                                        labels: {
                                            color: 'rgb(255, 99, 132)'
                                        }
                                    },                           
                                      labels: {  
                                        render: 'label',  // render 'label', 'value', 'percentage', 'image' or custom function, default is 'percentage
                                        precision: 0,// precision for percentage, default is 0
                                        showZero: false, //  whether or not labels of value 0 are displayed, default is false  
                                        fontSize: 14,   
                                        fontColor: '#000',// font color, can be color array for each data or function for dynamic color, default is defaultFontColor
                                        fontStyle: 'normal',   // font style, default is defaultFontStyle
                                        fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",         // font family, default is defaultFontFamily                  
                                        textShadow: false, // draw text shadows under labels, default is false
                                      }
                        }        
          }
          
          
          if ($scope.fd.Parameters.chartPrecision!=undefined && $scope.fd.Parameters.chartPrecision!=null ) {     
               $scope.fd.localVars.chartOptions.scale.ticks.precision = $scope.fd.Parameters.chartPrecision
          }
             
        
        if ($scope.fd.Parameters?.chartType?.name  === 'bar'  || $scope.fd.Parameters?.chartType?.name   === 'line' || $scope.fd.Parameters?.chartType?.name   === 'radar' || $scope.fd.Parameters?.chartType?.name   === 'bubble')  {
            $scope.fd.localVars.chartOptions.plugins.legend.display= false
        }

      
				
						
				$scope.fd.localVars.chartTypes = [ //removed radar, bubble and script
                            {id:1,name:'line'},{id:2,name:'bar'}, 
                            {id:4,name:'doughnut'},{id:5,name:'pie'},{id:6,name:'polarArea'},
                             ,{id:99,name:'counter'} //{id:3,name:'radar'},{id:7,name:'bubble'},{id:100, name:'script' },
                ]
            
			if ($scope.fd.Parameters.chartType==undefined) 
                            $scope.fd.Parameters.chartType=$scope.fd.localVars.chartTypes[1] //default = bar
						
                $scope.localVars.toggleDropdown = function()
                {
                           $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
                }
                              
                $scope.$on('InlineTaskClosed',function(event,data){
                    var taskId=data;
                    var pos = $scope.localObj.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
                    if (pos>=0) {
                      $scope.localObj.loadedTasks.splice(pos,1);  
                    }
                });
               
                if ($scope.fd.selectedTasks===undefined || $scope.fd.selectedTasks===null) $scope.fd.selectedTasks = [];
                
                if ($scope.fd.FormDef!=null && $scope.fd.FormDef!==undefined) {
                    $scope.fd.selectedTasks = $scope.fd.FormDef;
                }else   {
                    $scope.fd.FormDef = [];  
                } 
                
                let initiate_task = function(data)
                {
                    let loadTask=false;
                    $scope.localVars.taskLoaded = false;
                    if ($scope.localObj.loadedTasks.length>0)  {
                        if ($scope.localObj.loadedTasks[0].taskId.id != data.taskId) {
                            $scope.localObj.loadedTasks.length=0;
                            loadTask=true;
                        }
                    } else loadTask=true;
                    
                    $scope.localObj.loadedTasks.splice(0,1);
                         
                    for (let j = 0;j<$scope.fd.selectedTasks.length;j++) {
                            if ($scope.fd.selectedTasks[j].taskId.id==data.taskId) {
                                $timeout(function(){
                                    $scope.localObj.loadedTasks.push(data);
                                    $scope.localVars.taskLoaded = true;
                                });
                            }
                        }
                }
                                
                  //subscribe to events - initially only refresh data    
                        
                  if ($scope.resourceDefinition.page_state_id && $scope.fd.Parameters.widgetReference ) {
                        let whoami ='chart'+ $scope.fd.UuidRef  // valueStateName           
                        let subscribedSubject = $scope.resourceDefinition.page_state_id + '-'+ $scope.fd.Parameters.widgetReference //odabraniUUIDnekogELEMENTA    
                        let observer = $scope.ksm.subscribe(subscribedSubject,whoami,"valueChanged",process_observed_data);   
                  }
                   
               
               let lang=$rootScope.globals.currentUser.lang;  
               
                   

                $scope.localVars.taskIsOpen = function(taskId)
                  {
                    var isOpenPos = $scope.localObj.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (isOpenPos>=0) return true;
                    else return false;
                  }
                 
                 $scope.fd.pasteFromClipboard = function(task){
                        
                        navigator.clipboard.readText().then( (data) => {
                            /* clipboard successfully read */
                            $timeout(function(){task.widgetId = data})
                        },
                        () => {
                            /* clipboard read failed */
                            MessagingService.addMessage('Paste from clipboard failed','error');
                        });
                       
                }

                  
                $scope.fd.AddTaskToList = function ()
                {
                    $scope.fd.selectedTasks.push({widgetId:null,taskId:null});
                }
                  
                $scope.fd.ConfirmTaskList = function ()
                {
                     $scope.fd.FormDef = $scope.fd.selectedTasks;
                     $scope.fd.showConfirmed=true;
                     $timeout(function(){$scope.fd.showConfirmed=false},5000);
                }
                
                $scope.fd.RemoveTaskFromList = function (index){
                  
                   if (index>=0){
                             $scope.fd.selectedTasks.splice(index,1);         
                   }    
                }
          
          
                 $scope.localVars.saveTaskToResource = function(tdid,tei,datasetDefId,datasetRecordId){
                          TaskDataService.saveTaskToResource(tei,datasetDefId,datasetRecordId,$scope.fd.presentationId).then(function(data) {
                                                    
                              $state.go('app.navbar.tasks.initiate',{id: tdid,fromStateName:$state.current.name,fromStateParams:$state.params,outcome_id:0,prev_task_execute_id:tei});
    
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
             }
             
             
           $scope.fd.localVars.showProperties = function(datasetMapperType,showPropertiesRight)
          {
               //debugger
                if ($scope.fd.localVars.datasetMapperType==undefined)
                {
                   $scope.fd.localVars.datasetMapperType = datasetMapperType;
                }else
                {
                   if ($scope.fd.localVars.datasetMapperType==0 || $scope.fd.localVars.datasetMapperType!=datasetMapperType) 
                        $scope.fd.localVars.datasetMapperType = datasetMapperType;
                   else 
                       $scope.fd.localVars.datasetMapperType=0;
                }
               
                 
                if (showPropertiesRight) $scope.gsrvc.setFieldProperties($scope.fd);
           
                if ($scope.fd.localVars.dashboard != undefined)  {
                    //debugger
                     $scope.fd.localVars.fieldsList = []
                     $scope.fd.localVars.getFieldNamesFromObject($scope.fd.localVars.dashboard, $scope.fd.localVars.fieldsList)
                    
                }
          };
          
          
 
       $scope.fd.localVars.getFieldNamesFromObject = function (obj, fieldsList)   // find FieldNames in given Dashboard object recursively 
     {// fieldsList  is return variable (used for multiple select)
        //debugger
        var o = {};
        Object.keys(obj).forEach(function(key) {
          
            if ( (typeof(obj[key]) === 'object') && obj[key]    && key != 'NameField')  { //Do NOT parse 'NameField'  (we need it as it is)
              $scope.fd.localVars.getFieldNamesFromObject(obj[key], fieldsList)
            } 
            else {          
                    if (key == 'FieldName'  ) {  
                        //debugger
                        o[key]= obj[key];
                        }
                  
                    if (key == 'PresentationId' ) {
                        o['id']= obj[key];
                    }    
                    if (key == 'Label' ) {
                        o['name']= obj[key];
                    }    
                }
            }) ; 
        
        if ( o['FieldName'] && Object.keys(o).length > 0 ) fieldsList.push(o)   
    }; 

                
         },
             link: function (scope, elem, attrs) {
                
               
        }       
              
    }
  
};


            
            
'use strict';

export function ktCodesActions () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktCodesActions.html',
              controller: function(dragulaService)
                {}, 
             link: function (scope, elem, attrs) {
             
             scope.actions = [
                {id1:1,type:1,name1:'Initiate task',taskId:null,actionParams:{}},
                {id1:2,type:2,name1:'Send notification',notificationId:null,actionParams:{}},                
              ];
              
              
               scope.getSeqNoForNewAction = function(){
                  var seqNo=0;
                  var actLen=0;
                  for (var i=0;i<scope.codesActions.length;i++) {
                    
                    
                    if (scope.codesActions[i].actions!= undefined)
                    {
                                          
                      actLen = scope.codesActions[i].actions.length;
                      
                    }
                    
                    seqNo = seqNo+actLen;
                    
                  }
                  
                  return seqNo;
        
     
              
             
               }   
               
            }
    }
};
'use strict';

export function ktCodesDefActions () {
        
           var controller = ['$scope', '$stateParams','$state','CodesService','MessagingService','TaskDataService','$rootScope','$timeout','dragulaService','GridsterService',
                             function ($scope,$stateParams,$state,CodesService,MessagingService,TaskDataService,$rootScope,$timeout,dragulaService,GridsterService) {
          
        
        $scope.firstTime=true;
                 
        CodesService.CodesList().then(function(data) {
            
                            $scope.codesList = data.data;
                  
                      },function(error){
                        
                          MessagingService.addMessage(error.msg,'error');
               });

          $scope.codesActions.codesDownloaded=false;
          
          $scope.GetCodesByName = function()
          {
                     var lang=$rootScope.globals.currentUser.lang;
                    // $scope.loadingActions=true; 
                     CodesService.getCodesByName($scope.defaultCode,lang).then(function(data) {
                             $scope.codes = data.data;
                      //      $scope.loadingActions=false;
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
       
          };
    
         
                $scope.gsrvc= GridsterService;
                
                $scope.setupDragula = function()
                {
                     var widgetHandleResource = 'element-drag-handle';
                     
                     var bag = dragulaService.find($rootScope, 'bag-actions');
                     if (!bag)
                     {
                        $scope.gsrvc.setupDragula('bag-actions','codeActionsDragula',widgetHandleResource);    
                     }
                     else
                     {
                          $scope.gsrvc.destroyDragula('bag-actions');
                          $scope.gsrvc.setupDragula('bag-actions','codeActionsDragula',widgetHandleResource); 
                           
                      }
                };  
                    
                 

                    $scope.fillTransitionCounters=function(codeActions) {
                        codeActions.transitionList={};
                        var transition='';
                        
                        for (var i=0;i<codeActions.codesActionsList.length;i++)
                        {
                            transition=codeActions.codesActionsList[i].value1+codeActions.codesActionsList[i].value2;
                            if (codeActions.transitionList[transition] === undefined )
                            {
                                 codeActions.transitionList[transition]=1; 
                            }
                                 else codeActions.transitionList[transition]++;
                        }
                            

                    };
                   
                  $scope.removeCodeItem = function(pindex){
                    //scope.task.TaskOutcomeCodeId = null;
                     $scope.codesActions.codesActionsList.splice(pindex,1);
                      };
                      
       
                  $scope.removeAction = function(pindex,index){
                    //scope.task.TaskOutcomeCodeId = null;
                     $scope.codesActions.codesActionsList[pindex].actions.splice(index,1);
                      };
                      
                  $scope.GetCodesClick = function(){
                    //scope.task.TaskOutcomeCodeId = null;
                    scope.GetCodes();
                      };
                  $scope.GetCodesByNameClick = function(){
                    //scope.task.TaskOutcomeCodeId = null;
                    scope.GetCodesByName();
                      };
                                    
                  $scope.AddAction = function(){
                    
                      var found=false;
                      //dodati kontrole da se ne može dodati dupli
                      for (var i=0;i<$scope.codesActions.codesActionsList.length;i++)
                      {
                        if ($scope.codesActions.codesActionsList[i].id1==$scope.statusFrom.id && $scope.codesActions.codesActionsList[i].id2==$scope.statusTo.id) found=true;
                        
                      }
                      if (!found)
                      {
                        
                        $scope.codesActions.codesActionsList.push({id1:$scope.statusFrom.id,name1:$scope.statusFrom.name,value1:$scope.statusFrom.name,id2:$scope.statusTo.id,name2:$scope.statusTo.name,value2:$scope.statusTo.name,actions:[]});        
                        $scope.codesActions.selectedActionIndex=$scope.codesActions.codesActionsList.length-1;
                 
                      }
                    
                  };
                      
                $scope.GetCodes = function(){
                   // var lang=$rootScope.globals.currentUser.lang;
                  $scope.loadingActions=true; 
                    var lang=$rootScope.globals.currentUser.lang;
                    //$scope.codesActions.codesActionsList.length = 0;
                   
                      if (!$scope.codesActions.codesDownloaded)
                      {                      
                         TaskDataService.GetTaskCodesActionsByName($scope.taskUid,lang,$scope.defaultCode).then(function(data) {            
                                    
                                   $scope.codesActions.codesActionsList = data.data;
                                   $scope.codesActions.codesDownloaded=true;
                                   $scope.firstTime=false;
                                   $scope.fillTransitionCounters($scope.codesActions);  //MIGOR
                                   $scope.findSelectedTransition();
                                   $scope.loadingActions=false;
                                   
                              },function(error){
                                
                                  $scope.loadingActions=false;
                                  MessagingService.addMessage(error.msg,'error');
                            });
                      
                      }else
                      {
                       $scope.findSelectedTransition();
                       $scope.loadingActions=false;      
                      }
                      
                     
                };
              
                
                
                 //find selected transition
                  $scope.findSelectedTransition= function(){
                     var found=false;
                      for (var i=0;i<$scope.codesActions.codesActionsList.length;i++)
                      {
                            if ($scope.codesActions.codesActionsList[i].value1 == $scope.statusFrom.name && $scope.codesActions.codesActionsList[i].value2 == $scope.statusTo.name && !found)
                        {
                                    //  $scope.codesActions.codesActionsList.push(angular.copy($scope.codesActions.codesActionsListOriginal[i]));
                                   $scope.codesActions.selectedActionIndex=i;
                                   found=true;
         
                        }  
                      }
                      if (!found) $scope.AddAction();
                      $scope.setupDragula();
                  };
                $scope.$watch('codesActions.selectedTransition', function(newValue,oldValue){
                  
                  
                  if (newValue!=oldValue || $scope.firstTime)
                  {
                    
                   if (!!$scope.defaultCode)
                   {
                       $scope.GetCodesByName();
                   }
               
                    $scope.GetCodes();
                  
                  
                  // $timeout(function(){$scope.loadingActions.loading=false;});
                  }
                  /*else{
                    $scope.loadingActions.loading=false;
                    
                  }*/
                 
                });
                
                /*               
               if (!!$scope.defaultCode)
               {
                       $scope.GetCodesByName();
               }
               else{  
                   $scope.GetCodes();
               }
                */
                
          }];
          
          
        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktCodesDefActions.html',
              scope:{
                codes: '=',
                selectCode: '=',
                defaultCode: "@",
                task: "=",
                taskId: "=?",
				taskUid: "=?",
                actionsList: "@",
                codesActions: "=",
                statusFrom: "=",
                statusTo: "=",
                },
                controller:controller,
             link: function (scope, elem, attrs) {
              
               
            }
        }
        
};
'use strict';


export function ktCodesDetailEdit () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktCodesDetailEdit.html',
              scope:{
				codeId : '=',
				codesList: '=',
				showIconActive: '=',
				fd: '=',
               },
                controller:function($stateParams,$state, $scope,TaskDataService,$rootScope,dragularService,uiGridConstants,ProcessingService,MessagingService,CodesService,ResourcesDataService, $q, $timeout) 
                {
    
		$scope.CTRLNAME='codesDetailEdit';
		$scope.isCollapsed  = false;
		$scope.pageState={} //MIGOR - samo da proradi GETRESOUCEDEF
		$scope.paginationOptions={}//MIGOR - samo da proradi GETRESOUCEDEF
		$scope.showTableActions=true;// Needed by SmartTable
		$scope.searchInitiated = true
		var lang=$rootScope.globals.currentUser.lang;
		$scope.codesDetails=[]
		

		$scope.returnState = $stateParams.returnState
		if ($scope.returnState===undefined || $scope.returnState==='') {
		   $scope.returnState={state:{name:'app.navbar.codes.list'},Label:'Return to Codes list',params:{}} 
		}
		
		
		$scope.codesDetails = []
     

		$scope.ResourceSearch = function(page){
				$scope.searchInitiated=false;
				$scope.paginationOptions.totalItemCount=0;
				if (page!=undefined) $scope.currentPage=page;
				$timeout(function(){
					$scope.searchInitiated=true;
				});
		 };
		 
		 
		 $scope.returnToPreviousPage = function()
			{
					let page = $scope.returnState.state.name
					$state.go(page,$scope.returnState.params);
				 
			}
  
         
    $scope.codeTypeList = [{id:1,name:'System'},{id:2,name:'User'}]                      
          
     
    $scope.saveCode = function (isValid) {
        //debugger
          if (isValid) {
                $scope.activity.activityMessage = ProcessingService.setActivityMsg('Saving code '+ $scope.CodeHead.CodesHeadLang[0].CodeName);
                CodesService.CodesPost($scope.CodeHead)
                        .then(function(data) {
                                   MessagingService.addMessage(data.data,'success');
                              },function(error){
                                  MessagingService.addMessage(error.msg,'error');
                            });                             
          }
     }; 

   
    $scope.setDirectiveFn = function(directiveFn) { // directiveFn == getCodesDetails()
        //debugger //setDirectiveFn 
        $scope.directiveFn = directiveFn;
    };

     $scope.isCollapsedEditItem = false;
     
     
    $scope.editCodeItem = function()
		{
        
        //populate from grid
        $scope.codeItemHeader={Text: 'Edit code item',Type:'Edit'};
         if ($scope.CodesDetailLang.Lang==undefined) {
           $scope.CodesDetailLang.Lang=$scope.CodeHeadLang.Lang;
        }
         $scope.CodesDetailLang.CreatedBy=null;
         $scope.CodesDetailLang.ChangedBy=null;
        
        $scope.isCollapsedEditItem = !$scope.isCollapsedEditItem;
            
    }
    
	  $scope.CodesDetail = {codesdetaillang_set: []};
	  $scope.CodesDetailLang ={CodesDetailId:{}}; 
	  
  
      $scope.newCodeItem = function(){
        
            $scope.codeItemHeader={Text: 'New code item',Type:'New'};
            //populate from grid
            $scope.isCollapsedEditItem = !$scope.isCollapsedEditItem;
            $scope.CodesDetailLang.id=undefined;
            $scope.CodesDetailLang.Lang=$scope.CodeHeadLang.Lang;
            $scope.CodesDetailLang.CodesDetailId.CodesHeadId=$scope.CodeHeadLang.CodesHeadId;
        }
     
    $scope.editCodeLang = function(){
        //populate from grid
        $scope.isCollapsedEditLang = !$scope.isCollapsedEditLang 
    }
     
    $scope.saveCodeLang = function(id) {
        //debugger
            $scope.isCollapsedEditLang = !$scope.isCollapsedEditLang
            CodesService.CodesPost($scope.CodeHead).then(function(data) {    
                         $scope.data1 = data.data;
                    },function(error){   
                        MessagingService.addMessage(error.msg,'error');
                  });
      
    }
     
    $scope.getListOfCodes = function(){
       var lang=$rootScope.globals.currentUser.lang;
       CodesService.CodesGet(lang).then(function(data) {             
                                   $scope.data1 = data.data;   
                              },function(error){
                                  MessagingService.addMessage(error.msg,'error');
                            });    
    }
    
 
   // $scope.getListOfCodes();
    
    
      $scope.saveCodeItem = function (isValid) {
           //debugger
           if (isValid) {
            $scope.CodesDetailLang.CodesDetailId.Status = 'Active';
                CodesService.addUpdateCodesDetails($scope.codeItemHeader.Type,$scope.CodesDetailLang).then(function(data) {
                                  MessagingService.addMessage(data.msg,'success');          
                              },function(error){
                                  MessagingService.addMessage(error.msg,'error');
                            });
          }
        };
      
          
                
                $scope.showEditCodes = false
                  $scope.showListCodes = false
                  
                  $scope.pokaziModal = function() {
                           $('#exampleModalC').modal('show');         
                  }
                  
                   $scope.$watch('codeId', function (newValue, oldValue, scope) {
                        if (newValue) $scope.pokaziModal();
                        //debugger      
                        
                    });
                    
                  $scope.toggleEditCodes = function() {                      
                        $scope.showEditCodes = !$scope.showEditCodes   
                  }

                  $scope.toggleListCodes = function() {                      
                        $scope.showListCodes = !$scope.showListCodes   
                  }                  
                  
                  
                  $scope.removeCode = function(index){
                          //debugger
						$scope.codesDetails.splice(index,1);
					   if ($scope?.fd?.codeList) 	$scope.fd.codeList.splice(index,1);
					   if ($scope?.codesList) 	$scope.codesList.splice(index,1);
                  }
                  
                  $scope.unselectRows = function() {
                      $scope.codeId=0; 
                      $scope.codeSelected=false;
                      $scope.selectedCode=0         
                  }
                  

                 $scope.getCodesDetails = function(codeId,codeName){
                  
                    var lang=$rootScope.globals.currentUser.lang;
                    
                     $scope.codeId = codeId;
                     $scope.codeName = codeName;
                     $('#exampleModalC').modal('show');    
                        
                    if ($scope.codeId>0)  {
                      
                    CodesService.getCodesDetails($scope.codeId,lang).then(function(data) {         
                                   $scope.codesDetails = data.data;
                                   $scope.codesLoaded = true;   
                                    $('#exampleModalC').modal('show');                                       
                              },function(error){
                                  MessagingService.addMessage(error.msg,'error');
                            });
                    } else {
                      
                      $scope.codesDetails.length = 0;
                      $scope.codesLoaded = false;
                    }
                }
                
                // KORISTI SE
                 $scope.saveCodesDetails = function(){
                  
                        var lang=$rootScope.globals.currentUser.lang;
                        debugger
                    
                        if ($scope.codeId>0) {
                            CodesService.saveCodesDetails($scope.codeId, $scope.codesList, lang).then(
                                function(data) {
                                           MessagingService.addMessage(data.msg,'success');
                                           $scope.codesDetails = data.data;  
                              },function(error){ 
                                          MessagingService.addMessage(error.msg,'error');
                             });
                        } else {  
                          $scope.codesDetails.length = 0;
                        }
                    }
                
                $scope.addEmptyCodeItem = function(){
                  var lang=$rootScope.globals.currentUser.lang;
				  var n =    {id:null,Name:null,Value:null,Active:true,CodesDetailLang:[{Value:null,Lang:lang}]}
                     
				  
				   $scope.codesList.push(n)
				   
				   		$timeout(function(){
							var container = document.getElementById('scrollcontainer');
							container.scrollTop = container.scrollHeight; 
						})
						
				  
				}

                
               if ($scope.codeId>0)
                  {
                    $scope.getCodesDetails();
                  
                    if ($scope.codeId==0) $scope.codesLoaded = false;
                  } else $scope.codesLoaded = false;
                  
          
          },//controller
         
         link: function (scope, elem, attrs) {
                     
            }   
        }
    };
'use strict';

export function ktCodesDetailList () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktCodesDetailList.html',
              /*scope:{
                CodeHead : '=',
                },*/
                controller:function($scope,CodesService,MessagingService,TaskDataService,$rootScope,$timeout,dragularService)
                {
                  $scope.showEditCodes = false
                  $scope.showListCodes = false
                  

                  $scope.pokaziModal = function() {
                           $('#exampleModalC').modal('show');         
                  }
                  
                   $scope.$watch('codeId', function (newValue, oldValue, scope) {
                        if (newValue) $scope.pokaziModal();
                        //debugger      
                        
                    });
                    
                  $scope.toggleEditCodes = function() {                      
                        $scope.showEditCodes = !$scope.showEditCodes   
                  }

                  $scope.toggleListCodes = function() {                      
                        $scope.showListCodes = !$scope.showListCodes   
                  }                  
                  
                  
                  $scope.removeCode = function(index){
                          console.log("text")
                          //debugger
                      $scope.codesDetails.splice(index,1);
                  }
                  
                  $scope.unselectRows = function() {
                       
                      //$scope.gridApi1.selection.clearSelectedRows()
                      $scope.codeId=0; 
                      $scope.codeSelected=false;
                      $scope.selectedCode=0
                          
                  }
                  

                 $scope.getCodesDetails = function(codeId,codeName){
                  
                    var lang=$rootScope.globals.currentUser.lang;
                    
                     $scope.codeId = codeId;
                     $scope.codeName = codeName;
                     $('#exampleModalC').modal('show');    
                     
                       
                    if ($scope.codeId>0)  {
                      
                    CodesService.getCodesDetails($scope.codeId,lang).then(function(data) {         
                                   $scope.codesDetails = data.data;
                                   $scope.codesLoaded = true;   
                                    $('#exampleModalC').modal('show');                                       
                              },function(error){
                                  MessagingService.addMessage(error.msg,'error');
                            });
                    } else {
                      
                      $scope.codesDetails.length = 0;
                      $scope.codesLoaded = false;
                    }
                }
                
                
                   $scope.saveCodesDetails = function(){
                  
                        var lang=$rootScope.globals.currentUser.lang;
                        //debugger
                    
                        if ($scope.codeId>0) {
                            CodesService.saveCodesDetails($scope.codeId,$scope.codesDetails,lang).then(
                                function(data) {
                                           MessagingService.addMessage(data.msg,'success');
                                           $scope.codesDetails = data.data;  
                              },function(error){ 
                                          MessagingService.addMessage(error.msg,'error');
                             });
                        } else {  
                          $scope.codesDetails.length = 0;
                        }
                    }
                
    $scope.saveCodeHead = function (isValid) {
        //debugger
          if (isValid) {
                //$scope.activity.activityMessage = ProcessingService.setActivityMsg('Saving code '+ $scope.CodeHead.CodesHeadLang[0].CodeName);
                CodesService.CodesPost($scope.CodeHead)
                        .then(function(data) {
                                   MessagingService.addMessage(data.data.msg,'success');
                              },function(error){
                                  MessagingService.addMessage(error.msg,'error');
                            });                             
          }
        }; 

   

                $scope.addEmptyCodeItem = function(){
                  
                  
                  var lang=$rootScope.globals.currentUser.lang;
                   $scope.codesDetails.push({id:null,Name:null,Value:null,Active:true,CodesDetailLang:[{Value:null,Lang:lang}]});
                }
                
                //$scope.codeChanged({theDirFn: $scope.getCodesDetails});
                
               if ($scope.codeId>0)
                  {
                    $scope.getCodesDetails();
                  
                    if ($scope.codeId==0) $scope.codesLoaded = false;
                  } else $scope.codesLoaded = false;
                  
          },
         
         link: function (scope, elem, attrs) {
              
              
             
            }   
        }
    };
'use strict';

export function ktCodesDropdown  () {
          
          var controller = ['$scope', '$stateParams','$state','CodesService','MessagingService','TaskDataService','$rootScope','$timeout','dragularService',function ($scope,$stateParams,$state,CodesService,MessagingService,TaskDataService,$rootScope,$timeout,dragularService) {
          
                  $scope.GetCodesByName = function()
                  {
                     var lang=$rootScope.globals.currentUser.lang;
                  
                     CodesService.getCodesByName($scope.codeName,lang).then(function(data) {
                             $scope.codeList = data.data;
                           
                             var pos;
                             if ($scope.selectedCodeId!=undefined)
                             {
                              pos = $scope.codeList.map(function(e) { return e.id; }).indexOf($scope.selectedCodeId);
                             }
                             
                             /*
                              if (scope.selectedCodeValue!=undefined)
                             {
                              pos = scope.codeList.map(function(e) { return e.value; }).indexOf(scope.selectedCodeValue);
                             } */ 
                             if (pos>-1) {
                              
                              $scope.selectedCode = $scope.codeList[pos];
                                        
                              }
                                      
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
       
                  };
                  
                   $scope.GetCodes= function()
                  {
                     var lang=$rootScope.globals.currentUser.lang;
                  
                     CodesService.getCodesByName($scope.codeName,lang).then(function(data) {
                             $scope.codeList = data.data;
       
                                        
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
       
                  };
        
                  $scope.GetCodesClick = function(){
                    //scope.task.TaskOutcomeCodeId = null;
                    scope.GetCodes();
                      };
                  $scope.GetCodesByNameClick = function(){
                    //scope.task.TaskOutcomeCodeId = null;
                    $scope.GetCodesByName();
                      };
                 
                   if (!!$scope.codeName)
                    {
                      $scope.GetCodesByName();
                    }
                else{
            
                      $scope.GetCodes();
                    }
          
          
          }];
        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktCodesDropdown.html',
              scope:{
                //codeList: '=',
                selectedCodeId: '=',
                codeId: "=",
                codeName: "@",
                valueLength:"@",
                labelLength:"@",
                name:"@",
                label:"@",
                searchText:"@",
                required:"=",
                sizeXs: "=",
                //errorText:"@",
                
                
                },
             controller:controller,
             link: function (scope, elem, attrs) {
              
                  if (scope.selectedCode == undefined) scope.selectedCode=null;
                  
                 /*
                  scope.$watch('selectedCodeId',function(newValue, oldValue){
                    
                        if (scope.codeList!=undefined)
                        {
                             var pos = scope.codeList.map(function(e) { return e.id; }).indexOf(scope.selectedCodeId);
                             if (pos>-1) {
                              
                              scope.selectedCode = scope.codeList[pos];
                                        
                              }
                    
                        }
                    });
                    */
                  scope.clear = function(event,selected){
                    
                   scope.selectedCode = null;
                    
                    
                  };
                  
                   scope.onSelectUniqueCallback = function (item, model){
                      
                      if (item!=undefined)
                      {
                      scope.selectedCode = item;
                      scope.selectedCodeId = item.id;
                      
                      }else {
                        
                        scope.selectedCode = null;
                        scope.selectedCodeId=null;
                      }
                    };
                           
        }
      }
    };
'use strict';

export function ktCrudResource (ResourcesDataService,TaskDataService,KatalyoStateManager,$timeout) {
    var controller = ['$scope', '$uibModal', '$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','UtilityService','KatalyoStateManager','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,UtilityService,KatalyoStateManager,$templateCache,$compile,$element) {
   
      $scope.fd.localVars={};
      $scope.fd.localVars.searchFormDownloaded = false;
      $scope.fd.localVars.formLoaded=false;
      $scope.fd.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_;  
      $scope.fd.localVars.animationsEnabled = true;
      $scope.fd.localVars.widgetType = 2;
      $scope.gsrvc = GridsterService;
      $scope.fd.localVars.formParams={formViewType:1,showGridNavigation:false};
      $scope.fd.localVars.gridsterType="dataset";
      $scope.fd.localVars.resourceType="dataset";
      $scope.fd.localVars.resourceTypesList=[{type:'dataset',name:'Dataset'},{type:'file',name:'File'},{type:'counter',name:'Counter'}]
      $scope.fd.localVars.TablePrefix = 'resource'+$scope.fd.Related
      $scope.fd.localVars.ShowAdvancedProperties = true
      $scope.fd.localVars.showMenu = false
	  
      
      if ($scope.formData===undefined) {

        $scope.formData={}
        $scope.formData[$scope.fd.UuidRef]=[{}]
      } else if ($scope.formData[$scope.fd.UuidRef]===undefined || $scope.formData[$scope.fd.UuidRef]===null) 		
				$scope.formData[$scope.fd.UuidRef]=[{}]
 
	  
      $scope.fd.localVars.toggleDropdown = function(){
           $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
      }
         
       
    if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
    
    if ($scope.fd.ParametersLang===undefined || $scope.fd.ParametersLang===null) $scope.fd.ParametersLang={}

    $scope.fd.Parameters.ShowAdvancedProperties = true

    if ($scope.fd.ParametersLang?.CreatedByTemplate===undefined)  $scope.fd.ParametersLang.CreatedByTemplate='Created by {{user}} on {{date}} at {{time}}'
    if ($scope.fd.ParametersLang?.ChangedByTemplate===undefined)  $scope.fd.ParametersLang.ChangedByTemplate='Last changed by {{user}} on {{date}} at {{time}}'
    
    if ($scope.fd.PopulateType==undefined) $scope.fd.PopulateType="";

    $scope.fd.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: {layout: []},
				searchForm: {layout: []}
		} ;
      

        if ($scope.taskId==undefined) $scope.taskId="0";
        $scope.fd.localVars.taskId=$scope.taskId;
        
        $scope.fd.localVars.resourceDefinition = $scope.resourceDefinition
        $scope.fd.ParentDatasetDefId=$scope.fd.Related;
        $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
        $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;
        if ($scope.fd.localVars.formType==undefined) $scope.fd.localVars.formType='i'
        $scope.source_type=$scope.resourceDefinition.source_type;
        $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
        $scope.formDefinition = $scope.resourceDefinition.form_definition;
        $scope.fd.ParentResourceDefId=$scope.fd.Related

        if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
		
		$scope.resourceDefinition.parentWidgetUid = $scope.fd.UuidRef
			  
        
        $scope.fd.localVars.resourceRecordId=0;
		
        if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        
        
      //register widget 
      var out_fields = ['resourceId'];

   
        let w_actions=[
                    {id:1,name:'executeUpdateRecord'},
                    {id:2,name:'executeAddRecord'},
                    {id:3,name:'executeDeleteRecord'},
                    {id:4,name:'addSingleRecord'},
                    {id:5,name:'removeSingleRecord'},
                    {id:6,name:'setMultipleRecords'},  
                    {id:7,name:'addSingleRecordWithRefresh'},
                    {id:8,name:'setRecordsWithRefresh'}, 
                    {id:9,name:'setRecordId'},
                    {id:10,name:'refreshRecord'},
                    {id:11,name:'reloadFormWidget'},  
                ]
        if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
        let resource_uid = $scope.fd.localVars?.resourceDefinition?.uid 
        if (!resource_uid) resource_uid = $scope.fd.localVars?.resourceDefinition?.pageId
            
        var widgetDefinition = {DEI: [],actions: w_actions,dataSource:true, widgetLabel: 'CRUD resource',widgetName: 'crudResourceWidget',
        widgetId: $scope.fd.UuidRef,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resource_id:$scope.resourceDefinition.page_state_id,resourceDefId : $scope.fd.Related, output:out_fields, parentResourceId:resource_uid};
        $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
        $scope.fd.localVars.LocalId=$scope.fd.localVars.localWidgetId;
        
        $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
       
      
        if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
      
  

  $scope.fd.localVars.showProperties=function(datasetMapperType,showPropertiesRight)
      {
            
            if ($scope.fd.localVars.datasetMapperType==undefined)
            {
               $scope.fd.localVars.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.fd.localVars.datasetMapperType==0 || $scope.fd.localVars.datasetMapperType!=datasetMapperType) 
                    $scope.fd.localVars.datasetMapperType = datasetMapperType;
               else 
                   $scope.fd.localVars.datasetMapperType=0;
            }
            if (showPropertiesRight) $scope.gsrvc.setFieldProperties($scope.fd);
            
      };
        
    
      
    $scope.fd.localVars.setSelectedResource = function(id,saved)  {
              //debugger //setSelectedDataset
              if ($scope.fd.localVars.selectedResourceItem==undefined) 
                                $scope.fd.localVars.selectedResourceItem={};
              $scope.fd.localVars.getPublishedResourceById(id,saved);

              
            }  
            
       
    $scope.fd.localVars.getPublishedResourceById = function(id,saved) 
 
    {
    
            let pos
            if (saved && $scope.fd.FormDef!==undefined && $scope.fd.FormDef!==null)
              { 
                    pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                    if (pos>=0){
                        $scope.fd.localVars.selectedResourceItem.name = $scope.fd.localVars.publishedResourceList[pos].name;
                        $scope.fd.localVars.selectedDataset = $scope.fd.localVars.publishedResourceList[pos]
                    }
                    $scope.fd.localVars.selectedResourceItem.id = id;
                    $scope.fd.localVars.selectedResourceItem.name_confirmed = $scope.fd.localVars.selectedResourceItem.name +' ('+$scope.fd.localVars.selectedResourceItem.id +')'
                    $scope.fd.localVars.selectedResourceItem_c=$scope.fd.localVars.selectedResourceItem;
                    $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
                    $scope.fd.localVars.dashboard.searchForm.layout=angular.copy($scope.fd.FormDef)
                    $scope.fd.localVars.formLoaded=true;

              }else{
                  pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                   
                  if (pos>=0){

                    
                    $scope.fd.localVars.selectedResourceItem = $scope.fd.localVars.publishedResourceList[pos]
               
                    
                    ResourcesDataService.GetPublishedResourceById(id).then(function (data) {
                        let jsonFile=$scope.fd.Related+"-v"+data.data.Version+".json"
                        ResourcesDataService.fetchJsonFile(jsonFile).then(function (widgetDef) {

                            if (widgetDef.status)
                            {
                                $scope.fd.localVars.formLoaded=true;
                                MessagingService.addMessage(widgetDef.data,'error');
                            }else{


                                $scope.fd.localVars.selectedResourceItem.Form = widgetDef.Form
                                $scope.fd.localVars.selectedDataset = $scope.fd.localVars.publishedResourceList[pos];
                                $scope.fd.localVars.dashboard.widgets.layout = widgetDef.Form
                                $scope.fd.localVars.selectedResourceItem_c=$scope.fd.localVars.selectedResourceItem
                                $scope.fd.localVars.selectedResourceItem.name_confirmed = $scope.fd.localVars.selectedResourceItem.name
                                if ($scope.fd.localVars.selectedResourceItem_c!==undefined)
                                {
                                    $scope.fd.Parameters.PublishedResourceId=$scope.fd.localVars.selectedResourceItem_c.id;
                                    $scope.fd.Parameters.PublishedResourceVersion=$scope.fd.localVars.selectedResourceItem_c.Version;
                                    $scope.fd.Related=$scope.fd.localVars.selectedResourceItem_c.ResourceDefUid; 
                                    $scope.fd.localVars.dashboard.searchForm.layout=angular.copy($scope.fd.localVars.selectedResourceItem_c.Form)
                                    $scope.fd.localVars.freshForm=angular.copy($scope.fd.localVars.selectedResourceItem_c.Form)
                                    $scope.fd.Related = $scope.fd.localVars.publishedResourceList[pos].ResourceDefUid

                                }else MessagingService.addMessage('Error - published dataset not selected','error')
                                
                                $scope.fd.FormDef = $scope.fd.localVars.dashboard.widgets.layout
                                $scope.fd.localVars.formLoaded=true;
                            }
                        },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                $scope.fd.localVars.formLoaded=true;
                   
                        }); 
                        
                        },function(error){    
                          MessagingService.addMessage(error.msg,'error');
                          $scope.fd.localVars.formLoaded=true;
                    });
                    
                }
            }
             
       
}

    if ($scope.fd.localVars.publishedResourceList==undefined) $scope.fd.localVars.publishedResourceList=[];
   var lang=$rootScope.globals.currentUser.lang;
                
   ResourcesDataService.GetPublishedResourcesByType('dataset','form').then(
        function (data) {       
           $scope.fd.localVars.publishedResourceList = data.data;
            $scope.fd.localVars.formLoaded = true
           //debugger  //GetPublishedResourcesByType   
           //$scope.fd.localVars.dashboard.widgets.layout = JSON.parse(data.data[0].Form)
                        
             if ($scope.fd.Parameters.PublishedResourceId!=null) 
                                        $scope.fd.localVars.setSelectedResource($scope.fd.Parameters.PublishedResourceId,true);
             
           },function(error){    
                          MessagingService.addMessage(error.msg,'error');
    });
 

   
       $scope.fd.localVars.setField = function(form,name,value,msg)
        {
     				TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
        };  
   
  
  
    $scope.fd.localVars.getThisResourceWidget  = function()
    {

        //register here to ksm
        let dependent_field = "Field"+$scope.fd.UuidRef;
        let subscribedSubject =$scope.resourceDefinition.page_state_id+'-'+$scope.fd.SrcWidgetId
        let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
        let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",get_resource_record);
        let val = $scope.ksm.getState(subscribedSubject)
        if (val.status=='ok' && val.state && !$scope.formDefinition) get_resource_record(val.state)
    }

   
   
  
        
  
    let template;
    if ($scope.formDefinition) template = $templateCache.get('ktdirectivetemplates/ktCrudResource.html');
    else template = $templateCache.get('ktdirectivetemplates/ktCrudResourceExe.html');
          
    $element.append($compile(template)($scope)); 
  
  
}];
  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

           
      
          scope.fd.localVars.formType=scope.resourceDefinition.form_type;
      
          
  
        }
  } 
        
};
'use strict';



export function ktDatasetMapper  () {

        return {
             restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktDatasetMapper.html',
             scope:{
                       fd : "=",
             },
             controller: function($scope,CodesService,ResourcesDataService,GridsterService,$rootScope,ProcessingService,dragularService,$timeout,CODES_CONST,MessagingService)
             {
                $scope.fd.formPriority='e';
              $scope.fd.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_NEW_;
              $scope.fd.RelatedPopulateType=1;
              $scope.gsrvc = GridsterService
              if ($scope.fd.Parameters==undefined) $scope.fd.Parameters ={};              
              if ($scope.fd.PopulateType!=null && $scope.fd.PopulateType!="")
              {
                var pType = $scope.fd.PopulateType;
                var formPriority = pType.toString().substr(1,1);
                $scope.fd.RelatedPopulateType=pType.toString().substr(0,1);
                if (formPriority=="i" || formPriority=="e")
                {
                  
                  $scope.fd.formPriority = formPriority;
                }
              }

              if ($scope.fd.localVars.selectedResourceItem!=undefined)
              {
                $scope.fd.localVars.selectedResourceItem.src_type_text = $scope.fd.localVars.src_type_text[$scope.fd.RelatedPopulateType];
              }else
              {
                $scope.fd.localVars.selectedResourceItem = {src_type_text:$scope.fd.localVars.src_type_text[$scope.fd.RelatedPopulateType]};
              }
              
              $scope.fd.localVars.selectedResource=[];
              if ($scope.fd.localVars.selectedResourceItem != undefined)
              {
                 $scope.fd.localVars.selectedResource.push($scope.fd.localVars.selectedResourceItem);
                
              }


        // MIGOR DODAO 2.6.2021- PROVJERITI -POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)

        $scope.fd.localVars.getResources = function(resource_type)  {	
                
                if (resource_type==undefined) resource_type = $scope.fd.Parameters.SelectedResourceType
                if ($scope.fd.localVars.resourceList==undefined) $scope.fd.localVars.resourceList=[];
                var lang=$rootScope.globals.currentUser.lang;
                ResourcesDataService.getResourceDefListByType(lang,resource_type).then(
                    function(data) {
                            $scope.fd.localVars.resourceList = data.data;
                            $scope.fd.localVars.setResourceDd()  
                            
                    },function(error){    
                            MessagingService.addMessage(error.msg,'error');
                           });
					}
                              
		$scope.fd.localVars.setResourceDd = function(){		  
            let tmpResourceItem = $scope.fd.localVars.selectedResourceItem
                if ($scope.fd.Related!=undefined && $scope.fd.Related!=null) {
                        let pos = $scope.fd.localVars.resourceList.map(function(e) { return e.id; }).indexOf($scope.fd.Related);
                        if (pos>=0) {
                        $scope.fd.localVars.selectedResourceItem = $scope.fd.localVars.resourceList[pos]
                        $scope.fd.localVars.selectedResourceItem.name_confirmed=tmpResourceItem.name_confirmed

                    }
                }              
        }

        $scope.fd.localVars.getPublishedResources=function()
        {
            $scope.fd.localVars.publishedLoaded=false
                  
                ResourcesDataService.GetPublishedResourcesByTypeId($scope.fd.Related,'form').then(
                function (data) {       
              
                $scope.fd.localVars.publishedResourceList = data.data;
                $scope.fd.localVars.publishedLoaded=true
               
               },function(error){    
                    MessagingService.addMessage(error.msg,'error');
                });
            
        }         
        
        $scope.fd.localVars.GetPublishedResourcesByType = function(resource_type)  {	
                
                if (resource_type==undefined) resource_type = $scope.fd.Parameters.SelectedResourceType
                if ($scope.fd.localVars.publishedResourceList==undefined) $scope.fd.localVars.publishedResourceList=[];
                var lang=$rootScope.globals.currentUser.lang;
                
                // we are in build mode, so we should invalidate cahce (useCache is false)  TODO - provjeriti da li treba korisiti cache
                ResourcesDataService.GetPublishedResourcesByType(resource_type,'form', false).then(function (data) { 
                        //debugger   //GetPublishedResourcesByType  
              
                        $timeout(function(){
                            $scope.fd.localVars.publishedResourceList.length = 0;  
                            angular.extend($scope.fd.localVars.publishedResourceList, data.data);
                            //$scope.fd.localVars.publishedResourceList = data.data;
                 
                  
                            if ($scope.fd.Parameters.PublishedResourceId!=null && $scope.fd.Parameters.SelectVersionDirect) {
                                $scope.fd.localVars.setSelectedResource($scope.fd.Parameters.PublishedResourceId);
                            }  
                        
                         })
                 },function(error){    
                            MessagingService.addMessage(error.msg,'error');
                  });
               } 
    
    if ($scope.fd.localVars.resourceList==undefined) $scope.fd.localVars.resourceList=[]
    if ($scope.fd.Related==undefined || $scope.fd.localVars.resourceList.length==0)  $scope.fd.localVars.getResources($scope.fd.Parameters.SelectedResourceType)
    else $scope.fd.localVars.setResourceDd()
     /*
        if ($scope.fd.localVars.publishedResourceList==undefined || $scope.fd.localVars.publishedResourceList.length==0) {
                $scope.fd.localVars.GetPublishedResourcesByType();
        }
    */
             
       $scope.fd.localVars.changePriority= function(fp){
             $scope.fd.formPriority =fp; 
            };
         
          
         $scope.fd.localVars.confirm= function(){
               
               $timeout(function(){
                   $scope.fd.Parameters.Analytics = [];   // REMOVE OLD PARAMETERS  (Analytics....)
                   
                   $scope.fd.localVars.selectedResourceItem.src_type_text = $scope.fd.localVars.src_type_text[$scope.fd.RelatedPopulateType];
                   $scope.fd.PopulateType=$scope.fd.RelatedPopulateType+$scope.fd.formPriority;


                   $scope.fd.localVars.selectedResourceItem.name_confirmed = $scope.fd.localVars.selectedResourceItem.name
                    $scope.fd.Parameters.selectedResourceItem = {
                        'name_confirmed': $scope.fd.localVars.selectedResourceItem?.name_confirmed
                    }


                   $scope.fd.localVars.gridOptionsResourceData = {} //dataset is changed and gridOptions should be reset?? 
                   $scope.fd.localVars.datasetMapperType=0;
                   $scope.fd.GridState = {}
                   $scope.fd.localVars.selectedResourceItem_c=$scope.fd.localVars.selectedResourceItemPublished; 
                   
                   //if (!$scope.fd.Parameters.SelectVersionDirect) 
                    //{
                        let published = $scope.fd.localVars.publishedResourceList[$scope.fd.localVars.publishedResourceList.length-1]
                        
                        if (published!=undefined)
                        {
                            $scope.fd.localVars.selectedResourceItem_c = published
                            $scope.fd.Parameters.PublishedResourceId = published.id
                            $scope.fd.Parameters.PublishedResourceVersion = published.Version
                        }

                   // }
                   $scope.fd.localVars.setSelectedResource($scope.fd.Parameters.PublishedResourceId)

     
               });
               
             //  $scope.localVars.toggleProperties(0); //MIGOR dodao da se sakrije property kad stisne prozor , TODO - treba potvrditi da se nesto s time ne kvari
            };
				  
              
              
              $scope.fd.localVars.onSelectResourceCallback = function (item, model){

                  	let eventResultId=item.id;
                   	let eventResultName=item.name;
                    let eventResultParentElementId =item.parentElementId;
                    /*
                    if ($scope.fd.RelatedPopulateType!=1)
                    {
                        $scope.fd.localVars.getFormWidgets(item.id,$scope.fd.RelatedPopulateType);      
                    }*/
                    $scope.fd.Related=item.id
                    $scope.fd.Parameters.PublishedResourceId=0
                    $scope.fd.localVars.getPublishedResources()
                    //$scope.fd.localVars.selectedResourceItem = {id:eventResultId, name : eventResultName,parentElementId:eventResultParentElementId,Version:item.Version,ResourceDefId:item.ResourceDefId};
                    
                    
              }

              $scope.fd.localVars.onSelectVersionCallback = function (item, model){

                    $scope.fd.localVars.selectedResourceItemPublished = item
                    $scope.fd.Parameters.PublishedResourceId = item.id
                    $scope.fd.Parameters.PublishedResourceVersion = item.Version
                    /*
                     var eventResultId=item.id;
                     var eventResultName=item.name;
                     var eventResultParentElementId =item.parentElementId;
                     if ( item.id!=$scope.fd.localVars.selectedResourceItem.id && $scope.fd.localVars.relatedPopulateType!=1 )
                     {
                            $scope.fd.localVars.getFormWidgets(item.id,$scope.fd.RelatedPopulateType);      
                      }
                    
                      $scope.fd.localVars.selectedResourceItem = {id:eventResultId, name : eventResultName,parentElementId:eventResultParentElementId,Version:item.Version,ResourceDefId:item.ResourceDefId};
                    */
                    
              }
            
             $scope.fd.localVars.setSelectedSource = function(source_id){
             
                  if (source_id==-1)
                  {
                    
                    $scope.fd.RelatedPopulateType = '3';
                    $scope.fd.formPriority = 'e';
                    
                  }else
                  {
                   
                    $scope.fd.RelatedPopulateType = '2';
                    $scope.fd.formPriority = source_id.form_type;
                    $scope.fd.SrcWidgetId = source_id.parentElementId;
                    if (source_id.type=='rlist') $scope.fd.RelatedPopulateType = '4';
                    
                  }
             };
              
             $scope.fd.localVars.getFormWidgets = function(resource_id){
          

                  var lang=$rootScope.globals.currentUser.lang;
                  if ($scope.fd.PresentationId == undefined || $scope.fd.PresentationId==null) $scope.fd.PresentationId=0;
                  if ($scope.fd.UuidRef == undefined || $scope.fd.UuidRef==null) $scope.fd.UuidRef="0";
                  let formVersion = $scope.gsrvc.getResourceFormVersion($scope.fd.localVars.resourceId+$scope.fd.localVars.formType)
                  if (formVersion!=undefined)
                  {
                    ResourcesDataService.getFormWidgets(resource_id,$scope.fd.localVars.resourceId,$scope.fd.UuidRef,1,lang,formVersion?.Version).then(function(data) {
                               
                             
                     
                        $scope.fd.localVars.currentResourceInitiate = data.data.initiate_widgets;
                        
                        $scope.fd.localVars.currentResourceExecute = data.data.execute_widgets;
                      
                        $scope.fd.localVars.currentDownloaded = true;
                      
                      
                      
                        $scope.fd.localVars.previousResourceInitiate = data.data.initiate_widgets;
                        $scope.fd.localVars.previousResourceExecute = data.data.execute_widgets;
                     
                        $scope.fd.localVars.previousDownloaded = true;
                      
                      
                      
                         },function(error){
                           MessagingService.addMessage(error.msg,'error');
                    });
                }else MessagingService.addMessage('Error - Form version is undefined in dataset mapper directive (getFormWidgets function)','error');
             };
           
           
              $scope.fd.localVars.setPopulateMethod= function(populateMethod){
                        
                       $scope.fd.PopulateMethod=populateMethod;
                       
                       if (populateMethod=='A')
                        {
                          if ($scope.fd.localVars.selectedResourceItem_c!=undefined)
                          {
                                 var id=$scope.fd.localVars.selectedResourceItem_c.id;
                                 if (id==undefined) id=$scope.fd.localVars.selectedResourceItem_c.relatedId;
                                 //if (id!=undefined) $scope.fd.localVars.getFormWidgets($scope.fd.localVars.selectedResourceItem_c.id);
                          }
                          
                        }
                  };
                  
              $scope.fd.localVars.setPopulateMethod($scope.fd.PopulateMethod);
              
              
              $scope.fd.localVars.setPopulateType= function(populateType){
                        
                       $scope.fd.RelatedPopulateType=populateType;
                        
                        /*
                          if ($scope.fd.localVars.selectedResourceItem_c!=undefined)
                          {
                            $scope.fd.localVars.getFormWidgets($scope.fd.localVars.selectedResourceItem_c.relatedId);
                          }
                        */
                        
                  }
          
               },
             link: function (scope, elem, attrs) {
                       
             
             }
        }
};
'use strict';



export function ktDatasetMapperParent () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktDatasetMapperParent.html',
              controller: function($scope,CodesService,ResourcesDataService,GridsterService,$rootScope,ProcessingService,dragularService,$timeout,CODES_CONST,MessagingService){
               
            
                $scope.gsrvc = GridsterService
              if ($scope.gsrvc.parentResource[$scope.fd.UuidRef] == undefined) $scope.gsrvc.parentResource[$scope.fd.UuidRef]={}
              $scope.gsrvc.parentResource[$scope.fd.UuidRef].formPriorityParent='e';
              $scope.gsrvc.parentResource[$scope.fd.UuidRef].ParentSearchPriority='d';
              $scope.src_type_text_parent=CODES_CONST._POPULATE_TYPE_NEW_;
              $scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParentLocal=1;
              $scope.gsrvc.parentResource[$scope.fd.UuidRef].resourceListParentDownloaded=false
             
              if ($scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParent!=null)
              {
                var rpType = $scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParent;
                var formPriorityParent = rpType.toString().substr(1,1);
                var parentSearchPriority = rpType.toString().substr(2,1);
                $scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParentLocal=rpType.toString().substr(0,1);
              
                if (formPriorityParent=="i" || formPriorityParent=="e")
                {
                  
                  $scope.gsrvc.parentResource[$scope.fd.UuidRef].formPriorityParent = formPriorityParent;
                }
                
                if (parentSearchPriority=="i" || parentSearchPriority=="d")
                {
                  
                  $scope.gsrvc.parentResource[$scope.fd.UuidRef].ParentSearchPriority = parentSearchPriority;
                }
              }

              $scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent={}
              $scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent.src_type_text_parent = $scope.src_type_text_parent[$scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParent];
              

            $scope.gsrvc.parentResource[$scope.fd.UuidRef].resourceListParent=[];
            
            $scope.SetSelectedResourceParent = function(id)  {
              
              
              var pos = $scope.gsrvc.parentResource[$scope.fd.UuidRef].resourceListParent.map(function(e) { return e.id; }).indexOf(id);

              if (pos>=0){
                

                $scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceParent = $scope.gsrvc.parentResource[$scope.fd.UuidRef].resourceListParent[pos]
                $scope.gsrvc.parentResource[$scope.fd.UuidRef].ParentResourceDefId = $scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceParent.id
                $scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent.id = $scope.gsrvc.parentResource[$scope.fd.UuidRef].resourceListParent[pos].id;
                $scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent.name = $scope.gsrvc.parentResource[$scope.fd.UuidRef].resourceListParent[pos].name;
                
                $scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent.name_confirmed = $scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent.name +' ('+$scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent.id +')'
                $scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent_c=$scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent;
                
               
                $scope.SetPopulateTypeParent($scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParentLocal)

                

                $timeout(function(){

                    
                    $scope.gsrvc.parentResource[$scope.fd.UuidRef].resourceListParentDownloaded= true
                   
                })
                
                }
			    
            }
          
           $scope.setSelectedSourceParent = function(source_id){
             
                  if (source_id==-1)
                  {
                    
                    $scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParentLocal = '3';
                    $scope.gsrvc.parentResource[$scope.fd.UuidRef].formPriorityParent = 'e';
                    
                  }else
                  {
                   
                    $scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParentLocal = '2';
                    $scope.gsrvc.parentResource[$scope.fd.UuidRef].formPriorityParent = source_id.form_type;
                    $scope.gsrvc.parentResource[$scope.fd.UuidRef].SrcParentWidgetId =  source_id.parentElementId;
                    if (source_id.type=='rlist') $scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParentLocal = '4';
                    
                  }
             }; 
                  
         

		 //
			$scope.getResourceParent = function()  {
				
				if (true || $scope.fd.ElementType=="uploadfile" || $scope.fd.ElementType=="view" || $scope.fd.ElementType=="add" || $scope.fd.ElementType=="update"|| $scope.fd.ElementType=="rlist")
				{
					var lang=$rootScope.globals.currentUser.lang;
                    $scope.gsrvc.parentResource[$scope.fd.UuidRef].resourceListParentDownloaded = false
					
					
					// POPUNI LISTU DEFINICIJA OD RESURSA  -  potential parents 
					
					//if ($scope.fd.ElementType=="uploadfile") $scope.fd.Related =  $scope.fd?.Parameters?.rules?.[0]?.fileType?.ResourceDefUid 
					
					
					//TODO  umjesto ovog tamo kad odabire  a ovdje grešku jer nema!!
					
					
					//if ( ! $scope.fd.ParentResourceDefId) 	MessagingService.addMessage($scope.fd.ElementType + ', uuid=' + $scope.fd.UuidRef + ' - parent Resource not found' ,'error')
					
				if  (! $scope.fd.Related &&  $scope.fd.ElementType=='uploadfile')
						$scope.fd.Related =	 $scope.fd?.Parameters?.rules?.[0]?.fileType?.ResourceDefUid
					 
					 
					if  ($scope.fd.Related)  
					{	
							ResourcesDataService.getExistingResourceRelationships($scope.fd.Related, true).then(
								function(data) {
                                          
									$scope.gsrvc.parentResource[$scope.fd.UuidRef].resourceListParent = data.data;
									
									if ($scope?.fd?.localVars?.loadingParams) 	$scope.fd.localVars.loadingParams=false

									if ($scope.gsrvc.parentResource[$scope.fd.UuidRef].ParentResourceDefId!=null && $scope.gsrvc.parentResource[$scope.fd.UuidRef].ParentResourceDefId!=undefined)
									
										$scope.SetSelectedResourceParent($scope.gsrvc.parentResource[$scope.fd.UuidRef].ParentResourceDefId);
							
									
									$scope.gsrvc.parentResource[$scope.fd.UuidRef].resourceListParentDownloaded = true
							
								},function(error){    
									MessagingService.addMessage(error.msg,'error');
								})
							
					} //else MessagingService.addMessage('Resource not selected!','error');
							
				}
			}
				  
          
          
				  $scope.getResourceParent();
          
           $scope.changePriorityParent= function(id){
             
             $scope.gsrvc.parentResource[$scope.fd.UuidRef].formPriorityParent = id;
            
            };
           $scope.changeParentSearchPriority= function(id){
             
              $scope.gsrvc.parentResource[$scope.fd.UuidRef].ParentSearchPriority = id;
            };     
         
		 $scope.confirmParent= function(){
               
          
               if  ($scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent_c!=undefined){
                
                      if ($scope.gsrvc.parentResource[$scope.fd.UuidRef].ParentResourceDefId!=$scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent_c.id && $scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParent!=null && $scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParent!=undefined)
                      {
                          $scope.gsrvc.parentResource[$scope.fd.UuidRef].ParentResourceDefId=$scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent_c.id;
                       
                      }
                      $scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent.name_confirmed = $scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent_c.name +' ('+$scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent_c.id +')'

                 }
               
               $scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent.src_type_text = $scope.src_type_text_parent[$scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParentLocal];
               
               $scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParent=$scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParentLocal+$scope.gsrvc.parentResource[$scope.fd.UuidRef].formPriorityParent+$scope.gsrvc.parentResource[$scope.fd.UuidRef].ParentSearchPriority;
               
            };

               // FUNCTION ONSELECT DATASET CALLBACK
              $scope.onSelectResourceParentCallback = function (item, model){
				  
				  if (item) {
                  	var eventResultId=item.id;
                  	var eventResultName=item.name;
                    var eventResultParentElementId =item.parentElementId;
                    //if (item.id!=$scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent_c?.id){
                     // $scope.gsrvc.parentResource[$scope.fd.UuidRef].localVars.getFormWidgetsParent(item.id,$scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParentLocal);     
                    //}
              
                	  $scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent_c = {id:eventResultId, name : eventResultName,parentElementId:eventResultParentElementId};
				  } else
						$scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent_c=null
                    
              }//ONSELECT DATASET CALLBACK
            
             $scope.getFormWidgetsParent = function(resource_id,type){
          

                var lang=$rootScope.globals.currentUser.lang;
                if ($scope.gsrvc.parentResource[$scope.fd.UuidRef].localVars.formType==undefined) $scope.gsrvc.parentResource[$scope.fd.UuidRef].localVars.formType=""
                if ($scope.gsrvc.parentResource[$scope.fd.UuidRef].UuidRef == undefined || $scope.gsrvc.parentResource[$scope.fd.UuidRef].UuidRef==null) $scope.gsrvc.parentResource[$scope.fd.UuidRef].UuidRef="0";
                let formVersion = $scope.gsrvc.getResourceFormVersion($scope.gsrvc.parentResource[$scope.fd.UuidRef].localVars.resourceId+$scope.gsrvc.parentResource[$scope.fd.UuidRef].localVars.formType)

                 if (formVersion!=undefined)
                  {
                  ResourcesDataService.getFormWidgets(resource_id,$scope.gsrvc.parentResource[$scope.fd.UuidRef].localVars.resourceId,$scope.gsrvc.parentResource[$scope.fd.UuidRef].UuidRef,1,lang,formVersion.Version).then(function(data) {
                                 $scope.gsrvc.parentResource[$scope.fd.UuidRef].localVars.currentTaskInitiateDatasetsParent = data.data.initiate_widgets;
                                 $scope.gsrvc.parentResource[$scope.fd.UuidRef].localVars.currentTaskExecuteDatasetsParent = data.data.execute_widgets;
                                 $scope.gsrvc.parentResource[$scope.fd.UuidRef].localVars.currentDownloadedParent = true;
                                  
                                  
                    },function(error){
                                 MessagingService.addMessage(error.msg,'error');
                      });

              }else MessagingService.addMessage('Error - Form version is undefined in dataset mapper parent directive (getFormWidgetsParent function)','error');
             };
           
           
              
                  $scope.SetPopulateTypeParent= function(populateType){
                        
                     $scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParentLocal=populateType;
                       
                     /*if ($scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent_c!=undefined)
                     {
                            $scope.gsrvc.parentResource[$scope.fd.UuidRef].localVars.getFormWidgetsParent($scope.gsrvc.parentResource[$scope.fd.UuidRef].selectedResourceItemParent_c.id,$scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParentLocal);
                     }
                       */  
                        
                  }
                       
              $scope.getDatasetSources= function(){
                        
                        var radio = $scope.gsrvc.parentResource[$scope.fd.UuidRef].PopulateTypeParentLocal;
                        
                       }
                       
             },
             link: function (scope, elem, attrs) {
             
            
             
            
             //$scope.getDatasetSources();
          
             }
        }
};
'use strict';

export function ktDatasetToDatasetMapper () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktDatasetToDatasetMapper.html',
             controller: function ($scope,$state,CodesService,ResourcesDataService,GridsterService,$rootScope,ProcessingService,dragulaService,$timeout,CODES_CONST,MessagingService)
			 {
                 $scope.gsrvc = GridsterService; 
                  $scope.CTRL='ktDatasetToDatasetMapper'
                  if ($scope.fd.DatasetMapping ==undefined) $scope.fd.DatasetMapping = []; 
              
                $scope.$on("$destroy", function() {
                    //debugger
                    //dragulaService.destroy($rootScope, dragula_bag);
                    // TODO - Check is dragula is properly destroying bags (if not - manually destroy)
                });
             
              $scope.dataset1Fields = [];
              $scope.dataset2Fields = [];
			  
			  $scope.remove = function(sMap, index)
			  {
				  //debugger
				  $scope.mappingList.push( $scope.fd.DatasetMapping.splice(index,1)[0])
			  }
			  
			  $scope.sortList = function (list) {
				 
			return list
				 if (list?.length==0) {
					 return [{id:0}]
				 } else return list
			 }
			 
             
              //if ($scope.fd.selectedPackages==undefined) $scope.fd.selectedPackages=[];
             
            /*
            $scope.fd.localVars.confirmDataset2Dataset= function(){
               
               $timeout(function(){
               
                //$scope.fd.selectedPackages =$scope.fd.localVars.gridApi.selection.getSelectedRows();
                
                if ($scope.fd.selectedPackages!=undefined)
               {
                $scope.fd.DatasetMapping = [];
                  for (var i=0;i<$scope.fd.selectedPackages.length;i++)
                  {
                    $scope.fd.DatasetMapping.push($scope.fd.selectedPackages[i])
                      
                  
                  }
               }

               });
               
            };
            */
    var lang=$rootScope.globals.currentUser.lang;

    $scope.mappingTypes = [{id:1,value:1,name:'Fixed'},{id:2,value:2,name:'This resource'},{id:3,value:3,name:'Previous resource'}]
    /*
    CodesService.getCodesByName('dmt',lang).then(function (data) {
             $scope.mappingTypes = data.data;
    });*/ 
    //setup dragula
    $scope.setupDragula = function()
    {
         var widgetHandle = "element-drag-handle";
         var bag = dragulaService.find($rootScope, 'bag-resource-mapping');
         if (bag) dragulaService.destroy($rootScope, 'bag-resource-mapping');
         
         dragulaService.options($rootScope, 'bag-resource-mapping', {
                       revertOnSpill: true,
                       removeOnSpill: false,
                      /* copy:function (el,source){
                        
                        return source.id=='resource1-mapping';
                       
                        },
                       //direction:'vertical',
                       accepts:function (el,target, source) {
                          return target.id!='resource1-mapping';
                       },*/
                       moves: function (el, container, handle) {
                                 return handle.classList.contains(widgetHandle);
                       }
                   });     
              
    };
        
        // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
		$scope.fd.localVars.getDatasets = function()  {
			
            ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
						function(data) {			
							$scope.fd.localVars.datasetList = data.data;
                            $scope.fd.localVars.datasetLoaded=true;
                            //console.log($scope.datasetList);
				 
							},function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					};
     $scope.getDatasetMappings = function (datasetId) {
    
         var lang = $rootScope.globals.currentUser.lang;
         
         ResourcesDataService.getDatasetMappings(datasetId,lang).then(function(data) {
                               
                             $scope.dataset2Fields = data.data;
                             
                             $scope.setupDragula();
                             $scope.dataset1Loaded=true;
                             
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        };   

     $scope.getResourceFields = function (item,type) {
    
         var lang = $rootScope.globals.currentUser.lang;
         
         ResourcesDataService.getResourceFields(item.Dataset1.id,lang).then(function(data) {
                               
                             
                              if (type==1){
                                  $scope.dataset1Fields = data.data;

                               }
         
                              else{
                                $scope.dataset2Fields = data.data;

                                }
                               
                                $scope.getDatasetMappings(item.id);
                                
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        };
        
    $scope.fd.localVars.showMappingDetailsFn = function (item) {
        /*
        $scope.dataset1Loaded=false;
        if ($scope.dataset1Fields!=undefined) $scope.dataset1Fields.length=0;
        if ($scope.dataset2Fields!=undefined) $scope.dataset2Fields.length=0;
        
        $scope.selectedDataset1 = {id:item.Dataset1.id,name: item.Dataset1.resourcedeflang_set[0].Name};
        $scope.selectedDataset2 = {id:item.Dataset2.id,name: item.Dataset2.resourcedeflang_set[0].Name};
        $scope.getResourceFields(item,1);
        
        $scope.tmpMappingFields={}
        $scope.tmpMappingFields.dataset1=$scope.selectedDataset1;
        $scope.tmpMappingFields.dataset2=$scope.selectedDataset2;
        $scope.tmpMappingFields.mappingType= {id:item.MappingType.id,name:item.MappingType.Value,value:item.MappingType.Name};  
        $scope.tmpMappingFields.mappingDisplayName=item.DatasetMappingHeadLang_datasetmappingheadid[0].Name
        $scope.tmpMappingFields.mappingName=item.MappingName;
       
        $scope.fd.localVars.showMappingData(item);
        */
    
    };
        $scope.fd.localVars.showMappingData = function (selectedResource) {
        

        $scope.fd.localVars.showMappingDetails=true;
        $scope.fd.localVars.showMappingName=true;
          
         if (selectedResource==false || selectedResource==undefined) 
          {
             $scope.mappingFields={};
             $scope.saveDatasetMappingHeadStatus='createMapping';
          } else  
          {
              $scope.saveDatasetMappingHeadStatus='updateMapping';
              $scope.mappingFields= $scope.tmpMappingFields;
          }
          
         $scope.fd.localVars.getDatasets();//puni datasetList
         var lang = $rootScope.globals.currentUser.lang;
         CodesService.getCodesByName('dmt',lang).then(function (data) {
                                $scope.fd.localVars.codeList = data.data;
                                $scope.fd.localVars.mappingTypeLoaded = true;
            }); 
        };
        
        $scope.fd.localVars.gotoMapping = function () {
            
            $state.go('app.navbar.resources.dataset-transform')
        }
        $scope.removeSelectedMappings=  function()
        {
            let pos;
            if ($scope.fd?.DatasetMapping)
                for (let i=0;i<$scope.fd.DatasetMapping.length;i++)
                {
                    if ($scope.fd.DatasetMapping[i]!==undefined && $scope.fd.DatasetMapping[i]!==null)
                    {
                        pos  = $scope.mappingList.map(function(e) { return e.id; }).indexOf($scope.fd.DatasetMapping[i].id);
                    
                        $scope.mappingList.splice(pos,1);
                    }
                }
        }
        $scope.removeItem=  function(pindex,index)
        {
            $scope.dataset2Fields[pindex].fields.splice(index,1);
        };
        $scope.cancelMapping = function () {
            $scope.saveDatasetMappingHeadStatus='CancelOrInit';
            $scope.fd.localVars.showMappingDetails=false;
            $scope.fd.localVars.showMappingName=false;
        };
        $scope.fd.localVars.getMappingPackages = function () {
    
            var lang = $rootScope.globals.currentUser.lang;
            var fromDs = 0;
            var toDs = $scope.fd.localVars.selectedResourceItem?.id;
        
            ResourcesDataService.getMappingPackages(fromDs,toDs,lang).then(function(data) {
               
                $scope.mappingList = data.data;
                $scope.removeSelectedMappings();
                $scope.mappingsLoaded=true;
                $scope.setupDragula();
                
            },function(error){
                  
                MessagingService.addMessage(error.msg,'error');  
            });
        };
         $scope.fd.localVars.getMappingPackages();   
    },

    link: function (scope, elem, attrs) {
             
    }
  }      
};
'use strict';

export function ktDate () {

	var datePickerCtrl = ['$scope','$rootScope','GridsterService','CodesService','$compile','$element','$templateCache', 
		function ($scope,$rootScope,GridsterService,CodesService,$compile,$element,$templateCache) {
        
		//debugger
		$scope.$rootScope =$rootScope
		//convert string dates to js
		if ($scope.fd.Search) {
			if ($scope.fd.Search.between1)  $scope.fd.Search.between1= new Date($scope.fd.Search.between1 )
			if ($scope.fd.Search.between2)  $scope.fd.Search.between2= new Date($scope.fd.Search.between2 )
			if ($scope.fd.Search.value)  	$scope.fd.Search.value= new Date($scope.fd.Search.value)	
		}
	
		let itemValue = null;
        
		if ($scope.formData!=undefined) {
			if ($scope.formData.length==0)	
						$scope.formData=[{}];
			itemValue=$scope.formData[0][$scope.fd.FieldName]      
		}  else  
			$scope.formData=[{}];
		
		//set FormData  values
		if ($scope.fd.Search) {
			if ($scope.fd.Search.value)  $scope.formData[0][$scope.fd.FieldName]= new Date($scope.fd.Search.value)	
		}
		
		$scope.myscope = $scope	
		$scope.CTRL = $scope.CTRL  + ':ktdate'
		$scope.gsrvc = GridsterService;
		$scope.fd.localVars = {}        
		$scope[$scope.fd.id]  = {'fd': $scope.fd, 'localvars':$scope.fd.localVars}

		if ($scope.fd.ParametersLang==undefined || $scope.fd.ParametersLang==null) 
				$scope.fd.ParametersLang={};
		
		$scope.fd.isOpen=false;
        if ($scope.localVars==undefined) 
				$scope.localVars={};
			
		$scope.fd.localVars.search = [
			{id:1,filter:'gt',code_name:'gte_date',name:"From date",icon:"fa fa-chevron-right"},
			{id:2,filter:'lt',code_name:'lte_date',name:"To date",icon:"fa fa-chevron-left"},
			{id:3,filter:'eq',code_name:'eq_date',name:"Exact date",icon:"fa fa-bars"},
			{id:4,filter:'between',code_name:'between_date',name:"Between <date1> and <date2>",icon:"fa fa-expand"}
		];
	

        $scope.fd.localVars.processFilters = function(filterList)
        {
            for (let i=0;i<$scope[$scope.fd.id]['fd'].localVars.search.length;i++) {
                let pos = filterList.map(function(e) { return e.id; }).indexOf($scope[$scope.fd.id]['fd'].localVars.search[i].code_name);
                if (pos>=0) $scope[$scope.fd.id]['fd'].localVars.search[i].name = filterList[pos].name
            }
            
            if ($scope.fd.Search===undefined || $scope.fd.Search===null)   $scope.fd.Search=$scope[$scope.fd.id]['fd'].localVars.search[2];//initialize to equals
            if ($scope.fd.Search)  $scope.fd.Search.value= $scope.formData[0][$scope.fd.FieldName]; 
            $scope[$scope.fd.id]['fd'].localVars.filterReady=true
        }

        if ($scope.showSearchFilters || $scope.resourceDefinition.form_definition) {
                  let lang=$rootScope.globals.currentUser.lang;
                    CodesService.getCodesByName('search_filters',lang).then(function (data) {
                                try {
                                 //$scope.fd.localVars.processFilters(data.data) // BUG TODO
                                 $scope[$scope.fd.id]['fd'].localVars.processFilters(data.data)
                                
                                } catch (err) {
                                    debugger
                                }           
                    });
        }
		  

        
    let itemValueState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+'-boolValueStateName'+$scope.fd.PresentationId,itemValue);
    let itemValueStateName = itemValueState.subject.name;
        
        
    let value_changed = function(data)
    {
            itemValueState.subject.setStateChanges = data;
            itemValueState.subject.notifyObservers("valueChanged");
    };
        
    let action_value_changed = $scope.ksm.addAction(itemValueState,"valueChanged",value_changed);
       
	   
	   
    $scope.fd.on_change_action=function()
    {     
		//debugger //on_change_action		
		
		if ($scope.$rootScope.globals.currentApp.uid!="323_1") //only in execute mode
			if ( $scope.formData[0][$scope.fd.FieldName] == null) 	$scope.formData[0][$scope.fd.FieldName] ='' // after clearing the date on the form, the date must be '' instead "null"
		 
        if ($scope.fd.Dbtype==="datefielddefinition" && $scope.formData[0][$scope.fd.FieldName]) {
             $scope.formData[0][$scope.fd.FieldName].setHours(12,0,0,0);         
        }

        $scope.ksm.executeAction(itemValueState,"valueChanged", $scope.formData[0][$scope.fd.FieldName]);
        if ($scope.fd.Search)	{
				if ( $scope?.formData.length>0) 
								$scope.fd.Search.value = $scope.formData[0][$scope.fd.FieldName];
			}		
    }
       
	   
    $scope.fd.on_change_between=function(between)
    {
          if ($scope.fd.Dbtype==="datefielddefinition" && $scope.fd.Search[between]!==undefined && $scope.fd.Search[between]!==null)    $scope.fd.Search[between].setHours(12,0,0,0);      
    }
        
        let apply_value = function(data) {
                if (data!=undefined) $scope.formData[0][$scope.fd.FieldName] = data;
        };
        
        if ($scope.fd?.Parameters?.DependentFieldId!=undefined && $scope.fd?.Parameters?.DependentFieldId!=null)   
        {
            if ($scope.fd.Parameters.DependentFieldId!="") {
                let dependent_field = "Field"+$scope.fd.PresentationId;
                let subscribedSubject = $scope.resourceDefinition.page_state_id+'-'+$scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
                let state = $scope.ksm.getState(subscribedSubject);
                if (state.status=="ok") $scope.formData[0][$scope.fd.FieldName] = state.state;
            }
        }
        
   
		
	  $scope.applyDateFilters = function(index) //ovo je aktivna funkcija!!
	  {
		$scope.fd.Search=$scope.fd.localVars.search[index];
      
        if ($scope.formData !=undefined && $scope.formData.length>0) {
            if ($scope.formData[0][$scope.fd.FieldName]!=undefined)
							$scope.fd.Search.value=$scope.formData[0][$scope.fd.FieldName];// ponovno dodaj value
        }
		
		if ($scope.fd.Search.id==4)  
				$scope.fd.Search.ShowSecondDate=true // kad je  between
		else  
			$scope.fd.Search.ShowSecondDate=false  		
	  };


    $scope.showHideProperties = function(value)
    {
        $scope.gsrvc.setFieldPropertiesOpened(value);
        $scope.localVars.showFieldProperties=$scope.gsrvc.getFieldPropertiesOpened();
        if (value) 	$scope.gsrvc.setPropertiesPosition();
    };

  $scope.fd.localVars.formats = [{id:1,name:'dd-MMMM-yyyy HH:mm:ss:sss'}, {id:2,name:'yyyy/MM/dd HH:mm:ss:sss'}, {id:3,name:'dd.MM.yyyy HH:mm:ss:sss'}];
  $scope.fd.localVars.formatsTime = [{id:1,name:'HH:mm:ss'}, {id:2,name:'HH:mm:ss:sss'}, {id:2,name:'HH:mm'}];
  $scope.fd.localVars.formatsDate = [{id:1,name:'dd-MMMM-yyyy'}, {id:2,name:'yyyy/MM/dd'}, {id:3,name:'dd.MM.yyyy'}, {id:4,name:'shortDate'}];
  
 
  
 if ($scope.fd.dateFormatList ) delete $scope.fd.dateFormatList ;
 if ($scope.fd.timeFormatList ) delete $scope.fd.timeFormatList ;


  $scope.fd.setFormat = function()
  {
      $scope.fd.format="";
      if  ($scope.fd.ParametersLang.format1!=undefined && $scope.fd.ParametersLang.format1!=null)  {
        $scope.fd.format = $scope.fd.ParametersLang.format1.name;
      }
      
      if  ($scope.fd.ParametersLang.format2!=undefined && $scope.fd.ParametersLang.format2!=null){
        if ($scope.fd.format!="") {
			$scope.fd.format = $scope.fd.format+" "+$scope.fd.ParametersLang.format2.name;
        } else {
          $scope.fd.format = $scope.fd.ParametersLang.format2.name; 
        }
      }
      
      if ($scope.fd.format ==""){
        $scope.fd.format = $scope.fd.localVars.formats[2].name;
      }
  }
  
    let template;
    if ($scope.resourceDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktDate.html');
    else template = $templateCache.get('ktdirectivetemplates/ktDateExe.html');
    
    $element.append($compile(template)($scope));
    
    if (itemValueState.subject.currentStateIndex>=0) {
			$scope.formData[0][$scope.fd.FieldName] = itemValueState.subject.getState;
    }   
    
    if ($scope.formData[0][$scope.fd.FieldName]!=undefined) $scope.ksm.executeAction(itemValueStateName,"valueChanged", $scope.formData[0][$scope.fd.FieldName]);

                
}];//datepickerCtrl

 
        return {
            restrict: 'A',
			controller: datePickerCtrl,
             link:  function (scope, elem, attrs,ctrl) 
			 {
                         
             scope.fd.localVars.dateFormatList = [{id:1,name:'dd.MM.yyyy'},{id:2,name:'dd-MM-yyyy'},{id:3,name:'dd/MM/yyyy'},{id:4,name:'dd.MM.yy'}];
             scope.fd.localVars.timeFormatList = [ {id:1,name:'HH:mm', mask:'99:99'},
										 {id:2,name:'HH:mm:ss'},
										// {id:3,name:'HH:mm'},
										 {id:4,name:'HH:mm:ss:sss'}
										 ];
             
            var posFormatDate = scope.fd.localVars.dateFormatList.map(function(e) { return e.name.toString(); }).indexOf(scope.fd.ParametersLang.format1);
              
            if (posFormatDate>=0){
                             scope.fd.format1=scope.fd.localVars.dateFormatList[posFormatDate];      
            }
			
            var posFormatTime = scope.fd.localVars.timeFormatList.map(function(e) { return e.name.toString(); }).indexOf(scope.fd.ParametersLang.format2);
              
            if (posFormatTime>=0){
              scope.fd.ParametersLang.format2=scope.fd.localVars.timeFormatList[posFormatTime];      
             }
			 
            scope.fd.dirLoaded = true

            scope.fd.setFormat(); 
               //find object
			   
             scope.fd.showProperties = function()
             {
                  scope.localVars.showFieldProperties = true;
                  scope.gsrvc.setFieldProperties(scope.fd,scope.inputArray);
                };   
              
          scope.fd.setSystemDate=function()
		  {
                if (scope.fd.UseSystemDate) {
                  if (scope.formData !=undefined && scope.formData.length>0) {
                      scope.formData[0][scope.fd.FieldName]=new Date();
                  }
               }    
          }
             
        
             
              if (scope.formData !=undefined && scope.formData.length>0)
              {
                    if (scope.formData[0][scope.fd.FieldName]!= null && scope.formData[0][scope.fd.FieldName]!="")  {
                      scope.formData[0][scope.fd.FieldName] = new Date (scope.formData[0][scope.fd.FieldName]);
                   }
              }
               
              scope.fd.SetDefault = function()
             {
                  scope.fd.DefaultValue = {value:scope.formData[0][scope.fd.FieldName]};
              }
                
              if (scope.fd.UpdateWithDefault && !scope.fd.NoUpdate) scope.formData[0][scope.fd.FieldName] = new Date (scope.fd.DefaultValue?.value)
              if (scope.fd.UseSystemDate) scope.fd.setSystemDate();

   
            }
        };
    };
	
	
function DatePickerCtrl2 ($scope) {

	$scope.CTRLNAME='DatePickerCtrl2';
    $scope.fd.localVars.search=[                     /*  MIGOR TODO - VIDJETI DA LI OVO TREBA zaKOMENTIRATI ILI NE */
		{id:1,filter:'gte',name:"From <date>",icon:"fa fa-chevron-right"},
		{id:2,filter:'lte',name:"To <date>",icon:"fa fa-chevron-left"},
		{id:3,filter:'eq',name:"On <date>",icon:"fa fa-bars"},      // MIGOR TODO - vidjeti zasto se pokazuje na pocetku od datePicker2 kontrolera umjesto prvog
		{id:4,filter:'between',name:"Between <date> and <date>",icon:"fa fa-expand"}
	];
 
    if ($scope.fd.ParametersLang==undefined || $scope.fd.ParametersLang==null) $scope.fd.ParametersLang={};
 
        $scope.CTRL='datepicker2';
  
        $scope.refreshSearchValue = function() {
                 if ($scope.fd.Search) $scope.fd.Search.value=$scope.fd.sItemValue;      
        } 
        
	  $scope.applyDateFilters = function(index) {
           
		  var i=$scope.fd.localVars.search.selected.id; 

		  if ($scope.fd.localVars.search.selected.id==4)  	$scope.fd.localVars.search.showSecondDate=true // if (scope.fd.search.name=="Equals") scope.fd.search=null;
		  else  $scope.fd.localVars.search.showSecondDate=false
		  		
	  };

  $scope.today = function() {
    $scope.dt = new Date();
  };
  $scope.today();

  $scope.clear = function() {
    $scope.dt = null;
  };

  $scope.inlineOptions = {
    customClass: getDayClass,
    minDate: new Date(),
    showWeeks: true
  };

  $scope.dateOptions = {
    dateDisabled: disabled,
    formatYear: 'yy',
    minDate: new Date(),
    startingDay: 1
  };

  // Disable weekend selection
  function disabled(data) {
    var date = data.date,
      mode = data.mode;
    return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
  }

  $scope.toggleMin = function() {
    $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date();
    $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
  };

  $scope.toggleMin();

  $scope.open1 = function() {
    $scope.popup1.opened = true;
  };

  $scope.open2 = function() {
    $scope.popup2.opened = true; //DatePickerCtrl2
  };
  
  $scope.applyDateFilters = function() {
	  var sc=$scope;
	  var t=sc.fd;
	
    $scope.popup2.opened = true;
  };
   

  $scope.setDate = function(year, month, day) {
    $scope.dt = new Date(year, month, day);
  };

  $scope.fd.localVars.formats = [{id:1,name:'dd-MMMM-yyyy HH:mm:ss:sss'}, {id:2,name:'yyyy/MM/dd HH:mm:ss:sss'}, {id:3,name:'dd.MM.yyyy HH:mm:ss:sss'}];
  $scope.fd.localVars.formatsTime = [{id:1,name:'HH:mm:ss'}, {id:2,name:'HH:mm:ss:sss'}, {id:2,name:'HH:mm'}];
  $scope.fd.localVars.formatsDate = [{id:1,name:'dd-MMMM-yyyy'}, {id:2,name:'yyyy/MM/dd'}, {id:3,name:'dd.MM.yyyy'}, {id:4,name:'shortDate'}];
 
  $scope.setFormat = function()
  {
      $scope.format="";
      if  ($scope.fd.ParametersLang.format1!=undefined && $scope.fd.ParametersLang.format1!=null){
        $scope.format = $scope.fd.ParametersLang.format1.name;
      }
      
      if  ($scope.fd.ParametersLang.format2!=undefined && $scope.fd.ParametersLang.format2!=null)
      {
        if ($scope.format!="") {
         $scope.format = $scope.format+" "+$scope.fd.ParametersLang.format2.name;
        } else {
          $scope.format = $scope.fd.ParametersLang.format2.name;
        }
      }
      
      if ($scope.format =="") {
        $scope.format = $scope.formats[2];
      }
  }
  $scope.altInputFormats = ['M!/d!/yyyy'];

  $scope.popup1 = {
    opened: false
  };

  $scope.popup2 = {
    opened: false
  };

  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  var afterTomorrow = new Date();
  afterTomorrow.setDate(tomorrow.getDate() + 1);
  
  $scope.events = [
    {
      date: tomorrow,  status: 'full' },
    {
      date: afterTomorrow, status: 'partially' }
  ];

  function getDayClass(data) {
    var date = data.date,
      mode = data.mode;
    if (mode === 'day') {
      var dayToCheck = new Date(date).setHours(0,0,0,0);

      for (var i = 0; i < $scope.events.length; i++) {
        var currentDay = new Date($scope.events[i].date).setHours(0,0,0,0);

        if (dayToCheck === currentDay) {
          return $scope.events[i].status;
        }
      }
    }
    return '';
  }
};
'use strict';

export function ktDateExtendedProperties () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktDateExtendedProperties.html',
             controller: function(CodesService,ResourcesDataService,$rootScope,ProcessingService){},
             link: function (scope, elem, attrs) {
      
              }
        }
  
};
'use strict';

export function ktDeleteElement () {
        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktDeleteElement.html',
             link: function (scope, elem, attrs) {
  
            }
        };
};
'use strict';

export function ktDownload () {
        return {
            restrict: 'A',
		
             templateUrl: 'ktdirectivetemplates/ktDownload.html',
             controller: function($scope,$rootScope,GridsterService,WidgetDataExchangeService,UtilityService,ResourcesDataService){
				 
			
				$scope.fd.localVars = {
					calculateFunctions :[ {id:1,name:'sum'},{id:2,name:'mean'},{id:3,name:'min'},{id:4,name:'max'},{id:5,name:'count'} ] ,
					gsrvc: GridsterService
				}    

                
                 let w_actions=[
                    {id:1,name:'download'},
                    {id:2,name:'downloadWithParams'},
            
                ]
				
                
				if ($scope.fd.localVars==undefined)  $scope.fd.localVars={}
				$scope.fd.localVars.resourceDefinition = $scope.resourceDefinition
				
				$scope.localVars = {gsrvc:GridsterService} //because kt-delete-element
			
				if ($scope.fd.localVars.parentResourceId==undefined) $scope.fd.localVars.parentResourceId = $scope.resourceDefinition.pageId ?? $scope.resourceDefinition.uid // if directly on page 

                $scope.showProperties = function(event)
                {
                  $scope.fd.localVars.gsrvc.setFieldProperties($scope.fd,event);
                }
				
				
				
				  //register widget 
				  var out_fields = ['resourceId']
				  if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
							

				  var widgetDefinition = {
					  DEI: [],
						actions: w_actions,
						widgetLabel: 'Download',
						widgetName: 'ktDownload',
						widgetId: $scope.fd.UuidRef,
						task_initiate_id:$scope.taskInitiateId,
						task_execute_id:$scope.taskExecuteId,
						taskId:  $scope.lTaskId,
						resource_id:$scope.resourceDefinition.page_state_id,
						resourceDefId : $scope.fd.Related, 
						output:out_fields,
						parentResourceId:$scope.fd.localVars?.parentResourceId
					}
				  
				  $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
				  
				  $scope.fd.localVars.localId=$scope.fd.localVars.localWidgetId;
				  $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
				
				 if ($scope.resourceDefinition.form_definition || true){
                    ResourcesDataService.getResourceDefListByType($rootScope.globals.currentUser.lang,'file').then(
                        function(data) {            
                            $scope.fd.localVars.listOfFileTypes = data.data;
                         }
                        ,function(error){   MessagingService.addMessage(error.msg,'error')  }
                    );
        }
		
		$scope.fd.localVars.convertToDropdownList = function (inputlist, uid)
		{
			for (let i=0; i<inputlist.length;i++){
				inputlist[i] = { 
					id: inputlist[i]['resource' + uid + '_id'], 
					name: inputlist[i]['resource' + uid + '_FileName'],
                    guid: inputlist[i]['resource' + uid + '_guid']
				}
			}
		}
     		
		$scope.fd.localVars.fileSelected = async function (selected) {//Prepare list for dropdown ( {id , name})
			let id = selected.id//.split("_")[0]
			$scope.fd.localVars.fileRecords.length=0
			let data = await ResourcesDataService.getDatasetDataSimple(id)	
			$scope.fd.localVars.convertToDropdownList (data.data, selected.id)
			$scope.fd.Parameters.FileId = null
			$scope.fd.localVars.recordSelected = null
			if (data.data?.length) $scope.fd.localVars.fileRecords = data.data
		}
				
		
		$scope.fd.localVars.fileRecordSelected =  function (selected) {		
						$scope.fd.Parameters.FileId = selected.guid
		}
		
		
				
                },//end controler
				
             link: function (scope, elem, attrs) {
              
              if (scope.fd) {
                  if (scope.fd.Parameters == null) scope.fd.Parameters = {} //null or undefined !
                 
                  scope.fd.isLabelStyle = true;
				  scope.fd.Parameters.HideElementProperties = false 
				  
				  //if (scope.fd.Parameters.widgetReference)
							//scope.fd.Parameters.HideElementProperties = false 
				  //else 
					//  scope.fd.Parameters.HideElementProperties = true //hide value properties
						
				  
              }
            
            
           
            }
        };
};
'use strict';

export function ktDropdown ($timeout) {

        return {
            restrict: 'EA',
            require:['^form','ngModel'],
            templateUrl: 'ktdirectivetemplates/ktDropdown.html',
            controller: function($scope)
            {
               
                $scope.processKeyboardEntry = function(ev,index)
                {
                    let code = ev.keyCode || ev.which;
                    let key = ev.key;

                    //enter
                    if (code==13 && (ev.currentTarget.type=="button" || ev.currentTarget.type=="text")){
                        //move focus to next element
                        ev.preventDefault();
                        let next=index+1;
                        let id=$scope.parentFormId+"."+$scope.dropdownId+".DropdownItem"+next;
                        let elem = document.getElementById(id);
                        if (elem!=null) elem.focus(); 
                    }
                    //keydown
                    if (code==40){
                      //move focus to next element
                       ev.preventDefault();
                       let next=index+1;
                       let id=$scope.parentFormId+"."+$scope.dropdownId+".DropdownItem"+next;
                       let elem = document.getElementById(id);
                       if (elem!=null) elem.focus(); 
                    }
                    //keyup
                    if (code==38){
                      //move focus to previous element
                       ev.preventDefault();
                       let prev=index-1;
                       let elemDef = $scope.parentFormId+"."+$scope.dropdownId+".DropdownItem"+prev;
                       if (prev==-1) elemDef = $scope.parentFormId+"."+$scope.dropdownId+"search";
                       let elem = document.getElementById(elemDef);
                       
                       if (elem!=null) elem.focus(); 
                    }
                }
                
                /*
                $scope.$watch('selectedItems',function(newValue,oldValue){
                    if (newValue!=oldValue)
                    {
                            $scope.selectItem(null,newValue);    
                    
                    }
                });
                */
                $scope.selectItem = function(ev,item)
                {
                    if (item!=undefined)
                    {
                        if (!$scope.isMultiple){
                          $scope.selectedItem= item;
                          $scope.ngModel.$setViewValue($scope.selectedItem);
                          //ngModel.$validate();
                          let elemBtn = document.getElementById($scope.parentFormId+"."+$scope.dropdownId)
                          if (ev!=undefined) elemBtn.focus();
                          $scope.onSelectFn({item:$scope.selectedItem,model:$scope.ngModel});
                        }else
                        {
                          if (ev!=undefined) ev.stopPropagation();
                          if ($scope.selectedItems==null || $scope.selectedItems==undefined || !Array.isArray($scope.selectedItems)) $scope.selectedItems=[];
                          let pos = $scope.selectedItems.map(function(e) { return e.id; }).indexOf(item.id);
                          if (pos<0) $scope.selectedItems.push(item);
                          else $scope.selectedItems.splice(pos,1);
                          $scope.ngModel.$setViewValue($scope.selectedItems);
                          $scope.onSelectFn({item:$scope.selectedItems,model:$scope.ngModel});
                        }
                        
                    }
                }
                
                 $scope.dropdownBlurred = function()
                {
                    let elemBtn = document.getElementById($scope.parentFormId+"."+$scope.dropdownId)
                    
                    $scope.ngModel.$setTouched();
                                      
                    let elemSearch = document.getElementById($scope.parentFormId+"."+$scope.dropdownId+"search")
                    if (elemSearch!=null) elemSearch.focus();
                  
                }
                
                $scope.removeItem = function(index)
                {
                    $scope.selectedItems.splice(index,1);
                    $scope.ngModel.$setViewValue($scope.selectedItems); 
                
                }
                
                $scope.clearOnly = function()
                {
                    
                        $scope.selectedItem = null;
                        //set ngModel to null
                        $scope.ngModel.$setViewValue(null);
                   
                }
                
                
                $scope.loadItems = function(items)
                {
                    if (items!=undefined)
                    {
                        $scope.dropdownItems = items;
                        if ($scope.search.searchFilter!=undefined && $scope.search.searchFilter!="") $scope.dropdownItemsFiltered = $scope.filterItems();
                        else $scope.dropdownItemsFiltered = angular.copy($scope.dropdownItems.slice(0,50));
                    }                      
                   
                }
                 $scope.loadItemsOnChange = function()
                {
                    if ($scope.dropdownItems!=undefined)
                    {
                        if ($scope.search.searchFilter!=undefined && $scope.search.searchFilter!="") $scope.dropdownItemsFiltered = $scope.filterItems();
                        else $scope.dropdownItemsFiltered = angular.copy($scope.dropdownItems.slice(0,50));
                    }  
                   
                }
                $scope.filterItems = function()
                {
                    if ($scope.search.searchFilter=="") return angular.copy($scope.dropdownItems.slice(0,50));
                    else{
                        $scope.dropdownItemsFiltered=[];
                        let temp = [];
                        for (let i=0;i<$scope.dropdownItems.length;i++)
                        {
                            if ($scope.dropdownItems[i].name.toLowerCase().indexOf($scope.search.searchFilter.toLowerCase())>-1) temp.push($scope.dropdownItems[i]);
                        }
                        return angular.copy(temp);
                    }
                }
                $scope.clear = function(ev)
                {
                    if (!$scope.isMultiple){
                        if (ev!=undefined) ev.preventDefault();
                        $scope.clearOnly();
                    }
                }
               
          
                /*
                $scope.clearMultiple = function()
                {
      
                  $scope.formData[0][$scope.fd.FieldName] = null;
                   $scope.fd.Search.value.length=0;
                }
                */ 
                
            },
            scope:{
            
            dropdownItems:'=',
            dropdownId:'=',
            parentFormId:'=',
            searchText:'=',
            isMultiple:'=',
            selectedItems:'=?',
            onSelectFn:'&',
            clearFn: '&',
            selectItemFn:'&',
            loadItemsFn:'&',
            size:'=?',
            },
             
            link: function (scope, elem, attrs,ctrls) {
                
                scope.form = ctrls[0];
                scope.ngModel= ctrls[1];
                scope.selectedItem = null; //{id:null,name:scope.searchText};
                scope.clearCloseLink="Clear";
                scope.search={};
                
                if (scope.dropdownItems!=undefined) scope.dropdownItemsFiltered = angular.copy(scope.dropdownItems.slice(0,50));
                
                scope.clearFn({theClearFn: scope.clearOnly});
                scope.selectItemFn({theSelectItemFn: scope.selectItem});
                scope.loadItemsFn({theLoadItemsFn: scope.loadItems});
                
                if (!scope.isMultiple)
                {
                    if (scope.selectedItems!="" && scope.selectedItems!=undefined && scope.selectedItems!=null) scope.selectedItem=scope.selectedItems;
                    scope.ngModel.$setViewValue(scope.selectedItem); 
                }else
                {
                    scope.ngModel.$setViewValue(scope.selectedItems);
                }
                
                scope.showSearchInput = false;
                if (scope.isMultiple) scope.clearCloseLink="Close";
                
                let dropdownShow = elem[0].getElementsByClassName("dropdown");
                
                
                angular.element(dropdownShow).on("shown.bs.dropdown", function(event){
                   $timeout(function(){
                     scope.showSearchInput = true;
                     let elementId = scope.parentFormId+"."+scope.dropdownId+"search";
                     let searchInput = document.getElementById(elementId);
                     if (searchInput!=null) searchInput.focus();
                    });
                });
                
                angular.element(dropdownShow).on("hidden.bs.dropdown", function(event){
                   $timeout(function(){
                     scope.showSearchInput = false;
                    
                    });
                });
               
                 $timeout(function(){
                            scope.showSearchInput = false;
                           
                        });
               
                 scope.isSelectedMultiple = function(item)
                {
                 
                    //let items = ngModel.$modelValue;
                    if (item!=undefined)
                    {
                        if (item.id!=undefined)
                        {
                            let items = scope.ngModel.$modelValue;
                            if (items!=undefined)
                            {
                                for (let i=0;i<items.length;i++)
                                {
                                    if (items[i]!=undefined)
                                    {
                                        if (items[i].id==item.id) return true;
                                    }
                                }
                            }
                        }
                    }
                    
                    return false;
                }
            }
        }
  
};
'use strict';

export function ktDropdownMultiple ($timeout) {

        return {
            restrict: 'EA',
            require:['^form','ngModel'],
            templateUrl: 'ktdirectivetemplates/ktDropdownMultiple.html',
            controller: function($scope,$rootScope,$element,$timeout,$compile)
            {
                $scope.CTRL='ktDropdownMultiple';
                $scope.search={searchFilter:''};
				if ($scope.selectedItems==undefined) 	$scope.selectedItems=[]
				
				if ($rootScope.globals.scopes==undefined) 
				$rootScope.globals.scopes = $rootScope?.globals?.scopes ?? {}
				$rootScope.globals.scopes [$scope.$id] = $scope				
                if ($scope.fieldElement===undefined) $scope.fieldElement = {}
                if ($scope.dropdownItems==undefined) $scope.dropdownItems=[];          
				$scope.localVars = {  editMode: false   }
							 
      
							
			let dropdownTemplate=`
							<div id="pokazise{{::$id}}"  ng-if="localVars.editMode"    ng-class="{'show shadow-sm border': localVars.editMode}" class="show-more   rounded bg-white" 	style="z-index:1000;position:absolute;width:99%;overflow-y: scroll;">
							
							<div style="position: sticky;    top: 0;">
								<input  id="{{::parentFormId}}.{{::dropdownId}}search" 
								ng-focus="showDropdownItems=true" ng-blur="showDropdownItems=false"
								ng-class="{'form-control-xs': size=='small'}" ng-change="::loadItemsOnChange()" 
								ng-model-options="{ debounce: 300 }" 
								ng-model="search.searchFilter" 
								type="text" placeholder="Search..."  name="{{::parentFormId}}.{{::dropdownId}}search" style="width:100%" />
							</div>
								
							<div style="overflow-y: auto;">
							 
							<div ng-repeat="item in ::dropdownItems track by item.id" ng-if = "item.name.toLowerCase().indexOf(search.searchFilter.toLowerCase())!=-1 || search.searchFilter.trim()==''"  >
								<label style="overflow: hidden;{{::customStyleItems}}" ng-click="::clickItem(item,$index)"  class=" bgOnHover w-100 align-items-center kt-checkbox-label" for="cbdd-{{::dropdownId}}-{{::item.id}}">
									<input  type="checkbox"  ng-keydown ="onKeydown($event)"  ng-model="isSelected[item.id]" ng-checked="isSelected[item.id]" style="overflow: hidden;" class=" m-1" name="cbdd-{{::dropdownId}}-{{::item.id}}"/>  
									<span class="ml-1 bold" style="{{::customStyleItems}}" ng-bind="::getItemName(item)"> </span>  			</label>	
							</div>
							</div>	
						</div>`
						
			var KeyCodes = {
				BACKSPACE : 8,	TABKEY : 9,	RETURNKEY : 13,	ESCAPE : 27,  SPACEBAR : 32,	LEFTARROW : 37,		UPARROW : 38,		RIGHTARROW : 39,	DOWNARROW : 40,
			};

			$scope.onKeydown = function( $event) {
				
				//console.log('onkeydown: '+ $event?.key)
					/*console.log($event.target)
			
					var e = $event;
					var $target = $(e.target);
					var nextTab;
					switch (e.keyCode) {
						case KeyCodes.ESCAPE:
							if ( $scope.localVars.editMode) {
								$scope.switchMode( $event);
								 $timeout(function () {
									console.log('fokusirao2!')
										$target.focus();
									});
					
								
							}
							break;
						case KeyCodes.UPARROW:
							nextTab = - 1;
							break;
						case KeyCodes.RETURNKEY: e.preventDefault();
						case KeyCodes.DOWNARROW:
							nextTab = 1;
							break;
					}
					if (nextTab != undefined) {
						// do this outside the current $digest cycle
						// focus the next element by tabindex
					   $timeout(() => $('[tabindex=' + (parseInt($target.attr("tabindex")) + nextTab) + ']').focus());
					}
					*/
			};


		$element.on( "keydown", function(evt) {
			
			console.log( 'keydown, edit mode=' +$scope.localVars.editMode );
			console.log(evt);
			if (evt.key =="ArrowDown" ) {
				console.log('arrowdown')
				document.activeElement.dispatchEvent(new KeyboardEvent("keypress", { 	key: "Tab" }))
			}
			
			if (evt.key =="Escape" || evt.key =="Enter" ) {
				$scope.switchMode(evt)
				document.getElementById('dropdownmultiple'+$scope.$id).focus({ focusVisible: true });
				console.log('fokusirao! dropdownmultiple'+$scope.$id)
			}
			 
		});
		
		$scope.onFocus = function( $event) {
			// clear all other items
			console.log('onfocus ')
			console.log($event.target)
		  if (! $scope.localVars.editMode) {
			  console.log('focus switch to ' + $scope.localVars.editMode)
		  }
		};


				$scope.generatebadges = (selectedItems) => {
					let badges='<div style="width: 0 !important;padding-left: 0 !important;padding-right: 0 !important;margin-left: -5px !important;margin-right: 0 !important;visibility: hidden;" class="badge badge-secondary m-1"><span> I </span></div>'
							
					let badgeVisibility = $scope.localVars.editMode ? 'visible': 'hidden'
					if (selectedItems) selectedItems.forEach( (item) => {	
						badges = badges + `
						<div  class="badge badge-secondary m-1">
							<span> ${item.name}  </span>
							<div style="position:relative">
								<button itemid="${item.id}" type="button" class="border-0 removebadge" 
									style="position: absolute; right: -12px; top: -22px; color: black; background-color: azure; border-radius: 9px; padding: 1px 2px; visibility: ${badgeVisibility}">
								<i class="fa fa-times"></i>
								</button></div>
							</div>  `
					})
					return badges
				}


				
                $scope.clickItem = function(item,index)
                {
					if ( $scope.isSelected[item.id]) { // Remove from selected
						$scope.isSelected[item.id]= false
                        let pos = $scope.selectedItems.map(function(e) { return e.id; }).indexOf($scope.dropdownItems[index].id);
                        if (pos>=0) $scope.selectedItems.splice(pos,1); 	
                    } else 
					{ 	// add to selected	
						$scope.isSelected[item.id]= true
						$scope.selectedItems.push({...item})
                    }	
					$scope.badgecontainer.innerHTML = $scope.generatebadges($scope.selectedItems)
					$scope.onSelectFn( {item: $scope.selectedItems, model: {}} );  
                   // $scope.ngModel.$setViewValue($scope.selectedItems); 
                }
                
        
                $scope.switchMode = function(event)
                {     
					
					// clicked on x to remove badge element
					if (event.target.classList.contains('fa-times')) {
						event.stopPropagation()
						var pos = Array.prototype.indexOf.call(event.target.parentNode.parentNode.parentNode.parentNode.children, event.target.parentNode.parentNode.parentNode);//get index of clicked delete element
						if (pos>=0) {
							pos = pos-1 // ignore first badge which is static
							let item_id = $scope.selectedItems[pos].id
							$scope.isSelected[item_id]= false
							$scope.selectedItems.splice(pos,1)
							$scope.badgecontainer.innerHTML = $scope.generatebadges($scope.selectedItems)
							$scope.onSelectFn( {item: $scope.selectedItems, model: {}} );  
						}						
						return
					}
			
                    if ($scope.localVars.editMode) //Close Edit MODE
					{ 
						$scope.localVars.editMode = false;
						$element[0].getElementsByClassName('fa-angle-down')[0].style.visibility = 'visible';
						$element[0].getElementsByClassName('fa-angle-up')[0].style.visibility = 'hidden';
						for (let el of $element[0].querySelectorAll('.removebadge')) el.style.visibility = 'hidden';
						if ($rootScope.globals?.dropdownMultipleOpenedScope == $scope.$id) 	$rootScope.globals.dropdownMultipleOpenedScope=null
						
					}
                    else  { //open EDIT mode
						$rootScope.globals.dropdownMultipleOpenedScope =$scope.$id
						$scope.localVars.editMode = true;
						for (let el of $element[0].querySelectorAll('.removebadge')) el.style.visibility = 'visible';
						$element[0].getElementsByClassName('fa-angle-down')[0].style.visibility = 'hidden';
						$element[0].getElementsByClassName('fa-angle-up')[0].style.visibility = 'visible';
					
					}
                }
                
                $scope.getItemName = function(item)
                {
                	let name
                	name=item.name
                	if ($scope.showId) name = name +' ('+item.id+')'

                	return name
                }  
				
                $scope.selectItemsOnLoad = function()// TODO - vidjeti da li se koristi
                {
                    debugger     
                    let pos;
                    if ($scope.selectedItems!=undefined) {
                           for(let j=0;j<$scope.selectedItems.length;j++){
                              pos = $scope.dropdownItems.map(function(e) { return e.id; }).indexOf($scope.selectedItems[j].id);   
                              //if found (almost) identical object - replace it WITH newer version
                              if (pos>=0 && $scope.dropdownItems[pos].id!=null){
                                  $scope.dropdownItems[pos] = $scope.selectedItems[j]                             
                              }   
                           }    
                    }                        
                };
				

						
				$element.append($compile(dropdownTemplate)($scope));
                
				
				if (!document.body.hasAttribute('listener'))  //This function is only active in first ktDropdownMultiple on the page, but important for all ktdropdownmultiples!
				{			
					document.body.setAttribute('listener', $scope.$id)	
					
					document.addEventListener('click', // Check if clicked outside dropdown --> close it
						function(e){
							var openedScope = $rootScope.globals?.dropdownMultipleOpenedScope
							var openedDropdown =  document.getElementById("dropdownmultiple" + openedScope ) 
							
							if ( openedDropdown && !openedDropdown?.parentNode.contains(e.target) ) //is click outside dropdown ?
							{ 
								//debugger
								openedDropdown.getElementsByClassName('fa-angle-down')[0].style.visibility = 'visible';
								openedDropdown.getElementsByClassName('fa-angle-up')[0].style.visibility = 'hidden';
								
								for (let el of openedDropdown.querySelectorAll('.removebadge')) el.style.visibility = 'hidden';
									
								var otherscope = $rootScope.globals?.scopes?.[openedScope]
								if (otherscope) {
									otherscope.$evalAsync( ()=> {otherscope.localVars.editMode=false });
									otherscope.$digest();
								  }	
							}

									
						})//click
				}
				
            },
            
			
            scope:	{
				dropdownItems:'=',
				dropdownId:'=',
				parentFormId:'=',
				searchText:'=',
				selectedItems:'=?',
				requiredField:'=?',
				onSelectFn:'&',
				optionsFn: '=?',
				selectItemFn:'&',
				loadItemsFn:'&',
				setItemFn:'&',
				size:'=?',
				showId:'=?',
				modelType:'=?',
				customStyleItems:'=?',
				fieldElement:'=?'
            },
             
            link: function (scope, elem, attrs, ctrls) {
                scope.badgecontainer = elem[0].getElementsByClassName("badgecontainer")[0]
                scope.form = ctrls[0];
                scope.ngModel= ctrls[1];
                scope.selectedItem = null; //{id:null,name:scope.searchText};
                

                if (!Array.isArray(scope.selectedItems)) scope.selectedItems=[]
			

                    //For DOM -> model validation
                      scope.ngModel.$parsers.unshift(function(value) {
                         let valid = true
                         if (scope.requiredField) {
                            if (value?.length===0) valid = false
                            }
                            
                           scope.ngModel.$setValidity('required', valid);
                         return valid ? value : undefined;
                      });

                      //For model -> DOM validation
                        scope.ngModel.$formatters.unshift(function(value) {
                         let valid = true
                         if (scope.requiredField) {
                            if (value?.length===0) valid = false
                            }
                           scope.ngModel.$setValidity('required', valid);
                         return value;
                      });

                

                scope.clearSelectedItems = function() //	TODO - vidjeti da li se koristi
                {  
                        scope.selectedItems = [];
                        scope.badgecontainer.innerHTML  = scope.generatebadges(scope.selectedItems)
                        //set ngModel to null
                        //$scope.ngModel.$setViewValue(null);  
                }
                scope.optionsFn = {clearItems: scope.clearSelectedItems};
                scope.selectItemFn({theSelectItemFn: scope.selectItem});
                scope.loadItemsFn({theLoadItemsFn: scope.loadItems});
                scope.setItemFn({theSetItemFn: scope.setItem});
				
 
			   scope.$watch('selectedItems',function(newValue,oldValue){
 
				//debugger	
					if (scope.isSelected==undefined) 
					{
						scope.isSelected={}
					
						scope.badgecontainer.innerHTML  = scope.generatebadges(newValue)
							
						if (newValue) newValue.forEach
							(item => {	
								scope.isSelected[item.id] = true 
						})
					}
					
			   })
			  
              //   FOR TEST ONLY !!
			  /*
			  scope.$watch('dropdownItems',function(newValue,oldValue){
					//debugger
					 if (newValue==undefined) return
					 scope.isSelected={}
					 scope.selectedItems=[]
					 let sid = scope.$id 
					 scope.badgecontainer.innerHTML  = scope.generatebadges(scope.selectedItems)
                 })    
                */     
            }
        }
  
};
'use strict';

export function ktDropdownStandard ($timeout, $rootScope, UtilityService) {

        return {
            restrict: 'EA',
            require:['^form','ngModel'],
            templateUrl: 'ktdirectivetemplates/ktDropdownStandard.html',
            controller: function($scope,$element,$timeout,$rootScope, UtilityService)
            {
                if  ($scope.isMultiple==undefined) $scope.isMultiple = false 
                $scope.CTRL='ktDropdownStandard';
                $scope.search={searchFilter:''};
                $scope.model = {
                        selectedItems: {},
                        deletedItems: []
                };
					
		
                if (!$scope.dropdownItems || !Array.isArray($scope.dropdownItems)) $scope.dropdownItems=[];  
                $scope.editMode=false;


                $scope.$watch("selectedItems",function(newValue,oldValue){  // z parametra "selectedItems" puni selectedItems objekt iz dropdown elemenata - defaultna vrijednost //TODO  - VIDJETI DA LI OVO TREBA UOPCE
                   if (newValue!==undefined && (oldValue?.id != newValue?.id) ) {
							//debugger //ktdropdownstandard selectedItems                      
                             $scope.selectItemsOnLoad()
                        }     
                });
                   

                $scope.selectItem = function()  {
						//debugger //ktDropdownStandard  //selectItem 
                        if ($scope.isMultiple==false){

							if  ($scope.model?.id=="" ) { // if manually selected 'none' item (first item)
								  $scope.model.selectedItems=null;
								 $scope.ngModel.$setViewValue( $scope.model.id );
							} else  if ($scope.model?.id==undefined ) {	
							   if ($scope.model?.selectedItems?.id) {
								   $scope.model.id = $scope.model.selectedItems.id
							   } 
							    
                            } else {
                                let pos = $scope.dropdownItems.map(function(e) { return e.id; }).indexOf($scope.model.id);
                                if (pos>=0 && $scope.dropdownItems[pos].id!=null){
                                            $scope.model.selectedItems = angular.copy($scope.dropdownItems[pos])
                                }
								
                                $scope.ngModel.$setViewValue($scope.model.selectedItems);
                            } 
                        } else { 
							//if multiple
							  if ($scope.model.selectedItems==null || $scope.model.selectedItems==undefined || !Array.isArray($scope.model.selectedItems)) $scope.model = {selectedItems:[]};
							  $scope.ngModel.$setViewValue($scope.model.selectedItems);  
                        }
						
                        $scope.onSelectFn({item:$scope.model.selectedItems , model:$scope.ngModel});    
                }
                
                $scope.setItem = function(item) // Externaly called
                {
                    if (item.id!=undefined && item.id==null) $scope.model.selectedItems=item.id;
                    else $scope.model.selectedItems=item;           
                }
                
                
                
                $scope.removeItem = function(index)
                {
                    //debugger
                    $scope.model.deletedItems.push($scope.model.selectedItems[index]);
                    $scope.model.selectedItems.splice(index,1);
                    $scope.ngModel.$setViewValue($scope.model.selectedItems); 
                
                }
                
                $scope.clearOnly = function()
                {
                    //debugger
                        
                        let sel = $element[0].getElementsByTagName('select')
                        sel[0].focus()   

                        $scope.model.id = null
                        //set ngModel to null
                        $scope.ngModel.$setViewValue(null)
                        $scope.ngModel.$touched = true
                       
                }
                
                
                $scope.loadItems = function(items) //Externally called
                {
                    if (items!=undefined)
                    {
                        $scope.dropdownItems = items;
                        if ($scope.search.searchFilter!=undefined && $scope.search.searchFilter!="") $scope.dropdownItemsFiltered = $scope.filterItems();
                        else $scope.dropdownItemsFiltered = angular.copy($scope.dropdownItems.slice(0,50));
                    }                          
                }
                
				
                $scope.setEditMode = function(value)
                {
                    $scope.editMode = value;
                    if (!value)
                    {   
                        for (let i = 0;i<$scope.model.deletedItems.length;i++)
                            $scope.model.selectedItems.push($scope.model.deletedItems[i]);  
                    }
                        
                    $scope.model.deletedItems.length=0;
                }
                
                $scope.acceptChanges = function()
                {
                    $scope.editMode = false;
                    $scope.model.deletedItems.length=0;
                }
                
                $scope.selectItemsOnLoad = function() // fill "model.selectedItems" from props
                {
                   let pos;
                   //debugger //selectItemsOnLoad
				   $scope.dropdownItems.sort(UtilityService.getSortMethod(['aname'], $rootScope.globals?.currentUser?.langObj?.Code ))
					
					
                   if ( $scope.isMultiple==false )  {
                            if ( $scope.dropdownItems && $scope.dropdownItems.length>0) {
                                pos = $scope.dropdownItems.map(function(e) { return e.id; }).indexOf($scope.selectedItems?.id);
								
                                if (pos>=0 && $scope.dropdownItems[pos].id != null) {     
                                    $scope.model.selectedItems = $scope.dropdownItems[pos];
                                    $scope.model.id = $scope.dropdownItems[pos].id;
                                }
                                else {
			
                                    $scope.model.selectedItems = undefined
									$scope.model.id = undefined 									
                                }
                            }  
                    }
					
					if ($scope.isMultiple)  {
                           $scope.model.selectedItems=[];
                           for(let j=0;j<$scope.selectedItems.length;j++) {
                                if ($scope.selectedItems[j]!==null && $scope.dropdownItems!==undefined && $scope.dropdownItems.length>0) {
									 pos = $scope.dropdownItems.map(function(e) { return e.id; }).indexOf($scope.selectedItems[j].id);
					  
									if (pos>=0 && $scope.dropdownItems[pos].id!=null){
											$scope.model.selectedItems.push($scope.dropdownItems[pos]);
									}
									
									if ($scope.model.selectedItems.length==0) $scope.model.selectedItems = null;
                                }
                           }
                           
                    }
					
					
                         
                };
                
              
            },
            scope:{
                dropdownItems:'=',
                dropdownId:'=',
                parentFormId:'=',
                searchText:'=',
                isMultiple:'=',
                selectedItems:'=?',
                requiredField:'=?',
                onSelectFn:'&',
                clearFn: '&',
                selectItemFn:'&',
                loadItemsFn:'&',
                setItemFn:'&',
                size:'=?',
                showId:'=?',
                modelType:'=?',
            },
             
            link: function (scope, elem, attrs,ctrls) {
                
                scope.form = ctrls[0];
                scope.ngModel= ctrls[1];
                
				
                scope.clearFn({theClearFn: scope.clearOnly});
                scope.selectItemFn({theSelectItemFn: scope.selectItem});
                scope.loadItemsFn({theLoadItemsFn: scope.loadItems});
                scope.setItemFn({theSetItemFn: scope.setItem});
                
                scope.selectItemsOnLoad(); 

				/*
                scope.isSelectedMultiple = function(item)
                {   
                    if (item!=undefined)
                    {
                        if (item.id!=undefined)
                        {
                            let items = scope.ngModel.$modelValue;
                            if (items!=undefined)
                            {
                                for (let i=0;i<items.length;i++)
                                {
                                    if (items[i]!=undefined)
                                    {
                                        if (items[i].id==item.id) return true;
                                    }
                                }
                            }
                        }
                    }
                    
                    return false;
                }*/
				
				
            }
        }
  
};
'use strict';

export function ktEditCodes () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktEditCodes.html',
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService){    
                },
             link: function (scope, elem, attrs) {
                
                    
              }
        }
  
};
'use strict';

export function ktExecuteSmartContract () {
   
   var controller = ['$scope', '$uibModal', '$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','KatalyoStateManager','UtilityService','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,KatalyoStateManager,UtilityService,$templateCache,$compile,$element) {
     
      $scope.localVarsWidget = {};
      //$scope.fd = {};
      $scope.localVarsWidget.searchFormDownloaded = false;
      $scope.localVarsWidget.formLoaded=false;
      $scope.localVarsWidget.src_type_text=CODES_CONST._POPULATE_TYPE_;
      $scope.localVarsWidget.animationsEnabled = true;
      $scope.localVarsWidget.widgetType = 3;
      $scope.gsrvc = GridsterService;
      $scope.localVarsWidget.formParams={formViewType:1,showGridNavigation:true};
      $scope.fd.contractDatasets = true;
      if ($scope.formData==undefined) $scope.formData={};
      if ($scope.formData[$scope.fd.PresentationId]==undefined) $scope.formData[$scope.fd.PresentationId]=[];
      
      $scope.localVarsWidget.datasetMapperType=0;
      
      if ($scope.fd.PopulateType==undefined) $scope.fd.PopulateType="";
      
      $scope.localVarsWidget.openModal = function (size,template,ctrl,selectedType) {
     
         var modalInstance = $uibModal.open({
            animation: $scope.animationsEnabled,
            templateUrl: template,
            controller: ctrl,
            size: size,
            resolve: {
              selectedResourceItem: function () {
                return $scope.localVarsWidget.selectedResourceItem;
                },
              type: function () {
                return $scope.localVarsWidget.selectDatasetType;
                }
            }
         });
         modalInstance.result.then(function (selectedItem,windex,index) {
      
          if ($scope.localVarsWidget.selectDatasetType==1){
            $scope.localVarsWidget.selectedResourceItem = selectedItem;
            $scope.fd.Related =  $scope.selectedResourceItem.relatedId;
            $scope.fd.PopulateType=selectedItem.src_type_id;
            $scope.fd.ParentElementId = $scope.selectedResourceItem.parentElementId;
            $scope.fd.PresentationId = $scope.selectedResourceItem.presentationId;
            $scope.localVarsWidget.getFormResourceOriginal();
          
          }else if ($scope.localVarsWidget.selectDatasetType==2)
          {
            $scope.localVarsWidget.selectedRelatedResourceItem = selectedItem;
            $scope.fd.HasParentDataset =  $scope.selectedResourceItem.relatedId;
            $scope.fd.PopulateTypeParent=selectedItem.src_type_id;
            //$scope.fd.ParentElementId = $scope.selectedResourceItem.parentElementId;
            //$scope.fd.PresentationId = $scope.selectedResourceItem.presentationId;
          }
         
         }, function () {
        //$log.info('Modal dismissed at: ' + new Date());
         });
         
      };
     
      $scope.localVarsWidget.openModalSelectResource = function(){
        $scope.localVarsWidget.selectDatasetType  = 1;
        $scope.localVarsWidget.openModal('lg','selectResourceModal.html','SelectResourceModalCtrl',$scope.localVarsWidget.selectDatasetType);
        
      };
     
      $scope.localVarsWidget.openModalSelectRelatedResource = function(){
        $scope.localVarsWidget.selectDatasetType  = 2;
        $scope.localVarsWidget.openModal('lg','selectDatasetModal.html','SelectDatasetModalCtrl',$scope.localVarsWidget.selectDatasetType);
      };
      
     
      $scope.localVarsWidget.gridsterType="resource";
          // $scope.gridsterOpts = GridsterService.getGridsterOptions();
    
    
        
      $scope.localVarsWidget.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: []
      } ;
        
    
  
      //$scope.taskId=$stateParams.id;
      $scope.taskId=$scope.resourceDefinition.ResourceDefId;
      if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
      if ($scope.taskId==undefined) $scope.taskId=0;
      $scope.localVarsWidget.taskId=$scope.taskId;
      $scope.fd.ParentDatasetDefId=$scope.fd.Related;
      $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
      $scope.localVarsWidget.formType=$scope.resourceDefinition.form_type;
      $scope.source_type=$scope.resourceDefinition.source_type;
      $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
      $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
      $scope.formDefinition = $scope.resourceDefinition.form_definition;
      
      if ($scope.localVars == undefined)  $scope.localVars= {} 
      $scope.localVars.showMenu = false
      
       $scope.localVars.toggleDropdown = function(){
                           $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
       }
        
      if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
      $scope.localVarsWidget.resourceRecordId=0;
      if ($scope.taskInitiateId==undefined)
      {
        $scope.taskInitiateId =0;
      
      }
      if ($scope.taskExecuteId==undefined)
      {
         $scope.taskExecuteId =0;  
      }
        if ($scope.prevTaskExeId==undefined)
        {
            $scope.prevTaskExeId =0;
        }
        
      //register widget 
      var out_fields = ['resourceId'];
      //if ($scope.fd.LocalId==undefined || $scope.fd.LocalId==null || $scope.fd.LocalId==0)
      //{
         var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'viewResourceWidget',widgetId: $scope.fd.PresentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resourceDefId : $scope.localVarsWidget.selectedResource, output:out_fields, };
         $scope.localVarsWidget.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
         $scope.localVarsWidget.LocalId=$scope.localVarsWidget.localWidgetId;
         $scope.fd.LocalId=$scope.localVarsWidget.localWidgetId;
         //$scope.fd.LocalId=UtilityService.uuidNow();
         
      //}
      $scope.ksm = KatalyoStateManager;
      
      let update_presentation_id = function(data)
      {
         if (data[$scope.fd.LocalId]>0 && ($scope.fd.PresentationId==null || $scope.fd.PresentationId==0)) $scope.fd.PresentationId = data[$scope.fd.LocalId];
          //unsubscribe here later after implementing unsubscribe - ToDo
          
      }
      if ($scope.fd.PresentationId==0 || $scope.fd.PresentationId==null)
      {
         
         let dependent_field = $scope.fd.LocalId;
         let subscribedSubject = "formDefinitionState"+$scope.taskId+$scope.resourceDefinition.form_type;
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"formSaved",update_presentation_id);
  
      }        
      
       let apply_value = function(data)
        {
            let do_refresh=false;
            if (data!=undefined)
            {
               if (data != $scope.localVarsWidget.resourceRecordId)
               {
                  if (typeof data ==='number') $scope.localVarsWidget.resourceRecordId= data;
                  else if (Array.isArray(data))
                  {
                     if (data.length>0)
                     {
                      $scope.localVarsWidget.resourceRecordId= data[0].id  
                     }
                  }else
                  {
                     $scope.localVarsWidget.resourceRecordId = data.id;
                  }
                  do_refresh = true;
               }
            }
            //get selectedRecord
            if ($scope.localVarsWidget.resourceRecordId == null) $scope.localVarsWidget.resourceRecordId=0;
            
            if ($scope.localVarsWidget.resourceRecordId>0 && do_refresh) $scope.localVarsWidget.getFormResourceWithData();
            
            
        };
        
      
      if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
      
      if ($scope.fd.Parameters.RefreshOnIdChange)
      {
         
         //find 
         //subscribe observer
           
         let dependent_field = "Field"+$scope.fd.PresentationId;
         let subscribedSubject = "resourceidValueStateName"+$scope.fd.Parameters.ResourceIdItemId+$scope.resourceDefinition.transaction_id;
         let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
         let val = $scope.ksm.getState(subscribedSubject);
         $scope.localVarsWidget.resourceRecordId= val.id;
            
            //get selectedRecord
         if ($scope.localVarsWidget.resourceRecordId == null) $scope.localVarsWidget.resourceRecordId=0;
            
         if ($scope.localVarsWidget.resourceRecordId>0) $scope.localVarsWidget.getFormResourceWithData();
      }
      
      //subscribe observer
      if ($scope.fd.PopulateType.toString().substr(0,1)=="4")
      {
           /**********************************************************************
         ****************** Sync data with State manager **********************
         ***********************************************************************/
        /*
        $scope.itemValue = {val:null};
        
        let valueState= $scope.ksm.addSubject('datasetValueStateName'+$scope.fd.ItemId,$scope.itemValue.val);
        let valueStateName = valueState.subject.name;
        
        let value_changed = function(data)
        {
            valueState.subject.setStateChanges = data;
            valueState.subject.notifyObservers("valueChanged");
        };
        
        let action_value_changed = $scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
       
        */
       
       
        if ($scope.fd.SrcWidgetId!=undefined && $scope.fd.SrcWidgetId!=null)
        
        {
           
                let dependent_field = "Field"+$scope.fd.SrcWidgetId;
               // let subscribedSubject = $scope.fd.Parameters.SrcWidgetType+"ValueStateName"+$scope.fd.SrcWidgetId;
                let subscribedSubject = "rlistValueStateName"+$scope.fd.SrcWidgetId+$scope.resourceDefinition.transaction_id;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
            
        }  
         
      }
      
      let refresh_widget_data = function()
      
      {
         $scope.localVarsWidget.getFormResourceWithData();    
         
      }
      if ($scope.fd.Parameters.EventName!=undefined)
      {
         if ($scope.fd.Parameters.EventName!="")
         {
            let dependent_field2 = "Field"+$scope.fd.PresentationId;
            let subscribedSubject2 = "task"+$scope.resourceDefinition.transaction_id;
            let observer2 = $scope.ksm.subscribe(subscribedSubject2,dependent_field2,$scope.fd.Parameters.EventName,refresh_widget_data);
         }
      }
      
      $scope.localVarsWidget.showProperties=function(datasetMapperType)
      {
            
            if ($scope.localVarsWidget.datasetMapperType==undefined)
            {
               $scope.localVarsWidget.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.localVarsWidget.datasetMapperType==0 || $scope.localVarsWidget.datasetMapperType!=datasetMapperType) $scope.localVarsWidget.datasetMapperType = datasetMapperType;
               else $scope.localVarsWidget.datasetMapperType=0;
            }
            
      };
           
      $scope.localVarsWidget.setField = function(form,name,value,msg)
      {
         TaskDataService.setField(form,name,value);
         if (msg) MessagingService.addMessage(msg,'info');
      };  
      
      $scope.localVarsWidget.getResourceAll = function () {
          
            ResourcesDataService.getResourceDefAll($scope.fd.Related).then(function(data) {
                               
                             // MessagingService.addMessage(data.msg,'success');
                              $scope.fd.resource = data.data;
                              $scope.localVarsWidget.resourceLoaded = true;
                              
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        };
      $scope.localVarsWidget.getResourceAll();
      
       $scope.fd.loadBlockchainDataset = function (dataset) {
           
           if (dataset.DatasetId==undefined) dataset.DatasetId = {id:0}; 
           $scope.fd.selectedDataset = dataset;
           if (dataset.DatasetId.id>0) $scope.localVarsWidget.getFormResourceOriginal(dataset.DatasetId.id);
            
        };
        $scope.fd.loadBlockchainFunction = function (func)
        {
           if (func.InputDatasetId==undefined) func.DatasetId = {id:0}; 
           $scope.fd.selectedFunction = func;
           if (func.InputDatasetId.id>0) $scope.localVarsWidget.getFormResourceOriginal(func.InputDatasetId.id);
        }
        
         $scope.fd.executeBlockchainFunction = function (func)
        {
            var lang=$rootScope.globals.currentUser.lang;
              
               //$scope.localVarsWidget.formLoading=true;
              let limit =  100;
              $scope.fd.datasetLoaded=false;
              $scope.fd.gridOptions.columnDefs=[];
              if ($scope.fd.BlockChainPrimaryKey==undefined) $scope.fd.BlockChainPrimaryKey="";
              ResourcesDataService.executeBlockchainFunction($scope.fd.resource.Parameters.ContractId,$scope.fd.selectedFunction.FunctionName,$scope.formData[$scope.fd.PresentationId][0]).then(function(data) {
                  
                  MessagingService.addMessage(data.data,'success'); 

               },function(error){
                                   MessagingService.addMessage(error.msg,'error');   
         
               });
        }
      $scope.localVarsWidget.getFormResourceOriginal = function(datasetId){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
              $scope.localVarsWidget.formLoaded=false;
              ResourcesDataService.getResourceForm(datasetId,"i",lang).then(function(data) {
                            
                                $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                
                                if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                $scope.fd.wItemValue=data.data.widgets;
                                
                           /*
                                var container = $element.children().eq(0);
                                GridsterService.setupDragular($scope.fd.wItemValue,container,'rows-'+$scope.fd.PresentationId,'row-'+$scope.localVarsWidget.gridsterType+'-hadle',true);
                             */   
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.fd.ResourceRecordId}]}]});
						
                                  $scope.localVarsWidget.searchFormDownloaded = true;
                                  //$timeout(function(){$scope.localVarsWidget.formLoaded=true});
                                  $scope.localVarsWidget.formLoaded=true;
                                
                               // $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);     
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      $scope.fd.gridOptions = {
         
         showGridFooter: true,
        showColumnFooter: true,
        enableRowSelection: true,
        multiSelect: false,
      //  enableHorizontalScrollbar : 1,
       // enableVerticalScrollbar : 2,
        enableFiltering: true,
        enableRowHeaderSelection: false,
        enableColumnResizing: true,
        enableColumnReordering: true,
        //useExternalPagination: false,
        paginationPageSizes: [10, 25, 50,100,200,500,1000,5000,10000],
      }
        $scope.fd.GetBlockchainDatasetRecords = function(){
              var lang=$rootScope.globals.currentUser.lang;
              
               //$scope.localVarsWidget.formLoading=true;
              let limit =  100;
              $scope.fd.datasetLoaded=false;
              $scope.fd.gridOptions.columnDefs=[];
              if ($scope.fd.BlockChainPrimaryKey==undefined) $scope.fd.BlockChainPrimaryKey="";
              ResourcesDataService.getBlockchainDatasetRecords($scope.fd.selectedDataset.DatasetId.id,$scope.fd.selectedDataset.DatasetName,$scope.fd.resource.Parameters.ContractId,limit,$scope.fd.BlockChainPrimaryKey,lang).then(function(data) {
                  
                  $scope.fd.datasetLoaded=true;
                  
                  $scope.fd.gridOptions.data = data.data.data.rows;
                  
                  //$scope.fd.gridOptions.columnDefs = data.data.columns;
                  
                  //$scope.localVarsWidget.formLoading=false;
                  
               
               },function(error){
                                   MessagingService.addMessage(error.msg,'error');   
                             });
        }
        $scope.localVarsWidget.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
               $scope.localVarsWidget.formLoaded=false;
               if ($scope.fd.PresentationId==null)
               {
                    $scope.fd.PresentationId=0;
            
               }
               $scope.localVarsWidget.formLoading=true;
                         
              ResourcesDataService.getResourceFormExtended($scope.fd.Related,$scope.taskId,$scope.localVarsWidget.formType,$scope.fd.PresentationId,"w",lang).then(function(data) {
                               
                                  $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                  if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                  
                                 if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                              
                                $scope.fd.wItemValue=data.data.widgets;
                               
                                
                                  
                                $scope.localVarsWidget.searchFormDownloaded = true;
                                
                                $timeout(function(){    
                                   $scope.localVarsWidget.formLoaded=true;
                                   $scope.localVarsWidget.formLoading=false;
                                });
                                  
                               
                              //  $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 $scope.localVarsWidget.formLoading=false;
                                 
                                
                             });
                              
      };
      
              
        $scope.localVarsWidget.getFormResourceWithData = function(){
              var lang=$rootScope.globals.currentUser.lang;
              $scope.localVarsWidget.formLoaded=false;
              if ($scope.fd.PresentationId==null || $scope.fd.PresentationId==undefined)
              {
                $scope.fd.PresentationId = 0;
                
              }
              
              if ($scope.fd.ParentElementId==null || $scope.fd.ParentElementId==undefined)
              {
                $scope.fd.ParentElementId = 0;
                
              }
              
              
              
              
               if ($scope.localVarsWidget.resourceRecordId==undefined || $scope.localVarsWidget.resourceRecordId==0)
               {
                
                  if ($scope.localVarsWidget.previousTaskData['datasetRecordId']!=undefined && $scope.localVarsWidget.previousTaskData['datasetRecordId']!="" && $scope.localVarsWidget.previousTaskData['datasetId']==$scope.fd.Related) $scope.localVarsWidget.resourceRecordId = $scope.localVarsWidget.previousTaskData['datasetRecordId'];
                
               }
               if (typeof $scope.localVarsWidget.resourceRecordId !=='number' && typeof $scope.localVarsWidget.resourceRecordId !=='string')
               {
                  
                  if (Array.isArray($scope.localVarsWidget.resourceRecordId))
                  {
                     if ($scope.localVarsWidget.resourceRecordId.length>0)
                     {
                        $scope.localVarsWidget.resourceRecordId= $scope.localVarsWidget.resourceRecordId[0].id  
                     
                     }
                  }
                  else $scope.localVarsWidget.resourceRecordId = $scope.localVarsWidget.resourceRecordId.id;                 
               }
               
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.Related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.PopulateType,$scope.fd.ParentElementId,$scope.fd.PresentationId,$scope.prevTaskExeId,$scope.localVarsWidget.formType,$scope.localVarsWidget.widgetType,$scope.localVarsWidget.resourceRecordId,"w",lang).then(function(data) {

                                  $scope.formData[$scope.fd.PresentationId] =  data.data.form_data;
                                  if ($scope.formData[$scope.fd.PresentationId]==undefined) $scope.formData[$scope.fd.PresentationId]=[];
                                  $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                  if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                 
                                  if ($scope.formData[$scope.fd.PresentationId].length>0)
                                  {
                                    $scope.localVarsWidget.resourceRecordId = $scope.formData[$scope.fd.PresentationId][0]['id'];
                                  }
                                  $scope.localVarsWidget.datasetRecordId=$scope.localVarsWidget.resourceRecordId;
                                  if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                    //$scope.fd.wItemValue=data.data.widgets;
                               
                                  // $timeout(function() {
                                     $scope.localVarsWidget.formLoaded=true;
                                    // $scope.localVarsWidget.initiateFormLoaded=true;
                                     $scope.localVarsWidget.formLoading=false;
                                     $scope.localVarsWidget.searchFormDownloaded = true;
                                      
                                  //  });   
                                  
                                   
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - VIEW_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVarsWidget.resourceRecordId}]}]});
                                
                               // $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      
      
           $scope.localVarsWidget.setSelectedDataset = function(id)  {
              
              if ($scope.localVarsWidget.selectedResourceItem==undefined) $scope.localVarsWidget.selectedResourceItem={};
              var pos = $scope.localVarsWidget.resourceList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVarsWidget.selectedResourceItem.id = $scope.localVarsWidget.resourceList[pos].id;
                $scope.localVarsWidget.selectedResourceItem.name = $scope.localVarsWidget.resourceList[pos].name;
                $scope.localVarsWidget.selectedDataset = $scope.localVarsWidget.resourceList[pos];
                $scope.localVarsWidget.selectedResourceItem.name_confirmed = $scope.localVarsWidget.selectedResourceItem.name +' ('+$scope.localVarsWidget.selectedResourceItem.id +')'
                $scope.localVarsWidget.selectedResourceItem_c=$scope.localVarsWidget.selectedResourceItem;
                }
					}
          
                  
          // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
	$scope.localVarsWidget.getResources = function()  {
						
            if ($scope.localVarsWidget.resourceList==undefined) $scope.localVarsWidget.resourceList=[];
          
            var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'smartcontract').then(
						function(data) {
										
											  $scope.localVarsWidget.resourceList = data.data;
                       if ($scope.fd.Related!=null)
                       {
                        $scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
                
                        }     
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					}
   
   

$scope.localVarsWidget.getPreviousTaskWidget  = function(linkType)
    {
      var pTaskData;
      var pTaskDataRet = WidgetDataExchangeService.getPrevTaskData($scope.prevTaskExeId);
      if (Array.isArray(pTaskDataRet) && pTaskDataRet.length>0) pTaskData = pTaskDataRet[0];
            var datasetId=0,datasetRecordId=0;
            if (pTaskData!=undefined)
            {
               if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
               {
               for (var i=0;i<pTaskData.DEI.length;i++)
               {
                 if (pTaskData.DEI[i].name==linkType)
                 {
                   if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                   {
                     for (var j=0;j<pTaskData.DEI[i].value.length;j++)
                     {
                      if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined) datasetId=pTaskData.DEI[i].value[j].value;
                      if (pTaskData.DEI[i].value[j].name=="resourceRecordId" && pTaskData.DEI[i].value[j].value!=undefined) datasetRecordId=pTaskData.DEI[i].value[j].value;
                      
                       
                     }
                        
                       
                   }
                     
                 }
                   
                 }
               }
            }
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };


   
   
  $scope.localVarsWidget.previousTaskData=$scope.localVarsWidget.getPreviousTaskWidget("resourceLinkDatasetList");
 
          
  if ($scope.fd.Related!=null &&  !$scope.formDefinition && !$scope.localVarsWidget.searchFormDownloaded)
  {
    
    // $scope.localVarsWidget.getFormResourceWithData();
    // $scope.localVarsWidget.getDatasets();
    // $scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
    
  }else if ($scope.fd.Related!=null)
  {
     //$scope.localVarsWidget.getFormResource();
     $scope.localVarsWidget.getResources();
     //$scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
    
  } 

  
      //novi FILE CONNECTOR - view resource widget
      $scope.openWidgetConnector  = function(){
             $scope.localVarsWidget.showWidgetConnector= !$scope.localVarsWidget.showWidgetConnector;
             if ($scope.localVarsWidget.showWidgetConnector) {
                           
                 //POPUNI LISTU DATASETOVA            
                  ResourcesDataService.getResourceDefListByType(lang,'smartcontract').then(
                                function(data) {
                                                  $scope.resourceList = data.data;
                                                  //dodaj ime dataseta u konektore
                                                  if ($scope.localVarsWidget.listOfConnectors!=undefined) 
                                                             for (var i=0;i< $scope.localVarsWidget.listOfConnectors.length;i++) {
                                                                   //var p = $scope.resourceList.map(function(e) { return e.id; }).indexOf($scope.localVarsWidget.listOfConnectors[i].parentDatasetDefId);
                                                                   var p = $scope.localVarsWidget.resourceList.map(function(e) { return e.id; }).indexOf($scope.localVarsWidget.listOfConnectors[i].parentDatasetDefId);
                                                                   if (p>=0) $scope.localVarsWidget.listOfConnectors[i].parentDatasetName = $scope.resourceList[p].name;  
                                                             }
                                                  
                                                  },function(error){    
                                        MessagingService.addMessage(error.msg,'error');
                                                 });
                                                 
                                                 
 							if ($scope.fd.tItemValue==undefined || $scope.fd.tItemValue[0]==null) $scope.fd.tItemValue = []; 
							// ovo je  Kt-UPLOADER
							  $scope.localVarsWidget.listOfConnectors= WidgetDataExchangeService.getRegisteredWidgets();//MIGOR  - uzmi sve registrirane widgete
							  
							  //Brisi sve koji se vec nalaze u tItemValue
							   if ($scope.localVarsWidget.listOfConnectors!=undefined) 
								  for (var i=0;i< $scope.fd.tItemValue.length ;i++) {
										 for (var j=0;j< $scope.localVarsWidget.listOfConnectors.length;j++) {
                                              if ($scope.fd.tItemValue[i]!=null) {
                                                 if ($scope.localVarsWidget.listOfConnectors[j].widgetId==$scope.fd.tItemValue[i].widgetId)  {
                                                     $scope.localVarsWidget.listOfConnectors.splice(j,1);//brisi lokalni				   					    		
                                                 }
                                              }
                                         }
							    }
                                //dodaj sa servera
                                for (var i=0;i< $scope.fd.tItemValue.length ;i++) 
                                              if ($scope.fd.tItemValue[i]!=null) 
                                                  $scope.localVarsWidget.listOfConnectors.push($scope.fd.tItemValue[i]);		
                                

							  //Ostavi u listi konektora samo WIDGETE koji imaju "ResourceID" jer su to data widgeti
							  var newlist=[];
                              
							    if ($scope.localVarsWidget.listOfConnectors!=undefined){
                 
                                 for (var i=0;i< $scope.localVarsWidget.listOfConnectors.length;i++) {
                                                     if ($scope.localVarsWidget.listOfConnectors[i].DEI!=undefined)  
                                                         for (var j=0;j< $scope.localVarsWidget.listOfConnectors[i].DEI.length;j++) {
                                                                 //ako DEI nije true/false - resetiraj na false
                                                                 if ( ($scope.localVarsWidget.listOfConnectors[i].DEI[j].value!=false) && ($scope.localVarsWidget.listOfConnectors[i].DEI[j].value!=true) ) $scope.localVarsWidget.listOfConnectors[i].DEI[j].value=false;
                                                                 //dodaj konektor u novu listu 
                                                                
                                                             };
                                                        newlist.push($scope.localVarsWidget.listOfConnectors[i]);
                                               }
                                }//if
							  $scope.localVarsWidget.listOfConnectors=newlist; //konacna lista NOVIH dataset konektora 
 
			
	
            } //if showfileconnetor  
		}; // open FILECONNECTOR - VIEW
    

            $scope.localVarsWidget.okWidgetConnector = function () {
                $timeout(function() {
                $scope.fd.tItemValue=$scope.localVarsWidget.listOfConnectors;
                $scope.localVarsWidget.showWidgetConnector=false;  
                
                });
            };

          $scope.localVarsWidget.cancelWidgetConnector = function () {
                $timeout(function() {
                
                $scope.localVarsWidget.showWidgetConnector=false;  
                
                });
            };

       
        $scope.localVarsWidget.processWidgetDependencies = function() { //-----                
           if ($scope.fd.tItemValue!=undefined) 
            for (var i=0;i< $scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=$scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = $scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<$scope.fd.tItemValue[i].DEI.length;j++) {
                        if (($scope.fd.tItemValue[i].DEI[j].name==linkedItem) && ($scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = $scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("view "+$scope.fd.PresentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             $scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj $scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                              //  console.log("view "+ $scope.fd.PresentationId+" dobio event " + event.name);
                                for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    $scope.localVarsWidget.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    $scope.localVarsWidget.resourceRecordId = $scope.localVarsWidget.linkedResourceId;
                                  }
                                  if (data[k].name=='resourceId') $scope.localVarsWidget.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                }
                          
                              //get selectedRecord
                              $scope.localVarsWidget.getFormResourceWithData();
                                
                                    //	data: {resource_def_id:$scope.fd.linkedResourceDefId,resource_id:$scope.fd.linkedResourceId}
                                    
                              }) //on_END
                        }//if
                    }//for j
                }//if

             // else {  $scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget

          if ($scope.fd.PresentationId==undefined || $scope.fd.PresentationId==null) $scope.fd.PresentationId=0;
          
          $scope.localVarsWidget.formType=$scope.resourceDefinition.form_type;
          
          /*TaskDataService.getWidgetDependencies($scope.taskId,$scope.fd.PresentationId,$scope.localVarsWidget.formType).then(function(data) {
                               
                                $scope.fd.tItemValue=data.data;
                                $scope.localVarsWidget.processWidgetDependencies();
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });*/
                              
    
            let template
            template = $templateCache.get('ktdirectivetemplates/ktExecuteSmartContract.html');
            $element.append($compile(template)($scope)); 

  
      }];

  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

            }     
  }
  
};
'use strict';

export function ktExecuteTaskWidget () {

        return {
            restrict: 'A',
          controller:function($scope,UserService,ResourcesDataService,$rootScope,ProcessingService,$timeout,$stateParams,$cookies,
                              WidgetDataExchangeService,$state,TaskDataService,MessagingService,GridsterService,$templateCache,$compile,$element){
          
           if ($scope.localVars==undefined) $scope.localVars = {};
           $scope.localVars.showMenu = false
      

  
                $scope.localVars.executeTaskDataLoaded=false;
                if ($scope.localVarsExecuteTask==undefined) $scope.localVarsExecuteTask = {};
                var lang=$rootScope.globals.currentUser.lang;
                //$scope.localVarsExecuteTask = angular.copy($scope.localVars);
                if ($scope.localVarsExecuteTask.taskDefinition==undefined) $scope.localVarsExecuteTask.taskDefinition = {};
      	
                //WidgetDataExchangeService.deRegisterAllWidgets();//MIGOR TODO - dodao ovo ali gdje je registerTASK i da li treba ovdje????
                $scope.gsrvc = GridsterService;
                
                $scope.localVarsExecuteTask.fromStateName=$stateParams.fromStateName;
                $scope.localVarsExecuteTask.fromStateParams=$stateParams.fromStateParams;
                $scope.localVarsExecuteTask.cookieFromStateName=$cookies.getObject('executeTaskFromStateName');
                $scope.localVarsExecuteTask.cookieFromStateParams=$cookies.getObject('executeTaskFromStateParams');
                $scope.localVarsExecuteTask.noBackbutton = false;
                $scope.localVarsExecuteTask.backBtnFromCookie=false;
                $scope.localVarsExecuteTask.initiateFormLoaded = false;
                $scope.localVarsExecuteTask.taskInitiateInstance=[];
                $scope.localVarsExecuteTask.taskExecuteInstance=[];
                $scope.localVarsExecuteTask.dashboard = {widgets : [],data:{}};

      
                if ($scope.localVarsExecuteTask.fromStateName==undefined || $scope.localVarsExecuteTask.fromStateName=="")
                {
                    if ($scope.localVarsExecuteTask.cookieFromStateName==undefined || $scope.localVarsExecuteTask.cookieFromStateName=="")
                    {
                      $scope.localVarsExecuteTask.noBackButton = true;
                    }else
                    {
                      $scope.localVarsExecuteTask.fromStateName =  $scope.localVarsExecuteTask.cookieFromStateName;
                      $scope.localVarsExecuteTask.backBtnFromCookie = true;
                    }
                    
                  
                }else{
                  $cookies.putObject('executeTaskFromStateName',$scope.localVarsExecuteTask.fromStateName);
                  
                }
      
                if ($scope.localVarsExecuteTask.fromStateParams==undefined)
                {
                    if ($scope.localVarsExecuteTask.cookieFromStateParams!=undefined)
                    {
                        if ($scope.localVarsExecuteTask.backBtnFromCookie)
                        {
                          $scope.localVarsExecuteTask.fromStateParams =  $scope.localVarsExecuteTask.cookieFromStateParams;
                        }
                    }
                    
                }else if ($scope.localVarsExecuteTask.cookieFromStateParams==undefined)
                {
                  $cookies.putObject('executeTaskFromStateParams',$scope.localVarsExecuteTask.fromStateParams);
                  
                }else
                {
                    if ($scope.localVarsExecuteTask.backBtnFromCookie)
                    {
                  
                      $scope.localVarsExecuteTask.fromStateParams =  $scope.localVarsExecuteTask.cookieFromStateParams;
                  
                    }else
                    {
                        $cookies.putObject('executeTaskFromStateParams',$scope.localVarsExecuteTask.fromStateParams);    
                    }
                }
      
                $scope.localVarsExecuteTask.gridsterType="task";
              //  $scope.localVarsExecuteTask.gridsterExeFormOpts = GridsterService.getGridsterOptions();
                $scope.localVarsExecuteTask.formType="e";
               
                $scope.localVarsExecuteTask.isCollapsedTaskDetails=true;
                  $scope.localVarsExecuteTask.FormLockUnlock = function()
                {
                  $scope.localVarsExecuteTask.resourceDefinition.formParams.formLocked=!$scope.localVarsExecuteTask.resourceDefinition.formParams.formLocked;
                };
                
                $scope.localVarsExecuteTask.goBack = function(){
                                    $state.go($scope.localVarsExecuteTask.fromStateName,$scope.localVarsExecuteTask.fromStateParams);
                             
                };
                
                
                $scope.localVars.toggleDropdown = function(){
                           $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
                }

                
                $scope.localVars.setTaskExecuteData = function(inputData){
                                              
                                             $scope.localVarsExecuteTask.resourceDefinition= inputData.data.resourceDefinition;
                                             $scope.localVarsExecuteTask.dashboard.widgets.layout = inputData.data.widgets;
                                             $scope.localVarsExecuteTask.dashboard.data = inputData.data.form_data;
                                             $scope.localVarsExecuteTask.taskDefinition = inputData.data.taskdef[0];
                                             $scope.localVarsExecuteTask.taskDefinition.transaction_id = inputData.data.transactionId;
                                             $scope.localVarsExecuteTask.taskDefinition.fd = $scope.fd;
                                             $scope.localVarsExecuteTask.taskId = $scope.localVarsExecuteTask.taskDefinition.ResourceDefId_id;
                                             if ($scope.inlineTaskDefinition!=undefined) $scope.localVarsExecuteTask.taskDefinition.prev_task_id = $scope.inlineTaskDefinition.prev_task_id;
                                             
                                             $scope.localVarsExecuteTask.taskInitiateInstance = inputData.data.taskInitiateInstance;
                                             $scope.localVarsExecuteTask.taskExecuteInstance = inputData.data.taskExecuteInstance;
                                             if (!$scope.localVarsExecuteTask.OpenTaskInNewPage) $scope.localVarsExecuteTask.ShowCloseBtn=true;
                                      
                                             $scope.localVarsExecuteTask.initiateFormLoaded = true;
                                             $scope.localVarsExecuteTask.isCollapsed3 =false;
                                             $scope.localVarsExecuteTask.resourceDefinition.formParams={formLocked:true,formViewType:2};
                                             
                                                
                                             if ($scope.localVarsExecuteTask.taskExecuteInstance.length>0)
                                             {
                                                $scope.localVarsExecuteTask.taskDefinition.task_execute_id = $scope.localVarsExecuteTask.taskExecuteInstance[0].id;
                                                $scope.localVarsExecuteTask.taskDefinition.taskExecuteInstance=$scope.localVarsExecuteTask.taskExecuteInstance[0];
                                             
                                             }
                                             else
                                             {
                                              
                                              $scope.localVarsExecuteTask.taskDefinition.task_execute_id = 0;
                                             }
                                             
                                             if ($scope.localVarsExecuteTask.taskInitiateInstance.length>0)
                                             {
                                                $scope.localVarsExecuteTask.taskDefinition.task_initiate_id = $scope.localVarsExecuteTask.taskInitiateInstance[0].id;
                                                $scope.localVarsExecuteTask.taskDefinition.taskInitiateInstance=$scope.localVarsExecuteTask.taskInitiateInstance[0];
                                             
                                             }
                                             else
                                             {
                                              $scope.localVarsExecuteTask.taskDefinition.task_initiate_id = 0;
                                              
                                             }
                                             $scope.localVarsExecuteTask.taskDefinition.form_type="e";
                                            
                                            if ($scope.localVarsExecuteTask.taskDefinition.TaskOutcomeHeadId_id==undefined || $scope.localVarsExecuteTask.taskDefinition.TaskOutcomeHeadId_id==null)
                                            {
                                              $scope.localVarsExecuteTask.taskDefinition.TaskOutcomeHeadId_id = 0;
                                              
                                            }
                                            
                                             $scope.$on('ExecuteTaskPostProcess'+ $scope.localVarsExecuteTask.taskDefinition.task_execute_id,function(event,data1){
                                                $scope.localVars.getTaskExecuteData($scope.localVarsExecuteTask.taskDefinition.task_initiate_id,$scope.localVarsExecuteTask.taskDefinition.task_execute_id);
                                            });
                                            $scope.$on('InlineTaskClosed',function(event,data){
                                                if (data==$scope.localVarsExecuteTask.taskId) $scope.localVars.executeTaskDataLoaded=false;
                                            });
                  
                   
                                            $scope.$on('RefreshData'+ $scope.localVarsExecuteTask.taskDefinition.task_execute_id,function(event,data2){
                                              
                                               $scope.localVars.getTaskExecuteData($scope.localVarsExecuteTask.taskDefinition.task_initiate_id,$scope.localVarsExecuteTask.taskDefinition.task_execute_id,data2);
                                            });
                                            
                                            /*
                                            $scope.$on('ExecuteTask'+$scope.localVarsExecuteTask.task_execute_id,function(event,data){
                                                $scope.localVars.ExecuteTask(data.form,data.outcomeId);
                                            });
                                              */                            
                                            TaskDataService.GetTaskOutcomes($scope.localVarsExecuteTask.taskDefinition.ResourceDefId_id,$scope.localVarsExecuteTask.taskDefinition.TaskOutcomeHeadId_id,lang).then(function(data3) {            
                                              
                                                $scope.localVarsExecuteTask.taskOutcomes = data3.data;
                                                    
                                                   
                                                $scope.localVars.executeTaskDataLoaded=true;
                                              
                                             
                                            
                                              },function(error){
                                          
                                                  MessagingService.addMessage(error.msg,'error');
                                              });
                }
      
                $scope.localVars.getTaskExecuteData = function(initiate_id,execute_id,inData){
                      var lang=$rootScope.globals.currentUser.lang;
                     
                        $scope.localVarsExecuteTask.task_initiate_id = initiate_id;
                      
                        
                        $scope.localVarsExecuteTask.task_execute_id = execute_id;
                        $scope.localVars.executeTaskDataLoaded=false;                       
                      TaskDataService.preExecuteTask(initiate_id,execute_id,lang).then(function(data) {
                                             
                                                                        
                                      $scope.localVars.setTaskExecuteData(data);       
                          
                                        },function(error){
                                          
                                      
                                            MessagingService.addMessage(error.msg,'error');
                                      });
                   
                 };
                $scope.localVars.ExecuteTaskAction = function(action){
                     
                     
                        var lang=$rootScope.globals.currentUser.lang;
                      
                       TaskDataService.ExecuteTaskAction($scope.localVarsExecuteTask.task_initiate_id,$scope.localVarsExecuteTask.task_execute_id,action,lang).then(function(data) {
                 
                                             
                                              $scope.localVarsExecuteTask.taskInitiateInstance =data.data.data.taskInitiateInstance;
                                              $scope.localVarsExecuteTask.taskExecuteInstance =data.data.data.taskExecuteInstance;
                                              if ($scope.localVarsExecuteTask.taskExecuteInstance!=undefined)
                                                {
                                                $scope.localVarsExecuteTask.taskDefinition.task_execute_id = $scope.localVarsExecuteTask.taskExecuteInstance.id;
                                             
                                                }
                                                
                                              if (action=="claim")
                                              
                                              {
                                                $scope.localVars.pageChanged();
                                                $scope.localVarsExecuteTask.enableActions=true;
                                                $rootScope.$broadcast('RefreshData0',data.data.ret_value);
                                                
                                              }
                                              
                                              MessagingService.addMessage(data.data.msg,'success');
                                             
               
                                        },function(error){
                                          
                                      
                                            MessagingService.addMessage(error.msg,'error');
                                      });
                }
                
                
      
                $scope.localVars.ExecuteTask = function(form,outcomeId){
                        
                        
                      var lang=$rootScope.globals.currentUser.lang;
                      
                      if (form.$submitted) $scope.localVars.setSubmitted(form);
                      if (form.$valid) {
                      
                      
                          TaskDataService.executeTask($scope.localVarsExecuteTask.task_execute_id,$scope.localVarsExecuteTask.dashboard.data,outcomeId,lang).then(function(data) {
                                      
                                  MessagingService.addMessage(data.data.msg,'success');
                                  $rootScope.$broadcast('ExecuteTaskPostProcess'+$scope.localVarsExecuteTask.task_execute_id,data.data.ret_value);
                          },function(error){
                                  
                                  MessagingService.addMessage(error.msg,'error');           
                                            
                          });
                          
                    } // if (isValid)
                    else
                    {
                      MessagingService.addMessage("Please enter required data",'warning');
                      
                    }
                }; 
     
            $scope.localVars.setSubmitted = function (form) {
               form.$setSubmitted();
               angular.forEach(form, function(item) {
               if(item && item.$$parentForm === form && item.$setSubmitted) {
                   $scope.localVars.setSubmitted(item);
               }
           });
       }; 
         
          let template;
                        if ($scope.formDefinition) template = $templateCache.get('ktdirectivetemplates/ktExecuteTaskWidget.html');
                        else template = $templateCache.get('ktdirectivetemplates/ktExecuteTaskWidgetExe.html');
                      
                        $element.append($compile(template)($scope));  
          
          
          },
             link: function (scope, elem, attrs) {
                 
                 
               
 
    
    
                  
              }
        }             
};
'use strict';

export function ktFieldAdvancedProperties () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktFieldAdvancedProperties.html',
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService){  
                    
                    $scope.CTRL="ktFieldAdvancedProperties"
                    
                    if  ($scope.fd?.localVars?.[$scope.fd.id]==undefined ) {
						//debugger
						$scope.fd.localVars[$scope.fd.id] = {}
					}

                    $scope.fd.localVars[$scope.fd.id].addEvent=function()
                    {
                        if ($scope.fd.Parameters.events==undefined) $scope.fd.Parameters.events=[]
                        $scope.fd.Parameters.events.push({actions:[]})   
                    }

                    $scope.fd.localVars[$scope.fd.id].delEvent = function(idx){
                        $scope.fd.Parameters.events.splice(idx,1)   
                    }

                    $scope.fd.localVars[$scope.fd.id].addAction=function(event)
                    {
                        if (event.actions==undefined) event.actions=[]
                        event.actions.push({})   
                    }

                    $scope.fd.localVars[$scope.fd.id].insertAction=function(event,index)
                    {
                        if (event.actions==undefined) event.actions=[]
                        event.actions.splice(index,0,{})   
                    }
                     $scope.fd.localVars[$scope.fd.id].delAction=function(event,index)
                    {
                        if (event.actions==undefined) event.actions=[]
                        if (event.actions.length>index)  event.actions.splice(index,1)   
                    }
                },
             link: function (scope, elem, attrs) {
                
                    
              }
        }
  
};
'use strict';

export function ktFieldBasicProperties () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktFieldBasicProperties.html',
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService){    
                },
             link: function (scope, elem, attrs) {
                
                    
              }
        }
  
};
export function ktFieldBorderProperty () {
    return {
        restrict: 'A',
        templateUrl: 'ktdirectivetemplates/ktFieldBorderProperty.html',
          scope: {
            fd: '=',
        },
        controller: function($scope, $rootScope,GridsterService, $timeout){
            $scope.CTRL="ktFieldBorderProperty"
			$scope.gsrvc = GridsterService;  	
			if (!$scope.gsrvc?.Parameters) 	$scope.gsrvc.Parameters={}
			if (!$scope.fd.Parameters) $scope.fd.Parameters={}
			if (!$scope.gsrvc.selectedBorder)  $scope.gsrvc.selectedBorder={}
			 
			
			if (!$scope.gsrvc.Parameters?.[$scope.fd.UuidRef]) {
				
				$scope.gsrvc.Parameters[$scope.fd.UuidRef] = 
				{ 
				border: {
                            left: {
                                name: 'Left',
                                style:'solid',
                                width:0,
                                color:"#000000"
                            },
                            right: {
                                name: 'Right',
                                style:'solid',
                                width:0,
                                 color:"#000000"
                            } ,
                            top:{
                                name: 'Top',
                                style:'solid',
                                width:0,
                                color:"#000000"
                            },
                            bottom:{
                                name: 'Bottom',
                                style:'solid',
                                width:0,
                                color:"#000000"
                            }
							
				}, 
				margin: {
							left: {  
                                        name: 'Left Margin',
                                        value: 0,
                                        units:"px",
                                        auto: true
                                     },
                            right: {  
                                        name: 'Right Margin',
                                        value: 0,
                                        units:"px",
                                        auto: true
                                     },
                             top: {  
                                        name: 'Top Margin',
                                        value: 0,
                                        units:"px",
                                        auto: true
                                     },
                             bottom: {  
                                        name: 'Bottom Margin',
                                        value: 0,
                                        units:"px",
                                        auto: true
                                     },   
				}, 
				style :{
							left: {  
                                    name: 'Left Padding',
                                    value: 0,
                                    units:"px",
                                 },
                            right: {  
                                    name: 'Right Padding',
                                     value: 0,
                                    units:"px",
                                 },
                            top: {  
                                    name: 'Top Padding',
                                   value: 0,
                                    units:"px",
                                 },
                            bottom: {  
                                    name: 'Bottom Padding',
                                    value: 0,
                                    units:"px",
                                 },
					}
				}			
			
			}


			
			if ($scope.fd.Parameters.borders) 		
						$timeout(function () { angular.extend($scope.gsrvc.Parameters[$scope.fd.UuidRef].border, parseBorderToObject($scope.fd.Parameters.borders)) });

			if ($scope.fd.Parameters.margins) 		
						$timeout(function () { angular.extend($scope.gsrvc.Parameters[$scope.fd.UuidRef].margin, parseMarginToObject($scope.fd.Parameters.margins)) }); 

			if ($scope.fd.Parameters.paddings) 		
						$timeout(function () { angular.extend($scope.gsrvc.Parameters[$scope.fd.UuidRef].padding, parsePaddingToObject($scope.fd.Parameters.paddings)) });
	
			
			

			function parseBorderToObject(borderStr) {
				const borderSides = ['top', 'right', 'bottom', 'left'];
				const displayNames = {	top: 'Top',	right: 'Right',	bottom: 'Bottom',left: 'Left'};

				const result = {};

				borderSides.forEach(side => {
					result[side] = {
						name: displayNames[side],
						style: 'solid',
						width: 0,
						color: '#000000'
					};
				});

				const parts = borderStr.split(';').map(p => p.trim()).filter(Boolean);

				parts.forEach(part => {
					const [prop, value] = part.split(':').map(s => s.trim());
					if (!prop || !value) return;

					const match = prop.match(/border-(top|right|bottom|left)/);
					if (!match) return;

					const side = match[1];
					const [width, style, color] = value.split(' ');

					// Update with actual values from the string
					result[side] = {
						name: displayNames[side],
						style: style || 'solid',
						width: parseInt(width) || 0,
						color: color || '#000000'
					};
				});

				return result;
			}


			function generateborderCSS(newVal) {
						  let borderCSS = 
							  `border-top: ${newVal.top.width}px ${newVal.top.style} ${newVal.top.color}; ` +
							  `border-right: ${newVal.right.width}px ${newVal.right.style} ${newVal.right.color}; ` +
							  `border-bottom: ${newVal.bottom.width}px ${newVal.bottom.style} ${newVal.bottom.color}; ` +
							  `border-left: ${newVal.left.width}px ${newVal.left.style} ${newVal.left.color};`;
						  return borderCSS; 
			}

			function convertMarginObjectToCSS(marginObj) {
				  const cssSides = {
					top: 'margin-top',
					right: 'margin-right',
					bottom: 'margin-bottom',
					left: 'margin-left'
				  };

				  let css = '';

				  for (let side in cssSides) {
					const { value, units, auto } = marginObj[side];

					const cssValue = auto ? 'auto' : `${value}${units}`;
					css += `${cssSides[side]}: ${cssValue};`;
				  }

				  return css.trim();
				}

			function parseMarginToObject(css) {
				
			  const sidesMap = {'margin-left': 'left',	'margin-right': 'right',	'margin-top': 'top',	'margin-bottom': 'bottom'	  };

			  const sideNames = {	left: 'Left Margin',	right: 'Right Margin',	top: 'Top Margin',	bottom: 'Bottom Margin'	  };

			  const marginObject = {
				left: { name: 'Left Margin', value: 0, units: 'px', auto: false },
				right: { name: 'Right Margin', value: 0, units: 'px', auto: false },
				top: { name: 'Top Margin', value: 0, units: 'px', auto: false },
				bottom: { name: 'Bottom Margin', value: 0, units: 'px', auto: false }
			  };

			  const rules = css.split(';').map(rule => rule.trim()).filter(Boolean);

			  rules.forEach(rule => {
				const [property, value] = rule.split(':').map(part => part.trim());

				const side = sidesMap[property];
				if (!side) return;

				if (value === 'auto') {
				  marginObject[side] = {
					name: sideNames[side],
					value: 0,
					units: 'px',
					auto: true
				  };
				} else {
				  const match = value.match(/^(-?\d*\.?\d+)([a-z%]+)$/);
				  if (match) {
					const [, val, unit] = match;
					marginObject[side] = {
					  name: sideNames[side],
					  value: parseFloat(val),
					  units: unit,
					  auto: false
					};
				  }
				}
			  });

			  return marginObject;
			}

			function parsePaddingToObject(css) {
			  const sidesMap = {'padding-left': 'left','padding-right': 'right',	'padding-top': 'top',	'padding-bottom': 'bottom'  };

			  const sideNames = {	left: 'Left Padding',right: 'Right Padding',top: 'Top Padding',bottom: 'Bottom Padding' };

			  const paddingObject = {
				left: { name: 'Left Padding', value: 0, units: 'px'},
				right: { name: 'Right Padding', value: 0, units: 'px' },
				top: { name: 'Top Padding', value: 0, units: 'px' },
				bottom: { name: 'Bottom Padding', value: 0, units: 'px' }
			  };

			  // Split the CSS into individual rules
			  const rules = css.split(';').map(rule => rule.trim()).filter(Boolean);

			  rules.forEach(rule => {
				const [property, value] = rule.split(':').map(part => part.trim());

				const side = sidesMap[property];
				if (!side) return;

				const match = value.match(/^(-?\d*\.?\d+)([a-z%]+)$/);  // Matches number + unit (e.g., 10px, 1.5em)
				if (match) {
				  const [, val, unit] = match;
				  paddingObject[side] = {
					name: sideNames[side],
					value: parseFloat(val),
					units: unit
				  };
				}
			  });

			  return paddingObject;
			}


			function convertPaddingObjectToCSS(paddingObj) {
				
			  const cssSides = {    top: 'padding-top',    right: 'padding-right',    bottom: 'padding-bottom',    left: 'padding-left'  };

			  let css = '';

			  for (let side in cssSides) {
				const { value, units } = paddingObj[side];
				css += `${cssSides[side]}: ${value}${units};`; 
			  }

			  return css.trim();
			}

	
			
			$scope.$watch('gsrvc.Parameters[fd.UuidRef].border', function(newVal, oldVal) {
				if ((newVal && !angular.equals(newVal, oldVal)) ) {
					if ($scope.fd.Parameters.border) 	{
						$scope.fd.Parameters.border=$scope.gsrvc.Parameters[$scope.fd.UuidRef].border
						$scope.fd.Parameters.borders = generateborderCSS($scope.gsrvc.Parameters[$scope.fd.UuidRef].border)	
					}						
					else	
						$scope.fd.Parameters.borders = generateborderCSS($scope.gsrvc.Parameters[$scope.fd.UuidRef].border)		
				}
			}, true);
			


	
			$scope.$watch('gsrvc.Parameters[fd.UuidRef].padding', function(newVal, oldVal) {
				if ((newVal && !angular.equals(newVal, oldVal)) ) {
					if ($scope.fd.Parameters.padding) 	{
						$scope.fd.Parameters.padding = $scope.gsrvc.Parameters[$scope.fd.UuidRef].padding
						$scope.fd.Parameters.paddings = convertPaddingObjectToCSS( $scope.gsrvc.Parameters[$scope.fd.UuidRef].padding ) 
					}						
					else
						$scope.fd.Parameters.paddings = convertPaddingObjectToCSS( $scope.gsrvc.Parameters[$scope.fd.UuidRef].padding )  
				}

			}, true);
			
			$scope.$watch('gsrvc.Parameters[fd.UuidRef].margin', function(newVal, oldVal) {
				if ((newVal && !angular.equals(newVal, oldVal)) ) {
					if ($scope.fd.Parameters.margin) 	{
							$scope.fd.Parameters.margin = $scope.gsrvc.Parameters[$scope.fd.UuidRef].margin	
							$scope.fd.Parameters.margins =  convertMarginObjectToCSS( $scope.gsrvc.Parameters[$scope.fd.UuidRef].margin )
					}
					else 
						$scope.fd.Parameters.margins =  convertMarginObjectToCSS( $scope.gsrvc.Parameters[$scope.fd.UuidRef].margin )
				}			
			}, true);
			
		

            $scope.fd.select = function(selected){
                        $scope.fd.selected=selected;
                    }
                    
            $scope.gsrvc.selectBorder = function(selected){
                        $scope.gsrvc.selectedBorder[$scope.fd.UuidRef]=selected;
                    }
              },
			  
        link: function (scope, element, attr) {
          
        
        }
    }
};
'use strict';

export function ktFieldDataSourceProperties () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktFieldDataSourceProperties.html',
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService){
                
                },
             link: function (scope, elem, attrs) {
                
                
              
                
              }
        }
  
};
'use strict';

export function ktFieldExtendedProperties () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktFieldExtendedProperties.html',
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService){
                
                },
             link: function (scope, elem, attrs) {
                
                
              
                
              }
        }
  
};
'use strict';

export function ktFieldGeneralProperty () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktFieldGeneralProperty.html',
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService){    
                },
             link: function (scope, elem, attrs) {
                
                    
              }
        }
  
};
'use strict';

export function ktFieldSizeProperty () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktFieldSizeProperty.html',
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService){    
                },
             link: function (scope, elem, attrs) {
                
                    
              }
        }
  
};
'use strict';

export function ktFieldStyleProperty () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktFieldStyleProperty.html',
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService){    
                },
             link: function (scope, elem, attrs) {
                
                    
              }
        }
  
};
'use strict';

export function ktFile () {
        return {
            restrict: 'A', 
			controller: function ($scope, $rootScope,$element,ResourcesDataService,ProcessingService,$timeout,MessagingService,CODES_CONST,GridsterService,WidgetDataExchangeService,KatalyoStateManager,$q) {
	
        
        $scope.gsrvc = GridsterService; 
		if ($scope.gsrvc.resourcesList == undefined) $scope.gsrvc.resourcesList={}
	
        $scope.org_id = $rootScope.globals.currentUser.organisation.id;
        if ($scope.fd.localVars==undefined) $scope.fd.localVars={};        
        if ($scope.formData == undefined) $scope.formData=[{}];
        if ($scope.formData.length == 0) $scope.formData.push({});

        $scope.fd.localVars = {dashboard:{widgets:[]}}
        let newValueSingle,newValueMultiple;
        $scope.ctrl = this;
        
        $scope.fd.localVars.TablePrefix = 'resource'+$scope.fd.Related+'_'+$rootScope.globals.currentUser.organisation.id


        $scope.CTRLNAME='ktFile'

        if ($scope.fd.Parameters===undefined || $scope.fd.Parameters===null) $scope.fd.Parameters={}
        if ($scope.fd.Parameters.ResourceRelationshipType===undefined) $scope.fd.Parameters.ResourceRelationshipType='new'

        if ($scope.fd.MaxLength===undefined || $scope.fd.MaxLength===null) $scope.fd.MaxLength=1

        $scope.fd.localVars.formParams = {formViewType:1,showGridNavigation:true}

        if ($scope.fd.PresentationType==1)
        {
                $scope.setDropdownValue=function(theSelectItemFn)
                {
                        $scope.setItemValueDropdown = theSelectItemFn;
                
                }
                 $scope.setLoadDropdown = function(directiveFn) {
                        $scope.loadDropdown = directiveFn;
            
                };
                $scope.setClearDropdown = function(directiveFn) {
                        $scope.clearDropdown = directiveFn;
                }
        }
          $scope.fd.localVars.paginationOptions = {
                    pageNumber: 1,
                    pageSize: 10,
                    sort: null
                };
              
       
        var widgetDefinition = {DEI: [{'name':'resourceLinkFile','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'datasetListWidget',widgetId: $scope.fd.PresentationId,taskId:  $scope.lTaskId,
                                resourceDefId : $scope.fd.Related, //resourceDefId : $scope.selectedResource
                                resourceRecordId:$scope.fd.localVars.resourceRecordId,task_initiate_id:$scope.resourceDefinition.task_initiate_id,task_execute_id:$scope.resourceDefinition.task_execute_id, output:null };
        $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
        
        $scope.ksm = KatalyoStateManager;
        
        $scope.populateValue = function(newValue)
        {
                if ($scope.fd.MaxLength!=1)
                {
                 newValueMultiple = newValue;
                 newValueSingle="";
                }
                else
                {
                 newValueMultiple = [];
                 newValueSingle=newValue;
                }
               
                $scope.itemValue.val = newValue;
                if ($scope.fd.PresentationType==1 && $scope.setItemValueDropdown!=undefined) $scope.setItemValueDropdown(null,$scope.itemValue.val);
                $scope.formData[0][$scope.fd.FieldName] = $scope.itemValue.val;
                $scope.fd.Search.value = $scope.formData[0][$scope.fd.FieldName];
                $scope.ksm.executeAction(valueStateName,"valueChanged", newValue);
                if (newValue && $scope.setItemValueDropdown!=undefined) $scope.setItemValueDropdown(null,newValue);
                else if ($scope.clearDropdown!=undefined) $scope.clearDropdown();
                WidgetDataExchangeService.setData({
                    DEI: [{name:'resourceLinkFile',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:newValueSingle}
                        ,{name:'resourceRecordIds',value:newValueMultiple},{name:'resourceRecordsAll',value:$scope.fd.localVars.datasetItems}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});   
                
        }

     $scope.fd.localVars.filesData = []
    
    /**********************************************************************/
    /***************** Get files for smart table ktFile *******************/
    /**********************************************************************/
    $scope.fd.localVars.getFiles= function(tableState, pageNumber,pageSize){


        //taskExecuteId: 0   taskInitiateId: 0
        let deferred = $q.defer();    

        $timeout(function(){

            $scope.resourceLoading=true;
            var lang=$rootScope.globals.currentUser.lang;
            var newPage
           
            
            if (pageNumber==undefined) pageNumber = $scope.fd.localVars.paginationOptions.pageNumber;
            if (pageSize==undefined) pageSize = $scope.fd.localVars.paginationOptions.pageSize;
            
            if ($scope.fd.localVars.filesData!==undefined) {
                    $scope.fd.localVars.totalCount= $scope.fd.localVars.filesData?.length
                    $scope.fd.localVars.paginationOptions.totalItemCount=$scope.fd.localVars.filesData?.length
                    $scope.fd.localVars.paginationOptions.numberOfPages = Math.ceil($scope.fd.localVars.paginationOptions.totalItemCount/pageSize);
            }

            if ($scope.fd.localVars.totalCount>0){
                if (Math.ceil($scope.fd.localVars.totalCount/pageSize)<pageNumber)
                    newPage = Math.ceil($scope.fd.localVars.totalCount/pageSize);
            }
            
             if ($scope.fd.localVars.filesData) 
                    $scope.fd.localVars.results = {results : $scope.fd.localVars.filesData.slice( (pageNumber -1) * pageSize, pageNumber * pageSize) }
             else 
                    $scope.fd.localVars.results = {}     
             $scope.fd.localVars.results.columns=$scope.fd.localVars.filesColumns

             $scope.fd.localVars.currentPage=pageNumber;
             $scope.fd.localVars.results.pageSize = pageSize;
             $scope.fd.localVars.results.numberOfPages = $scope.fd.localVars.paginationOptions.numberOfPages;
             $scope.fd.localVars.results.count =   $scope.fd.localVars.totalCount
      
             
             deferred.resolve({data: $scope.fd.localVars.results});
         })

      return deferred.promise;
    
    }
         /**********************************************************************
         ****************** Sync data with State manager **********************
         ***********************************************************************/
       
        if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
        $scope.itemValue = {val:null};
        
        let valueState= $scope.ksm.addSubject($scope.fd.ElementType+'ValueStateName'+$scope.fd.ItemId+$scope.resourceDefinition.transaction_id,$scope.itemValue.val);
        let valueStateName = valueState.subject.name;
        
        let value_changed = function(data)
        {
            valueState.subject.setStateChanges = data;
            valueState.subject.notifyObservers("valueChanged");
        };
        
        let action_value_changed = $scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
       
        
        let apply_value = function(data)
        {
            let local_data;
            let state=data.state        
            if ($scope.itemValue.val!=state)
            {
                local_data = state;
                if ($scope.fd.Parameters.DependentFieldFilter!=undefined)
                {
                        if ($scope.fd.Parameters.DependentFieldFilter!="" || $scope.fd.Parameters.DependentFieldElement!="")
                        {
                                if (Array.isArray(state))
                                {
                                        if (state.length>0) local_data = state[0];
                                        else local_data = null;
                                        
                                }
                                else
                                {
                                     local_data = state;
                                }
                                if ($scope.fd.localVars.datasetItems==undefined)
                                {
                                        $scope.fd.refreshDatasetDataList("",true,local_data);
                                        local_data=null;
                                }
                                else
                                {
                                        let element1,element2;
                                        if ($scope.fd.Parameters.DependentFieldFilter!="")
                                        {
                                                element1 = $scope.fd.Parameters.DependentFieldFilter;
                                                element2 = "id";
                                        }
                                        else
                                        {
                                                element1 = "id";
                                                element2 = $scope.fd.Parameters.DependentFieldElement;
                                        }
                                        let pos = $scope.fd.localVars.datasetItems.map(function(e) { return e[element1]; }).indexOf(local_data[element2]);

                                        if (pos>=0) local_data = $scope.fd.localVars.datasetItems[pos];
                                        else local_data = null;
                                }
                        }
                }
                $scope.populateValue(local_data);
            }
        }; 
       
        if ($scope.fd.Parameters.DependentFieldId!=undefined && $scope.fd.Parameters.DependentFieldId!=null)
        
        {
            if ($scope.fd.Parameters.DependentFieldId!="")
            {
                let dependent_field = $scope.fd.FieldName;
                let subscribedSubject = $scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId+$scope.resourceDefinition.transaction_id;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value,true);
                let val = $scope.ksm.getState(subscribedSubject);
                $scope.populateValue(val.state);
            }
        }
        

          //**********************************************************
         //           GET FORM FIELDS
         //**********************************************************      
            
          $scope.fd.getFormFields = function(){
              
              
              var lang=$rootScope.globals.currentUser.lang;
           
                         
              ResourcesDataService.getFormFields($scope.fd.Related,lang).then(function(data) {
                               
                                  $scope.fd.presentationElements= data.data;
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
                              
          };

          /************ Get selected records for dropdown **************/
        $scope.fd.getDatasetList = function()
        {
                if ($scope.formData[0][$scope.fd.FieldName+'l']!=undefined && $scope.formData[0][$scope.fd.FieldName+'l'].length>0 && $scope.fd.PresentationId!=null && $scope.fd.PresentationId!=undefined)
                {
                  ResourcesDataService.getResourceDataList($scope.fd.Related,$scope.fd.PresentationId,lang,{'id__in': $scope.formData[0][$scope.fd.FieldName+'l']}).then(function(data) {
                             
                             if ($scope.formData===undefined) $scope.formData = [{}];
                             if ($scope.fd.MaxLength==1) $scope.formData[0][$scope.fd.FieldName] = data.data[0];
                             else $scope.formData[0][$scope.fd.FieldName] = data.data;
                             $scope.populateValue($scope.formData[0][$scope.fd.FieldName]);
                             WidgetDataExchangeService.setSearch($scope.fd.PresentationId,$scope.taskExecuteId);
                             //$scope.ksm.executeAction(valueStateName,"valueChanged", $scope.formData[0][$scope.fd.FieldName]);
                             //$scope.itemValue.val = $scope.formData[0][$scope.fd.FieldName];
                      },function(error){    
                      MessagingService.addMessage(error.msg,'error');
                  });
                }
        }
        
      
      
        $scope.$watch('itemValue.val',function(newValue,oldValue){
                if (newValue!=oldValue)
                {
                        $scope.populateValue(newValue);    
                
                }
        });
        
           
         $scope.fd.localVars.fileSelectionChanged = function(file){
                             
                                $scope.formData[0][$scope.fd.FieldName]=file;
                                
                                $scope.fd.localVars.fileSelected =file.isSelected
                                
                                $scope.fd.localVars.SelectedFile = file                               
                                // count selected
                                $scope.fd.localVars.resourceDataRecordSelected=$scope.formData[0][$scope.fd.FieldName].length; 
                                
                                WidgetDataExchangeService.setData({
                                DEI: [{name:'resourceLinkFile',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.fd.localVars.SelectedFile.id},
                                {name:'resourceRecordIds',value:file},{name:'resourceRecordsAll',value:$scope.fd.localVars.filesData}]}],
                                widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});

        };

        $scope.search=[
                            {id:1,filter:'onlist',name:"On list:",icon:"fa fa-chevron-right"},
                            {id:2,filter:'notonlist',name:"Not on list:",icon:"fa fa-expand"},
                      ];
				
        if ($scope.fd!=undefined) {
                  if ($scope.fd.Search==undefined)
                  {
                    $scope.fd.Search=$scope.search[0]; //MIGOR TODO - greska kod incijacije za multiple , mozda treba kod promjene na multiple ovo jos jednom okinuti
                  }
        } 

			  $scope.applySearchFilters = function(index) {
                   
				  $scope.fd.Search=$scope.search[index];
                            $scope.fd.Search.value = [ $scope.formData[0][$scope.fd.FieldName] ];
                            $scope.fd.isOpen=false;		
			  };
       
       
        $scope.src_type_text=CODES_CONST._POPULATE_TYPE_  
      
        
        var lang = $rootScope.globals.currentUser.lang;
        
        $scope.fd.localVars.isResourceSelected = false;
 
				$scope.fd.localVars.selectedDataRecord=false;
 
				$scope.taskId=0;
       
        			   
					   
	$scope.fd.gridOptionsFile = {
                data:[],
                showGridFooter: false,
                showColumnFooter: false,
                enableRowSelection: true,
                multiSelect: false,
                enableHorizontalScrollbar : true, 
                enableVerticalScrollbar : true,
                enableRowHeaderSelection: false, //false
                showHeader:true,
                enableColumnResizing: true,
                autoResize:true,
                minRowsToShow: 4,
                displayselectionCheckbox:false,
                enableGridMenu: true,
        }
					   
        $scope.fd.RelationshipType = $scope.fd.MaxLength;
     
						
          if ( $scope.fd.localVars==undefined )  $scope.fd.localVars={}

        if ($scope.resourceDefinition!=undefined)
        {
          $scope.taskId=$scope.resourceDefinition.ResourceDefId;
          $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
          $scope.formType=$scope.resourceDefinition.form_type;
          $scope.source_type=$scope.resourceDefinition.source_type;
          $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
          $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
          $scope.formDefinition = $scope.resourceDefinition.form_definition;
          
         
        
        }
        
         $scope.fd.gridsterType = "resource";
          
          $scope.fd.localVars.resourceDashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: [],
          data:{}
				} ;
        if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
        $scope.fd.resourceRecordId=0;
        if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        if ($scope.fd.PresentationType==null)
        {
              $scope.fd.PresentationType = 0;
        }
            
          //$scope.fd.tItemValue = $scope.fd.FormDef;
          //if (typeof $scope.fd.tItemValue=="string") $scope.fd.tItemValue=[]; 
		  
          //$scope.fd.resourcesList=[];
		  
		  if ($scope.fd.resourcesList) delete $scope.fd.resourcesList;
		  
          $scope.fd.resourceListLength=0;
          $scope.fd.selectedFile = 0;
          //$scope.fd.selectedFileDropdown = 0;
          //if ($scope.fd.Related!=null) $scope.fd.selectedFile = $scope.fd.Related;
					
          
          
           $scope.setItemFn = function(directiveFn) {
            $scope.SetFileId = directiveFn;
            
        };
        
        $scope.fd.resourceDataRecordSelected=false;
				  
         //*********************************************************************************************
          //************************************ GET FILE LIST ***************************************
                    //*********************************************************************************************
       $scope.fd.localVars.getResources = function(search)  {
                        var lang=$rootScope.globals.currentUser.lang;
              ResourcesDataService.getResourceDefListByTypeFilter(lang,'file',search,$scope.fd.selectedFile).then(
            function(data) {
                                        
                //$scope.fd.resourcesList = data.data;
				$scope.gsrvc.resourcesList[$scope.fd.UuidRef]= data.data
                            
                            if (!Array.isArray($scope.gsrvc.resourcesList[$scope.fd.UuidRef]))   $scope.gsrvc.resourcesList[$scope.fd.UuidRef]=[];            
                        
                            if ($scope.fd.Related!=null)
                            {
                                   $scope.fd.resourceId = $scope.fd.Related;
                                   $scope.fd.resourceListLength =  $scope.gsrvc.resourcesList[$scope.fd.UuidRef].length;
                                   //select dataset from dropdown
                                    var pos =  $scope.gsrvc.resourcesList[$scope.fd.UuidRef].map(function(e) { return e.id; }).indexOf($scope.fd.resourceId);

                                   if (pos>=0){
                                       $scope.fd.selectedResource= $scope.gsrvc.resourcesList[$scope.fd.UuidRef][pos];
                                      
                                       $scope.fd.isResourceSelected=true;
                                       $scope.fd.localVars.pickButtonLabel="Choose "+$scope.fd.selectedResource.name+" record...";

                                   }
                         
                            }
                            $scope.fd.RelatedLoaded=true;
                                             
                     },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                         });
       };     
          
      $scope.fd.localVars.downloadFile = function(fileId,fileName){
                ResourcesDataService.downloadFile($scope.fd.Related,fileId).then(function(data) {
                               
                                    MessagingService.addMessage('File '+fileName+' downloaded','info');
                                    var url = URL.createObjectURL(new Blob([data.data]));
                                    var a = document.createElement('a');
                                    a.href = url;
                                    a.download = fileName;
                                    a.target = '_blank';
                                    a.click();
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
      };// dowload file END
      
      
       $scope.fd.localVars.previewFile = function(fileId,fileName,fileType){
           
            ResourcesDataService.downloadFile($scope.fd.Related,fileId).then(function(data) {
                               
                                    var url = URL.createObjectURL(new Blob([data.data],{type:fileType}));
                                    let new_doc = window.open(url,"_blank");
                                  
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
      };// preview file END

           $scope.fd.getResourceDataRefresh = function (retValue) 
            {
              var lang = $rootScope.globals.currentUser.lang;
              //ToDo ovo prebaciti sve u jedan API poziv
               if ($scope.resourceRecordId>0 && $scope.fd.MaxLength==0)
              {
                ResourcesDataService.getResourceDataWithRelated($scope.parentResourceDefId,$scope.resourceId,$scope.resourceRecordId,$scope.taskId,$scope.fd.ItemId,lang).then(function(data) {
                            $scope.formData[0][$scope.fd.FieldName] = data; 
                            $scope.setupGrid(data);                
                },function(error){    
                    MessagingService.addMessage(error.msg,'error');
			 					});
                      
                }
            }
            


        /* delete selected child record*/
        $scope.fd.localVars.deleteChildRecord = function()
        {
              var lang = $rootScope.globals.currentUser.lang;
              if ($scope.resourceRecordId>0 && $scope.fd.MaxLength==0 && $scope.fd.localVars.fileSelected)
              {
               
              ResourcesDataService.DeleteChildRelationship($scope.fd.PresentationId,$scope.parentResourceDefId,$scope.resourceRecordId,$scope.fd.localVars.SelectedFile[$scope.fd.localVars.TablePrefix+'_id']).then(function(data) {
                      MessagingService.addMessage(data.data,'success');
                       $scope.fd.localVars.filesData.length = 0
                      $scope.fd.localVars.fileSelected = false
                      $scope.fd.localVars.GetResourceDataForParent()
                },function(error){    
                    MessagingService.addMessage(error.data,'error');
                                    });
            }       
        }

            $scope.linkedWidgetId = 0;
            
            if ($scope.fd.Search!=undefined) $scope.linkedWidgetId = $scope.fd.Search.WidgetId;
            
            var refresh_list_from_callback=function(data)
            {
                $scope.fd.refreshDatasetDataList("",true,$scope.lData);
                
            }
              
            $scope.fd.refreshDatasetDataList = function(search,apply,val)
            {
              var lang = $rootScope.globals.currentUser.lang;
              //ToDo ovo prebaciti sve u jedan API poziv
              $scope.lData = val;
               if ($scope.fd.PresentationId!=null && $scope.fd.PresentationId!=undefined)
                {
                        var ctrl = this;
                        this.l_apply = apply;
                        this.l_val = val;
                        let fromCache=true;
                   //ResourcesDataService.getResourceDataList($scope.fd.Related,$scope.fd.PresentationId,lang,search).then(function(data) {
                   ResourcesDataService.getResourceDataListAll($scope.fd.Related,$scope.fd.PresentationId,lang,fromCache,refresh_list_from_callback).then(function(data) {
                   
                           $scope.fd.localVars.datasetItems = data.data;
                           $timeout(function(){
                                //if (!$scope.fd.ReadOnly) $scope.loadDropdown($scope.fd.localVars.datasetItems);
                                if (ctrl.l_apply) apply_value(ctrl.l_val);
                           });
                    },function(error){    
                    MessagingService.addMessage(error.msg,'error');
									});
              
                }
            };
           
          
            $scope.fd.localVars.restoreGridState= function() {
            //debugger
            if ($scope.fd['GridState']!==undefined && $scope.fd['GridState']!==null)
            {
              
                if ($scope.fd['GridState']['columnsDef']!==undefined) $scope.fd.localVars.filesColumns =  $scope.fd['GridState']['columnsDef']
                if ($scope.fd['GridState']['columnsQuery']!==undefined) $scope.fd.columnsForQuery =  $scope.fd['GridState']['columnsQuery']

            }
        };              
      
          // Resource is selected
              $scope.fd.onSelectCallback = function (item, model){
                var eventResultId=item.id;
                $scope.fd.eventResultName=item.name;
                
                 $scope.fd.resourceId=eventResultId;
                 $scope.fd.isResourceSelected=true;
                    
                $scope.fd.Related=$scope.fd.resourceId;
                $scope.fd.localVars.getPublishedResources()
                if ($scope.fd.Related!=undefined && $scope.fd.Related!=null) $scope.fd.getFormFields();
                   
              }
              
            // Resource is selected
              $scope.fd.onSelectPublished = function (item, model){
                let pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(item.id);
                let old_publish_id = $scope.fd.Parameters.PublishedResourceId
                if (pos>=0){
                    $scope.fd.Parameters.PublishedResourceId = $scope.fd.localVars.publishedResourceList[pos].id;
                
                    $scope.fd.Parameters.PublishedResourceVersion = $scope.fd.localVars.publishedResourceList[pos].Version;
                    if ($scope.fd.GridState?.columnsDef===undefined || $scope.fd.Parameters.PublishedResourceId !=old_publish_id) $scope.fd.localVars.getColumnsDef()
                    else $scope.fd.localVars.fileListDownloaded =true
                }
                
                  
              }
         $scope.fd.localVars.getPublishedResources=function()
              {
               $scope.fd.localVars.publishedLoaded=false        
              ResourcesDataService.GetPublishedResourcesByTypeId($scope.fd.Related,'form').then(
                function (data) { 
                if ($scope.fd.localVars===undefined) $scope.fd.localVars={}      
                   $scope.fd.localVars.publishedResourceList = data.data;
                   $scope.fd.localVars.publishedLoaded=true

                  
                   },function(error){    
                                  MessagingService.addMessage(error.msg,'error');
                });
            }



        $scope.fd.localVars.ShowSearchForm = function(id) 
 
        {   let show_search_form
            if ($scope.fd.ShowSearchForm) show_search_form = false
            else show_search_form = true
            $scope.fd.localVars.getPublishedResourceById(id,show_search_form)
            
        }
        /*********************************************************************************************/
        /******************************* GET PUBLISHED DATASET DETAILS *******************************/
        /*********************************************************************************************/ 

        $scope.fd.localVars.getPublishedResourceById = function(id,show_search_form) 
        {
            if (show_search_form)  {
                let pos
                let old_publish_id = $scope.fd.Parameters.PublishedResourceId
                if ($scope.fd.FormDef!==undefined && $scope.fd.FormDef!==null && $scope.fd.FormDef.length>0) { 
                        pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                        $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
                        $scope.fd.localVars.formLoaded=true;
                  } else 
                  {
                      pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                      $scope.fd.FormDef={}
                      if (pos>=0){
                        ResourcesDataService.GetPublishedResourceById(id).then(function (data) {
                                $scope.fd.FormDef = data.data.Form  
                                $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
                                $scope.fd.localVars.formLoaded=true;
                            },function(error){    
                              MessagingService.addMessage(error.msg,'error');
                        });

                    }
                }
             
            }
        }    

        $scope.fd.localVars.getColumnsDef = function () {

                
                    ResourcesDataService. getResourceColumns($scope.fd.Parameters.PublishedResourceId,'file',lang,$scope.fd.Parameters.PublishedResourceVersion).then(function(data) {//MIGOR
                                    
                                          $scope.fd.localVars.filesColumns = data.data.columnsDef
                                          $scope.fd.localVars.results.columns =  $scope.fd.localVars.filesColumns
                                          $scope.fd.localVars.fileListDownloaded = true;
                                        
                                          $scope.fd.localVars.saveGridState(false)
                                         
                                             
                                          },function(error){
                                        MessagingService.addMessage(error.msg,'error');
                                     });

            }

         /*********************************************************************************************/
        /************************ GET RESOURCE LIST FOR EXISTING RELATIONSHIP *************************/
        /*********************************************************************************************/
       $scope.fd.localVars.getExistingResources = function()  {

             scope.gsrvc.resourcesList[$scope.fd.UuidRef].length=0
             $scope.fd.RelatedLoaded=false
             
             let resource_def_id = $scope.resourceDefinition.ResourceDefId_id
             if (resource_def_id===undefined) resource_def_id = $scope.resourceDefinition.ResourceDefId
             
             if (resource_def_id===undefined) resource_def_id = $scope.resourceDefinition.ParentDatasetDefId

            if (resource_def_id)
            {
              ResourcesDataService.getExistingResourceRelationships(resource_def_id).then(function(data) {
                                        
					$scope.gsrvc.resourcesList[$scope.fd.UuidRef] = data.data;
                            
                            if (!Array.isArray(scope.gsrvc.resourcesList[$scope.fd.UuidRef]))  $scope.gsrvc.resourcesList[$scope.fd.UuidRef]=[];            
                        
                            if ($scope.fd.Related!=null)
                            {
                                   $scope.fd.resourceId = $scope.fd.Related;
                                   $scope.fd.resourceListLength = $scope.gsrvc.resourcesList[$scope.fd.UuidRef].length;
                                   //select dataset from dropdown
                                    var pos = $scope.gsrvc.resourcesList[$scope.fd.UuidRef].map(function(e) { return e.id; }).indexOf($scope.fd.resourceId);

                                   if (pos>=0){
                                       $scope.fd.selectedResource=$scope.gsrvc.resourcesList[$scope.fd.UuidRef][pos];
                                      
                                       $scope.fd.isResourceSelected=true;
                                   }
                         
                            }

                            if ($scope.fd.Parameters.PublishedResourceId!=undefined) 	$scope.fd.localVars.getPublishedResources()
                            
                            $scope.fd.RelatedLoaded=true;
               
                     },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                         });
          }else  MessagingService.addMessage('Dataset id error (directive fn getExistingResources)','error');
       };     
          
          
          
                if ($scope.formDefinition)
                {
                 if ($scope.fd.Parameters.ResourceRelationshipType==='new' || $scope.fd.Parameters.ResourceRelationshipType==='view') $scope.fd.localVars.getResources();
                 else $scope.fd.localVars.getExistingResources();
                }
        $scope.fd.setupGrid= function(data)
        {
              $scope.fd.localVars.filesColumns = data.columnsDef;
              
              $timeout(function(){
                $scope.fd.localVars.restoreGridState();
               
               });
              
              
        }
            
              $scope.fd.localVars.setupGridNew= function(data)
              {
                $scope.fd.localVars.filesData = data.data;
                if ($scope.fd.GridState?.columnsDef===undefined) $scope.fd.localVars.filesColumns = data.columnsDef;
                $scope.fd.localVars.fileListDownloaded = true
              
              }
              
 
            $scope.fd.localVars.restoreGridState();
               
       
              
              
            
            //  Popuni listu gridOptions.data sa listom svih resursa odabranog tipa
						
            
        $scope.fd.getResourceDataFiltered = function () {

            $scope.filter = {};
            var lang = $rootScope.globals.currentUser.lang;

           //scope.activity.activityMessage = ProcessingService.setActivityMsg('Retriving data '+scope.selectedResource);
          //$scope.filter = ResourcesDataService.prepareResourceWidgetData($scope.dashboard.widgets,-1);
         
          if ($scope.fd.selectedResource==null) {
            $scope.fd.selectedResourceId = $scope.fd.Related;
          }else
          {
             $scope.fd.selectedResourceId = $scope.fd.selectedResource.id;
            
          }
	//		ResourcesDataService.getResourceDataFiltered($scope.fd.Related,lang,$scope.filter).then(function(data) {//MIGOR
                ResourcesDataService.getResourceDataFiltered($scope.fd.selectedResourceId,$scope.taskId,lang,$scope.fd.resourceDashboard.widgets).then(function(data) {//MIGOR
                            
                            $scope.fd.setupGrid(data);
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                             });
        }
		
	

        $scope.fd.localVars.saveGridState= function(show_message) {
               //debugger //ktTaskDatasetList smarttable
               let columnsDef = $scope.fd.localVars.filesColumns

               let columnsQuery = $scope.fd.localVars.columnsForQuery
               $scope.fd['GridState']={'columnsDef':columnsDef,'columnsQuery': columnsQuery}
               
              if (show_message)
               MessagingService.addMessage("To make changes stick please save form",'info');            
    };		
             
        $scope.fd.getResourceData = function () 
	{
                // $scope.activity.activityMessage = ProcessingService.setActivityMsg('Downloading resource data for '+$scope.resourceId);
                 var lang = $rootScope.globals.currentUser.lang;
                 ResourcesDataService.getResourceData($scope.resourceId,$scope.taskId,lang).then(function(data) {
                                                 
                                                                $scope.fd.setupGridNew(data);
        
                },function(error){    
                        MessagingService.addMessage(error.msg,'error');
                });
	};
            $scope.fd.localVars.results = {}         


     //**********************************************************
     //           GET FILES DIRECT FILTER
     //**********************************************************      
      $scope.fd.localVars.getFilesDirect = function (relatedDatasetId,items) {
        
        $scope.fd.localVars.fileListDownloaded =false

        ResourcesDataService.getResourceDataDirectFilter(relatedDatasetId,$scope.fd.PresentationId,"i",lang,{id__in: items}).then(function(data) {
                                
                                    $scope.fd.localVars.setupGridNew(data);
                               
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    $scope.fd.localVars.fileListDownloaded = true
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };

        
        /* Get children for parent*/
        $scope.fd.localVars.GetResourceDataForParent = function () 
        {
              var lang = $rootScope.globals.currentUser.lang;
              if ($scope.resourceRecordId>0 && $scope.fd.MaxLength==0)
              {
                $scope.fd.localVars.fileListDownloaded =false
                ResourcesDataService.getResourceDataM2m($scope.fd.PresentationId,$scope.parentResourceDefId,$scope.fd.Related,$scope.resourceRecordId,$scope.taskId,$scope.fd.ItemId,lang).then(function(data) {
                            $scope.formData[0][$scope.fd.FieldName] = data; 
                            $scope.fd.localVars.setupGridNew(data);                
                },function(error){    
                    MessagingService.addMessage(error.msg,'error');
                    $scope.fd.localVars.fileListDownloaded = true
                                    });
            }              
        }

         //**********************************************************
         //           GET FILES DATA DIRECT FILTER
         //**********************************************************      
        $scope.fd.localVars.getFilesData = function (file_def_id,dataset_def_id) {
                    
                    $scope.filter = {};
                    var lang = $rootScope.globals.currentUser.lang;
                    //$scope.fd.linkedResourceId = resource_id; //MIGOR - mozda je visak (je)
                    //$scope.fd.linkedResourceDefId = resource_def_id; //MIGOR - mozda je visak (je)
               if (file_def_id!=undefined)
               {
                  
                        $scope.fd.localVars.filesData.data.length=0;
                        $scope.fd.fileSelected = false;
                        $scope.fd.localVars.resourceDataDownloading = true
                        ResourcesDataService.getFilesData($scope.fd.PresentationId,file_def_id,dataset_def_id,0).then(function(data) {
                                       
                             
                                 
                            $scope.fd.localVars.filesData = data.data
                            
                            $scope.lastResourceDefId = file_def_id;
                            $scope.lastResourceId = dataset_def_id;
                            $scope.fd.localVars.fileListDownloaded = true;
                            $scope.fd.localVars.resourceDataDownloading = false
                        
                        }           
                        ,function(error){    
                             MessagingService.addMessage(error.msg,'error');    
                             $scope.fd.localVars.fileListDownloaded = true;
                             $scope.fd.localVars.resourceDataDownloading = false
                        });
                }
              
        };//getFilsData END
              
        
              
              
              $scope.fd.onSelectSearchForm= function (item, model){
               
               if ($scope.fd.Search==undefined) $scope.fd['search']={taskId:item};
               else $scope.fd.Search.taskId = item;
                //$scope.fd.Search.widgetId=0; //ovo treba na serveru dohvatiti widgetId
                
                
              } 
            if ($scope.fd.Parameters.PublishedResourceId!=undefined && $scope.fd.Parameters.PublishedResourceId!=null)

            {
             $scope.fd.localVars.getPublishedResources()

             if ($scope.fd.GridState?.columnsDef===undefined) $scope.fd.localVars.getColumnsDef()
             else 

                {
                    $scope.fd.localVars.restoreGridState()
                    $scope.fd.localVars.fileListDownloaded =true
                }

               
                                        
                                          
                                         
            }

            //ako ima odabranih dohvati ih i setupiraj
            if ($scope.formData!=undefined && $scope.formData.length>0 && !$scope.fd.Parameters.NoGetData)
            {
                if ($scope.formData[0][$scope.fd.FieldName]!=undefined){
                   if ($scope.fd.PresentationType==0)
                  {
                    $scope.fd.localVars.getFilesDirect($scope.fd.Related,[$scope.formData[0][$scope.fd.FieldName]]);
                  }
                  else
                  {
                   if  ($scope.fd.OverrideType!="f") $scope.fd.getDatasetList();
                  }
                } else if (!$scope.formDefinition && $scope.fd.MaxLength==0) $scope.fd.localVars.GetResourceDataForParent();

            }else if ($scope.fd.PresentationType==0)
            
            {
                if (!$scope.formDefinition && $scope.fd.MaxLength==0 && !$scope.fd.Parameters.NoGetData)  $scope.fd.localVars.GetResourceDataForParent();
            }
            
            if ($scope.fd.Parameters.PublishedResourceId!=undefined) {

                if ($scope.formDefinition) {
                    $scope.fd.localVars.getPublishedResources() 
                    $scope.fd.getFormFields()
                }
                else $scope.fd.localVars.getPublishedResourceById($scope.fd.Parameters.PublishedResourceId,$scope.fd.ShowSearchForm)
            
            }
          
				},//...controller
				
            templateUrl: 'ktdirectivetemplates/ktFile.html',
            link: function (scope, elem, attrs) {
				  
                scope.fd.localVars.smartTableLinked=true
          
            }
    
    }
};
'use strict';

export function ktFileUpload($timeout,WidgetDataExchangeService,ResourcesDataService,TaskDataService) {
        return {
        restrict: 'A', 
             templateUrl: 'ktdirectivetemplates/ktFileUpload.html',
             controller: function ($scope, $element,$rootScope,$uibModal,MessagingService,ProcessingService,$log,GridsterService,$timeout,$cookies,$stateParams) {

                //console.log("U kontroleru");
                $scope.gsrvc = GridsterService;
                $scope.fd.ReadOnly=false;
                $scope.animationsEnabled = true;
                $scope.showFileMetaData=false;
                $scope.taskId=$scope.resourceDefinition.ResourceDefId;
                if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
                if ($scope.taskId==undefined) $scope.taskId=0;  
                if ($scope.localVars==undefined)  $scope.localVars = {datasetMapperType:0};
                $scope.fd.files = [];              
                $scope.localVars.showProperties=function(datasetMapperType)
                {
                 
                 if ($scope.localVars.datasetMapperType==undefined)
                 {
                    $scope.localVars.datasetMapperType = datasetMapperType;
                 }else
                 {
                    if ($scope.localVars.datasetMapperType==0 || $scope.localVars.datasetMapperType!=datasetMapperType) $scope.localVars.datasetMapperType = datasetMapperType;
                    else $scope.localVars.datasetMapperType=0;
                 }
                 
                };
            
            
             $scope.localVars.okFileConnector = function () {
                $timeout(function() {
                $scope.fd.tItemValue=$scope.fd.listOfConnectors;
                $scope.localVars.showProperties(0);
                
                });
            };
            
             $scope.localVars.cancelFileConnector = function () {
                $timeout(function() {
                $scope.fd.listOfConnectors=angular.copy($scope.fd.tItemValue);
                $scope.localVars.showProperties(0);
                
                });
            };

            
		  $scope.okModal = function (windex,index) {
			$timeout(function() {$scope.showFileMetaData=false; });
		  };

		  $scope.cancelModal = function () {
			$timeout(function() {$scope.showFileMetaData=false; });
		  };
		  
       
        
		 $scope.showMetadata = function(fileIndex,fileId){ 
		 
				   var lang=$rootScope.globals.currentUser.lang;
				   var file_resource_type = "file";
				    $scope.taskId=$stateParams.id;
				   
				    //ResourcesDataService.getResourceFormextended(id resursa ,task-id, i, $scope.fd.presentationId,lang)
					
				   ResourcesDataService.getResourceForm(fileId,"i",lang).then(function(data) {
                               
                                 var sc=$scope;
                                  //$scope.gridOptions.data = data.data;
								  //$scope.fd.files[fileIndex].dashboard=[];
								  $scope.fd.files[fileIndex].dashboard=data.data;
								  //files[$index].dashboard.widgets
								  
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
						});
                            
		

			  };
     
           
			// OPEN MODAL filehelper
			 $scope.openModal = function (size,fileIndex) {
                  var modalInstance = $uibModal.open({
                  animation: $scope.animationsEnabled,
                  templateUrl: 'filehelper.html',
                  controller: 'FileModalInstanceCtrl',
                  size: size,
                  resolve: {
                    retValue: function () {
                      return {resourceId:$scope.resourceId,fileIndex:fileIndex,files:$scope.fd.files,headline:'Enter file metadata'};
                    }
                  }
            });
			
			
            modalInstance.result.then(function (retValue,windex,index) {
             // $scope.getResourceForm ();
             
         
          }, function () {
          //$log.info('Modal dismissed at: ' + new Date());
          });
       
		};
        
      
      //novi FILE CONNECTOR - UPLOADER
      $scope.localVars.openFileConnector  = function(){
             //$scope.fd.showFileConnector= !$scope.fd.showFileConnector;
            $scope.localVars.showProperties(1);
             if ($scope.localVars.datasetMapperType==1) {
                           
                 //POPUNI LISTU DATASETOVA            
                  ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
                                function(data) {
                                                  $scope.datasetList = data.data;
                                                  //dodaj ime dataseta u konektore
                                                  if ($scope.fd.listOfConnectors!=undefined) 
                                                             for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                                   //var p = $scope.datasetList.map(function(e) { return e.id; }).indexOf($scope.fd.listOfConnectors[i].parentDatasetDefId);
                                                                   var p = $scope.datasetList.map(function(e) { return e.id; }).indexOf($scope.fd.listOfConnectors[i].parentDatasetDefId);
                                                                   if (p>=0) $scope.fd.listOfConnectors[i].parentDatasetName = $scope.datasetList[p].name;  
                                                             }
                                                  
                                                  },function(error){    
                                        MessagingService.addMessage(error.msg,'error');
                                                 });
                                                 
                                                 
 							if ($scope.fd.tItemValue==undefined || $scope.fd.tItemValue[0]==null) $scope.fd.tItemValue = []; 
							// ovo je  Kt-UPLOADER
							  $scope.fd.listOfConnectors= WidgetDataExchangeService.getRegisteredWidgets();//MIGOR  - uzmi sve registrirane widgete
							  
							  //Brisi sve koji se vec nalaze u tItemValue
							   if ($scope.fd.listOfConnectors!=undefined) 
								  for (var i=0;i< $scope.fd.tItemValue.length ;i++) {
										 for (var j=0;j< $scope.fd.listOfConnectors.length;j++) {
                                              if ($scope.fd.tItemValue[i]!=null) {
                                                 if ($scope.fd.listOfConnectors[j].widgetId==$scope.fd.tItemValue[i].widgetId)  {
                                                     $scope.fd.listOfConnectors.splice(j,1);//brisi lokalni				   					    		
                                                 }
                                              }
                                         }
							    }
                                //dodaj sa servera
                                for (var i=0;i< $scope.fd.tItemValue.length ;i++) 
                                              if ($scope.fd.tItemValue[i]!=null) 
                                                  $scope.fd.listOfConnectors.push($scope.fd.tItemValue[i]);		
                                

							  //Ostavi u listi konektora samo WIDGETE koji imaju "ResourceID" jer su to data widgeti
							  var newlist=[];
                              
							    if ($scope.fd.listOfConnectors!=undefined){
                 
                                 for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                     if ($scope.fd.listOfConnectors[i].DEI!=undefined)  
                                                         for (var j=0;j< $scope.fd.listOfConnectors[i].DEI.length;j++) {
                                                             if ($scope.fd.listOfConnectors[i].DEI[j].name=='resourceLink') {
                                                                 //ako DEI nije true/false - resetiraj na false
                                                                 if ( ($scope.fd.listOfConnectors[i].DEI[j].value!=false) && ($scope.fd.listOfConnectors[i].DEI[j].value!=true) ) $scope.fd.listOfConnectors[i].DEI[j].value=false;
                                                                 //dodaj konektor u novu listu 
                                                                 newlist.push($scope.fd.listOfConnectors[i]);
                                                             };						 						  						   					      
                                                    }
                                               }
                                }//if
							  $scope.fd.listOfConnectors=newlist; //konacna lista NOVIH dataset konektora 
 
							  //return {selectedItemFromServer:$scope.fd.tItemValue,listOfConnectors: $scope.fd.listOfConnectors,headline:'Choose required interfaces',selectedFileConnector:$scope.selectedFileConnector};
						
				  
				/* interfaceModal.result.then(function (selectedItem) { 
							//$scope.fd.tItemValue=selectedItem; // //MIGOR TODO vidjet da li treba angular.copy(selectedItem);
                            $scope.fd.tItemValue=angular.copy(selectedItem); // MIGOR TODO - TEST SA ANGULAR COPY
                            
                            
							// MIGOR  TODO -
							//selektirani widget ima "resourceID" interface" -  registriramo se na njegov "event"
							
							$scope.$on('resourceId:'+selectedItem,
								function(event, data){
									console.log('resourceID uhvacen u ktUploader! data:' +  data);
							})
							
							//$scope.fd.listOfConnectors= WidgetDataExchangeService.getRegisteredInterfaces(selectedItem); 
							
							
				}*/
	
            } //if showfileconnetor  
		}; // open FILECONNECTOR - UPLOADER
                    
      
					
				 	// FUNCTION ONSELECT CALLBACK II
					$scope.onSelectCallback2 = function (item, model,fileIndex){
						var eventResultId=item.id;
						$scope.eventResultName=item.Name;
						
						 //console.log("onSelectCallback II:" +  $scope.eventResultName+ ' ' + eventResultId);

						  $scope.resourceId=eventResultId;
						  $scope.isResourceSelected=true;
						 	
								$scope.fd.filetype=$scope.resourceId; 						
					}//onSelectCallback II
				 
				 
				 
				 
					// FUNCTION - ON_SELECT_FILETYPE 
					// NAKON TO SE ZA POJEDINAÈNI FILE ODABERE FILE-TYPE  --> $scope.resourceId
					
					$scope.onSelectFileType = function (item,fileIndex){
						var selectedFileTypeId=item.id;
						$scope.resourceId=selectedFileTypeId;
						 $scope.isResourceSelected=true;
			             if ($scope.fd.files[fileIndex].fileResourceID!=selectedFileTypeId) {
			              $scope.fd.files[fileIndex].fileResourceID = selectedFileTypeId;
			              $scope.fd.files[fileIndex].formLoaded = false;
			             }
					
					
						 
						console.log("onSelectFileType :" + selectedFileTypeId);
		
						$scope.fileIndex=fileIndex;
						
								//if ($scope.fd.files[fileIndex].fileResourceID== undefined) {
								//	$scope.getResourceForm ();
								//	}
									
								//if ($scope.resourceId != undefined) {	
									//$scope.getResourceForm ();
								//}
						 		
						//$scope.fd.related=$scope.resourceId; // ovo viska??? MIGOR
						
						$scope.showMetadata(fileIndex,$scope.fd.files[fileIndex].fileResourceID );
						
						var err=$scope.testRules();
				
					}//onSelectFileType
				 
				 
				    
				var lang = $rootScope.globals.currentUser.lang;
				var type="file"; // PROMJENITI - ZASAD JE HARD-CODED !!!!! MIGOR
					 
					 
					// poziva se iz ktUploader.html
					$scope.remove = function (index) {
						
						$scope.fd.MetaData.splice(index,1);
						$scope.isOpen=true;
						var err=$scope.testRules();	
					}
					 
					 
			// POPUNI LISTU  lIST OF FILE TYPES
            ResourcesDataService.getResourceDefByType(lang,type).then(
						function(data) {
											  $scope.listOfFileTypes = data.data;
											 
							},function(error){
											 MessagingService.addMessage(error.msg,'error');
							
						});
                	            
            
	
      
     
			 },// controler_ktUploader_END
			

			//  ***************************************************  KT- UPLOADER   LINK FUNKCIJA *****************************
			require: '^form', // MIGOR  - NOVO DODAO 
			link: function (scope, elem, attrs,formCtrl) { //MIGOR NOVO
                        
                        
                                
                                //console.log("U post-link");
		  
                                //var element = elem[0].getElementsByClassName('fileElement');
                                 //scope.fd.uiUploader = uiUploader;
                                 //scope.fd.uiUploader.createUploader(scope.fd.PresentationId);
                                
                                				
                                //MIGOR TODO - prilagoditi widgetdefinition za uploader da salje i povezani related dataset
                                var out_fields = ['resourceId'];
                                var widgetDefinition = {DEI: [{'name':'resourceLinkR','value':[{name:'resourceId',value:scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'ktUploader',localWidgetId:scope.fd.LocalId,widgetId: scope.fd.PresentationId,taskId:  scope.lTaskId,resourceDefId : scope.selectedResource, output:out_fields, };
                                //var widgetDefinition = {DEI: [{'name':'resourceLinkR','value':false}],actions: [{name:'PrepareData',status:false}],name: 'ktUploader',localWidgetId:scope.fd.localId,widgetId: scope.fd.presentationId,taskId:  scope.lTaskId,resourceDefId : scope.selectedResource, output:out_fields, };
		  
                                scope.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition); //zamijeniti gdje se sve pojavljujue i staviti LOCAL TODO
                                scope.fd.LocalId=scope.localWidgetId;         
      
                               // scope.fd.uiUploader.removeAll(scope.fd.PresentationId); //MIGOR TEMP- TREBA nekako obrisati inicijalne fajlove kod reigstracija ali ovdje ne radi !!!
                                //console.log(element.files);

                      /*
                                var element = elem[0].getElementsByClassName('fileElement');
            
                                element[0].addEventListener('change', function(e) {
                
                                        $timeout(function() {
                                                var files = e.target.files;
                                                scope.fd.uiUploader.addFiles(files,scope.fd.PresentationId);				
                                                scope.fd.files =scope.fd.uiUploader.getFiles(scope.fd.PresentationId);  
                          
                                                var err=scope.testRules();
                                        });
                                });    
    	
                                */
        var fileCounter = 0;
			//scope.rules=[];
			if (scope.fd.MetaData==undefined)  scope.fd.MetaData=[];        
			scope.rules =  scope.fd.MetaData;
				
				// ADD RULE DEFINITION - poziva se iz ktUploader.html
				scope.addRuleDefinition=function(name,min,max,minTotal){
					
					if (min==undefined) min=0;			
					
					for (var i=1, l=scope.rules.length; i<l; i++) 
								if (scope.rules[i].name==name) name='';
							
					if (name!=undefined && name != '') {
						scope.rules.push({'name':name,'min':min,'max':max});
						//scope.rules.minTotal=minTotal;	
						scope.fd.Related =  scope.rules[0].fileType?.ResourceDefUid //Only first rule is considered parent/related (for now) !!
					}
					
					// POPUNI LISTU DEFINICIJA OD RESURSA  -  potential parents 
					
					 
					
				}
            
                scope.btn_remove = function(index,file) {
                                
                        //$log.info('deleting=' + file);
                        //var s=scope;
                        //var f=formCtrl;
                       // scope.fd.uiUploader.removeFile(file,scope.fd.PresentationId);
                        scope.fd.files.splice(index,1);
                        var err=scope.testRules();
                                
                };      
			

                scope.btn_clean = function() {
                   //scope.fd.uiUploader.removeAll(scope.fd.PresentationId);
                   scope.fd.files.length = 0;

                };


        scope.testRules = function(){
					
                var errMsg=null;
                for (var i=1; i < scope.rules.length; i++) { //search rules
                        var filesFound=0;
                        for(var j = 0; j < scope.fd.files.length; j++ ) {//search files
                                if (scope.fd.files[j].fileResourceID == scope.rules[i].name) filesFound=filesFound+1;
                        }
                        
                        if (filesFound < scope.rules[i].min) {formCtrl.uploaderForm.$setValidity('Not enough file types', false);
                        }	 else formCtrl.uploaderForm.$setValidity('Not enough file types', true);
                        
                        if (filesFound > scope.rules[i].max) {formCtrl.uploaderForm.$setValidity('Too many file types', false);
                                }	 else formCtrl.uploaderForm.$setValidity('Too many file types', true);
                 
                }
					
		if (scope.rules.length>0) {
                        if (scope.fd.files.length < scope.rules[0].min) formCtrl.uploaderForm.$setValidity('Minimum files needed', false); 
                        else formCtrl.uploaderForm.$setValidity('Minimum files needed', true); }
  
					//errMsg=null; // samo za test !!!     MAKNUTI KASNIJEEE !!!!     <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
                return errMsg;
					
         }//test_RULES
               
	scope.checkForChanges = function(files) {
                //scope.fd.files = files;
                scope.files = files;
        };
     	//*******************************************************************************************************
		// 											 kt-UPLOADER BTN_UPLOAD
		//*******************************************************************************************************
        scope.btn_upload = function() {
            				
        // CHECK THE RULES FIRST
		var errMsg=scope.testRules();
                errMsg=null; // samo za test !!!     MAKNUTI KASNIJEEEE !!!!     <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
					
		if (errMsg==null) {
	
        		var csrf_token = $cookies.get('csrftoken'); //'miro';//$cookieStore.get('csrftoken');
			
                        Upload.upload({
                            url: '../api/file-upload/',
                            headers: {'X-CSRFToken' : csrf_token },
                            file: scope.fd.files,
                            data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId},
                        }).then(function (resp) {
                                console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
                                file.uploadSuccess=true;
                        }, function (resp) {
                                console.log('Error status: ' + resp.status);
                                file.uploadError=true;
                                file.status=resp;
                        }, function (evt) {
                                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                                file.status='Uploading...';
                        });
                        
                        /*
        		// ZA svaki FAJL pojedinaèno !
        		scope.fd.uiUploader.startUpload(scope.fd.PresentationId,{  
				url: '../api/file-upload/', 
				headers: {'X-CSRFToken' : csrf_token },
					concurrency: 3,
					// u data napuniti podatke vezane za fajl - fileType , ID resursa
					data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId},
					onProgress: function(file) {
						$log.info(file.name + '=' + file.humanSize);
                                                $timeout(function() { file.status='Uploading...'; });
                                        },
					onCompleted: function(file, response,status) {

                                                //$log.info(file + 'response' + response);
                                                response=JSON.parse(response); //convertiram string u JSON objekt
								
						if (status==201) {// NAKON SMO USPJESNO UPLOADALI FILE , POTREBAN METADATA UPLOAD

                                                        // response.... ID fajla
                                                        // file.fileResourceID ... je file_type 
                                                        // scope.resourceData .. spremljeni meta podaci
								
                                                        $timeout(function() { file.uploadSuccess=true;  });
									

                        				//OUTPUT: data.savedResourceId .. ID meta-resursa koji je pridruen fajlu (unutar 11-ice ili 12-ice)
									
                                        		 file.resourceData={};
									
                                                        //MessagingService.addMessage("File upload successful! "+response,'success');
									
                                                        //PRIPREMA scope.resourceData  ZA UPLOAD 
                                                        if (file.dashboard!=undefined)
                                                        {
                                                                //code
                                                                var fieldId="";
                                                                var sc=scope;
                                                                          
                                                                for (var i=0;i<file.dashboard.widgets.length;i++) {//idem po gridROW
                                                                        for (var j=0;j<file.dashboard.widgets[i].layout.length;j++)
                                                                                for (var k=0;k<file.dashboard.widgets[i].layout[j].layout.length;k++)	
                                                                                {
                                                                                        fieldId='Field'+file.dashboard.widgets[i].layout[j].layout[k].itemId;
                                                                                        if (file.dashboard.widgets[i].layout[j].layout[k].dbtype=='id') {
                                                                                                fieldId=fieldId+'_id'//code
                                                                                                fieldId='id'//code
                                                                                        }
                                                                                        file.resourceData[fieldId] = file.dashboard.widgets[i].layout[j].layout[k].sItemValue	
                                                                                }
                                                                }//for
                                                                
                                                                                                                 
                                                                //  ********************************* METAUPLOAD ************************
                                        
                                                                if (file.resourceData)
                                                                {
                                                                        // ovdje je sve i update modela i insert meta pddataka - napravljena posebna DRF funkcija
                                                                        file.metaStatus='Saving metadata...'
                                                                        //	data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId},
                                                                        //ResourcesDataService.fileMetaUpload(response,file.fileResourceID,scope.fd.linkedResourceId,scope.fd.linkedResourceDefId, file.resourceData).then(
                                                                        ResourcesDataService.fileMetaUpload(response,file.fileResourceID,scope.fd.linkedResourceId,scope.fd.linkedResourceDefId, file.dashboard.widgets).then(
                                                                                                
                                                                        // service.fileMetaUpload= function (fileId,fileMetaId,resourceId,resourceDefId,fileResourceData) {
                                                                                function(data) {
                                                                                                                                                        
                                                                                // MessagingService.addMessage(data.msg,'success');
                                                                                                file.metaSuccess=true;
                                                                                                scope.showFileMetaData=false;
                                                                    
                                                                                                //$log.info('data savedresourceid:' + data.savedResourceId);
                                                                                                                                 
                                                                                },function(error){
                                                                                        //MessagingService.addMessage(error.msg,'error');
                                                                                        file.metaError=true;
                                                                                        file.metaStatus = error.msg;
                                                                                                                                                        
                                                                                                                                                                         
                                                                                });
                                                                } //IF
                                                        }
                                                        else
                                                        {
                                                                $timeout(function() {
                                                                        file.noMeta = true;
                                                                        //file.metaSuccess=true;
                                                                });
                                                        }
                                                                                                         // });
                                                        fileCounter++;
                                                        if (scope.fd.files.length == fileCounter){ //MIGOR -Ovaj se okida a onaj drugi na 123 izgleda na
                                                           $rootScope.$broadcast('InitiateTaskFilesUploaded',{'resource_id':scope.fd.linkedResourceId,'resource_def_id': scope.fd.linkedResourceDefId})
                                                        }
                                                
                                                }        
                                                else { 
                                                        //if file upload error
                                                        $timeout(function() {
                                                                file.uploadError=true;
                                                                file.status=response;
                                                        });
                                                                                                                 
                                                }
                                                                   
                                                        
                                        }//on_completed
                                }); //startUpload
                                */
		} else {
                        //scope.ac.alerts = 'Min Total!!';
			//$log.info(errMsg);
		}
        }; // FUNCTION b.n_up1oad

       
        scope.processWidgetDependencies = function() { //-----  ktUploader  -----
              
           if (scope.fd.tItemValue!=undefined) 
            for (var i=0;i< scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<scope.fd.tItemValue[i].DEI.length;j++) {
                        if ((scope.fd.tItemValue[i].DEI[j].name=='resourceLink') && (scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("uploader "+scope.fd.PresentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                                //console.log("uploader "+ scope.fd.PresentationId+" dobio event " + event.name);
                                scope.ProcessEvent(data);
                               
                                    //	data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId}
                                    
                              }) //on_END
                             var data = WidgetDataExchangeService.getDataByWidgetId(scope.resourceDefinition.task_execute_id,scope.resourceDefinition.task_initiate_id,scope.resourceDefinition.prev_task_id,linkedWidgetId,linkedItem);
                             scope.ProcessEvent(data);
                        }//if
                    }//for j
                }//if

             // else {  scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktUploader
      scope.ProcessEvent=function(data)
      {
         for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId') scope.fd.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                  if (data[k].name=='resourceId') scope.fd.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                  if (scope.fd.linkedResourceDefId>0 && scope.fd.linkedResourceId>0) scope.fd.uploadReady = true;
                                }
                          
         
         if (scope.fd.files.length>0 && scope.fd.uploadReady) scope.btn_upload();  // poziva UPLOAD - MIGOR TODO - upload treba samo ako ima fajl !!!
                                
        
      };
            
        
        	
      			
	
     	  // ne znam da li ce u ovoj link funkciji widget vec imati resource_id
          //ILJU treba dohvatit sa servera tItemValue
          
          scope.formType=scope.resourceDefinition.form_type;
          
         /* if (scope.fd.PresentationId!=undefined && scope.fd.PresentationId!=null) {
          TaskDataService.getWidgetDependencies(scope.taskId,scope.fd.PresentationId,scope.formType).then(function(data) {
                               
                                //scope.fd.tItemValue=data.data;

                                  //ovo je da trenutno radi
                               // WidgetDataExchangeService.setData(scope.fd.tItemValue);
                                //scope.processWidgetDependencies();
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                              
          } */
          
          //MIGOR - poèisti fajlove kad dobije InitateTask event
		  scope.$on('ProcessTaskWidgets',function(event, data){
           //scope.btn_clean(); // MIGOR - PRIVREMENO MAKNUO JER CE BITI VISAK KAD PRORADI OVO GORE
           if (scope.fd.files.length>0 && scope.fd.uploadReady) scope.btn_upload();
          });

		  
		  
		  //MIGOR NOVO TODO
		  scope.interfaceHandler= function (event,data) {
							scope.test=0;
				
			 // scope.fd.linkedResourceId = data.resource_id;
			   //scope.fd.linkedResourceDefId = data.resource_def_id;
			  
			   //scope.btn_upload();  
		  }
		  
                        
        
                               
       
     } //link directive 'ktUploader'
    };
};
'use strict';

export function ktFormElementProperties () {
    return {
        restrict: 'A',
        replace: true,
        template: '<div ng-include="getTemplateUrl()" class="mt-0 mr-1"></div>',
        scope: {
            fd: '=',
            localVars: '=',
            resourceDefinition:'=?',
        },
        controller: function($scope, $rootScope, TaskDefinitionService,GridsterService){
            $scope.CTRL="ktFormElementProperties"
            $scope.tds =TaskDefinitionService
            $scope.gsrvc = GridsterService
			
			
			if (!$scope.fd.localVars ) $scope.fd.localVars={}
			
            //$rootScope.massUpdateFieldList = [
			$scope.fd.localVars.massUpdateFieldList=[
                    {id:1, name: 'Required', value:'required'},
                    {id:2, name: 'Read Only', value:'readOnly'}
             ]
            
              },
        link: function (scope, element, attr) {
          
          scope.getTemplateUrl = function() {
                
                var template ="";
                if (scope.localVars==undefined) scope.localVars = {};
                if (scope.fd!==undefined)
                {
                    template = 'ktdirectivetemplates/'+scope.fd.DirectiveName+'Properties.html';// MIGOR TODO- Security check !!!
                }else
                {
                    template = 'ktdirectivetemplates/ErrorElementProperties.html';
                }
                return template;
           
            };
        }
    }
};
export function ktFormFieldGenerator () {
    return {
        
        controller:function($scope,$compile,$element){
            
             //$scope.CTRL="ktFormFieldGenerator"
             var generatedTemplate = '<div ' + $scope.fd.AngularDirectiveName + '></div>';
             $element.append($compile(generatedTemplate)($scope));
            
            },
        link: function(scope, element) {
           
        }
    };
};
'use strict';

export function ktFormlayout () {
    
        return {
            restrict: 'A',
           
          controller: ['$scope','dragulaService','$rootScope','GridsterService','$element','$compile','$templateCache',
              function($scope,dragulaService,$rootScope,GridsterService,$element,$compile,$templateCache){
                  
                $scope.gsrvc = GridsterService;    
                $scope.CTRL = "ktFormlayout";                 
                var widgetHandleResource = 'element-drag-handle';
                let template = $templateCache.get('ktdirectivetemplates/ktFormLayoutExe.html');
                
                if ($scope.resourceDefinition.form_definition)    template = $templateCache.get('ktdirectivetemplates/ktFormLayout.html');
                
                $scope.massUpdateFieldList=[
                    {id:1, Field:'ReadOnly',Label:'Read only',Component:'checkbox'},
                    {id:2, Field:'ShowField',Label:'Show field',Component:'checkbox'},
                    {id:3, Field:'Required',Label:'Required',Component:'checkbox'},
                ];
                
                var bag = dragulaService.find($rootScope, 'bag-dataset');
                if (!bag)  
                     $scope.gsrvc.setupDragula('bag-dataset','dataset-toolbox',widgetHandleResource);    
                else {
                    if ($scope.gsrvc.formViewType == 4){
                       if ($scope.gsrvc.formViewTypeCounterDs==0) $scope.gsrvc.destroyDragula('bag-dataset');
                       $scope.gsrvc.setupDragula('bag-dataset','dataset-toolbox',widgetHandleResource); 
                       $scope.gsrvc.addFormViewTypeCounterDs(1);
                    }                      
                 }

                $element.append($compile(template)($scope));  
            }],
          
            link: function (scope, elem, attrs) {
            
            
            scope.hideAnimation=false;
            
            scope.inputArray.countActive=scope.inputArray.length;
            
             scope.countActiveFn = function (){
                scope.countActive=0;
                for (var i=0;i<scope.inputArray.layout.length;i++)
                {
                   if (scope.inputArray.layout[i].Status=='Active') scope.countActive++;
                   
                   if (scope.countActive>0) break;
                    
                }
                return scope.countActive;
             };
              
            scope.removeField = function (index){
						
                if (index > -1) {
							// if (scope.inputArray.layout[index].saved==false) {
                     scope.inputArray.layout[index].Status='Deleted'; //splice(index, 1);
                     scope.inputArray.countActive--;
							// }
				}

            };       
          }
            
        };
    };
export function ktGenericPropertyGenerator () {
    return {
        restrict: 'A',
        replace: true,
        template: '<div ng-include="getTemplateUrl()" ></div>',
          scope: {
            fd: '=',
            wTemplate:'=',
          },
        controller: function($scope, $rootScope){
            $scope.CTRL="ktGenericPropertyGenerator"
            
              },
        link: function (scope, element, attr) {
          
          scope.getTemplateUrl = function() {
                
                var template ="";
               
                template = 'ktdirectivetemplates/'+scope.wTemplate
               
                return template;
           
            };
        }
    }
};
'use strict';

export function ktGrid (GridsterService,$timeout,$rootScope,dragulaService) {

        return {
            restrict: 'A',
          
			scope:{
                   allColumns: "=",
                   parent:'=',
                   gridType: '=',
                   formParams:'=',
                   formParamsParent:'=',
                   showSearchFilters:'=',
                   resourceDefinition: '=',
                   parentResourceDefId: '=',
                   resourceRecordId: '=',
                   resourceFormLoaded : '=',
                   formData : '=',  
                   hideProcessingAnimation : '=?',
                   params:'=?',
                   parentWidget:'=?',            		   
            },
            controller: ['$scope','dragulaService','$rootScope','$element','$compile','$templateCache',
          
            function($scope,dragulaService,$rootScope,$element,$compile,$templateCache){
            
                $scope.gsrvc = GridsterService;
                $scope.CTRL="ktGrid"
                var widgetHandle = $scope.gridType+'-row-drag-handle';
                
                $scope.$on("$destroy", function() {
                    //debugger
                    //dragulaService.destroy($rootScope, dragula_bag);
                    // TODO - Check is dragula is properly destroying bags (if not - manually destroy)
                });
            
                var bag = dragulaService.find($scope, 'bag-rows-'+$scope.gridType+'-'+$scope.$id);

                if (bag) {
                     dragulaService.destroy($scope, 'bag-rows-'+$scope.gridType+'-'+$scope.$id);   
                }    
                dragulaService.options($scope, 'bag-rows-'+$scope.gridType+'-'+$scope.$id, {
                  revertOnSpill: true,
                  removeOnSpill: false,
                  
                  accept:function (el,target, source) {
                      return false;
                  },
                  moves: function (el, container, handle) {
                            return handle.classList.contains(widgetHandle);
                  }
                });
				
                
                
                let template;
                if ($scope.resourceDefinition===undefined) $scope.resourceDefinition={form_definition:false}
                if ($scope.resourceDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktGrid.html');
                else template = $templateCache.get('ktdirectivetemplates/ktGridExe.html');
          
                $element.append($compile(template)($scope));
				
				$scope.myparentWidgetUid=''
				if ($scope.resourceDefinition?.parentWidgetUid) 	
						$scope.myparentWidgetUid = $scope.resourceDefinition?.parentWidgetUid
					
				if ($scope.resourceDefinition.showHidden==undefined) $scope.resourceDefinition.showHidden={}
				//$scope.resourceDefinition.showHidden[$scope.myparentResourceDefId + '-'+ $scope.resourceDefinition.uid]=false
				//debugger
				$scope.resourceDefinition.showHidden[$scope.myparentWidgetUid+ '-'+ $scope.resourceDefinition.uid]=false
						
                
            
            }],
            link: function (scope, elem, attrs) {
				
 
                scope.ShowFormView = function(viewId)
                {                
                    scope.formParams.formViewType=viewId;
                    scope.gsrvc.setFormViewType(scope.formParams.formViewType);     
                };
      
                scope.getClass = function(size)
                {
                    return "col-lg-"+size;
                };
          
                         
                scope.$watch('resourceFormLoaded',function(newValue,oldValue){   
                    if (newValue!=oldValue || newValue) {
                     scope.formLoaded = scope.resourceFormLoaded;
                    }
                });
                
                scope.$watch('formParams.showGridNavigation',function(newValue,oldValue){  
                    if (newValue!=oldValue || newValue ) {
                        if (scope.formParams!==undefined)  scope.showGridNavigation = scope.formParams.showGridNavigation;
                    }
                });
        
             } 
        }
    };
'use strict';

export function clone(obj) {  // javascript object cloning (replacement for angular.copy)
    if (obj === null || typeof (obj) !== 'object' || 'isActiveClone' in obj)
        return obj;

    if (obj instanceof Date)
        var temp = new obj.constructor(); //or new Date(obj);
    else
        var temp = obj.constructor();

    for (var key in obj) {
        if (key=='gsrvc') continue // skipping angular objects!!
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            obj['isActiveClone'] = null;
            temp[key] = clone(obj[key]);
            delete obj['isActiveClone'];
        }
    }
    return temp;
}


export function ktGridColumn () {
     //  console.log("u direktivi kt-textbox ");
        return {
            restrict: 'A',
             
             scope:{
                   inputArray : '=',
                   allColumns: "=",
                   parent: "=",
                   gridType: '=',
                   formType: '=',
                   resourceDefinition: '=', 
                   formParams:'=',
                   formParamsParent:'=',
                   showSearchFilters:'=',
                   parentResourceDefId: '=',
                   resourceRecordId: '=',
                   resourceFormLoaded : '=',
                   formData : '=',
                   index : '=',
                   params: '=?',
                   parentWidget:'=?',
      			},
                 controller: ['$scope', '$element','$rootScope','GridsterService','WidgetDataExchangeService','$timeout','dragulaService','KatalyoStateManager','$compile','$templateCache','UtilityService',
                              function ($scope, $element,$rootScope,GridsterService,WidgetDataExchangeService,$timeout,dragulaService,KatalyoStateManager,$compile,$templateCache,UtilityService) {
                        
                        //if ($scope.localVars == undefined || $scope.localVars == null) $scope.localVars={};
                        if ($scope.inputArray.localVars == undefined || $scope.inputArray.localVars == null) $scope.inputArray.localVars={};
                        $scope.CTRL='ktGridColumn'
                        $scope.ksm = KatalyoStateManager;
                        $scope.gsrvc = GridsterService;
                        //$scope.localVars.gsrvc = GridsterService;
                        //$scope.inputArray.localVars.gsrvc = GridsterService;
                        $scope.inputArray.localVars.gsrvc_changeConfirmDeleteElement =  GridsterService.changeConfirmDeleteElement
                        $scope.inputArray.localVars.gsrvc_setConfirmDeleteElement =  GridsterService.setConfirmDeleteElement
                        $scope.inputArray.localVars.gsrvc_getConfirmDeleteElement =  GridsterService.getConfirmDeleteElement
                        $scope.inputArray.localVars.gsrvc_deleteElement = GridsterService.deleteElement
                       
                        if ( $scope.inputArray.Parameters == undefined || Object.keys($scope.inputArray.Parameters || {}).length === 0 ) {
                            
                            $scope.inputArray.Parameters={ //DDEFAULT VALUES
                                SizeXMd: 24,
                                SizeXSm: 24, 
                                SizeXXs: 24
                            }
                        }
                            
                            
                       if ($scope.inputArray.Parameters.border == undefined || $scope.inputArray.Parameters.border == null )
                       {
                       
                        $scope.inputArray.Parameters.border = {
                            left: {
                                name: 'Left',
                                style:'solid',
                                width:0,
                                color:"#000000"
                            },
                            right: {
                                name: 'Right',
                                style:'solid',
                                width:0,
                                 color:"#000000"
                            } ,
                            top:{
                                name: 'Top',
                                style:'solid',
                                width:0,
                                color:"#000000"
                            },
                            bottom:{
                                name: 'Bottom',
                                style:'solid',
                                width:0,
                                color:"#000000"
                            }
                        };
                       }
                         
                           
                        if ($scope.inputArray.Parameters.margin ==  undefined ||  $scope.inputArray.Parameters.margin ==  null) {
                                $scope.inputArray.Parameters.margin= {
                                     left: {  
                                        name: 'Left Margin',
                                        value: 0,
                                        units:"px",
                                        auto: true
                                     },
                                     right: {  
                                        name: 'Right Margin',
                                        value: 0,
                                        units:"px",
                                        auto: true
                                     },
                                     top: {  
                                        name: 'Top Margin',
                                        value: 0,
                                        units:"px",
                                        auto: true
                                     },
                                     bottom: {  
                                        name: 'Bottom Margin',
                                        value: 0,
                                        units:"px",
                                        auto: true
                                     },        
                                }
                        }
                        if ($scope.inputArray.Parameters.padding ==  undefined ||  $scope.inputArray.Parameters.padding ==  null){
                                $scope.inputArray.Parameters.padding= {
                                 left: {  
                                    name: 'Left Padding',
                                    value: 0,
                                    units:"px",
                                    auto: true
                                 },
                                 right: {  
                                    name: 'Right Padding',
                                     value: 0,
                                    units:"px",
                                    auto: true
                                 },
                                 top: {  
                                    name: 'Top Padding',
                                   value: 0,
                                    units:"px",
                                    auto: true
                                 },
                                 bottom: {  
                                    name: 'Bottom Padding',
                                    value: 0,
                                    units:"px",
                                    auto: true
                                 },
                                     
                                };
                        }
                    

                
                if ($scope.inputArray.UuidRef==undefined) $scope.inputArray.UuidRef=UtilityService.uuidv4()
                $scope.inputArray.Parameters.UuidRef = $scope.inputArray.UuidRef

                let w_actions=[
                    {id:1,name:'toggleVisibility'},
                    {id:2,name:'showField'},
                    {id:3,name:'hideField'},
                ]
                 let parentWidgetUid = ''

                if ($scope.parentWidget!=undefined) parentWidgetUid = $scope.parentWidget+'-'
                var widgetDefinition = {widgetLabel: 'Column',widgetName: 'column',widgetId: parentWidgetUid+$scope.inputArray.UuidRef,fd:$scope.inputArray,actions:w_actions,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,parentResourceId:$scope.resourceDefinition.uid};
                $scope.inputArray.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
                $scope.inputArray.localVars.LocalId=$scope.inputArray.localVars.localWidgetId;
                $scope.inputArray.LocalId=$scope.inputArray.localVars.localWidgetId;
                
                let update_presentation_id = function(data)
                {
                   if (data[$scope.inputArray.LocalId]>0 && ($scope.inputArray.PresentationId==null || $scope.inputArray.PresentationId==0)) $scope.inputArray.PresentationId = data[$scope.inputArray.LocalId];
                  //unsubscribe here later after implementing unsubscribe - ToDo
                  
                }
                
                if ($scope.inputArray.PresentationId==0 || $scope.inputArray.PresentationId==null)
                {
                 
                    let resource_id = $scope.resourceDefinition.ResourceDefId;
                    if (resource_id==undefined) resource_id = $scope.resourceDefinition.ResourceDefId_id;
                    let dependent_field = $scope.inputArray.LocalId;
                    let subscribedSubject = "formDefinitionState"+resource_id+$scope.resourceDefinition.form_type;
                    let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"formSaved",update_presentation_id);
                }

    
                let columnId = $scope.gridType+'_'+$scope.resourceDefinition.ResourceDefId_id+'_'+$scope.inputArray.ElementType+'_'+$scope.parent.id+'_'+$scope.inputArray.id;
                let formChangesSubject = 'datasetFormState'+$scope.resourceDefinition.ResourceDefId_id;
                //let originalColumn = angular.copy($scope.inputArray);    
                //Add Subject to katalyo state manager (name must be unique)
                //let columnSubject = $scope.ksm.addSubject(columnId,angular.copy($scope.inputArray));
                
                //define fn for applyChange action 
                /*
                let changed_item= function(data)
                {
                
                    //scope.inputArray = data; 
                    if (!$scope.syncFromObserver)
                    {
                        columnSubject.subject.setState = angular.copy($scope.inputArray);
                        columnSubject.subject.notifyObservers();
                    }
         
                };
    
                //add action to subject rowSubject
                let action_change_column = $scope.ksm.addAction(columnSubject.subject.name,"applyChangeToColumn",changed_item);    
                */
                
        
                
                
                
                //define fn to sync to manager 
                let process_undo = function(data,action)
                {
                    if (data!==undefined)
                    {
                        let columnData = data.oldData;
                        if (data.id===columnId && action==="undoDatasetFormChange")
                        
                        {
                            $scope.parent.layout[$scope.index] = columnData;
                            $scope.ksm.executeAction(formChangesSubject,"undoDatasetFormChangeDone");    
                            $scope.syncFromObserver=true;
                        }
                    }
                };
                
                //define fn to sync to manager 
                let process_redo = function(data,action)
                {
                    if (data!==undefined)
                    {
                        let columnData = data.newData;
                        if (data.id===columnId && action==="redoDatasetFormChange")
                        
                        {
                          
                                $scope.parent.layout[$scope.index] = columnData;
                                $scope.syncFromObserver=true;
                         
                        }
                    }
                };
                
                 //create observer if change comes from someplace else (e.g. undo or from server)
                let observer_undo = $scope.ksm.subscribe(formChangesSubject,columnId,"undoDatasetFormChange",process_undo);
                 //create observer if change comes from someplace else (e.g. undo or from server)
                let observer_redo = $scope.ksm.subscribe(formChangesSubject,columnId,"redoDatasetFormChange",process_redo);
            
          //  if ($scope.formParams.formViewType!==2 && ($scope.formParamsParent.formViewType!==2 || $scope.formParamsParent===undefined))      
           // {
           
        /****************** remove bloody watchers that kill the application START ****************************************
              $scope.$watch('inputArray.layout',function(newValue,oldValue){
               
                //process object change
                if (newValue.length!==oldValue.length && !$scope.syncFromObserver)
                {
                  //$scope.ksm.executeAction(columnSubject.subject.name,'applyChangeToColumn',angular.copy(newValue));
                   $scope.ksm.executeAction(formChangesSubject,"datasetFormChanged",{'id':columnId,'source':columnId,'oldData':angular.copy(oldValue),'newData':angular.copy(newValue)});
                } else $scope.syncFromObserver=false;              
              
                });
            
                $scope.$watch('inputArray',function(newValue,oldValue){
               
                //process object change
                if (newValue.SizeX!==oldValue.SizeX && !$scope.syncFromObserver)
                {
                    //$scope.ksm.executeAction(columnSubject.subject.name,'applyChangeToColumn',angular.copy(newValue));
                    $scope.ksm.executeAction(formChangesSubject,"datasetFormChanged",{'id':columnId,'source':columnId,'oldData':angular.copy(oldValue),'newData':angular.copy(newValue)});
                } else $scope.syncFromObserver=false;              
              
                });
             
            //}
           ***************** remove bloody watchers that kill the application END ****************************************/
        
            $scope.addColumn = function (row,type)
            {
          
                  let lindex = $scope.index+type;
                  let size = $scope.inputArray.SizeX; 
                  let newColumn = GridsterService.getEmptyColumnWithId($scope.allColumns);
                  
                  newColumn.SizeX = size;
                  //let oldRow = angular.copy(row);
                  //let oldRow = clone(row);
                  row.layout.splice(lindex,0, newColumn);
                  //let newRow = clone(row);
                  //let source = $scope.gridType+'_'+$scope.resourceDefinition.ResourceDefId_id+'_'+row.ElementType+'_'+row.ContainerId+'_'+row.id;
                  //$scope.ksm.executeAction(formChangesSubject,"datasetFormChanged",{'id':source,'source':source,'oldData':oldRow,'newData':newRow });
                  $scope.gsrvc.selectedFieldParent.countActive++;
            };
              
                    
                    
                    
              if ($scope.gridType=="" || $scope.gridType==undefined) {
                    $scope.gridType="resource";
                }
                 
                  $scope.getClass = function(size)
                  {
                    
                    return "col-lg-"+size;
                    
                  };
                  
                  $scope.setpOpen = function(value)
                  {
                    $scope.pOpen=value;
                  };
                  
                  $scope.setHandle = function (type){
                        return "column-"+type+"-handle";
                 };
                 
                 
                 $scope.addRow = function (){
                        $scope.inputArray.layout.push(GridsterService.getEmptyRowWithId($scope.inputArray));
                 };
                 

              
                  
                $scope.showHideProperties = function(value)
                      {
                        $scope.gsrvc.setFieldPropertiesOpened(value);
                        $scope.showFieldProperties=$scope.gsrvc.getFieldPropertiesOpened();
             
                      };
 
               $scope.splitColumn = function (column)
               {
                
                var splitColumn = GridsterService.getNewRowForSplitColumn($scope.allRows,column);
                  $scope.parent.layout.splice($scope.parent.layout.indexOf(column),1,splitColumn);
              };
                  
                  
               $scope.remove = function (item){
                   //debugger
						
                   if (item.layout.length==0) {
                          if ($scope.parent==undefined){
                            $scope.allColumns.splice($scope.allColumns.indexOf(item), 1);
                          } else    {
                            $scope.parent.layout.splice($scope.parent.layout.indexOf(item), 1);   
                          }
                       }
                       
                };
                
                const subjectCol= $scope.resourceDefinition.page_state_id+"-"+$scope.inputArray.UuidRef

                let valueState= $scope.ksm.addSubject(subjectCol,null);
                const valueStateName = valueState.subject.name;
        
                let show_field = function(data)
                {
                    $scope.inputArray.ShowField = true
                    let state = data
                    state['val'] = true
                    valueState.subject.setStateChanges = state
                    valueState.subject.notifyObservers("showField",state)
                }
                let hide_field = function(data)
                {
                    $scope.inputArray.ShowField = false
                    let state = data
                    state['val'] = true
                    valueState.subject.setStateChanges = state
                    valueState.subject.notifyObservers("hideField",state)
                }

                let toggle_visibility = function(data)
                {
                    $scope.inputArray.ShowField = !$scope.inputArray.ShowField
                    let state = data
                    state['val'] =  $scope.inputArray.ShowField
                    valueState.subject.setStateChanges = state
                    valueState.subject.notifyObservers("toggleVisibility",data)     
                }

                let action_show = $scope.ksm.addAction(valueStateName,"showField",show_field);
                let action_hide = $scope.ksm.addAction(valueStateName,"hideField",hide_field);
                let action_toggle = $scope.ksm.addAction(valueStateName,"toggleVisibility",toggle_visibility);
                
                
                // ng-click="fd.localVars.gsrvc.setConfirmDeleteElement(false);  localVars.gsrvc.deleteElement(fd)">
                $scope.inputArray.localVars.confirmAndDeleteElement = function (yesno , fdvalue) // delete Column
                {
                    //debugger
                    $scope.inputArray.localVars.gsrvc_setConfirmDeleteElement(yesno)
                    $scope.inputArray.localVars.gsrvc_deleteElement(fdvalue)
                }     
                
                
 
                $scope.deleteElement = function (index) // delete Column - not used ??
                {
                    debugger
                    $scope.inputArray.localVars.gsrvc.deleteElement($scope.inputArray)
                }     
                
                 $scope.inputArray.select = function(selected)
                 {
                     $scope.inputArray.selected=selected;
                 }
                    
                  $scope.inputArray.selectBorder = function(selected)
                  {
                      $scope.inputArray.selectedBorder=selected;
                  }
                    
                let template;
                if ($scope.resourceDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktGridColumn.html');
                else template = $templateCache.get('ktdirectivetemplates/ktGridColumnExe.html');
          
                $element.append($compile(template)($scope)); 
                         
                }],
                
                
             link: function (scope, elem, attrs) {
                       
             
        }
    }
};
'use strict';

export function ktGridRow () {
        return {
            restrict: 'A',
              scope:{
                   row : '=',
                   allRows: "=",
                   parent: "=",
                   gridType: '=',
                   formType: '=',
                   resourceDefinition: '=', 
                   formParams:'=',
                   formParamsParent:'=',
                   showSearchFilters:'=',
                   parentResourceDefId: '=',
                   resourceRecordId: '=',
                   resourceFormLoaded : '=',
                   formData : '=',  
                   params:'=?',
                   parentWidget:'=?',   
      			},
                
             controller: ['$scope','GridsterService','WidgetDataExchangeService','$timeout','dragulaService','$rootScope','KatalyoStateManager','$compile','$element','$templateCache',
                          function($scope,GridsterService,WidgetDataExchangeService,$timeout,dragulaService,$rootScope,KatalyoStateManager,$compile,$element,$templateCache)
                {
                $scope.CTRL = 'ktGridRow';
                $scope.gsrvc = GridsterService;
                $scope.row.localVars = {}
                $scope.row.localVars.gsrvc = () => GridsterService
                $scope.ksm = KatalyoStateManager;
                
                //let originalRow = angular.copy($scope.row); // TODO - Zasto je ovo tu ako se ne koristi??? MIGOR
                let rowId = $scope.gridType+'_'+$scope.resourceDefinition.ResourceDefId_id+'_'+$scope.row.ElementType+'_'+$scope.row.ContainerId+'_'+$scope.row.id;
                let formChangesSubject = 'datasetFormState'+$scope.resourceDefinition.ResourceDefId_id;
                
                var widgetDefinition = {name: 'row',widgetId: $scope.row.PresentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId};
                $scope.row.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
                $scope.row.LocalId=$scope.row.localWidgetId;
                
                  $scope.$on("$destroy", function() {
                    //debugger
                    //dragulaService.destroy($rootScope, dragula_bag);
                    // TODO - Check is dragula is properly destroying bags (if not - manually destroy)
                });
             
               
                /**********************************************************************
                 ****************** Sync data with State manager **********************
                 ***********************************************************************/
                let dependent_field_pid = $scope.row.LocalId;
                let resource_id = $scope.resourceDefinition.ResourceDefId
                let subscribedSubjectPid = "formDefinitionState"+resource_id+$scope.resourceDefinition.form_type;
                let dependent_field_pid2
                
                
                let update_presentation_id2 = function(data) 
                {
                    let presentation_id = angular.copy($scope.row.PresentationId)
                    if (data[presentation_id]!==undefined)
                    {
                        $scope.row.PresentationId = data[presentation_id];
                    //unsubscribe here later after implementing unsubscribe - ToDo
                    dependent_field_pid2 = $scope.row.PresentationId
                    let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
                    }
                }
                
                let update_presentation_id = function(data) 
                {
                    if (data[$scope.row.LocalId]>0 && $scope.row.PresentationId==0 && data[$scope.row.LocalId]!==undefined) $scope.row.PresentationId = data[$scope.row.LocalId];    
                    let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
                    //unsubscribe here later after implementing unsubscribe - ToDo
                }
                
                
                if ($scope.row.PresentationId===null || $scope.row.PresentationId===0)  {
                    let observerPid = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid,"formSaved",update_presentation_id);
                } else{
                    dependent_field_pid2 = $scope.row.PresentationId
                    let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
                }
        

                $scope.isFormViewTypeEqual = function(what) {
                        let gsrvcType= $scope.gsrvc.getFormViewType()  
                        if ( gsrvcType == what) return true;
                        return false;        
                }
                
                
                
                $scope.oldprintRow = function(pid) {// STILL USED !!!
                                  
                        let x=document.getElementById('row'+pid)
                        x.classList.add("printme");
                        
                        var doc = document.implementation.createHTMLDocument('My title');  
                        doc.head.innerHTML+='  <link rel="stylesheet" type="text/css" href="/static/modules/styles/build/css/master.css" /> '                   
                        doc.head.innerHTML+=' <link rel="stylesheet" type="text/css" href="/static/modules/styles/build/css/main.css" />'
                        doc.body.innerHTML+='<div id="content">TEST</div>'

                        var strWindowFeatures = "location=yes,height=570,width=520,scrollbars=yes,status=yes";
                        var win = window.open("", "_blank", strWindowFeatures);
                        
                        //win.document.open();
                        //win.document.write('<!DOCTYPE html> <html><head> <style> @page { size: auto !important;} </style> <link rel="stylesheet" type="text/css" href="/static/modules/styles/build/css/master.css" />   <link rel="stylesheet" type="text/css" href="/static/modules/styles/build/css/main.css" />   </head><body><div id="content"></div></body>  </html> ');
                        //win.document.close();
                       
                        var loadingscreen = document.getElementById('loadingscreen')
                        if (loadingscreen) loadingscreen.parentNode.removeChild(loadingscreen); 
                        
                        var gridloading= document.getElementById('gridloading')   
                        if (gridloading) gridloading.parentNode.removeChild(gridloading);   
                         
                        var printContents = document.getElementById('row'+pid)
                        //var com = $compile(printContents)($scope);
                        
                        htmlTree(printContents)                           
                        win.document.body.innerHTML = printContents.innerHTML;

                        $timeout(function() {    
//                        win.print();     
  }); 
                      
                }

                $scope.printRow = function(pid) {
                                  
                        let x=document.getElementById('row'+pid)
                        x.classList.add("printme");
                        
                        var doc = document.implementation.createHTMLDocument('My title');  
                        doc.head.innerHTML+='  <link rel="stylesheet" type="text/css" href="/static/modules/styles/build/css/master.css" /> '                   
                        doc.head.innerHTML+=' <link rel="stylesheet" type="text/css" href="/static/modules/styles/build/css/main.css" />'
                        doc.body.innerHTML+='<div id="content">TEST</div>'

                        //var URL = "https://localhost:8080;url=" + location.href;
                        var strWindowFeatures = "location=yes,height=570,width=520,scrollbars=yes,status=yes";
                        //var win = window.open("", "_blank", strWindowFeatures);
                        
                       // win.document.open();
                        //win.document.write('<!DOCTYPE html> <html><head> <style> @page { size: auto !important;} </style> <link rel="stylesheet" type="text/css" href="/static/modules/styles/build/css/master.css" />   <link rel="stylesheet" type="text/css" href="/static/modules/styles/build/css/main.css" />   </head><body><div id="content"></div></body>  </html> ');
                        //win.document.close();
                       
                        var loadingscreen = document.getElementById('loadingscreen')
                        if (loadingscreen) loadingscreen.parentNode.removeChild(loadingscreen); 
                        
                        var gridloading= document.getElementById('gridloading')   
                        if (gridloading) gridloading.parentNode.removeChild(gridloading);   
                         
                        //var printContents = document.getElementById('row'+pid)
                           
                        //var com = $compile(printContents)($scope);
                        //win.document.body.innerHTML = com[0].innerHTML      
                        //win.document.body.innerHTML = printContents.innerHTML;
                        $timeout(function() {        window.print();            }); 
                                   
                       // win.document = document.getElementById('row'+pid).cloneNode(true);
        
                }
                
                //define fn to sync to manager 
                let process_undo = function(data,action)  
                {
                    if (data!==undefined) {
                        let rowData = data.oldData;
                        if (data.id===rowId && action==="undoDatasetFormChange")    {
                            $scope.row = rowData;
                            $scope.ksm.executeAction(formChangesSubject,"undoDatasetFormChangeDone");    
                            $scope.syncFromObserver=true;
                        }
                    }
                };
                
                //define fn to sync to manager 
                let process_redo = function(data,action) 
                {
                    if (data!==undefined)  {
                        let rowData = data.newData;
                        if (data.id===rowId && action==="redoDatasetFormChange") {
                                $scope.row = rowData;
                                $scope.syncFromObserver=true;
                        }
                    }
                };
                
                 //create observer if change comes from someplace else (e.g. undo or from server)
                let observer_undo = $scope.ksm.subscribe(formChangesSubject,rowId,"undoDatasetFormChange",process_undo);
                 //create observer if change comes from someplace else (e.g. undo or from server)
                let observer_redo = $scope.ksm.subscribe(formChangesSubject,rowId,"redoDatasetFormChange",process_redo);
                
                $scope.addColumn = function (row){
                    row.layout.push($scope.gsrvc.getEmptyColumnWithId($scope.parent.layout));  
                };
                $scope.addRowAbove = function (row){
                    $scope.parent.layout.splice($scope.parent.layout.indexOf(row),0, GridsterService.getEmptyRowWithId($scope.allRows));
                };
              
                $scope.addRowBelow = function (row){
                    $scope.parent.layout.splice($scope.parent.layout.indexOf(row)+1,0, GridsterService.getEmptyRowWithId($scope.allRows));
                };
                $scope.getClass = function(size) {     
                    return "col-lg-"+size;     
                };
              
                $scope.getHandle = function(){
                    return "row-"+$scope.gridType+"-handle";     
                };
              
                $scope.setHandle = function (type){
                        return type+"-handle";
                };
                if ($scope.row.Parameters==undefined) $scope.row.Parameters={};
                if ($scope.row.Parameters.BackgroundOpacity==null || $scope.row.Parameters.BackgroundOpacity==undefined ) $scope.row.Parameters.BackgroundOpacity=1;
                
                
                $scope.row.BackRepeatChanged = function (){       
                        if ($scope.row.Parameters.RepeatBackImg) $scope.row.Parameters.RepeatBackText = 'repeat';
                        else $scope.row.Parameters.RepeatBackText = 'no-repeat';
                };
                 
				 
				 /*
                $scope.$watch('row',function(newValue,oldValue){
               
                    if (newValue!==oldValue && !$scope.syncFromObserver)   {
                         $scope.ksm.executeAction(formChangesSubject,"addDatasetFormChange",{'id':rowId,'data':angular.copy(oldValue)});
                    } else $scope.syncFromObserver=false;              
              
                });*/
                
            
            var widgetHandle = $scope.setHandle($scope.gridType+'-column-drag');
            
            var bag = dragulaService.find($scope, 'bag-columns-'+$scope.gridType);
             
            if (bag) {
                dragulaService.destroy($scope, 'bag-columns-'+$scope.gridType);
            }
            dragulaService.options($scope, 'bag-columns-'+$scope.gridType, {
                    revertOnSpill: true,
                    removeOnSpill: false,
                    direction:'vertical',
                    accept:function (el,target, source) {
                              return false;
                    },
                    moves: function (el, container, handle) {
                              return handle.classList.contains(widgetHandle);
                    }
             });

             $scope.row.downloadImage = function(fileDefId,fileId){
                ResourcesDataService.downloadFile(fileDefId,fileId).then(function(data) {
                               
                                   
                                    var url = URL.createObjectURL(new Blob([data.data]));
                                    $scope.row.Parameters.BackgroundImageUrl=url
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
            };// dowload image END

            if ($scope.row.Parameters.FileDefId?.id>0 && $scope.row.Parameters.FileId>0) $scope.row.downloadImage($scope.row.Parameters.FileDefId?.id,$scope.row.Parameters.FileId);

                
            let template;
            if ($scope.resourceDefinition.form_definition)    {
                template = $templateCache.get('ktdirectivetemplates/ktGridRow.html');
            }
                else template = $templateCache.get('ktdirectivetemplates/ktGridRowExe.html');
          
            $element.append($compile(template)($scope));  
                 
            }],
             
             link: function (scope, elem, attrs) {
              

          //  if (scope.formParams.formViewType!==2 && (scope.formParamsParent.formViewType!==2 || scope.formParamsParent===undefined))           
          //  {
          
          /*
                scope.$watch('row.layout',function(newValue,oldValue){
               
                  //process object change
                  if (newValue.length!==oldValue.length && !scope.syncFromObserver)
                  {
                    scope.ksm.executeAction(formChangesSubject,"addDatasetFormChange",{'id':rowId,'data':angular.copy(oldValue)});
                  } else scope.syncFromObserver=false;              
              
                },true);
            */
             
            }
        };
    };
    
    
    
export   function    htmlTree (obj){
        var obj = obj || document.getElementsByTagName('body')[0];
        var str=""
        
        
        if (obj.tagName == 'INPUT')  {
            if (obj.value) obj.setAttribute("value", obj.value); 
           // output.push(obj);
            }
        if (obj.hasChildNodes()) {
          var child = obj.firstChild;
          while (child) {
            if (child.nodeType === 1 && child.nodeName != 'SCRIPT'){
              str += htmlTree(child) + ".";
            }
            child = child.nextSibling;
          }
        }
        
        if (obj.classList.contains('noprint' )) 
        {  
        obj.remove()
        }
        return "";
      }
'use strict';

export function ktGroup () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktGroup.html',
             controller:function($scope,UserService,$rootScope,GridsterService){
                 
                 $scope.gsrvc = GridsterService;
           if ($scope.localVars==undefined) $scope.localVars={};
              //MIGOR START
              $scope.search=[
                      {id:1,filter:'onlist',name:"On list:",icon:"fa fa-chevron-right"},
                      {id:2,filter:'notonlist',name:"Not on list:",icon:"fa fa-expand"},
                ];
				
               if ($scope.fd!=undefined) {
                  if ($scope.fd.search==undefined)
                  {
                    $scope.fd.search=$scope.search[0]; //MIGOR TODO - greska kod incijacije za multiple , mozda treba kod promjene na multiple ovo jos jednom okinuti
                  }
               } 

			  $scope.applyListFilters = function(index) {
                   
				   $scope.fd.search=$scope.search[index];
                   if( typeof $scope.formData[0][$scope.fd.FieldName] === 'string' ) {
                        //$scope.fd.search.value = [ $scope.fd.sItemValue ];
                        $scope.fd.search.value = [ {'id':$scope.formData[0][$scope.fd.FieldName]} ];
                    }
                   //if ($scope.fd.search.name=="Equals") $scope.fd.search=null;
				   $scope.isOpen=false;		
			  	};
                
                //MIGOR END
                
             $scope.showProperties = function(event)
            {
                  $scope.gsrvc.setFieldProperties($scope.fd,event);
            };    
			
			if ($scope.fd.localVars==undefined)  $scope.fd.localVars={}

            $scope.groupItem = {selectedGroup : null};
          
             $scope.populateGroup = function (item,model) {              
           
                  $scope.selectedGroup = item;
                  $scope.fd.codeId = item.id;
                  $scope.formData[0][$scope.fd.FieldName]=item.id;
             
               $scope.fd.search.value = [ {'id':$scope.formData[0][$scope.fd.FieldName]} ]; //MIGOR TODO - vidjeti da li ovjde siTemValue ( provjeriti i ostale sluèajeve u onselect funkciji)

    				};

              
            $scope.getGroups = function () {
              UserService.getUsersGroups('groups').then(function(data){
              
              $scope.groupList = data.data;
              
              if ($scope.formData!=undefined && $scope.formData.length>0)
              {
                    if ($scope.formData[0][$scope.fd.FieldName]!=null) {
                         UserService.getGroupObjectById($scope.formData[0][$scope.fd.FieldName]).then(function(data){
                            $scope.selectedGroup = data;
                            $scope.groupItem.selectedGroup=$scope.selectedGroup;
                           
                          });
                       
                         
                      }
                     else if ($scope.formData[0][$scope.fd.FieldName]!=null) {
                     
                      if ($scope.formData[0][$scope.fd.FieldName].length>0)
                      {
                        if ($scope.formData[0][$scope.fd.FieldName][0]!=undefined)
                        {
                         UserService.getGroupObjectById($scope.formData[0][$scope.fd.FieldName][0]).then(function(data){
                            $scope.selectedGroup = data;
                            $scope.groupItem.selectedGroup=$scope.selectedGroup;
                            $scope.formData[0][$scope.fd.FieldName]=$scope.selectedGroup.id;
                          });
                      }
                         
                      }
                     }
              }
    				});
          
          }
          
          
          $scope.$watch('groupItem.selectedGroup', function(newValue,oldValue){
                    //debugger
                    if ($scope.formData && newValue)  $scope.formData[0][$scope.fd.FieldName]=newValue.id;
                });
           $scope.clear = function(event,select)
        {
          $scope.formData[0][$scope.fd.FieldName] = null;
          $scope.fd.search.value = null;
          $scope.groupItem.selectedGroup = null;
        }
        
  				$scope.getGroups();
          
         
                
                },
             link: function (scope, elem, attrs) {
          
          
          
          
        
          
              }
        }
  
};
'use strict';

export function ktHeader () {
        return {
            restrict: 'A',
			 controller: function ($scope) {},
             templateUrl: 'ktdirectivetemplates/ktHeader.html',
             controller:function($scope,KatalyoStateManager,WidgetDataExchangeService,UtilityService)
             {  
                
                if ($scope.fd.localVars===undefined) $scope.fd.localVars={}
                var widgetDefinition = {name: 'header',widgetId: $scope.fd.PresentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId};
                $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
                $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
				if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
					
                if ($scope.fd.localVars == undefined ) 
                $scope.fd.localVars = {showMenu: false }
                
                $scope.fd.localVars.PropertyElements=['ktFieldBorderProperty.html']
               

                 $scope.fd.localVars.taskId=$scope.resourceDefinition.ResourceDefId;
                if ($scope.fd.localVars.taskId==undefined)  $scope.fd.localVars.taskId=$scope.resourceDefinition.ResourceDefId_id;
                if ($scope.fd.localVars.taskId==undefined) $scope.fd.localVars.taskId=0;
        

                $scope.fd.localVars.toggleDropdown = function(){
                           $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
                }
        
        
                $scope.ksm = KatalyoStateManager;
                        let update_presentation_id = function(data)
                        {
                           if (data[$scope.fd.LocalId]>0 && ($scope.fd.PresentationId==null || $scope.fd.PresentationId==0)) $scope.fd.PresentationId = data[$scope.fd.LocalId];
                          //unsubscribe here later after implementing unsubscribe - ToDo
                          
                        }
                        if ($scope.fd.PresentationId==0 || $scope.fd.PresentationId==null)
                        {
                         
                            let dependent_field = $scope.fd.LocalId;
                            let subscribedSubject = "formDefinitionState"+$scope.fd.localVars.taskId+$scope.resourceDefinition.form_type;
                            let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"formSaved",update_presentation_id);
                  
                        }


                },
             link: function (scope, elem, attrs) {
              
                if (scope.fd==undefined) scope.fd={};

                if (scope.fd.Parameters==undefined) scope.fd.Parameters={};
                if (scope.fd.Parameters.BackgroundOpacity==null || scope.fd.Parameters.BackgroundOpacity==undefined ) scope.fd.Parameters.BackgroundOpacity=1;



            }
        };
};
'use strict';

export function ktHelpCenter (KatalyoStateManager,SettingsService,MessagingService) {
        return {
            restrict: 'A',
             scope:{
                   helpId : '=',
                   position : '=?',
                  
                },
			 controller: function ($scope) {},
             templateUrl: 'ktdirectivetemplates/ktHelpCenter.html',
             
             link: function (scope, elem, attrs) {
                scope.showHelp = false
                scope.ksm = KatalyoStateManager;
                if (!scope.position) scope.position='fixed'
               
                //get page by helpId
                SettingsService.getHelpPage(scope.helpId).then(function(data) {
                             
                             scope.pageId = data?.data?.pageid
                             scope.pVer = data?.data?.pagev
                             scope.pageEnvId = data?.data?.envid
                             scope.exeUserId = data?.data?.exeuser
                             scope.pageMaxWidth = data?.data?.maxwidth
                             scope.statusCode=data.status
                                
                        },function(error){
                            scope.statusCode = error.status

                            if (scope.statusCode!=404) MessagingService.addMessage(error.msg,'error')
                });
                
                scope.showHideHelp = function(show){
                    if (!scope.firstClick) scope.firstClick=true
                    scope.showHelp = show
                }
            }
        };
};
'use strict';

export function ktIconPicker ($timeout) {
        return {
            restrict: 'A',
             controller: function($scope){  
                 $scope.allButtons=['btn-primary','btn-light','btn-dark','btn-success','btn-danger','btn-info','btn-warning','btn-outline-primary','btn-outline-light','btn-outline-dark','btn-outline-success','btn-outline-danger','btn-outline-info','btn-outline-warning','btn-link'];
                 $scope.icons =  [{"full": "fab fa-500px","shorty": "500px"},{"full": "fab fa-accessible-icon","shorty": "accessible-icon"},{"full": "fab fa-accusoft","shorty": "accusoft"},{"full": "fab fa-adn","shorty": "adn"},{"full": "fab fa-adversal","shorty": "adversal"},{"full": "fab fa-affiliatetheme","shorty": "affiliatetheme"},{"full": "fab fa-algolia","shorty": "algolia"},{"full": "fab fa-alipay","shorty": "alipay"},{"full": "fab fa-amazon","shorty": "amazon"},{"full": "fab fa-amazon-pay","shorty": "amazon-pay"},{"full": "fab fa-amilia","shorty": "amilia"},{"full": "fab fa-android","shorty": "android"},{"full": "fab fa-angellist","shorty": "angellist"},{"full": "fab fa-angrycreative","shorty": "angrycreative"},{"full": "fab fa-angular","shorty": "angular"},{"full": "fab fa-app-store","shorty": "app-store"},{"full": "fab fa-app-store-ios","shorty": "app-store-ios"},{"full": "fab fa-apper","shorty": "apper"},{"full": "fab fa-apple","shorty": "apple"},{"full": "fab fa-apple-pay","shorty": "apple-pay"},{"full": "fab fa-asymmetrik","shorty": "asymmetrik"},{"full": "fab fa-audible","shorty": "audible"},{"full": "fab fa-autoprefixer","shorty": "autoprefixer"},{"full": "fab fa-avianex","shorty": "avianex"},{"full": "fab fa-aviato","shorty": "aviato"},{"full": "fab fa-aws","shorty": "aws"},{"full": "fab fa-bandcamp","shorty": "bandcamp"},{"full": "fab fa-behance","shorty": "behance"},{"full": "fab fa-behance-square","shorty": "behance-square"},{"full": "fab fa-bimobject","shorty": "bimobject"},{"full": "fab fa-bitbucket","shorty": "bitbucket"},{"full": "fab fa-bitcoin","shorty": "bitcoin"},{"full": "fab fa-bity","shorty": "bity"},{"full": "fab fa-black-tie","shorty": "black-tie"},{"full": "fab fa-blackberry","shorty": "blackberry"},{"full": "fab fa-blogger","shorty": "blogger"},{"full": "fab fa-blogger-b","shorty": "blogger-b"},{"full": "fab fa-bluetooth","shorty": "bluetooth"},{"full": "fab fa-bluetooth-b","shorty": "bluetooth-b"},{"full": "fab fa-btc","shorty": "btc"},{"full": "fab fa-buromobelexperte","shorty": "buromobelexperte"},{"full": "fab fa-buysellads","shorty": "buysellads"},{"full": "fab fa-cc-amazon-pay","shorty": "cc-amazon-pay"},{"full": "fab fa-cc-amex","shorty": "cc-amex"},{"full": "fab fa-cc-apple-pay","shorty": "cc-apple-pay"},{"full": "fab fa-cc-diners-club","shorty": "cc-diners-club"},{"full": "fab fa-cc-discover","shorty": "cc-discover"},{"full": "fab fa-cc-jcb","shorty": "cc-jcb"},{"full": "fab fa-cc-mastercard","shorty": "cc-mastercard"},{"full": "fab fa-cc-paypal","shorty": "cc-paypal"},{"full": "fab fa-cc-stripe","shorty": "cc-stripe"},{"full": "fab fa-cc-visa","shorty": "cc-visa"},{"full": "fab fa-centercode","shorty": "centercode"},{"full": "fab fa-chrome","shorty": "chrome"},{"full": "fab fa-cloudscale","shorty": "cloudscale"},{"full": "fab fa-cloudsmith","shorty": "cloudsmith"},{"full": "fab fa-cloudversify","shorty": "cloudversify"},{"full": "fab fa-codepen","shorty": "codepen"},{"full": "fab fa-codiepie","shorty": "codiepie"},{"full": "fab fa-connectdevelop","shorty": "connectdevelop"},{"full": "fab fa-contao","shorty": "contao"},{"full": "fab fa-cpanel","shorty": "cpanel"},{"full": "fab fa-creative-commons","shorty": "creative-commons"},{"full": "fab fa-creative-commons-by","shorty": "creative-commons-by"},{"full": "fab fa-creative-commons-nc","shorty": "creative-commons-nc"},{"full": "fab fa-creative-commons-nc-eu","shorty": "creative-commons-nc-eu"},{"full": "fab fa-creative-commons-nc-jp","shorty": "creative-commons-nc-jp"},{"full": "fab fa-creative-commons-nd","shorty": "creative-commons-nd"},{"full": "fab fa-creative-commons-pd","shorty": "creative-commons-pd"},{"full": "fab fa-creative-commons-pd-alt","shorty": "creative-commons-pd-alt"},{"full": "fab fa-creative-commons-remix","shorty": "creative-commons-remix"},{"full": "fab fa-creative-commons-sa","shorty": "creative-commons-sa"},{"full": "fab fa-creative-commons-sampling","shorty": "creative-commons-sampling"},{"full": "fab fa-creative-commons-sampling-plus","shorty": "creative-commons-sampling-plus"},{"full": "fab fa-creative-commons-share","shorty": "creative-commons-share"},{"full": "fab fa-css3","shorty": "css3"},{"full": "fab fa-css3-alt","shorty": "css3-alt"},{"full": "fab fa-cuttlefish","shorty": "cuttlefish"},{"full": "fab fa-d-and-d","shorty": "d-and-d"},{"full": "fab fa-dashcube","shorty": "dashcube"},{"full": "fab fa-delicious","shorty": "delicious"},{"full": "fab fa-deploydog","shorty": "deploydog"},{"full": "fab fa-deskpro","shorty": "deskpro"},{"full": "fab fa-deviantart","shorty": "deviantart"},{"full": "fab fa-digg","shorty": "digg"},{"full": "fab fa-digital-ocean","shorty": "digital-ocean"},{"full": "fab fa-discord","shorty": "discord"},{"full": "fab fa-discourse","shorty": "discourse"},{"full": "fab fa-dochub","shorty": "dochub"},{"full": "fab fa-docker","shorty": "docker"},{"full": "fab fa-draft2digital","shorty": "draft2digital"},{"full": "fab fa-dribbble","shorty": "dribbble"},{"full": "fab fa-dribbble-square","shorty": "dribbble-square"},{"full": "fab fa-dropbox","shorty": "dropbox"},{"full": "fab fa-drupal","shorty": "drupal"},{"full": "fab fa-dyalog","shorty": "dyalog"},{"full": "fab fa-earlybirds","shorty": "earlybirds"},{"full": "fab fa-ebay","shorty": "ebay"},{"full": "fab fa-edge","shorty": "edge"},{"full": "fab fa-elementor","shorty": "elementor"},{"full": "fab fa-ello","shorty": "ello"},{"full": "fab fa-ember","shorty": "ember"},{"full": "fab fa-empire","shorty": "empire"},{"full": "fab fa-envira","shorty": "envira"},{"full": "fab fa-erlang","shorty": "erlang"},{"full": "fab fa-ethereum","shorty": "ethereum"},{"full": "fab fa-etsy","shorty": "etsy"},{"full": "fab fa-expeditedssl","shorty": "expeditedssl"},{"full": "fab fa-facebook","shorty": "facebook"},{"full": "fab fa-facebook-f","shorty": "facebook-f"},{"full": "fab fa-facebook-messenger","shorty": "facebook-messenger"},{"full": "fab fa-facebook-square","shorty": "facebook-square"},{"full": "fab fa-firefox","shorty": "firefox"},{"full": "fab fa-first-order","shorty": "first-order"},{"full": "fab fa-first-order-alt","shorty": "first-order-alt"},{"full": "fab fa-firstdraft","shorty": "firstdraft"},{"full": "fab fa-flickr","shorty": "flickr"},{"full": "fab fa-flipboard","shorty": "flipboard"},{"full": "fab fa-fly","shorty": "fly"},{"full": "fab fa-font-awesome","shorty": "font-awesome"},{"full": "fab fa-font-awesome-alt","shorty": "font-awesome-alt"},{"full": "fab fa-font-awesome-flag","shorty": "font-awesome-flag"},{"full": "fab fa-fonticons","shorty": "fonticons"},{"full": "fab fa-fonticons-fi","shorty": "fonticons-fi"},{"full": "fab fa-fort-awesome","shorty": "fort-awesome"},{"full": "fab fa-fort-awesome-alt","shorty": "fort-awesome-alt"},{"full": "fab fa-forumbee","shorty": "forumbee"},{"full": "fab fa-foursquare","shorty": "foursquare"},{"full": "fab fa-free-code-camp","shorty": "free-code-camp"},{"full": "fab fa-freebsd","shorty": "freebsd"},{"full": "fab fa-fulcrum","shorty": "fulcrum"},{"full": "fab fa-galactic-republic","shorty": "galactic-republic"},{"full": "fab fa-galactic-senate","shorty": "galactic-senate"},{"full": "fab fa-get-pocket","shorty": "get-pocket"},{"full": "fab fa-gg","shorty": "gg"},{"full": "fab fa-gg-circle","shorty": "gg-circle"},{"full": "fab fa-git","shorty": "git"},{"full": "fab fa-git-square","shorty": "git-square"},{"full": "fab fa-github","shorty": "github"},{"full": "fab fa-github-alt","shorty": "github-alt"},{"full": "fab fa-github-square","shorty": "github-square"},{"full": "fab fa-gitkraken","shorty": "gitkraken"},{"full": "fab fa-gitlab","shorty": "gitlab"},{"full": "fab fa-gitter","shorty": "gitter"},{"full": "fab fa-glide","shorty": "glide"},{"full": "fab fa-glide-g","shorty": "glide-g"},{"full": "fab fa-gofore","shorty": "gofore"},{"full": "fab fa-goodreads","shorty": "goodreads"},{"full": "fab fa-goodreads-g","shorty": "goodreads-g"},{"full": "fab fa-google","shorty": "google"},{"full": "fab fa-google-drive","shorty": "google-drive"},{"full": "fab fa-google-play","shorty": "google-play"},{"full": "fab fa-google-plus","shorty": "google-plus"},{"full": "fab fa-google-plus-g","shorty": "google-plus-g"},{"full": "fab fa-google-plus-square","shorty": "google-plus-square"},{"full": "fab fa-google-wallet","shorty": "google-wallet"},{"full": "fab fa-gratipay","shorty": "gratipay"},{"full": "fab fa-grav","shorty": "grav"},{"full": "fab fa-gripfire","shorty": "gripfire"},{"full": "fab fa-grunt","shorty": "grunt"},{"full": "fab fa-gulp","shorty": "gulp"},{"full": "fab fa-hacker-news","shorty": "hacker-news"},{"full": "fab fa-hacker-news-square","shorty": "hacker-news-square"},{"full": "fab fa-hackerrank","shorty": "hackerrank"},{"full": "fab fa-hips","shorty": "hips"},{"full": "fab fa-hire-a-helper","shorty": "hire-a-helper"},{"full": "fab fa-hooli","shorty": "hooli"},{"full": "fab fa-hornbill","shorty": "hornbill"},{"full": "fab fa-hotjar","shorty": "hotjar"},{"full": "fab fa-houzz","shorty": "houzz"},{"full": "fab fa-html5","shorty": "html5"},{"full": "fab fa-hubspot","shorty": "hubspot"},{"full": "fab fa-imdb","shorty": "imdb"},{"full": "fab fa-instagram","shorty": "instagram"},{"full": "fab fa-internet-explorer","shorty": "internet-explorer"},{"full": "fab fa-ioxhost","shorty": "ioxhost"},{"full": "fab fa-itunes","shorty": "itunes"},{"full": "fab fa-itunes-note","shorty": "itunes-note"},{"full": "fab fa-java","shorty": "java"},{"full": "fab fa-jedi-order","shorty": "jedi-order"},{"full": "fab fa-jenkins","shorty": "jenkins"},{"full": "fab fa-joget","shorty": "joget"},{"full": "fab fa-joomla","shorty": "joomla"},{"full": "fab fa-js","shorty": "js"},{"full": "fab fa-js-square","shorty": "js-square"},{"full": "fab fa-jsfiddle","shorty": "jsfiddle"},{"full": "fab fa-kaggle","shorty": "kaggle"},{"full": "fab fa-keybase","shorty": "keybase"},{"full": "fab fa-keycdn","shorty": "keycdn"},{"full": "fab fa-kickstarter","shorty": "kickstarter"},{"full": "fab fa-kickstarter-k","shorty": "kickstarter-k"},{"full": "fab fa-korvue","shorty": "korvue"},{"full": "fab fa-laravel","shorty": "laravel"},{"full": "fab fa-lastfm","shorty": "lastfm"},{"full": "fab fa-lastfm-square","shorty": "lastfm-square"},{"full": "fab fa-leanpub","shorty": "leanpub"},{"full": "fab fa-less","shorty": "less"},{"full": "fab fa-line","shorty": "line"},{"full": "fab fa-linkedin","shorty": "linkedin"},{"full": "fab fa-linkedin-in","shorty": "linkedin-in"},{"full": "fab fa-linode","shorty": "linode"},{"full": "fab fa-linux","shorty": "linux"},{"full": "fab fa-lyft","shorty": "lyft"},{"full": "fab fa-magento","shorty": "magento"},{"full": "fab fa-mailchimp","shorty": "mailchimp"},{"full": "fab fa-mandalorian","shorty": "mandalorian"},{"full": "fab fa-markdown","shorty": "markdown"},{"full": "fab fa-mastodon","shorty": "mastodon"},{"full": "fab fa-maxcdn","shorty": "maxcdn"},{"full": "fab fa-medapps","shorty": "medapps"},{"full": "fab fa-medium","shorty": "medium"},{"full": "fab fa-medium-m","shorty": "medium-m"},{"full": "fab fa-medrt","shorty": "medrt"},{"full": "fab fa-meetup","shorty": "meetup"},{"full": "fab fa-megaport","shorty": "megaport"},{"full": "fab fa-microsoft","shorty": "microsoft"},{"full": "fab fa-mix","shorty": "mix"},{"full": "fab fa-mixcloud","shorty": "mixcloud"},{"full": "fab fa-mizuni","shorty": "mizuni"},{"full": "fab fa-modx","shorty": "modx"},{"full": "fab fa-monero","shorty": "monero"},{"full": "fab fa-napster","shorty": "napster"},{"full": "fab fa-neos","shorty": "neos"},{"full": "fab fa-nimblr","shorty": "nimblr"},{"full": "fab fa-nintendo-switch","shorty": "nintendo-switch"},{"full": "fab fa-node","shorty": "node"},{"full": "fab fa-node-js","shorty": "node-js"},{"full": "fab fa-npm","shorty": "npm"},{"full": "fab fa-ns8","shorty": "ns8"},{"full": "fab fa-nutritionix","shorty": "nutritionix"},{"full": "fab fa-odnoklassniki","shorty": "odnoklassniki"},{"full": "fab fa-odnoklassniki-square","shorty": "odnoklassniki-square"},{"full": "fab fa-old-republic","shorty": "old-republic"},{"full": "fab fa-opencart","shorty": "opencart"},{"full": "fab fa-openid","shorty": "openid"},{"full": "fab fa-opera","shorty": "opera"},{"full": "fab fa-optin-monster","shorty": "optin-monster"},{"full": "fab fa-osi","shorty": "osi"},{"full": "fab fa-page4","shorty": "page4"},{"full": "fab fa-pagelines","shorty": "pagelines"},{"full": "fab fa-palfed","shorty": "palfed"},{"full": "fab fa-patreon","shorty": "patreon"},{"full": "fab fa-paypal","shorty": "paypal"},{"full": "fab fa-periscope","shorty": "periscope"},{"full": "fab fa-phabricator","shorty": "phabricator"},{"full": "fab fa-phoenix-framework","shorty": "phoenix-framework"},{"full": "fab fa-phoenix-squadron","shorty": "phoenix-squadron"},{"full": "fab fa-php","shorty": "php"},{"full": "fab fa-pied-piper","shorty": "pied-piper"},{"full": "fab fa-pied-piper-alt","shorty": "pied-piper-alt"},{"full": "fab fa-pied-piper-hat","shorty": "pied-piper-hat"},{"full": "fab fa-pied-piper-pp","shorty": "pied-piper-pp"},{"full": "fab fa-pinterest","shorty": "pinterest"},{"full": "fab fa-pinterest-p","shorty": "pinterest-p"},{"full": "fab fa-pinterest-square","shorty": "pinterest-square"},{"full": "fab fa-playstation","shorty": "playstation"},{"full": "fab fa-product-hunt","shorty": "product-hunt"},{"full": "fab fa-pushed","shorty": "pushed"},{"full": "fab fa-python","shorty": "python"},{"full": "fab fa-qq","shorty": "qq"},{"full": "fab fa-quinscape","shorty": "quinscape"},{"full": "fab fa-quora","shorty": "quora"},{"full": "fab fa-r-project","shorty": "r-project"},{"full": "fab fa-ravelry","shorty": "ravelry"},{"full": "fab fa-react","shorty": "react"},{"full": "fab fa-readme","shorty": "readme"},{"full": "fab fa-rebel","shorty": "rebel"},{"full": "fab fa-red-river","shorty": "red-river"},{"full": "fab fa-reddit","shorty": "reddit"},{"full": "fab fa-reddit-alien","shorty": "reddit-alien"},{"full": "fab fa-reddit-square","shorty": "reddit-square"},{"full": "fab fa-rendact","shorty": "rendact"},{"full": "fab fa-renren","shorty": "renren"},{"full": "fab fa-replyd","shorty": "replyd"},{"full": "fab fa-researchgate","shorty": "researchgate"},{"full": "fab fa-resolving","shorty": "resolving"},{"full": "fab fa-rev","shorty": "rev"},{"full": "fab fa-rocketchat","shorty": "rocketchat"},{"full": "fab fa-rockrms","shorty": "rockrms"},{"full": "fab fa-safari","shorty": "safari"},{"full": "fab fa-sass","shorty": "sass"},{"full": "fab fa-schlix","shorty": "schlix"},{"full": "fab fa-scribd","shorty": "scribd"},{"full": "fab fa-searchengin","shorty": "searchengin"},{"full": "fab fa-sellcast","shorty": "sellcast"},{"full": "fab fa-sellsy","shorty": "sellsy"},{"full": "fab fa-servicestack","shorty": "servicestack"},{"full": "fab fa-shirtsinbulk","shorty": "shirtsinbulk"},{"full": "fab fa-shopware","shorty": "shopware"},{"full": "fab fa-simplybuilt","shorty": "simplybuilt"},{"full": "fab fa-sistrix","shorty": "sistrix"},{"full": "fab fa-sith","shorty": "sith"},{"full": "fab fa-skyatlas","shorty": "skyatlas"},{"full": "fab fa-skype","shorty": "skype"},{"full": "fab fa-slack","shorty": "slack"},{"full": "fab fa-slack-hash","shorty": "slack-hash"},{"full": "fab fa-slideshare","shorty": "slideshare"},{"full": "fab fa-snapchat","shorty": "snapchat"},{"full": "fab fa-snapchat-ghost","shorty": "snapchat-ghost"},{"full": "fab fa-snapchat-square","shorty": "snapchat-square"},{"full": "fab fa-soundcloud","shorty": "soundcloud"},{"full": "fab fa-speakap","shorty": "speakap"},{"full": "fab fa-spotify","shorty": "spotify"},{"full": "fab fa-squarespace","shorty": "squarespace"},{"full": "fab fa-stack-exchange","shorty": "stack-exchange"},{"full": "fab fa-stack-overflow","shorty": "stack-overflow"},{"full": "fab fa-staylinked","shorty": "staylinked"},{"full": "fab fa-steam","shorty": "steam"},{"full": "fab fa-steam-square","shorty": "steam-square"},{"full": "fab fa-steam-symbol","shorty": "steam-symbol"},{"full": "fab fa-sticker-mule","shorty": "sticker-mule"},{"full": "fab fa-strava","shorty": "strava"},{"full": "fab fa-stripe","shorty": "stripe"},{"full": "fab fa-stripe-s","shorty": "stripe-s"},{"full": "fab fa-studiovinari","shorty": "studiovinari"},{"full": "fab fa-stumbleupon","shorty": "stumbleupon"},{"full": "fab fa-stumbleupon-circle","shorty": "stumbleupon-circle"},{"full": "fab fa-superpowers","shorty": "superpowers"},{"full": "fab fa-supple","shorty": "supple"},{"full": "fab fa-teamspeak","shorty": "teamspeak"},{"full": "fab fa-telegram","shorty": "telegram"},{"full": "fab fa-telegram-plane","shorty": "telegram-plane"},{"full": "fab fa-tencent-weibo","shorty": "tencent-weibo"},{"full": "fab fa-the-red-yeti","shorty": "the-red-yeti"},{"full": "fab fa-themeco","shorty": "themeco"},{"full": "fab fa-themeisle","shorty": "themeisle"},{"full": "fab fa-trade-federation","shorty": "trade-federation"},{"full": "fab fa-trello","shorty": "trello"},{"full": "fab fa-tripadvisor","shorty": "tripadvisor"},{"full": "fab fa-tumblr","shorty": "tumblr"},{"full": "fab fa-tumblr-square","shorty": "tumblr-square"},{"full": "fab fa-twitch","shorty": "twitch"},{"full": "fab fa-twitter","shorty": "twitter"},{"full": "fab fa-twitter-square","shorty": "twitter-square"},{"full": "fab fa-typo3","shorty": "typo3"},{"full": "fab fa-uber","shorty": "uber"},{"full": "fab fa-uikit","shorty": "uikit"},{"full": "fab fa-uniregistry","shorty": "uniregistry"},{"full": "fab fa-untappd","shorty": "untappd"},{"full": "fab fa-usb","shorty": "usb"},{"full": "fab fa-ussunnah","shorty": "ussunnah"},{"full": "fab fa-vaadin","shorty": "vaadin"},{"full": "fab fa-viacoin","shorty": "viacoin"},{"full": "fab fa-viadeo","shorty": "viadeo"},{"full": "fab fa-viadeo-square","shorty": "viadeo-square"},{"full": "fab fa-viber","shorty": "viber"},{"full": "fab fa-vimeo","shorty": "vimeo"},{"full": "fab fa-vimeo-square","shorty": "vimeo-square"},{"full": "fab fa-vimeo-v","shorty": "vimeo-v"},{"full": "fab fa-vine","shorty": "vine"},{"full": "fab fa-vk","shorty": "vk"},{"full": "fab fa-vnv","shorty": "vnv"},{"full": "fab fa-vuejs","shorty": "vuejs"},{"full": "fab fa-weebly","shorty": "weebly"},{"full": "fab fa-weibo","shorty": "weibo"},{"full": "fab fa-weixin","shorty": "weixin"},{"full": "fab fa-whatsapp","shorty": "whatsapp"},{"full": "fab fa-whatsapp-square","shorty": "whatsapp-square"},{"full": "fab fa-whmcs","shorty": "whmcs"},{"full": "fab fa-wikipedia-w","shorty": "wikipedia-w"},{"full": "fab fa-windows","shorty": "windows"},{"full": "fab fa-wix","shorty": "wix"},{"full": "fab fa-wolf-pack-battalion","shorty": "wolf-pack-battalion"},{"full": "fab fa-wordpress","shorty": "wordpress"},{"full": "fab fa-wordpress-simple","shorty": "wordpress-simple"},{"full": "fab fa-wpbeginner","shorty": "wpbeginner"},{"full": "fab fa-wpexplorer","shorty": "wpexplorer"},{"full": "fab fa-wpforms","shorty": "wpforms"},{"full": "fab fa-xbox","shorty": "xbox"},{"full": "fab fa-xing","shorty": "xing"},{"full": "fab fa-xing-square","shorty": "xing-square"},{"full": "fab fa-y-combinator","shorty": "y-combinator"},{"full": "fab fa-yahoo","shorty": "yahoo"},{"full": "fab fa-yandex","shorty": "yandex"},{"full": "fab fa-yandex-international","shorty": "yandex-international"},{"full": "fab fa-yelp","shorty": "yelp"},{"full": "fab fa-yoast","shorty": "yoast"},{"full": "fab fa-youtube","shorty": "youtube"},{"full": "fab fa-youtube-square","shorty": "youtube-square"},{"full": "fab fa-zhihu","shorty": "zhihu"},{"full": "far fa-address-book","shorty": "address-book"},{"full": "far fa-address-card","shorty": "address-card"},{"full": "far fa-angry","shorty": "angry"},{"full": "far fa-arrow-alt-circle-down","shorty": "arrow-alt-circle-down"},{"full": "far fa-arrow-alt-circle-left","shorty": "arrow-alt-circle-left"},{"full": "far fa-arrow-alt-circle-right","shorty": "arrow-alt-circle-right"},{"full": "far fa-arrow-alt-circle-up","shorty": "arrow-alt-circle-up"},{"full": "far fa-bell","shorty": "bell"},{"full": "far fa-bell-slash","shorty": "bell-slash"},{"full": "far fa-bookmark","shorty": "bookmark"},{"full": "far fa-building","shorty": "building"},{"full": "far fa-calendar","shorty": "calendar"},{"full": "far fa-calendar-alt","shorty": "calendar-alt"},{"full": "far fa-calendar-check","shorty": "calendar-check"},{"full": "far fa-calendar-minus","shorty": "calendar-minus"},{"full": "far fa-calendar-plus","shorty": "calendar-plus"},{"full": "far fa-calendar-times","shorty": "calendar-times"},{"full": "far fa-caret-square-down","shorty": "caret-square-down"},{"full": "far fa-caret-square-left","shorty": "caret-square-left"},{"full": "far fa-caret-square-right","shorty": "caret-square-right"},{"full": "far fa-caret-square-up","shorty": "caret-square-up"},{"full": "far fa-chart-bar","shorty": "chart-bar"},{"full": "far fa-check-circle","shorty": "check-circle"},{"full": "far fa-check-square","shorty": "check-square"},{"full": "far fa-circle","shorty": "circle"},{"full": "far fa-clipboard","shorty": "clipboard"},{"full": "far fa-clock","shorty": "clock"},{"full": "far fa-clone","shorty": "clone"},{"full": "far fa-closed-captioning","shorty": "closed-captioning"},{"full": "far fa-comment","shorty": "comment"},{"full": "far fa-comment-alt","shorty": "comment-alt"},{"full": "far fa-comment-dots","shorty": "comment-dots"},{"full": "far fa-comments","shorty": "comments"},{"full": "far fa-compass","shorty": "compass"},{"full": "far fa-copy","shorty": "copy"},{"full": "far fa-copyright","shorty": "copyright"},{"full": "far fa-credit-card","shorty": "credit-card"},{"full": "far fa-dizzy","shorty": "dizzy"},{"full": "far fa-dot-circle","shorty": "dot-circle"},{"full": "far fa-edit","shorty": "edit"},{"full": "far fa-envelope","shorty": "envelope"},{"full": "far fa-envelope-open","shorty": "envelope-open"},{"full": "far fa-eye","shorty": "eye"},{"full": "far fa-eye-slash","shorty": "eye-slash"},{"full": "far fa-file","shorty": "file"},{"full": "far fa-file-alt","shorty": "file-alt"},{"full": "far fa-file-archive","shorty": "file-archive"},{"full": "far fa-file-audio","shorty": "file-audio"},{"full": "far fa-file-code","shorty": "file-code"},{"full": "far fa-file-excel","shorty": "file-excel"},{"full": "far fa-file-image","shorty": "file-image"},{"full": "far fa-file-pdf","shorty": "file-pdf"},{"full": "far fa-file-powerpoint","shorty": "file-powerpoint"},{"full": "far fa-file-video","shorty": "file-video"},{"full": "far fa-file-word","shorty": "file-word"},{"full": "far fa-flag","shorty": "flag"},{"full": "far fa-flushed","shorty": "flushed"},{"full": "far fa-folder","shorty": "folder"},{"full": "far fa-folder-open","shorty": "folder-open"},{"full": "far fa-frown","shorty": "frown"},{"full": "far fa-frown-open","shorty": "frown-open"},{"full": "far fa-futbol","shorty": "futbol"},{"full": "far fa-gem","shorty": "gem"},{"full": "far fa-grimace","shorty": "grimace"},{"full": "far fa-grin","shorty": "grin"},{"full": "far fa-grin-alt","shorty": "grin-alt"},{"full": "far fa-grin-beam","shorty": "grin-beam"},{"full": "far fa-grin-beam-sweat","shorty": "grin-beam-sweat"},{"full": "far fa-grin-hearts","shorty": "grin-hearts"},{"full": "far fa-grin-squint","shorty": "grin-squint"},{"full": "far fa-grin-squint-tears","shorty": "grin-squint-tears"},{"full": "far fa-grin-stars","shorty": "grin-stars"},{"full": "far fa-grin-tears","shorty": "grin-tears"},{"full": "far fa-grin-tongue","shorty": "grin-tongue"},{"full": "far fa-grin-tongue-squint","shorty": "grin-tongue-squint"},{"full": "far fa-grin-tongue-wink","shorty": "grin-tongue-wink"},{"full": "far fa-grin-wink","shorty": "grin-wink"},{"full": "far fa-hand-lizard","shorty": "hand-lizard"},{"full": "far fa-hand-paper","shorty": "hand-paper"},{"full": "far fa-hand-peace","shorty": "hand-peace"},{"full": "far fa-hand-point-down","shorty": "hand-point-down"},{"full": "far fa-hand-point-left","shorty": "hand-point-left"},{"full": "far fa-hand-point-right","shorty": "hand-point-right"},{"full": "far fa-hand-point-up","shorty": "hand-point-up"},{"full": "far fa-hand-pointer","shorty": "hand-pointer"},{"full": "far fa-hand-rock","shorty": "hand-rock"},{"full": "far fa-hand-scissors","shorty": "hand-scissors"},{"full": "far fa-hand-spock","shorty": "hand-spock"},{"full": "far fa-handshake","shorty": "handshake"},{"full": "far fa-hdd","shorty": "hdd"},{"full": "far fa-heart","shorty": "heart"},{"full": "far fa-hospital","shorty": "hospital"},{"full": "far fa-hourglass","shorty": "hourglass"},{"full": "far fa-id-badge","shorty": "id-badge"},{"full": "far fa-id-card","shorty": "id-card"},{"full": "far fa-image","shorty": "image"},{"full": "far fa-images","shorty": "images"},{"full": "far fa-keyboard","shorty": "keyboard"},{"full": "far fa-kiss","shorty": "kiss"},{"full": "far fa-kiss-beam","shorty": "kiss-beam"},{"full": "far fa-kiss-wink-heart","shorty": "kiss-wink-heart"},{"full": "far fa-laugh","shorty": "laugh"},{"full": "far fa-laugh-beam","shorty": "laugh-beam"},{"full": "far fa-laugh-squint","shorty": "laugh-squint"},{"full": "far fa-laugh-wink","shorty": "laugh-wink"},{"full": "far fa-lemon","shorty": "lemon"},{"full": "far fa-life-ring","shorty": "life-ring"},{"full": "far fa-lightbulb","shorty": "lightbulb"},{"full": "far fa-list-alt","shorty": "list-alt"},{"full": "far fa-map","shorty": "map"},{"full": "far fa-meh","shorty": "meh"},{"full": "far fa-meh-blank","shorty": "meh-blank"},{"full": "far fa-meh-rolling-eyes","shorty": "meh-rolling-eyes"},{"full": "far fa-minus-square","shorty": "minus-square"},{"full": "far fa-money-bill-alt","shorty": "money-bill-alt"},{"full": "far fa-moon","shorty": "moon"},{"full": "far fa-newspaper","shorty": "newspaper"},{"full": "far fa-object-group","shorty": "object-group"},{"full": "far fa-object-ungroup","shorty": "object-ungroup"},{"full": "far fa-paper-plane","shorty": "paper-plane"},{"full": "far fa-pause-circle","shorty": "pause-circle"},{"full": "far fa-play-circle","shorty": "play-circle"},{"full": "far fa-plus-square","shorty": "plus-square"},{"full": "far fa-question-circle","shorty": "question-circle"},{"full": "far fa-registered","shorty": "registered"},{"full": "far fa-sad-cry","shorty": "sad-cry"},{"full": "far fa-sad-tear","shorty": "sad-tear"},{"full": "far fa-save","shorty": "save"},{"full": "far fa-share-square","shorty": "share-square"},{"full": "far fa-smile","shorty": "smile"},{"full": "far fa-smile-beam","shorty": "smile-beam"},{"full": "far fa-smile-wink","shorty": "smile-wink"},{"full": "far fa-snowflake","shorty": "snowflake"},{"full": "far fa-square","shorty": "square"},{"full": "far fa-star","shorty": "star"},{"full": "far fa-star-half","shorty": "star-half"},{"full": "far fa-sticky-note","shorty": "sticky-note"},{"full": "far fa-stop-circle","shorty": "stop-circle"},{"full": "far fa-sun","shorty": "sun"},{"full": "far fa-surprise","shorty": "surprise"},{"full": "far fa-thumbs-down","shorty": "thumbs-down"},{"full": "far fa-thumbs-up","shorty": "thumbs-up"},{"full": "far fa-times-circle","shorty": "times-circle"},{"full": "far fa-tired","shorty": "tired"},{"full": "far fa-trash-alt","shorty": "trash-alt"},{"full": "far fa-user","shorty": "user"},{"full": "far fa-user-circle","shorty": "user-circle"},{"full": "far fa-window-close","shorty": "window-close"},{"full": "far fa-window-maximize","shorty": "window-maximize"},{"full": "far fa-window-minimize","shorty": "window-minimize"},{"full": "far fa-window-restore","shorty": "window-restore"},{"full": "fas fa-ad","shorty": "ad"},{"full": "fas fa-address-book","shorty": "address-book"},{"full": "fas fa-address-card","shorty": "address-card"},{"full": "fas fa-adjust","shorty": "adjust"},{"full": "fas fa-air-freshener","shorty": "air-freshener"},{"full": "fas fa-align-center","shorty": "align-center"},{"full": "fas fa-align-justify","shorty": "align-justify"},{"full": "fas fa-align-left","shorty": "align-left"},{"full": "fas fa-align-right","shorty": "align-right"},{"full": "fas fa-allergies","shorty": "allergies"},{"full": "fas fa-ambulance","shorty": "ambulance"},{"full": "fas fa-american-sign-language-interpreting","shorty": "american-sign-language-interpreting"},{"full": "fas fa-anchor","shorty": "anchor"},{"full": "fas fa-angle-double-down","shorty": "angle-double-down"},{"full": "fas fa-angle-double-left","shorty": "angle-double-left"},{"full": "fas fa-angle-double-right","shorty": "angle-double-right"},{"full": "fas fa-angle-double-up","shorty": "angle-double-up"},{"full": "fas fa-angle-down","shorty": "angle-down"},{"full": "fas fa-angle-left","shorty": "angle-left"},{"full": "fas fa-angle-right","shorty": "angle-right"},{"full": "fas fa-angle-up","shorty": "angle-up"},{"full": "fas fa-angry","shorty": "angry"},{"full": "fas fa-ankh","shorty": "ankh"},{"full": "fas fa-apple-alt","shorty": "apple-alt"},{"full": "fas fa-archive","shorty": "archive"},{"full": "fas fa-archway","shorty": "archway"},{"full": "fas fa-arrow-alt-circle-down","shorty": "arrow-alt-circle-down"},{"full": "fas fa-arrow-alt-circle-left","shorty": "arrow-alt-circle-left"},{"full": "fas fa-arrow-alt-circle-right","shorty": "arrow-alt-circle-right"},{"full": "fas fa-arrow-alt-circle-up","shorty": "arrow-alt-circle-up"},{"full": "fas fa-arrow-circle-down","shorty": "arrow-circle-down"},{"full": "fas fa-arrow-circle-left","shorty": "arrow-circle-left"},{"full": "fas fa-arrow-circle-right","shorty": "arrow-circle-right"},{"full": "fas fa-arrow-circle-up","shorty": "arrow-circle-up"},{"full": "fas fa-arrow-down","shorty": "arrow-down"},{"full": "fas fa-arrow-left","shorty": "arrow-left"},{"full": "fas fa-arrow-right","shorty": "arrow-right"},{"full": "fas fa-arrow-up","shorty": "arrow-up"},{"full": "fas fa-arrows-alt","shorty": "arrows-alt"},{"full": "fas fa-arrows-alt-h","shorty": "arrows-alt-h"},{"full": "fas fa-arrows-alt-v","shorty": "arrows-alt-v"},{"full": "fas fa-assistive-listening-systems","shorty": "assistive-listening-systems"},{"full": "fas fa-asterisk","shorty": "asterisk"},{"full": "fas fa-at","shorty": "at"},{"full": "fas fa-atlas","shorty": "atlas"},{"full": "fas fa-atom","shorty": "atom"},{"full": "fas fa-audio-description","shorty": "audio-description"},{"full": "fas fa-award","shorty": "award"},{"full": "fas fa-backspace","shorty": "backspace"},{"full": "fas fa-backward","shorty": "backward"},{"full": "fas fa-balance-scale","shorty": "balance-scale"},{"full": "fas fa-ban","shorty": "ban"},{"full": "fas fa-band-aid","shorty": "band-aid"},{"full": "fas fa-barcode","shorty": "barcode"},{"full": "fas fa-bars","shorty": "bars"},{"full": "fas fa-baseball-ball","shorty": "baseball-ball"},{"full": "fas fa-basketball-ball","shorty": "basketball-ball"},{"full": "fas fa-bath","shorty": "bath"},{"full": "fas fa-battery-empty","shorty": "battery-empty"},{"full": "fas fa-battery-full","shorty": "battery-full"},{"full": "fas fa-battery-half","shorty": "battery-half"},{"full": "fas fa-battery-quarter","shorty": "battery-quarter"},{"full": "fas fa-battery-three-quarters","shorty": "battery-three-quarters"},{"full": "fas fa-bed","shorty": "bed"},{"full": "fas fa-beer","shorty": "beer"},{"full": "fas fa-bell","shorty": "bell"},{"full": "fas fa-bell-slash","shorty": "bell-slash"},{"full": "fas fa-bezier-curve","shorty": "bezier-curve"},{"full": "fas fa-bible","shorty": "bible"},{"full": "fas fa-bicycle","shorty": "bicycle"},{"full": "fas fa-binoculars","shorty": "binoculars"},{"full": "fas fa-birthday-cake","shorty": "birthday-cake"},{"full": "fas fa-blender","shorty": "blender"},{"full": "fas fa-blind","shorty": "blind"},{"full": "fas fa-bold","shorty": "bold"},{"full": "fas fa-bolt","shorty": "bolt"},{"full": "fas fa-bomb","shorty": "bomb"},{"full": "fas fa-bone","shorty": "bone"},{"full": "fas fa-bong","shorty": "bong"},{"full": "fas fa-book","shorty": "book"},{"full": "fas fa-book-open","shorty": "book-open"},{"full": "fas fa-book-reader","shorty": "book-reader"},{"full": "fas fa-bookmark","shorty": "bookmark"},{"full": "fas fa-bowling-ball","shorty": "bowling-ball"},{"full": "fas fa-box","shorty": "box"},{"full": "fas fa-box-open","shorty": "box-open"},{"full": "fas fa-boxes","shorty": "boxes"},{"full": "fas fa-braille","shorty": "braille"},{"full": "fas fa-brain","shorty": "brain"},{"full": "fas fa-briefcase","shorty": "briefcase"},{"full": "fas fa-briefcase-medical","shorty": "briefcase-medical"},{"full": "fas fa-broadcast-tower","shorty": "broadcast-tower"},{"full": "fas fa-broom","shorty": "broom"},{"full": "fas fa-brush","shorty": "brush"},{"full": "fas fa-bug","shorty": "bug"},{"full": "fas fa-building","shorty": "building"},{"full": "fas fa-bullhorn","shorty": "bullhorn"},{"full": "fas fa-bullseye","shorty": "bullseye"},{"full": "fas fa-burn","shorty": "burn"},{"full": "fas fa-bus","shorty": "bus"},{"full": "fas fa-bus-alt","shorty": "bus-alt"},{"full": "fas fa-business-time","shorty": "business-time"},{"full": "fas fa-calculator","shorty": "calculator"},{"full": "fas fa-calendar","shorty": "calendar"},{"full": "fas fa-calendar-alt","shorty": "calendar-alt"},{"full": "fas fa-calendar-check","shorty": "calendar-check"},{"full": "fas fa-calendar-minus","shorty": "calendar-minus"},{"full": "fas fa-calendar-plus","shorty": "calendar-plus"},{"full": "fas fa-calendar-times","shorty": "calendar-times"},{"full": "fas fa-camera","shorty": "camera"},{"full": "fas fa-camera-retro","shorty": "camera-retro"},{"full": "fas fa-cannabis","shorty": "cannabis"},{"full": "fas fa-capsules","shorty": "capsules"},{"full": "fas fa-car","shorty": "car"},{"full": "fas fa-car-alt","shorty": "car-alt"},{"full": "fas fa-car-battery","shorty": "car-battery"},{"full": "fas fa-car-crash","shorty": "car-crash"},{"full": "fas fa-car-side","shorty": "car-side"},{"full": "fas fa-caret-down","shorty": "caret-down"},{"full": "fas fa-caret-left","shorty": "caret-left"},{"full": "fas fa-caret-right","shorty": "caret-right"},{"full": "fas fa-caret-square-down","shorty": "caret-square-down"},{"full": "fas fa-caret-square-left","shorty": "caret-square-left"},{"full": "fas fa-caret-square-right","shorty": "caret-square-right"},{"full": "fas fa-caret-square-up","shorty": "caret-square-up"},{"full": "fas fa-caret-up","shorty": "caret-up"},{"full": "fas fa-cart-arrow-down","shorty": "cart-arrow-down"},{"full": "fas fa-cart-plus","shorty": "cart-plus"},{"full": "fas fa-certificate","shorty": "certificate"},{"full": "fas fa-chalkboard","shorty": "chalkboard"},{"full": "fas fa-chalkboard-teacher","shorty": "chalkboard-teacher"},{"full": "fas fa-charging-station","shorty": "charging-station"},{"full": "fas fa-chart-area","shorty": "chart-area"},{"full": "fas fa-chart-bar","shorty": "chart-bar"},{"full": "fas fa-chart-line","shorty": "chart-line"},{"full": "fas fa-chart-pie","shorty": "chart-pie"},{"full": "fas fa-check","shorty": "check"},{"full": "fas fa-check-circle","shorty": "check-circle"},{"full": "fas fa-check-double","shorty": "check-double"},{"full": "fas fa-check-square","shorty": "check-square"},{"full": "fas fa-chess","shorty": "chess"},{"full": "fas fa-chess-bishop","shorty": "chess-bishop"},{"full": "fas fa-chess-board","shorty": "chess-board"},{"full": "fas fa-chess-king","shorty": "chess-king"},{"full": "fas fa-chess-knight","shorty": "chess-knight"},{"full": "fas fa-chess-pawn","shorty": "chess-pawn"},{"full": "fas fa-chess-queen","shorty": "chess-queen"},{"full": "fas fa-chess-rook","shorty": "chess-rook"},{"full": "fas fa-chevron-circle-down","shorty": "chevron-circle-down"},{"full": "fas fa-chevron-circle-left","shorty": "chevron-circle-left"},{"full": "fas fa-chevron-circle-right","shorty": "chevron-circle-right"},{"full": "fas fa-chevron-circle-up","shorty": "chevron-circle-up"},{"full": "fas fa-chevron-down","shorty": "chevron-down"},{"full": "fas fa-chevron-left","shorty": "chevron-left"},{"full": "fas fa-chevron-right","shorty": "chevron-right"},{"full": "fas fa-chevron-up","shorty": "chevron-up"},{"full": "fas fa-child","shorty": "child"},{"full": "fas fa-church","shorty": "church"},{"full": "fas fa-circle","shorty": "circle"},{"full": "fas fa-circle-notch","shorty": "circle-notch"},{"full": "fas fa-city","shorty": "city"},{"full": "fas fa-clipboard","shorty": "clipboard"},{"full": "fas fa-clipboard-check","shorty": "clipboard-check"},{"full": "fas fa-clipboard-list","shorty": "clipboard-list"},{"full": "fas fa-clock","shorty": "clock"},{"full": "fas fa-clone","shorty": "clone"},{"full": "fas fa-closed-captioning","shorty": "closed-captioning"},{"full": "fas fa-cloud","shorty": "cloud"},{"full": "fas fa-cloud-download-alt","shorty": "cloud-download-alt"},{"full": "fas fa-cloud-upload-alt","shorty": "cloud-upload-alt"},{"full": "fas fa-cocktail","shorty": "cocktail"},{"full": "fas fa-code","shorty": "code"},{"full": "fas fa-code-branch","shorty": "code-branch"},{"full": "fas fa-coffee","shorty": "coffee"},{"full": "fas fa-cog","shorty": "cog"},{"full": "fas fa-cogs","shorty": "cogs"},{"full": "fas fa-coins","shorty": "coins"},{"full": "fas fa-columns","shorty": "columns"},{"full": "fas fa-comment","shorty": "comment"},{"full": "fas fa-comment-alt","shorty": "comment-alt"},{"full": "fas fa-comment-dollar","shorty": "comment-dollar"},{"full": "fas fa-comment-dots","shorty": "comment-dots"},{"full": "fas fa-comment-slash","shorty": "comment-slash"},{"full": "fas fa-comments","shorty": "comments"},{"full": "fas fa-comments-dollar","shorty": "comments-dollar"},{"full": "fas fa-compact-disc","shorty": "compact-disc"},{"full": "fas fa-compass","shorty": "compass"},{"full": "fas fa-compress","shorty": "compress"},{"full": "fas fa-concierge-bell","shorty": "concierge-bell"},{"full": "fas fa-cookie","shorty": "cookie"},{"full": "fas fa-cookie-bite","shorty": "cookie-bite"},{"full": "fas fa-copy","shorty": "copy"},{"full": "fas fa-copyright","shorty": "copyright"},{"full": "fas fa-couch","shorty": "couch"},{"full": "fas fa-credit-card","shorty": "credit-card"},{"full": "fas fa-crop","shorty": "crop"},{"full": "fas fa-crop-alt","shorty": "crop-alt"},{"full": "fas fa-cross","shorty": "cross"},{"full": "fas fa-crosshairs","shorty": "crosshairs"},{"full": "fas fa-crow","shorty": "crow"},{"full": "fas fa-crown","shorty": "crown"},{"full": "fas fa-cube","shorty": "cube"},{"full": "fas fa-cubes","shorty": "cubes"},{"full": "fas fa-cut","shorty": "cut"},{"full": "fas fa-database","shorty": "database"},{"full": "fas fa-deaf","shorty": "deaf"},{"full": "fas fa-desktop","shorty": "desktop"},{"full": "fas fa-dharmachakra","shorty": "dharmachakra"},{"full": "fas fa-diagnoses","shorty": "diagnoses"},{"full": "fas fa-dice","shorty": "dice"},{"full": "fas fa-dice-five","shorty": "dice-five"},{"full": "fas fa-dice-four","shorty": "dice-four"},{"full": "fas fa-dice-one","shorty": "dice-one"},{"full": "fas fa-dice-six","shorty": "dice-six"},{"full": "fas fa-dice-three","shorty": "dice-three"},{"full": "fas fa-dice-two","shorty": "dice-two"},{"full": "fas fa-digital-tachograph","shorty": "digital-tachograph"},{"full": "fas fa-directions","shorty": "directions"},{"full": "fas fa-divide","shorty": "divide"},{"full": "fas fa-dizzy","shorty": "dizzy"},{"full": "fas fa-dna","shorty": "dna"},{"full": "fas fa-dollar-sign","shorty": "dollar-sign"},{"full": "fas fa-dolly","shorty": "dolly"},{"full": "fas fa-dolly-flatbed","shorty": "dolly-flatbed"},{"full": "fas fa-donate","shorty": "donate"},{"full": "fas fa-door-closed","shorty": "door-closed"},{"full": "fas fa-door-open","shorty": "door-open"},{"full": "fas fa-dot-circle","shorty": "dot-circle"},{"full": "fas fa-dove","shorty": "dove"},{"full": "fas fa-download","shorty": "download"},{"full": "fas fa-drafting-compass","shorty": "drafting-compass"},{"full": "fas fa-draw-polygon","shorty": "draw-polygon"},{"full": "fas fa-drum","shorty": "drum"},{"full": "fas fa-drum-steelpan","shorty": "drum-steelpan"},{"full": "fas fa-dumbbell","shorty": "dumbbell"},{"full": "fas fa-edit","shorty": "edit"},{"full": "fas fa-eject","shorty": "eject"},{"full": "fas fa-ellipsis-h","shorty": "ellipsis-h"},{"full": "fas fa-ellipsis-v","shorty": "ellipsis-v"},{"full": "fas fa-envelope","shorty": "envelope"},{"full": "fas fa-envelope-open","shorty": "envelope-open"},{"full": "fas fa-envelope-open-text","shorty": "envelope-open-text"},{"full": "fas fa-envelope-square","shorty": "envelope-square"},{"full": "fas fa-equals","shorty": "equals"},{"full": "fas fa-eraser","shorty": "eraser"},{"full": "fas fa-euro-sign","shorty": "euro-sign"},{"full": "fas fa-exchange-alt","shorty": "exchange-alt"},{"full": "fas fa-exclamation","shorty": "exclamation"},{"full": "fas fa-exclamation-circle","shorty": "exclamation-circle"},{"full": "fas fa-exclamation-triangle","shorty": "exclamation-triangle"},{"full": "fas fa-expand","shorty": "expand"},{"full": "fas fa-expand-arrows-alt","shorty": "expand-arrows-alt"},{"full": "fas fa-external-link-alt","shorty": "external-link-alt"},{"full": "fas fa-external-link-square-alt","shorty": "external-link-square-alt"},{"full": "fas fa-eye","shorty": "eye"},{"full": "fas fa-eye-dropper","shorty": "eye-dropper"},{"full": "fas fa-eye-slash","shorty": "eye-slash"},{"full": "fas fa-fast-backward","shorty": "fast-backward"},{"full": "fas fa-fast-forward","shorty": "fast-forward"},{"full": "fas fa-fax","shorty": "fax"},{"full": "fas fa-feather","shorty": "feather"},{"full": "fas fa-feather-alt","shorty": "feather-alt"},{"full": "fas fa-female","shorty": "female"},{"full": "fas fa-fighter-jet","shorty": "fighter-jet"},{"full": "fas fa-file","shorty": "file"},{"full": "fas fa-file-alt","shorty": "file-alt"},{"full": "fas fa-file-archive","shorty": "file-archive"},{"full": "fas fa-file-audio","shorty": "file-audio"},{"full": "fas fa-file-code","shorty": "file-code"},{"full": "fas fa-file-contract","shorty": "file-contract"},{"full": "fas fa-file-download","shorty": "file-download"},{"full": "fas fa-file-excel","shorty": "file-excel"},{"full": "fas fa-file-export","shorty": "file-export"},{"full": "fas fa-file-image","shorty": "file-image"},{"full": "fas fa-file-import","shorty": "file-import"},{"full": "fas fa-file-invoice","shorty": "file-invoice"},{"full": "fas fa-file-invoice-dollar","shorty": "file-invoice-dollar"},{"full": "fas fa-file-medical","shorty": "file-medical"},{"full": "fas fa-file-medical-alt","shorty": "file-medical-alt"},{"full": "fas fa-file-pdf","shorty": "file-pdf"},{"full": "fas fa-file-powerpoint","shorty": "file-powerpoint"},{"full": "fas fa-file-prescription","shorty": "file-prescription"},{"full": "fas fa-file-signature","shorty": "file-signature"},{"full": "fas fa-file-upload","shorty": "file-upload"},{"full": "fas fa-file-video","shorty": "file-video"},{"full": "fas fa-file-word","shorty": "file-word"},{"full": "fas fa-fill","shorty": "fill"},{"full": "fas fa-fill-drip","shorty": "fill-drip"},{"full": "fas fa-film","shorty": "film"},{"full": "fas fa-filter","shorty": "filter"},{"full": "fas fa-fingerprint","shorty": "fingerprint"},{"full": "fas fa-fire","shorty": "fire"},{"full": "fas fa-fire-extinguisher","shorty": "fire-extinguisher"},{"full": "fas fa-first-aid","shorty": "first-aid"},{"full": "fas fa-fish","shorty": "fish"},{"full": "fas fa-flag","shorty": "flag"},{"full": "fas fa-flag-checkered","shorty": "flag-checkered"},{"full": "fas fa-flask","shorty": "flask"},{"full": "fas fa-flushed","shorty": "flushed"},{"full": "fas fa-folder","shorty": "folder"},{"full": "fas fa-folder-minus","shorty": "folder-minus"},{"full": "fas fa-folder-open","shorty": "folder-open"},{"full": "fas fa-folder-plus","shorty": "folder-plus"},{"full": "fas fa-font","shorty": "font"},{"full": "fas fa-football-ball","shorty": "football-ball"},{"full": "fas fa-forward","shorty": "forward"},{"full": "fas fa-frog","shorty": "frog"},{"full": "fas fa-frown","shorty": "frown"},{"full": "fas fa-frown-open","shorty": "frown-open"},{"full": "fas fa-funnel-dollar","shorty": "funnel-dollar"},{"full": "fas fa-futbol","shorty": "futbol"},{"full": "fas fa-gamepad","shorty": "gamepad"},{"full": "fas fa-gas-pump","shorty": "gas-pump"},{"full": "fas fa-gavel","shorty": "gavel"},{"full": "fas fa-gem","shorty": "gem"},{"full": "fas fa-genderless","shorty": "genderless"},{"full": "fas fa-gift","shorty": "gift"},{"full": "fas fa-glass-martini","shorty": "glass-martini"},{"full": "fas fa-glass-martini-alt","shorty": "glass-martini-alt"},{"full": "fas fa-glasses","shorty": "glasses"},{"full": "fas fa-globe","shorty": "globe"},{"full": "fas fa-globe-africa","shorty": "globe-africa"},{"full": "fas fa-globe-americas","shorty": "globe-americas"},{"full": "fas fa-globe-asia","shorty": "globe-asia"},{"full": "fas fa-golf-ball","shorty": "golf-ball"},{"full": "fas fa-gopuram","shorty": "gopuram"},{"full": "fas fa-graduation-cap","shorty": "graduation-cap"},{"full": "fas fa-greater-than","shorty": "greater-than"},{"full": "fas fa-greater-than-equal","shorty": "greater-than-equal"},{"full": "fas fa-grimace","shorty": "grimace"},{"full": "fas fa-grin","shorty": "grin"},{"full": "fas fa-grin-alt","shorty": "grin-alt"},{"full": "fas fa-grin-beam","shorty": "grin-beam"},{"full": "fas fa-grin-beam-sweat","shorty": "grin-beam-sweat"},{"full": "fas fa-grin-hearts","shorty": "grin-hearts"},{"full": "fas fa-grin-squint","shorty": "grin-squint"},{"full": "fas fa-grin-squint-tears","shorty": "grin-squint-tears"},{"full": "fas fa-grin-stars","shorty": "grin-stars"},{"full": "fas fa-grin-tears","shorty": "grin-tears"},{"full": "fas fa-grin-tongue","shorty": "grin-tongue"},{"full": "fas fa-grin-tongue-squint","shorty": "grin-tongue-squint"},{"full": "fas fa-grin-tongue-wink","shorty": "grin-tongue-wink"},{"full": "fas fa-grin-wink","shorty": "grin-wink"},{"full": "fas fa-grip-horizontal","shorty": "grip-horizontal"},{"full": "fas fa-grip-vertical","shorty": "grip-vertical"},{"full": "fas fa-h-square","shorty": "h-square"},{"full": "fas fa-hamsa","shorty": "hamsa"},{"full": "fas fa-hand-holding","shorty": "hand-holding"},{"full": "fas fa-hand-holding-heart","shorty": "hand-holding-heart"},{"full": "fas fa-hand-holding-usd","shorty": "hand-holding-usd"},{"full": "fas fa-hand-lizard","shorty": "hand-lizard"},{"full": "fas fa-hand-paper","shorty": "hand-paper"},{"full": "fas fa-hand-peace","shorty": "hand-peace"},{"full": "fas fa-hand-point-down","shorty": "hand-point-down"},{"full": "fas fa-hand-point-left","shorty": "hand-point-left"},{"full": "fas fa-hand-point-right","shorty": "hand-point-right"},{"full": "fas fa-hand-point-up","shorty": "hand-point-up"},{"full": "fas fa-hand-pointer","shorty": "hand-pointer"},{"full": "fas fa-hand-rock","shorty": "hand-rock"},{"full": "fas fa-hand-scissors","shorty": "hand-scissors"},{"full": "fas fa-hand-spock","shorty": "hand-spock"},{"full": "fas fa-hands","shorty": "hands"},{"full": "fas fa-hands-helping","shorty": "hands-helping"},{"full": "fas fa-handshake","shorty": "handshake"},{"full": "fas fa-hashtag","shorty": "hashtag"},{"full": "fas fa-haykal","shorty": "haykal"},{"full": "fas fa-hdd","shorty": "hdd"},{"full": "fas fa-heading","shorty": "heading"},{"full": "fas fa-headphones","shorty": "headphones"},{"full": "fas fa-headphones-alt","shorty": "headphones-alt"},{"full": "fas fa-headset","shorty": "headset"},{"full": "fas fa-heart","shorty": "heart"},{"full": "fas fa-heartbeat","shorty": "heartbeat"},{"full": "fas fa-helicopter","shorty": "helicopter"},{"full": "fas fa-highlighter","shorty": "highlighter"},{"full": "fas fa-history","shorty": "history"},{"full": "fas fa-hockey-puck","shorty": "hockey-puck"},{"full": "fas fa-home","shorty": "home"},{"full": "fas fa-hospital","shorty": "hospital"},{"full": "fas fa-hospital-alt","shorty": "hospital-alt"},{"full": "fas fa-hospital-symbol","shorty": "hospital-symbol"},{"full": "fas fa-hot-tub","shorty": "hot-tub"},{"full": "fas fa-hotel","shorty": "hotel"},{"full": "fas fa-hourglass","shorty": "hourglass"},{"full": "fas fa-hourglass-end","shorty": "hourglass-end"},{"full": "fas fa-hourglass-half","shorty": "hourglass-half"},{"full": "fas fa-hourglass-start","shorty": "hourglass-start"},{"full": "fas fa-i-cursor","shorty": "i-cursor"},{"full": "fas fa-id-badge","shorty": "id-badge"},{"full": "fas fa-id-card","shorty": "id-card"},{"full": "fas fa-id-card-alt","shorty": "id-card-alt"},{"full": "fas fa-image","shorty": "image"},{"full": "fas fa-images","shorty": "images"},{"full": "fas fa-inbox","shorty": "inbox"},{"full": "fas fa-indent","shorty": "indent"},{"full": "fas fa-industry","shorty": "industry"},{"full": "fas fa-infinity","shorty": "infinity"},{"full": "fas fa-info","shorty": "info"},{"full": "fas fa-info-circle","shorty": "info-circle"},{"full": "fas fa-italic","shorty": "italic"},{"full": "fas fa-jedi","shorty": "jedi"},{"full": "fas fa-joint","shorty": "joint"},{"full": "fas fa-journal-whills","shorty": "journal-whills"},{"full": "fas fa-kaaba","shorty": "kaaba"},{"full": "fas fa-key","shorty": "key"},{"full": "fas fa-keyboard","shorty": "keyboard"},{"full": "fas fa-khanda","shorty": "khanda"},{"full": "fas fa-kiss","shorty": "kiss"},{"full": "fas fa-kiss-beam","shorty": "kiss-beam"},{"full": "fas fa-kiss-wink-heart","shorty": "kiss-wink-heart"},{"full": "fas fa-kiwi-bird","shorty": "kiwi-bird"},{"full": "fas fa-landmark","shorty": "landmark"},{"full": "fas fa-language","shorty": "language"},{"full": "fas fa-laptop","shorty": "laptop"},{"full": "fas fa-laptop-code","shorty": "laptop-code"},{"full": "fas fa-laugh","shorty": "laugh"},{"full": "fas fa-laugh-beam","shorty": "laugh-beam"},{"full": "fas fa-laugh-squint","shorty": "laugh-squint"},{"full": "fas fa-laugh-wink","shorty": "laugh-wink"},{"full": "fas fa-layer-group","shorty": "layer-group"},{"full": "fas fa-leaf","shorty": "leaf"},{"full": "fas fa-lemon","shorty": "lemon"},{"full": "fas fa-less-than","shorty": "less-than"},{"full": "fas fa-less-than-equal","shorty": "less-than-equal"},{"full": "fas fa-level-down-alt","shorty": "level-down-alt"},{"full": "fas fa-level-up-alt","shorty": "level-up-alt"},{"full": "fas fa-life-ring","shorty": "life-ring"},{"full": "fas fa-lightbulb","shorty": "lightbulb"},{"full": "fas fa-link","shorty": "link"},{"full": "fas fa-lira-sign","shorty": "lira-sign"},{"full": "fas fa-list","shorty": "list"},{"full": "fas fa-list-alt","shorty": "list-alt"},{"full": "fas fa-list-ol","shorty": "list-ol"},{"full": "fas fa-list-ul","shorty": "list-ul"},{"full": "fas fa-location-arrow","shorty": "location-arrow"},{"full": "fas fa-lock","shorty": "lock"},{"full": "fas fa-lock-open","shorty": "lock-open"},{"full": "fas fa-long-arrow-alt-down","shorty": "long-arrow-alt-down"},{"full": "fas fa-long-arrow-alt-left","shorty": "long-arrow-alt-left"},{"full": "fas fa-long-arrow-alt-right","shorty": "long-arrow-alt-right"},{"full": "fas fa-long-arrow-alt-up","shorty": "long-arrow-alt-up"},{"full": "fas fa-low-vision","shorty": "low-vision"},{"full": "fas fa-luggage-cart","shorty": "luggage-cart"},{"full": "fas fa-magic","shorty": "magic"},{"full": "fas fa-magnet","shorty": "magnet"},{"full": "fas fa-mail-bulk","shorty": "mail-bulk"},{"full": "fas fa-male","shorty": "male"},{"full": "fas fa-map","shorty": "map"},{"full": "fas fa-map-marked","shorty": "map-marked"},{"full": "fas fa-map-marked-alt","shorty": "map-marked-alt"},{"full": "fas fa-map-marker","shorty": "map-marker"},{"full": "fas fa-map-marker-alt","shorty": "map-marker-alt"},{"full": "fas fa-map-pin","shorty": "map-pin"},{"full": "fas fa-map-signs","shorty": "map-signs"},{"full": "fas fa-marker","shorty": "marker"},{"full": "fas fa-mars","shorty": "mars"},{"full": "fas fa-mars-double","shorty": "mars-double"},{"full": "fas fa-mars-stroke","shorty": "mars-stroke"},{"full": "fas fa-mars-stroke-h","shorty": "mars-stroke-h"},{"full": "fas fa-mars-stroke-v","shorty": "mars-stroke-v"},{"full": "fas fa-medal","shorty": "medal"},{"full": "fas fa-medkit","shorty": "medkit"},{"full": "fas fa-meh","shorty": "meh"},{"full": "fas fa-meh-blank","shorty": "meh-blank"},{"full": "fas fa-meh-rolling-eyes","shorty": "meh-rolling-eyes"},{"full": "fas fa-memory","shorty": "memory"},{"full": "fas fa-menorah","shorty": "menorah"},{"full": "fas fa-mercury","shorty": "mercury"},{"full": "fas fa-microchip","shorty": "microchip"},{"full": "fas fa-microphone","shorty": "microphone"},{"full": "fas fa-microphone-alt","shorty": "microphone-alt"},{"full": "fas fa-microphone-alt-slash","shorty": "microphone-alt-slash"},{"full": "fas fa-microphone-slash","shorty": "microphone-slash"},{"full": "fas fa-microscope","shorty": "microscope"},{"full": "fas fa-minus","shorty": "minus"},{"full": "fas fa-minus-circle","shorty": "minus-circle"},{"full": "fas fa-minus-square","shorty": "minus-square"},{"full": "fas fa-mobile","shorty": "mobile"},{"full": "fas fa-mobile-alt","shorty": "mobile-alt"},{"full": "fas fa-money-bill","shorty": "money-bill"},{"full": "fas fa-money-bill-alt","shorty": "money-bill-alt"},{"full": "fas fa-money-bill-wave","shorty": "money-bill-wave"},{"full": "fas fa-money-bill-wave-alt","shorty": "money-bill-wave-alt"},{"full": "fas fa-money-check","shorty": "money-check"},{"full": "fas fa-money-check-alt","shorty": "money-check-alt"},{"full": "fas fa-monument","shorty": "monument"},{"full": "fas fa-moon","shorty": "moon"},{"full": "fas fa-mortar-pestle","shorty": "mortar-pestle"},{"full": "fas fa-mosque","shorty": "mosque"},{"full": "fas fa-motorcycle","shorty": "motorcycle"},{"full": "fas fa-mouse-pointer","shorty": "mouse-pointer"},{"full": "fas fa-music","shorty": "music"},{"full": "fas fa-neuter","shorty": "neuter"},{"full": "fas fa-newspaper","shorty": "newspaper"},{"full": "fas fa-not-equal","shorty": "not-equal"},{"full": "fas fa-notes-medical","shorty": "notes-medical"},{"full": "fas fa-object-group","shorty": "object-group"},{"full": "fas fa-object-ungroup","shorty": "object-ungroup"},{"full": "fas fa-oil-can","shorty": "oil-can"},{"full": "fas fa-om","shorty": "om"},{"full": "fas fa-outdent","shorty": "outdent"},{"full": "fas fa-paint-brush","shorty": "paint-brush"},{"full": "fas fa-paint-roller","shorty": "paint-roller"},{"full": "fas fa-palette","shorty": "palette"},{"full": "fas fa-pallet","shorty": "pallet"},{"full": "fas fa-paper-plane","shorty": "paper-plane"},{"full": "fas fa-paperclip","shorty": "paperclip"},{"full": "fas fa-parachute-box","shorty": "parachute-box"},{"full": "fas fa-paragraph","shorty": "paragraph"},{"full": "fas fa-parking","shorty": "parking"},{"full": "fas fa-passport","shorty": "passport"},{"full": "fas fa-pastafarianism","shorty": "pastafarianism"},{"full": "fas fa-paste","shorty": "paste"},{"full": "fas fa-pause","shorty": "pause"},{"full": "fas fa-pause-circle","shorty": "pause-circle"},{"full": "fas fa-paw","shorty": "paw"},{"full": "fas fa-peace","shorty": "peace"},{"full": "fas fa-pen","shorty": "pen"},{"full": "fas fa-pen-alt","shorty": "pen-alt"},{"full": "fas fa-pen-fancy","shorty": "pen-fancy"},{"full": "fas fa-pen-nib","shorty": "pen-nib"},{"full": "fas fa-pen-square","shorty": "pen-square"},{"full": "fas fa-pencil-alt","shorty": "pencil-alt"},{"full": "fas fa-pencil-ruler","shorty": "pencil-ruler"},{"full": "fas fa-people-carry","shorty": "people-carry"},{"full": "fas fa-percent","shorty": "percent"},{"full": "fas fa-percentage","shorty": "percentage"},{"full": "fas fa-phone","shorty": "phone"},{"full": "fas fa-phone-slash","shorty": "phone-slash"},{"full": "fas fa-phone-square","shorty": "phone-square"},{"full": "fas fa-phone-volume","shorty": "phone-volume"},{"full": "fas fa-piggy-bank","shorty": "piggy-bank"},{"full": "fas fa-pills","shorty": "pills"},{"full": "fas fa-place-of-worship","shorty": "place-of-worship"},{"full": "fas fa-plane","shorty": "plane"},{"full": "fas fa-plane-arrival","shorty": "plane-arrival"},{"full": "fas fa-plane-departure","shorty": "plane-departure"},{"full": "fas fa-play","shorty": "play"},{"full": "fas fa-play-circle","shorty": "play-circle"},{"full": "fas fa-plug","shorty": "plug"},{"full": "fas fa-plus","shorty": "plus"},{"full": "fas fa-plus-circle","shorty": "plus-circle"},{"full": "fas fa-plus-square","shorty": "plus-square"},{"full": "fas fa-podcast","shorty": "podcast"},{"full": "fas fa-poll","shorty": "poll"},{"full": "fas fa-poll-h","shorty": "poll-h"},{"full": "fas fa-poo","shorty": "poo"},{"full": "fas fa-poop","shorty": "poop"},{"full": "fas fa-portrait","shorty": "portrait"},{"full": "fas fa-pound-sign","shorty": "pound-sign"},{"full": "fas fa-power-off","shorty": "power-off"},{"full": "fas fa-pray","shorty": "pray"},{"full": "fas fa-praying-hands","shorty": "praying-hands"},{"full": "fas fa-prescription","shorty": "prescription"},{"full": "fas fa-prescription-bottle","shorty": "prescription-bottle"},{"full": "fas fa-prescription-bottle-alt","shorty": "prescription-bottle-alt"},{"full": "fas fa-print","shorty": "print"},{"full": "fas fa-procedures","shorty": "procedures"},{"full": "fas fa-project-diagram","shorty": "project-diagram"},{"full": "fas fa-puzzle-piece","shorty": "puzzle-piece"},{"full": "fas fa-qrcode","shorty": "qrcode"},{"full": "fas fa-question","shorty": "question"},{"full": "fas fa-question-circle","shorty": "question-circle"},{"full": "fas fa-quidditch","shorty": "quidditch"},{"full": "fas fa-quote-left","shorty": "quote-left"},{"full": "fas fa-quote-right","shorty": "quote-right"},{"full": "fas fa-quran","shorty": "quran"},{"full": "fas fa-random","shorty": "random"},{"full": "fas fa-receipt","shorty": "receipt"},{"full": "fas fa-recycle","shorty": "recycle"},{"full": "fas fa-redo","shorty": "redo"},{"full": "fas fa-redo-alt","shorty": "redo-alt"},{"full": "fas fa-registered","shorty": "registered"},{"full": "fas fa-reply","shorty": "reply"},{"full": "fas fa-reply-all","shorty": "reply-all"},{"full": "fas fa-retweet","shorty": "retweet"},{"full": "fas fa-ribbon","shorty": "ribbon"},{"full": "fas fa-road","shorty": "road"},{"full": "fas fa-robot","shorty": "robot"},{"full": "fas fa-rocket","shorty": "rocket"},{"full": "fas fa-route","shorty": "route"},{"full": "fas fa-rss","shorty": "rss"},{"full": "fas fa-rss-square","shorty": "rss-square"},{"full": "fas fa-ruble-sign","shorty": "ruble-sign"},{"full": "fas fa-ruler","shorty": "ruler"},{"full": "fas fa-ruler-combined","shorty": "ruler-combined"},{"full": "fas fa-ruler-horizontal","shorty": "ruler-horizontal"},{"full": "fas fa-ruler-vertical","shorty": "ruler-vertical"},{"full": "fas fa-rupee-sign","shorty": "rupee-sign"},{"full": "fas fa-sad-cry","shorty": "sad-cry"},{"full": "fas fa-sad-tear","shorty": "sad-tear"},{"full": "fas fa-save","shorty": "save"},{"full": "fas fa-school","shorty": "school"},{"full": "fas fa-screwdriver","shorty": "screwdriver"},{"full": "fas fa-search","shorty": "search"},{"full": "fas fa-search-dollar","shorty": "search-dollar"},{"full": "fas fa-search-location","shorty": "search-location"},{"full": "fas fa-search-minus","shorty": "search-minus"},{"full": "fas fa-search-plus","shorty": "search-plus"},{"full": "fas fa-seedling","shorty": "seedling"},{"full": "fas fa-server","shorty": "server"},{"full": "fas fa-shapes","shorty": "shapes"},{"full": "fas fa-share","shorty": "share"},{"full": "fas fa-share-alt","shorty": "share-alt"},{"full": "fas fa-share-alt-square","shorty": "share-alt-square"},{"full": "fas fa-share-square","shorty": "share-square"},{"full": "fas fa-shekel-sign","shorty": "shekel-sign"},{"full": "fas fa-shield-alt","shorty": "shield-alt"},{"full": "fas fa-ship","shorty": "ship"},{"full": "fas fa-shipping-fast","shorty": "shipping-fast"},{"full": "fas fa-shoe-prints","shorty": "shoe-prints"},{"full": "fas fa-shopping-bag","shorty": "shopping-bag"},{"full": "fas fa-shopping-basket","shorty": "shopping-basket"},{"full": "fas fa-shopping-cart","shorty": "shopping-cart"},{"full": "fas fa-shower","shorty": "shower"},{"full": "fas fa-shuttle-van","shorty": "shuttle-van"},{"full": "fas fa-sign","shorty": "sign"},{"full": "fas fa-sign-in-alt","shorty": "sign-in-alt"},{"full": "fas fa-sign-language","shorty": "sign-language"},{"full": "fas fa-sign-out-alt","shorty": "sign-out-alt"},{"full": "fas fa-signal","shorty": "signal"},{"full": "fas fa-signature","shorty": "signature"},{"full": "fas fa-sitemap","shorty": "sitemap"},{"full": "fas fa-skull","shorty": "skull"},{"full": "fas fa-sliders-h","shorty": "sliders-h"},{"full": "fas fa-smile","shorty": "smile"},{"full": "fas fa-smile-beam","shorty": "smile-beam"},{"full": "fas fa-smile-wink","shorty": "smile-wink"},{"full": "fas fa-smoking","shorty": "smoking"},{"full": "fas fa-smoking-ban","shorty": "smoking-ban"},{"full": "fas fa-snowflake","shorty": "snowflake"},{"full": "fas fa-socks","shorty": "socks"},{"full": "fas fa-solar-panel","shorty": "solar-panel"},{"full": "fas fa-sort","shorty": "sort"},{"full": "fas fa-sort-alpha-down","shorty": "sort-alpha-down"},{"full": "fas fa-sort-alpha-up","shorty": "sort-alpha-up"},{"full": "fas fa-sort-amount-down","shorty": "sort-amount-down"},{"full": "fas fa-sort-amount-up","shorty": "sort-amount-up"},{"full": "fas fa-sort-down","shorty": "sort-down"},{"full": "fas fa-sort-numeric-down","shorty": "sort-numeric-down"},{"full": "fas fa-sort-numeric-up","shorty": "sort-numeric-up"},{"full": "fas fa-sort-up","shorty": "sort-up"},{"full": "fas fa-spa","shorty": "spa"},{"full": "fas fa-space-shuttle","shorty": "space-shuttle"},{"full": "fas fa-spinner","shorty": "spinner"},{"full": "fas fa-splotch","shorty": "splotch"},{"full": "fas fa-spray-can","shorty": "spray-can"},{"full": "fas fa-square","shorty": "square"},{"full": "fas fa-square-full","shorty": "square-full"},{"full": "fas fa-square-root-alt","shorty": "square-root-alt"},{"full": "fas fa-stamp","shorty": "stamp"},{"full": "fas fa-star","shorty": "star"},{"full": "fas fa-star-and-crescent","shorty": "star-and-crescent"},{"full": "fas fa-star-half","shorty": "star-half"},{"full": "fas fa-star-half-alt","shorty": "star-half-alt"},{"full": "fas fa-star-of-david","shorty": "star-of-david"},{"full": "fas fa-star-of-life","shorty": "star-of-life"},{"full": "fas fa-step-backward","shorty": "step-backward"},{"full": "fas fa-step-forward","shorty": "step-forward"},{"full": "fas fa-stethoscope","shorty": "stethoscope"},{"full": "fas fa-sticky-note","shorty": "sticky-note"},{"full": "fas fa-stop","shorty": "stop"},{"full": "fas fa-stop-circle","shorty": "stop-circle"},{"full": "fas fa-stopwatch","shorty": "stopwatch"},{"full": "fas fa-store","shorty": "store"},{"full": "fas fa-store-alt","shorty": "store-alt"},{"full": "fas fa-stream","shorty": "stream"},{"full": "fas fa-street-view","shorty": "street-view"},{"full": "fas fa-strikethrough","shorty": "strikethrough"},{"full": "fas fa-stroopwafel","shorty": "stroopwafel"},{"full": "fas fa-subscript","shorty": "subscript"},{"full": "fas fa-subway","shorty": "subway"},{"full": "fas fa-suitcase","shorty": "suitcase"},{"full": "fas fa-suitcase-rolling","shorty": "suitcase-rolling"},{"full": "fas fa-sun","shorty": "sun"},{"full": "fas fa-superscript","shorty": "superscript"},{"full": "fas fa-surprise","shorty": "surprise"},{"full": "fas fa-swatchbook","shorty": "swatchbook"},{"full": "fas fa-swimmer","shorty": "swimmer"},{"full": "fas fa-swimming-pool","shorty": "swimming-pool"},{"full": "fas fa-synagogue","shorty": "synagogue"},{"full": "fas fa-sync","shorty": "sync"},{"full": "fas fa-sync-alt","shorty": "sync-alt"},{"full": "fas fa-syringe","shorty": "syringe"},{"full": "fas fa-table","shorty": "table"},{"full": "fas fa-table-tennis","shorty": "table-tennis"},{"full": "fas fa-tablet","shorty": "tablet"},{"full": "fas fa-tablet-alt","shorty": "tablet-alt"},{"full": "fas fa-tablets","shorty": "tablets"},{"full": "fas fa-tachometer-alt","shorty": "tachometer-alt"},{"full": "fas fa-tag","shorty": "tag"},{"full": "fas fa-tags","shorty": "tags"},{"full": "fas fa-tape","shorty": "tape"},{"full": "fas fa-tasks","shorty": "tasks"},{"full": "fas fa-taxi","shorty": "taxi"},{"full": "fas fa-teeth","shorty": "teeth"},{"full": "fas fa-teeth-open","shorty": "teeth-open"},{"full": "fas fa-terminal","shorty": "terminal"},{"full": "fas fa-text-height","shorty": "text-height"},{"full": "fas fa-text-width","shorty": "text-width"},{"full": "fas fa-th","shorty": "th"},{"full": "fas fa-th-large","shorty": "th-large"},{"full": "fas fa-th-list","shorty": "th-list"},{"full": "fas fa-theater-masks","shorty": "theater-masks"},{"full": "fas fa-thermometer","shorty": "thermometer"},{"full": "fas fa-thermometer-empty","shorty": "thermometer-empty"},{"full": "fas fa-thermometer-full","shorty": "thermometer-full"},{"full": "fas fa-thermometer-half","shorty": "thermometer-half"},{"full": "fas fa-thermometer-quarter","shorty": "thermometer-quarter"},{"full": "fas fa-thermometer-three-quarters","shorty": "thermometer-three-quarters"},{"full": "fas fa-thumbs-down","shorty": "thumbs-down"},{"full": "fas fa-thumbs-up","shorty": "thumbs-up"},{"full": "fas fa-thumbtack","shorty": "thumbtack"},{"full": "fas fa-ticket-alt","shorty": "ticket-alt"},{"full": "fas fa-times","shorty": "times"},{"full": "fas fa-times-circle","shorty": "times-circle"},{"full": "fas fa-tint","shorty": "tint"},{"full": "fas fa-tint-slash","shorty": "tint-slash"},{"full": "fas fa-tired","shorty": "tired"},{"full": "fas fa-toggle-off","shorty": "toggle-off"},{"full": "fas fa-toggle-on","shorty": "toggle-on"},{"full": "fas fa-toolbox","shorty": "toolbox"},{"full": "fas fa-tooth","shorty": "tooth"},{"full": "fas fa-torah","shorty": "torah"},{"full": "fas fa-torii-gate","shorty": "torii-gate"},{"full": "fas fa-trademark","shorty": "trademark"},{"full": "fas fa-traffic-light","shorty": "traffic-light"},{"full": "fas fa-train","shorty": "train"},{"full": "fas fa-transgender","shorty": "transgender"},{"full": "fas fa-transgender-alt","shorty": "transgender-alt"},{"full": "fas fa-trash","shorty": "trash"},{"full": "fas fa-trash-alt","shorty": "trash-alt"},{"full": "fas fa-tree","shorty": "tree"},{"full": "fas fa-trophy","shorty": "trophy"},{"full": "fas fa-truck","shorty": "truck"},{"full": "fas fa-truck-loading","shorty": "truck-loading"},{"full": "fas fa-truck-monster","shorty": "truck-monster"},{"full": "fas fa-truck-moving","shorty": "truck-moving"},{"full": "fas fa-truck-pickup","shorty": "truck-pickup"},{"full": "fas fa-tshirt","shorty": "tshirt"},{"full": "fas fa-tty","shorty": "tty"},{"full": "fas fa-tv","shorty": "tv"},{"full": "fas fa-umbrella","shorty": "umbrella"},{"full": "fas fa-umbrella-beach","shorty": "umbrella-beach"},{"full": "fas fa-underline","shorty": "underline"},{"full": "fas fa-undo","shorty": "undo"},{"full": "fas fa-undo-alt","shorty": "undo-alt"},{"full": "fas fa-universal-access","shorty": "universal-access"},{"full": "fas fa-university","shorty": "university"},{"full": "fas fa-unlink","shorty": "unlink"},{"full": "fas fa-unlock","shorty": "unlock"},{"full": "fas fa-unlock-alt","shorty": "unlock-alt"},{"full": "fas fa-upload","shorty": "upload"},{"full": "fas fa-user","shorty": "user"},{"full": "fas fa-user-alt","shorty": "user-alt"},{"full": "fas fa-user-alt-slash","shorty": "user-alt-slash"},{"full": "fas fa-user-astronaut","shorty": "user-astronaut"},{"full": "fas fa-user-check","shorty": "user-check"},{"full": "fas fa-user-circle","shorty": "user-circle"},{"full": "fas fa-user-clock","shorty": "user-clock"},{"full": "fas fa-user-cog","shorty": "user-cog"},{"full": "fas fa-user-edit","shorty": "user-edit"},{"full": "fas fa-user-friends","shorty": "user-friends"},{"full": "fas fa-user-graduate","shorty": "user-graduate"},{"full": "fas fa-user-lock","shorty": "user-lock"},{"full": "fas fa-user-md","shorty": "user-md"},{"full": "fas fa-user-minus","shorty": "user-minus"},{"full": "fas fa-user-ninja","shorty": "user-ninja"},{"full": "fas fa-user-plus","shorty": "user-plus"},{"full": "fas fa-user-secret","shorty": "user-secret"},{"full": "fas fa-user-shield","shorty": "user-shield"},{"full": "fas fa-user-slash","shorty": "user-slash"},{"full": "fas fa-user-tag","shorty": "user-tag"},{"full": "fas fa-user-tie","shorty": "user-tie"},{"full": "fas fa-user-times","shorty": "user-times"},{"full": "fas fa-users","shorty": "users"},{"full": "fas fa-users-cog","shorty": "users-cog"},{"full": "fas fa-utensil-spoon","shorty": "utensil-spoon"},{"full": "fas fa-utensils","shorty": "utensils"},{"full": "fas fa-vector-square","shorty": "vector-square"},{"full": "fas fa-venus","shorty": "venus"},{"full": "fas fa-venus-double","shorty": "venus-double"},{"full": "fas fa-venus-mars","shorty": "venus-mars"},{"full": "fas fa-vial","shorty": "vial"},{"full": "fas fa-vials","shorty": "vials"},{"full": "fas fa-video","shorty": "video"},{"full": "fas fa-video-slash","shorty": "video-slash"},{"full": "fas fa-vihara","shorty": "vihara"},{"full": "fas fa-volleyball-ball","shorty": "volleyball-ball"},{"full": "fas fa-volume-down","shorty": "volume-down"},{"full": "fas fa-volume-off","shorty": "volume-off"},{"full": "fas fa-volume-up","shorty": "volume-up"},{"full": "fas fa-walking","shorty": "walking"},{"full": "fas fa-wallet","shorty": "wallet"},{"full": "fas fa-warehouse","shorty": "warehouse"},{"full": "fas fa-weight","shorty": "weight"},{"full": "fas fa-weight-hanging","shorty": "weight-hanging"},{"full": "fas fa-wheelchair","shorty": "wheelchair"},{"full": "fas fa-wifi","shorty": "wifi"},{"full": "fas fa-window-close","shorty": "window-close"},{"full": "fas fa-window-maximize","shorty": "window-maximize"},{"full": "fas fa-window-minimize","shorty": "window-minimize"},{"full": "fas fa-window-restore","shorty": "window-restore"},{"full": "fas fa-wine-glass","shorty": "wine-glass"},{"full": "fas fa-wine-glass-alt","shorty": "wine-glass-alt"},{"full": "fas fa-won-sign","shorty": "won-sign"},{"full": "fas fa-wrench","shorty": "wrench"},{"full": "fas fa-x-ray","shorty": "x-ray"},{"full": "fas fa-yen-sign","shorty": "yen-sign"},{"full": "fas fa-yin-yang","shorty": "yin-yang"}]    
                                 
            },
             
             templateUrl: 'ktdirectivetemplates/ktIconPicker.html',
			 link: function (scope, elem, attrs) {
                 
                 scope.CTRL='ktIconPicker'
                 scope.filteredIcons=[];
                 scope.iconsFilter={filter:null,filteringIcons:false};
                 scope.showIcons=false;
                 scope.showButtons=false;
                 scope.itemsLoaded=false;
    
 
 
                 scope.resetStyle = function () {
                      scope.selectedIcon=null;
					  scope.selectedButton=null
                 }
				 
				 
                 scope.showIconsFunc = function (state) {      
                        if (state) {
							scope.filteredIcons = scope.icons   
							scope.itemsLoaded = true;
                        } else {
                        }
                      scope.showIcons=state;
                      scope.showButtons=state;  
                      scope.iconsFilter.filter='';  
                 };
                 

                  //when icon is selected
                  scope.iconChosen = function (id) {
                      scope.selectedIcon=id.full;
                 }
                 
                 
                 //when button style is selected
                  scope.styleChosen = function (id) {
                      scope.selectedButton=id;
                 }
                 
                 
                  scope.showButtonsFunc = function (state) {
                      scope.showButtons=state;  
                 }
                
                
                
                   scope.getBtnClass = function () {
                       //debugger
                    var btnCls ="btn btn-outline-primary btn-sm"; //default class
                    if (scope.selectedButton!="" && scope.selectedButton!=undefined)  {
                        btnCls = scope.selectedButton+" btn btn-sm";
                    }
                        return btnCls;
                 };
                  
                   
                 scope.pickIcon = function () {
                     scope.showIcons=true;
                     scope.showButtons=false; 
                 }   

                 scope.pickAll= function () {
                     scope.showIcons=true;
                     scope.showButtons=true;
                     console.log('pick button');
                  }
				 
                scope.pickButton = function () {
                     scope.showButtons=true;
                     scope.showIcons=false;
                     //console.log('pick button='+  $scope.selectedButton);
                 }   
                 

                scope.filterFn = function(currIcon)     {
                        if (currIcon.indexOf(scope.iconsFilter.filter)!== -1) {
                                return true; // this will be listed in the results
                            }
                            return false; // otherwise it won't be within the results
                        };
                
                scope.hideBtns=function() {
                    scope.showButtons=false; 
                  };
  

                
                scope.getFilteringStatus=function()  {       
                    return  scope.iconsFilter.filteringIcons;    
                  };

                scope.changed_filter=function () {
                       scope.filteredIcons=[]
                          for (var i=0;i<scope.icons.length;i++)  {
                               if (scope.icons[i].shorty.indexOf(scope.iconsFilter.filter)!== -1) 
                                    scope.filteredIcons.push(scope.icons[i])
                          }                           
                };
                  
                  
        
             },
             scope:{
                  selectedIcon:'=',
                  title:'=?',
				  setDisabled:'=?',
                  selectedButton:'=',
                  btnLabel:'=',
                  selectIcons:'=',
                  selectColors:'=',
                  uniqueId:'=',
                  showIcons:'<',
                  showButtons:'<',
                  designMode:'<',

            
        }
      }
};
'use strict';

export function ktImage () {
 return {
      restrict: 'A',

	  controller: function ($scope,$rootScope,GridsterService,MessagingService, ResourcesDataService,KatalyoStateManager,WidgetDataExchangeService)
	  {      
		$scope.fd.ImageUrl=''
	  
        if ($scope.fd.localVars==undefined) $scope.fd.localVars={};
		
        $scope.fd.localVars.showMenu = false
      
        $scope.fd.localVars.toggleDropdown = function(){
            $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
        }

		$scope.fd.localVars.convertToDropdownList = function (inputlist, uid)
		{
			for (let i=0; i<inputlist.length;i++){
				inputlist[i] = { 
					id: inputlist[i]['resource' + uid + '_id'], 
					name: inputlist[i]['resource' + uid + '_FileName'],
                    guid: inputlist[i]['resource' + uid + '_guid']
				}
			}
		}
		
		$scope.fd.localVars.getRecordListOnInit = async function()  {
		
			let data = await ResourcesDataService.getDatasetDataSimple($scope.fd.Parameters.FileDefId?.id)	
			$scope.fd.localVars.convertToDropdownList (data.data, $scope.fd.Parameters.FileDefId?.id )
			$scope.fd.localVars.fileRecords = data.data
            if ($scope.fd.Parameters.FileId?.length>0)
            {
             let pos
             pos = $scope.fd.localVars.fileRecords.map(function(e) { return e.guid }).indexOf($scope.fd.Parameters.FileId)
             if (pos>=0) $scope.fd.localVars.recordSelected = $scope.fd.localVars.fileRecords[pos]
            }
		}
		
		if ( $scope.resourceDefinition.form_definition && $scope.fd.Parameters?.FileId  && $scope.fd.Parameters.FileDefId?.id) {
			
				$scope.fd.localVars.getRecordListOnInit()
				
		}
		
		
		$scope.fd.localVars.fileSelected = async function (selected) {//Prepare list for dropdown ( {id , name})
			let id = selected.id//.split("_")[0]
			let data = await ResourcesDataService.getDatasetDataSimple(id)	
			$scope.fd.localVars.convertToDropdownList (data.data, selected.id)
			$scope.fd.localVars.fileRecords = data.data
		}
				
		
		$scope.fd.localVars.fileRecordSelected =  function (selected) {		
						$scope.fd.Parameters.FileId = selected.guid
		}
				
		

         $scope.taskId = $scope.resourceDefinition.ResourceDefId;
         $scope.fd.localVars.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
         $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;
         $scope.fd.localVars.source_type=$scope.resourceDefinition.source_type;
         $scope.fd.localVars.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
         $scope.fd.localVars.taskExecuteId = $scope.resourceDefinition.task_execute_id;
         $scope.fd.localVars.formDefinition = $scope.resourceDefinition.form_definition;
         $scope.fd.localVars.resourceRecordId = 0;
         $scope.fd.ParentElementId = 0;
         if ($scope.fd.localVars.formDefinition==undefined) $scope.fd.localVars.formDefinition = false;
         if ($scope.fd.localVars.taskInitiateId==undefined) $scope.fd.localVars.taskInitiateId =0;
         if ($scope.fd.localVars.taskExecuteId==undefined) $scope.fd.localVars.taskExecuteId =0;
         if ($scope.fd.localVars.prevTaskExeId==undefined) $scope.fd.localVars.prevTaskExeId =0;
		if ($scope.fd.localVars==undefined)  $scope.fd.localVars={}

        var widgetDefinition = {name: 'ktImage',widgetId: $scope.fd.PresentationId,taskId:  $scope.taskId,
        task_initiate_id:$scope.fd.localVars.taskInitiateId,task_execute_id:$scope.fd.localVars.taskExecuteId};
        $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
        $scope.fd.localVars.LocalId=$scope.fd.localVars.localWidgetId;
        $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
        
        
        $scope.fd.localVars.showMenu = false
        
         $scope.fd.localVars.toggleDropdown = function(){
             $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
         }
         
         
        $scope.fd.localVars.setField = function(form,name,value,msg)
        {
            TaskDataService.setField(form,name,value);
             if (msg) MessagingService.addMessage(msg,'info');
        };
                    
        $scope.ksm=KatalyoStateManager
                    
                     /**********************************************************************
                     ****************** Sync data with State manager **********************
                     ***********************************************************************/
                    let dependent_field_pid = $scope.fd.LocalId;
                    let subscribedSubjectPid = "formDefinitionState"+$scope.taskId+$scope.resourceDefinition.form_type;
                    let dependent_field_pid2
                    let update_presentation_id2 = function(data) {
                        let presentation_id = angular.copy($scope.fd.PresentationId)
                        if (data[presentation_id]!==undefined)
                        {
                            $scope.fd.PresentationId = data[presentation_id];
                        //unsubscribe here later after implementing unsubscribe - ToDo
                        dependent_field_pid2 = $scope.fd.PresentationId
                        let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
                        }
                    }
                    let update_presentation_id = function(data) {
                        if (data[$scope.fd.LocalId]>0 && ($scope.fd.PresentationId==0 ||  $scope.fd.PresentationId==null)  && data[$scope.fd.LocalId]!==undefined) $scope.fd.PresentationId = data[$scope.fd.LocalId];
                      
                        let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
                        //unsubscribe here later after implementing unsubscribe - ToDo
                    }
                    
                    
                    if ($scope.fd.PresentationId===null || $scope.fd.PresentationId===0)
                    {
                        let observerPid = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid,"formSaved",update_presentation_id);
                    } else{
                        dependent_field_pid2 = $scope.fd.PresentationId
                        let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
                    }
        
		
		

     $scope.gsrvc= GridsterService;

      if ($scope.resourceDefinition.form_definition){
                    ResourcesDataService.getResourceDefListByType($rootScope.globals.currentUser.lang,'file').then(
                        function(data) {            
                            $scope.fd.localVars.listOfFileTypes = data.data;
                         }
                        ,function(error){   MessagingService.addMessage(error.msg,'error')  }
                    );
        }
     
	 $scope.fd.downloadImage = function(fileDefId,fileId)
	 {
          ResourcesDataService.downloadFile(fileDefId,fileId).then(
				function(data) {  
                             var url = URL.createObjectURL(new Blob([data.data]));
                              $scope.fd.ImageUrl=url
                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
   
				});
      };// dowload image
	  

      if ($scope.fd.Parameters.FileDefId?.id && $scope.fd.Parameters.FileId?.length>0) 
				$scope.fd.downloadImage( $scope.fd.Parameters.FileDefId?.id,$scope.fd.Parameters.FileId)
   },
   
     templateUrl: 'ktdirectivetemplates/ktImage.html',
     link: function (scope, elem, attrs) {      
               
            }
        };
};
'use strict';

export function ktInitiateTaskWidget ($timeout) {

  return {
          restrict: 'A',
          templateUrl: 'ktdirectivetemplates/ktInitiateTaskWidget.html',
          controller: function($scope,$rootScope,UserService,ResourcesDataService,TaskDataService,MessagingService,KatalyoStateManager,GridsterService,$timeout,$state,$stateParams) 
		  {
                $scope.gsrvc= GridsterService;
                $scope.CTRL='ktInitiateTaskWidget'
                
                if ($scope.fd.FormDef==undefined) $scope.fd.FormDef= []
                if ($scope.resourceDefinition!=undefined) {
                  $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
                }
                
                if ($scope.fd.localVars == undefined) $scope.fd.localVars={};
                $scope.fd.localVars.loadedTasks = [];
                $scope.fd.localVars.resourceItem = {}
                $scope.fd.localVars.selectedResource = {};
                $scope.fd.localVars.showMenu = false
				$scope.fd.localVars.resourceLoaded = false
      
                $scope.fd.localVars.toggleDropdown = function(){
                           $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
                }
  
                if ($scope.fd.ElementType=="itask") 	$scope.fd.localVars.datasetMapperType=0;                
                
 
                /*********** SETUP KATALYO STATE MANAGER *************************/
                $scope.ksm = KatalyoStateManager;
                let initiatedTaskId=null;
                let initiateTaskState= $scope.ksm.addSubject('initiateTaskStateName'+$scope.fd.PresentationId,initiatedTaskId);
                let initiateTaskStateName = initiateTaskState.subject.name;
                
                let task_initiated = function(data)
                {
                    initiateTaskState.subject.setStateChanges = data;
                    initiateTaskState.subject.notifyObservers("taskInitiated");
                    
                };
                
                let action_task_initiated = $scope.ksm.addAction(initiateTaskStateName,"taskInitiated",task_initiated);
                             
                $scope.$on('InlineTaskClosed',function(event,data){
                    var taskId=data;
                    var pos = $scope.fd.localVars.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
                    if (pos>=0) {
                      $scope.fd.localVars.loadedTasks.splice(pos,1);  
                    }
                });
               
                var lang=$rootScope.globals.currentUser.lang;
                $scope.fd.localVars.taskListParameters = {placeholder:'Select or search task...',label:$scope.fd.placeholder,name:'task',
                paddingLeft:true,selectedItem:null,hideLabel:true,columnSizeLabel:'col-lg-24',dropdownSize:'col-lg-24',onSelectFunction:''};
                
                if ($scope.fd.FormDef==undefined) $scope.fd.FormDef = [];
                $scope.fd.localVars.selectedResourceIndex=-1;
            

              
                $scope.fd.localVars.LoadTask=function(taskId,outcomeId,previousTask,openTaskType)
                {
                    
                    var localVars = {'isInlineTask':$scope.fd.localVars.isInlineTask,'OpenTaskType':openTaskType,'taskIndex':$scope.fd.localVars.loadedTasks.length,'loadTaskDirect' : true,'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,};
                    
                    if (openTaskType!="newPage") localVars.ShowCloseBtn = true;
                    else localVars.ShowReturnBtn = true;
                    var pos = $scope.fd.localVars.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (pos<0 && openTaskType=="current") {
                        $scope.fd.localVars.loadedTasks.splice(0,0,{'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                        
                    } else if (openTaskType=="inline")   {
                        $scope.fd.localVars.loadedTasks.length=0;
                        $scope.fd.localVars.loadedTasks.push({'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                    } else if (openTaskType=="container") {
                        localVars = {'isInlineTask':$scope.fd.localVars.isInlineTask,'OpenTaskType':'current','taskIndex':0,'loadTaskDirect' : true,'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,};
                    
                         $scope.ksm.executeAction(initiateTaskStateName,"taskInitiated", {'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});          
                    }
                    
                    if (openTaskType=="newPage") {
                        $scope.gsrvc.setTaskDataInNewPage({'localVars':localVars,'taskDefinition':$scope.resourceDefinition});
                    }
					
                    $scope.gsrvc.setOpenTaskType(openTaskType);   
                }
				  
                  
                $scope.fd.localVars.OpenPage = function(button)
                {
                        let page_version    
                        if (button.SelectVersionDirect) 
							page_version = button.selectedPublishedResource?.Version
                        else page_version=0
                        
                        $state.go(button.page_def.ResourceExtended.Target,{pageid: button.id,rinstance:0,version:page_version,parameters:{prev_task:$scope.resourceDefinition,page_state_id:$stateParams.parameters?.prev_page_state_id,prev_page_state_id:$scope.resourceDefinition.page_state_id,use_state:false}});
                }
                  
                
				$scope.fd.localVars.taskIsOpen = function(taskId)
                {
                    var isOpenPos = $scope.fd.localVars.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
                    if (isOpenPos>=0) return true 
                    return false
                }
                  
                     
              /*  $scope.fd.localVars.ShowResourceDefinition = function (resourceId)
				{
                      $scope.fd.localVars.showResourceDetails=true
                      if ($scope.fd.FormDef.length>0) {
                        for (var i=0;i<$scope.fd.FormDef.length;i++) {
                            if ($scope.fd.FormDef[i].id==resourceId) {
                                $scope.fd.localVars.selectedResourceIndex=i;
                                 $scope.fd.localVars.selectedResourceType = $scope.fd.FormDef[i].ResourceType;
                                $timeout(function() { 
										$scope.fd.localVars.resourceItem = $scope.fd.FormDef[i] //TODO .......
								});// resource Item is shown on screen 
                                break;
                              }
                        } 
                      } else {
                            //this is the first resource to be selectedItem - just show
                            if ($scope.fd.localVars.resourceItem) {    
                                 $scope.fd.localVars.selectedResourceIndex=0;    
                                 $scope.fd.localVars.selectedResourceType=$scope.fd.localVars.resourceItem.ResourceType
                                 $timeout(function() { });
                            }   
                        }      
                 }*/
                  
                    
                $scope.fd.localVars.ShowResourceDefinition = function (i)
				{
                      
                      $scope.fd.localVars.showResourceDetails=true

                      //debugger
					    
                    if ($scope.fd.FormDef.length>0 && $scope.fd.localVars.selectedResource!==$scope.fd.FormDef[i]) {
                        $scope.fd.localVars.showResourceDetails=true
                        $scope.fd.localVars.selectedResourceIndex=i;
                        //$scope.fd.localVars.selectedResourceType = $scope.fd.FormDef[i].ResourceType;
                        $scope.fd.localVars.selectedResource = $scope.fd.FormDef[i] 
						//$scope.fd.localVars.setResourceType ($scope.fd.localVars.selectedResourceType)// just to get list of all resources - resourceListForDropdown   
						$scope.fd.localVars.resourceItem.id= $scope.fd.FormDef[i].id
						$scope.fd.localVars.resourceItem.name= $scope.fd.FormDef[i].name 
						$scope.fd.localVars.resourceLoaded = false

                            $timeout(function(){ $scope.fd.localVars.resourceLoaded = true})
						    //$scope.fd.localVars.ShowResourceDetails()
                            
                            
                    }
                    /*
                    
                    else {  
                            if ($scope.fd.localVars.resourceItem) {    //this is the first resource to be selectedItem - just show
                                 $scope.fd.localVars.selectedResourceIndex=0;    
                                 //$scope.fd.localVars.selectedResourceType=$scope.fd.localVars.resourceItem.ResourceType
                            }
                        }        
                    */
                }
				   
				   
                   
                  $scope.fd.localVars.NewResource = function ()
				  {
						//debugger
						//RESET 
						$scope.fd.localVars.selectedResource = { ResourceType: null, id: null, name: '', btnLabel: '', btnClass: 'btn-primary'}
						//$scope.fd.localVars.selectedResourceType=null
						$scope.fd.localVars.resourceItem = {}
						if ($scope.clearDropdownValue) $scope.clearDropdownValue()
                     
						if (!$scope.fd.localVars.showResourceDetails) $scope.fd.localVars.showResourceDetails = true	  	
						 $scope.fd.localVars.selectedResourceIndex=-1
						 //$scope.fd.localVars.ShowResourceDetails()
				 }
					
			
				 $scope.setClearFn = function(theClearFn)
				 {
					  $scope.clearDropdownValue = theClearFn	  
				 }
				  
				  
                 $scope.fd.localVars.AddResource = function ()
				 {
                    //debugger
					if (!$scope.fd.localVars.selectedResourceType)  { MessagingService.addMessage('Action not selected!','warning'); return }
					if (!$scope.fd.localVars.resourceItem?.id && $scope.fd.localVars.selectedResourceType=='page')  { MessagingService.addMessage('Resource not selected!','warning'); return }
					//if ($scope.fd.localVars.selectedResource.btnLabel=='') { MessagingService.addMessage('Label is missing!','warning'); return }
					
                    $scope.fd.localVars.showResourceDetails=false

					if ($scope.fd.localVars.selectedResource===$scope.fd.FormDef[0])  return
					    
					$scope.fd.localVars.selectedResource.ResourceType = $scope.fd.localVars.selectedResourceType;
					$scope.fd.localVars.selectedResource.name = $scope.fd.localVars.resourceItem.name;
					$scope.fd.localVars.selectedResource.id = $scope.fd.localVars.resourceItem.id;
						
                    if ( $scope.fd.localVars.selectedResourceIndex == -1) $scope.fd.FormDef.push(angular.copy($scope.fd.localVars.selectedResource)); 

                    

                  }
                  
				  
                 
				 $scope.fd.localVars.ShowResourceDetails = function ()
				 {
                        if ($scope.fd.localVars.selectedResource?.id) {
                           
                            ResourcesDataService.getResourceDefAll($scope.fd.localVars.selectedResource.id).then( //get page
								function(data) {
										$scope.fd.localVars.selectedResource.page_def = data.data; 	
										$scope.fd.localVars.selectedResource.id=data.data.uid //TODO  - we probably dont need fd.localVars.selectedResource.id
										$scope.fd.localVars.selectedResource.name=data.data.Name//TODO  - we probably dont need fd.localVars.selectedResource.id
								 },function(error){
										MessagingService.addMessage(error.msg,'error');  
								});  
                        } else {
                            var pos = $scope.fd.FormDef.map(function(e) { if (e!=undefined) return e.id; else return null;}).indexOf($scope.fd.localVars.selectedResource.id);
                            // if (pos<0)   $scope.fd.FormDef.push(angular.copy($scope.fd.localVars.selectedResource)); 
                        }
                       
                        /*
                        if ($scope.fd.ElementType=='itask') 
                              $scope.fd.wItemValue = $scope.fd.FormDef;
                         else  
                              $scope.fd.tItemValue = $scope.fd.FormDef;
                        */

                    $scope.fd.localVars.showResourceDetails = true
                 };
				 
				 
               
                $scope.fd.localVars.RemoveResourceFromList = function (index)
				{
                        if (index>=0){
                                  $scope.fd.FormDef.splice(index,1);
                                  $scope.fd.localVars.selectedResourceIndex=-1;
                                  //$scope.fd.localVars.selectedResourceType=''
                                  $scope.fd.localVars.showResourceDetails=false;
                                       
                        }
                }
          
          
		  
                 $scope.fd.localVars.saveTaskToResource = function(tdid,tei,datasetDefId,datasetRecordId){
                          TaskDataService.saveTaskToResource(tei,datasetDefId,datasetRecordId,$scope.fd.presentationId)
                          .then(function(data) {                     
                              $state.go('app.navbar.tasks.initiate',{id: tdid,fromStateName:$state.current.name,fromStateParams:$state.params,outcome_id:0,prev_task_execute_id:tei});                                   
                           },function(error){
                                MessagingService.addMessage(error.msg,'error');
                            });
                 }
                 
                 
                 
                 $scope.fd.localVars.setResourceType = function (resource_type)//page or task - callback on button click
				 {
                  $scope.fd.localVars.selectedResourceType= resource_type;//TODO - mozda viska
				  $scope.fd.localVars.selectedResource.ResourceType= resource_type;
                  $scope.fd.localVars.resourceLoaded = false; 
                  if   ($scope.gsrvc.getFormViewType()==1 || $scope.fd.ElementType=='itask') {
                        ResourcesDataService.getResourceDefListByType(lang,resource_type).then(
							function(data) {                 
                                  $timeout(function() {
                                        $scope.fd.localVars.resourceListForDropdown = data.data;
                                        $scope.fd.localVars.resourceLoaded = true;         
                                  });    
                               },function(error){
                                  MessagingService.addMessage(error.msg,'error');
                            });
					}    
                    
                 }    
				

                $scope.fd.localVars.setResourceType('page')
				
                $scope.onSelectResourceCallback = function(selected, model)
				{
					 //debugger //onSelectResourceCallback
					 if ( selected?.id) {
                            ResourcesDataService.getResourceDefAll(selected.id).then( //get page
								function(data) {
										$scope.fd.localVars.selectedResource.page_def = data.data; 
										$scope.fd.localVars.selectedResource.id=data.data.uid //TODO  - we probably dont need fd.localVars.selectedResource.id
										$scope.fd.localVars.selectedResource.name=data.data.Name//TODO  - we probably dont need fd.localVars.selectedResource.name
                                        $scope.fd.localVars.showResourceDetails=true										
								 },function(error){
										MessagingService.addMessage(error.msg,'error');  
								});  
                        } 
											
				}

        },

        link: function (scope, elem, attrs) {     }       
              
    }
  
};
'use strict';

export function ktInput () {
        return {
            restrict: 'A',
		
             templateUrl: 'ktdirectivetemplates/ktInput.html',
             controller: function($scope,GridsterService,WidgetDataExchangeService,UtilityService){
				 
                $scope.gsrvc = GridsterService
				$scope.fd.showField=true
				
				
				if ($scope.fd.localVars==undefined)  $scope.fd.localVars={}
				
				$scope.fd.localVars.resourceDefinition = $scope.resourceDefinition	
				
				$scope.fd.localVars.gsrvc = $scope.gsrvc //because kt-delete-element
			
				if ($scope.fd.localVars.parentResourceId==undefined) $scope.fd.localVars.parentResourceId = $scope.resourceDefinition.pageId ?? $scope.resourceDefinition.uid // if directly on page 

                $scope.showProperties = function(event)
                {
                  $scope.fd.localVars.gsrvc.setFieldProperties($scope.fd,event);
                }
				
				
				
				  //register widget 
				  var out_fields = ['resourceId']
				  if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
							
				  let w_actions=[]

				  var widgetDefinition = {
					  DEI: [{'name':'resourceLink','displayName':'Dataset record id','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],
						actions: w_actions,
						widgetLabel: 'Label',
						widgetName: 'ktLabel',
						widgetId: $scope.fd.UuidRef,
						task_initiate_id:$scope.taskInitiateId,
						task_execute_id:$scope.taskExecuteId,
						taskId:  $scope.lTaskId,
						resource_id:$scope.resourceDefinition.page_state_id,
						resourceDefId : $scope.fd.Related, 
						output:out_fields,
						parentResourceId:$scope.fd.localVars?.parentResourceId
					}
				  
				  $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
				  $scope.fd.localVars.localId=$scope.fd.localVars.localWidgetId;
				  $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
				
				
				
                },//end controler
				
             link: function (scope, elem, attrs) {
              
              if (scope.fd) {
                  if (scope.fd.Parameters == null) scope.fd.Parameters = {} //null or undefined !
                 
                  scope.fd.isLabelStyle = true;
				  scope.fd.Parameters.HideElementProperties = false 
  
              }
            
            
           
            }
        };
};
'use strict';

export function ktKtlyoStaking () {
   
   var controller = ['$scope', '$uibModal','$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','KatalyoStateManager','UtilityService','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,KatalyoStateManager,UtilityService,$templateCache,$compile,$element) {
     
      $scope.localVarsWidget = {};
      //$scope.fd = {};
      $scope.localVarsWidget.searchFormDownloaded = false;
      $scope.localVarsWidget.formLoaded=false;
      $scope.localVarsWidget.src_type_text=CODES_CONST._POPULATE_TYPE_;
      $scope.localVarsWidget.animationsEnabled = true;
      $scope.localVarsWidget.widgetType = 3;
      $scope.gsrvc = GridsterService;
      $scope.localVarsWidget.formParams={formViewType:1,showGridNavigation:true};
      $scope.fd.contractDatasets = true;
      if ($scope.formData==undefined) $scope.formData={};
      if ($scope.formData[$scope.fd.PresentationId]==undefined) $scope.formData[$scope.fd.PresentationId]=[];
      $scope.fd.msgs={};
      $scope.localVarsWidget.datasetMapperType=0;
      $scope.fd.ShowTab=1;
      if ($scope.fd.PopulateType==undefined) $scope.fd.PopulateType="";
      $scope.fd.token1Contract="0x24E3794605C84E580EEA4972738D633E8a7127c8";
      $scope.fd.token1ContractAbi=[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}];;
      $scope.fd.token2Contract="0x1DE5e000C41C8d35b9f1f4985C23988f05831057";
      $scope.fd.token2ContractAbi=[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}];;
      $scope.fd.stakingContract="0x8C05bA21557936E3e0713dCE4F9C3bfc974f4C8E";
      $scope.fd.stakingContractAbi=[{"inputs":[{"internalType":"address","name":"_token1","type":"address"},{"internalType":"address","name":"_token2","type":"address"},{"internalType":"uint256","name":"_apy","type":"uint256"},{"internalType":"uint256","name":"_duration","type":"uint256"},{"internalType":"uint256","name":"_tokenRatio","type":"uint256"},{"internalType":"uint256","name":"_maxStakeAmt1","type":"uint256"},{"internalType":"uint256","name":"_rewardAmt1","type":"uint256"},{"internalType":"address","name":"_owner","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"sentDate","type":"uint256"}],"name":"AddedToBlackList","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"token1","type":"address"},{"indexed":false,"internalType":"address","name":"token2","type":"address"},{"indexed":false,"internalType":"uint256","name":"apy","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"duration","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"maxStakeAmt1","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"maxStakeAmt2","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"rewardAmt1","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"rewardAmt2","type":"uint256"},{"indexed":false,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"uint256","name":"createdAt","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"interestRate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"tokenRatio","type":"uint256"}],"name":"CreatedContract","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"redeemedDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"EarlyRedeemed","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"redeemedDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount2","type":"uint256"}],"name":"EarlyRedeemedAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Received","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"redeemedDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount2","type":"uint256"}],"name":"Redeemed","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"redeemedDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount2","type":"uint256"}],"name":"RedeemedAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"sentDate","type":"uint256"}],"name":"RemovedFromBlackList","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Reverted","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"address","name":"tokenCtr","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Staked","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"startDate","type":"uint256"}],"name":"StartStaking","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"stopDate","type":"uint256"}],"name":"StopStaking","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"sentDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"TransferBackReward","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"sentDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"TransferReward","type":"event"},{"stateMutability":"payable","type":"fallback"},{"inputs":[],"name":"activate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"apy","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"addressList","type":"address[]"},{"internalType":"bool","name":"blStatus","type":"bool"}],"name":"blackList","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"createdAt","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"deActivate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"duration","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"}],"name":"getBlackListedStatus","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getMyInfo","outputs":[{"components":[{"internalType":"address","name":"wallet","type":"address"},{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"createdAt","type":"uint256"},{"internalType":"bool","name":"redeemed","type":"bool"},{"internalType":"uint256","name":"rewardAmt1","type":"uint256"},{"internalType":"uint256","name":"rewardAmt2","type":"uint256"},{"internalType":"uint256","name":"redeemedAt","type":"uint256"},{"internalType":"uint256","name":"stakeEnd","type":"uint256"}],"internalType":"struct KtlyoStaking.Transaction[]","name":"","type":"tuple[]"},{"components":[{"internalType":"uint256","name":"limit1","type":"uint256"},{"internalType":"uint256","name":"limit2","type":"uint256"}],"internalType":"struct KtlyoStaking.MaxLimit","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getMyLimits","outputs":[{"components":[{"internalType":"uint256","name":"limit1","type":"uint256"},{"internalType":"uint256","name":"limit2","type":"uint256"}],"internalType":"struct KtlyoStaking.MaxLimit","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getMyStakings","outputs":[{"components":[{"internalType":"address","name":"wallet","type":"address"},{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"createdAt","type":"uint256"},{"internalType":"bool","name":"redeemed","type":"bool"},{"internalType":"uint256","name":"rewardAmt1","type":"uint256"},{"internalType":"uint256","name":"rewardAmt2","type":"uint256"},{"internalType":"uint256","name":"redeemedAt","type":"uint256"},{"internalType":"uint256","name":"stakeEnd","type":"uint256"}],"internalType":"struct KtlyoStaking.Transaction[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getRewardsInfo","outputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getStakeRewardAmounts","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"}],"name":"getStakings","outputs":[{"components":[{"internalType":"address","name":"wallet","type":"address"},{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"createdAt","type":"uint256"},{"internalType":"bool","name":"redeemed","type":"bool"},{"internalType":"uint256","name":"rewardAmt1","type":"uint256"},{"internalType":"uint256","name":"rewardAmt2","type":"uint256"},{"internalType":"uint256","name":"redeemedAt","type":"uint256"},{"internalType":"uint256","name":"stakeEnd","type":"uint256"}],"internalType":"struct KtlyoStaking.Transaction[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"info","outputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxStakeAmt1","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxStakeAmt2","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"indexId","type":"uint256"}],"name":"redeem","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"redeemAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"indexId","type":"uint256"}],"name":"redeemEarly","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"redeemEarlyAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"rewardAmt1","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"rewardAmt2","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"tokenContract","type":"address"},{"internalType":"uint256","name":"amt","type":"uint256"}],"name":"stake","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"token1","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"token2","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"reward_amount","type":"uint256"}],"name":"transferBackReward","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"reward_amount","type":"uint256"}],"name":"transferReward","outputs":[],"stateMutability":"nonpayable","type":"function"},{"stateMutability":"payable","type":"receive"}];
     
    
     
      $scope.localVarsWidget.gridsterType="resource";
          // $scope.gridsterOpts = GridsterService.getGridsterOptions();
    
    
        
      $scope.localVarsWidget.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: []
      } ;
        
    
  
      //$scope.taskId=$stateParams.id;
      $scope.taskId=$scope.resourceDefinition.ResourceDefId;
      if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
      if ($scope.taskId==undefined) $scope.taskId=0;
      $scope.localVarsWidget.taskId=$scope.taskId;
      $scope.fd.ParentDatasetDefId=$scope.fd.Related;
      $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
      $scope.localVarsWidget.formType=$scope.resourceDefinition.form_type;
      $scope.source_type=$scope.resourceDefinition.source_type;
      $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
      $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
      $scope.formDefinition = $scope.resourceDefinition.form_definition;
        
      if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
      $scope.localVarsWidget.resourceRecordId=0;
      if ($scope.taskInitiateId==undefined)
      {
        $scope.taskInitiateId =0;
      
      }
      if ($scope.taskExecuteId==undefined)
      {
         $scope.taskExecuteId =0;  
      }
        if ($scope.prevTaskExeId==undefined)
        {
            $scope.prevTaskExeId =0;
        }
        
      //register widget 
      var out_fields = ['resourceId'];
      //if ($scope.fd.LocalId==undefined || $scope.fd.LocalId==null || $scope.fd.LocalId==0)
      //{
         var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'viewResourceWidget',widgetId: $scope.fd.PresentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resourceDefId : $scope.localVarsWidget.selectedResource, output:out_fields, };
         $scope.localVarsWidget.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
         $scope.localVarsWidget.LocalId=$scope.localVarsWidget.localWidgetId;
         $scope.fd.LocalId=$scope.localVarsWidget.localWidgetId;
         //$scope.fd.LocalId=UtilityService.uuidNow();
         
      //}
      $scope.ksm = KatalyoStateManager;
      
      let update_presentation_id = function(data)
      {
         if (data[$scope.fd.LocalId]>0 && ($scope.fd.PresentationId==null || $scope.fd.PresentationId==0)) $scope.fd.PresentationId = data[$scope.fd.LocalId];
          //unsubscribe here later after implementing unsubscribe - ToDo
          
      }
      if ($scope.fd.PresentationId==0 || $scope.fd.PresentationId==null)
      {
         
         let dependent_field = $scope.fd.LocalId;
         let subscribedSubject = "formDefinitionState"+$scope.taskId+$scope.resourceDefinition.form_type;
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"formSaved",update_presentation_id);
  
      }        
      
       let apply_value = function(data)
        {
            let do_refresh=false;
            if (data!=undefined)
            {
               if (data != $scope.localVarsWidget.resourceRecordId)
               {
                  if (typeof data ==='number') $scope.localVarsWidget.resourceRecordId= data;
                  else if (Array.isArray(data))
                  {
                     if (data.length>0)
                     {
                      $scope.localVarsWidget.resourceRecordId= data[0].id  
                     }
                  }else
                  {
                     $scope.localVarsWidget.resourceRecordId = data.id;
                  }
                  do_refresh = true;
               }
            }
            //get selectedRecord
            if ($scope.localVarsWidget.resourceRecordId == null) $scope.localVarsWidget.resourceRecordId=0;
            
            if ($scope.localVarsWidget.resourceRecordId>0 && do_refresh) $scope.localVarsWidget.getFormResourceWithData();
            
            
        };
        
      
      if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
      
      if ($scope.fd.Parameters.RefreshOnIdChange)
      {
         
         //find 
         //subscribe observer
           
         let dependent_field = "Field"+$scope.fd.PresentationId;
         let subscribedSubject = "resourceidValueStateName"+$scope.fd.Parameters.ResourceIdItemId+$scope.resourceDefinition.transaction_id;
         let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
         let val = $scope.ksm.getState(subscribedSubject);
         $scope.localVarsWidget.resourceRecordId= val.id;
            
            //get selectedRecord
         if ($scope.localVarsWidget.resourceRecordId == null) $scope.localVarsWidget.resourceRecordId=0;
            
         if ($scope.localVarsWidget.resourceRecordId>0) $scope.localVarsWidget.getFormResourceWithData();
      }
      
      //subscribe observer
      if ($scope.fd.PopulateType.toString().substr(0,1)=="4")
      {
           /**********************************************************************
         ****************** Sync data with State manager **********************
         ***********************************************************************/
        
       
        if ($scope.fd.SrcWidgetId!=undefined && $scope.fd.SrcWidgetId!=null)
        
        {
           
                let dependent_field = "Field"+$scope.fd.SrcWidgetId;
               // let subscribedSubject = $scope.fd.Parameters.SrcWidgetType+"ValueStateName"+$scope.fd.SrcWidgetId;
                let subscribedSubject = "rlistValueStateName"+$scope.fd.SrcWidgetId+$scope.resourceDefinition.transaction_id;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
            
        }  
         
      }
      
      let refresh_widget_data = function()
      
      {
         $scope.localVarsWidget.getFormResourceWithData();    
         
      }
      if ($scope.fd.Parameters.EventName!=undefined)
      {
         if ($scope.fd.Parameters.EventName!="")
         {
            let dependent_field2 = "Field"+$scope.fd.PresentationId;
            let subscribedSubject2 = "task"+$scope.resourceDefinition.transaction_id;
            let observer2 = $scope.ksm.subscribe(subscribedSubject2,dependent_field2,$scope.fd.Parameters.EventName,refresh_widget_data);
         }
      }
      
      $scope.localVarsWidget.showProperties=function(datasetMapperType)
      {
            
            if ($scope.localVarsWidget.datasetMapperType==undefined)
            {
               $scope.localVarsWidget.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.localVarsWidget.datasetMapperType==0 || $scope.localVarsWidget.datasetMapperType!=datasetMapperType) $scope.localVarsWidget.datasetMapperType = datasetMapperType;
               else $scope.localVarsWidget.datasetMapperType=0;
            }
            
      };
           
      $scope.localVarsWidget.setField = function(form,name,value,msg)
      {
         TaskDataService.setField(form,name,value);
         if (msg) MessagingService.addMessage(msg,'info');
      };  
      
      $scope.localVarsWidget.getResourceAll = function () {
          
            ResourcesDataService.getResourceDefAll($scope.fd.Related).then(function(data) {
                               
                             // MessagingService.addMessage(data.msg,'success');
                              $scope.fd.resource = data.data;
                              $scope.localVarsWidget.resourceLoaded = true;
                              
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        };
      //$scope.localVarsWidget.getResourceAll();
      
        
      $scope.localVarsWidget.getFormResourceOriginal = function(datasetId){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
              $scope.localVarsWidget.formLoaded=false;
              ResourcesDataService.getResourceForm(datasetId,"i",lang).then(function(data) {
                            
                                $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                
                                if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                $scope.fd.wItemValue=data.data.widgets;
                                
                           /*
                                var container = $element.children().eq(0);
                                GridsterService.setupDragular($scope.fd.wItemValue,container,'rows-'+$scope.fd.PresentationId,'row-'+$scope.localVarsWidget.gridsterType+'-hadle',true);
                             */   
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.fd.ResourceRecordId}]}]});
						
                                  $scope.localVarsWidget.searchFormDownloaded = true;
                                  //$timeout(function(){$scope.localVarsWidget.formLoaded=true});
                                  $scope.localVarsWidget.formLoaded=true;
                                
                               // $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);     
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      
      $scope.fd.openStakeScreen=function(token){
         
         $scope.fd.ShowTab=2;
         if (token=='BNF') $scope.fd.ShowTab=3;
         $scope.fd.currentTokenTicker=token;
         $scope.fd.confirmation1 = null;
         $scope.fd.transactionHash1 = null;
         $scope.fd.errorMessage1 = null;
         $scope.fd.confirmation2 = null;
         $scope.fd.transactionHash2 = null;
         $scope.fd.errorMessage2 = null;
         
         if ($scope.fd.eth_address==undefined)
         {
            web3.eth.getAccounts().then(function (result) {
                      $timeout(function(){
                           $scope.fd.eth_address = result[0];
                            $scope.fd.getAllowance($scope.fd.eth_address,token);
                           $scope.fd.getMyLimits(token);
                      });
            });
         
         } else
         {
           $scope.fd.getAllowance($scope.fd.eth_address,token);
         $scope.fd.getMyLimits(token); 
            
         }
        
       
      }
      
      $scope.fd.getAllowance = function(wallet,token){
                  
                   var tokenAddress;
                   var tokenABI;
                   var contractAddress = $scope.fd.stakingContract;
                   if (token=="KTLYO")
                   {
                     tokenAddress= $scope.fd.token1Contract;
                     tokenABI = $scope.fd.token1ContractAbi;
                   }else
                   {
                     tokenAddress= $scope.fd.token2Contract;
                     tokenABI = $scope.fd.token2ContractAbi;
                     
                     
                   }
                  
            let web3;       
            if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to web3 wallet!",'error');
            }
                     
               if (web3!=null)
               {
                                var tokenInst = new web3.eth.Contract(tokenABI,tokenAddress);
                                
        
                                tokenInst.methods.allowance(wallet,contractAddress).call().then(function (allowance_raw) {
                                var bal = web3.utils.fromWei(allowance_raw, 'ether');
                                
                                $timeout(function(){$scope.fd.allowance = bal;});
                                });
                  }    
                 
      }
      
         $scope.fd.setAllowance = function(){
                  
                  $scope.fd.confirmation1 = null;
                  $scope.fd.transactionHash1 = null;
                  $scope.fd.errorMessage1 = null;
                   let web3;
                   var tokenAddress,tokenABI;
                   var spender = $scope.fd.stakingContract;
                   var owner = $scope.fd.eth_address;
                   var token = $scope.fd.currentTokenTicker;
                   if (token=="KTLYO")
                   {
                     tokenAddress= $scope.fd.token1Contract;
                     tokenABI = $scope.fd.token1ContractAbi;
                   }else
                   {
                     tokenAddress= $scope.fd.token2Contract;
                     tokenABI = $scope.fd.token2ContractAbi;
                     
                     
                   }
                   if (window.ethereum)
                     {
                      web3= new Web3(window.ethereum);  
                     }else if (window.web3)
                     {
                        web3= new Web3(window.web3); 
                     }else
                     {
                        web3 = null;
                        MessagingService.addMessage("Error connecting to wallet!",'error');
                     }
                              
                        if (web3!=null)
                        {
                                var tokenInst = new web3.eth.Contract(tokenABI,tokenAddress);
                                
                                tokenInst.options.from = owner;
                                let amount_wei = web3.utils.toWei($scope.fd.ApproveAmount.toString(), 'ether');
                                
                                tokenInst.methods.approve(spender,amount_wei).send()
                                .on('transactionHash', function(hash){
                                 
                                    $timeout(function(){$scope.fd.transactionHash1=hash;
                                              $scope.fd.pending1=true;});
                                    
                                 })
                                 .on('confirmation', function(confirmationNumber, receipt){
                                    if (confirmationNumber>0)
                                    {
                                    $timeout(function(){$scope.fd.confirmation1=confirmationNumber;
                                              $scope.fd.pending1=false;
                                             
                                              });
                                     $scope.fd.getAllowance($scope.fd.eth_address,$scope.fd.currentTokenTicker);
                                    }
                                 })
                                 .on('receipt', function(receipt){
                                $timeout(function(){$scope.fd.trxReceipt1=receipt;
                                         $scope.fd.status1=receipt.status;  
                                         });
                                  
                                  //console.log(receipt);

                                 })
                              .on('error', function(error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.
                                  $timeout(function(){$scope.fd.errorMessage1=error.message;
                                 if (receipt!=undefined)  $scope.fd.status1=receipt.status;  
                                  });
                              });
                                
                               
                  } else MessagingService.addMessage("Error connecting to wallet!",'error');     
                 
      }
      
       $scope.fd.stake = function(){
                  
                   var tokenAddress,tokenABI;
                   var contractAddress = $scope.fd.stakingContract;
                   var contractABI = $scope.fd.stakingContractAbi;
                   var owner = $scope.fd.eth_address;
                   var token = $scope.fd.currentTokenTicker;
                   $scope.fd.confirmation2 = null;
                  $scope.fd.transactionHash2 = null;
                  $scope.fd.errorMessage2 = null;
                  let web3;
                   if (token=="KTLYO")
                   {
                     tokenAddress= $scope.fd.token1Contract;
                     tokenABI = $scope.fd.token1ContractAbi;
                   }else
                   {
                     tokenAddress= $scope.fd.token2Contract;
                     tokenABI = $scope.fd.token2ContractAbi;
                     
                     
                   }
                  if (window.ethereum)
                  {
                   web3= new Web3(window.ethereum);  
                  }else if (window.web3)
                  {
                     web3= new Web3(window.web3); 
                  }else
                  {
                     web3 = null;
                     MessagingService.addMessage("Error connecting to web3 wallet!",'error');
                  }
                     
               if (web3!=null)
               {
                  
                               
                                var contractInst = new web3.eth.Contract(contractABI,contractAddress);
                                
                                contractInst.options.from = owner;
                                let amount_wei = web3.utils.toWei($scope.fd.StakeAmount.toString(), 'ether');
                                contractInst.methods.stake(tokenAddress,amount_wei).send()
                                .on('transactionHash', function(hash){
                                 
                                    $timeout(function(){$scope.fd.transactionHash2=hash;
                                              $scope.fd.pending2=true;});
                                    
                                 })
                                 .on('confirmation', function(confirmationNumber, receipt){
                                    if (confirmationNumber>0)
                                    {
                                     $timeout(function(){$scope.fd.confirmation2=confirmationNumber;
                                               $scope.fd.pending2=false;
                                               });
                                    }
                                 })
                                 .on('receipt', function(receipt){
                                 $timeout(function(){$scope.fd.trxReceipt2=receipt;
                                          $scope.fd.status2=receipt.status;  
                                          });
                                  $scope.fd.getAllowance($scope.fd.eth_address,token);
                                  //console.log(receipt);

                                 })
                              .on('error', function(error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.
                                 $timeout(function(){$scope.fd.errorMessage2=error.message;
                                  $scope.fd.pending2=false;
                                  if (receipt!=undefined) $scope.fd.status2=receipt.status;
                                  });
                              });

                              /*
                                  contractInst.methods.stake(tokenAddress,amount_wei).send().then(function (trx) {
                                
                                    MessagingService.addMessage(trx,'success');
                                
                                },function(error){
                                 MessagingService.addMessage(error.message,'error');     
                                 });
                                 */
                  } else MessagingService.addMessage("Error connecting to wallet!",'error');     
                 
      }
      
      $scope.fd.Redeem = function(early,index){
            
            var web3;
            
            if ($scope.fd.msgs[index]==undefined) $scope.fd.msgs[index] = {confirmation : null,transactionHash : null,errorMessage : null,pending:null,trxReceipt:null,status : null};
            else
            {
               $scope.fd.msgs[index].confirmation=null;
               $scope.fd.msgs[index].transactionHash = null;
               $scope.fd.msgs[index].errorMessage = null;
               $scope.fd.msgs[index].trxReceipt = null;
               $scope.fd.msgs[index].pending = null;
               $scope.fd.msgs[index].status = null;
            
            }
            
            $scope.fd.currectIndex=index;      
            
            if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to web3 wallet!",'error');
            }
                     
               if (web3!=null)
               {
                        var contractAddress = $scope.fd.stakingContract;
                        var contractABI = $scope.fd.stakingContractAbi;
                        
                        var contractInst = new web3.eth.Contract(contractABI,contractAddress);
                         
                        web3.eth.getAccounts().then(function (result) { 
                              $scope.fd.eth_address = result[0];
                              
                              contractInst.options.from = $scope.fd.eth_address;
                               
                           if (early)
                           {
                              contractInst.methods.redeemEarly(index).send()
                               .on('transactionHash', function(hash){
                           
                                    $timeout(function(){$scope.fd.msgs[index].transactionHash=hash;
                                       $scope.fd.msgs[index].pending=true;
                                       });
                              
                              })
                              .on('confirmation', function(confirmationNumber, receipt){
                                 if (confirmationNumber>0)
                                    {
                                       $timeout(function(){$scope.fd.msgs[index].confirmation=confirmationNumber;
                                          $scope.fd.msgs[index].pending=false;
                                          
                                          });
                                    }
                              })
                              .on('receipt', function(receipt){
                                 $timeout(function(){
                                       $scope.fd.msgs[index].trxReceipt=receipt;
                                       $scope.fd.msgs[index].status=receipt.status;  
                                        
                                           
                                 });
                               
                                 $scope.fd.getMyStakings();
                                 

                              })
                              .on('error', function(error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.
                                  $timeout(function(){$scope.fd.msgs[index].errorMessage=error.message;
                                          if (receipt!=undefined) $scope.fd.msgs[index].status=receipt.status;
                                           $scope.fd.msgs[index].pending=false;});
                              });
                             
                           }
                           else{
                                 contractInst.methods.redeem(index).send()
                                 .on('transactionHash', function(hash){
                           
                                    $timeout(function(){$scope.fd.msgs[index].transactionHash=hash;
                                             $scope.fd.msgs[index].pending=true;});
                                    
                                 })
                                 .on('confirmation', function(confirmationNumber, receipt){
                                    if (confirmationNumber>0)
                                    {
                                    $timeout(function(){
                                       $scope.fd.msgs[index].confirmation=confirmationNumber;
                                             $scope.fd.msgs[index].pending=false;});
                                    }
                                 })
                                 .on('receipt', function(receipt){
                                    
                                $timeout(function(){
                                 
                                         $scope.fd.msgs[index].trxReceipt=receipt;
                                         $scope.fd.msgs[index].status=receipt.status; 
                                         
                                         
                                         });
                                  $scope.fd.getMyStakings();
                                 

                                 })
                              .on('error', function(error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.
                                  $timeout(function(){
                                          $scope.fd.msgs[index].errorMessage=error.message;
                                    
                                          if (receipt!=undefined)  $scope.fd.msgs[index].status=receipt.status;
                                           $scope.fd.msgs[index].pending=false;});
                                 
                              });
                        
                           }
               });
      
            } 
                 
      };
      
      $scope.fd.getBalance = function(token){
                  
                  let web3;
                   var tokenAddress,tokenABI;
                   
                   if (token=="KTLYO")
                   {
                     tokenAddress= $scope.fd.token1Contract;
                     tokenABI = $scope.fd.token1ContractAbi;
                   }else
                   {
                     tokenAddress= $scope.fd.token2Contract;
                     tokenABI = $scope.fd.token2ContractAbi;
                     
                     
                   }
           if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to web3 wallet!",'error');
            }
                     
               if (web3!=null)
               {
                                var tokenInst = new web3.eth.Contract(tokenABI,tokenAddress);
                                          
        
                                tokenInst.methods.balanceOf($scope.fd.eth_address).call().then(function (bal_raw) {
                                var bal = web3.utils.fromWei(bal_raw, 'ether');
                                if (bal<=100)
                                {
                                        $scope.ktlyo_balance_ok = false;
                                        $scope.ktlyo_balance_msg = "Insufficient balance";
                                }else $scope.ktlyo_balance_ok = true;
                                $timeout(function(){$scope.balance_ktlyo = bal+ " KTLYO";});
                                });
                    }   
               };
        
        
         
          $scope.fd.formatNumber = function(input_string){
            let number;
            
           if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to web3 wallet!",'error');
            }
                     
               if (web3!=null)
               {
                  
              
               number = Number(web3.utils.fromWei(input_string, 'ether')).toLocaleString(undefined, { maximumFractionDigits: 18 });
                               
               }
            
            /*
           let decimals = ("000000000000000000" + input_string.substr(input_string.length - 18)).slice(-18);
           if (input_string.length<19) number= "0."+decimals;
           else number = input_string.substring(0,input_string.length - 18)+"."+decimals;
           */
           return number;
          }
          
          
          $scope.fd.getAmount = function(token,forToken,amount,amountReward){
            let number,numberReward;
            
            let tokenTicker = $scope.fd.getTokenTicker(token);
            if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to wallet!",'error');
            }
                     
               if (web3!=null)
               {
               
               number = Number(web3.utils.fromWei(amount, 'ether'));
               numberReward = Number(web3.utils.fromWei(amountReward, 'ether'));
               if (tokenTicker==forToken) number = number+numberReward;
               else number = numberReward;
               number = number.toLocaleString(undefined, { maximumFractionDigits: 4 });
                               
            }
           
           return number;
          }
          
          $scope.fd.isReleased = function(stake){
            
              if (stake.stakeEnd>=$scope.fd.currentDate) return false;
              else return true;
           }
          
         
          
          
          $scope.fd.formatDate = function(input_timestamp){
            let date_var;
            let options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',hour: '2-digit', minute:'2-digit',second:'2-digit',hour12:false };
            date_var = new Date(input_timestamp*1000).toLocaleDateString(undefined,options);
          
           return date_var;
          }
        
        $scope.fd.getTokenTicker = function(tokenAddress){
        
         let tokenTicker;
         if (tokenAddress.toLowerCase()== $scope.fd.token1Contract.toLowerCase())
         {
            tokenTicker="KTLYO";
         }else
         {
            tokenTicker="BNF";
                     
         }
         return tokenTicker;
        }
        
        $scope.fd.setMax = function(){
         
         if ($scope.fd.remainStakeLimit > $scope.fd.allowance) $scope.fd.StakeAmount = $scope.fd.allowance;
         else $scope.fd.StakeAmount = $scope.fd.remainStakeLimit;
         
         
        };
        $scope.fd.setMaxAllowance = function(){
         
         $scope.fd.ApproveAmount = $scope.fd.remainStakeLimit;
         
        };
        $scope.fd.getMyLimits = function(token){
              var lang=$rootScope.globals.currentUser.lang;
             
             if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to wallet!",'error');
            }
                     
               if (web3!=null)
               {                 
                  web3.eth.getAccounts().then(function (result) {
                      $timeout(function(){
                           $scope.fd.eth_address = result[0];
                           if ($scope.fd.eth_address!=null)
                           {
                              
                              //get address and abi
                              var contractAddress = $scope.fd.stakingContract;
                              var contractABI = $scope.fd.stakingContractAbi;
                               
                              var contractInst = new web3.eth.Contract(contractABI,contractAddress);
                                
                                contractInst.options.from = $scope.fd.eth_address;
        
                                contractInst.methods.getMyLimits().call().then(function (data) {
                                    
                                    if (token=="KTLYO") $scope.fd.spentStakeLimit=web3.utils.fromWei(data.limit1,'ether');
                                    else $scope.fd.spentStakeLimit=web3.utils.fromWei(data.limit2,'ether');
                                    
                                    
                                     contractInst.methods.getStakeRewardAmounts().call().then(function (data) {
                                    
                                    $timeout(function(){
                                       if (token=="KTLYO") $scope.fd.maxStakeLimit=web3.utils.fromWei(data[4],'ether');
                                       else $scope.fd.maxStakeLimit=web3.utils.fromWei(data[5],'ether');
                                       $scope.fd.maxStakeLimitPrint = Number($scope.fd.maxStakeLimit).toLocaleString(undefined, { maximumFractionDigits: 18 });
                                       $scope.fd.remainStakeLimit = $scope.fd.maxStakeLimit - $scope.fd.spentStakeLimit;
                                       $scope.fd.remainStakeLimitPrint = Number($scope.fd.remainStakeLimit).toLocaleString(undefined, { maximumFractionDigits: 18 });
                                    })
                                 },
                                function(error){
                                    MessagingService.addMessage(error.message,'error')
                                 });
                                
                                },
                                function(error){
                                    MessagingService.addMessage(error.message,'error')
                                 });
                                
                                contractInst.methods.getStakeRewardAmounts().call().then(function (data) {
                                    
                                    if (token=="KTLYO") $scope.fd.maxStakeLimit=data.maxStakeAmt1;  
                                    else $scope.fd.maxStakeLimit=data.maxStakeAmt2;
                                
                                },
                                function(error){
                                    MessagingService.addMessage(error.message,'error')
                                 });
                             
                              
                           
                           }else MessagingService.addMessage("Error connecting to wallet!",'error') ;
                      });
                  },function(error){
                        $timeout(function(){
                          
                           $scope.fd.error_msg = error.message;
                           
                        });
                  });
                          
                 
                }

        }
         
   
          
          
        $scope.fd.getMyStakings = function(){
              var lang=$rootScope.globals.currentUser.lang;
              $scope.fd.afterQuery=false;
              //$scope.fd.myStakes=[];
            
            if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to wallet!",'error');
            }
                     
               if (web3!=null)
               {
                  

                                    
                  web3.eth.getAccounts().then(function (result) {
                      
                           $scope.fd.eth_address = result[0];
                           if ($scope.fd.eth_address!=null)
                           {
                              
                              //get address and abi
                              var contractAddress = $scope.fd.stakingContract;
                              var contractABI = $scope.fd.stakingContractAbi;
                               
                              var contractInst = new web3.eth.Contract(contractABI,contractAddress);
                                
                                contractInst.options.from = $scope.fd.eth_address;
        
                                contractInst.methods.getMyStakings().call().then(function (data) {
                                    
                                    $scope.fd.currentDate = Math.floor(Date.now() / 1000);
                                
                                    $timeout(function(){ $scope.fd.myStakes = data;$scope.fd.afterQuery=true;});
                                
                                },
                                function(error){
                                    MessagingService.addMessage(error.message,'error')
                                 });
                             
                              
                           
                           }else MessagingService.addMessage("Error connecting to wallet!",'error') ;
                     
                  },function(error){
                        $timeout(function(){
                          
                           $scope.fd.error_msg = error.message;
                           
                        });
                  });
                          
                 
                }

        }
        
        
        
        //$scope.fd.getMyStakings();
        
        $scope.localVarsWidget.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
               $scope.localVarsWidget.formLoaded=false;
               if ($scope.fd.PresentationId==null)
               {
                    $scope.fd.PresentationId=0;
            
               }
               $scope.localVarsWidget.formLoading=true;
                         
              ResourcesDataService.getResourceFormExtended($scope.fd.Related,$scope.taskId,$scope.localVarsWidget.formType,$scope.fd.PresentationId,"w",lang).then(function(data) {
                               
                                  $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                  if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                  
                                 if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                              
                                $scope.fd.wItemValue=data.data.widgets;
                               
                                
                                  
                                $scope.localVarsWidget.searchFormDownloaded = true;
                                
                                $timeout(function(){    
                                   $scope.localVarsWidget.formLoaded=true;
                                   $scope.localVarsWidget.formLoading=false;
                                });
                                  
                               
                              //  $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 $scope.localVarsWidget.formLoading=false;
                                 
                                
                             });
                              
      };
      
              
        $scope.localVarsWidget.getFormResourceWithData = function(){
              var lang=$rootScope.globals.currentUser.lang;
              $scope.localVarsWidget.formLoaded=false;
              if ($scope.fd.PresentationId==null || $scope.fd.PresentationId==undefined)
              {
                $scope.fd.PresentationId = 0;
                
              }
              
              if ($scope.fd.ParentElementId==null || $scope.fd.ParentElementId==undefined)
              {
                $scope.fd.ParentElementId = 0;
                
              }
              
              
              
              
               if ($scope.localVarsWidget.resourceRecordId==undefined || $scope.localVarsWidget.resourceRecordId==0)
               {
                
                  if ($scope.localVarsWidget.previousTaskData['datasetRecordId']!=undefined && $scope.localVarsWidget.previousTaskData['datasetRecordId']!="" && $scope.localVarsWidget.previousTaskData['datasetId']==$scope.fd.Related) $scope.localVarsWidget.resourceRecordId = $scope.localVarsWidget.previousTaskData['datasetRecordId'];
                
               }
               if (typeof $scope.localVarsWidget.resourceRecordId !=='number' && typeof $scope.localVarsWidget.resourceRecordId !=='string')
               {
                  
                  if (Array.isArray($scope.localVarsWidget.resourceRecordId))
                  {
                     if ($scope.localVarsWidget.resourceRecordId.length>0)
                     {
                        $scope.localVarsWidget.resourceRecordId= $scope.localVarsWidget.resourceRecordId[0].id  
                     
                     }
                  }
                  else $scope.localVarsWidget.resourceRecordId = $scope.localVarsWidget.resourceRecordId.id;                 
               }
               
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.Related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.PopulateType,$scope.fd.ParentElementId,$scope.fd.PresentationId,$scope.prevTaskExeId,$scope.localVarsWidget.formType,$scope.localVarsWidget.widgetType,$scope.localVarsWidget.resourceRecordId,"w",lang).then(function(data) {

                                  $scope.formData[$scope.fd.PresentationId] =  data.data.form_data;
                                  if ($scope.formData[$scope.fd.PresentationId]==undefined) $scope.formData[$scope.fd.PresentationId]=[];
                                  $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                  if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                 
                                  if ($scope.formData[$scope.fd.PresentationId].length>0)
                                  {
                                    $scope.localVarsWidget.resourceRecordId = $scope.formData[$scope.fd.PresentationId][0]['id'];
                                  }
                                  $scope.localVarsWidget.datasetRecordId=$scope.localVarsWidget.resourceRecordId;
                                  if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                    //$scope.fd.wItemValue=data.data.widgets;
                               
                                  // $timeout(function() {
                                     $scope.localVarsWidget.formLoaded=true;
                                    // $scope.localVarsWidget.initiateFormLoaded=true;
                                     $scope.localVarsWidget.formLoading=false;
                                     $scope.localVarsWidget.searchFormDownloaded = true;
                                      
                                  //  });   
                                  
                                   
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - VIEW_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVarsWidget.resourceRecordId}]}]});
                                
                               // $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      
      
           $scope.localVarsWidget.setSelectedDataset = function(id)  {
              
              if ($scope.localVarsWidget.selectedResourceItem==undefined) $scope.localVarsWidget.selectedResourceItem={};
              var pos = $scope.localVarsWidget.resourceList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVarsWidget.selectedResourceItem.id = $scope.localVarsWidget.resourceList[pos].id;
                $scope.localVarsWidget.selectedResourceItem.name = $scope.localVarsWidget.resourceList[pos].name;
                $scope.localVarsWidget.selectedDataset = $scope.localVarsWidget.resourceList[pos];
                $scope.localVarsWidget.selectedResourceItem.name_confirmed = $scope.localVarsWidget.selectedResourceItem.name +' ('+$scope.localVarsWidget.selectedResourceItem.id +')'
                $scope.localVarsWidget.selectedResourceItem_c=$scope.localVarsWidget.selectedResourceItem;
                }
					}
          
                  
          // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
	$scope.localVarsWidget.getResources = function()  {
						
            if ($scope.localVarsWidget.resourceList==undefined) $scope.localVarsWidget.resourceList=[];
          
            var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'smartcontract').then(
						function(data) {
										
											  $scope.localVarsWidget.resourceList = data.data;
                       if ($scope.fd.Related!=null)
                       {
                        $scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
                
                        }     
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					}
   
         
  if ($scope.fd.Related!=null &&  !$scope.formDefinition && !$scope.localVarsWidget.searchFormDownloaded)
  {
    
    // $scope.localVarsWidget.getFormResourceWithData();
    // $scope.localVarsWidget.getDatasets();
    // $scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
    
  }else if ($scope.fd.Related!=null)
  {
     //$scope.localVarsWidget.getFormResource();
     //$scope.localVarsWidget.getResources();
     //$scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
    
  } 

    


       
     
                              
    
            let template
            template = $templateCache.get('ktdirectivetemplates/ktKtlyoStaking.html');
            $element.append($compile(template)($scope)); 

  
      }];

  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

            }     
  }
  
};
'use strict';

export function ktLabel () {
        return {
            restrict: 'A',
		
             templateUrl: 'ktdirectivetemplates/ktLabel.html',
             controller: function($scope,GridsterService,WidgetDataExchangeService,UtilityService){
				 
			
				$scope.fd.localVars = {
					calculateFunctions :[ {id:1,name:'sum'},{id:2,name:'mean'},{id:3,name:'min'},{id:4,name:'max'},{id:5,name:'count'} ] ,
					gsrvc: GridsterService
				}    

                
                //$scope.gsrvc = GridsterService;
				
                
				if ($scope.fd.localVars==undefined)  $scope.fd.localVars={}
				$scope.fd.localVars.resourceDefinition = $scope.resourceDefinition
				
				$scope.localVars = {gsrvc:GridsterService} //because kt-delete-element
			
				if ($scope.fd.localVars.parentResourceId==undefined) $scope.fd.localVars.parentResourceId = $scope.resourceDefinition.pageId ?? $scope.resourceDefinition.uid // if directly on page 

                $scope.showProperties = function(event)
                {
                  $scope.fd.localVars.gsrvc.setFieldProperties($scope.fd,event);
                }
				
				
				
				  //register widget 
				  var out_fields = ['resourceId']
				  if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
							
				  let w_actions=[]

				  var widgetDefinition = {
					  DEI: [{'name':'resourceLink','displayName':'Dataset record id','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],
						actions: w_actions,
						widgetLabel: 'Label',
						widgetName: 'ktLabel',
						widgetId: $scope.fd.UuidRef,
						task_initiate_id:$scope.taskInitiateId,
						task_execute_id:$scope.taskExecuteId,
						taskId:  $scope.lTaskId,
						resource_id:$scope.resourceDefinition.page_state_id,
						resourceDefId : $scope.fd.Related, 
						output:out_fields,
						parentResourceId:$scope.fd.localVars?.parentResourceId
					}
				  
				  $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
				  $scope.fd.localVars.localId=$scope.fd.localVars.localWidgetId;
				  $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
				
				
				
                },//end controler
				
             link: function (scope, elem, attrs) {
              
              if (scope.fd) {
                  if (scope.fd.Parameters == null) scope.fd.Parameters = {} //null or undefined !
                 
                  scope.fd.isLabelStyle = true;
				  scope.fd.Parameters.HideElementProperties = false 
				  
				  //if (scope.fd.Parameters.widgetReference)
							//scope.fd.Parameters.HideElementProperties = false 
				  //else 
					//  scope.fd.Parameters.HideElementProperties = true //hide value properties
						
				  
              }
            
            
           
            }
        };
};
'use strict';

export function ktList ($rootScope,CodesService,GridsterService, KatalyoStateManager,$timeout) {

        return {
            restrict: 'A',
            controller: function ($scope,CodesService,$rootScope,MessagingService,GridsterService,UtilityService, KatalyoStateManager,$compile,$element,$templateCache,$timeout,$q){
                $scope.CTRL='ktList'
				$scope.gsrvc = GridsterService;
				if (!$scope.gsrvc.codeList) $scope.gsrvc.codeList = {}	
				if (!$scope.gsrvc.codeListFull)  $scope.gsrvc.codeListFull = {}
				if (!$scope.gsrvc.codesLoaded)  $scope.gsrvc.codesLoaded = {}
				
				//debugger
				if ($scope.fd.codeList) {		delete $scope.fd.codeList		}
				if ($scope.fd.codeListFull) {		delete $scope.fd.codeListFull		}
				if ($scope.fd.searchList) {		delete $scope.fd.searchList		}
				
				
				
				//$scope.fd.testuid=UtilityService.uuidv4() // scope testing
				//console.log('init controler: ' + $scope.fd.testuid) //scope testing
                $scope.fd.localVars = {}
				//$scope.fd.localVars[$scope.fd.id]  = $scope.fd
                if (!$scope[$scope.fd.id]?.fd) $scope[$scope.fd.id]  = {'fd': $scope.fd}
				$scope.myscope = $scope
				$scope.MessagingService=MessagingService
                 
				//if ($scope.fd.localVars==undefined)  $scope.fd.localVars={ }

                let template;
                if ($scope.resourceDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktList.html');
                else template = $templateCache.get('ktdirectivetemplates/ktListExe.html');
          
		  		//console.log('init link: ' + $scope.fd.testuid) //scope testing
			
                if ($scope.fd.Parameters===undefined) $scope.fd.Parameters = {}
                var lang = $rootScope.globals.currentUser.lang; 
                $scope.organisation_id =  $rootScope.globals.currentUser?.organisation?.id

                if ($scope.fd.Parameters.ValueFontColor===undefined) $scope.fd.Parameters.ValueFontColor = '#000'
                
                $scope.codesService = CodesService;
                if ($scope.gsrvc.codesLoaded[$scope.fd.UuidRef]==undefined)	 $scope.gsrvc.codesLoaded[$scope.fd.UuidRef]= false
                //$scope.codesLoaded = false
				
				//$scope.fd.codeList = []
				$scope.gsrvc.codeList[$scope.fd.UuidRef] = []

				
                 let field_name = $scope.fd.FieldName;
                 let elementObject = {};
                 elementObject[field_name]=null;
                 if ($scope.formData==undefined)
                 {

                    $scope.formData=[];
                    $scope.formData.push(elementObject);
                 }
                  if (!$scope.formData.length) $scope.formData = [{}]
                 // else if ($scope.formData[0][field_name]==undefined) $scope.formData[0][field_name] =null;
                $scope.itemValue = {val:$scope.formData[0][field_name]};
                
                $scope.ksm = KatalyoStateManager;
                if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
               
                
                let listValueState= $scope.ksm.addSubject('listValueStateName'+$scope.fd.ItemId,$scope.itemValue.val);
                let listValueStateName = listValueState.subject.name;
                
                let value_changed = function(data)
                {
                    listValueState.subject.setStateChanges = data;
                    listValueState.subject.notifyObservers("valueChanged");
                };
                
                let action_value_changed = $scope.ksm.addAction(listValueStateName,"valueChanged",value_changed);
                
                let parentWidgetUid = ''

                if ($scope.parentWidget!=undefined) parentWidgetUid = $scope.parentWidget+'-'

                let wrState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+'-'+parentWidgetUid+$scope.fd.UuidRef+'-widgetReady',{widget:$scope.fd.UuidRef,processed:false})
                let wrStateName = wrState.subject.name
                
                
                let widget_ready = function(data)
                {
                    wrState.subject.setStateChanges = data
                    wrState.subject.notifyObservers("widgetReady")
                   
                };
                
                let action_widget_ready = $scope.ksm.addAction(wrStateName,"widgetReady",widget_ready)
                
                let apply_value = function(data)
                {
                    if ($scope.formData[0][field_name]!=data) $scope.formData[0][field_name] = data;
                }; 
               
                if ($scope.fd.Parameters.DependentFieldId!=undefined && $scope.fd.Parameters.DependentFieldId!=null)
                
                {
                    if ($scope.fd.Parameters.DependentFieldId!="")
                    {
                        let dependent_field = $scope.fd.Parameters.DependentFieldId;
                        let subscribedSubject = $scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId;
                        let observer_undo = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value,true);
                        
                    }
                }
        
                
                         $scope.fd.localVars.searchList=[
                            {id:1,filter:'onlist',code_name:'onlist',name:"On list",icon:"fa fa-check"},
                            {id:2,filter:'notonlist',code_name:'notonlist',name:"Not on list",icon:"fa fa-times"},
                        ];
                        
                        // get search filter in correct language
                        $scope.fd.localVars.processFilters = function(filterList)
                        {
                            for (let i=0;i<$scope.fd.localVars.searchList.length;i++)  {
                                let pos = filterList.map(function(e) { return e.id; }).indexOf($scope.fd.localVars.searchList[i].code_name);
                                if (pos>=0) $scope.fd.localVars.searchList[i].name = filterList[pos].name
                            }
                                
                            if (!$scope.fd.Search)  
								$scope.fd.Search=$scope.fd.localVars.searchList[0];//initialize to equals
                            else
								$scope.fd.Search.value = $scope.formData[0][$scope.fd.FieldName]; 

                            $scope.fd.filterReady=true
                        }
                        
                        if ($scope.showSearchFilters || $scope.resourceDefinition.form_definition)
                        {
                            CodesService.getCodesByName('search_filters',lang).then(function (data) {
                                        //debugger;
                                        try {
											$scope[$scope.fd.id]['fd'].localVars.processFilters(data.data)
                                        } catch (err) {
                                                //debugger
                                        }
                                        
                            });
                        }
                        
                
                $scope.setDropdownValue=function(theSelectItemFn)
                {
                    $scope.setItemValueDropdown = theSelectItemFn;
                
                }
                
                $scope.setClearDropdown = function(directiveFn) {
                        $scope.clearDropdown = directiveFn;
                }
                
              
			    $scope.fd.saveNewCode = function (CodeHead) {

			
						CodeHead.Version=1;
						CodeHead.Active=true;
						CodeHead.CodeType={"id": 2, "name": "User"}
						
						   CodesService.CodesPost(CodeHead).then(function(data) {         
											   $scope.MessagingService.addMessage(data.data.msg,'success');
											   CodeHead.id=data.data.data;  

												      CodesService.CodesList().then(function(data) {
														//$scope.fd.showAddNew=false
														$scope.gsrvc.codesDefinitionList = data.data
													  })
						   
												
										  },function(error){
											
											   $scope.MessagingService.addMessage(error.msg,'error');
										});                             
						

					};

		
			$scope.fd.SetDefault = function()
            {
                    $scope.fd.DefaultValue = {value:$scope.formData[0][field_name]};
            }
            $scope.fd.selection_changed = function (item,model) {
                    //debugger
                    if ($rootScope.globals?.app?.uniqueId!="ktlyo_builder")
							$scope.fd.Search.value = $scope.formData[0][field_name];
                    //$scope.fd.DefaultValue = {value:$scope.formData[0][field_name]};
                    $scope.ksm.executeAction(listValueStateName,"valueChanged", $scope.formData[0][field_name]);
                    if (!$scope.fd.Multiline && $scope.formData[0][field_name]?.id==null) delete $scope.formData[0][field_name]
                }
            $scope.removeItem = function(index)
                {
                    $scope.formData[0][field_name].splice(index,1);
                    //$scope.ngModel.$setViewValue($scope.model.selectedItems); 
                
                }
                
             $scope.selectedItemId =  $scope.gsrvc.getSelectedItemId(); 
            
            $scope.showProperties = function(event)
                {
                  $scope.fd.loadingProperties=true
				  $scope.gsrvc.setFieldProperties($scope.fd, $scope.inputArray);// inputArray is parent

                  $timeout(function(){$scope.fd.loadingProperties=false})
       
                };
                
                
               
                $scope.fd.code={selectedCode:null};
				
				$scope.refreshcodesDefinitionList = function () 
				{	
							$scope.gsrvc.codesDefinitionList=[]
							

							$scope.gsrvc.codeHeads.forEach( (ch) => {
											$scope.gsrvc.codesDefinitionList.push ( {'id': ch.id, 'uid':ch.uid, 'name': ch.CodeName })
							})
			 
							if ($scope.fd.CodeId!=undefined)
							{
										var posCodesDef = $scope.gsrvc.codesDefinitionList.map(function(e) { return e.uid.toString(); }).indexOf($scope.fd.CodeId.toString());
					  
										if (posCodesDef>=0){
											$scope.fd.code.selectedCode=$scope.gsrvc.codesDefinitionList[posCodesDef];   
										}else
										{
										  if (!isNaN(+$scope.fd.CodeId) )	 $scope.fd.CodeId = $scope.fd.CodeId+'-'+$scope.organisation_id  //if code is number then add org_id
										  posCodesDef = $scope.gsrvc.codesDefinitionList.map(function(e) { return e.id.toString(); }).indexOf($scope.fd.CodeId.toString());
										  if (posCodesDef>=0) 	$scope.fd.code.selectedCode=$scope.gsrvc.codesDefinitionList[posCodesDef]
										}
							}
					
				}
				
                
                if ($scope.resourceDefinition.form_definition)
                {
					if ($scope.gsrvc.codesDefinitionList==undefined) {
						
						CodesService.CodesGet(lang).then(
								function(data) {
									$scope.gsrvc.codeHeads = data.data;
									$scope.refreshcodesDefinitionList() 
								    $scope.fd.codeListPropsDownloaded=true
								},function(error){
										  $scope.MessagingService.addMessage(error.msg,'error');
								 })
					} else $scope.refreshcodesDefinitionList() 	//ovo linija možda ne treba 
							
                             
                }//if
                

			
                
                $scope.applyListFilters = function(index) {
               
                    $scope.fd.Search=$scope.fd.localVars.searchList[index];
               
                    if( typeof $scope.formData[0][$scope.fd.FieldName] === 'string' ) {
                        $scope.fd.Search.value = [ {'id':$scope.formData[0][$scope.fd.FieldName]} ];
                    }
                
                    $scope.isOpen=false;     
                };

                if ($scope.fd.Multiline && $scope.formData[0][$scope.fd.FieldName]===undefined) $scope.formData[0][$scope.fd.FieldName]=[]

        
				
		$scope.fd.openModal = function(isnew) {
			
			if (!isnew) {
				$scope.fd.getCodes($scope.fd.code?.selectedCode.uid)
			
				for (const ch of $scope.gsrvc.codeHeads) {
					if ($scope.fd.code?.selectedCode?.id == ch.id) {
						$scope.fd.localVars.selectedCodeHead = ch
						break
					}
				}
			} else { //NEW
				$scope.fd.localVars.selectedCodeHead = null				
				//$scope.fd.codeList.length=0
				$scope.gsrvc.codeList[$scope.fd.UuidRef].length=0
	
			}
			
			 $timeout(function() { $scope.fd.showAddNew= true    });
			

		}
		
		
                 $scope.fd.saveCodesDetails = function(selectedCodeHead, codesList){
                  
                        if (selectedCodeHead.id>0) {
                            CodesService.saveCodesDetails(selectedCodeHead.id, codesList, lang).then(
                                function(data) {
								                                          
										  $scope.MessagingService.addMessage(data.msg,'success');
										  
                                           $scope.codesDetails = data.data;
										
										$timeout(function() { 
												//$scope.fd.codeList = data.data;  		// $scope.fd.codeList	?  
												$scope.gsrvc.codeList[$scope.fd.UuidRef] = data.data
										});
 
																	   
                              },function(error){ 
                                          $scope.MessagingService.addMessage(error.msg,'error');
                             });
                        } else {  
                          //$scope.codesDetails.length = 0;
                        }
                    }


			
			
			
        $scope.fd.getCodes = function (code) {
           
           if (code == undefined) return;
		   
            let searchCode="";
            
            $scope.codesService.getCodes(code,lang).then(function(data){
                
                        //$scope.fd.codeListFull = data.data;
						$scope.gsrvc.codeListFull[$scope.fd.UuidRef] = data.data;
						
						
                        //$scope.fd.codeList = [];
						$scope.gsrvc.codeList[$scope.fd.UuidRef] = [];
						
                        //filter data here
                        if ($scope.fd.Parameters.Condition!=undefined)
                        {
                            if ($scope.fd.Parameters.Condition!="")
                            {
                                let conditions =  $scope.fd.Parameters.Condition.split(";");
                                
                                for (let i=0;i<conditions.length;i++)
                                {
                                   let idx = $scope.gsrvc.codeListFull[$scope.fd.UuidRef].map(function(e) { return e.value; }).indexOf(conditions[i]);
                                   if (idx>=0) $scope.gsrvc.codeList[$scope.fd.UuidRef].push($scope.gsrvc.codeListFull[$scope.fd.UuidRef][idx]);
                                }
                            } else $scope.gsrvc.codeList[$scope.fd.UuidRef] = $scope.gsrvc.codeListFull[$scope.fd.UuidRef]
                        }else $scope.gsrvc.codeList[$scope.fd.UuidRef]= $scope.gsrvc.codeListFull[$scope.fd.UuidRef]
                        
                        
                        if ($scope.CTRL !=='ktList') { //angular scope mix debug
                             console.log('ktlist - nije moj scope !  CTRL= ' +  $scope.CTRL)
                                   
                        }
                        
                        if ($scope.fd.localVars===undefined) {//angular scope mix debug fix errror
							//debugger
							 Object.assign($scope.fd , $scope[$scope.fd.id].fd);//vrati nazad fd koji je dobar! scopeovi se mixaju zbog nečeg.
                             console.log('ktlist - nemam localvars!')         
                        }
       
                        //$scope.fd.codesLoaded = true
						$scope.gsrvc.codesLoaded[$scope.fd.UuidRef]=true
                        //$scope.codesLoaded = true
                        //this should come from server however for also on client
                        if ($scope.fd.UpdateWithDefault && $scope.fd.UseDefault && !$scope.fd.NoUpdate) $scope.formData[0][$scope.fd.FieldName] = $scope.fd.DefaultValue?.value

                        if ($scope.fd.Parameters.UseUserProperty) $scope.formData[0][$scope.fd.FieldName] = $rootScope.globals.currentUser.uep.AdvancedProperties[$scope.fd.Parameters.UserPropertyId]


                        if ($scope.formData!=undefined && !$scope.fd.Multiline) // NOT MULTILLINE !
                        {
                            if ($scope.formData[0][$scope.fd.FieldName]!=null && $scope.formData[0][$scope.fd.FieldName]!=undefined)
                            {   
								if ( Array.isArray($scope.formData[0][$scope.fd.FieldName]) )
									searchCode = $scope.formData[0][$scope.fd.FieldName][0]?.id // if ARRAY
                                if (typeof($scope.formData[0][$scope.fd.FieldName])=='string' || typeof($scope.formData[0][$scope.fd.FieldName])=='number' ) 
									searchCode = $scope.formData[0][$scope.fd.FieldName].toString() //if STRING or NUMBER
                                else if ($scope.formData[0][$scope.fd.FieldName].id) searchCode = $scope.formData[0][$scope.fd.FieldName].id.toString()
                                else  searchCode = $scope.formData[0][$scope.fd.FieldName]
                                
								if (searchCode) {
                                    let pos = $scope.gsrvc.codeList[$scope.fd.UuidRef].map(function(e) {
										if (e.id!=null) return e.id.toString();
										else return e.id;
                                    }).indexOf(searchCode);
                     
                                    if (pos>=0)    $timeout(function(){  
											$scope.formData[0][$scope.fd.FieldName]=$scope.gsrvc.codeList[$scope.fd.UuidRef][pos]  
									})

								}
                            }
                            
                        }

                        $scope.ksm.executeAction(wrStateName,"widgetReady", {widget:$scope.fd.UuidRef,processed:true});
                
            });
          
        }
        
		
		
        if (!$scope.fd.ReadOnly && $scope.fd.CodeId!=undefined && $scope.fd.CodeId.toString().length>0) 
			$scope.fd.getCodes($scope.fd.CodeId);
        else if ($scope.fd.CodeId && $scope.fd.CodeId.toString().length>0){
            if ($scope.fd.UpdateWithDefault && !$scope.fd.NoUpdate) $scope.formData[0][$scope.fd.FieldName] = $scope.fd.DefaultValue?.value

            if ($scope.fd.Parameters.UseUserProperty) $scope.formData[0][$scope.fd.FieldName] = $rootScope.globals.currentUser.uep.AdvancedProperties[$scope.fd.Parameters.UserPropertyId]
        }

		  
		  
		  
                $element.append($compile(template)($scope)); 
                 },
            
            link: function (scope, elem, attrs) {

      }//link

    }
};


export function ktListParser () {
        return {
                restrict: 'A',
                require:'ngModel',
       
        link: function (scope, elem, attrs,ngModelController) {


                //For model -> DOM validation (model -> view)
                //
                function formatFormatter(value){

                    let valid = true
                    //if (value===undefined)  value={id:null,name:$scope.fd.SearchText}
                    if ($scope.fd.Required && !$scope.fd.Multiline) {
                        if (value?.id==null)    {

                            valid = false
                            
                        }
                       ngModelController.$setValidity('required', valid);
                    }
                    
                    return valid? value : undefined;
                    //return value

                }
                //For DOM -> model validation (view -> model)
                function formatParser(value){

                        let valid = true
                         if ($scope.fd.Required && !$scope.fd.Multiline) {
                            if (value?.id==null)    {

                            valid = false
                            
                        }
                        ngModelController.$setValidity('required', valid);
                    }
                         
                         //return value
                         return valid? value : undefined;

                }

                ngModelController.$formatters.push(formatFormatter)

                ngModelController.$parsers.push(formatParser)


        }

   }


}
'use strict';

export function ktLoader () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktLoader.html',
            scope:{
                   
                   loaderMsg: "=",
                   loaderSize: "=",
      			},
                controller: function(){},
             link: function (scope, elem, attrs) {
                    
              }
        }             
};
'use strict';



export function ktMassPropertyUpdateSelect (KatalyoStateManager, TaskDataService,MessagingService) {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktMassPropertyUpdateSelect.html',
              controller: function($scope){
			
             },
             link: function (scope, elem, attrs) {
                   
              //To do - get this from server (db table)
			  
			  
			  if (!scope.fd.localVars) scope.fd.localVars={}
			  
            //scope.fd.massUpdateFieldList=[
			scope.fd.localVars.massUpdateFieldList=[
                {id:1, Field:'ReadOnly',Label:'Read only',Component:'checkbox'},
                {id:2, Field:'ShowField',Label:'Show field',Component:'checkbox'},
                {id:3, Field:'Required',Label:'Required',Component:'checkbox'},
                {id:4, Field:'Parameters[ValueFontBold]',Label:'Value-Font-Bold',Component:'checkbox'}
            ];
              
            scope.ksm = KatalyoStateManager;
            scope.taskDataService = TaskDataService;
            scope.messagingService  = MessagingService

              let massUpdateState= scope.ksm.addSubject('massUpdateState',null);
              let massUpdateStateName = massUpdateState.subject.name;

              let activate_mass_update = function(data)
              {
                   massUpdateState.subject.setStateChanges = data;
                   massUpdateState.subject.notifyObservers("massUpdateChanged");
              }
            
             let action_mass_update_changed = scope.ksm.addAction(massUpdateStateName,"massUpdateChanged",activate_mass_update);
             
             scope.activateMassUpdateFn = function(item)
              {
                  scope.ksm.executeAction(massUpdateStateName,"massUpdateChanged", {Active:true,Item:item});
              }
              
              scope.deActivateMassUpdateFn = function(index)
              {
                  scope.ksm.executeAction(massUpdateStateName,"massUpdateChanged", {Active:false,Item:null});
                  $('#massPropertyUpdate'+ scope.fd.PresentationId).modal('hide')
              }
              
              
               scope.hideMassUpdateFn = function()
              { 
                 $('#massPropertyUpdate'+ scope.fd.PresentationId).modal('hide') 

                 if (scope.localVars.turnAllPropertiesOn) {        
                    scope.taskDataService.setField(scope.inputArray.layout, scope.selected.Field ,  true );  
                    scope.messagingService.addMessage('All fields are ' + scope.selected.Label ,'info');
                 }
                 
                 if (scope.localVars.turnAllPropertiesOff) {
                    scope.taskDataService.setField(scope.inputArray.layout, scope.selected.Field ,  false );  
                    scope.messagingService.addMessage('All fields are not ' + scope.selected.Label ,'info'); 
                 }
                 scope.localVars.turnAllPropertiesOn = false
                 scope.localVars.turnAllPropertiesOff = false    
              }

             }
        }
};
'use strict';



export function ktMassPropertyUpdateSelect2 (KatalyoStateManager, TaskDataService, MessagingService) {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktMassPropertyUpdateSelect2.html',
             controller: function($scope) {   

			 },
             link: function (scope, elem, attrs) 
                {
              
              //To do - get this from server (db table)
            //scope.massUpdateFieldList=[
			scope.inputArray.localVars.massUpdateFieldList=[
                {id:1, Field:'ReadOnly',Label:'Read only',Component:'checkbox'},
                {id:2, Field:'ShowField',Label:'Show field',Component:'checkbox'},
                {id:3, Field:'Required',Label:'Required',Component:'checkbox'},

            ];
              
            scope.ksm = KatalyoStateManager;
            scope.taskDataService = TaskDataService;
            scope.messagingService = MessagingService;
            //scope.localVars.turnAllPropertiesOn = false
            scope.inputArray.localVars.turnAllPropertiesOn = false
            
            //scope.localVars.turnAllPropertiesOff = false
            scope.inputArray.localVars.turnAllPropertiesOff = false
            

            let massUpdateState= scope.ksm.addSubject('massUpdateState',null);
            let massUpdateStateName = massUpdateState.subject.name;
            
            
             scope.inputArray.localVars.setField = function(form,name,value,msg)
            {
                scope.taskDataService.setField(form,name,value);
                if (msg) scope.messagingService.addMessage(msg,'info');
            };

            let activate_mass_update = function(data)
            {
                   scope.active = data.Active
                   massUpdateState.subject.setStateChanges = data;
                   massUpdateState.subject.notifyObservers("massUpdateChanged");
            }
            
            let action_mass_update_changed = scope.ksm.addAction(massUpdateStateName,"massUpdateChanged",activate_mass_update);
             
            
            scope.activateMassUpdateFn = function(item)
              {
                  scope.ksm.executeAction(massUpdateStateName,"massUpdateChanged", {Active:true,Item:item}); 
              }
              
              scope.deActivateMassUpdateFn = function(index)
              {
                  scope.selected = null
                  scope.ksm.executeAction(massUpdateStateName,"massUpdateChanged", {Active:false,Item:null});
                  $('#massPropertyUpdate').modal('hide')
              }
              
              
              scope.hideMassUpdateFn = function()
              { 
                 //debugger
                 $('#massPropertyUpdate').modal('hide')
                 if (scope.localVars.turnAllPropertiesOn) {
                   scope.localVars.setField(scope.inputArray.layout, scope.selected.Field ,  true  , 'All fields are ' + scope.selected.Label   )
                 }
                 if (scope.localVars.turnAllPropertiesOff) {
                   scope.localVars.setField(scope.inputArray.layout, scope.selected.Field ,  false , 'All fields are not' + scope.selected.Label   )
                 }
                 scope.localVars.turnAllPropertiesOn = false
                 scope.localVars.turnAllPropertiesOff = false
                 
                 
              }
              

             }
        }
};
'use strict';

export function ktMassUpdateProperties (KatalyoStateManager) {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktMassUpdateProperties.html',
             controller: function($scope)
			 {  
				if ($scope.fd.massUpdate) 	delete $scope.fd.massUpdate	
                },
             link: function (scope, elem, attrs) {
              
              //
            scope.ksm = KatalyoStateManager;

            
            let massUpdateState= scope.ksm.addSubject('massUpdateState',null);
            let massUpdateStateName = massUpdateState.subject.name;

            let activate_mass_update = function(data)
            {
                    //scope.fd.massUpdate = data;
					scope.fd.localVars.massUpdate = data;
					
            }
            
            let dependent_field = "Field"+scope.fd.PresentationId;
            let observer = scope.ksm.subscribe(massUpdateStateName,dependent_field,"massUpdateChanged",activate_mass_update);
            let state = scope.ksm.getState(massUpdateStateName);
            if (state.status=="ok" && state.state!==null) 
					scope.fd.localVars.massUpdate = state.state;
            }
      }
  
};
'use strict';

export function ktMenuClick () {

        return {
          restrict: 'A',
          templateUrl: 'ktdirectivetemplates/ktMenuClick.html',
          controller: function($scope,$stateParams){
            
            if ($scope.localVars==undefined) $scope.localVars={};
            if ($scope.fd==undefined) $scope.fd={};
            if ($scope.taskDefinition==undefined) $scope.taskDefinition={};
                   
            $scope.localVars.menuId = $stateParams.id;
            $scope.localVars.previousTask=$stateParams.prev_task_execute_id;
            $scope.localVars.outcomeId=$stateParams.outcome_id;
            $scope.localVars.OpenTaskType = "newPage";
            //$scope.localVars.ShowReturnBtn = true;
            if ($scope.localVars.previousTask==undefined) $scope.localVars.previousTask = 0;
            if ($scope.localVars.outcomeId==undefined) $scope.localVars.outcomeId = 0;
            $scope.initType = $stateParams.init_type;
            $scope.localVars.processMenuClicked = true;
            if ($scope.initType=="t")
            {
              $scope.localVars.processMenuClicked = false;
              $scope.localVars.processStartTask = true;
            }
           
                
            },
          link: function (scope, elem, attrs) {
       
       
       
        
          
      }
      
          
    }
};
'use strict';

export function ktMenuDefinition() {
  
   return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktMenuDefinition.html',
            scope: {
					menuItem:'=',
					localVars:'='
            },
            controller: function($scope,$rootScope,$timeout,MenuService,MessagingService,ResourcesDataService)
			{
              let lang = $rootScope.globals.currentUser.lang;
              if ($scope.localVars==undefined) $scope.localVars={};
              $scope.menu_service = MenuService;
              $scope.CTRL='ktMenuDefinition'
              
              if ($scope.menuItem==undefined) $scope.menuItem = $scope.menu_service.getSelectedSidemenu();
              
              $scope.headerLabel="Grant access to side menu";
              $scope.usersLabel="Users";
              $scope.groupsLabel="Groups";  
             
              $scope.localVars.setPage = function() 
			  {
                var pos = $scope.localVars.pageList.map(function(e) { return e.id; }).indexOf($scope.menuItem.s_menus_Target_id); 
                if (pos>=0){
                  $scope.menuItem.Target = $scope.localVars.pageList[pos];
                }
              }
			  
              $scope.getUsersGroups4menu= function(menuId)
			  {
				$scope.menuItem.UsersGroupsDownloaded = false;
                //var menuId = $scope.menuItem.s_menus_id;
                if (menuId!=null) {
					  MenuService.getUsersGroupsForMenu(menuId,lang).then(
							function(data) {
							  $scope.menuItem.Users = data.Users;
							  $scope.menuItem.Groups = data.Groups;
							  $scope.menuItem.UsersGroupsDownloaded = true;
							 
							},function(error){    
							  MessagingService.addMessage(error.msg,'error');
						});
                } else 
					$scope.menuItem.UsersGroupsDownloaded = true;    
              }
              
			  
			  
            $scope.localVars.getPages = function()
            {
				ResourcesDataService.getResourceDefListByType(lang,'page').then(
					function(data) {
						  $scope.localVars.pageList = data.data;
						  $scope.localVars.pagesLoaded=true;
						  $scope.localVars.setPage();
						  if (! $scope.menuItem?.UsersGroupsDownloaded) 	$scope.getUsersGroups4menu( $scope.menuItem.s_menus_id );
					},function(error){    
						MessagingService.addMessage(error.msg,'error');
					});
            }
			  
  
			ResourcesDataService.GetPublishedResourcesByTypeId($scope.menuItem.s_menus_Target,'form').then(
                function (data) {       
					$scope.localVars.selectedResourcesPublishedList={}
                    $scope.localVars.selectedResourcesPublishedList[$scope.menuItem.s_menus_Target] = data.data;

                    if (! $scope.menuItem.s_menus_SelectVersionDirect){
                        let published = $scope.localVars.selectedResourcesPublishedList[$scope.menuItem.s_menus_Target][$scope.localVars.selectedResourcesPublishedList[$scope.menuItem.s_menus_Target].length-1]                       
                    }
					
					if ($scope.menuItem.s_menus_SelectVersionDirect){ // fill 'select version' options to have both id and name (when there is saved data)
						  let publishedList = $scope.localVars.selectedResourcesPublishedList[$scope.menuItem.s_menus_Target] 
						  publishedList.forEach( (item)=> {
							  if (item.Version == $scope.menuItem.s_menus_TargetPageVersion) 
								  $scope.menuItem.selectedPublishedResource = item
						  } )
					 
					}
                  
					  //if (!$scope.menuItem.SelectVersionDirect || (initial_load && $scope.menuItem.SelectVersionDirect)){
					  //      scope.localVars.relatedResourcesColumns[$scope.menuItem.s_menus_Target] = []       
					 //   }
               } 
			   ,function(error){    
                    MessagingService.addMessage(error.msg,'error');  
			});
			   
			   
            $scope.saveSideMenu = function()
            {    
             $scope.menu_service.saveMenu($scope.menu_service.selectedSideMenu,lang).then(
					function(data) {
                           if ($scope.menu_service.selectedSideMenu.s_menus_id == null || $scope.menu_service.selectedSideMenu.s_menus_id==undefined)  {
                              $scope.menu_service.setSelectedSidemenu(data.data,lang);
                              $scope.menu_service.addNewSideMenuToNavbar($scope.menu_service.selectedSideMenu);
                            }
							else  {
                              $scope.menu_service.selectedSideMenu = data.data;   
                            }
							
                            $scope.menu_service.updateNavbarSelectedSideMenu();
                            MessagingService.addMessage(data.msg,'success');
                    },
					function(error){    
                                MessagingService.addMessage(error.msg,'error');
                          
                    });
              };
               
               
               
            $scope.localVars.getPages();    
            $scope.localVars.menuLoaded = true;
			
            $scope.$watch('menu_service.selectedSideMenu',function(newValue,oldValue){
                  if (newValue!=oldValue) {
                  $scope.menuItem=$scope.menu_service.getSelectedSidemenu();
                  }
            });
			   
           },
           link: function (scope, elem, attrs) {
              
           
      }
    }
  
};
'use strict';

export function multipleList (){ 
   return {
      require: 'ngModel',
      link: function(scope, elem, attr,ngModel) {
        
      //MIGOR START
              scope.search=[
				{id:1,filter:'onlist',name:"On list:",icon:"fa fa-chevron-right"},
				{id:2,filter:'notonlist',name:"Not on list:",icon:"fa fa-expand"},
                ];
				
              // if (scope.fd!=undefined) scope.fd.search=scope.search[0]; //MIGOR TODO - greska kod incijacije za multiple , mozda treba kod promjene na multiple ovo jos jednom okinuti
                 
              //MIGOR END
          var lenList = attr.multipleList;
          scope.doneBlur = false;
          if (lenList == undefined)
          {
            lenList = 0;
          }
        
        scope.updateValues=function(){
         if (scope.fd!=undefined)
         {
           if (scope.formData[0]['Field'+scope.fd.itemId]==undefined || scope.formData[0]['Field'+scope.fd.itemId]==null)
           {
          
             scope.formData[0]['Field'+scope.fd.itemId]=[];
       
           }
           scope.$select.selectedItemsMultipleList= scope.formData[0]['Field'+scope.fd.itemId];
           
           if (scope.formData[0]['Field'+scope.fd.itemId].length>0)
           {
              scope.fd.search.value=scope.formData[0]['Field'+scope.fd.itemId]; //MIGOR
           }
         }else
         {
          scope.$select.selectedItemsMultipleList=scope.selectedItems;
          
         }
         
        };
        
       // scope.updateValues();
        
        scope.$watch('selectedItems', function(){
               
               scope.updateValues();

        });
    
          /*function for multiple list START ILJ*/
          scope.removeItemFromList =  function(index){
              
              if (scope.formData[0]['Field'+scope.fd.itemId]!=undefined)
              {
                scope.formData[0]['Field'+scope.fd.itemId].splice(index,1);
              }else
              {
                
                scope.selectedItems.splice(index,1);
              }
              scope.checkValidity(); 
          if (scope.fd!=undefined) scope.fd.search.value=scope.formData[0]['Field'+scope.fd.itemId]; //MIGOR
        

          };
        
            
       scope.addItemToList =  function(item) {
        
        if (item!=null)
        {
          var pos;
          if (scope.formData[0]['Field'+scope.fd.itemId]!=undefined)
          {
           pos = scope.formData[0]['Field'+scope.fd.itemId].map(function(e) { return e.id; }).indexOf(item.id);
              
              if (pos<0){
              
                 scope.formData[0]['Field'+scope.fd.itemId].push(angular.copy(item));
                 
                
                
              }
          }else
          {
              if (scope.selectedItems==undefined) scope.selectedItems = [];
              pos = scope.selectedItems.map(function(e) { return e.id; }).indexOf(item.id);
              
              if (pos<0){
               
                 scope.selectedItems.push(angular.copy(item));
                
          
              }
          }
              if (scope.doneBlur)
              {
               scope.checkValidity(); 
              }
              if (scope.fd!=undefined) scope.fd.search.value=scope.formData[0]['Field'+scope.fd.itemId]; //MIGOR
        }
   

      };
    scope.checkValidity = function(){
        scope.doneBlur = true;
        var valid;
        if (scope.fd!=undefined)
        {
          valid = (!scope.fd.required) || (scope.formData[0]['Field'+scope.fd.itemId].length >= lenList);
        }else
        {
          valid = (!scope.required) || (scope.selectedItems.length >= lenList);
        }
        ngModel.$setValidity('multipleList', valid);
      
    };
    /*function for multiple list END*/   
      }
   };
};
'use strict';

export function ktNavbarDefinition() {
  
  return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktNavbarDefinition.html',
            scope:  {
                navbarItem:'=',
                localVars:'='
            },
            controller: function($scope,$rootScope,$timeout,MenuService,CodesService,MessagingService,ResourcesDataService){
            
              $scope.CTRL="ktNavbarDefinition"
               
              let lang = $rootScope.globals.currentUser.lang;
              var curUser=$rootScope.globals.currentUser

              if ($scope.localVars==undefined) $scope.localVars={};
              $scope.menu_service=MenuService;
               
              if ($scope.navbarItem==undefined) {      
                    $scope.navbarItem=$scope.menu_service.getSelectedNavbar();  
              }
              
              if ($scope.navbarItem.Users == undefined) $scope.navbarItem.Users=[]
              if ($scope.navbarItem.Groups == undefined) $scope.navbarItem.Groups=[]
              
              $scope.selectedUsers = $scope.navbarItem.Users
              $scope.selectedGroups = $scope.navbarItem.Groups
                            
              $scope.headerLabel="Grant access to navigation";
              $scope.usersLabel="Users";
              $scope.groupsLabel="Groups";
              
              $scope.getUsersGroups= function()
			  {
					var menuId = $scope.navbarItem.s_menus_id;
					if (menuId!=null) {
					  MenuService.getUsersGroupsForMenu(menuId,lang).then(
							function(data) {
								  $scope.navbarItem.Users = data.Users;
								  $scope.navbarItem.Groups = data.Groups; 
								  $scope.selectedUsers = $scope.navbarItem.Users  //needed for selectUsers widget
								  $scope.selectedGroups = $scope.navbarItem.Groups  //needed for selectGroups widget
								  $scope.navbarItem.UsersGroupsDownloaded = true; 
							},function(error){    
								MessagingService.addMessage(error.msg,'error');
					  });
					} else $scope.navbarItem.UsersGroupsDownloaded = true;
              }
              	
			
			ResourcesDataService.GetPublishedResourcesByTypeId($scope.navbarItem.s_menus_Target,'form').then(
					function (data) {       
						$scope.localVars.selectedResourcesPublishedList={}
						$scope.localVars.selectedResourcesPublishedList[$scope.navbarItem.s_menus_Target] = data.data;
						
						// fill 'select version' options to have both id and name (for already saved data)
						if ($scope.navbarItem.s_menus_SelectVersionDirect){ 
							  let publishedList = $scope.localVars.selectedResourcesPublishedList[$scope.navbarItem.s_menus_Target] 
							  publishedList.forEach( (item)=> {
								  if (item.Version == $scope.navbarItem.s_menus_TargetPageVersion) 
									  $scope.navbarItem.selectedPublishedResource = item
							  } ) 
						}
					},function(error){    
						MessagingService.addMessage(error.msg,'error');   
			});
			
			
              $scope.localVars.setPage = function() {
                var pos = $scope.localVars.pageList.map(function(e) { return e.id; }).indexOf($scope.navbarItem.s_menus_Target_id);
                if (pos>=0){
                  $scope.navbarItem.Target = $scope.localVars.pageList[pos];
                }
              }


              $scope.localVars.getPages = function() {
                  ResourcesDataService.getResourceDefListByType(lang,'page').then(
                        function(data) {
                          $scope.localVars.pageList = data.data;
                          $scope.localVars.pagesLoaded=true;
                          $scope.localVars.setPage();  
                        },function(error){    
                          MessagingService.addMessage(error.msg,'error');
                        });
              }
              
              $scope.localVars.getPages()

            //TODO - vidjeti jel ovo dole treba
             if ($scope.selectedUsers==undefined || $scope.selectedGroups==undefined)   $scope.getUsersGroups(); 
             
               
              $scope.$watch('menu_service.selectedNavbar',function(newValue,oldValue){
                  if (newValue!=oldValue) {
                        $scope.navbarItem=$scope.menu_service.getSelectedNavbar();
                        $scope.localVars.setPage()
                  }
               });
               
               $scope.$watch('selectedUsers',function(newValue,oldValue){
                  let a= newValue
                 // debugger
               });
               
                $scope.$watch('navbarItem',function(newValue,oldValue){
                  let a= newValue
                  $scope.localVars.setPage()

               });
            
            $scope.Cancel = function() {
               $scope.menu_service.navbarSelected = false;   
            };              
                                    
            $scope.saveNavbar = function(form) {
                //debugger; //saveNavbar
                if (form.$valid) $scope.menu_service.saveMenu($scope.menu_service.selectedNavbar,lang).then(
					function(data) {    
                        if ($scope.menu_service.selectedNavbar.s_menus_id == 0 || $scope.menu_service.selectedNavbar.s_menus_id == null || $scope.menu_service.selectedNavbar.s_menus_id==undefined)  {
                                $scope.menu_service.selectedNavbar = data.data;
                                $scope.currentNavbarId = $scope.menu_service.selectedNavbar.s_menus_id;
                                $scope.menu_service.selectedNavbar.SideMenus = [];
                                $scope.menu_service.navbarItems.push(angular.copy($scope.menu_service.selectedNavbar));
                                $scope.menu_service.setCurrentNavbarId($scope.currentNavbarId,lang);  
                        } else  {
                             $scope.menu_service.selectedNavbar = data.data;
                             $scope.currentNavbarId = $scope.menu_service.selectedNavbar.s_menus_id; 
                           }
                            
						MessagingService.addMessage(data.msg,'success');
							 
					},function(error){    
                         MessagingService.addMessage(error.msg,'error');
                      });
            };
            
              $scope.localVars.navbarLoaded = true;
			  
            }, //controller
            
            link: function (scope, elem, attrs) {  
      }
    }
  
};
'use strict';

export function ktNotificationList () {
   
    var controller = ['$scope', '$uibModal','$stateParams','$timeout','CodesService','ResourcesDataService','$rootScope','ProcessingService','WidgetDataExchangeService','GridsterService','MessagingService','CODES_CONST','TaskDataService',
                      function ($scope,$uibModal,$stateParams,$timeout,CodesService,ResourcesDataService,$rootScope,ProcessingService,WidgetDataExchangeService,GridsterService,MessagingService,CODES_CONST,TaskDataService) {
      
      
    
    $scope.localVars={};
    $scope.localVars.datasetMapperType=0;
    $scope.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_; 
    $scope.localVars.searchFormDownloaded = false;
    $scope.localVars.showSearchFilters=true;
    $scope.localVars.resourceDataDownloaded = true;
    $scope.taskId=$scope.resourceDefinition.ResourceDefId;
    if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
    if ($scope.taskId==undefined) $scope.taskId=0
    $scope.localVars.taskId=$scope.taskId;
    $scope.localVars.widgetType = 4;
    
    $scope.localVars.parentDatasetDefId=$scope.fd.related;
    $scope.localVars.animationsEnabled = true;
    $scope.localVars.gridsterType="resource";
          

     $scope.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: GridsterService.getEmptyDatasetForm()
				} ;
        
        
       $scope.localVars.gridOptionsResourceData = {
           //  columnDefs: colDefs,
        enableGridMenu: true,
        showGridFooter: true,
        showColumnFooter: true,
        enableRowSelection: true,
        multiSelect: $scope.fd.multiline,
      //  enableHorizontalScrollbar : 1,
       // enableVerticalScrollbar : 2,
        enableFiltering: true,
        enableRowHeaderSelection: true,
        enableColumnResizing: true,
        enableColumnReordering: true,
        useExternalPagination: true,
        paginationPageSizes: [10, 25, 50,100,200,500,1000],
        enablePaginationControls: false,
      };

  var paginationOptions = {
    pageNumber: 1,
    pageSize: 10,
    sort: null
    };
    
    
       $scope.localVars.gridOptionsRelated = {
      //  columnDefs: colDefs,
       enableGridMenu: true,
       showGridFooter: true,
       showColumnFooter: true,
       enableRowSelection: false,
       multiSelect: false,
       enableHorizontalScrollbar : 2, 
       nableVerticalScrollbar : 2,
       enableFiltering: true,
       enableRowHeaderSelection: true,
       enableColumnResizing: true,
       minRowsToShow: 2,
      
   }
    
        $scope.taskId=$scope.resourceDefinition.ResourceDefId;
        if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
        if ($scope.taskId==undefined) $scope.taskId=0;
        
        //$scope.fd.populateType=1;
        $scope.fd.parentDatasetDefId=$scope.fd.related;
        $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
        $scope.localVars.formType=$scope.resourceDefinition.form_type;
        $scope.localVars.source_type=$scope.resourceDefinition.source_type;
        $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
        $scope.formDefinition = $scope.resourceDefinition.form_definition;
        if  ($scope.formDefinition==undefined)
        {
          
          $scope.formDefinition = false;
        }
        
        
        
        
          if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        
        $scope.localVars.resourceRecordId = 0;
        $scope.fd.parentElementId = 0;
        
        
        
      var out_fields = ['resourceRecordId']
      //resourceLink
      var widgetDefinition = {DEI: [{'name':'resourceLinkDatasetList','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'datasetListWidget',widgetId: $scope.fd.presentationId,taskId:  $scope.lTaskId,
      resourceDefId : $scope.fd.related, //resourceDefId : $scope.selectedResource
      resourceRecordId:$scope.localVars.resourceRecordId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId, output:out_fields };
      $scope.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
      $scope.localVars.localId=$scope.localWidgetId;
      
      
      $scope.localVars.gridOptionsResourceData.onRegisterApi = function (gridApi) {
        //set gridApi on scope
        $scope.localVars.gridApi = gridApi;
           
          gridApi.selection.on.rowSelectionChanged($scope,function(row){

            $scope.localVars.datasetRecordSelected=row.isSelected;
            if ($scope.localVars.datasetRecordSelected)
              {
                if (row.entity.id!=$scope.localVars.selectedDatasetRecordId)
                {
                  $scope.localVars.selectedDatasetRecordId = row.entity.id;
                }
              }else
              {
                $scope.localVars.selectedDatasetRecordId = 0;
                
              }
              $scope.localVars.gridOptionsRelated.columnDefs=[];
              $scope.localVars.gridOptionsRelated.data=[];
              $scope.localVars.showGrid=false;
              $scope.localVars.prevTaskPackage ={resourceDefId:$scope.fd.related,records:gridApi.selection.getSelectedRows()}
              
               if (gridApi.selection.getSelectedRows().length>0)
              {
                //$rootScope.$broadcast('EventresourceLink'+$scope.fd.presentationId,$scope.selectedDatasetRecordId);
                WidgetDataExchangeService.setData({
                  DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                        ,{name:'resourceRecordIds',value:gridApi.selection.getSelectedRows()},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.presentationId,task_execute_id:$scope.taskExecuteId});
            
              }
              
          });
          
            //external pagination
          gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
            paginationOptions.pageNumber = newPage;
            paginationOptions.pageSize = pageSize;
            $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,newPage,pageSize);
          });
      
           gridApi.selection.on.rowSelectionChangedBatch($scope,function(row){

              $scope.localVars.prevTaskPackage ={resourceDefId:$scope.fd.related,records:gridApi.selection.getSelectedRows()}
              
          });
     }
     
     
     $scope.localVars.ProcessSearchForm=function (form){
            
            if (form!=undefined){
     					for(var i=0;i<form.length;i++) {
                
                    if ('type' in form[i])
                    {
                      if (form[i].type == 'resource' && form[i].autoSearch)
                      {
                        var pos = $scope.localVars.childWidgets.map(function(e) { return e.widgetId; }).indexOf(form[i].presentationId);
                        if (pos<0) $scope.localVars.childWidgets.push({widgetId:form[i].presentationId,processed:false})
                        
                      }
                     }
                      if ('layout' in form[i])
                      {
                           
                       $scope.localVars.ProcessSearchForm(form[i].layout);
                      }
              }
          } 
           
      };
      
      $scope.localVars.SearchFormProcessed=false;

      /*
      $scope.localVars.setDatasetMapperType= function(type){
            $scope.localVars.datasetMapperType = type;
          };      
      */
       $scope.localVars.setSelectedDataset = function(id)  {
              
              if ($scope.localVars.selectedResourceItem==undefined) $scope.localVars.selectedResourceItem={};
              var pos = $scope.localVars.datasetList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVars.selectedResourceItem.id = $scope.localVars.datasetList[pos].id;
                $scope.localVars.selectedResourceItem.name = $scope.localVars.datasetList[pos].name;
                $scope.localVars.selectedDataset = $scope.localVars.datasetList[pos];
                $scope.localVars.selectedResourceItem.name_confirmed = $scope.localVars.selectedResourceItem.name +' ('+$scope.localVars.selectedResourceItem.id +')'
                $scope.localVars.selectedResourceItem_c=$scope.localVars.selectedResourceItem;
                }
					};
          
       // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
        $scope.localVars.getDatasets = function()  {
						
            if ($scope.localVars.datasetList==undefined) $scope.localVars.datasetList=[];
          
            var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'notification').then(
						function(data) {
                      $scope.localVars.datasetList = data.data;
                       if ($scope.fd.related!=null)
                       {
                        $scope.localVars.setSelectedDataset($scope.fd.related);
                
                        }     
											 
		 },function(error){    
                                MessagingService.addMessage(error.msg,'error');
	 });
	}
            
      $scope.localVars.GetDatasetData=function(data)

      {

            fromWidget = data.widgetId;
            var allProcessed=true;
            var pos = $scope.localVars.childWidgets.map(function(e) { return e.widgetId; }).indexOf(fromWidget);
            //if (pos<0) $scope.fd.childWidgets.push({widgetId:fromWidget,processed:true});
            for (var i=0;i<$scope.localVars.childWidgets.length;i++)
              {
                
                if ($scope.localVars.childWidgets[i].widgetId == fromWidget) $scope.localVars.childWidgets[i].processed = true;
                if (!$scope.localVars.childWidgets[i].processed) allProcessed = $scope.localVars.childWidgets[i].processed;
              }
             // if (!$scope.SearchFormProcessed) $timeout(function() {$scope.GetDatasetData(fromWidget);},1000);
              if($scope.fd.autoSearch && allProcessed && $scope.localVars.SearchFormProcessed) {
                  $scope.localVars.selectedResource=$scope.fd.related;
                  $scope.localVars.getResourceColumns(true);
                                      
                }
      };
       
      if ($scope.localVars!=undefined) $scope.localVars.childWidgets = [];
      else $scope.localVars = {childWidgets : []};
     // $scope.uncaughtWidgets = [];
      var fromWidget=0;
   
 
      $scope.$on('SearchFormReady'+$scope.taskExecuteId,function(event, data){
      
           $scope.localVars.GetDatasetData(data); 
            
      });     
     
   
   //**********************************************************
	//           GET DATASET RELATED RECORDS
	//**********************************************************      
        $scope.localVars.getDatasetRelatedRecords = function (relatedDatasetId,recordId,modelId) {
  
  
         var lang = $rootScope.globals.currentUser.lang;
        
         ResourcesDataService.getResourceDataRelated($scope.fd.related,recordId,relatedDatasetId,0,modelId,lang).then(function(data) {
                                
                                     $scope.localVars.gridOptionsRelated.data = data.data;
                                     $scope.localVars.gridOptionsRelated.columnDefs = data.columnsDef;
                                     $scope.localVars.showGrid=true;
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
        
        
 //**********************************************************
	//           GET DATASET SINGLE RECORD
	//**********************************************************      
      $scope.localVars.getDatasetSingleRecord = function (relatedDatasetId,recordId) {
  
  
         var lang = $rootScope.globals.currentUser.lang;
        
         ResourcesDataService.getResourceDataDirectFilter(relatedDatasetId,0,lang,{id: recordId}).then(function(data) {
                                
                                     $scope.localVars.gridOptionsRelated.data = data.data;
                                     $scope.localVars.gridOptionsRelated.columnDefs = data.columnsDef;
                               
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
    
        $scope.$on('SearchFormReady'+$scope.taskExecuteId+$scope.fd.presentationId,function(event, data1){
      
                                        $scope.localVars.GetDatasetData(data1); 
            
        });
        
    $scope.localVars.getFormResource = function(){   
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.presentationId==null) {
                $scope.fd.presentationId = 0;
              }
              
               
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.populateType,$scope.fd.parentElementId,$scope.fd.presentationId,$scope.prevTaskExeId,$scope.localVars.formType,$scope.localVars.widgetType,$scope.localVars.resourceRecordId,"f",lang).then(function(data) {
                 
                                    $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                
                             
                                    $scope.localVars.selectedResourceItem_c = {'name':$scope.localVars.resourceWidgetDefinition.name,'id':$scope.fd.related,'relatedId':$scope.fd.related,'presentationId':$scope.fd.presentationId,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
                              
                               
                                    $scope.fd.fItemValue=data.data.widgets;

                                    $scope.localVars.searchFormDownloaded = true;
                                    $scope.localVars.setField($scope.fd.fItemValue,'required',false);
                                    $scope.localVars.formLoaded=true;
                                   //prepare search form
                                    $scope.localVars.ProcessSearchForm($scope.fd.fItemValue);
                                    $scope.localVars.SearchFormProcessed = true;
                                    if ($scope.localVars.childWidgets.length>0)
                                    {
                                      WidgetDataExchangeService.registerSearch({widgetId:$scope.fd.presentationId,taskExecuteId:$scope.taskExecuteId,prevTaskExeId:$scope.prevTaskExeId,childWidgets:$scope.localVars.childWidgets});
                                    }
                                    else
                                    {
                                       $rootScope.$broadcast('SearchFormReady'+$scope.taskExecuteId,{widgetId:$scope.fd.presentationId});
                                    }
                                    $scope.localVars.dashboard.widgets.layout =  data.data.widgets;    
                                    $scope.formData[$scope.fd.presentationId] =  data.data.form_data;
                                    $scope.fd.search = $scope.formData[$scope.fd.presentationId];
               
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error'); 
                             });
                              
      };//getFormResource_END
    
  $scope.localVars.getFormResourceOriginal = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.presentationId==null)
              {
                $scope.fd.presentationId = 0;
                
              }
              ResourcesDataService.getResourceForm($scope.fd.related,"i",lang).then(function(data) {
                            
                                $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                $scope.localVars.dashboard.widgets.layout=data.data.widgets;
                                 $scope.localVars.selectedResourceItem_c = {'name':$scope.localVars.resourceWidgetDefinition.name,'id':$scope.fd.related,'relatedId':$scope.fd.related, 'presentationId':$scope.fd.presentationId  ,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
                            
                             
                                $scope.fd.fItemValue=data.data.widgets;
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.presentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.localVars.resourceRecordId}]}]});
						
                                  $scope.localVars.searchFormDownloaded = true;
                                   $timeout(function() {
                                    $scope.localVars.formLoaded=true;
                                     
                                    });
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
   
   $scope.localVars.datasetRecordSelected = false;
   $scope.localVars.selectedDatasetRecordId = 0;
 
     
      $scope.localVars.getResourceData = function () {

        // scope.activity.activityMessage = ProcessingService.setActivityMsg('Downloading resource data for '+scope.selectedResource);
        var lang = $rootScope.globals.currentUser.lang;
        $scope.localVars.resourceDataDownloading = true;
        if ($scope.localVars.pageSize==undefined) $scope.localVars.pageSize = paginationOptions.pageSize;
        ResourcesDataService.getResourceData($scope.localVars.selectedResource,$scope.taskId,lang).then(function(data) {
                               
                                     $scope.localVars.gridOptionsResourceData.data = data.data;
                                     $scope.localVars.gridOptionsResourceData.columnDefs = data.columnsDef;
                                     $scope.localVars.restoreGridState();
                                     $scope.localVars.resourceDataDownloaded = true;
                                    
                                 },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                   
                             });
        };

		 
      //**********************************************************
      //           GET RESOURCE DATA PAGINATED
      //**********************************************************      
    $scope.localVars.getResourceDataPaginated = function (urlNext,urlPrev,newPage,pageSize) {
        
        
        $scope.localVars.resourceDataDownloaded = false;        
        if (Math.ceil($scope.localVars.totalCount/pageSize)<newPage)
        {
          newPage = Math.ceil($scope.localVars.totalCount/pageSize);
        }
         
         var lang = $rootScope.globals.currentUser.lang;
          
         if (pageSize==undefined)
         
         {
          $scope.localVars.pageSize = paginationOptions.pageSize;
          pageSize= $scope.localVars.pageSize;
         }
         
         if ($scope.fd.populateMethod=='M')
         {
          ResourcesDataService.getResourceDataPaginatedFilter($scope.localVars.selectedResource,urlNext,urlPrev,newPage,pageSize,lang,$scope.fd.search, $scope.localVars.dashboard.widgets.layout).then(function(data) {
                                    
                                    
                                      
                                    $scope.localVars.gridOptionsResourceData.data = data.data.results;
                                    $scope.localVars.restoreGridState();
                                    $scope.localVars.resourceDataDownloaded = true;
                                    
                                    $scope.localVars.nextPage = data.data.next;
                                    $scope.localVars.previousPage = data.data.previous;
                                    $scope.localVars.totalCount=data.data.count;
                                    $scope.localVars.currentPage=newPage;
                                    $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/pageSize);
                                    $scope.localVars.pageSize = pageSize;
                                    $scope.localVars.gridOptionsResourceData.totalItems=$scope.localVars.totalCount;
                                    
                                    WidgetDataExchangeService.setData({
                                    DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                                    ,{name:'resourceRecordIds',value: null},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.presentationId,task_execute_id:$scope.taskExecuteId});
            
                                    $rootScope.$broadcast("StartTask"+$scope.fd.presentationId+"Completed",$scope.localVars.gridOptionsResourceData.data);
                                   
                                   
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
         }
         else if ($scope.fd.populateMethod=='A')
         {
          var task_instance=0;  
          if ($scope.localVars.formType=='i') task_instance = $scope.taskInitiateId;
          else task_instance = $scope.taskExecuteId;
    
          ResourcesDataService.getResourceDataPaginatedAuto($scope.localVars.selectedResource,urlNext,urlPrev,newPage,pageSize,lang,$scope.fd.presentationId,task_instance,$scope.localVars.formType).then(function(data) {
                                    
                                    
                                      
                                    $scope.localVars.gridOptionsResourceData.data = data.data.results;
                                    $scope.localVars.restoreGridState();
                                    $scope.localVars.resourceDataDownloaded = true;
                                    
                                    $scope.localVars.nextPage = data.data.next;
                                    $scope.localVars.previousPage = data.data.previous;
                                    $scope.localVars.totalCount=data.data.count;
                                    $scope.localVars.currentPage=newPage;
                                    $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/pageSize);
                                    $scope.localVars.pageSize = pageSize;
                                    $scope.localVars.gridOptionsResourceData.totalItems=$scope.localVars.totalCount;
                                    
                                    WidgetDataExchangeService.setData({
                                    DEI: [{name:'resourceLink',value:[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                                    ,{name:'resourceRecordIds',value: null},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.presentationId,task_execute_id:$scope.taskExecuteId});
            
                                    $rootScope.$broadcast("StartTask"+$scope.fd.presentationId+"Completed",$scope.localVars.gridOptionsResourceData.data);
                                   
                                   
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
          
         }
        };


 $scope.localVars.pageChanged = function(){
        $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,$scope.localVars.currentPage,$scope.localVars.pageSize);
         };
   //**********************************************************
	//           GET RESOURCE COLUMNS
	//**********************************************************      
  $scope.localVars.getResourceColumns = function (getData) {
     var lang = $rootScope.globals.currentUser.lang;
     if ($scope.localVars.selectedResource==undefined) $scope.localVars.selectedResource = $scope.fd.related;
     
     if ($scope.localVars.selectedResource!=undefined && $scope.localVars.selectedResource!=null)
     {
     ResourcesDataService.getResourceColumns($scope.localVars.selectedResource,$scope.taskId,lang).then(function(data) {
                                
                $scope.localVars.gridOptionsResourceData.columnDefs = data.data;
                
                if (getData) $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,1,$scope.localVars.pageSize);               
                
         //                            MessagingService.addMessage(data.msg,'success');
         
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
               
     }
  };
     
     $scope.localVars.getResourceDataFiltered = function () {

            $scope.filter = {};
            var lang = $rootScope.globals.currentUser.lang;

           //scope.activity.activityMessage = ProcessingService.setActivityMsg('Retriving data '+scope.selectedResource);
          //$scope.filter = ResourcesDataService.prepareResourceWidgetData($scope.dashboard.widgets,-1);
         
          if ($scope.localVars.selectedResource==null) {
            $scope.localVars.selectedResource = $scope.fd.related;
          }
	//		ResourcesDataService.getResourceDataFiltered($scope.fd.related,lang,$scope.filter).then(function(data) {//MIGOR
         ResourcesDataService.getResourceDataFiltered($scope.localVars.selectedResource,$scope.taskId,lang,$scope.localVars.dashboard.data).then(function(data) {//MIGOR
                            
                                  $scope.localVars.gridOptionsResourceData.data = data.data;
                                  $scope.localVars.gridOptionsResourceData.columnDefs = data.columnsDef;
                                  
                                    $timeout(function(){
                                      $scope.localVars.resourceDataDownloaded = true;
                                      $scope.localVars.restoreGridState();
                                    });
                                 
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                             });
        };
		
       $scope.localVars.setField = function(form,name,value,msg)
        {
     				TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
        };
        
          $scope.localVars.showHideSearchForm = function()
        {
     				if ($scope.fd.showSearchForm) $scope.localVars.getFormResource();
        };
       
        
    
  if ($scope.fd.related!=null &&  !$scope.formDefinition && !$scope.localVars.searchFormDownloaded)
  {
    $scope.localVars.getFormResource();
    
  }else if ($scope.fd.related!=null && ($scope.localVars.showForm || $scope.fd.autoSearch))
  {
     $scope.localVars.getFormResource();
     $scope.localVars.getDatasets();
      $scope.localVars.getResourceColumns(false);
    
  }else if(!$scope.localVars.showForm)
  {
     $scope.localVars.showHideSearchForm();
     $scope.localVars.getResourceColumns(false);
     $scope.localVars.getDatasets();
    
  }
  
    
    
		 $scope.localVars.saveGridState= function() {
       var state = $scope.localVars.gridApi.saveState.save();
       $scope.fd.gridState = state;
       MessagingService.addMessage("To make changes stick please save form",'info');
             
    };
  
   $scope.localVars.restoreGridState= function() {
    if ($scope.fd.gridState!=null)
    {
       if ($scope.localVars.gridApi!=undefined)
       {
      
        $scope.localVars.gridApi.saveState.restore($scope,$scope.fd.gridState);
        
       }else
       {
        $timeout(function(){
            $scope.localVars.restoreGridState();
        });
       }
    }
  };
        
}]; //controler_END

  return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktNotificationList.html',
            controller: controller,
            link: function (scope, elem, attrs) {

            
            
               $rootScope.$broadcast("Widget"+scope.fd.PresentationId+"Ready",null);
                          
            
             }
             
             
  } 
        
};
'use strict';

export function ktNotificationSendWidget (TaskDataService) {
   
   var controller = ['$scope', '$uibModal', '$state','$stateParams','$element','dragularService','$timeout','CodesService','ResourcesDataService','$rootScope','ProcessingService','MessagingService','GridsterService','WidgetDataExchangeService','CODES_CONST',
                     function ($scope,$uibModal,$state,$stateParams,$element,dragularService,$timeout,CodesService,ResourcesDataService,$rootScope,ProcessingService,MessagingService,GridsterService,WidgetDataExchangeService,CODES_CONST) {
      
      $scope.fd.localVars = {};
      $scope.fd.localVars.searchFormDownloaded = false;
      $scope.fd.localVars.formLoaded=false;
      $scope.fd.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_;
      $scope.fd.localVars.animationsEnabled = true;
      $scope.fd.localVars.widgetType = 1;
      $scope.fd.localVars.hidePopulateMethod = true;
      
      if ($scope.fd!=undefined)
      {
           $scope.fd.populateMethod = "M";
      }else
      {
           $scope.fd={populateMethod : "M"};
      }
      
      $scope.gsrvc = GridsterService;
      $scope.fd.localVars.gridsterType="resource";
      $scope.fd.localVars.resourceType="notification";
     
          
     if ($scope.localVars == undefined) $scope.localVars={};
                
      $scope.localVars.showMenu = false
      
      $scope.localVars.toggleDropdown = function(){
                                       $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
      }
    
        
      $scope.fd.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: GridsterService.getEmptyDatasetForm()
				} ;
        
     
  
        //$scope.taskId=$stateParams.id;
        $scope.taskId=$scope.resourceDefinition.ResourceDefId;
        if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
        if ($scope.taskId==undefined) $scope.taskId=0;
        $scope.fd.localVars.taskId=$scope.taskId;
        $scope.fd.parentDatasetDefId=$scope.fd.related;
        $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
        $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;
        $scope.source_type=$scope.resourceDefinition.source_type;
        $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
        $scope.formDefinition = $scope.resourceDefinition.form_definition;
        
        if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
        $scope.fd.localVars.resourceRecordId=0;
        if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        
     //register widget 
     var out_fields = ['resourceId']
     var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'viewResourceWidget',widgetId: $scope.fd.presentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resourceDefId : $scope.fd.localVars.selectedResource, output:out_fields, };
      $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
       $scope.fd.localVars.localId=$scope.fd.localVars.localWidgetId;  		
         
        $scope.fd.localVars.showProperties=function(datasetMapperType,showPropertiesRight)
      {
            
            if ($scope.fd.localVars.datasetMapperType==undefined)
            {
               $scope.fd.localVars.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.fd.localVars.datasetMapperType==0 || $scope.fd.localVars.datasetMapperType!=datasetMapperType) 
                    $scope.fd.localVars.datasetMapperType = datasetMapperType;
               else 
                   $scope.fd.localVars.datasetMapperType=0;
            }
            if (showPropertiesRight) $scope.gsrvc.setFieldProperties($scope.fd);
            
      };
        
        $scope.fd.localVars.getFormResourceOriginal = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.presentationId==null)
              {
                $scope.fd.presentationId = 0;
                
              }
              ResourcesDataService.getResourceForm($scope.fd.related,"i",lang).then(function(data) {
                            
                                $scope.fd.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                $scope.fd.localVars.dashboard.widgets.layout=data.data.widgets;
                                if ($scope.fd.localVars.selectedResourceItem!=undefined)
                                 { 
                                  $scope.fd.localVars.selectedResourceItem.name=$scope.fd.localVars.resourceWidgetDefinition.name;
                                  $scope.fd.localVars.selectedResourceItem.relatedId=$scope.fd.related;
                                  $scope.fd.localVars.selectedResourceItem.presentationId=$scope.fd.presentationId;
                                  $scope.fd.localVars.selectedResourceItem.src_type_id=$scope.fd.populateType;
                                  $scope.fd.localVars.selectedResourceItem.src_type_text=$scope.fd.localVars.src_type_text[$scope.fd.populateType];
                                  $scope.fd.localVars.selectedResourceItem.parentElementId=$scope.fd.parentElementId;
                                 }
                                else{
                                  $scope.fd.localVars.selectedResourceItem={'name':$scope.fd.localVars.resourceWidgetDefinition.name,'relatedId':$scope.fd.related, 'presentationId':$scope.fd.presentationId  ,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.fd.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
 
                                }
                                $scope.fd.wItemValue=data.data.widgets;
                                
                                var container = $element.children().eq(0);
                                GridsterService.setupDragular($scope.fd.wItemValue,container,'rows-'+$scope.fd.presentationId,'row-'+$scope.fd.localVars.gridsterType+'-hadle',true);
                                
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.presentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.fd.localVars.resourceRecordId}]}]});
						
                                  $scope.fd.localVars.searchFormDownloaded = true;
                                  $scope.fd.localVars.formLoaded=true;
                                     
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
        
        $scope.fd.localVars.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
               if ($scope.fd.presentationId==null)
               {
                    $scope.fd.presentationId=0;
            
               }
               $scope.fd.localVars.formLoading=true;
                         
              ResourcesDataService.getResourceFormExtended($scope.fd.related,$scope.taskId,$scope.fd.localVars.formType,$scope.fd.presentationId,"w",lang).then(function(data) {
                               
                                  $scope.fd.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                  $scope.fd.localVars.dashboard.widgets.layout =  data.data.widgets;
                                 if ($scope.fd.localVars.selectedResourceItem!=undefined)
                                 { 
                                  $scope.fd.localVars.selectedResourceItem.name=$scope.fd.localVars.resourceWidgetDefinition.name;
                                  $scope.fd.localVars.selectedResourceItem.relatedId=$scope.fd.related;
                                  $scope.fd.localVars.selectedResourceItem.presentationId=$scope.fd.presentationId;
                                  $scope.fd.localVars.selectedResourceItem.src_type_id=$scope.fd.populateType;
                                  $scope.fd.localVars.selectedResourceItem.src_type_text=$scope.fd.localVars.src_type_text[$scope.fd.populateType];
                                  $scope.fd.localVars.selectedResourceItem.parentElementId=$scope.fd.parentElementId;
                                 }
                                else{
                                  $scope.fd.localVars.selectedResourceItem={'name':$scope.fd.localVars.resourceWidgetDefinition.name,'relatedId':$scope.fd.related, 'presentationId':$scope.fd.presentationId  ,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.fd.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
 
                                }
                              
                                $scope.fd.wItemValue=data.data.widgets;
                                $scope.fd.localVars.searchFormDownloaded = true;
                                  
                                  $scope.fd.localVars.formLoaded=true;
                                  $scope.fd.localVars.formLoading=false;
                                   
                                  var container = $element.children().eq(0).children().eq(1).children().eq(0);
                                  GridsterService.setupDragular($scope.fd.wItemValue,container[0],'rows-'+$scope.fd.presentationId,'row-'+$scope.fd.localVars.gridsterType+'-handle',true);
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 $scope.fd.localVars.formLoading=false;
                                 
                                
                             });
                              
      };
      
              
        $scope.fd.localVars.getFormResourceWithData = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.presentationId==null || $scope.fd.presentationId==undefined)
              {
                $scope.fd.presentationId = 0;
                
              }
              
              if ($scope.fd.parentElementId==null || $scope.fd.parentElementId==undefined)
              {
                $scope.fd.parentElementId = 0;
                
              }

              
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.populateType,$scope.fd.parentElementId,$scope.fd.presentationId,$scope.prevTaskExeId,$scope.fd.localVars.formType,$scope.fd.localVars.widgetType,$scope.fd.localVars.resourceRecordId,"w",lang).then(function(data) {

                                  $scope.formData[$scope.fd.presentationId] =  data.data.form_data;
                                  $scope.fd.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                  $scope.fd.localVars.dashboard.widgets.layout=data.data.widgets;
                                  $scope.fd.localVars.resourceRecordId = data.data.resourceRecordId;
                                  $scope.fd.localVars.datasetRecordId=$scope.fd.localVars.resourceRecordId;
                                  if ($scope.fd.localVars.selectedResourceItem!=undefined)
                                 { 
                                  $scope.fd.localVars.selectedResourceItem.name=$scope.fd.localVars.resourceWidgetDefinition.name;
                                  $scope.fd.localVars.selectedResourceItem.relatedId=$scope.fd.related;
                                  $scope.fd.localVars.selectedResourceItem.presentationId=$scope.fd.presentationId;
                                  $scope.fd.localVars.selectedResourceItem.src_type_id=$scope.fd.populateType;
                                  $scope.fd.localVars.selectedResourceItem.src_type_text=$scope.fd.localVars.src_type_text[$scope.fd.populateType];
                                  $scope.fd.localVars.selectedResourceItem.parentElementId=$scope.fd.parentElementId;
                                 }
                                else{
                                  $scope.fd.localVars.selectedResourceItem={'name':$scope.fd.localVars.resourceWidgetDefinition.name,'relatedId':$scope.fd.related, 'presentationId':$scope.fd.presentationId  ,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.fd.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
 
                                }
                                //$scope.fd.wItemValue=data.data.widgets;
                               
                                 //  $timeout(function() {
                                     $scope.fd.localVars.formLoaded=true;
                                     $scope.fd.localVars.formLoading=false;
                                     $scope.fd.localVars.searchFormDownloaded = true;
                                      
                                 //   });   
                                                                          
                                   WidgetDataExchangeService.setData({widgetId:$scope.fd.presentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.fd.localVars.resourceRecordId}]}]});
	                                 
                                   var container = $element.children().eq(0).children().eq(1).children().eq(0);
                                   GridsterService.setupDragular($scope.fd.wItemValue,container[0],'rows-'+$scope.fd.presentationId,'row-'+$scope.fd.localVars.gridsterType+'-handle',true);
                                   
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      
      
      
        $scope.fd.localVars.setField = function(form,name,value,msg)
        {
     				TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
        };
        
           $scope.fd.localVars.setSelectedDataset = function(id)  {
              
              if ($scope.fd.localVars.selectedResourceItem==undefined) $scope.fd.localVars.selectedResourceItem={};
              var pos = $scope.fd.localVars.datasetList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.fd.localVars.selectedResourceItem.id = $scope.fd.localVars.datasetList[pos].id;
                $scope.fd.localVars.selectedResourceItem.name = $scope.fd.localVars.datasetList[pos].name;
                $scope.fd.localVars.selectedDataset = $scope.fd.localVars.datasetList[pos];
                $scope.fd.localVars.selectedResourceItem.name_confirmed = $scope.fd.localVars.selectedResourceItem.name +' ('+$scope.fd.localVars.selectedResourceItem.id +')'
                $scope.fd.localVars.selectedResourceItem_c=$scope.fd.localVars.selectedResourceItem;
                }
					}
          
                  
          // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
					$scope.fd.localVars.getDatasets = function()  {
						
            if ($scope.fd.localVars.datasetList==undefined) $scope.fd.localVars.datasetList=[];
          
            var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'notification').then(
						function(data) {
										
											  $scope.fd.localVars.datasetList = data.data;
                       if ($scope.fd.related!=null)
                       {
                        $scope.fd.localVars.setSelectedDataset($scope.fd.related);
                
                        }     
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					}
          
  if ($scope.fd.related!=null &&  !$scope.formDefinition && !$scope.fd.localVars.searchFormDownloaded)
  {
     $scope.fd.localVars.getFormResourceWithData();
    // $scope.fd.localVars.getDatasets();
    // $scope.fd.localVars.setSelectedDataset($scope.fd.related);
    
  }else if ($scope.fd.related!=null)
  {
     $scope.fd.localVars.getFormResource();
     $scope.fd.localVars.getDatasets();
     //$scope.fd.localVars.setSelectedDataset($scope.fd.related);
    
  }
  
  
      }];

  return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktNotificationSendWidget.html',
            controller: controller,
            link: function (scope, elem, attrs) {

           
            
           // scope.resourceData = {};
  
            scope.fd.localVars.prepareResourceData = function(resourceRecordId){

             scope.fd.itemValue =  ResourcesDataService.prepareResourceWidgetData(scope.fd.localVars.dashboard.widgets.layout,resourceRecordId);
            }
          
           scope.fd.localVars.processWidgetDependencies = function() { //-----  ktUploader  -----
              
           if (scope.fd.tItemValue!=undefined) 
            for (var i=0;i< scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<scope.fd.tItemValue[i].DEI.length;j++) {
                        if ((scope.fd.tItemValue[i].DEI[j].name==linkedItem) && (scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("view "+scope.fd.presentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                               // console.log("view "+ scope.fd.presentationId+" dobio event " + event.name);
                                for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    scope.fd.localVars.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    scope.resourceRecordId = scope.fd.localVars.linkedResourceId;
                                  }
                                  if (data[k].name=='resourceId') scope.fd.localVars.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                }
                          
                              //get selectedRecord
                              //scope.getFormResourceWithData();
                                
                                    //	data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId}
                                    
                              }) //on_END
                        }//if
                    }//for j
                }//if

             // else {  scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget

          if (scope.fd.presentationId==undefined || scope.fd.presentationId==null) scope.fd.presentationId=0;
          
          scope.fd.localVars.formType=scope.resourceDefinition.form_type;
          /*
          TaskDataService.getWidgetDependencies(scope.taskId,scope.fd.presentationId,scope.fd.localVars.formType).then(function(data) {
                               
                                scope.fd.tItemValue=data.data;
                                scope.fd.localVars.processWidgetDependencies();
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                                */
          
            scope.$on('InitiateTaskPostProcess',function(event, data){
              
            if (data!=undefined){
              for(var i=0;i<data.length;i++) {
                if (scope.fd.presentationId==data[i].widgetId) WidgetDataExchangeService.setData(data[i]); 
              }
              //set all elements read-only
            }
              scope.fd.localVars.setField(scope.fd.localVars.dashboard.widgets.layout,'readOnly',true);
          });
  
      }     
    }
        
};
'use strict';

export function ktNumber () {
        return {
            restrict: 'A',
		controller: function ($scope,$rootScope,ResourcesDataService,CodesService,MessagingService,GridsterService,$templateCache,$compile,$element) {
                
                 $scope.gsrvc = GridsterService;
                 $scope.fd.localVars =  {};
                 $scope[$scope.fd.id]  = {'fd': $scope.fd}
                 if ($scope.formData==undefined)  $scope.formData = [{}];
				 if ($scope.fd.localVars==undefined)  $scope.fd.localVars={}
                
                 if ($scope.fd.Parameters==undefined) $scope.fd.Parameters = {};
                 
                 $scope.fd.setStep = function() {
                  $scope.fd.stepValue =parseFloat(Math.pow(0.1,$scope.fd.Parameters.NoOfDecimals)).toFixed($scope.fd.Parameters.NoOfDecimals);
                 }; 
                
                if ($scope.fd.stepValue==null || $scope.fd.stepValue==undefined) $scope.fd.setStep();
               
               
               
			   	$scope.myscope=$scope
				
                $scope.fd.SetDefault = function()
                {
                    $scope.fd.DefaultValue = {value:$scope.formData[0][$scope.fd.FieldName]};
                }
                
                
                
                $scope.fd.localVars.search=[
			  	{id:1,filter:'gt',code_name:'gte',name:"Greater than",icon:"fa fa-chevron-right"},
			  	{id:2,filter:'between',code_name:'between',name:"Between",icon:"fa fa-expand"},
			  	{id:3,filter:'lt',code_name:'lte',name:"Lower than",icon:"fa fa-chevron-left"},
			  	{id:4,filter:'eq',code_name:'eq',name:"Equals",icon:"fa fa-bars"} ];
                

                $scope.fd.localVars.processFilters = function(filterList)
                {
                    for (let i=0;i< $scope[$scope.fd.id]['fd'].localVars.search.length;i++)
                    {
                        let pos = filterList.map(function(e) { return e.id; }).indexOf( $scope[$scope.fd.id]['fd'].localVars.search[i].code_name);
                        if (pos>=0)  $scope[$scope.fd.id]['fd'].localVars.search[i].name = filterList[pos].name
                    }
                   
                    
                    if ($scope.fd.Search===undefined || $scope.fd.Search===null)   $scope.fd.Search=$scope.fd.localVars.search[3];//initialize to equals
                    if ($scope.fd.Search)  $scope.fd.Search.Value=$scope.formData[0][$scope.fd.FieldName]; 

                    $scope[$scope.fd.id]['fd'].localVars.filterReady=true
                }

                if ($scope.showSearchFilters || $scope.resourceDefinition.form_definition)
                {
                    let lang=$rootScope.globals.currentUser.lang;
                    CodesService.getCodesByName('search_filters',lang).then(function (data) {
                                //debugger;
                                //$scope.fd.localVars.processFilters(data.data)
                                $scope[$scope.fd.id]['fd'].localVars.processFilters(data.data); 
                    });
                }

                let itemValue = null;
                if ($scope.formData!=undefined)
                {
                        if (!$scope.formData.length) $scope.formData=[{}];
                        itemValue=$scope.formData[0][$scope.fd.FieldName]
                        
                }else $scope.formData=[{}];
                
                let itemValueState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+'-numberValueStateName'+$scope.fd.PresentationId,itemValue);
                let itemValueStateName = itemValueState.subject.name;
                
                
                let value_changed = function(data)
                {
                    itemValueState.subject.setStateChanges = data;
                    itemValueState.subject.notifyObservers("valueChanged");
                };
                
                let action_value_changed = $scope.ksm.addAction(itemValueState,"valueChanged",value_changed);
               
                $scope.on_blur_action=function()
                {
                        
                        $scope.ksm.executeAction(itemValueState,"valueChanged", $scope.formData[0][$scope.fd.FieldName]);
                        //$scope.fd.DefaultValue = $scope.formData[0][$scope.fd.FieldName];
                };
               
                
                
                let apply_value = function(data) {
                        if (data!=undefined) $scope.formData[0][$scope.fd.FieldName] = data;
                };
                
                if ($scope.fd?.Parameters?.DependentFieldId!=undefined && $scope.fd?.Parameters?.DependentFieldId!=null)   
                {
                    if ($scope.fd.Parameters.DependentFieldId!="")
                    {
                        let dependent_field = "Field"+$scope.fd.PresentationId;
                        let subscribedSubject = $scope.resourceDefinition.page_state_id+'-'+$scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId;
                        let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
                        let state = $scope.ksm.getState(subscribedSubject);
                        if (state.status=="ok") $scope.formData[0][$scope.fd.FieldName] = state.state;
                    }
                }
                
                
                
                
                      
                 
                $scope.fd.localVars.loadCounters = function()
                {
                  
 

                  if (!$scope.fd.localVars.counterList)
                  {
                    
                    const lang=$rootScope.globals.currentUser.lang
                    $scope.fd.localVars.countersLoaded=false
                    let counterDefId = 0
                    if ($scope.fd.Parameters.counterDefId?.id) counterDefId = $scope.fd.Parameters.counterDefId.id
                    ResourcesDataService.getResourceDefListByTypeFilter(lang,'counter','',counterDefId).then(
                        function(data) {
                                            
                            $scope.fd.localVars.counterList = data.data;
                                    
                            if (!Array.isArray($scope.fd.localVars.counterList))   $scope.fd.localVars.counterList=[];            
                                
                                  
                            //let pos = $scope.fd.localVars.countersList.map(function(e) { return e.id; }).indexOf($scope.fd.Parameters.counterDefId.id);

                            //if (pos>=0) $scope.fd.selectedResource=$scope.fd.resourcesList[pos];
                                              
                                    
                            $scope.fd.localVars.countersLoaded=true;
                                                                     
                        },function(error){    
                            MessagingService.addMessage(error.msg,'error');
                    });

                  } 

                  
                }      
                
                if ($scope.fd.Parameters.UseCounter) $scope.fd.localVars.loadCounters()
                
                $scope.fd.localVars.formatNumber = function(inputNumber)
                {
                  
                  let formatedNumber = ""

                  if ($scope.formData.length && $scope.formData[0][$scope.fd.FieldName]!=undefined)
                  {
                    let NoOfDecimals = 0
                    
                    if ($scope.fd.MaxLength>0) NoOfDecimals = $scope.fd.MaxLength

                    //if ($scope.fd.Parameters.UseFormat) 

                    if ($scope.fd.Dbtype!='integerfielddefinition') formatedNumber = inputNumber?.toLocaleString(navigator.language,{minimumFractionDigits:NoOfDecimals,maximumFractionDigits:NoOfDecimals});
                    else formatedNumber=inputNumber?.toString()
                    
                  } 

                  return formatedNumber
                }
                
               
                
                 $scope.fd.formatNumberBlockchain = function(input)
                {
                  let formatedNumber;
                  let web3;
                  if ($scope.fd.Parameters.ConvertBlockchainFormat)
                  {
                        if (input!=undefined)
                        {
                               

                                if (window.ethereum)
                                {
                                  web3 = new Web3(window.ethereum);
                                }else if (window.web3)
                                {
                                  web3 = new Web3(window.web3);
                                   //console.log(web3);
                                }
                                
                                else if ($rootScope.globals.currentUser.web3Infura)
                                {
                                   web3 = new Web3($rootScope.globals.currentUser.web3Infura);     
                                } else
                                {
                                   console.log('web3 provider not available');
                                   $scope.fd.WalletError = 'web3 provider not available';
                                   return input;
                                }
                                if ($scope.fd.Parameters.FromArray!=undefined) input = $scope.formData[0][$scope.fd.Parameters.SourceFieldName][$scope.fd.Parameters.FromArray];
                                
                                formatedNumber = web3.utils.fromWei(input.toLocaleString('fullwide', {useGrouping:false}), 'ether').toLocaleString(undefined,{minimumFractionDigits:$scope.fd.Parameters.NoOfDecimals,maximumFractionDigits:18});
                                
                  
                        }else  formatedNumber = input;
                  }else formatedNumber=input;
                  if ($scope.fd.Parameters.ConvertToDays) formatedNumber = formatedNumber/86400;                              
                  return formatedNumber;
                }
                
                $scope.fd.localVars.formatNumber();
                let template;
                if ($scope.resourceDefinition.form_definition)  template = $templateCache.get('ktdirectivetemplates/ktNumber.html');
                else template = $templateCache.get('ktdirectivetemplates/ktNumberExe.html');
                $element.append($compile(template)($scope)); 
                
                
                 if (itemValueState.subject.currentStateIndex>=0)
                {
                       
                        $scope.formData[0][$scope.fd.FieldName] = itemValueState.subject.getState;
            
                }   
                
                if ($scope.formData[0][$scope.fd.FieldName]!=undefined) $scope.ksm.executeAction(itemValueStateName,"valueChanged", $scope.formData[0][$scope.fd.FieldName]);
                
                
                
                
            },
             
            link: function (scope, elem, attrs) {
  
				scope.isOpen=true;
            
                scope.refreshSearchValue = function() {
                         if (scope.fd.Search) scope.fd.Search.Value=scope.formData[0][scope.fd.FieldName]
                }; 
                        
               
                
               
                scope.showProperties = function(event) {
                  	  scope.gsrvc.setFieldProperties(scope.fd, scope.inputArray);// inputArray is parent
                };
             
                scope.applyNumFilters = function(index) {
				    scope.fd.Search=scope.fd.localVars.search[index];
                    if (scope.fd.Search && scope.formData!=undefined && scope.formData.length) {
                            scope.fd.Search.Value=scope.formData[0][scope.fd.FieldName]; 
                    }
                    if (scope.fd.Search.Value==undefined) scope.fd.Search.Value = "";		
                };

                if (scope.fd.UpdateWithDefault && !scope.fd.NoUpdate) scope.formData[0][scope.fd.FieldName] = scope.fd.DefaultValue?.value
       
            }
            
        }
};
'use strict';

export function ktOutcomeActions () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktOutcomeActions.html',
              controller: function($scope,dragularService){
                
               $scope.getSeqNoForNewAction = function(){
                  var seqNo=0;
                  for (var i=0;i<$scope.outcomes.length;i++) {
                     
                     seqNo = seqNo+$scope.outcomes[i].actions.length;
                     
                  }
                  
                  seqNo++;        
                  return seqNo;
      
                  }
                  
              $scope.actions = [
                {id1:1,type:1,name1:'Start task',taskId:null,actionParams:{}},
                {id1:2,type:2,name1:'Send notification',taskId:null,actionParams:{}}
                
              ];
                      
                      
                  $scope.setupDragular = function(){
                            
                                      setTimeout(function(){
                                        // var container = elem.children().eq(0).children().eq(0).children().eq(0).children().eq(2).children().eq(0).children().eq(0).children().eq(1).children().eq(0).children();
                                         var container = document.getElementsByClassName('outcomeActionsDragular');
                                        // var widgets =[$$scope.pTaskInitiateFormResources,$$scope.pTaskExecuteFormResources,$$scope.initiateFormResources,$$scope.selectedResource,$$scope.executeFormResources];
                                                     
                                         dragularService(container,
                                           {
                                          // nameSpace: namespace ,
                                           copy: true,
                                           classes: {
                                           //mirror: 'gu-mirror-empty'
                                               },
                                           revertOnSpill: true,
                                           containersModel: $scope.actions,
                                           //direction:'vertical',
                                         // accepts: accepts,
                                           
                                            moves: function (el, container, handle) {
                                               return handle.classList.contains("element-drag-handle");
                                             }
                                         
                                            }
                                            );
                                          }
                                        );          
                                  
                            }
                 
                 $scope.setupDragular();
                },
             link: function (scope, elem, attrs) {
              
             
              
              /*          
              scope.outcomeDefActionsOptions =
              
              {
                itemMoved: function (event) {
                    event.dest.sortableScope.modelValue[event.dest.index].id = scope.getSeqNoForNewAction();
                },
                clone:true,
              }
              */
             
             
               
        }
    }
};
'use strict';

export function ktOutcomeDefList () {

    return {
                restrict: 'A',
                templateUrl: 'ktdirectivetemplates/ktOutcomeDefList.html',
                scope:{
                        task: '=',
                        localVars: '=',
                        fd: '=',
                },
                controller: function($scope,TaskDefinitionService,CodesService,MessagingService,TaskDataService,$rootScope,$timeout,dragulaService,GridsterService){
                        
                        $scope.parameters = {placeholder:'Select template to load',label:'Outcomes',name:'outcomes',selectedItem:$scope.task.TaskOutcomeHeadId,
                        paddingLeft:true,hideLabel:true,dropdownSize:'col-lg-24'};
                        $scope.showLoadFromTemplate ={};
                        $scope.tds=TaskDefinitionService;
                        $scope.outcomesDownloaded = false;
                        $scope.localVars.outcomes=[];
                        var lang=$rootScope.globals.currentUser.lang;
                        
                        $scope.gsrvc=GridsterService;
                        
                         $scope.setupDragula = function()
                         {
                              var widgetHandleResource = 'element-drag-handle';
                              
                              var bag = dragulaService.find($rootScope, 'bag-outcomes');
                              if (!bag)
                              {
                                 $scope.gsrvc.setupDragula('bag-outcomes','outcomesDragula',widgetHandleResource);    
                              }
                              else
                              {
                                   $scope.gsrvc.destroyDragula('bag-outcomes');
                                   $scope.gsrvc.setupDragula('bag-outcomes','outcomesDragula',widgetHandleResource); 
                                    
                               }
                         };  
                        
                        
                        TaskDataService.GetTaskOutcomesDef(lang).then(function(data) {
                       
                                    $scope.outcomeCodes = data.data;
                                    if ($scope.task.TaskOutcomeHeadId!=null)
                                    {
                                         
                                         var pos = $scope.outcomeCodes.map(function(e) { return e.id; }).indexOf($scope.task.TaskOutcomeHeadId);
                                         if (pos>-1) {
                                           $scope.parameters.selectedItem = $scope.outcomeCodes[pos];
                                           $scope.selectedOutcomeId=$scope.parameters.selectedItem.id;
                             
                                           
                                         }
                                         $scope.GetOutcomes(); 
         
         
                                    }   
                                  
                               },function(error){
                                 
                                   MessagingService.addMessage(error.msg,'error');
                               }
                         );
                
                 
                 $scope.showoutcomedetails= function(outcome,index,showLoadFromTemplate){
                                 //transfer child $scope parameters to parents 
                                 $scope.showLoadFromTemplate=showLoadFromTemplate;
                                 $scope.clickedOutcome = outcome;
                                 $scope.selectedOutcomeIndex=index
                                 $scope.showConfirmRemoveOutcome = false;
                                 $scope.setupDragula();
                 };
                 
                 $scope.selectOutcome= function(outcome){
                                 $scope.localVars.selectedButton.outcome=outcome;
                               
                 };
                 
                               
                 $scope.selectedOutcome = function(item,model){
                               $scope.parameters.selectedItem = item;
                               $scope.selectedOutcomeId=item.id;
                               }                     
                        $scope.removeAction = function(index){
                             //$scope.task.TaskOutcomeCodeId = null;
                              $scope.clickedOutcome.actions.splice(index,1);
                        }
                        
                        $scope.removeOutcome = function(index){
                             //$scope.task.TaskOutcomeCodeId = null;
                              $scope.localVars.outcomes.splice(index,1);
                        }
            
                            
                    
                          $scope.isSelectedOutcome = function(index) {
                             // if ($scope.selectedIndex==index) return true;
                              //return false;
                              if ($scope.selectedOutcomeIndex==index ) return true;
                              return false;
                              
                          };
                                          
                                          
                 $scope.localVars.promjenioOutcome = function (index,isSelected) {
                    //debugger   //promjenioOutcome              

                   isSelected = isSelected[$scope.localVars.selectedButtonIndex]
                   
                   if (isSelected[index] == true) {
                       for (let key in isSelected) {
                            isSelected[key]=false
                       } 

                       isSelected[index] = true
                       
                       $scope.localVars.selectedOutcomeIndex = index
                   } else 
                        $scope.localVars.selectedOutcomeIndex = null
                 }
                                          
                                                                         
                   
                  $scope.addOutcomeItem = function(newItem){
                                                   
                         if (newItem!=undefined && newItem!=null) {
                           $scope.localVars.outcomes.push(newItem);
                         }else {
                            // $timeout(function(){ //MIGOR -može se maknuti timeout
                                 $scope.localVars.outcomes.push({id1:null,name1:null,outcomeName:null,icon:null,btnName:'*New Outcome*',btnClass:null,actions:[]});
                                 $scope.selectedOutcomeIndex= $scope.localVars.outcomes.length-1;
                                 $scope.clickedOutcome=$scope.localVars.outcomes[$scope.selectedOutcomeIndex];
                                 $scope.showLoadFromTemplate[$scope.selectedOutcomeIndex]=true;
                            //});
                          };
                               
                            //$timeout(function(){ //MIGOR -može se maknuti timeout
                                   $scope.showoutcomedetails( $scope.localVars.outcomes[$scope.localVars.outcomes.length-1], $scope.localVars.outcomes.length-1, $scope.showLoadFromTemplate);
                            // });
                             
                            
                             // vidjeti da li ovo dole ima funkciju                   
                      //   if ($scope.parameters.selectedItem) delete $scope.parameters.selectedItem; //reset selected item
                     }
                          
                     $scope.GetOutcomes = function(){
                                
                               var lang=$rootScope.globals.currentUser.lang;               
                               var outcomeId = 0                /*MIGOR provjeriti jos*/  
                              // if ($scope.parameters.selectedItem!=undefined) { /*MIGOR provjeriti jos*/ 
                               //     outcomeId = $scope.parameters.selectedItem.id;  
                              // }
                              if ($scope.task.TaskOutcomeHeadId !=undefined) outcomeId = $scope.task.TaskOutcomeHeadId;
                              
                               
                               $scope.loadingActions=true; 
                              if (!$scope.outcomesDownloaded)
                               {   
                                    TaskDataService.GetTaskOutcomes( $scope.task.ResourceDefId,outcomeId,lang).then(function(data) {            
                                               
                                              $scope.localVars.outcomes = data.data;
                                              //$scope.task.TaskOutcomeHeadId = $scope.parameters.selectedItem.id;
                                              //$scope.selectedOutcomeId=$scope.parameters.selectedItem.id;
                                              $scope.outcomesDownloaded = true;
                                              $scope.loadingActions=false; 
                                             // if ($scope.localVars.outcomes.length>0)  $scope.showoutcomedetails($scope.localVars.outcomes[0],0,$scope.showLoadFromTemplate); //show first available outcome (if any)
                                              
                                    },function(error){
                                             $scope.loadingActions=false; 
                                             MessagingService.addMessage(error.msg,'error');
                                    });
                               }
                               else
                               {
                                $scope.loadingActions=false;      
                               }
                 
                     }//GetOutcomes
         
                        //**********************************************************
                        //           SAVE TASK OUTCOMES
                        //**********************************************************    
                        $scope.localVars.saveTaskOutcomes = function(){
               
                                    //check for errors
                                    var saveTaskOutcomesErrors=[];
                                    if (!$scope.task.InfiniteTask)
                                    {
                                       for(var i=0;i<$scope.localVars.outcomes.length;i++){
                                            if ($scope.localVars.outcomes[i].outcomeName==null) 
                                                saveTaskOutcomesErrors.push('Outcome name must be defined!');
                                       }
                                       if ($scope.localVars.outcomes.length==0)
                                           saveTaskOutcomesErrors.push("Outcome must be defined!");
                                    }
                                    
                                    if (saveTaskOutcomesErrors.length>0) 
                                             MessagingService.addMessage(saveTaskOutcomesErrors,'error');
                                    else 
                                    { // NO ERRORS
                         
                                                var lang=$rootScope.globals.currentUser.lang;
                                 
                                                //ako ne postoji outcomeHead a ima podataka onda kreiramo novi outcomeHead 
                                                if (($scope.task.TaskOutcomeHeadId == null || $scope.task.TaskOutcomeHeadId==undefined || $scope.task.TaskOutcomeHeadId==0))
                                                {
                                                            if ($scope.localVars.outcomes.length>0) {
                                    
                                                                        $scope.OutcomeHead = {Active:true,id:null};
                                                                        $scope.OutcomeHead.Lang = lang;
                                                                        $scope.OutcomeHead.OutcomeName="OutcomeTask"+$scope.task.ResourceDefId;
                                                                        $scope.OutcomeHead.Name="OutcomeTask"+$scope.task.ResourceDefId;
                    
                                                                        TaskDataService.SaveOutcomeDefinition($scope.OutcomeHead).then(function(data) {
                                                           
                                                                                    $scope.task.TaskOutcomeHeadId=data.data.data.id;
                                                                                    MessagingService.addMessage(data.data.msg,'success');     
                                                                                    $scope.saveTaskOutcomesFinalize();
                                                        
                                                                        },function(error){                   
                                                                                    MessagingService.addMessage(error.msg,'error');
                                                                        }); 
                                                            }
         
                                                }  //ako već postoji outcomehead onda samo snimamo outcome 
                                                else  $scope.saveTaskOutcomesFinalize();
                                    }
                        };
                   

                        $scope.saveTaskOutcomesFinalize = function(){
                                
                                 var outcomes = {outcomeId: $scope.task.TaskOutcomeHeadId, defaultOutcomeId:$scope.task.DefaultOutcomeId, outcomes:$scope.localVars.outcomes};
                                //TODO - nekad je ResourceDefId_id a nekad ResourceDefId !!
                                 TaskDataService.SaveTaskOutcomes($scope.task.ResourceDefId_id || $scope.task.ResourceDefId,!$scope.task.InfiniteTask,outcomes,lang).then(function(data) {
                                                                 
                                           $scope.localVars.outcomes.outcomeCodesDetails = data.data;
                                           $scope.localVars.outcomes.selectedOutcomeIndex=-1;
                                           MessagingService.addMessage(data.msg,'success');
                                
                                         
                                     },function(error){
                                         
                                           MessagingService.addMessage(error.msg,'error');
                                       });
                                                                   
                        }
                    
                            
                        $scope.GetAllOutcomes = function(){
                           
                               var lang=$rootScope.globals.currentUser.lang;                
                               TaskDataService.GetTaskOutcomes(0,0,lang).then(function(data) {            
                                                                                         
                                   for(var i=0;i<data.data.length;i++) { 
                                    data.data[i].id=data.data[i].id1;
                                    data.data[i].name=data.data[i].name1;
                                   }
                                   $scope.allOutcomes = data.data;
                                   
                               },function(error){
                                           MessagingService.addMessage(error.msg,'error');
                               });
                 
                        };//GetAllOutcomes
                           
                        // $scope.GetAllOutcomes();        
                        
            },
            link: function (scope, elem, attrs) {
              
               
            }
    }
};
'use strict';

export function ktPageContainer () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktTaskContainer.html',
             /*scope: {
                inputParameters: '=',
                //selectedItem: '=',
                inputArray: '=',
            },*/
             controller: function($scope,$rootScope,$timeout,UserService,ResourcesDataService,TaskDataService,MessagingService,GridsterService) {
                
                 $scope.gsrvc= GridsterService;
                 if (!Array.isArray($scope.fd.selectedTasks)) $scope.fd.selectedTasks=[];
                if ($scope.resourceDefinition!=undefined)
                {
                  $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
                }
                if ($scope.localVars == undefined) $scope.localVars={};
                $scope.localObj={loadedTasks : []};
                $scope.localVars.taskItem = null;
                $scope.localVars.selectedTask = {};
                $scope.localVars.showMenu = false
      
                $scope.localVars.toggleDropdown = function(){
                           $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
                }
                
                               
                $scope.$on('InlineTaskClosed',function(event,data){
                    //var index=data;
                    //$scope.localObj.loadedTasks.splice(index,1);
                    var taskId=data;
                    var pos = $scope.localObj.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (pos>=0)
                    {
                      $scope.localObj.loadedTasks.splice(pos,1);  
                    }
                });
               
                if ($scope.fd.selectedTasks===undefined || $scope.fd.selectedTasks===null) $scope.fd.selectedTasks = [];
                
                if ($scope.fd.FormDef!=null && $scope.fd.FormDef!==undefined) {
                 $scope.fd.selectedTasks = $scope.fd.FormDef;
                }else
                {
                $scope.fd.FormDef = [];
                
                } 
                
                let initiate_task = function(data)
                {
                    let loadTask=false;
                    $scope.localVars.taskLoaded = false;
                    if ($scope.localObj.loadedTasks.length>0)
                    
                    {
                        if ($scope.localObj.loadedTasks[0].taskId.id != data.taskId)
                        {
                            $scope.localObj.loadedTasks.length=0;
                            loadTask=true;
                        }
                    }else loadTask=true;
                    
                    
                  //  if (loadTask)
                    //{
                        $scope.localObj.loadedTasks.splice(0,1);
                         
                        for (let j = 0;j<$scope.fd.selectedTasks.length;j++)
                        {
                        
                            if ($scope.fd.selectedTasks[j].taskId.id==data.taskId)
                            {
                            
                                $timeout(function(){
                                $scope.localObj.loadedTasks.push(data);
                                $scope.localVars.taskLoaded = true;
                                });
                            }
                        }
                    //}
                }
                
                for (let i = 0;i<$scope.fd.selectedTasks.length;i++)
                {
                    let subscribedSubject = 'initiateTaskStateName'+$scope.fd.selectedTasks[i].widgetId;
                    let dependent_field = 'taskContainer'+$scope.fd.UuidRef+$scope.resourceDefinition.transaction_id;
                    $scope.ksm.subscribe(subscribedSubject,dependent_field,"taskInitiated",initiate_task);  
                
                }
                
                /*
                  $scope.localVars.LoadTask=function(taskId,outcomeId,previousTask,openTaskType)
                  {
                    
                   
                        $scope.localObj.loadedTasks.splice(0,0,{'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                        
                    
                    
                  }
                  
                 */
                let lang=$rootScope.globals.currentUser.lang;    
                ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
                                                    
                                $scope.fd.taskList = data.data;
                                $scope.fd.tasksLoaded=true;
                                
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });

                   $scope.localVars.taskIsOpen = function(taskId)
                  {
                    var isOpenPos = $scope.localObj.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (isOpenPos>=0) return true;
                    else return false;
                  }
                 
                   $scope.fd.pasteFromClipboard = function(task){
                        
                        navigator.clipboard.readText().then( (data) => {
                            /* clipboard successfully read */
                            $timeout(function(){task.widgetId = data})
                        },
                        () => {
                            /* clipboard read failed */
                            MessagingService.addMessage('Paste from clipboard failed','error');
                        });
                       
                }

                  
                $scope.fd.AddTaskToList = function (){
  
                    $scope.fd.selectedTasks.push({widgetId:null,taskId:null});
     
                }
                  
                   $scope.fd.ConfirmTaskList = function (){
                     $scope.fd.FormDef = $scope.fd.selectedTasks;
                     $scope.fd.showConfirmed=true;
                     $timeout(function(){$scope.fd.showConfirmed=false},5000);
                   }
                   $scope.fd.RemoveTaskFromList = function (index){
                 
                  
                   if (index>=0){
             
                             $scope.fd.selectedTasks.splice(index,1);
                                  
                   }
                            
                    
                 }
          
          
                 $scope.localVars.saveTaskToResource = function(tdid,tei,datasetDefId,datasetRecordId){
                          TaskDataService.saveTaskToResource(tei,datasetDefId,datasetRecordId,$scope.fd.presentationId).then(function(data) {
                                                    
                              $state.go('app.navbar.tasks.initiate',{id: tdid,fromStateName:$state.current.name,fromStateParams:$state.params,outcome_id:0,prev_task_execute_id:tei});
                                                             
                                
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
             }
             
                
                },
             link: function (scope, elem, attrs) {
                
               
        }       
              
    }
  
};
'use strict';

export function ktPageForm () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktPageForm.html',
             controller: function($scope,MessagingService,GridsterService,WidgetRegisterService,ProcessingService,
              ResourcesDataService,KatalyoStateManager,WidgetDataExchangeService,dragulaService,$stateParams,$rootScope,$timeout){
                 
                $scope.resourceObject = $stateParams.resource;
                $scope.CTRL='ktPageForm'
                $scope.formLoaded=false;
                $scope.resourceId=$stateParams.id;
                $scope.gsrvc = GridsterService;
                $scope.showFieldProperties = false;
                $scope.resourceDefinition.ResourceDefId=$scope.resourceId;
                //$scope.resourceDefinition.form_type=$scope.formType;
                $scope.formType='i'
                $scope.resourceDefinition.form_definition=true;

                $scope.gridsterType="page";
                $scope.refreshForm=false;
                $scope.dashboard = {};
                $scope.reloadTaskToolbox = false;
                if ($scope.localVars==undefined) $scope.localVars={};
                
                 WidgetDataExchangeService.deRegisterAllWidgets();

                 
              
                 $scope.dashboardLocal ={widgets:{layout: GridsterService.getEmptyTaskForm(),data:{}}};
                 let lang=$rootScope.globals.currentUser.lang;
                
                $scope.ksm = KatalyoStateManager;

                var form_saved = function(data)
                    {
                        formDefinitionState.subject.setStateChanges = data;
                        formDefinitionState.subject.notifyObservers("formSaved");
                    };
                
               
                var formDefinitionState,formDefinitionStateName;   
                $scope.setupKatalyoStateManager = function()
                {
                    formDefinitionState= $scope.ksm.addSubject('formDefinitionState'+$scope.resourceId+$scope.resourceDefinition.form_type,null);
                    formDefinitionStateName = formDefinitionState.subject.name;
                    
                    let action_value_changed = $scope.ksm.addAction(formDefinitionStateName,"formSaved",form_saved);
                    
                }
                 $scope.setupKatalyoStateManager();
                 
                $scope.ShowFormView = function(viewId,locked)
                {
                   //$timeout(function(){
                    if ($scope.resourceDefinition.formParams===undefined) 
                    {
                       $scope.resourceDefinition.formParams={} 
                    }
                       
                        $scope.resourceDefinition.formParams.formViewType=viewId;
                        $scope.gsrvc.setFormViewType($scope.resourceDefinition.formParams.formViewType);

                  //  })
                  
                         
                };
            
                      
                $scope.showHideProperties = function(value)
                {
                        $scope.gsrvc.setFieldPropertiesOpened(value);
                        $scope.showFieldProperties=$scope.gsrvc.getFieldPropertiesOpened();
             
                };
            
            $scope.$watch('gsrvc.getFieldPropertiesOpened()',function(newValue,oldValue){
                    
                    if (newValue!=oldValue)
                    {
                     $scope.selectedField=$scope.gsrvc.getFieldProperties();
                     $scope.showFieldProperties = $scope.gsrvc.getFieldPropertiesOpened();
                    }
            });
            
            
             $scope.$watch('gsrvc.getFieldProperties()',function(newValue,oldValue){
                    
                    if (newValue!=oldValue)
                    {
                     $scope.selectedField=$scope.gsrvc.getFieldProperties();
                     $scope.showFieldProperties = $scope.gsrvc.getFieldPropertiesOpened();
                    }
            });
   
   
     
            $scope.formFromServerLoaded = {};
            
            $scope.localVars.getResourceForm = function () {
                  
                    ResourcesDataService.getResourceForm($scope.resourceId,'i',lang).then(function(data) {
                                      
                            var resourceFormData = data.data
                            $scope.resourceDefinition = resourceFormData.resourceDefinition
                            $scope.resourceDefinition.form_definition = true                    
                                
                            if (resourceFormData.widgets.length>0) {
                                $scope.dashboard={widgets:{layout:resourceFormData.widgets}}
                             }else {
                              $scope.dashboard = {widgets:{layout:angular.copy($scope.resourceDefinition.ResourceExtended.DefaultForm)}}
                             }
                            
                             $scope.resourceVersion = $scope.resourceDefinition.Version;
                            
                             $scope.gsrvc.setResourceFormVersion($scope.resourceDefinition.id,{Version:$scope.resourceVersion}); 

                             $scope.resourceDefinition.formParams={formViewType:1,showGridNavigation:false};
                             
                           
                             $scope.formLoaded=true;
                             $scope.formFromServerLoaded = true;
                             $scope.ShowFormView($scope.resourceDefinition.formParams.formViewType,false);
                             
                           
                  },function(error){
               
                    
                   MessagingService.addMessage(error.msg,'error');
                  
                  
               });
                  
            };
            
            $scope.localVars.getResourceForm()

             $scope.get_published_resource_forms=function(){               
                ResourcesDataService.GetPublishedResources($scope.resource.uid).then(function (data) {       
                   $scope.localVars.publishedResources = data.data;
                });
            }
            $scope.get_published_resource_forms();
            

    $scope.newVersion = function()
    {
        $scope.creatingNewVersion=true
        ResourcesDataService.SetNewResourceVersion($scope.resourceId)
                .then(function(data) {
                    if (data.status==200)
                    {
                    
                        $scope.resourceDefinition.NewVersion = data.data
                        $scope.resourceDefinition.Published=false
                        $scope.formVersion = {NewVersion:data.data,Published:false}
                        $scope.gsrvc.setResourceFormVersion($scope.resourceDefinition.id,$scope.formVersion);
                    }else MessagingService.addMessage(data.data,'error');
                    $scope.creatingNewVersion=false
         
                   },function(error){
                                  MessagingService.addMessage(error.msg,'error');
                                  $scope.creatingNewVersion=false
                                 
                             });

    };
  
    //**********************************************************
    //          SHOW MODAL
    //**********************************************************
     $scope.showModal = function (p_type) {
     //POST publish-resource , resource_id, version i description
     //$scope.saveModal=true;
     $('#pagePublish').modal('show'); 
     $scope.modalAction=p_type
     $scope.newPublishVersion = $scope.resourceDefinition.NewVersion

        
    }
        //**********************************************************
          //           SAVE TASK FORM DEFINITION
          //**********************************************************
      
        $scope.saveForm = function (isValid) {
                
            if (isValid)
            {
                $scope.activity.activityMessage = ProcessingService.setActivityMsg('Saving page form for '+$scope.resourceId);
                $scope.savingForm = true;
               
                ResourcesDataService.saveResourceForm($scope.dashboard.widgets.layout,$scope.resourceId,$scope.formType,$scope.localVars.newDescription).then(function(data) {
                            
                                    MessagingService.addMessage(data.data.msg,data.data.msgType);
                                    $scope.formVersion= {Version:data.data.version}
                                    $scope.resourceDefinition.FormVersion=$scope.formVersion
                                    
                                    if (data.data.has_changes) 
                                    {
                                        $scope.resourceDefinition.Published=true
                                        $scope.formVersion.Published=true
                                        $scope.resourceDefinition.Version =  $scope.formVersion.Version
                                        $scope.gsrvc.setFieldPropertiesOpened(false)
                                    }

                                    $scope.gsrvc.setResourceFormVersion($scope.resourceDefinition.id,$scope.formVersion); 
                                    $scope.ksm.executeAction(formDefinitionStateName,"formSaved",data.data.new_items);

                                    $scope.savingForm = false;
                                     
                      
                                    if (data.data.formData.length>0) {
                                        $scope.dashboard={widgets:{layout:data.data.formData}}
                                       
                                        
                                    }   

                                    $scope.formLoaded=true;
                                    $scope.formFromServerLoaded = true;
                                    
                                    $('#pagePublish').modal('hide') 

                                    // $scope.ShowFormView($scope.resourceDefinition.formParams.formViewType,false);
                                     
    
                               },function(error){
                                 
                                   $scope.savingForm = false;
                                   MessagingService.addMessage(error.msg,'error');
                                  
                                });
                                  
                              
            }
    }
             
                             
            $scope.$on('CtrlPBPressed',function(event,data){
                  
                var key=data;
                if (key=='b' || key=='B')
                {
                    if ($scope.resourceDefinition.formParams.formViewType!=1) $scope.ShowFormView(1);
            
                }
                if (key=='p' || key=='P')
                {
                    if ($scope.resourceDefinition.formParams.formViewType!=2) $scope.ShowFormView(2);
                }
                  
            });  
          
         
           
            
                
                },
             link: function (scope, elem, attrs) {
              
            
            
             
                  
                  
            }
        }
};
'use strict';

export function ktPageformlayout () {
        return {
            restrict: 'A',
            
			controller: function ($scope,dragulaService,$rootScope,WidgetDataExchangeService,GridsterService,$compile,$element,$templateCache) {
                    
                $scope.CTRL="ktPageformlayout"
                
                let deletedWidgetsState= $scope.ksm.addSubject('deletedWidgetsState'+$scope.resourceDefinition.id+$scope.resourceDefinition.form_type,null);
                let deletedWidgetsStateName = deletedWidgetsState.subject.name;
                
                let add_deleted = function(data){

                    let deleted = deletedWidgetsState.subject.getState
                    if (deleted===undefined || deleted===null) deleted=[]            
                    deleted.push(data)
                    deletedWidgetsState.subject.setStateChanges = deleted;
                }            

                let action_value_changed = $scope.ksm.addAction(deletedWidgetsStateName,"addDeleted",add_deleted);
				//let action_value_changed = $scope.ksm.addAction(deletedWidgetsState,"addDeleted",add_deleted);
                
                let process_deleted_widgets=function(){

                    let deletedw = deletedWidgetsState.subject.getState
                    if (deletedw!==null)
                    {
                        for (let i=0;i<deletedw.length;i++)
                        {
                           for (let j=0;j<$scope.inputArray.layout.length;j++)
                           {
                             if ($scope.inputArray.layout[j].Status=="Deleted" && $scope.inputArray.layout[j].PresentationId===deletedw[i].PresentationId) $scope.inputArray.layout.splice(j,1)  
                           }
                           
                        }
                    }
                }
                let subscribedSubject = "formDefinitionState"+$scope.resourceDefinition.id+$scope.resourceDefinition.form_type;
                let dependent_field = $scope.inputArray.PresentationId;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"formSaved",process_deleted_widgets);

                

                $scope.removeField = function (index){
						// console.log("REMOVE FIELD "+index);
						if (index > -1) {
                        
                            WidgetDataExchangeService.deRegisterWidget($scope.inputArray.layout[index].LocalId);
                            if ($scope.inputArray.layout[index].Saved==true && $scope.inputArray.layout[index].PresentationId!=null && $scope.inputArray.layout[index].PresentationId!=undefined) {
								
                                 $scope.inputArray.layout[index].Status="Deleted";
                                 //subscribe to save form event

                                 $scope.ksm.executeAction(deletedWidgetsStateName,"addDeleted",{PresentationId:$scope.inputArray.layout[index].PresentationId,idx:index})
							 }else
                             {
                                $scope.inputArray.layout.splice(index,1);
                                
                             }
                             
						}

				};

                $scope.undoDelete = function (index){
                        // console.log("REMOVE FIELD "+index);
                        if (index > -1) {
                        
                                 $scope.inputArray.layout[index].Status="Active";
                        }

                };
                
       
                let template;
               if ($scope.resourceDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktPageFormLayout.html');
               else template = $templateCache.get('ktdirectivetemplates/ktPageFormLayoutExe.html');

                //template = $templateCache.get('ktdirectivetemplates/ktPageFormLayout.html');
          
               $element.append($compile(template)($scope));

			},
			 link: function (scope, elem, attrs) {

                if (scope.inputArray.layout==undefined || scope.inputArray.layout==null) scope.inputArray.layout = [];
          
            }
        };
};
'use strict';

export function ktPageMenu () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktPageMenu.html',
            scope:{
            localVars:'=',
            navbarItemsLeft:'=',
            navbarItemsRight:'=',
            pageMenu:'=?',
            resource:'=',
            },
            controller: ['$scope','$timeout','dragulaService','$rootScope','MenuService','ResourcesDataService','MessagingService','GridsterService','$state',
          
            function($scope,$timeout,dragulaService,$rootScope,MenuService,ResourcesDataService,MessagingService,GridsterService,$state){
               
               $scope.localVars.selectedNavbar = {layout : []}
               $scope.localVars.pageMenuItems= []

			   $scope.gsrvc = GridsterService;    
               let currentUser=$rootScope.globals.currentUser;
			   
               if ($scope.pageMenu) 
                    $scope.localVars.pageMenuItems= $scope.pageMenu
               else 
                    $scope.localVars.pageMenuItems=[]
               
  
               if ($scope.resource.ResourceType.ResourceCode=='pagemenu') {
                  $scope.localVars.showNavbarDetails = true;
                  $scope.localVars.showMenuDetails = false;
                        $timeout(function(){
                            $scope.localVars.showNavbarDetails = true;
                            $scope.localVars.showNavbarDetailsFirst = true;
                        })   
                }
                          
               
               $scope.whenSuccesfullDrop = function(itemIndex) {
                    $scope.localVars.getMenuDetails(itemIndex)
                    $scope.localVars.selectedPageMenuItem = $scope.localVars.pageMenuItems[itemIndex]
                     $timeout(function(){
                        $scope.localVars.showMenuDetails = true;
                    })  
               }
                                             


               if ($scope.localVars == undefined) $scope.localVars={};
               $scope.localVars.pagesLoaded=false;    
               let lang = $rootScope.globals.currentUser.lang;
              
   
                $scope.localVars.getMenuDetails = function(index) // when clicked on specific page menu item
                {
				 //debugger
                  if (  $scope.localVars.pageMenuItems.length===index) index--;
                  $scope.localVars.selectedMenu  =   $scope.localVars.pageMenuItems[index];
                  $scope.localVars.selectedMenu.index=index;
                  $scope.localVars.showMenuDetails = false;
				  
				  				  
				  if ($scope.localVars.selectedMenu.Groups==undefined) $scope.localVars.selectedMenu.Groups=[]
				  if ($scope.localVars.selectedMenu.Users==undefined)  $scope.localVars.selectedMenu.Users=[]
				  			  
                  if ($scope.localVars.selectedMenu.Target==undefined)   
							$scope.localVars.selectedMenu.Target = {id:  $scope.localVars.pageMenuItems[index].id,name:   $scope.localVars.pageMenuItems[index].name};
                  
				  if ($scope.localVars.selectedMenu.s_menus_Name==undefined) $scope.localVars.selectedMenu.s_menus_Name =   $scope.localVars.pageMenuItems[index].name;

				  
                   $timeout(function(){
                        $scope.localVars.showMenuDetails = true;
                    })
                
                    
                };
                
                  
                  
                $scope.localVars.deletePageMenu = function(menu,index) {
                    if (menu.s_menus_id!==null && menu.s_menus_id!==undefined)   {
                       if (menu.deleteItem) menu.deleteItem = false;
                       else menu.deleteItem = true;
                    }
                    else {
                        $scope.localVars.pageMenuItems.splice(index,1);
                        $scope.localVars.selectedMenu = null;
                        $scope.localVars.showMenuDetails = false;
                    }
                  };
                  
                  
                $scope.buildDataset = function(e)
                {
                    $state.go("'app.navbar.resources.new",{'resource_type':'dataset'});
                };
                
                 $scope.buildPage = function(e)
                {
                    $state.go("'app.navbar.resources.new",{'resource_type':'page'});
                };
                
                $scope.savePageMenu = function()
                {
                    let navbarLeft,navbarRight
                    let sideMenuItems = angular.copy($scope.localVars.pageMenuItems);
					//sideMenuItem may contain "Groups" or "Users" if there was change (if clicked on page menu element)
                    
                    MenuService.saveFullAppMenu($scope.resource.uid, navbarLeft, navbarRight,sideMenuItems ).then(
						function(data) {
							MessagingService.addMessage(data.msg,'success');
							$scope.localVars.pageMenuItems=data.pageMenu   
						},
						function(error){    
							MessagingService.addMessage(error.msg,'error');
						});
                };
                
                //get pages
                ResourcesDataService.getResourceDefListByType(lang,'page').then(
					function(data) {					
						$scope.localVars.pageList = data.data;
						$scope.localVars.pagesLoaded=true;    						 
                    },function(error){    
                    MessagingService.addMessage(error.msg,'error');
				});
                
            
            }],
            link: function (scope, elem, attrs) {       
             
            }
        }
  
};
'use strict';

export function ktPageMenuExe ($timeout) {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktPageMenuExe.html',
            scope:{
                sideMenus:'=',
                params:'=',
            },
            controller: ['$scope','$rootScope','MenuService','GridsterService',
          
            function($scope,$rootScope,MenuService,GridsterService){
               
                $scope.menu_service = MenuService;     
                $scope.gsrvc = GridsterService;     

                 let currentUser=$rootScope.globals.currentUser;
              
            }],
            link: function (scope, elem, attrs) {

                 scope.setSideMenu = function(menuId) {     
                    scope.menu_service.setSelectedSidemenu(menuId) ;
                };
                scope.mergeObjects = (...objects) =>
                    objects.reduce((acc, cur) => ({ ...acc, ...cur }));

                document.addEventListener('mouseup', function(e) {
                    // hide side-menu when clicked outside
                    let container = document.getElementById('page-menu-id');
                    if (container && scope.menu_service.getSideMenuVisibility()) {
                       $timeout(function(){scope.menu_service.toggleSideMenuVisibility()})
                    }   
                });
            
            }
        }
  
};
'use strict';

//import indexJson from './index.json'  assert {type: 'json'};
import indexJson from './../../../../0001_modules/0001_index/angularJs/index.json'//with {type: 'json'};

export function ktPopover ($compile) {

        return {
            restrict: 'A',
             scope: {
					tid: '=',
					enable: '=',
					timeout: '=',
					showOnStart: '=',
					icon: '='
				},
			controller: function($scope, $rootScope,$timeout, TaskDefinitionService,GridsterService){
				this.$timeout = $timeout
				var langCode = $rootScope.globals.currentUser.langObj.Code
				$scope.content= indexJson[langCode].popover    
			},	
            link: function (scope, elem, attrs) {
                	
				scope.open = function (tid) {
					//debugger
				}
				
				
				
				scope.$watch('enable',function(newValue,oldValue){
					if (oldValue==true && newValue==false) {
						//debugger
						elem.tooltip("hide");
						return
					}
					
					if (newValue && scope.content[scope.tid] ) {
						elem.attr('title', scope.content[scope.tid]);
						//elem.attr('content', scope.content[scope.tid]);
						elem.tooltip({html:true});
						 
						if (scope?.icon) elem.append($compile(" <i ng-click='open(tid)' class='fas fa-info-circle'></i>")(scope));
						if (scope?.showOnStart) {
							elem.tooltip("show");	
							setTimeout( ()=> { elem.tooltip("hide")} , 3000) 
						}
					}				  

					elem.on('$destroy', function() {	
						elem.tooltip('dispose');
						if (attrs?.$$observers?.['title']) delete attrs.$$observers['title'];
					});
				})
    
            }
        }
  
};
'use strict';

export function ktProcessingAnimation () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktProcessingAnimation.html',
            scope:{
                   message : "@",
                   showMsg: "=",
                   showAsCard: "=",
      			},
                controller: function(){},
             link: function (scope, elem, attrs) {
                    
              }
        }             
};
'use strict';

export function ktProcessingAnimationTimeline () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktProcessingAnimationTimeline.html',
            scope:{
                   message : "@",
                   showMsg: "=",
                   animationType: "=",
                   params: "=?",
      			},
             link: function (scope, elem, attrs) {
                
                scope.formItems = [1,2,3,4];
                if (scope.animationType=="table") scope.formItems = [1,2,3,4,5,6,7,8];
                if (scope.animationType=="card") 
                {   
                    scope.cardItems = []
                    for (let i =0;i<scope.params?.iNumber;i++) scope.cardItems.push(i+1)
                }
                if (scope.params?.skeletonColor)
                {
                    //scope.backgroundGradient ='background: linear-gradient(to right, '+scope.params?.gradientColorFrom+' 8%, '+scope.params?.gradientColorTo+' 18%, '+scope.params?.gradientColorFrom+' 33%);'
                    scope.skeletonColor = 'background-color:'+scope.params?.skeletonColor+';'
                }

                if (scope.params?.backgroundColor) scope.backgroundColor = 'background-color:'+scope.params?.backgroundColor+';'
               
              
        }  
    }           
};
'use strict';

export function ktProcPhProperty () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktProcPhProperty.html',
             controller: function($scope){    
                },
             link: function (scope, elem, attrs) {
                
                    
              }
        }
  
};
'use strict';

export function ktPropertyHeader () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktPropertyHeader.html',
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService){    
                },
             link: function (scope, elem, attrs) {
                
                    
              }
        }
  
};
'use strict';



export function ktPublishedResourceSelector  () {

        return {
             restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktPublishedResourceSelector.html',
             scope:{
                	 localVars : "=",
                       fd : "=",
             },
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService,dragularService,$timeout,CODES_CONST,MessagingService)
             {
                $scope.fd.formPriority='e';
              $scope.fd.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_NEW_;
              $scope.fd.RelatedPopulateType=1;
              if ($scope.fd.Parameters==undefined) $scope.fd.Parameters ={};              
              if ($scope.fd.PopulateType!=null && $scope.fd.PopulateType!="")
              {
                var pType = $scope.fd.PopulateType;
                var formPriority = pType.toString().substr(1,1);
                $scope.fd.RelatedPopulateType=pType.toString().substr(0,1);
                if (formPriority=="i" || formPriority=="e")
                {
                  
                  $scope.fd.formPriority = formPriority;
                }
              }

              if ($scope.fd.localVars.selectedResourceItem!=undefined)
              {
                $scope.fd.localVars.selectedResourceItem.src_type_text = $scope.fd.localVars.src_type_text[$scope.fd.RelatedPopulateType];
              }else
              {
                $scope.fd.localVars.selectedResourceItem = {src_type_text:$scope.fd.localVars.src_type_text[$scope.fd.RelatedPopulateType]};
              }
              
             


                  
                  //get-published-resources/(?P<resourceType>.+)/(?P<publishType>.+)'
        $scope.fd.localVars.GetPublishedResourcesByType = function()  {	
                
                if ($scope.fd.localVars.publishedResourceList==undefined) $scope.fd.localVars.publishedResourceList=[];
                var lang=$rootScope.globals.currentUser.lang;
                
                ResourcesDataService.GetPublishedResourcesByType($scope.fd.localVars.resourceType,'form').then(function (data) {       
                        $scope.fd.localVars.publishedResourceList = data.data;
                        
                           
                        if ($scope.fd.Parameters.PublishedResourceId!=null) {
                            $scope.fd.localVars.setSelectedResource($scope.fd.Parameters.PublishedResourceId);
                        }  
                 },function(error){    
                            MessagingService.addMessage(error.msg,'error');
                  });
               } 
    
    
     
    
	if ($scope.fd.localVars.publishedResourceList==undefined) {
            $scope.fd.localVars.GetPublishedResourcesByType();
    }
         
    /* if ($scope.fd.localVars.resourceList==undefined) {
            $scope.fd.localVars.getResources();
    }
    */     
       $scope.fd.localVars.changePriority= function(fp){ 
             $scope.fd.formPriority =fp; 
            };
         
          
         $scope.fd.localVars.confirm= function(){
               
                    $scope.fd.localVars.selectedResourceItem = $scope.fd.localVars.selectedResource
                   //$scope.fd.localVars.selectedResourceItem.src_type_text = $scope.fd.localVars.src_type_text[$scope.fd.RelatedPopulateType];
                  // $scope.fd.localVars.selectedResourceItem.name_confirmed = $scope.fd.localVars.selectedResourceItem.name +' ('+$scope.fd.localVars.selectedResourceItem.id +')'
                   $scope.fd.PopulateType=$scope.fd.RelatedPopulateType+$scope.fd.formPriority;
                   $scope.fd.localVars.datasetMapperType=0;
                   $scope.fd.localVars.setSelectedResource($scope.fd.localVars.selectedResourceItem.id);
             
               
             //  $scope.localVars.toggleProperties(0); //MIGOR dodao da se sakrije property kad stisne prozor , TODO - treba potvrditi da se nesto s time ne kvari
            };
				  
              
              
              $scope.fd.localVars.onSelectResourceCallback = function (item, model){

                  	var eventResultId=item.id;
                  	var eventResultName=item.name;
                    var eventResultParentElementId =item.parentElementId;
                   
                   // if (item.id!=$scope.fd.localVars.selectedResourceItem.id && $scope.fd.localVars.relatedPopulateType!=1){
                      // TODO - kad se promjeni dataset onda se treba resetirati GRIDSTATE
                     // $scope.fd.GridState = {} TODO i ovo dodati?
                     //$scope.fd.Parameters.GridState = {state:[]}
                      
                      //$scope.fd.localVars.getFormWidgets(item.id);
                      
                  //  }
                    
              
                	  $scope.fd.localVars.selectedResourceItem_c = {id:eventResultId, name : eventResultName,parentElementId:eventResultParentElementId,Form:item.Form,Version:item.Version,ResourceDefId:item.ResourceDefId};
                    
                    
              }
            
             $scope.fd.localVars.setSelectedSource = function(source_id){
             
                  if (source_id==-1)
                  {
                    
                    $scope.fd.RelatedPopulateType = '3';
                    $scope.fd.formPriority = 'e';
                    
                  }else
                  {
                   
                    $scope.fd.RelatedPopulateType = '2';
                    $scope.fd.formPriority = source_id.form_type;
                    $scope.fd.SrcWidgetId = source_id.parentElementId;
                    if (source_id.type=='rlist') $scope.fd.RelatedPopulateType = '4';
                    
                  }
             };
              
             $scope.fd.localVars.getFormWidgets = function(resource_id){
          

                  var lang=$rootScope.globals.currentUser.lang;
                  if ($scope.fd.PresentationId == undefined || $scope.fd.PresentationId==null) $scope.fd.PresentationId=0;
          
                  ResourcesDataService.getFormWidgets(resource_id,$scope.fd.localVars.taskId,$scope.fd.PresentationId,1,lang).then(function(data) {
                               
                             
                                 
                                    $scope.fd.localVars.currentTaskInitiateDatasets = data.data.initiate_widgets;
                                    
                                    $scope.fd.localVars.currentTaskExecuteDatasets = data.data.execute_widgets;
                                  
                                    $scope.fd.localVars.currentDownloaded = true;
                                  
                                  
                                  
                                    $scope.fd.localVars.previousTaskInitiateDatasets = data.data.initiate_widgets;
                                    $scope.fd.localVars.previousTaskExecuteDatasets = data.data.execute_widgets;
                                 
                                    $scope.fd.localVars.previousDownloaded = true;
                                  
                                  
                                  
                                     },function(error){
                                       MessagingService.addMessage(error.msg,'error');
                                });
             };
           
           
              $scope.fd.localVars.setPopulateMethod= function(populateMethod){
                        
                       $scope.fd.PopulateMethod=populateMethod;
                       
                       if (populateMethod=='A')
                        {
                          if ($scope.fd.localVars.selectedResourceItem_c!=undefined)
                          {
                                 var id=$scope.fd.localVars.selectedResourceItem_c.id;
                                 if (id==undefined) id=$scope.fd.localVars.selectedResourceItem_c.relatedId;
                                 if (id!=undefined) $scope.fd.localVars.getFormWidgets($scope.fd.localVars.selectedResourceItem_c.id);
                          }
                          
                        }
                  };
                  
              $scope.fd.localVars.setPopulateMethod($scope.fd.PopulateMethod);
              
              
              $scope.fd.localVars.setPopulateType= function(populateType){
                        
                       $scope.fd.RelatedPopulateType=populateType;
                       
                          if ($scope.fd.localVars.selectedResourceItem_c!=undefined)
                          {
                            $scope.fd.localVars.getFormWidgets($scope.fd.localVars.selectedResourceItem_c.relatedId);
                          }
                          
                        
                  }
          
               },
             link: function (scope, elem, attrs) {
                       
             
             }
        }
};
'use strict';

export function ktReadSmartContract () {
   
   var controller = ['$scope', '$uibModal', '$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','KatalyoStateManager','UtilityService','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,KatalyoStateManager,UtilityService,$templateCache,$compile,$element) {
     
     
      //$scope.fd = {};
      if ($scope.fd.formData==undefined)  $scope.fd.formData=[{}];
      $scope.fd.searchFormDownloaded = false;
      $scope.fd.formLoaded=false;
      $scope.fd.src_type_text=CODES_CONST._POPULATE_TYPE_;
      $scope.fd.animationsEnabled = true;
      $scope.fd.widgetType = 3;
      $scope.gsrvc = GridsterService;
      $scope.fd.formParams={formViewType:1,showGridNavigation:true};
      $scope.fd.contractDatasets = true;


      if ($scope.localVars == undefined)  $scope.localVars= {} 
      $scope.localVars.showMenu = false
      
      $scope.localVars.toggleDropdown = function(){
                           $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
      }
       
       
      $scope.fd.datasetMapperType=0;
      
      if ($scope.fd.PopulateType==undefined) $scope.fd.PopulateType="";
     
      $scope.fd.gridsterType="resource";
          // $scope.gridsterOpts = GridsterService.getGridsterOptions();
        
      $scope.fd.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: []
      } ;
        
    
  
      //$scope.taskId=$stateParams.id;
      $scope.taskId=$scope.resourceDefinition.ResourceDefId;
      if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
      if ($scope.taskId==undefined) $scope.taskId=0;
      $scope.fd.taskId=$scope.taskId;
      $scope.fd.ParentDatasetDefId=$scope.fd.Related;
      $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
      $scope.fd.formType=$scope.resourceDefinition.form_type;
      $scope.source_type=$scope.resourceDefinition.source_type;
      $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
      $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
      $scope.formDefinition = $scope.resourceDefinition.form_definition;
        
      if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
      $scope.fd.resourceRecordId=0;
      if ($scope.taskInitiateId==undefined)
      {
        $scope.taskInitiateId =0;
      
      }
      if ($scope.taskExecuteId==undefined)
      {
         $scope.taskExecuteId =0;  
      }
        if ($scope.prevTaskExeId==undefined)
        {
            $scope.prevTaskExeId =0;
        }
        
      //register widget 
      var out_fields = ['resourceId'];
      //if ($scope.fd.LocalId==undefined || $scope.fd.LocalId==null || $scope.fd.LocalId==0)
      //{
         var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'viewResourceWidget',widgetId: $scope.fd.PresentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resourceDefId : $scope.fd.selectedResource, output:out_fields, };
         $scope.fd.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
         $scope.fd.LocalId=$scope.fd.localWidgetId;
         $scope.fd.LocalId=$scope.fd.localWidgetId;
         //$scope.fd.LocalId=UtilityService.uuidNow();
         
      //}
      $scope.ksm = KatalyoStateManager;
      
      let update_presentation_id = function(data)
      {
         if (data[$scope.fd.LocalId]>0 && ($scope.fd.PresentationId==null || $scope.fd.PresentationId==0)) $scope.fd.PresentationId = data[$scope.fd.LocalId];
          //unsubscribe here later after implementing unsubscribe - ToDo
          
      }
      if ($scope.fd.PresentationId==0 || $scope.fd.PresentationId==null)
      {
         
         let dependent_field = $scope.fd.LocalId;
         let subscribedSubject = "formDefinitionState"+$scope.taskId+$scope.resourceDefinition.form_type;
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"formSaved",update_presentation_id);
  
      }        
      
       let apply_value = function(data)
        {
            let do_refresh=false;
            if (data!=undefined)
            {
               if (data != $scope.fd.resourceRecordId)
               {
                  if (typeof data ==='number') $scope.fd.resourceRecordId= data;
                  else if (Array.isArray(data))
                  {
                     if (data.length>0)
                     {
                      $scope.fd.resourceRecordId= data[0].id  
                     }
                  }else
                  {
                     $scope.fd.resourceRecordId = data.id;
                  }
                  do_refresh = true;
               }
            }
            //get selectedRecord
            if ($scope.fd.resourceRecordId == null) $scope.fd.resourceRecordId=0;
            
           // if ($scope.fd.resourceRecordId>0 && do_refresh) $scope.fd.getFormResourceWithData();
            
            
        };
        
      
      if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
      
      if ($scope.fd.Parameters.RefreshOnIdChange)
      {
         
         //find 
         //subscribe observer
           
         let dependent_field = "Field"+$scope.fd.PresentationId;
         let subscribedSubject = "resourceidValueStateName"+$scope.fd.Parameters.ResourceIdItemId+$scope.resourceDefinition.transaction_id;
         let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
         let val = $scope.ksm.getState(subscribedSubject);
         $scope.fd.resourceRecordId= val.id;
            
            //get selectedRecord
         if ($scope.fd.resourceRecordId == null) $scope.fd.resourceRecordId=0;
            
         //if ($scope.fd.resourceRecordId>0) $scope.fd.getFormResourceWithData();
      }
      
      //subscribe observer
      if ($scope.fd.PopulateType.toString().substr(0,1)=="4")
      {
         
        if ($scope.fd.SrcWidgetId!=undefined && $scope.fd.SrcWidgetId!=null)
        
        {
           
                let dependent_field = "Field"+$scope.fd.SrcWidgetId;
               // let subscribedSubject = $scope.fd.Parameters.SrcWidgetType+"ValueStateName"+$scope.fd.SrcWidgetId;
                let subscribedSubject = "rlistValueStateName"+$scope.fd.SrcWidgetId+$scope.resourceDefinition.transaction_id;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
            
        }  
         
      }
      
      let refresh_widget_data = function()
      
      {
        // $scope.fd.getFormResourceWithData();    
         
      }
      if ($scope.fd.Parameters.EventName!=undefined)
      {
         if ($scope.fd.Parameters.EventName!="")
         {
            let dependent_field2 = "Field"+$scope.fd.PresentationId;
            let subscribedSubject2 = "task"+$scope.resourceDefinition.transaction_id;
            let observer2 = $scope.ksm.subscribe(subscribedSubject2,dependent_field2,$scope.fd.Parameters.EventName,refresh_widget_data);
         }
      }
      
      $scope.fd.showProperties=function(datasetMapperType)
      {
            
            if ($scope.fd.datasetMapperType==undefined)
            {
               $scope.fd.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.fd.datasetMapperType==0 || $scope.fd.datasetMapperType!=datasetMapperType) $scope.fd.datasetMapperType = datasetMapperType;
               else $scope.fd.datasetMapperType=0;
            }
            
      };
           
      $scope.fd.setField = function(form,name,value,msg)
      {
         TaskDataService.setField(form,name,value);
         if (msg) MessagingService.addMessage(msg,'info');
      };  
      
      $scope.fd.getResourceAll = function () {
          
            ResourcesDataService.getResourceDefAll($scope.fd.Related).then(function(data) {
                               
                             // MessagingService.addMessage(data.msg,'success');
                              $scope.fd.resource = data.data;
                              $scope.fd.resourceLoaded = true;
                              if ( $scope.fd.Parameters.AutoLoad) $scope.fd.readBlockchainVars();
                              
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        };
              
         $scope.fd.readBlockchainVars = function ()
        {
            var lang=$rootScope.globals.currentUser.lang;
              //let provider=$rootScope.globals.currentUser.web3Provider;
              //$rootScope.globals.currentUser.web3Infura = new Web3(new Web3.providers.WebsocketProvider('wss://ropsten.infura.io/ws/v3/d5619a41905a41f88c5e742e4180ef3c'))
              $rootScope.globals.currentUser.web3Infura = new Web3(new Web3.providers.HttpProvider('https://mainnet.infura.io/v3/d5619a41905a41f88c5e742e4180ef3c'))
              
              ResourcesDataService.readBlockchainVars($scope.fd.resource.Parameters.ContractId,$scope.fd.resource.Parameters.ContractAbi).then(function(data) {
                  
                  $scope.fd.formData[0]=data.data.vars;
                  $scope.fd.getFormResourceOriginal( $scope.fd.resource.Parameters.PublicVarsDatasetId.id);

               },function(error){
                                   MessagingService.addMessage(error.msg,'error');   
         
               });
        }
      $scope.fd.getFormResourceOriginal = function(datasetId){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
              $scope.fd.formLoaded=false;
              ResourcesDataService.getResourceForm(datasetId,"i",lang).then(function(data) {
                            
                                $scope.fd.resourceWidgetDefinition= data.data.resourceDefinition;
                                if (Array.isArray(data.data.widgets)) $scope.fd.dashboard.widgets.layout =  data.data.widgets;
                                
                                if ($scope.fd.selectedResourceItem!=undefined)
                                 { 
                                  $scope.fd.selectedResourceItem.name=$scope.fd.resourceWidgetDefinition.name;
                                  $scope.fd.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.fd.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.fd.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.fd.selectedResourceItem.src_type_text=$scope.fd.src_type_text[$scope.fd.PopulateType];
                                  $scope.fd.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.fd.selectedResourceItem={'name':$scope.fd.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.fd.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                $scope.fd.wItemValue=data.data.widgets;
                                
                           /*
                                var container = $element.children().eq(0);
                                GridsterService.setupDragular($scope.fd.wItemValue,container,'rows-'+$scope.fd.PresentationId,'row-'+$scope.fd.gridsterType+'-hadle',true);
                             */   
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.fd.ResourceRecordId}]}]});
						
                                  $scope.fd.searchFormDownloaded = true;
                                  //$timeout(function(){$scope.fd.formLoaded=true});
                                  $scope.fd.formLoaded=true;
                                
                               // $scope.fd.setField($scope.fd.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.fd.setField($scope.fd.dashboard.widgets.layout,'Required',false);
                                //$scope.fd.readBlockchainVars();
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      $scope.fd.gridOptions = {
         
         showGridFooter: true,
        showColumnFooter: true,
        enableRowSelection: true,
        multiSelect: false,
      //  enableHorizontalScrollbar : 1,
       // enableVerticalScrollbar : 2,
        enableFiltering: true,
        enableRowHeaderSelection: false,
        enableColumnResizing: true,
        enableColumnReordering: true,
        //useExternalPagination: false,
        paginationPageSizes: [10, 25, 50,100,200,500,1000,5000,10000],
      }
       
        $scope.fd.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
               $scope.fd.formLoaded=false;
               if ($scope.fd.PresentationId==null)
               {
                    $scope.fd.PresentationId=0;
            
               }
               $scope.fd.formLoading=true;
                         
              ResourcesDataService.getResourceFormExtended($scope.fd.resource.Parameters,$scope.taskId,$scope.fd.formType,$scope.fd.PresentationId,"w",lang).then(function(data) {
                               
                                  $scope.fd.resourceWidgetDefinition= data.data.resourceDefinition;
                                  if (Array.isArray(data.data.widgets)) $scope.fd.dashboard.widgets.layout =  data.data.widgets;
                                  
                                 if ($scope.fd.selectedResourceItem!=undefined)
                                 { 
                                  $scope.fd.selectedResourceItem.name=$scope.fd.resourceWidgetDefinition.name;
                                  $scope.fd.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.fd.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.fd.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.fd.selectedResourceItem.src_type_text=$scope.fd.src_type_text[$scope.fd.PopulateType];
                                  $scope.fd.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.fd.selectedResourceItem={'name':$scope.fd.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.fd.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                              
                                $scope.fd.wItemValue=data.data.widgets;
                               
                                
                                  
                                $scope.fd.searchFormDownloaded = true;
                                
                                $timeout(function(){    
                                   $scope.fd.formLoaded=true;
                                   $scope.fd.formLoading=false;
                                });
                                  
                               
                              //  $scope.fd.setField($scope.fd.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.fd.setField($scope.fd.dashboard.widgets.layout,'Required',false);
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 $scope.fd.formLoading=false;
                                 
                                
                             });
                              
      };
      
              
       
           $scope.fd.setSelectedDataset = function(id)  {
              
              if ($scope.fd.selectedResourceItem==undefined) $scope.fd.selectedResourceItem={};
              var pos = $scope.fd.resourceList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.fd.selectedResourceItem.id = $scope.fd.resourceList[pos].id;
                $scope.fd.selectedResourceItem.name = $scope.fd.resourceList[pos].name;
                $scope.fd.selectedDataset = $scope.fd.resourceList[pos];
                $scope.fd.selectedResourceItem.name_confirmed = $scope.fd.selectedResourceItem.name +' ('+$scope.fd.selectedResourceItem.id +')'
                $scope.fd.selectedResourceItem_c=$scope.fd.selectedResourceItem;
                }
					}
          
                  
          // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
	$scope.fd.getResources = function()  {
						
            if ($scope.fd.resourceList==undefined) $scope.fd.resourceList=[];
          
            var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'smartcontract').then(
						function(data) {
										
											  $scope.fd.resourceList = data.data;
                       if ($scope.fd.Related!=null)
                       {
                        $scope.fd.setSelectedDataset($scope.fd.Related);
                
                        }     
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					}
   

$scope.fd.getPreviousTaskWidget  = function(linkType)
    {
      var pTaskData;
      var pTaskDataRet = WidgetDataExchangeService.getPrevTaskData($scope.prevTaskExeId);
      if (Array.isArray(pTaskDataRet) && pTaskDataRet.length>0) pTaskData = pTaskDataRet[0];
            var datasetId=0,datasetRecordId=0;
            if (pTaskData!=undefined)
            {
               if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
               {
               for (var i=0;i<pTaskData.DEI.length;i++)
               {
                 if (pTaskData.DEI[i].name==linkType)
                 {
                   if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                   {
                     for (var j=0;j<pTaskData.DEI[i].value.length;j++)
                     {
                      if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined) datasetId=pTaskData.DEI[i].value[j].value;
                      if (pTaskData.DEI[i].value[j].name=="resourceRecordId" && pTaskData.DEI[i].value[j].value!=undefined) datasetRecordId=pTaskData.DEI[i].value[j].value;
                      
                       
                     }
                        
                       
                   }
                     
                 }
                   
                 }
               }
            }
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };


   
   
  $scope.fd.previousTaskData=$scope.fd.getPreviousTaskWidget("resourceLinkDatasetList");
 
          
  if ($scope.fd.Related!=null &&  !$scope.formDefinition && !$scope.fd.searchFormDownloaded)
  {
     $scope.fd.getResourceAll();
    
  }
  else if ($scope.fd.Related!=null)
  {
     //$scope.fd.getFormResource();
     $scope.fd.getResources();
     $scope.fd.getResourceAll();
     //$scope.fd.setSelectedDataset($scope.fd.Related);
    
  } 

        $scope.fd.processWidgetDependencies = function() { //-----                
           if ($scope.fd.tItemValue!=undefined) 
            for (var i=0;i< $scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=$scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = $scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<$scope.fd.tItemValue[i].DEI.length;j++) {
                        if (($scope.fd.tItemValue[i].DEI[j].name==linkedItem) && ($scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = $scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("view "+$scope.fd.PresentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             $scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj $scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                              //  console.log("view "+ $scope.fd.PresentationId+" dobio event " + event.name);
                                for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    $scope.fd.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    $scope.fd.resourceRecordId = $scope.fd.linkedResourceId;
                                  }
                                  if (data[k].name=='resourceId') $scope.fd.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                }
                          
                              //get selectedRecord
                              //$scope.fd.getFormResourceWithData();
                                
                                    //	data: {resource_def_id:$scope.fd.linkedResourceDefId,resource_id:$scope.fd.linkedResourceId}
                                    
                              }) //on_END
                        }//if
                    }//for j
                }//if

             // else {  $scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget

          if ($scope.fd.PresentationId==undefined || $scope.fd.PresentationId==null) $scope.fd.PresentationId=0;
          
          $scope.fd.formType=$scope.resourceDefinition.form_type;
          /*
          TaskDataService.getWidgetDependencies($scope.taskId,$scope.fd.PresentationId,$scope.fd.formType).then(function(data) {
                               
                                $scope.fd.tItemValue=data.data;
                                $scope.fd.processWidgetDependencies();
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                                */
                              
    
            let template
            template = $templateCache.get('ktdirectivetemplates/ktReadSmartContract.html');
            $element.append($compile(template)($scope)); 

   
  
  
      }];

  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

            }     
  }
  
};
'use strict';

export function ktRegexValidator (){ 
   return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ngModel) {           
          ngModel.$validators.ktRegexValidator = function(modelValue, viewValue) {
            
            if (modelValue===undefined && viewValue===undefined) return true;
            
              let regex = attr.ktRegexValidator;
              let value = modelValue || viewValue;
              let valid = value.match(regex);
              if (valid!==null) return true;
              else
              {
                ngModel.$setValidity(scope.fd.ErrorMsg,false);
                return false;
              }
          };    
      }
   };
};
'use strict';

export function ktResource () {

        return {
            restrict: 'A', 
			controller: function ($scope, $rootScope,$element,$compile,$templateCache,ResourcesDataService,TaskDataService,ProcessingService,$timeout,$q,MessagingService,CODES_CONST,GridsterService,UtilityService,WidgetDataExchangeService,KatalyoStateManager) {

	
        
        $scope.gsrvc = GridsterService;  
		if ($scope.gsrvc.resourcesList == undefined) $scope.gsrvc.resourcesList={}
		if ($scope.gsrvc.presentationElements == undefined) $scope.gsrvc.presentationElements={}
		if ($scope.fd.resourcesList) 		delete $scope.fd.resourcesList
		if ($scope.fd.presentationElements) delete $scope.fd.presentationElements 
		


        $scope.localVars = {}
        
        $scope.localVars[$scope.fd.id]  = {} 
        //$scope.localVars[$scope.fd.id][$scope.fd.id]  = {'fd': $scope.fd, 'localVars':$scope.localVars[$scope.fd.id]}        
        
        if (Array.isArray($scope.fd.NameField)) $scope.fd.NameField={}
        //$scope.localVars[$scope.fd.id].dashboard = {widgets:[]}
        $scope.localVars[$scope.fd.id].datasetlistlinked = false
        $scope.localVars[$scope.fd.id].gridsterType = 'dataset'
        if ($scope.formData == undefined || !Array.isArray($scope.formData)) $scope.formData=[{}];
        if ($scope.formData.length == 0) $scope.formData.push({});
        if ($scope.formData[0][$scope.fd.FieldName] === undefined) $scope.formData[0][$scope.fd.FieldName] =[{}]
        let newValueSingle,newValueMultiple;
        $scope.localVars[$scope.fd.id].resourceTypesList=[{type:'dataset',name:'Dataset',ElementType:'resource'},{type:'file',name:'File',ElementType:'file'},{type:'counter',name:'Counter',ElementType:'counter'}]

        $scope.localVars[$scope.fd.id].TablePrefix = 'resource'+$scope.fd.Related//+'_'+$rootScope.globals.currentUser.organisation.id
        
        $scope.localVars[$scope.fd.id].formParams = {formViewType:1,showGridNavigation:true}
        $scope.localVars[$scope.fd.id].parentResourceRecordId = $scope.resourceRecordId
        $scope.ctrl = this;
        $scope.CTRLNAME='ktResource'

        if ($scope.fd.localVars == undefined) $scope.fd.localVars={}

        $scope.localVars[$scope.fd.id].ShowAdvancedProperties = $scope.params?.ShowAdvancedProperties
       
        $scope.fd.localVars = $scope.localVars
        
        //$scope.localVars[$scope.fd.id]=$scope.localVars[$scope.fd.id]

        if ($scope.fd.Parameters===undefined || $scope.fd.Parameters===null) $scope.fd.Parameters={}
        if ($scope.fd.Parameters.ResourceRelationshipType===undefined) $scope.fd.Parameters.ResourceRelationshipType='new'
        if ($scope.fd.Parameters.DefState===undefined) $scope.fd.Parameters.DefState='basic'
        
        if ($scope.fd.FormDefSearch==undefined) $scope.fd.FormDefSearch={}
        
        if ($scope.fd.Parameters.ResourceType==undefined)
        {
            if ($scope.fd.Parameters.ResourceRelationshipType=='existing')  $scope.fd.Parameters.ResourceType=$scope.fd.ResourceType
            else $scope.fd.Parameters.ResourceType=$scope.localVars[$scope.fd.id].resourceTypesList[0].type
        }
        if ($scope.fd.Parameters.ResourceType=='file') $scope.localVars[$scope.fd.id].actionDef= [{id:1,btnLabel:'Preview file',btnClass:'btn-outline-primary',icon:'fa fa-search'},{id:2,btnLabel:'Download file',btnClass:'btn-outline-primary',icon:'fa fa-download'}] 
    
        if ($scope.fd.MaxLength===undefined) $scope.fd.MaxLength=1
        if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
        $scope.fd.Parameters.UuidRef = $scope.fd.UuidRef

        let parentWidgetUid = ''

        if ($scope.parentWidget!=undefined) parentWidgetUid = $scope.parentWidget+'-'

         let w_actions=[
                    {id:0,name:'countRecords'},
                    {id:1,name:'refreshData'},
                    {id:2,name:'dataLoaded'},
                    {id:3,name:'valueChanged'},  
                ]

        var widgetDefinition = {DEI: [{'name':'resourceLinkDataset','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: w_actions,name: 'datasetListWidget',widgetLabel: 'Related resource records',widgetName: 'resourceWidget',widgetId: parentWidgetUid+$scope.fd.UuidRef,taskId:  $scope.lTaskId,
                                resourceDefId : $scope.fd.Related, //resourceDefId : $scope.selectedResource
                                resourceRecordId:$scope.localVars[$scope.fd.id].resourceRecordId,task_initiate_id:$scope.resourceDefinition.task_initiate_id,task_execute_id:$scope.resourceDefinition.task_execute_id, output:null,parentResourceId:$scope.resourceDefinition.uid };
        $scope.localVars[$scope.fd.id].localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
        
        if (!$scope.fd.Saved) $scope.fd.ItemId = $scope.localVars[$scope.fd.id].localWidgetId


        $scope.ksm = KatalyoStateManager;
        
        $scope.populateValue = function(newValue)
        {
                let ip,pos

                if (newValue.inputParams!=undefined && newValue.inputParams!='') ip =  JSON.parse(newValue.inputParams)
                if (ip?.fieldId) {

                    if (newValue.state?.itemValue?.val) pos = $scope.fd.localVars.datasetItems.map(function(e) { return e.id }).indexOf(newValue.state?.itemValue?.val[ip?.fieldId]);

                    if (pos>=0) $scope.itemValue.val = $scope.fd.localVars.datasetItems[pos]
                    else{

                        if (newValue?.state?.selectedItems) pos = $scope.fd.localVars.datasetItems.map(function(e) { return e.id }).indexOf(newValue.state?.selectedItems[ip?.fieldId])
                        if (pos>=0) $scope.itemValue.val = $scope.fd.localVars.datasetItems[pos]
                    }
                }else{

                    if (newValue?.state?.itemValue) $scope.itemValue = newValue.state.itemValue
                    else if (newValue?.state?.selectedItems) $scope.itemValue.val = newValue.state.selectedItems
                }
                $scope.formData[0][$scope.fd.FieldName] = $scope.itemValue.val;
                $scope.fd.Search.value = $scope.formData[0][$scope.fd.FieldName];
                if (newValue?.state) $scope.ksm.executeAction(valueStateName,"valueChanged", newValue?.state)
                else $scope.ksm.executeAction(valueStateName,"valueChanged", newValue)
               
                WidgetDataExchangeService.setData({
                    DEI: [{name:'resourceLinkDataset',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:newValue}
                        ,{name:'resourceRecordIds',value:newValue},{name:'resourceRecordsAll',value:$scope.fd.localVars.datasetItems}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});   
    
        }
       
         /**********************************************************************
         ****************** Sync data with State manager **********************
         ***********************************************************************/
       
        if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
        $scope.itemValue = {val:null};
        
        let valueState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+'-'+parentWidgetUid+$scope.fd.UuidRef,$scope.itemValue.val);
        let valueStateName = valueState.subject.name;

        let wrState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+'-'+parentWidgetUid+$scope.fd.UuidRef+'-widgetReady',$scope.itemValue.val);
        let wrStateName = wrState.subject.name;
        
        let value_changed = function(data)
        {   
            valueState.subject.setStateChanges = data;
            valueState.subject.notifyObservers("valueChanged");
        };
        
        let action_value_changed = $scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
        
        let refresh_data = function(data)
        {
            $scope.localVars[$scope.fd.id].GetResourceDataForParent()
            let st = valueState.subject.getState

            if (st==undefined) st={}
            st['action_index'] = data?.action_index
            valueState.subject.setStateChanges = st
            valueState.subject.notifyObservers("refreshData")
        };
        
        let action_refresh_data = $scope.ksm.addAction(valueStateName,"refreshData",refresh_data);
        
        let widget_ready = function(data)
        {
                    wrState.subject.setStateChanges = data;
                    wrState.subject.notifyObservers("widgetReady");
                   
        };
                
        let action_widget_ready = $scope.ksm.addAction(wrStateName,"widgetReady",widget_ready);

        let data_loaded = function(data)
        {
            valueState.subject.setStateChanges = data
            //notify
            valueState.subject.notifyObservers("dataLoaded")
        }
        let action_data_loaded= $scope.ksm.addAction(valueStateName,"dataLoaded",data_loaded);


         let count_records = function(data)
        {

            //valueState.subject.setStateChanges = data

            let result
            
            result = [$scope.localVars[$scope.fd.id].gridData.length]
            
            if ($scope.localVars[$scope.fd.id].gridData.length>0){
                //apply filter
                let key,val
                let in_data = data['events_data']['in_data']
                if (in_data==undefined) in_data = "{}"
                let input = JSON.parse(in_data)

              

                if (Object.keys(input).length>0)
                {
                    result = Object.entries(input).map( ([key, val] = item) => {
                                
                           if (val=='currentUser()') val = $rootScope.globals.currentUser.userid
                           return $scope.localVars[$scope.fd.id].gridData.reduce((count, item) => (item[key] == val ? count + 1 : count), 0)
                                
                    });
                } 

            }
            let state = valueState.subject.getState
            if (result!=undefined && result.length>0) state['countRecords'] = result[0]
            else state['countRecords'] = null
            valueState.subject.setStateChanges = state

            $scope.fd.Parameters.events[data.event_index].actions[data.action_index].completed = true
            $scope.fd.Parameters.events[data.event_index].actions[data.action_index].result = state['countRecords']
            $scope.processEvents(state,false)
            //notify
            valueState.subject.notifyObservers("countRecords")
        }
        let action_count_records= $scope.ksm.addAction(valueStateName,"countRecords",count_records);


        
        let apply_value = function(data)
        {
            let local_data;        
            
                local_data = data;
                if ($scope.fd.Parameters.DependentFieldFilter!=undefined)
                {
                        if ($scope.fd.Parameters.DependentFieldFilter!="" || $scope.fd.Parameters.DependentFieldElement!="")
                        {
                                if (Array.isArray(data))
                                {
                                        if (data.length>0) local_data = data[0];
                                        else local_data = null;
                                        
                                }
                                else
                                {
                                     local_data = data;
                                }
                                let dItems ;
                                if ($scope.fd.ShowField && !$scope.fd.ReadOnly) dItems = $scope.fd.localVars.datasetItems;
                                else dItems = $scope.fd.localVars.datasetItemsHidden;
                                if (dItems==undefined)
                                {
                                        $scope.fd.refreshDatasetDataList("",true,local_data);
                                        local_data=null;
                                }
                                else
                                {
                                        let element1,element2;
                                        if ($scope.fd.Parameters.DependentFieldFilter!="")
                                        {
                                                element1 = $scope.fd.Parameters.DependentFieldFilter;
                                                element2 = "id";
                                        }
                                        else
                                        {
                                                element1 = "id";
                                                element2 = $scope.fd.Parameters.DependentFieldElement;
                                        }
                                        let pos = dItems.map(function(e) { return e[element1]; }).indexOf(local_data[element2]);

                                        if (pos>=0) local_data = dItems[pos];
                                        else local_data = null;
                                }
                        }
                }
                $scope.populateValue(local_data);
        };
        
        $scope.apply_value = apply_value
        
        /*
        if ($scope.fd.Parameters.DependentFieldId!=undefined && $scope.fd.Parameters.DependentFieldId!=null)
        
        {
            if ($scope.fd.Parameters.DependentFieldId!="")
            {
                let dependent_field = "Field"+$scope.fd.PresentationId;
                let subscribedSubject = $scope.resourceDefinition.page_state_id+"-"+$scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value,true);
                let val = $scope.ksm.getState(subscribedSubject);
                $scope.populateValue(val.state);
            }
        }
        */
          /************ Get selected records for dropdown **************/
        $scope.fd.getDatasetList = function()
        {
                if ($scope.formData[0][$scope.fd.FieldName]!=undefined && $scope.formData[0][$scope.fd.FieldName].length>0 && $scope.fd.PresentationId!=null && $scope.fd.PresentationId!=undefined)
                {
                  ResourcesDataService.getResourceDataList($scope.fd.Related,$scope.fd.PresentationId,lang,{'id__in': $scope.formData[0][$scope.fd.FieldName]}).then(function(data) {
                             
                             if ($scope.formData===undefined) $scope.formData = [{}];
                             if ($scope.fd.MaxLength==1) $scope.formData[0][$scope.fd.FieldName] = data.data[0];
                             else $scope.formData[0][$scope.fd.FieldName] = data.data;
                             $scope.populateValue($scope.formData[0][$scope.fd.FieldName]);
                             WidgetDataExchangeService.setSearch($scope.fd.PresentationId,$scope.taskExecuteId);
                             //$scope.ksm.executeAction(valueStateName,"valueChanged", $scope.formData[0][$scope.fd.FieldName]);
                             //$scope.itemValue.val = $scope.formData[0][$scope.fd.FieldName];
                      },function(error){    
                      MessagingService.addMessage(error.msg,'error');
                  });
                }
        }
        
    $scope.localVars[$scope.fd.id].gridDataRetrieved =false;
    $scope.localVars[$scope.fd.id].results = {} 
    $scope.localVars[$scope.fd.id].gridData=[]
    

     $scope.localVars[$scope.fd.id].processTableAction = function(file, actionId){
        let btn = $scope.localVars[$scope.fd.id].actionDef[actionId]
        if (btn.id==1){

             $scope.localVars[$scope.fd.id].previewFile(file['resource'+$scope.fd.Related+'_id'],file['resource'+$scope.fd.Related+'_FileName'])

        }

        if (btn.id==2){
            $scope.localVars[$scope.fd.id].downloadFile(file['resource'+$scope.fd.Related+'_id'],file['resource'+$scope.fd.Related+'_FileName'])

        }
    }    
    /**********************************************************/
     /************ Populate ktResource smart table **************/
     /**********************************************************/
    $scope.localVars[$scope.fd.id].getDatasetDataForSmartTable = function(tableState, pageNumber,pageSize)
    {
         let deferred = $q.defer(); 
         if ($scope.fd.Related!=null && $scope.fd.Related!=undefined && $scope.fd.Related!="")
            {
                if (!$scope.resourceDefinition.form_definition)
                {
                
                    let presentation_id = $scope.fd.PresentationId
                    if (presentation_id==null || presentation_id===undefined)  presentation_id=0
                    var lang=$rootScope.globals.currentUser.lang;
                    if ($scope.localVars[$scope.fd.id].gridData===undefined) $scope.localVars[$scope.fd.id].gridData = []
                    
                    //debugger //getDatasetDataForSmartTable //==ktRefreshData
                    
                    if (pageNumber==undefined) pageNumber = 1;
                    if (pageSize==undefined) pageSize = 5;
                   
                   let items = $scope.formData[0][$scope.fd.FieldName] 
                   if (items==undefined) items = []
                   if ($scope.localVars[$scope.fd.id].gridDataRetrieved === true || items.length===0)
                   {
                         
                           $scope.localVars[$scope.fd.id].results.columns=$scope.localVars[$scope.fd.id].columnDefs
                           $scope.localVars[$scope.fd.id].results.pageSize = pageSize;
                           $scope.localVars[$scope.fd.id].results.count =    $scope.localVars[$scope.fd.id].gridData.length
                           $scope.localVars[$scope.fd.id].results.numberOfPages = Math.ceil($scope.localVars[$scope.fd.id].results.count/pageSize)
                           $scope.localVars[$scope.fd.id].results.results = $scope.localVars[$scope.fd.id].gridData.slice( (pageNumber -1) * pageSize, pageNumber * pageSize)

                           deferred.resolve({data: $scope.localVars[$scope.fd.id].results});
                   }
                   else
                   {
                        if (items!=[{}])
                        {
                           ResourcesDataService.getResourceDataDirectFilter($scope.fd.Related,{id__in: items},$scope.fd.GridState['columnsQuery']).then(function(data) {
                                
                                $scope.localVars[$scope.fd.id].gridDataRetrieved = true;                        
                           
                                $scope.localVars[$scope.fd.id].results.columns = $scope.fd.GridState['columnsDef']
                           
                                $scope.localVars[$scope.fd.id].results.pageSize = pageSize;
                                $scope.localVars[$scope.fd.id].gridData = data.data
                                $scope.localVars[$scope.fd.id].results.count =    $scope.localVars[$scope.fd.id].gridData.length
                                $scope.localVars[$scope.fd.id].results.numberOfPages = Math.ceil($scope.localVars[$scope.fd.id].results.count/pageSize)
                                if ($scope.localVars[$scope.fd.id].gridData) 
                                    $scope.localVars[$scope.fd.id].results.results = $scope.localVars[$scope.fd.id].gridData.slice( (pageNumber -1) * pageSize, pageNumber * pageSize)
                                else 
                                    $scope.localVars[$scope.fd.id].results = {}
                                
                                deferred.resolve({data: $scope.localVars[$scope.fd.id].results});
                                                   
                                },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                            });
                        }
                    }
                }
           
        }else

        {

            MessagingService.addMessage($scope.fd.Parameters.ResourceType+' is not selected. Please select '+$scope.fd.Parameters.ResourceType,'info');
            deferred.resolve({data: $scope.localVars[$scope.fd.id].results});
        }
        
         return deferred.promise;
    }
      
      /*
        $scope.$watch('itemValue.val',function(newValue,oldValue){
                if (newValue!=oldValue && newValue!=undefined)
                {
                //        $scope.fd.Parameters.ChildResource   
                
                }
        });
        */
        
        $scope.search=[
                            {id:1,filter:'onlist',name:"On list:",icon:"fa fa-chevron-right"},
                            {id:2,filter:'notonlist',name:"Not on list:",icon:"fa fa-expand"},
                      ];
				
        if ($scope.fd!=undefined) {
                  if ($scope.fd.Search==undefined)
                  {
                    $scope.fd.Search=$scope.search[0]; //MIGOR TODO - greska kod incijacije za multiple , mozda treba kod promjene na multiple ovo jos jednom okinuti
                  }
        } 

			  $scope.applySearchFilters = function(index) {
                   
				  $scope.fd.Search=$scope.search[index];
                            $scope.fd.Search.value = [ $scope.formData[0][$scope.fd.FieldName] ];
                            $scope.fd.isOpen=false;		
			  };
       
       
        $scope.src_type_text=CODES_CONST._POPULATE_TYPE_  
      
        $scope.fd.inputParamsDatasets = {placeholder:'Select dataset...',label:'Dataset',name:'datasets',columnSizeLabel:'col-24',
                hideLabel:false,paddingLeft:true,dropdownSize:'col-24',labelTextSize:'label-xs text-muted',sizeXs:true};
       
       
        $scope.fd.inputParamsSearchForm = {placeholder:'Select task...',label:'Search form task',name:'tasks',columnSizeLabel:'col-24',
                hideLabel:false,paddingLeft:true,dropdownSize:'col-24',labelTextSize:'label-xs text-muted',sizeXs:true};
                
       
        var lang = $rootScope.globals.currentUser.lang;
        
        $scope.localVars[$scope.fd.id].isResourceSelected = false;
 
				$scope.localVars[$scope.fd.id].selectedDataRecord=false;
				$scope.taskId=0;
       
        $scope.localVars[$scope.fd.id].showFormVar = false;
        
        $scope.localVars[$scope.fd.id].gridOptions ={}
	
					   
        $scope.fd.RelationshipType = $scope.fd.MaxLength;

			if ($scope.fd.localVars==undefined)  $scope.fd.localVars={}
        
        $scope.fd.ParentDatasetDefId=$scope.fd.Related;
        if ($scope.resourceDefinition!=undefined)
        {
          $scope.taskId=$scope.resourceDefinition.ResourceDefId;
          $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
          $scope.formType=$scope.resourceDefinition.form_type;
          $scope.source_type=$scope.resourceDefinition.source_type;
          $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
          $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
          $scope.formDefinition = $scope.resourceDefinition.form_definition;
          
         
        
        }
        
        if ($scope.taskId==undefined) $scope.taskId=0
         $scope.fd.gridsterType = "resource";
          
          $scope.localVars[$scope.fd.id].resourceDashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: [],
          data:{}
				} ;
        if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
        $scope.fd.resourceRecordId=0;
        if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
      
       
          //$scope.fd.resourcesList=[];
		  $scope.gsrvc.resourcesList[$scope.fd.UuidRef] = []
		  
          $scope.fd.resourceListLength=0;
          $scope.fd.selectedResource = 0;
		
  
        //*********************************************************************************************
        //************************************ GET DATASET LIST ***************************************
		//*********************************************************************************************
       $scope.localVars[$scope.fd.id].getResources = function(element_type,search)  {
			const lang=$rootScope.globals.currentUser.lang
            $scope.fd.RelatedLoaded=false
            //set widget variables

            //$scope.fd.ElementType=element_type

            ResourcesDataService.getResourceDefListByTypeFilter(lang,element_type,search,$scope.fd.selectedResource).then(
			    function(data) {
									
       			  $scope.gsrvc.resourcesList[$scope.fd.UuidRef] = data.data;
                            
                            if (!Array.isArray($scope.gsrvc.resourcesList[$scope.fd.UuidRef]))   $scope.gsrvc.resourcesList[$scope.fd.UuidRef]=[];            
                        
                            if ($scope.fd.Related!=null)
                            {
                                   $scope.fd.resourceId = $scope.fd.Related;
                                   $scope.fd.resourceListLength = $scope.gsrvc.resourcesList[$scope.fd.UuidRef].length;
                                   //select dataset from dropdown
                                    var pos = $scope.gsrvc.resourcesList[$scope.fd.UuidRef].map(function(e) { return e.id; }).indexOf($scope.fd.resourceId);

                                   if (pos>=0){
                                       $scope.fd.selectedResource=$scope.gsrvc.resourcesList[$scope.fd.UuidRef][pos];
                                      
                                       $scope.fd.isResourceSelected=true;
                                   }
                         
                            }

                    
							if ( !$scope.localVars[$scope.fd.id].publishedLoaded )  $scope.localVars[$scope.fd.id].getPublishedResources()
 
                            $scope.fd.RelatedLoaded=true;
                											 
                     },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
       };	  

       $scope.localVars[$scope.fd.id].getPublishedResources=function()
        {
            if ($scope.localVars[$scope.fd.id]!=undefined)
            {
                $scope.localVars[$scope.fd.id].publishedLoaded=false        
                ResourcesDataService.GetPublishedResourcesByTypeId($scope.fd.Related,'form').then(
                    function (data) {       
                        if ($scope.localVars[$scope.fd.id]!=undefined)
                        {
                                $scope.localVars[$scope.fd.id].publishedResourceList = data.data
                                $scope.localVars[$scope.fd.id].publishedLoaded=true
                               if ($scope.formDefinition && $scope.fd.GridState?.columnsDef!=undefined) 

                                {
                                    $scope.localVars[$scope.fd.id].gridDataRetrieved = true
                                    $scope.localVars[$scope.fd.id].resourceDataDownloaded = true
                                    
                                }
                               if ($scope.fd.Parameters.PublishedResourceId!=undefined) {
                                    if ($scope.fd.PresentationType==2) $scope.fd.ShowSearchForm = true
                                    $scope.localVars[$scope.fd.id].getPublishedResourceById($scope.fd.Parameters.PublishedResourceId,$scope.fd.ShowSearchForm)
                                }
                        }else MessagingService.addMessage('Error in localVars = '+$scope.fd.UuidRef,'error')

                       },function(error){    
                                      MessagingService.addMessage(error.msg,'error');
                });
            }else MessagingService.addMessage('Error - localVars = '+$scope.localVars[$scope.fd.id],'error');
        }   
             
			
        $scope.fd.resourceDataRecordSelected=false;

        

        $scope.localVars[$scope.fd.id].ShowForm = function(id) 
        { 
            $scope.localVars[$scope.fd.id].getPublishedResourceById(id,true)
            
        }

        $scope.fd.localVars[$scope.fd.id].ShowSearchForm = function(id) 
        {   let show_search_form
            if ($scope.fd.ShowSearchForm) show_search_form = false
            else show_search_form = true
            $scope.localVars[$scope.fd.id].getPublishedResourceById(id,show_search_form)
            
        }
		/*********************************************************************************************/
        /******************************* GET PUBLISHED DATASET DETAILS *******************************/
        /*********************************************************************************************/	

        $scope.localVars[$scope.fd.id].getPublishedResourceById = function(id,show_search_form) 
        {
            
            let pos
            let old_publish_id = $scope.fd.Parameters.PublishedResourceId
            
            pos = $scope.localVars[$scope.fd.id].publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
          
            if (pos>=0){
                $scope.localVars[$scope.fd.id].publishedResource = $scope.localVars[$scope.fd.id].publishedResourceList[pos]
                if (show_search_form)  {

                    if ($scope.fd.FormDefSearch?.layout!==undefined && $scope.fd.FormDefSearch?.layout!==null && $scope.fd.FormDefSearch?.layout?.length>0) {
                            //$scope.fd.FormDefinition.layout = $scope.fd.FormDef
                            //$scope.localVars[$scope.fd.id].formLoaded=true;
                            $scope.fd.formLoaded = true
                      } else 
                      {
                         
                            $scope.fd.FormDefSearch={}

                            ResourcesDataService.GetPublishedResourceById(id).then(function (data) {
                                    //get version here and load json

                                    

                                    let jsonFile=$scope.fd.Related+"-v"+data.data.Version+".json"
                                    ResourcesDataService.fetchJsonFile(jsonFile).then(function (widgetDef) {
                                            
                                             if (widgetDef.status)
                                            {
                                                 MessagingService.addMessage(widgetDef.data,'error');
                                                $scope.fd.formLoaded=true;
                                          
                                            }else{

                                                $scope.fd.FormDefSearch.layout  = widgetDef.Form
                                                $scope.fd.formLoaded = true
                                            }
                                        },function(error){    
                                            MessagingService.addMessage(error.msg,'error');
                                            $scope.fd.formLoaded=true;
               
                               
                                    });   
                               
                                   
                                },function(error){    
                                  MessagingService.addMessage(error.msg,'error');
                                  $scope.fd.formLoaded=true;
                            });

                        
                    }
                }else $scope.fd.formLoaded=true;
             
            }else $scope.fd.formLoaded=true;
        }    


         //*********************************************************************************************
          //************************************ GET TASK LIST ***************************************
					//*********************************************************************************************
					$scope.fd.getTasks = function(search)  {
						var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
										
											  $scope.fd.taskList = data.data;
                        
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
          }
					
        //  $scope.fd.getTasks('');
          
				    // when confirm selection clicked
            /*
              $scope.fd.confirmSelection = function ()
						{
							
							$scope.fd.SearchFormDownloaded=false;
							$scope.fd.resourceDashboard.widgets.length=0;
					 }
            	$scope.fd.cancel = function ()
						{
              $scope.fd.SearchFormDownloaded=false;
              $scope.fd.resourceDashboard.widgets.length=0;

            }
            */
	
        
         $scope.fd.rowSelectionChanged = function(row){
                             
                                $scope.formData[0][$scope.fd.FieldName]=row
                                $scope.localVars[$scope.fd.id].selectedResourceRecord = row
                                $scope.localVars[$scope.fd.id].selectedResourceRecordId = row[$scope.localVars[$scope.fd.id].TablePrefix+'_id'];                                 
                                $scope.localVars[$scope.fd.id].isRecordSelected=row.isSelected;
                                // count selected
                                $scope.fd.resourceDataRecordSelected=$scope.formData[0][$scope.fd.FieldName].length; 
                                
                                WidgetDataExchangeService.setData({
                                DEI: [{name:'resourceLinkDataset',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars[$scope.fd.id].selectedResourceRecordId},
                                {name:'resourceRecordIds',value:row},{name:'resourceRecordsAll',value:$scope.localVars[$scope.fd.id].gridOptions.data}]}],
                                widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});

        };
        
        /* delete selected child record*/
        $scope.localVars[$scope.fd.id].deleteChildRecord = function()
        {
              var lang = $rootScope.globals.currentUser.lang;
              if ($scope.localVars[$scope.fd.id].parentResourceRecordId>0 && $scope.localVars[$scope.fd.id].isRecordSelected)
              {
               
              ResourcesDataService.DeleteChildRelationship($scope.fd.PresentationId,$scope.parentResourceDefId,$scope.localVars[$scope.fd.id].parentResourceRecordId,$scope.localVars[$scope.fd.id].selectedResourceRecordId).then(function(data) {
                      MessagingService.addMessage(data.data,'success');
                       $scope.localVars[$scope.fd.id].gridData.length=0
                      $scope.localVars[$scope.fd.id].isRecordSelected = false
                      $scope.localVars[$scope.fd.id].GetResourceDataForParent();

                },function(error){    
                    MessagingService.addMessage(error.data,'error');
                                    });
            }       
        }
        /*   
        $scope.fd.getResourceDataRefresh = function (retValue) 
            {
              var lang = $rootScope.globals.currentUser.lang;
              //ToDo ovo prebaciti sve u jedan API poziv
              if ($scope.resourceRecordId>0)
              {
              ResourcesDataService.getResourceDataM2m($scope.fd.PresentationId,$scope.parentResourceDefId,$scope.fd.Related,$scope.resourceRecordId).then(function(data) {
                            $scope.formData[0][$scope.fd.FieldName] = data; 
                            $scope.setupGrid(data);                
                },function(error){    
                    MessagingService.addMessage(error,'error');
									});
            }       
        }
        */    

        $scope.localVars[$scope.fd.id].GetResourceDataForParent = function () 
        {
              var lang = $rootScope.globals.currentUser.lang;
              if ($scope.localVars[$scope.fd.id].parentResourceRecordId>0)
              {
                $scope.localVars[$scope.fd.id].gridDataRetrieved = false
                //$scope.formData[0][$scope.fd.FieldName]={}
                ResourcesDataService.getResourceDataM2m($scope.fd.PresentationId,$scope.parentResourceDefId,$scope.fd.Related,$scope.localVars[$scope.fd.id].parentResourceRecordId,$scope.taskId,$scope.fd.ItemId,lang).then(function(data) {
                            $scope.formData[0][$scope.fd.FieldName] = data; 
                           // $scope.localVars[$scope.fd.id].setupGridNew(data);  BUG TODO!
                            $scope.localVars[$scope.fd.id].setupGridNew(data);  
                            
                },function(error){    
                    MessagingService.addMessage(error.msg,'error');
                                    });
            }              
        }


        $scope.linkedWidgetId = 0;
            
        if ($scope.fd.Search!=undefined) $scope.linkedWidgetId = $scope.fd.Search.WidgetId;
            
        var refresh_list_from_callback=function(data)
        {
                $scope.fd.refreshDatasetDataList("",true,$scope.lData);    
        }
              
       
        $scope.fd.localVars.datasetItems= []
			
			
        $scope.fd.refreshDatasetDataList = function(search,apply,val)
            {
				//debugger
              var lang = $rootScope.globals.currentUser.lang;
              //ToDo ovo prebaciti sve u jedan API poziv
               if ($scope.fd.PresentationId!=null && $scope.fd.PresentationId!=undefined && $scope.fd.NameField?.id!=undefined && $scope.fd.NameField?.name!=undefined)
                {
                        var ctrl = this;
                        this.l_apply = apply;
                        this.l_val = val;
                        let fromCache=true;
                    
                   //ResourcesDataService.getResourceDataList($scope.fd.Related,$scope.fd.PresentationId,lang,search).then(function(data) {
                   ResourcesDataService.getResourceDataListAll($scope.fd.Related,$scope.fd.PresentationId,lang,fromCache,refresh_list_from_callback,$scope.fd.NameField).then(function(data) {
                           
                           if ($scope.itemValue.val==undefined || $scope.itemValue.val==null)
                           {
                                if (Array.isArray($scope.formData))
                                {
                                   if (Array.isArray($scope.formData[0][$scope.fd.FieldName]))
                                        for (let i=0;i<$scope.formData[0][$scope.fd.FieldName].length;i++)
                                        {
                                                if ($scope.fd.MaxLength==1) $scope.itemValue.val={'id':$scope.formData[0][$scope.fd.FieldName][i]};
                                                else
                                                
                                                {
                                                        $scope.itemValue.val = [];
                                                        $scope.itemValue.val.push ({'id':$scope.formData[0][$scope.fd.FieldName][i]});
                                                        
                                                }
                                        }
                                }
                                
                           }
                           
                           if ($scope.fd.ShowField)
                           {
                                $scope.fd.localVars.datasetItems = angular.copy(data.data)
                                if ($scope.fd.localVars.datasetItems.length>0)
                                {
                                    //if (!$scope.fd.Required && $scope.fd.localVars.datasetItems[0].id!=null) $scope.fd.localVars.datasetItems.unshift({id:null});

                                    //select value if exists
                                    if (typeof($scope.formData[0][$scope.fd.FieldName])=='number')
                                    {
                                       let pos = $scope.fd.localVars.datasetItems.map(function(e) { return e.id; }).indexOf($scope.formData[0][$scope.fd.FieldName]);
               
                                        if (pos>=0) $scope.formData[0][$scope.fd.FieldName] = $scope.fd.localVars.datasetItems[pos]

                                        if ($scope.fd.ReadOnly) $scope.fd.selectItem($scope.formData[0][$scope.fd.FieldName])

                                    }
                                }
                                
                           }
                           else
                           {
                                $scope.fd.localVars.datasetItemsHidden = angular.copy(data.data)
                                /*
                                if ($scope.fd.localVars.datasetItemsHidden.length>0)
                                {
                                    if (!$scope.fd.Required && $scope.fd.localVars.datasetItemsHidden[0].id!=null) $scope.fd.localVars.datasetItemsHidden.unshift({id:null});   
                                }
                                */
                           }
                           $timeout(function(){
                                //if (!$scope.fd.ReadOnly) $scope.loadDropdown($scope.fd.localVars.datasetItems);
                                $scope.fd.dataReady = true
                                //if (ctrl.l_apply) apply_value(ctrl.l_val); //TODO - migor uncomment later when bug is found
								
                           });
                    },function(error){    
                    MessagingService.addMessage(error.msg,'error');
									});
              
                }
            };
           
         
          
          /************ Call task when magnifier is clicked or autoSearch=true **************/
          
        $scope.fd.SelectDatasetRecords = function(taskId,autoSearch){
            
           // $scope.PreInitiateTask(taskId,0);
            $scope.fd.autoSearchLocal=autoSearch;
            $scope.localVars.showForm = true;
            if (!$scope.fd.searchFormDownloaded)
            {   
                if  (taskId==undefined || taskId==null || taskId==0) MessagingService.addMessage("Error in definition!! Search form is not assigned to dataset.","error");
                else 
                {
                    $scope.localVars.StartTask(taskId,0,0);
                    //$rootScope.$broadcast("ProcessTask"+$scope.fd.presentationId,{'taskId':taskId,'task_execute_id':$scope.taskExecuteId});
                    //if (autoSearch) $scope.fd.ConfirmSelection();
          
                    $scope.fd.searchFormDownloaded=true;
                
                }
            }
        };
     
        
        $scope.localVars[$scope.fd.id].downloadFile = function(fileId,fileName){
                ResourcesDataService.downloadFile($scope.fd.Related,fileId).then(function(data) {
                               
                                    MessagingService.addMessage('File '+fileName+' downloaded','info');
                                    var url = URL.createObjectURL(new Blob([data.data]));
                                    var a = document.createElement('a');
                                    a.href = url;
                                    a.download = fileName;
                                    a.target = '_blank';
                                    a.click();
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
      };// dowload file END
      
      
       $scope.localVars[$scope.fd.id].previewFile = function(fileId,fileName,fileType){
           
            ResourcesDataService.downloadFile($scope.fd.Related,fileId).then(function(data) {
                               
                                    var url = URL.createObjectURL(new Blob([data.data],{type:fileType}));
                                    let new_doc = window.open(url,"_blank");
                                  
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
      };// preview file END
          
          
          /*
           var localWidgetId="";  
            $scope.$on("Event"+localWidgetId+"resourceLinkDataset",function(event,data){
             
            for (var i=0;i<data[1].value.length;i++)
            {
             $scope.fd.gridOptions.data.push(data[1].value[i]);
            }
          });
          */
          
          
          /*
           Confirm selection - populate with selected items from search form
          */
          
          
          $scope.fd.autoSearchLocal = true;
          var counter=0;
          
          $scope.fd.ConfirmSelection = function(){
            
            var items=[];
            if ($scope.localVars[$scope.fd.id].gridOptions.data!=undefined)
            {
              for (var i=0;i<$scope.localVars[$scope.fd.id].gridOptions.data.length;i++)
              {
              
             
               items.push($scope.localVars[$scope.fd.id].gridOptions.data[i].id);
              
              }
            }
            //Get also selected from search form
            var linkedItem = 'resourceLinkDataset';
            if ($scope.linkedWidgetId!=undefined) //linkedWidgetId = 2325;
            {
             var data = WidgetDataExchangeService.getDataByWidgetIdOnly($scope.linkedWidgetId,linkedItem);
             //var data = WidgetDataExchangeService.getDataByLocalTaskWidgetId(localTaskId,WidgetId,linkedItem);
             var fromWidget=[];
             for (var k=0;k<data.length;k++) {
                if ($scope.fd.AutoSearch && $scope.fd.autoSearchLocal)
                {
                   if (data[k].name=='resourceRecordsAll') fromWidget = data[k].value; 
                }
                else{
                     if (data[k].name=='resourceRecordIds') fromWidget = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                  }
              }
              
            
             if (fromWidget!=null)                         
             {
               for (var j=0;j<fromWidget.length;j++)
               {
               
                   var pos = items.map(function(e) { return e; }).indexOf(fromWidget[j].id);
               
                   if (pos<0) items.push(fromWidget[j].id);
                }
              
              }
            }
            if ($scope.formData!=undefined)
            {
              if ($scope.formData.length>0) $scope.formData[0][$scope.fd.FieldName]=items;
            }
            
            if ($scope.fd.PresentationType==0)
            {
              if ($scope.localVars[$scope.fd.id].gridOptions.data!=undefined)
              {
                 if (items.length>0 && $scope.localVars[$scope.fd.id].gridOptions.data.length<items.length)
                 {
                   if ($scope.fd.Related>0 && items!=[{}]) $scope.fd.getDatasetDirect($scope.fd.Related,{'id__in':items});
                 
                 }
              }
            }
            
            if ($scope.fd.PresentationType==1 && items.length>0) $scope.fd.getDatasetList();
            
            //$scope.fd.searchFormDownloaded=false;
            
            
            $scope.localVars.showForm = false;
          };
              /*
               Cancel selection - cancel selection from search form 
               */
          
          $scope.fd.CancelSelection = function(){
             $scope.localVars.showForm = false;
            
          }
       
      
         //**********************************************************
         //           GET FORM FIELDS
         //**********************************************************      
            
          $scope.fd.getFormFields = function(refresh){
              
              
            let lang=$rootScope.globals.currentUser.lang;
            
            if (refresh==undefined) refresh=false
            ResourcesDataService.getFormFields($scope.fd.Related,lang,$scope.fd.Parameters.PublishedResourceVersion,refresh).then(function(data) {
                               
                                  //$scope.fd.presentationElements= data.data;
								  $scope.gsrvc.presentationElements[$scope.fd.UuidRef] = data.data;
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
                              
          };
      
      
       //**********************************************************
         //          Clear saerch task dropdown
         //**********************************************************      
            
           $scope.localVars[$scope.fd.id].clearSearchTask = function(event,select){
            $scope.fd.Search.taskId = null;
           };
         //**********************************************************
         //          Remove selected records from grid
         //**********************************************************      
          
            
            
              $scope.localVars[$scope.fd.id].setupGridNew= function(data)
              {
                $scope.localVars[$scope.fd.id].gridData = data.data;
                if (!$scope.localVars[$scope.fd.id].columnDefs) $scope.localVars[$scope.fd.id].columnDefs = $scope.fd['GridState']['columnsDef'] //data.columnsDef;
                $scope.localVars[$scope.fd.id].gridDataRetrieved = true
                $scope.ksm.executeAction(valueStateName,"dataLoaded", {data:$scope.localVars[$scope.fd.id].gridData});
                $scope.ksm.executeAction(wrStateName,"widgetReady", {widget:$scope.fd.UuidRef,processed:true});
              
              }
              
  
           $scope.localVars[$scope.fd.id].saveGridState= function(show_message) {
               //debugger //ktTaskDatasetList smarttable
               let columnsDef = $scope.localVars[$scope.fd.id].columnDefs

               let columnsQuery = $scope.localVars[$scope.fd.id].columnsForQuery
               $scope.fd['GridState']={'columnsDef':columnsDef,'columnsQuery': columnsQuery}
                                
              if (show_message)
               MessagingService.addMessage("To make changes stick please save form",'info');            
    };

    $scope.localVars[$scope.fd.id].restoreGridState= function() {
        //debugger
        if ($scope.fd['GridState']!==undefined && $scope.fd['GridState']!==null)
        {
          
            if ($scope.fd['GridState']['columnsDef']!==undefined) $scope.localVars[$scope.fd.id].columnDefs =  $scope.fd['GridState']['columnsDef']
            if ($scope.fd['GridState']['columnsQuery']!==undefined) $scope.localVars[$scope.fd.id].columnsForQuery =  $scope.fd['GridState']['columnsQuery']

        }
    };   
            
    if ($scope.fd['GridState']!==undefined && $scope.fd['GridState']!==null) $scope.localVars[$scope.fd.id].restoreGridState();

    $scope.localVars[$scope.fd.id].getResourceDataRelated= function () {

            $scope.filter = {};
            var lang = $rootScope.globals.currentUser.lang;

           //scope.activity.activityMessage = ProcessingService.setActivityMsg('Retriving data '+scope.selectedResource);
          //$scope.filter = ResourcesDataService.prepareResourceWidgetData($scope.dashboard.widgets,-1);
         
          if ($scope.fd.selectedResource==null) {
            $scope.fd.selectedResourceId = $scope.fd.Related;
          }else
          {
             $scope.fd.selectedResourceId = $scope.fd.selectedResource.id;
            
          }
    //      ResourcesDataService.getResourceDataFiltered($scope.fd.Related,lang,$scope.filter).then(function(data) {//MIGOR
         ResourcesDataService.getResourceDataFiltered($scope.fd.Related,$scope.fd.ResourceId).then(function(data) {//MIGOR
                            
                            $scope.fd.setupGrid(data);
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                             });
        }

            
		 $scope.fd.getResourceDataFiltered = function () {

            $scope.filter = {};
            var lang = $rootScope.globals.currentUser.lang;

           //scope.activity.activityMessage = ProcessingService.setActivityMsg('Retriving data '+scope.selectedResource);
          //$scope.filter = ResourcesDataService.prepareResourceWidgetData($scope.dashboard.widgets,-1);
         
          if ($scope.fd.selectedResource==null) {
            $scope.fd.selectedResourceId = $scope.fd.Related;
          }else
          {
             $scope.fd.selectedResourceId = $scope.fd.selectedResource.id;
            
          }
	//		ResourcesDataService.getResourceDataFiltered($scope.fd.Related,lang,$scope.filter).then(function(data) {//MIGOR
         ResourcesDataService.getResourceDataFiltered($scope.fd.selectedResourceId,$scope.taskId,lang,$scope.fd.resourceDashboard.widgets).then(function(data) {//MIGOR
                            
                            $scope.fd.setupGrid(data);
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                             });
        }
		
						
             
        $scope.fd.getResourceData = function () 
	{
                // $scope.activity.activityMessage = ProcessingService.setActivityMsg('Downloading resource data for '+$scope.resourceId);
                 var lang = $rootScope.globals.currentUser.lang;
                 ResourcesDataService.getResourceData($scope.resourceId,$scope.taskId,lang).then(function(data) {
                                                 
                                                                $scope.localVars[$scope.fd.id].setupGridNew(data);
        
                },function(error){    
                        MessagingService.addMessage(error.msg,'error');
                });
	};
       
        if ($scope.localVars[$scope.fd.id].publishedResourceList==undefined) $scope.localVars[$scope.fd.id].publishedResourceList=[];
    var lang=$rootScope.globals.currentUser.lang;

     
    $scope.localVars[$scope.fd.id].GetRecordForView = function(datasetDefId,datasetRecordId){
         
         if (datasetRecordId===undefined) datasetRecordId=0
         if (datasetDefId===undefined) datasetDefId=0
         $scope.localVars[$scope.fd.id].resourceRecordId = datasetRecordId
         $scope.fd.ParentDatasetDefId = datasetDefId
         if ($scope.resourceDefinition.pageId==undefined) $scope.resourceDefinition.pageId=0

            let pageid = $scope.resourceDefinition.pageId
            let rinstance = $scope.resourceDefinition.page_instance_id
            let prev_resource_id = $scope.taskExecuteId
         if ($scope.fd.PopulateType.toString().substr(0,1)=='3')
         {
            //pageid = $scope.resourceDefinition.prev_page_id
            prev_resource_id = $scope.resourceDefinition.prev_page_instance_id
         
         }
         if (prev_resource_id==undefined) prev_resource_id=0

          TaskDataService.GetTaskViewResource($scope.fd.UuidRef,pageid,$scope.taskId,prev_resource_id,rinstance,'i',datasetDefId,datasetRecordId,$scope.fd.Parameters.PublishedResourceVersion).then(function(data) {

                                  let dataset_record
                                  if (Array.isArray(data.data.data))
                                    {
                                      if  (data.data.length>0) dataset_record  = data.data.data[0]
                                      else dataset_record={}
                                    }
                                  else dataset_record  = data.data.data
                                  
                                  $scope.formData[0][$scope.fd.FieldName] =  [dataset_record]

                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
      }     

     //**********************************************************
     //           GET DATASET DIRECT FILTER
     //**********************************************************      
      $scope.fd.getDatasetDirect = function (relatedDatasetId,filter_data) {

        ResourcesDataService.getResourceDataDirectFilter(relatedDatasetId,filter_data,$scope.fd.GridState['columnsQuery']).then(function(data) {
                                
                                    if ($scope.fd.PresentationType==0) $scope.localVars[$scope.fd.id].setupGridNew(data);
                                    else if ($scope.fd.PresentationType==2)
                                    {
                                        $scope.formData=[{}]
                                        $scope.formData[0][$scope.fd.FieldName]=data
                                    }
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
                
    $scope.localVars[$scope.fd.id].getColumnsDef = function () {

        
            ResourcesDataService. getResourceColumns($scope.fd.Parameters.PublishedResourceId,'dataset',lang,$scope.fd.Parameters.PublishedResourceVersion).then(function(data) {//MIGOR
                            
                                  $scope.localVars[$scope.fd.id].columnDefs = data.data.columnsDef
                                  $scope.localVars[$scope.fd.id].results.columns =  $scope.localVars[$scope.fd.id].columnDefs
                                  $scope.localVars[$scope.fd.id].resourceDataDownloaded = true;
                                
                                  $scope.localVars[$scope.fd.id].saveGridState(false)
                                 
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                             });

    }

         $scope.fd.selectItem = function(item)
         {
            $scope.ksm.executeAction(valueStateName,"valueChanged", {itemValue:{val:item}})
         }

        //element is selected
        $scope.localVars[$scope.fd.id].itemSelected = function(item,model)

        {
            $scope.fd.selectItem(item)
        }

        // Resource is selected
        $scope.fd.onSelectCallback = function (item, model)
		{
                var eventResultId=item.id;
                $scope.fd.eventResultName=item.name;
                
                $scope.fd.resourceId=eventResultId;
                $scope.fd.isResourceSelected=true;
				
                //if ($scope.fd.Parameters.ResourceRelationshipType==='existing')
                //{
                    if (item.max_length!=undefined) $scope.fd.MaxLength=item.max_length
                    if (item.db_type!=undefined) $scope.fd.Dbtype=item.db_type
                    $scope.fd.Parameters.FieldNameRelatedParent=item.field_name

                    if ($scope.fd.Parameters.FieldNameRelatedParent==undefined) $scope.fd.Parameters.FieldNameRelatedParent = 'Field'+item.rmdUid
                    
                //}
               	$scope.fd.Related=$scope.fd.resourceId;
                $scope.localVars[$scope.fd.id].getPublishedResources()
                //if ($scope.fd.Related!=undefined && $scope.fd.Related!=null) $scope.fd.getFormFields();
                   
         }
              
         // Resource is selected
         $scope.fd.onSelectPublished = function (item, model)
		{
                let pos = $scope.localVars[$scope.fd.id].publishedResourceList.map(function(e) { return e.id; }).indexOf(item?.id);
                let old_publish_id = $scope.fd.Parameters.PublishedResourceId
                if (pos>=0){
                    $scope.fd.Parameters.PublishedResourceId = $scope.localVars[$scope.fd.id].publishedResourceList[pos].id
                    $scope.fd.Parameters.ChildResourceName = $scope.fd.name+ ' ('+$scope.fd.id+')'
                    $scope.fd.Parameters.PublishedResourceVersion = $scope.localVars[$scope.fd.id].publishedResourceList[pos].Version;
                    if ($scope.fd.GridState?.columnsDef===undefined || $scope.fd.Parameters.PublishedResourceId !=old_publish_id) $scope.localVars[$scope.fd.id].getColumnsDef()
                    else $scope.localVars[$scope.fd.id].resourceDataDownloaded =true
                    $scope.fd.getFormFields(true)
                }

                $scope.fd.Parameters.DefState = 'advanced'


                  
        }

        $scope.fd.onSelectSearchForm= function (item, model)
		{
               
               if ($scope.fd.Search==undefined) $scope.fd['search']={taskId:item};
               else $scope.fd.Search.taskId = item;
                //$scope.fd.Search.widgetId=0; //ovo treba na serveru dohvatiti widgetId
                
                
        } 
			  
        if ($scope.fd.Parameters.UseUserProperty && $rootScope.globals.currentUser.uep?.AdvancedProperties!=undefined) $scope.formData[0][$scope.fd.FieldName] = $rootScope.globals.currentUser.uep?.AdvancedProperties[$scope.fd.Parameters.UserPropertyId]

        //ako ima odabranih dohvati ih i setupiraj
        if ($scope.formData!=undefined && $scope.fd.Parameters.GetData && !$scope.formDefinition)
        {
            if (Array.isArray($scope.formData) && $scope.formData.length>0)
            {
                if ($scope.formData[0][$scope.fd.FieldName]!=undefined && Array.isArray($scope.formData[0][$scope.fd.FieldName]))
                {

                    if ($scope.fd.PresentationType==0)
                    {
                        //$scope.localVars[$scope.fd.id].resourceDataDownloaded =true
                        if ($scope.formData[0][$scope.fd.FieldName]!=[{}] && $scope.fd.ElementType!='eresource') $scope.fd.getDatasetDirect($scope.fd.Related,{'id__in':[$scope.formData[0][$scope.fd.FieldName]]});
                        else if ($scope.fd.ElementType=='eresource') 
                        {
                                let f_data = {}
                                f_data[$scope.fd.FieldName] = $scope.localVars[$scope.fd.id].parentResourceRecordId
                                $scope.fd.getDatasetDirect($scope.fd.Related,f_data);
                        }
                    }
                    else if ($scope.fd.PresentationType==1 && $scope.fd.ShowField)
                    {
                        $scope.fd.refreshDatasetDataList() // TODO - check why no parameters is sent to function
                    }
                    
                    else if ($scope.fd.Related===null)
                    {
                        MessagingService.addMessage('Resource is not selected. Please select resource','info');
                    }
                    else if ($scope.fd.PresentationType==1 && $scope.fd.ShowField)
                    {
                        $scope.fd.refreshDatasetDataList()// TODO - check why no parameters is sent to function
                
                    }else $scope.localVars[$scope.fd.id].GetResourceDataForParent()

                    
                }
                else if ($scope.fd.PresentationType==1 && $scope.fd.ShowField)
                {
                        $scope.fd.refreshDatasetDataList()// TODO - check why no parameters is sent to function

                }
                else if ($scope.fd.PresentationType==2 && typeof($scope.formData[0][$scope.fd.FieldName])=='number')
                {       
                        $scope.fd.itemValue = angular.copy($scope.formData[0][$scope.fd.FieldName])
                        $scope.formData[0][$scope.fd.FieldName] = [{}]
                        $scope.localVars[$scope.fd.id].GetRecordForView($scope.fd.Related,$scope.fd.itemValue);
                }
                else $scope.localVars[$scope.fd.id].GetResourceDataForParent() 
                    
            
                
            }
        }
        
        if ($scope.resourceDefinition.form_definition)
        {
            if ($scope.fd.Parameters.ResourceRelationshipType==='new' || $scope.fd.Parameters.ResourceRelationshipType==='view') $scope.localVars[$scope.fd.id].getResources($scope.fd.Parameters.ResourceType)
            else $scope.localVars[$scope.fd.id].getPublishedResources()
        }

        if ($scope.fd.Parameters.PublishedResourceId!=undefined) {

            if ($scope.formDefinition) {
                $scope.localVars[$scope.fd.id].getPublishedResources() 
                $scope.fd.getFormFields()
            }
            else if($scope.fd.Parameters.GetData || $scope.fd.ShowSearchForm) $scope.localVars[$scope.fd.id].getPublishedResourceById($scope.fd.Parameters.PublishedResourceId,$scope.fd.ShowSearchForm)
            
        }

        $scope.processEvents = function(data,newRound)
        {

            UtilityService.process_events($scope.resourceDefinition.page_state_id,valueState,data,$scope.fd.Parameters.events,$scope.ksm,newRound)
        }

        //process events and execute actions
        if (!$scope.formDefinition && $scope.fd.Parameters?.events?.length>0) UtilityService.subscribe_2_events($scope.resourceDefinition.page_state_id,$scope.parentWidget,$scope.fd.Parameters.events,$scope,$scope.ksm)

        let template;
        if ($scope.formDefinition) template = $templateCache.get('ktdirectivetemplates/ktResource.html');
        else 
            { 
                if ($scope.fd.Parameters.ResourceType=='file')  template = $templateCache.get('ktdirectivetemplates/ktFileExe.html')
                else template = $templateCache.get('ktdirectivetemplates/ktResourceExe.html')
            }


          
        $element.append($compile(template)($scope));  
          
	},//...controller
				
           
            link: function (scope, elem, attrs) {
             		scope.localVars[scope.fd.id].datasetlistlinked  = true
            }
    
    }
};
'use strict';

export function ktResourceDefinition () {
      
        return {
        restrict: 'A',
        scope:{
                    resource:'=',
                  
            },
	templateUrl: 'ktdirectivetemplates/ktResourceDefinition.html',
        controller: function ($scope,$rootScope,GridsterService,KatalyoStateManager,ResourcesDataService,MessagingService,CodesService)
        {
                $scope.gsrvc = GridsterService;
                
                $scope.ksm = KatalyoStateManager;
               
               
                $scope.EditResourceFn=function(val)
                {
                        
                     $scope.editResource=val;
                }
                let lang = $rootScope.globals.currentUser.lang;
                CodesService.getCodesByName('codestatus',lang).then(function (data) {
                                $scope.resourceStatusList = data.data
                                $scope.statusesDownloaded=true
                             });

                $scope.saveResourceDef = function (forma) {
          
                  if (forma.$valid)
                  {
                    ResourcesDataService.SaveResourceDef2($scope.resource).then(function(data) {
                                       
                                       if (data.status===200 || data.status==201)
                                        {
                                        MessagingService.addMessage(data.msg,'success');  
                                        }
                                        },function(error){
                                      
                                      MessagingService.addMessage(error.msg,'error');  
                 
                                    });
                    
                  }else
                  {
                    
                    MessagingService.addMessage("Please enter required data",'warning'); 
                  }
                }; 
                
                },
        link: function (scope, elem, attrs) {
				
             
        
        }      
            
        }
};
'use strict';

export function ktResourceFlowDef (WidgetDataExchangeService,ResourcesDataService,dragulaService,$rootScope,$timeout) {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktResourceFlowDef.html',
             controller: function($scope){  
                    
                    $scope.CTRL="ktResourceFlowDef"
                    
                    
                     $scope.actionTypes = [
                  {id:1,name: "Process widgets", value: "procwidgets"},
                  {id:2,name: "Widget action",  value: "widgetaction"},
                  {id:3, name: "Open Page", value: "openpage"},
                   {id:4, name: "Go to previous page", value: "backbutton"},
                // {id:0,name: "Execute task", value: "executetask"},
                //  {id:1,name: "Start task", value: "runtask"},
                //  {id:3,name: "Refresh task",  value: "refreshtask"},
                //  {id:4, name: "Complete task", value: "completetask"},
                //  {id:6, name: "Close form", value: "closeform"},
                //  {id:7, name: "Clear form", value: "clearform"},
                //  {id:10, name: "Initiate task", value: "initiatetask"}
                ]

                },
             link: function (scope, elem, attrs) {
                
                scope.wdes = WidgetDataExchangeService

                 let lang=$rootScope.globals.currentUser.lang

                  scope.addEvent=function()
                    {
                        if (scope.resource.Parameters.events==undefined) scope.resource.Parameters.events=[]
                        scope.resource.Parameters.events.push({actions:[]})   
                        scope.setupDragula(scope.resource.Parameters.events.length-1)
                    }

                    scope.delEvent = function(idx){
                        scope.resource.Parameters.events.splice(idx,1)   
                    }

                    scope.addAction=function(event)
                    {
                        if (event.actions==undefined) event.actions=[]
                        event.actions.push({})   
                    }

                    scope.insertAction=function(event,index)
                    {
                        if (event.actions==undefined) event.actions=[]

                        event.actions.splice(index,0,{id:event.actions.length+1})   
                    }
                     scope.delAction=function(event,index)
                    {
                        if (event.actions==undefined) event.actions=[]
                        if (event.actions.length>index)  event.actions.splice(index,1)   
                    }

                scope.onSelectFn = function(item,model,action) {
                    //debugger  
                    action.action = item
                    if (item.value=='openpage') scope.getPages()
                 }

                scope.onSelectWidgetCallback = function(item,model,action)
                {
                   action.widgetRefObj.loaded = false
                    
                    $timeout(function(){ 
                        
                            action.widgetRef = item?.id
                            action.widgetRefObj.loaded = true
                    })
                    

                }

                scope.onSelectActionCallback = function(item,model,action)
                {
                    action.widgetActionName = item?.name
                }

                scope.onSelectPageCallback=function(item,model,idx,action)
                {
                    
                    if (item?.id!=undefined)
                    {
                        ResourcesDataService.getResourceDefAll(item.id).then(function(data) { 
                                    action.page_def = data.data;
                                  
                        })
                    }
                }

            scope.getPublishedResources=function(pageId,isChecked)
            {
                
                if (isChecked){
                    if (scope.publishedResourceList==undefined)  scope.publishedResourceList={}
                      
                    ResourcesDataService.GetPublishedResourcesByTypeId(pageId,'form').then(
                    function (data) {       
                  
                    scope.publishedResourceList[pageId] = data.data;
                    
                   
                   },function(error){    
                        MessagingService.addMessage(error.msg,'error');
                    });
                }
            
            }

            scope.actionsFinished= function(actions){
                for (let i=0;i<actions.length;i++)
                {
                    if (actions[i].id==undefined) actions[i].id = i+1
                }
            }


                scope.setupDragula=function (index) {
                    
                    if (!index) index = 0
                   
                    let actionHandle = 'action-drag-handle'
                    let bag = dragulaService.find($rootScope, 'bag-action-'+scope.resource.uid+'-'+index);
                     
                    if (!bag)
                    {
                    dragulaService.options($rootScope, 'bag-action-'+scope.resource.uid+'-'+index, {
                            revertOnSpill: true,
                            removeOnSpill: false,
                            direction:'vertical',
                          //  copy:function(el,target, source){
                          //      return false
                          //  },
                            accept:function (el,target, source) {
                                return false;
                            },
                            moves: function (el, container, handle) {
                                
                                return handle.classList.contains(actionHandle);
                            }
                     });
                    }
                }
             scope.getPages=function () {
                ResourcesDataService.getResourceDefListByType(lang,'page').then(function(data) {
                                                    
                                  scope.pageList = data.data;
                                                               
                                scope.pagesLoaded=true;
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
            }
                    
        }
    }
  
};
'use strict';

export function ktResourceid () {
      
        return {
        restrict: 'A',
	//templateUrl: 'ktdirectivetemplates/ktResourceid.html',
        controller: function ($scope,$rootScope, CodesService, GridsterService,KatalyoStateManager,$templateCache,$compile,$element)
        {
                $scope.gsrvc = GridsterService;
                $scope.myscope=$scope
				 $scope.fd.localVars =  {};
				 
				  $scope[$scope.fd.id]  = {'fd': $scope.fd}
				   
				 
				 if ($scope.fd.localVars==undefined)  $scope.fd.localVars={}
                
                 if ($scope.fd.Parameters==undefined) $scope.fd.Parameters = {};
                 
                $scope.ksm = KatalyoStateManager;
              
                let resourceIdValue = null;
				
				 $scope.fd.setStep = function() {
                  $scope.fd.stepValue =parseFloat(Math.pow(0.1,$scope.fd.Parameters.NoOfDecimals)).toFixed($scope.fd.Parameters.NoOfDecimals);
                 }; 
                
                if ($scope.fd.stepValue==null || $scope.fd.stepValue==undefined) $scope.fd.setStep();
				
				
                if ($scope.formData!=undefined)
                {
                        if ($scope.formData.length==0) $scope.formData=[{}]
                        if (!Array.isArray($scope.formData)) $scope.formData=[{}]
                        
                        resourceIdValue=$scope.formData[0][$scope.fd.FieldName]
                        
                }else $scope.formData=[{}];
                
                  let parentWidgetUid = ''
				  
			 $scope.fd.localVars.search=[
                {id:1,filter:'gt',name:"Greater than",icon:"fa fa-chevron-right"},
                {id:2,filter:'between',name:"Between",icon:"fa fa-expand"},
                {id:3,filter:'lt',name:"Lower than",icon:"fa fa-chevron-left"},
                {id:4,filter:'eq',name:"Equals",icon:"fa fa-bars"} ];
				
				  $scope.fd.SetDefault = function()
                {
                    $scope.fd.DefaultValue = {value:$scope.formData[0][$scope.fd.FieldName]};
                }
                
				$scope.fd.localVars.processFilters = function(filterList)
                {
                    for (let i=0;i< $scope[$scope.fd.id]['fd'].localVars.search.length;i++)
                    {
                        let pos = filterList.map(function(e) { return e.id; }).indexOf( $scope[$scope.fd.id]['fd'].localVars.search[i].code_name);
                        if (pos>=0)  $scope[$scope.fd.id]['fd'].localVars.search[i].name = filterList[pos].name
                    }
                   
                    
                    if ($scope.fd.Search===undefined || $scope.fd.Search===null)   $scope.fd.Search=$scope.fd.localVars.search[3];//initialize to equals
                    if ($scope.fd.Search)  $scope.fd.Search.Value=$scope.formData[0][$scope.fd.FieldName]; 

                    $scope[$scope.fd.id]['fd'].localVars.filterReady=true
                }

                if ($scope.showSearchFilters || $scope.resourceDefinition.form_definition)
                {
                    let lang=$rootScope.globals.currentUser.lang;
                    CodesService.getCodesByName('search_filters',lang).then(function (data) {

                                $scope[$scope.fd.id]['fd'].localVars.processFilters(data.data); 
                    });
                }
				

                if ($scope.parentWidget!=undefined) parentWidgetUid = $scope.parentWidget+'-'

                let valueState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+'-'+parentWidgetUid+$scope.fd.UuidRef,resourceIdValue);

            
                let valueStateName = valueState.subject.name;

                 
                let value_changed = function(data)
                {
                    valueState.subject.setStateChanges = data;
                    valueState.subject.notifyObservers("valueChanged");
                };
                
                let action_value_changed = $scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
                                                  
                               
                $scope.on_blur_action=function()
                {
                        
                        $scope.ksm.executeAction(valueStateName,"valueChanged", $scope.formData[0][$scope.fd.FieldName]);
                        
                };
               
                
                
                let apply_value = function(data)
                {
                        if (Array.isArray(data)) 
                        {
                                if (data[0][$scope.fd.FieldName]==undefined) $scope.formData[0][$scope.fd.FieldName] = data[0][$scope.fd.FieldName]
                                else if (data[0]['id']==undefined) $scope.formData[0][$scope.fd.FieldName] = data[0]['id']
                        }         
                        else if (Object.prototype.toString.call(data) === '[object Object]') 
                        {
                                if (data[$scope.fd.FieldName]==undefined) $scope.formData[0][$scope.fd.FieldName] = data[$scope.fd.FieldName]
                                else if (data['id']==undefined) $scope.formData[0][$scope.fd.FieldName] = data['id']
                        }

                    $scope.ksm.executeAction(valueStateName,"valueChanged", $scope.formData[0][$scope.fd.FieldName]);
                }; 
               // let observer_undo = $scope.ksm.subscribe(formChangesSubject,"Field"+$scope.fd.ItemId,"valueChanged",apply_value);
                if ($scope.fd.Parameters.DependentFieldId!=undefined && $scope.fd.Parameters.DependentFieldId!=null)
                
                {
                    if ($scope.fd.Parameters.DependentFieldId!="")
                    {
                        let dependent_field = "Field"+$scope.fd.PresentationId;
                        let subscribedSubject = $scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId+$scope.resourceDefinition.transaction_id;
                        let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
                        let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
                        let val = $scope.ksm.getState(subscribedSubject);
                        if (val.state!=null) apply_value(val.state);
                    }
                }

				if ( $scope.fd.localVars==undefined) $scope.fd.localVars={}

                 if (resourceIdValue!=undefined) $scope.ksm.executeAction(valueStateName,"valueChanged", resourceIdValue);

                let template
                if ($scope.resourceDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktResourceid.html');
                else template = $templateCache.get('ktdirectivetemplates/ktResourceidExe.html');
                
                 $element.append($compile(template)($scope));  

                },
        link: function (scope, elem, attrs) {
				
        
        

				
                scope.refreshSearchValue = function() {
                        if (scope.fd.Search) scope.fd.Search.Value=scope.formData[0][scope.fd.FieldName];      
                } 
                
                /*if (scope.showSearchFilters)  {
                    scope.fd.Search=scope.search[3];//initialize to equals
                    if (scope.fd.Search && scope.formData!=undefined && scope.formData.length>0) scope.fd.Search.Value=scope.formData[0][scope.fd.FieldName]; 
                }*/
              
                scope.showProperties = function(event)
                {
                        scope.gsrvc.setFieldProperties(scope.fd, scope.inputArray);// inputArray is parent
       
                };
                
				scope.applyNumFilters = function(index) {
				    scope.fd.Search=scope.fd.localVars.search[index];
                    if (scope.fd.Search && scope.formData!=undefined && scope.formData.length) {
                            scope.fd.Search.Value=scope.formData[0][scope.fd.FieldName]; 
                    }
                    if (scope.fd.Search.Value==undefined) scope.fd.Search.Value = "";		
                };
				
                scope.applyFilters = function(index) {
                        scope.fd.Search=scope.search[index];
                              
                        if (scope.formData[0][scope.fd.FieldName]) scope.fd.Search.Value=scope.formData[0][scope.fd.FieldName];      
                         
                }
				
				          if (scope.fd.UpdateWithDefault && !scope.fd.NoUpdate) scope.formData[0][scope.fd.FieldName] = scope.fd.DefaultValue?.value
        
            }
        };
};
'use strict';

export function ktResourceRef () {
        return {
        restrict: 'A', 
        controller: function ($scope, $rootScope,ResourcesDataService,ProcessingService,$timeout,MessagingService,GridsterService,UtilityService,WidgetDataExchangeService) {
	
        $scope.gsrvc = GridsterService;
       	
       	 if ($scope.fd.localVars==undefined) $scope.fd.localVars={};        
 				 if (!$scope.fd.Parameters)  $scope.fd.Parameters={}
        if ($scope.localVars==undefined) $scope.localVars={};        

						
          $scope.colLength = ['col-lg-2','col-lg-4','col-lg-6','col-lg-8','col-lg-10','col-lg-12','col-lg-14','col-lg-16','col-lg-18','col-lg-20','col-lg-22','col-lg-24'];
       
	  			$scope.fd.localVars.resourceTypesList=[{id:1,type:'page',name:'Page'},{id:2,name:'Dataset',type:'resource'},{id:3,name:'File',type:'file'},{id:4,name:'Application',type:'application'}]
 					
 					         let w_actions=[
                    {id:1,name:'valueChanged'},  
                ]

        let parentWidgetUid = ''

        if ($scope.parentWidget!=undefined) parentWidgetUid = $scope.parentWidget+'-'

        if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
        $scope.fd.Parameters.UuidRef = $scope.fd.UuidRef

        if (!$scope.fd.Saved) $scope.fd.ItemId = $scope.localVars.localWidgetId
				
				let widgetDefinition = {actions: w_actions,name: 'resourceRefWidget',widgetLabel: 'Resource reference',widgetName: 'resourceRefWidget',widgetId: parentWidgetUid+$scope.fd.UuidRef,output:null,parentResourceId:$scope.resourceDefinition.uid };
       
				$scope.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
                                		
					// Resource type is selected
              $scope.fd.localVars.onSelectCallback = function (item, model){
                var eventResultId=item.id;				
              } 
          
            
				},//...controller
				
            templateUrl: 'ktdirectivetemplates/ktResourceRef.html',
            link: function (scope, elem, attrs) {
				    
            if (!scope.fd.PopulateType) scope.fd.PopulateType=0
            }
    
    }
};
'use strict';



export function ktResourceSelector  (ResourcesDataService,$rootScope,dragularService,$timeout,MessagingService) {

        return {
             restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktResourceSelector.html',
             scope:{
                       selectedResource:'=',
                       resourceTypesList:'=',
                       parameters:'=',


             },
        link: function (scope, elem, attrs) {
              

            if (!scope.parameters) scope.parameters={}
 
            scope.getResources = function(resource_type)  {   
                
        
                if (scope.resourceList==undefined) {
                 scope.resourceList={};
                 scope.resourceList[resource_type]=[]
                }
   
                var lang=$rootScope.globals.currentUser.lang;
                if (!scope.resourceList[scope.parameters.SelectedResourceType]?.length && scope.parameters.SelectedResourceType){

                    ResourcesDataService.getResourceDefListByType(lang,resource_type).then(
                        function(data) {
                            scope.resourceList[resource_type] = data.data;
                            scope.setResourceDd() 
                            if (scope.selectedResource?.id) scope.getPublishedResources() 
                            
                    },function(error){    
                            MessagingService.addMessage(error.msg,'error');
                           });
                }
            
        }
                              
        scope.setResourceDd = function(){        
            let tmpResourceItem = scope.selectedResource
                if (!scope.selectedResource){
                        let pos = scope.resourceList[scope.parameters.SelectedResourceType].map(function(e) { return e.id; }).indexOf(scope.selectedResource?.id);
                        if (pos>=0) {
                        scope.selectedResource= scope.resourceList[scope.parameters.SelectedResourceType][pos]
                }
            }              
        }

        scope.getPublishedResources=function()
        {
            scope.publishedLoaded=false
                
             if (scope.publishedResourceList==undefined) 
            {
                scope.publishedResourceList={};
                if (scope.parameters.SelectedResourceType) scope.publishedResourceList[scope.parameters.SelectedResourceType]=[]
            }

            ResourcesDataService.GetPublishedResourcesByTypeId(scope.selectedResource.id,'form').then(
                function (data) {       
              
                scope.publishedResourceList[scope.parameters.SelectedResourceType] = data.data;
                scope.publishedLoaded=true

                if (!scope.parameters.SelectVersionDirect) {

                    scope.parameters.PublishedResourceId = scope.publishedResourceList[scope.parameters.SelectedResourceType][0].id
                    scope.parameters.PublishedResourceVersion = scope.publishedResourceList[scope.parameters.SelectedResourceType][0].Version
                }

               
               },function(error){    
                    MessagingService.addMessage(error.msg,'error');
            });
            
        }         
        
        scope.GetPublishedResourcesByType = function(resource_type)  { 
                
                if (resource_type==undefined) resource_type = scope.resourceType
                if (scope.publishedResourceList==undefined) 
                    {
                        scope.publishedResourceList={};
                        if (scope.parameters.SelectedResourceType) scope.publishedResourceList[scope.parameters.SelectedResourceType]=[]
                    }
                var lang=$rootScope.globals.currentUser.lang;
                
                // we are in build mode, so we should invalidate cahce (useCache is false)  TODO - provjeriti da li treba korisiti cache
                ResourcesDataService.GetPublishedResourcesByType(resource_type,'form', false).then(function (data) { 
                        //debugger   //GetPublishedResourcesByType  
              
                        $timeout(function(){
                            scope.publishedResourceList[scope.parameters.SelectedResourceType].length = 0;  
                            angular.extend(scope.publishedResourceList[scope.parameters.SelectedResourceType], data.data);

                         })
                 },function(error){    
                            MessagingService.addMessage(error.msg,'error');
                  });
               } 
    
         /* 
         scope.confirm= function(){
               
               $timeout(function(){
                  
                   
     
              


                   scope.selectedResourceItem.name_confirmed = scope.selectedResourceItem.name +' ('+scope.selectedResourceItem.id +')'
                    scope.parameters.selectedResourceItem = {
                        'name_confirmed': scope.selectedResourceItem?.name_confirmed
                    }


                 
                   scope.selectedResourceItem_c=scope.selectedResourceItemPublished; 
                   
                 
                        let published = scope.publishedResourceList[scope.publishedResourceList.length-1]
                        
                        if (published!=undefined)
                        {
                            scope.selectedResourceItem_c = published
                            scope.parameters.PublishedResourceId = published.id
                            scope.parameters.PublishedResourceVersion = published.Version
                        }

   
                  

     
               });
           
            };
                  
           */   
              
              scope.onResourceSelectorCallback = function (item, model){

                    let eventResultId=item.id;
                    let eventResultName=item.name;
                    let eventResultParentElementId =item.parentElementId;
              
                    scope.selectedResource = item
                    scope.parameters.PublishedResourceId=0
                    scope.getPublishedResources()
                   
                    
              }

              scope.onResourceSelectorVersionCallback = function (item, model){

                    scope.selectedResourceItemPublished = item
                    scope.parameters.PublishedResourceId = item.id
                    scope.parameters.PublishedResourceVersion = item.Version
                 
                    
              }

              if (scope.parameters.SelectedResourceType) scope.getResources(scope.parameters.SelectedResourceType)
          
              
             }
        }
};
'use strict';

export function ktRichtextbox () {
       
        return {
            restrict: 'A',
                controller: function ($scope,$rootScope,$templateCache,$element,$compile,GridsterService,WidgetDataExchangeService,CodesService,$sce) {
                        $scope.gsrvc = GridsterService;
                        if ($scope.localVars==undefined) $scope.localVars={};
						if ($scope.fd.localVars==undefined) $scope.fd.localVars={};
                        
						$scope.fd.localVars.wdes = WidgetDataExchangeService
                        $scope.fd.localVars.resourceDefinition=$scope.resourceDefinition
						
						
                        if ($scope.formData==undefined) {
                            $scope.formData = [{}];     
                        } else if ($scope.formData.length==0) 	$scope.formData = [{}];
                        
                        $scope.fd.localVars.enableEditDefault=true
                        var lang=$rootScope.globals.currentUser.lang;
						
						if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
						var out_fields = []
						
						let w_actions=[
								{id:1,name:'addText'} 
						]

						var widgetDefinition = {
							DEI: [], 
							actions: w_actions,
							dataSource:true,
							widgetLabel: 'Richtextbox',
							widgetName: 'richtextbox',
							widgetId: $scope.fd.UuidRef,
							resource_id:$scope.resourceDefinition.page_state_id,
							resourceDefId : $scope.fd.Related, 
							output:out_fields,
							parentResourceId:$scope.fd.localVars.resourceDefinition.uid 
						};
						  
						$scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
	  
	  
	  
	  
	  
                         CodesService.getCodesByName('usertags',lang).then(
							function (data) {
                                $scope.fd.tagList = data.data;
                                
                                 var pos = $scope.fd.tagList.map(function(e) { return e.id; }).indexOf($scope.fd.UniqueId);

                                   if (pos>=0){
                                       $scope.fd.UniqueIdObj=$scope.fd.tagList[pos];
                                      
                                   }
                             });
                         
                        if ($scope.formData[0]!=undefined &&  $scope.fd.ReadOnly) $scope.fd.readOnlyVal=$sce.trustAsHtml($scope.formData[0][$scope.fd.FieldName]);
                        
                         $scope.$watch("fd.ReadOnly",function(newValue,oldValue){
                                  
                                  if (newValue)
                                  {
                                     //if ($scope.showSearchFilters)
                                       if ($scope.formData[0]!=undefined &&  $scope.fd.ReadOnly) $scope.fd.readOnlyVal=$sce.trustAsHtml($scope.formData[0][$scope.fd.FieldName]);
                                  } 
                         });
                         

                        $scope.isOpen=true;
                        $scope.isOpen=false;
                                                
                                                $scope.search=[
                                                {id:1,filter:'begins',name:"Begins with",icon:"fa fa-chevron-right"},
                                                {id:2,filter:'contains',name:"Contains",icon:"fa fa-expand"},
                                                {id:3,filter:'ends',name:"Ends with",icon:"fa fa-chevron-left"},
                                                {id:4,filter:'eq',name:"Equals",icon:"fa fa-bars"} ];
                       
                        $scope.fd.localVars.EditDefault = function(){
                            $scope.formData[0][$scope.fd.FieldName]=$scope.fd.DefaultValue

                        }

                       $scope.fd.SetDefault = function(){
                                $scope.fd.DefaultValue = $scope.formData[0][$scope.fd.FieldName];
                        }
                        
                                          $scope.applyTextFilters = function(index) {
                                                   $scope.fd.Search=$scope.search[index];
                                    if ($scope.fd.Search) $scope.fd.Search.value=$scope.fd.sItemValue; 
                                    $scope.isOpen=false;		
                                                };
                                
                                $scope.refreshSearchValue = function() {
                                 if ($scope.fd.Search) $scope.fd.Search.value=$scope.fd.sItemValue;      
                             };
                         
                         $scope.fd.onSelectUnique = function(item,model)
                        {
                                
                                $scope.fd.UniqueId=item.id;
                        }
                             
                              $scope.showProperties = function(event)
                                {
                                  $scope.gsrvc.setFieldProperties($scope.fd,event);
                       
                                };
                             
                               if ($scope.fd.showSearchForm)  {
                                   if ($scope.fd.Search==undefined) $scope.fd.Search=$scope.search[3];//initialize to equals
                              }
                        
                        let template;
                        if ($scope.resourceDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktRichtextbox.html');
                        else template = $templateCache.get('ktdirectivetemplates/ktRichtextboxExe.html');
          
                        $element.append($compile(template)($scope));  
                        
                        },
             
             link: function (scope, elem, attrs) {
				


              
            }
        };
};
'use strict';

export function ktSearchBox () {
        return {
            restrict: 'A',
		controller: function ($scope,GridsterService,$templateCache,$compile,$element) {
                
                 $scope.gsrvc = GridsterService;
                 if ($scope.localVars==undefined) $scope.localVars =  {};
                 if ($scope.formData==undefined)  $scope.formData = [{}];
                 if ($scope.fd.Parameters==undefined) $scope.fd.Parameters = {};
                 
                 $scope.fd.setStep = function() {
                  $scope.fd.stepValue =parseFloat(Math.pow(0.1,$scope.fd.Parameters.NoOfDecimals)).toFixed($scope.fd.Parameters.NoOfDecimals);
                 }; 
                
                if ($scope.fd.stepValue==null || $scope.fd.stepValue==undefined) $scope.fd.setStep();
               
               
                if ($scope.fd.showSearchForm)  
                {
                 if ($scope.fd.search==undefined)    $scope.fd.search=$scope.search[3];//initialize to equals
                 if ($scope.fd.search)  $scope.fd.search.value=$scope.fd.sItemValue; 
                }
                
                $scope.search=[
			  	{id:1,filter:'gt',name:"Greater than",icon:"fa fa-chevron-right"},
			  	{id:2,filter:'between',name:"Between",icon:"fa fa-expand"},
			  	{id:3,filter:'lt',name:"Lower than",icon:"fa fa-chevron-left"},
			  	{id:4,filter:'eq',name:"Equals",icon:"fa fa-bars"} ];
                 
                $scope.formatNumber = function()
                {
                  if ($scope.formData[0][$scope.fd.FieldName]!=undefined)
                  {
                    $scope.formatedNumber = $scope.formData[0][$scope.fd.FieldName].toLocaleString(navigator.language,{minimumFractionDigits:$scope.fd.Parameters.NoOfDecimals,maximumFractionDigits:$scope.fd.Parameters.NoOfDecimals});
                    
                  }else  $scope.formatedNumber = "";
                }
                
               
                
                 $scope.fd.formatNumberBlockchain = function(input)
                {
                  let formatedNumber;
                  let web3;
                  if ($scope.fd.Parameters.ConvertBlockchainFormat)
                  {
                        if (input!=undefined)
                        {
                               

                                if (window.ethereum)
                                {
                                  web3 = new Web3(window.ethereum);
                                }else if (window.web3)
                                {
                                  web3 = new Web3(window.web3);
                                   console.log(web3);
                                }
                                
                                else if ($rootScope.globals.currentUser.web3Infura)
                                {
                                   web3 = new Web3($rootScope.globals.currentUser.web3Infura);     
                                } else
                                {
                                   console.log('web3 provider not available');
                                   
                                   return input;
                                }
                                if ($scope.fd.Parameters.FromArray!=undefined) input = $scope.formData[0][$scope.fd.Parameters.SourceFieldName][$scope.fd.Parameters.FromArray];
                                
                                formatedNumber = web3.utils.fromWei(input.toLocaleString('fullwide', {useGrouping:false}), 'ether').toLocaleString(undefined,{minimumFractionDigits:$scope.fd.Parameters.NoOfDecimals,maximumFractionDigits:18});
                                
                  
                        }else  formatedNumber = input;
                  }else formatedNumber=input;
                  if ($scope.fd.Parameters.ConvertToDays) formatedNumber = formatedNumber/86400;                              
                  return formatedNumber;
                }
                
                let template;
                if ($scope.resourceDefinition.form_definition)  template = $templateCache.get('ktdirectivetemplates/ktSearchBox.html');
                else template = $templateCache.get('ktdirectivetemplates/ktSearchBoxExe.html');
                $element.append($compile(template)($scope)); 

            },
             
            link: function (scope, elem, attrs) {
  
				scope.isOpen=true;
            
                scope.refreshSearchValue = function() {
                         if (scope.fd.search) scope.fd.search.value=scope.fd.sItemValue;      
                }; 
                        
                if (scope.fd.showSearchForm)  {
                        if (scope.fd.search==undefined)   scope.fd.search=scope.search[3];//initialize to equals
                        if (scope.fd.search)  scope.fd.search.value=scope.fd.sItemValue; 
                }
               
                scope.showProperties = function(event) {
                   			 scope.gsrvc.setFieldProperties(scope.fd, scope.inputArray);// inputArray is parent
                };
             
                scope.applyNumFilters = function(index) {
				   scope.fd.search=scope.search[index];
                   if (scope.fd.sItemValue) scope.fd.search.value=scope.fd.sItemValue;
				   scope.isOpen=false;		
                };
       
            }
            
        }
};
		
                
               
'use strict';

export function ktSelectGeneric () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktSelectGeneric.html',
             scope: {
                inputParameters: '=',
                selectedItem: '=',
                inputArray: '=',
                requiredField: '=?',
                onSelectFn: '&',
                refreshFn: '&',
            },
            controller: function(UserService,ResourcesDataService,$rootScope,ProcessingService){},
             link: function (scope, elem, attrs) {
                
                 scope.onSelectItem = function(item,model) {
                   scope.onSelectFn(item,model);
                }
                
                 scope.refreshResults = function(filter) {
                   scope.refreshFn(filter);
                }
                     
              }
        }
  
};
'use strict';

export function ktSelectGroups () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktSelectGroups.html',
            /*  scope:{
                selectedItems:'=',
             },*/
            controller: function($scope,UserService){

                $scope.groupList=[];
                
                $scope.getGroups = function () {
                      UserService.getUsersGroups('groups').then(function(data){
						  
                      $scope.groupList = data.data;
                      $scope.groupsDownloaded=true;
					  
					  
					    $scope.selectedGroups.forEach( // add UID to selected 
						function(selected) { 
							  var match = $scope.groupList.find(function(group) {
								return group.id === selected.id;
							  });
							  if (match) selected.uid = match.uid;
							  
							});
							
				
                      });
            
                 }
                
                $scope.getGroups();
                            
            },
            link: function (scope, elem, attrs) {
            
            
           
                    
                   
                
            
            }

    }
};
'use strict';

export function ktSelectGroupsWithScope () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktSelectGroupsWithScope.html',
              scope:{
                selectedItems:'=',
                size:'=?',
                selectId:'=',
             },
             controller: function($scope,UserService){
                 $scope.selected={groups:$scope.selectedItems};
         
         
           $scope.$watch('selected.groups',function(newValue,oldValue){
              
              if (newValue!=oldValue && newValue!==undefined)
              {
               $scope.selectedItems=newValue;
              }
            });
          
           
             $scope.groupList=[];
        //if ($scope.selectedItems==undefined) $scope.selectedItems=[]

        $scope.getGroups = function () {
          UserService.getUsersGroups('groups').then(function(data){
          $scope.groupList = data.data;
          $scope.groupsDownloaded = true;
				});

        }
				$scope.getGroups();
                },
             link: function (scope, elem, attrs) {
            
          
       
        
        
      
    

            }

    }
};
'use strict';

export function ktSelectUsers (UserService,$timeout) {

    return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktSelectUsers.html',
            controller: function($scope, UserService){
               
                $scope.userList=[];
                $scope.getUsers = function () {
              
                UserService.getUsersGroups('users').then(function(data){
                         $scope.userList = data.data;
                         $scope.usersDownloaded=true;
                         //$scope.addCurrentUser();
                        });
                }
		
            $scope.getUsers();  
          
           },
           
           link: function (scope, elem, attrs) {
         
        }//LInk
    }
};
'use strict';

export function ktSelectUsersWithScope (UserService) {

    return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktSelectUsersWithScope.html',
             scope:{
              selectedItems:'=',
              size:'=?',
              selectId:'=',
             },
              controller: function(UserService){},
             link: function (scope, elem, attrs) {


              
       scope.userList=[];
        //if (scope.selectedItems==undefined) scope.selectedItems=[]
        scope.selected={users:scope.selectedItems};
        
        
           
             scope.$watch('selected.users',function(newValue,oldValue){
              
              if (newValue!==oldValue && newValue!==undefined)
              {
               scope.selectedItems=newValue;
              }
            });
         

        scope.getUsers = function () {
            //debugger
            
          UserService.getUsersGroups('users').then(function(data){
          scope.userList = angular.copy(data.data);
          scope.usersDownloaded = true;
				});

        }
				scope.getUsers();

            
            
        scope.userSelected =  function(item,model) {
        
     
        /*
            var pos = scope.selectedItems.map(function(e) { return e.id; }).indexOf(item.id);
              
            if (pos<0){
                 scope.selectedItems.push(angular.copy(item));
                
              }
          */  

        };
      
      }
    }
};
'use strict';

export function ktSeparator () {
        return {
            restrict: 'A',
			 controller: function ($scope,GridsterService) {
                
                $scope.gsrvc = GridsterService;
                $scope.showProperties = function(event)
                {
                     $scope.gsrvc.setFieldProperties($scope.fd,event);
                };

                },
             templateUrl: 'ktdirectivetemplates/ktSeparator.html',
             link: function (scope, elem, attrs) {

            }
        };
};
'use strict';

export function ktSimpleUser (UserService) {

	return {
        restrict: 'A',
         templateUrl: 'ktdirectivetemplates/ktSimpleUser.html',
         scope:{
                selectedUser : '=',
                userList: '=',
                selectedUserModel: '='
                },      
		 controller: function(UserService){},
         link: function (scope, elem, attrs) {
          
            console.log('scope user list')
            console.log(scope.userList);
           /* scope.getUsers = function () {
              UserService.getUsersGroups('users').then(function(data){
                  scope.userList = data.data;
                  scope.selectedUserModel = UserService.getUserObjectById(scope.selectedUser); 
                  scope.selectedUser = scope.selectedUserModel.id;                  
                 });
            }*/
          
            scope.populateUser = function (item,model) { 
                  scope.selectedUserModel = item;
                  scope.selectedUser = item.id;   
    		};
                    

         }
    }
};
'use strict';

export function ktSmartCards($timeout, UtilityService, ResourcesDataService,MessagingService) {
        return {
            restrict: 'EA',
             controller: function ($scope, $rootScope, $filter, $timeout, UtilityService, ResourcesDataService,MessagingService,$sce,$element) {
                
                    $scope.displayTableData = [];
                    $scope.priority= { min:1, max:3 }
                    $scope.isSortChanged = true
                    $scope.Math = window.Math;
                    $scope.local= { stItemsOnPage:$scope.itemsOnPage}
                    $scope.showTableConfigMenu=false
                    $scope.pageItemsList = [5,10,25,50,100,250,500,1000];
                    $scope.myFormat={}
                    $scope.langCode = $rootScope.globals.currentUser.langObj.Code
                    $scope.leftCss="left: 0px;"              
                    if ($scope.fontSize==undefined ) $scope.fontSize = "1rem"                                
                    $scope.CTRL='ktSmartCards'
                    if ($scope.clientSide==undefined) $scope.clientSide=false;
                    if ($scope.usePagination==undefined) $scope.usePagination=false;
                    if ($scope.tableData!=undefined) $scope.displayTableData = $scope.tableData;
                    // PARAMETERS DEFAULTS
                    if ($scope.parameters===undefined)  $scope.parameters.table = { }   
                    if ($scope.parameters.table==undefined)    $scope.parameters.table = { }
                    
                    if ($scope.parameters.PagerLabel1===undefined) $scope.parameters.PagerLabel1 ='items per page | Page:'
                    if ($scope.parameters.PagerLabel2===undefined) $scope.parameters.PagerLabel2 ='of'
                    if ($scope.parameters.PagerLabel3===undefined) $scope.parameters.PagerLabel3 ='items'                  
                    if ($scope.parameters.PagerMaxPages===undefined) {
                        $scope.parameters.PagerMaxPages = 10
                        if (window.innerWidth<992) 
                                $scope.parameters.PagerMaxPages = Math.round($scope.parameters.PagerMaxPages/2)
                    }  else if ($scope.parameters.PagerMaxPages>=10)  {
                        if (window.innerWidth<992) 
                                $scope.parameters.PagerMaxPages = Math.round($scope.parameters.PagerMaxPages/2)
                    }
                    

                    if ($scope.parameters.table.VerticalSpacing==undefined) $scope.parameters.table.VerticalSpacing=0
                                     
                    
                   /* Array.prototype.sortBy = function (propertyName, sortDirection) { // should be used instead GETSORTMEHTOD !!
                        // sortDirection :  true=ascending, false=descending
                        var sortArguments = arguments;
                        this.sort(function (objA, objB) {

                            var result = 0;
                            for (var argIndex = 0; argIndex < sortArguments.length && result === 0; argIndex += 2) {

                                var propertyName = sortArguments[argIndex];
                                result = (objA[propertyName] < objB[propertyName]) ? -1 : (objA[propertyName] > objB[propertyName]) ? 1 : 0;

                                //Reverse if sort order is false (DESC)
                                result *= !sortArguments[argIndex + 1] ? 1 : -1;
                            }
                            return result;
                        });

                    }*/
                    
                     $scope.getSortMethod = UtilityService.getSortMethod
                    
                    
                    $scope.sortGridData = function ()
                    {
                         $scope.isSortChanged = false                     
                                let sortArguments = []
                                var allTableData = $scope.gridData()
                                
                                if (allTableData!=undefined && allTableData.length >1 ) {
                                        for (const col of  $scope.columnDefs) {     
                                            if (col.sort =='ascending' || col.sort =='descending') {
                                                sortArguments.push(col.sort[0] + col.name)        
                                            }        
                                        }
                                    // var langCode = $rootScope.globals?.currentUser?.langObj?.Code ?? 'en-GB'
                                        allTableData.sort ($scope.getSortMethod(sortArguments,$rootScope.globals?.currentUser?.langObj?.Code ));      
                                }
                      
                    }
                    
                    
                     const numFormat = new Intl.NumberFormat("de-DE", {
                          maximumFractionDigits: 2 ,
                          minimumFractionDigits: 2
                    });
                    
                    
    
    
                    $scope.getItem = function (column,item)
                    {    
                        let val;
                        if (item.resourcedeflang_set) {
                             val = get(item,column.name, null)        // For RESOURCE LIST table
                        }
                        else {
                            val = item[column.name]      //for user data
                        }
                        
                        if (val===null || val===undefined) return "∅";          
                        //debugger //smarttable //getItem
                        
                        if (column.cellFilter) { //DATE FORMAT
                            if (column.cellFilter.substring(0,4).trim()=="date") 
                                    val = $filter(column.cellFilter.substring(0,4))(val,column.cellFilter.substring(6,column.cellFilter.length).trim());
                        }
  
                        // number.toString().replace(/\./g, ',') # replace dot with comma
                        if (column.ElementType == "number")   val =  $scope.myFormat[column.id].format(val)
        
                        return val;
                    };
                                    
                    
                    $scope.rowSelected = function(row) 
                    { 
                         $scope.rowSelectedCount = row.isSelected;
                         $scope.positionCss="left: "+$scope.cursorPositionLeft+"px"
                         $scope.rowSelectedChange({item:row}); 
                    };
                      
                    $scope.setActionsPosition = function(event,index) 
                    { 
                      let currentTargetOffsetLeft = event.currentTarget.offsetLeft 
                       
                      //  let actions = $element[0].getElementsByClassName("sm-actions"+index)
                      let table = document.getElementById("tblcontainer"+$scope.parameters.UuidRef)
                      //  if (actions.length) actions[0].offsetLeft = currentTargetOffsetLeft
                      $scope.cursorPositionLeft = currentTargetOffsetLeft - table.scrollLeft + event.offsetX
                    };     
                    
                   $scope.copycolumnDefs = function() 
                    {
                        //debugger //copycolumnDefs
                        for (let item of $scope.columnDefs) {
                                 if (item.sort == "true" || item.sort == "reverse")  {
                                          $timeout(function() {
                                             if ($scope.sortColumnDefs)  $scope.sortColumnDefs.push(item)  })
                                  }
                        }   
                    }
                    
                    
                    $scope.dropSuccess = function() { // NOT USED - DEMONSTRATION OF "ACTION ON DROP"
                        for (let src of $scope.sortColumnDefs) {
                             for (let dst of $scope.columnDefs) {
                                    if (src == dst)  {
                                       //debugger
                                    }
                             }   
                        }
                    }
                     
                    
                    $scope.sortFilter = function (item) { 
                        return item.sort === 'true' || item.sort === 'reverse'; 
                    };
                    
                    
                    $scope.toggleTableConfigMenu = function()
                    {
                       $scope.showTableConfigMenu = !$scope.showTableConfigMenu
                    }
                    
                    $scope.toggleSortMenu = function()
                    {
                       $scope.showSortMenu = !$scope.showSortMenu
                    }
                    
                    
                    $scope.selectPage = function (page) { 
                        $scope.$broadcast ('selectPage', page);//send to smart-table controller
                    };
        
                      
                    $scope.printTable = function()
                    {                  
                        let columns=[]
                        var output="<div class='container'>"
                        output = output+ "<div id='printb' class='noprint' style='padding:10px'> <button  onClick=' var e = document.getElementById(&quot;printb&quot;); e.remove(); window.print()'>Print</button></div>" 
                        var data= $scope.gridData()
                       

                       // PRINT HEADER
                        output = output+ "<div class='red'>" 
                        var columnStyles=''
                        for (let i=0; i< $scope.columnDefs.length;i++) {
                              let col = $scope.columnDefs[i]
                              if (col.visible == true) {
                                  let colClass="cell col" + i 
                                  if  ( col.ElementType == "number" ) 
                                       output = output + "<div class=' " + colClass + " ar' >" + col.displayName + "</div>";
                                  else 
                                      output = output + "<div class=' " + colClass +  " ' >" + col.displayName + "</div>";
                                  columnStyles+= ' .col' + i + '  {  margin-left: 4px ; width:' + col.width + ' }' 
                              }
                        }
                        output = output+ "</div>" 

                        // PRINT DATA
                        for(let row of data) {
                             
                            output = output+ "<div class='red'>"
                            for (let i=0; i< $scope.columnDefs.length; i++)  {
                                 let col = $scope.columnDefs[i]
                                 if (col.visible == true) {
                                    let colClass="cell col" + i
                                    if  ( col.ElementType == "number" ) {
                                        let formatted = row[col.name].toLocaleString(  $scope.langCode || 'en-GB', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
                                        output=output + '<div class="' + colClass + ' ar">'+ formatted +  '</div>'
                                    }
                                    else {
                                        output=output + '<div class="' + colClass+ '">'+ row[col.name] +  '</div>'
                                    }
                                 }
                            }     
                            output = output+ "</div>"        
                        }
                        
                        /*
                        var doc = document.implementation.createHTMLDocument('My title');  
                        doc.head.innerHTML+='  <link rel="stylesheet" type="text/css" href="/static/modules/styles/build/css/master.css" /> '                   
                        doc.head.innerHTML+=' <link rel="stylesheet" type="text/css" href="/static/modules/styles/build/css/main.css" />'
                        doc.body.innerHTML+='<div id="content">TEST</div>'
                        */
                        
                        var strWindowFeatures = "location=yes,height=570,width=520,scrollbars=yes,status=yes";
                        var win = window.open("", "_blank", strWindowFeatures);       
                        
                        win.document.body.innerHTML+=
                       // ' <style type="text/css" media="print">   @page { size: landscape;  }    body {   writing-mode: tb-rl; } </style>'  
                      //  ' <style type="text/css" >   @page { size: landscape;  }    body {  } </style>'  
                        ' <style type="text/css">'
                        +' @page {  size: landscape;  margin: 0;}  html, body {   width: 297mm;   height: 210mm;  }'
                       // +' @page {  size: A4;  margin: 0;}  html, body {   width: 2000px;   height: 1000px;  }'
                        +' .red {  font-weight: bold; max-width: 100%;  font-size: 10px; display: table-row; } '
                        +' .cell  {  width: 100px; float: left;   display: table-column; }'
                        +' .ar {  text-align: right  }'
                        +' .container { display: table;  width: 100%; } '
                        +  columnStyles
                        +' </style> '
                       
                        win.document.body.innerHTML += output;

                    }
             
            $scope.export2excel = function() {
              
                var wb = new ExcelJS.Workbook();
                if ($scope.parameters.excelExportTemplateFileType?.id!=undefined)
                {
                ResourcesDataService.downloadFile($scope.parameters.excelExportTemplateFileId , $scope.parameters.excelExportTemplateFileType.id)
                .then(function(data) {
                            MessagingService.addMessage('File downloaded','info');
                            $scope.template = data.data;
                        },function(error){    
                            MessagingService.addMessage(error.msg,'error');  
                      })
                .then( function(data) {               
                    wb.xlsx.load($scope.template).
                        then(workbook => {
                              workbook.eachSheet((sheet, id) => {
                                   if ($scope.$parent.formData) {
                                        let party_name = $scope.$parent.formData[Object.keys($scope.$parent.formData)[0]][0]["party_name"]
                                        let contract_number = $scope.$parent.formData[Object.keys($scope.$parent.formData)[0]][0]["contract_number"]
                                         sheet.getCell('A2').value = party_name;
                                         sheet.getCell('B3').value = contract_number;     
                                   }
                         
                                  let temp=[]
                                  let header=[]
     
                                  $scope.columnDefs.forEach(  (col, i) =>     
                                  {
                                      if (col.visible) {
                                          header.push(col.displayName)
                                          let colWidth = col.width.replace("%","").replace("px","") // for Excel we dont want % or px
                                          temp.push({header: col.displayName, key:col.name, width: colWidth } ) 
                                      }                                          
                                  });
                                  
                                sheet.columns = temp
                               
                                /*sheet.insertRow(6, header,'i')  TODO - make header dynamicaly created
                                sheet.spliceRows(5, 1); */
                                var data = $scope.gridData()
                                sheet.insertRows(7, data,'i')                          
                                sheet.spliceRows(6, 1);
                                //sheet.spliceRows(1, 1);
                                sheet.getRow(1).hidden = true   
                                                             
                                return workbook                                
                              })
                       
                
                          workbook.xlsx.writeBuffer().then((data) => {
                                  const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                                  saveAs(blob, 'export.xlsx');
                                }); 
                            
                        })
                    })
                }else MessagingService.addMessage('Export template is not defined!','warning');
            }
             
             
  
                   $scope.exportTable = function()
                    {   
                        const workbook = new ExcelJS.Workbook();
                        const worksheet = workbook.addWorksheet('New Sheet');          
                        let temp=[]
                        let isDate={}
                        let isList={}
                        let isColumnVisible=[]
                        
                        for (let col of $scope.columnDefs) {
                                if (col.visible) {
                                    isColumnVisible.push(col.name)
                                    temp.push({header: col.displayName, key:col.name})
                                    if (col.ElementType== 'list')  isList[col.name] = true 
                                    if (col.ElementType== 'date')  isDate[col.name] = true     
                                }
                        }
                        
                        worksheet.columns = temp
                        //worksheet.columns = $scope.columnDefs.map(col => {header: col.displayName, key:col.name}); //TODO mozda ovo ubaciti umjesto gore

                        var allTableData=$scope.gridData()
                        var allExportData = []
                        // creating  data for export
                        for (let row of allTableData) {
                            let obj = {}
                            for (let col of isColumnVisible) {                          
                                 obj[col] = row[col]
                                 if (row[col] && isList[col])   {  //when list
                                         obj[col] = row[col]
                                     }  
                                 if (row[col] && isDate[col])   {  //when date
                                          obj[col] = new Date(row[col])
                                     }   
                              }
                            allExportData.push(obj)
                        }
                          
                        worksheet.addRows(allExportData)
                        
                        workbook.xlsx.writeBuffer().then((data) => {
                          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                          saveAs(blob, 'export.xlsx');
                        });  
                    }
                    
                    
                    $scope.refreshDataExt = function(pageNumber,pageSize)  
                    { 
                          $scope.tableState.pagination.number = pageSize;
                          $scope.tableState.pagination.start = (pageNumber-1)*pageSize;
                          $scope.refreshData($scope.tableState);
                    }
                    
                    
                    $scope.flipSort = function(tc) {
                        if (tc.sort == undefined || tc.sort=="")
                            tc.sort="ascending"
                        else  if (tc.sort=="ascending") 
                            tc.sort="descending" 
                        else if (tc.sort=="descending") 
                            tc.sort=""
                        
                        $scope.isSortChanged = true

            
                    }
                    
                    // REFRESH FUNCTION - CALLED FROM SMART-TABLE !!
                    $scope.refreshData = function(tableState) 
                    {  
                       if (tableState.pagination.number==undefined || tableState.pagination.number==NaN)   
                            tableState.pagination.number=10;
                        
                        //debugger //refreshData
                        if ( $scope.isSortChanged)  {
                            $scope.isSortChanged = false
                            $scope.sortGridData()     
                        }
                       
                       //actually function GETDATASMARTTABLE in ktTaskDatasetList widget 
                       $scope.ktRefreshData({tableState: tableState, pageNumber:(tableState.pagination.start/tableState.pagination.number)+1, pageSize:tableState.pagination.number})
                            .then(function (result) {
                                //debugger //smarttable //get formated displayTabeData 
        
                                $scope.displayTableData = result.data.results;
                                $scope.columnDefs = result.data.columns;
                                $scope.totalMatched = result.data.count;

                                
                                for (const col of $scope.columnDefs) {
                                    var newFormat;
                                    let useGrouping = col.disableGrouping ? false : true
                                    
                                    if (col.decimalPlaces)     
                                            newFormat = new Intl.NumberFormat("de-DE", { useGrouping: useGrouping,  maximumFractionDigits: col.decimalPlaces ,  minimumFractionDigits: col.decimalPlaces  });
                                     else 
                                            newFormat = new Intl.NumberFormat("de-DE", { useGrouping: useGrouping });
                                    $scope.myFormat[col.id] = newFormat
                               }
                                
                                 
                                 
                                
                                if (result.data.results!=undefined) {
                                       for (let item of result.data.results){  
                                         item.getItem= {}
                                         for (let col of result.data.columns) {
                                                item.getItem[col.name] = $scope.getItem(col ,item)
                                            }                                         
                                    }   
                                }
                                
                                
                                if (tableState!=undefined)  {
                                    tableState.pagination.numberOfPages = result.data.numberOfPages;
                                    tableState.pagination.totalItemCount = result.data.count;
                                }
                                $scope.tableState = tableState;
                                
                             
                            });  
                    };
                    
                    /*
                     $scope.getActionLabel = function(index) 
                    {  
                        return $scope.actionDefinition[index].Label
                    };
                    */
                  
                    let stringToPath = function (path) {
                        // If the path isn't a string, return it
                        if (typeof path !== 'string') return path;
                        var output = []; 
                        path.split('.').forEach(function (item, index) {
                            // Split to an array with bracket notation
                            item.split(/\[([^}]+)\]/g).forEach(function (key) {
                                if (key.length > 0)    output.push(key);// Push to the new array
                            });
                        });
                        return output;
                    };
                        
                    
                  
                    let get = function (obj, path, def) {
                       
                          
                        path = stringToPath(path);// Get the path as an array
                        var current = obj;// Cache the current object
                        // For each item in the path, dig into the object
                        if (path!==null && path!==undefined)
                        {
                            for (var i = 0; i < path.length; i++) {
                            // If the item isn't found, return the default (or null)
                            if ( current[path[i]] === undefined || current[path[i]] === null ) return def;
                            current = current[path[i]]; // Otherwise, update the current  value
                            }
                        } else return def
                        return current;
                    };

            $scope.convertToHtml=function(content){
                
                return $sce.trustAsHtml(content)
            }
       
        $scope.$watch('columnDefs', function (newValue) { //SORTIRANJE KOLONA - NE ZNAM DA LI UOPČE OVO IMA IKAKVOG SMISLA..MISLIM DA NE - TODO OBRISATI

            if ($scope.sortColumnDefs == undefined) $scope.sortColumnDefs =  []      
            if ($scope.columnDefs == undefined) $scope.columnDefs =  []  
             
            for (let item of $scope.columnDefs) {
                  if (item.sort == "ascending" || item.sort == "descending") {
                       //if new column already exists in sort array do nothing otherwise push into new array
                       if ( ! $scope.sortColumnDefs.includes(item) )   
                                        $scope.sortColumnDefs.push(item)   
                                
                  }                      
            } 

           //  //sort kolona 
           // $scope.sortColumnDefs.sort(  (a,b) => (a.sortOrder > b.sortOrder) ? 1 : ((b.sortOrder > a.sortOrder) ? -1 : 0))                               
            
        },true);
        
      /* 
        $scope.$watch('sortColumnDefs', function (newValue,oldValue) {
            
            for (let i=0; i < $scope.sortColumnDefs.length;i++) {
                       if ($scope.sortColumnDefs[i].sort == "")  {
                            $scope.sortColumnDefs.splice(i, 1);
                       } else    
                           $scope.sortColumnDefs[i]['sortOrder'] = i
         
            }
                
        }, true);*/
  

        
                },  //CTRL
               scope:{
                    tableData:'=?',
                    parameters:'=?',
                    fontSize:'=?',
                    cellPadding:'=?',
                    columnDefs:'=?',
                    usePagination:'=?',
                    clientSide:'=?',
                    itemsOnPage:'=',
                    allowSort:'=',
					fd:'=',
					resourceDefinition:'=',
                    rowSelectedChange:'&',
                    ktRefreshData:'&ktRefreshData',
                    gridData:'&gridData',
                    setFnRefreshData: '&',
                    showActionButtons:'=?',
                    processAction:'&ktProcessAction',
                    initialPage: '=?',
                    actionDefinition: '=?',
            },
            templateUrl: 'ktdirectivetemplates/ktSmartCards.html',
            link: function (scope, elem, attrs) {
                // scope.formLoaded=true // MIGOR - todo test
                scope.setFnRefreshData({theDirFn: scope.refreshDataExt});
                if (scope.actionDefinition===undefined) scope.actionDefinition=[{actionId:1,Label:'Edit'}]
                 
             }
    }
             
      
};
'use strict';

export function ktSmartTable ($timeout, UtilityService, ResourcesDataService,MessagingService) {
        return {
            restrict: 'EA',
             controller: function ($scope, $rootScope, $filter, $timeout, UtilityService, ResourcesDataService,MessagingService,$sce,$element) { 
                    $scope.displayTableData = [];
                    $scope.priority= { min:1, max:3 }
                    $scope.isSortChanged = true
                    $scope.Math = window.Math;
                    $scope.local= { stItemsOnPage:$scope.itemsOnPage}
                    $scope.showTableConfigMenu=false
                    $scope.pageItemsList = [5,10,25,50,100,250,500,1000];
                    $scope.myFormat={}
                    $scope.langCode = $rootScope.globals.currentUser.langObj.Code
                    $scope.leftCss="left: 0px;"  
					$scope.positionCss=""				
                    if ($scope.fontSize==undefined ) $scope.fontSize = "1rem"                                
                    $scope.CTRL='ktSmartTable'
                    if ($scope.clientSide==undefined) $scope.clientSide=false;
                    if ($scope.usePagination==undefined) $scope.usePagination=false;
                    if ($scope.tableData!=undefined) $scope.displayTableData = $scope.tableData;
                    // PARAMETERS DEFAULTS
                    if ($scope.parameters===undefined)  $scope.parameters.table = { }   
                    if ($scope.parameters.table==undefined)    $scope.parameters.table = { }
                    
                    if ($scope.parameters.PagerLabel1===undefined) $scope.parameters.PagerLabel1 ='items per page | Page:'
                    if ($scope.parameters.PagerLabel2===undefined) $scope.parameters.PagerLabel2 ='of'
                    if ($scope.parameters.PagerLabel3===undefined) $scope.parameters.PagerLabel3 ='items'                  
                    if ($scope.parameters.PagerMaxPages===undefined) {
                        $scope.parameters.PagerMaxPages = 10
                        if (window.innerWidth<992) 
                                $scope.parameters.PagerMaxPages = Math.round($scope.parameters.PagerMaxPages/2)
                    }  else if ($scope.parameters.PagerMaxPages>=10)  {
                        if (window.innerWidth<992) 
                                $scope.parameters.PagerMaxPages = Math.round($scope.parameters.PagerMaxPages/2)
                    }
                    

                    if ($scope.parameters.table.VerticalSpacing==undefined) $scope.parameters.table.VerticalSpacing=0
                                     
                    
                 /*   Array.prototype.sortBy = function (propertyName, sortDirection) { // should be used instead GETSORTMEHTOD !!
                        // sortDirection :  true=ascending, false=descending
                        var sortArguments = arguments;
                        this.sort(function (objA, objB) {
                            var result = 0;
                            for (var argIndex = 0; argIndex < sortArguments.length && result === 0; argIndex += 2) {
                                var propertyName = sortArguments[argIndex];
                                result = (objA[propertyName] < objB[propertyName]) ? -1 : (objA[propertyName] > objB[propertyName]) ? 1 : 0;
                                result *= !sortArguments[argIndex + 1] ? 1 : -1;//Reverse if sort order is false (DESC)
                            }
                            return result;
                        });   }*/
                    
                    $scope.getSortMethod = UtilityService.getSortMethod
              
                    
                    $scope.sortGridData = function ()
                    {
                         $scope.isSortChanged = false                     
                                let sortArguments = []
                                var allTableData = $scope.gridData()
                                
                                if (allTableData!=undefined && allTableData.length >1 ) {
                                        for (const col of  $scope.columnDefs) {     
                                            if (col.sort =='ascending' || col.sort =='descending') {
                                                sortArguments.push(col.sort[0] + col.name)  // first leter is a(scending) or d(escending)      
                                            }        
                                        }
                                    
                                        allTableData.sort ($scope.getSortMethod(sortArguments, $rootScope.globals?.currentUser?.langObj?.Code ));      
                                }
                      
                    }
                    
                    
                     const numFormat = new Intl.NumberFormat("de-DE", {
                          maximumFractionDigits: 2 ,
                          minimumFractionDigits: 2
                    });
                    
                    
					$scope.showMenuFn = (event) => {
						
						event.stopPropagation();
						
						let cursorPositionLeft = event.clientX 
  
						let table = document.getElementById("dlist-" +$scope.parameters.UuidRef)
						if (table) {
							let rect = table.getBoundingClientRect();
							console.log(rect.top, rect.right, rect.bottom, rect.left);
							cursorPositionLeft = event.clientX - rect.x 
						}
						$scope.positionCss= "left: "+ cursorPositionLeft +"px"
		
					}
    
                    $scope.getItem = function (column,item)
                    {    
                        let val;
                        if (item.resourcedeflang_set) {
                             val = get(item,column.name, null)        // For RESOURCE LIST table
                        }
                        else {
                            val = item[column.name]      //for user data
                        }
                        
                        if (val===null || val===undefined) return "∅";          
                        //debugger //smarttable //getItem
                        
                        if (column.cellFilter) { //DATE FORMAT
                            if (column.cellFilter.substring(0,4).trim()=="date") 
                                    val = $filter(column.cellFilter.substring(0,4))(val,column.cellFilter.substring(6,column.cellFilter.length).trim());
                        }
  
                        // number.toString().replace(/\./g, ',') # replace dot with comma
                        if (column.ElementType == "number")   val =  $scope.myFormat[column.id].format(val)
        
                        return val;
                    };
                                    
                    
                    $scope.rowSelected = function(row) 
                    { 
                        if (!$scope.parameters.Multiline){
                            
                         $scope.rowSelectedCount = row.isSelected;
                         $scope.positionCss="left: "+$scope.cursorPositionLeft+"px"
                         $scope.rowSelectedChange({item:row});
                        
                        }else {
                            if ($scope.allSelected) $scope.allSelected = row.isSelected
                            $scope.rowSelectedMultiple(row)
                        }
                    };
                     $scope.rowSelectedMultiple = function(row) 
                    { 
                             
                            $scope.selectMultiple({item:row});
                        
                    };

                    $scope.selectAllRows = function() 

                    { 
                        $scope.allSelected = !$scope.allSelected

                        for (let i=0;i<$scope.displayTableData.length;i++)
                        {
                           $scope.displayTableData[i].isSelected = $scope.allSelected 
                        }
                        $scope.selectMultiple({item:null,selectAll:$scope.allSelected,deselectAll:!$scope.allSelected}); 
                    };
                      
                    $scope.setActionsPosition = function(event,index) 
                    { 
                      let currentTargetOffsetLeft = event.currentTarget.offsetLeft 
                       
                      //  let actions = $element[0].getElementsByClassName("sm-actions"+index)
                      let table = document.getElementById("tblcontainer"+$scope.parameters.UuidRef)
                      //  if (actions.length) actions[0].offsetLeft = currentTargetOffsetLeft
                      $scope.cursorPositionLeft = currentTargetOffsetLeft - table.scrollLeft + event.offsetX
                    };     
                    
                   $scope.copycolumnDefs = function() 
                    {
                        //debugger //copycolumnDefs
                        for (let item of $scope.columnDefs) {
                                 if (item.sort == "true" || item.sort == "reverse")  {
                                          $timeout(function() {
                                             if ($scope.sortColumnDefs)  $scope.sortColumnDefs.push(item)  })
                                  }
                        }   
                    }
                    
                    
                    $scope.dropSuccess = function() { // NOT USED - DEMONSTRATION OF "ACTION ON DROP"
                        for (let src of $scope.sortColumnDefs) {
                             for (let dst of $scope.columnDefs) {
                                    if (src == dst)  {
                                       //debugger
                                    }
                             }   
                        }
                    }
                     
                    
                    $scope.sortFilter = function (item) { 
                        return item.sort === 'true' || item.sort === 'reverse'; 
                    };
                    
                    
                    $scope.toggleTableConfigMenu = function()
                    {
                       $scope.showTableConfigMenu = !$scope.showTableConfigMenu
                    }
                    
                    $scope.toggleSortMenu = function()
                    {
                       $scope.showSortMenu = !$scope.showSortMenu
                    }
                    
                    
                    $scope.selectPage = function (page) { 
                        $scope.$broadcast ('selectPage', page);//send to smart-table controller
                    };
        
                      
                    $scope.printTable = function()
                    {                  
                        let columns=[]
                        var output="<div class='container'>"
                        output = output+ "<div id='printb' class='noprint' style='padding:10px'> <button  onClick=' var e = document.getElementById(&quot;printb&quot;); e.remove(); window.print()'>Print</button></div>" 
                        var data= $scope.gridData()
                       

                       // PRINT HEADER
                        output = output+ "<div class='red'>" 
                        var columnStyles=''
                        for (let i=0; i< $scope.columnDefs.length;i++) {
                              let col = $scope.columnDefs[i]
                              if (col.visible == true) {
                                  let colClass="cell col" + i 
                                  if  ( col.ElementType == "number" ) 
                                       output = output + "<div class=' " + colClass + " ar' >" + col.displayName + "</div>";
                                  else 
                                      output = output + "<div class=' " + colClass +  " ' >" + col.displayName + "</div>";
                                  columnStyles+= ' .col' + i + '  {  margin-left: 4px ; width:' + col.width + ' }' 
                              }
                        }
                        output = output+ "</div>" 

                        // PRINT DATA
                        for(let row of data) {
                             
                            output = output+ "<div class='red'>"
                            for (let i=0; i< $scope.columnDefs.length; i++)  {
                                 let col = $scope.columnDefs[i]
                                 if (col.visible == true) {
                                    let colClass="cell col" + i
                                    if  ( col.ElementType == "number" ) {
                                        let formatted = row[col.name].toLocaleString(  $scope.langCode || 'en-GB', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
                                        output=output + '<div class="' + colClass + ' ar">'+ formatted +  '</div>'
                                    }
                                    else {
                                        output=output + '<div class="' + colClass+ '">'+ row[col.name] +  '</div>'
                                    }
                                 }
                            }     
                            output = output+ "</div>"        
                        }
                        
                        /*
                        var doc = document.implementation.createHTMLDocument('My title');  
                        doc.head.innerHTML+='  <link rel="stylesheet" type="text/css" href="/static/modules/styles/build/css/master.css" /> '                   
                        doc.head.innerHTML+=' <link rel="stylesheet" type="text/css" href="/static/modules/styles/build/css/main.css" />'
                        doc.body.innerHTML+='<div id="content">TEST</div>'
                        */
                        
                        var strWindowFeatures = "location=yes,height=570,width=520,scrollbars=yes,status=yes";
                        var win = window.open("", "_blank", strWindowFeatures);       
                        
                        win.document.body.innerHTML+=
                       // ' <style type="text/css" media="print">   @page { size: landscape;  }    body {   writing-mode: tb-rl; } </style>'  
                      //  ' <style type="text/css" >   @page { size: landscape;  }    body {  } </style>'  
                        ' <style type="text/css">'
                        +' @page {  size: landscape;  margin: 0;}  html, body {   width: 297mm;   height: 210mm;  }'
                       // +' @page {  size: A4;  margin: 0;}  html, body {   width: 2000px;   height: 1000px;  }'
                        +' .red {  font-weight: bold; max-width: 100%;  font-size: 10px; display: table-row; } '
                        +' .cell  {  width: 100px; float: left;   display: table-column; }'
                        +' .ar {  text-align: right  }'
                        +' .container { display: table;  width: 100%; } '
                        +  columnStyles
                        +' </style> '
                       
                        win.document.body.innerHTML += output;

                    }
             
            $scope.export2excel = function() {
              
                var wb = new ExcelJS.Workbook();
                if ($scope.parameters.excelExportTemplateFileType?.id!=undefined)
                {
                ResourcesDataService.downloadFile($scope.parameters.excelExportTemplateFileId , $scope.parameters.excelExportTemplateFileType.id)
                .then(function(data) {
                            MessagingService.addMessage('File downloaded','info');
                            $scope.template = data.data;
                        },function(error){    
                            MessagingService.addMessage(error.msg,'error');  
                      })
                .then( function(data) {               
                    wb.xlsx.load($scope.template).
                        then(workbook => {
                              workbook.eachSheet((sheet, id) => {
                                   if ($scope.$parent.formData) {
                                        let party_name = $scope.$parent.formData[Object.keys($scope.$parent.formData)[0]][0]["party_name"]
                                        let contract_number = $scope.$parent.formData[Object.keys($scope.$parent.formData)[0]][0]["contract_number"]
                                         sheet.getCell('A2').value = party_name;
                                         sheet.getCell('B3').value = contract_number;     
                                   }
                         
                                  let temp=[]
                                  let header=[]
     
                                  $scope.columnDefs.forEach(  (col, i) =>     
                                  {
                                      if (col.visible) {
                                          header.push(col.displayName)
                                          let colWidth = col.width.replace("%","").replace("px","") // for Excel we dont want % or px
                                          temp.push({header: col.displayName, key:col.name, width: colWidth } ) 
                                      }                                          
                                  });
                                  
                                sheet.columns = temp
                               
                                /*sheet.insertRow(6, header,'i')  TODO - make header dynamicaly created
                                sheet.spliceRows(5, 1); */
                                var data = $scope.gridData()
                                sheet.insertRows(7, data,'i')                          
                                sheet.spliceRows(6, 1);
                                //sheet.spliceRows(1, 1);
                                sheet.getRow(1).hidden = true   
                                                             
                                return workbook                                
                              })
                       
                
                          workbook.xlsx.writeBuffer().then((data) => {
                                  const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                                  saveAs(blob, 'export.xlsx');
                                }); 
                            
                        })
                    })
                }else MessagingService.addMessage('Export template is not defined!','warning');
            }
             
             
  
                   $scope.exportTable = function()
                    {   
                        const workbook = new ExcelJS.Workbook();
                        const worksheet = workbook.addWorksheet('New Sheet');          
                        let temp=[]
                        let isDate={}
                        let isList={}
                        let isColumnVisible=[]
                        
                        for (let col of $scope.columnDefs) {
                                if (col.visible) {
                                    isColumnVisible.push(col.name)
                                    temp.push({header: col.displayName, key:col.name})
                                    if (col.ElementType== 'list')  isList[col.name] = true 
                                    if (col.ElementType== 'date')  isDate[col.name] = true     
                                }
                        }
                        
                        worksheet.columns = temp
                        //worksheet.columns = $scope.columnDefs.map(col => {header: col.displayName, key:col.name}); //TODO mozda ovo ubaciti umjesto gore

                        var allTableData=$scope.gridData()
                        var allExportData = []
                        // creating  data for export
                        for (let row of allTableData) {
                            let obj = {}
                            for (let col of isColumnVisible) {                          
                                 obj[col] = row[col]
                                 if (row[col] && isList[col])   {  //when list
                                         obj[col] = row[col]
                                     }  
                                 if (row[col] && isDate[col])   {  //when date
                                          obj[col] = new Date(row[col])
                                     }   
                              }
                            allExportData.push(obj)
                        }
                          
                        worksheet.addRows(allExportData)
                        
                        workbook.xlsx.writeBuffer().then((data) => {
                          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                          saveAs(blob, 'export.xlsx');
                        });  
                    }
                    
                    
                    $scope.refreshDataExt = function(pageNumber,pageSize)  
                    { 
                          $scope.tableState.pagination.number = pageSize;
                          $scope.tableState.pagination.start = (pageNumber-1)*pageSize;
                          $scope.refreshData($scope.tableState);
                    }
                    
                    
                    $scope.flipSort = function(tc) {
                        if (tc.sort == undefined || tc.sort=="")
                            tc.sort="ascending"
                        else  if (tc.sort=="ascending") 
                            tc.sort="descending" 
                        else if (tc.sort=="descending") 
                            tc.sort=""
                        
                        $scope.isSortChanged = true

            
                    }
                    
                    // REFRESH FUNCTION - CALLED FROM SMART-TABLE !!
                    $scope.refreshData = function(tableState) 
                    {  
                       if (tableState.pagination.number==undefined || tableState.pagination.number==NaN)   
                            tableState.pagination.number=10;
                        
                        //debugger
                        if ( $scope.isSortChanged)  {
                            $scope.isSortChanged = false
                            $scope.sortGridData()     
                        }
                       
                       //actually function GETDATASMARTTABLE in ktTaskDatasetList widget 
                       $scope.ktRefreshData({tableState: tableState, pageNumber:(tableState.pagination.start/tableState.pagination.number)+1, pageSize:tableState.pagination.number})
                            .then(function (result) {
                                //debugger //smarttable //get formated displayTabeData 
        
                                $scope.displayTableData = result.data.results;
                                $scope.columnDefs = result.data.columns;
                                $scope.totalMatched = result.data.count;

                                
                                for (const col of $scope.columnDefs) {
                                    var newFormat;
                                    let useGrouping = col.disableGrouping ? false : true
                                    
                                    if (col.decimalPlaces)     
                                            newFormat = new Intl.NumberFormat("de-DE", { useGrouping: useGrouping,  maximumFractionDigits: col.decimalPlaces ,  minimumFractionDigits: col.decimalPlaces  });
                                     else 
                                            newFormat = new Intl.NumberFormat("de-DE", { useGrouping: useGrouping });
                                    $scope.myFormat[col.id] = newFormat
                               }
                                
                                 
                                 
                                
                                if (result.data.results!=undefined) {
                                       for (let item of result.data.results){  
                                         item.getItem= {}
                                         for (let col of result.data.columns) {
                                                item.getItem[col.name] = $scope.getItem(col ,item)
                                            }                                         
                                    }   
                                }
                                
                                
                                if (tableState!=undefined)  {
                                    tableState.pagination.numberOfPages = result.data.numberOfPages;
                                    tableState.pagination.totalItemCount = result.data.count;
                                }
                                $scope.tableState = tableState;
                                
                             
                            });  
                    };
                    
                    /*
                     $scope.getActionLabel = function(index) 
                    {  
                        return $scope.actionDefinition[index].Label
                    };
                    */
                  
                    let stringToPath = function (path) {
                        // If the path isn't a string, return it
                        if (typeof path !== 'string') return path;
                        var output = []; 
                        path.split('.').forEach(function (item, index) {
                            // Split to an array with bracket notation
                            item.split(/\[([^}]+)\]/g).forEach(function (key) {
                                if (key.length > 0)    output.push(key);// Push to the new array
                            });
                        });
                        return output;
                    };
                        
                    
                  
                    let get = function (obj, path, def) {
                       
                          
                        path = stringToPath(path);// Get the path as an array
                        var current = obj;// Cache the current object
                        // For each item in the path, dig into the object
                        if (path!==null && path!==undefined)
                        {
                            for (var i = 0; i < path.length; i++) {
                            // If the item isn't found, return the default (or null)
                            if ( current[path[i]] === undefined || current[path[i]] === null ) return def;
                            current = current[path[i]]; // Otherwise, update the current  value
                            }
                        } else return def
                        return current;
                    };

            $scope.convertToHtml=function(content){
                
                return $sce.trustAsHtml(content)
            }
       
        $scope.$watch('columnDefs', function (newValue) { //SORTIRANJE KOLONA - NE ZNAM DA LI UOPČE OVO IMA IKAKVOG SMISLA..MISLIM DA NE - TODO OBRISATI

            if ($scope.sortColumnDefs == undefined) $scope.sortColumnDefs =  []      
            if ($scope.columnDefs == undefined) $scope.columnDefs =  []  
             
            for (let item of $scope.columnDefs) {
                  if (item.sort == "ascending" || item.sort == "descending") {
                       //if new column already exists in sort array do nothing otherwise push into new array
                       if ( ! $scope.sortColumnDefs.includes(item) )   
                                        $scope.sortColumnDefs.push(item)   
                                
                  }                      
            } 

           //  //sort kolona 
           // $scope.sortColumnDefs.sort(  (a,b) => (a.sortOrder > b.sortOrder) ? 1 : ((b.sortOrder > a.sortOrder) ? -1 : 0))                               
            
        },true);
        
      /* 
        $scope.$watch('sortColumnDefs', function (newValue,oldValue) {
            
            for (let i=0; i < $scope.sortColumnDefs.length;i++) {
                       if ($scope.sortColumnDefs[i].sort == "")  {
                            $scope.sortColumnDefs.splice(i, 1);
                       } else    
                           $scope.sortColumnDefs[i]['sortOrder'] = i
         
            }
                
        }, true);*/
  

        
                },  //CTRL
               scope:{
                    tableData:'=?',
                    parameters:'=?',
					parameterslang:'=?',
                    fontSize:'=?',
                    cellPadding:'=?',
                    columnDefs:'=?',
                    usePagination:'=?',
                    clientSide:'=?',
                    itemsOnPage:'=',
                    allowSort:'=',
                    rowSelectedChange:'&',
                    selectMultiple:'&',
                    ktRefreshData:'&ktRefreshData',
                    gridData:'&gridData',
                    setFnRefreshData: '&',
                    showActionButtons:'=?',
                    processAction:'&ktProcessAction',
                    initialPage: '=?',
                    actionDefinition: '=?',
            },
            templateUrl: 'ktdirectivetemplates/ktSmartTable.html',
            link: function (scope, elem, attrs) {
                 
                scope.setFnRefreshData({theDirFn: scope.refreshDataExt});
                if (scope.actionDefinition===undefined) scope.actionDefinition=[{actionId:1,Label:'Edit'}]
                 
             }
    }
             
      
};
'use strict';

export function ktStartTaskWidget ($rootScope,$stateParams,GridsterService,ResourcesDataService,TaskDataService,MessagingService,WidgetDataExchangeService,$timeout,$cookies) {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktStartTaskWidget.html',
            controller: function(UserService,ResourcesDataService,$rootScope,ProcessingService,$timeout,$stateParams,$cookies,WidgetDataExchangeService,$state,TaskDataService,MessagingService,GridsterService){},
             link: function (scope, elem, attrs) {
                 
                var lang=$rootScope.globals.currentUser.lang;
                scope.taskListParameters = {placeholder:'Select or search task...',label:scope.fd.Label,name:'task',
                  selectedItem:null,hideLabel:false,columnSizeLabel:'col-lg-4',dropdownSize:'col-lg-8',onSelectFunction:''};
               
                scope.initiateFormLoaded=false;
                scope.isSaving=false;
                
                scope.previousTask=$stateParams.prev_task_execute_id;
                scope.previousTaskOutcomeId=$stateParams.outcome_id;
                scope.previousTaskPackage=$stateParams.prev_task_package; 
                scope.gridsterType="task";
                //scope.gridsterOpts = GridsterService.getGridsterOptions();
                scope.showSearchFilters=false;      
                scope.dashboard = {widgets : []};
                scope.taskDefId=scope.fd.Related;          
                
                scope.fromStateName=$stateParams.fromStateName;
                scope.fromStateParams=$stateParams.fromStateParams;
                scope.cookieFromStateName=$cookies.getObject('initiateTaskFromStateName');
                scope.cookieFromStateParams=$cookies.getObject('initiateTaskFromStateParams');
                scope.noBackbutton = false;
                scope.backBtnFromCookie=false;
      
      
  
                scope.removeField = function (index){
						
                  if (index > -1) {
						 
                 scope.inputArray.layout.splice(index, 1);
						 
                  }

                }   

 
 
    
          scope.InititateAllList = function(){
      
            
              ResourcesDataService.getResourceDefByType(lang,'task').then(function(data) {
                                
                                  scope.gridOptions.data = data.data;
                                   
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
          }
        
    
    //napuni grid s definicijama resursa
   // $scope.InititateAllList();
                 
     scope.InititateMyList = function(){
      
         
              ResourcesDataService.getResourceDefListByLangByTypeUser(lang,'task').then(function(data) {
                                
                                 scope.gridOptions.data = data.data;
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
    
          
    };   
    
      scope.TaskSelectionChanged = function(item,model){
      
       scope.taskListParameters.selectedItem=item;
       scope.fd.Related = scope.taskListParameters.selectedItem.id;
       scope.SelectAnyTask();
  
     };
     
     scope.SelectAnyTask = function(){
      
      if (scope.fd.Search.startAnyTask)
          {
            
            scope.taskDefId=scope.taskListParameters.selectedItem.id;   
          //  scope.InititateMyList(); 
          }
          else
          {
            scope.taskDefId = scope.fd.Related;
          }
          
     };
      
     
      if (scope.fromStateName==undefined || scope.fromStateName=="")
      {
          if (scope.cookieFromStateName==undefined || scope.cookieFromStateName=="")
          {
            scope.noBackButton = true;
          }else
          {
            scope.fromStateName =  scope.cookieFromStateName;
            scope.backBtnFromCookie = true;
          }
          
        
      }else{
        $cookies.putObject('initiateTaskFromStateName',scope.fromStateName);
        
      }
      
      if (scope.fromStateParams==undefined)
      {
          if (scope.cookieFromStateParams!=undefined)
          {
              if (scope.backBtnFromCookie)
              {
                scope.fromStateParams =  scope.cookieFromStateParams;
              }
          }
          
      }else if (scope.cookieFromStateParams==undefined)
      {
        $cookies.putObject('initiateTaskFromStateParams',scope.fromStateParams);
        
      }else
      {
          if (scope.backBtnFromCookie)
          {
        
            scope.fromStateParams =  scope.cookieFromStateParams;
        
          }else
          {
              $cookies.putObject('initiateTaskFromStateParams',scope.fromStateParams);    
          }
      }
      
      
       if (scope.previousTask==undefined || scope.previousTask=="")
          {
           // $state.go();
            
            scope.previousTask = 0;
            
          }
      scope.potentialOwners = {};
      

      
    //WidgetDataExchangeService.deRegisterAllWidgets();	//Migor - cistim taskwidgetRegistry 

      scope.localTaskId=WidgetDataExchangeService.registerTask(scope.taskDefId);
     
     if  (scope.fd.localVars===undefined)  scope.fd.localVars={} 
      scope.fd.localVars.taskDefinition ={};
      scope.potentialOwners.potentialOwnersUsers = [];
      scope.potentialOwners.potentialOwnersGroups = [];
      
         scope.FormLockUnlock = function()
      {
        scope.resourceDefinition.formParams.formLocked=!scope.resourceDefinition.formParams.formLocked;

     
      };
      
      scope.PreInitiateTask = function(){
           var lang=$rootScope.globals.currentUser.lang;
          scope.taskInitiateId=0;
          scope.taskExecuteId=0;
          
         
        TaskDataService.preInitiateTask(scope.taskDefId,scope.previousTask,lang).then(function(data) {
                                
                                   
                                   scope.fd.localVars.taskDefinition = data.data.taskdef[0];
                                   scope.fd.localVars.taskDefinition.prev_task_id = scope.previousTask;
                                   scope.fd.localVars.taskDefinition.form_type="i";
                                   scope.fd.localVars.taskDefinition.source_type = $stateParams.src_type;
                                   scope.fd.localVars.taskDefinition.taskFormLoaded = false;
                                   if (scope.fd.localVars.taskDefinition.AutoInitiate) {
                                  
                                       scope.AutoInitiateTask();
                                                                    
                                  }else
                                      {
                                       scope.resourceDefinition=data.data.resourceDefinition;
                                       scope.dashboard.widgets.layout = data.data.widgets;
                                       scope.resourceDefinition.formParams = {formLocked:true,formViewType:2};
                                      
                                      $timeout(function(){scope.initiateFormLoaded = true;});
                      
                                      }
                                     
     
                              },function(error){
                                
                            
                                  MessagingService.addMessage(error.msg,'error');
                            });
      };
      
      scope.CancelClicked = function(){
        
        $state.go( scope.fromStateName, scope.fromStateParams);
      
      };
      
       scope.AutoInitiateTask = function(){
        var lang=$rootScope.globals.currentUser.lang;
        //  if (isValid) {
        var parentDataset=scope.getPreviousTaskWidget();
        if (scope.previousTaskOutcomeId==undefined) scope.previousTaskOutcomeId=0;
          
          TaskDataService.initiateTask(scope.taskDefId,scope.previousTask,scope.previousTaskOutcomeId,[],scope.potentialOwners,parentDataset['datasetId'],parentDataset['datasetRecordId'],lang).then(function(data) {
                                
                                    
                                    scope.task_initiate_id = data.data.task_initiate_id;
                                    scope.task_execute_id = data.data.task_execute_id;
                                    //$state.go('app.navbar.tasks.execute',{id: scope.taskDefId,task_initiate_id:scope.task_initiate_id,task_execute_id:scope.task_execute_id,fromStateName:scope.fromStateName,fromStateParams:scope.fromStateParams,prev_task_package:scope.previousTaskPackage,prev:scope.taskExecuteId});
                                   
                                  
                              },function(error){
                                    
                                  MessagingService.addMessage(error.msg,'error');
                            });
         // }
      }
      
       scope.InitiateTask = function(form){
        var f = scope.forma;
        if (form.$submitted) scope.setSubmitted(form);
        if (form.$valid) {
            
            //var initiateData={};
            $rootScope.$broadcast('ProcessTaskWidgets',{}); //svi widgeti slusaju ovaj event
            scope.isSaving = true;
            var lang=$rootScope.globals.currentUser.lang;
            if (scope.previousTaskOutcomeId==undefined) scope.previousTaskOutcomeId=0;
            //ako je prethodni task imao listu povuci WidgetData
            var parentDataset=scope.getPreviousTaskWidget();
                    
                TaskDataService.initiateTask(scope.taskDefId,scope.previousTask,scope.previousTaskOutcomeId,scope.dashboard.widgets.layout,scope.potentialOwners,parentDataset['datasetId'],parentDataset['datasetRecordId'],lang).then(function(data) {
                                
					
                                  MessagingService.addMessage(data.data.msg,'success');
                                  $rootScope.$broadcast('InitiateTaskPostProcess',data.data.ret_value);
                                  //ovo treba staviti u event InitiateTaskPostProcessFinished                        
                                  scope.fd.GridState.cancelBtnIcon = "fa fa-arrow-circle-left";
                                  scope.fd.GridState.cancelBtnTxt = "Go back";
                                  scope.taskInitiated=true;
                                 
     
                              },function(error){
                                 // $scope.isSaving = false;    
                                  MessagingService.addMessage(error.msg,'error');
                            });
                          
                          scope.isSaving = false;  
						
			
							
          } // if (isValid)
          else
          {
            MessagingService.addMessage("Please enter required data",'warning');
            
          }
      };

    scope.getPreviousTaskWidget  = function()
    {
      var pTaskData = WidgetDataExchangeService.getPrevTaskData(scope.fd.localVars.taskDefinition.prev_task_id);
            var datasetId=0,datasetRecordId=0;
            if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
            {
            for (var i=0;i<pTaskData.DEI.length;i++)
            {
              if (pTaskData.DEI[i].name=="resourceLink")
              {
                if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                {
                  for (var j=0;j<pTaskData.DEI[i].value.length;j++)
                  {
                   if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined) datasetId=pTaskData.DEI[i].value[j].value;
                   if (pTaskData.DEI[i].value[j].name=="resourceRecordId" && pTaskData.DEI[i].value[j].value!=undefined) datasetRecordId=pTaskData.DEI[i].value[j].value;
                   
                    
                  }
                     
                    
                }
                  
              }
                
              }
              if (datasetId==undefined || datasetId=="") datasetId=0;
              if (datasetRecordId==undefined || datasetRecordId=="") datasetRecordId=0;
            }
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };
        scope.setSubmitted = function (form) {
          form.$setSubmitted();
          angular.forEach(form, function(item) {
            if(item && item.$$parentForm === form && item.$setSubmitted) {
              scope.setSubmitted(item);
            }
          });
        } 
      //get form   
    
     
                 
                ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
                                                    
                                  scope.taskList = data.data;
                                    var pos = scope.taskList.map(function(e) { return e.id; }).indexOf(scope.fd.Related);
              
                                   if (pos>=0){
                                        scope.taskListParameters.selectedItem =  scope.taskList[pos];
                                          }                             
                                
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
      
      if (scope.fd.Search===undefined || scope.fd.Search===null)         scope.fd.Search = {startAnyTask:false};  
      if (scope.taskDefId!=undefined && scope.taskDefId>0 && !scope.fd.Search.startAnyTask) scope.PreInitiateTask();
      else if (scope.fd.Search.startAnyTask)  $rootScope.$broadcast('PageLoaded',{});             
              }
        }             
};
'use strict';

export function ktStyleAttribute () {

        return {
            restrict: 'A',
            scope:{
              fd: '=',
              styleType:'=',
            },
         
            link: function (scope, elem, attrs) {
				
			    scope.colLength=[];
                for (var i=0;i<24;i++) scope.colLength.push('col-lg-'+(i+1));

                if (scope.fd.Parameters==undefined) scope.fd.Parameters={};
                
                scope.$watch(function () { return elem[0].style.width},  widthChangedCallBack, true);
                scope.$watch(function () { return elem[0].style.height},  heightChangedCallBack, true);

                function widthChangedCallBack(newValue, oldValue) {
                    if (newValue !== oldValue && scope.fd.Parameters!=undefined && scope.fd.Parameters?.CustomSize) {
                    if (scope.styleType=="label") {
                        if (scope.fd.Parameters.LabelStyle==undefined) scope.fd.Parameters.LabelStyle = {};
                        scope.fd.Parameters.LabelStyle.Width = newValue;
                    }
                    if (scope.styleType=="element")    {
                        if (scope.fd.Parameters.ElementStyle==undefined) scope.fd.Parameters.ElementStyle = {};
                        scope.fd.Parameters.ElementStyle.Width = newValue;
                    }
                  }
                }
              

                 function heightChangedCallBack(newValue, oldValue) {
                    if (newValue !== oldValue && scope.fd.Parameters!=undefined && scope.fd.Parameters?.CustomSize) {
                    // do something interesting here
                    if (scope.styleType=="label")  {
                        if (scope.fd.Parameters.LabelStyle==undefined) scope.fd.Parameters.LabelStyle = {};
                        scope.fd.Parameters.LabelStyle.Height = newValue;
                    }
                    if (scope.styleType=="element")  {
                        if (scope.fd.Parameters.ElementStyle==undefined) scope.fd.Parameters.ElementStyle = {};
                        scope.fd.Parameters.ElementStyle.Height = newValue;
                    }
                  }
                }

				
				//MIGOR NEW
                scope.$watch('fd.LabelLength',function(newValue,oldValue){
                    if (newValue!=oldValue){
                        scope.fd.gridClassLabel = scope.colLength[scope.fd.LabelLength-1];
                    }
                    });

                scope.$watch('fd.ValueLength',function(newValue,oldValue){
                    if (newValue!=oldValue) {
                        scope.fd.gridClassElement = scope.colLength[scope.fd.ValueLength-1];
                    }
                    });
               
             
                scope.fd.process_size_style = function(newValue)
                {
                            let customStyleLabel = scope.fd.Parameters.customCssLabel+";text-align:"+scope.fd.Parameters.LabelAlign+" !important;font-size:"+scope.fd.Parameters.FontSize+scope.fd.Parameters.FontUnits+";color:"+scope.fd.Parameters.FontColor+";";
                            let customStyleElement = scope.fd.Parameters.customCssElement+";font-size:"+scope.fd.Parameters.ValueFontSize+scope.fd.Parameters.ValueFontUnits+";color:"+scope.fd.Parameters.ValueFontColor+";";
                            
                            scope.fd.labelAlign = "text-align:"+scope.fd.Parameters.LabelAlign+" !important";
                            if  (scope.fd.Parameters.FontBold) customStyleLabel = customStyleLabel+ "font-weight: bold;"
                            if  (scope.fd.Parameters.ValueFontBold) customStyleElement = customStyleElement+ "font-weight: bold;"

                            if (newValue?.CustomSize)  {
                                scope.fd.customStyleLabel= customStyleLabel+";width:"+scope.fd.Parameters.LabelStyle?.Width+";height:"+scope.fd.Parameters.LabelStyle?.Height;
                                scope.fd.customStyleElement = customStyleElement+"resize:both;width:"+scope.fd.Parameters.ElementStyle?.Width+";height:"+scope.fd.Parameters.ElementStyle?.Height;
                                scope.fd.gridClassLabel="";
                                scope.fd.gridClassElement="";     
                            } else   {
                                scope.fd.customStyleLabel=customStyleLabel;
                                scope.fd.customStyleElement=customStyleElement;
                                scope.fd.gridClassLabel = scope.colLength[scope.fd.LabelLength-1];
                                scope.fd.gridClassElement = scope.colLength[scope.fd.ValueLength-1];
                            }
                }
                
                 scope.$watch('fd.Parameters',function(newValue,oldValue){
					  if (newValue!=oldValue && scope.fd.process_size_style)  {
						scope.fd.process_size_style(newValue);
					  }
                 },true);
				 
               scope.fd.process_size_style(scope.fd.Parameters);

                 
            }
        }
  
};
'use strict';

export function ktTabs () {
       
        return {
              restrict: 'A',
		controller: function ($scope,GridsterService,UtilityService,$templateCache,$compile,$element) {

             
       //if ($scope.fd.layout==undefined || $scope.fd.layout.length==0)   $scope.fd.layout=$scope.resourceDefinition.ResourceExtended.DefaultForm// $scope.fd.layout=[]
       $scope.fd.selectedTab = 0
       $scope.gsrvc = GridsterService
       //$scope.fd.countActive=1

       $scope.parent = $scope.inputArray
       
        
        if ($scope.fd.localVars == undefined) $scope.fd.localVars= {} 
        $scope.fd.localVars.parent = $scope.inputArray
         

         $scope.fd.localVars.confirmAndDeleteElement = function (yesno , fdvalue) // delete Column
          {
                    //debugger
                    $scope.fd.localVars.gsrvc_setConfirmDeleteElement(yesno)
                    $scope.fd.localVars.gsrvc_deleteElement(fdvalue)
         } 
                
        $scope.fd.localVars.gsrvc_changeConfirmDeleteElement =  GridsterService.changeConfirmDeleteElement
	    $scope.fd.localVars.gsrvc_setConfirmDeleteElement =  GridsterService.setConfirmDeleteElement
	    $scope.fd.localVars.gsrvc_getConfirmDeleteElement =  GridsterService.getConfirmDeleteElement
	    $scope.fd.localVars.gsrvc_deleteElement = GridsterService.deleteElement
		
		
		$scope.fd.localVars.confirmDeleteTab = function () {
			  if ($scope.fd.layout.length > 1) // 	do not delete last tab! 
					$scope.fd.layout[$scope.fd.selectedTab].Status='Deleted';
					//$scope.fd.layout.splice($scope.fd.selectedTab,1)
			  $scope.fd.localVars.clickedOnDeleteTab=false
		}
		
      
       
       $scope.addNewTab = function () {
          
          let newTab = angular.copy($scope.resourceDefinition.ResourceExtended.DefaultForm[0])
          newTab.UuidRef = UtilityService.uuidv4()
          $scope.fd.layout.push(newTab)
       }
       
       
      $scope.showProperties=function(index,showPropertiesRight)
        {
            //debugger
          $scope.fd.selectedTab=index
           if (showPropertiesRight) $scope.gsrvc.setFieldProperties($scope.fd, $scope.fd.localVars.parent );
      
        };

          let template;
          if ($scope.resourceDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktTabs.html');
          else template = $templateCache.get('ktdirectivetemplates/ktTabsExe.html');
          
          $element.append($compile(template)($scope)); 


    },
             link: function (scope, elem, attrs) {

            }
        };
};
'use strict';

export function ktTaskAddResource ($timeout,UtilityService) {
   
   var controller = ['$scope', '$uibModal', '$state','$stateParams','dragularService','$timeout','CodesService','ResourcesDataService','UtilityService','$rootScope','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','CODES_CONST','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$state,$stateParams,dragularService,$timeout,CodesService,ResourcesDataService,UtilityService,$rootScope,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,CODES_CONST,$templateCache,$compile,$element) {
      
      $scope.fd.localVars = {};
      $scope.fd.localVars.searchFormDownloaded = false;

      $scope.fd.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_;
      $scope.fd.localVars.animationsEnabled = true;
      $scope.fd.localVars.widgetType = 1;
      $scope.fd.localVars.hidePopulateMethod = true;
      $scope.fd.localVars.datasetMapperType=0;      
      $scope.fd.localVars.formParams={formViewType:1,showGridNavigation:false};
      $scope.fd.localVars.showMenu = false
      $scope.fd.localVars.widgetReady=false
      $scope.gsrvc = GridsterService
      $scope.fd.localVars.ShowAdvancedProperties = true
      $scope.fd.localVars.resourceTypesList=[{type:'dataset',name:'Dataset'},{type:'counter',name:'Counter'}]
	  $scope.gsrvc.parentResource[$scope.fd.UuidRef] = $scope.fd

      if ($scope.fd.Parameters===null || $scope.fd.Parameters===undefined) $scope.fd.Parameters = {}
      if ($scope.formData===undefined)  $scope.formData={}
      $scope.formData[$scope.fd.UuidRef]= [{}]
      if ($scope.fd.Multiline) $scope.formData[$scope.fd.UuidRef]= [[{}]]
      $scope.fd.Parameters.SelectedResourceType='dataset'

      $scope.fd.Parameters.ShowAdvancedProperties = true
      $scope.fd.localVars.selectedRecords={}

      $scope.fd.localVars.toggleDropdown = function(){
           $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
       }
       
      
      $scope.formParamsParent=$scope.formParams;
      
      if ($scope.fd!=undefined){
           $scope.fd.PopulateMethod = "M";
      } else {
           $scope.fd={PopulateMethod : "M"};
      }
	  
      if (typeof($scope.fd.DatasetMapping)=='string') $scope.fd.DatasetMapping=[];
        
        $scope.fd.localVars.gridsterType="dataset";
        $scope.fd.localVars.resourceType="dataset";
    
          
        $scope.fd.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: {}
		} ;
       
        
        $scope.taskId=$scope.resourceDefinition.ResourceDefUid;
        if ($scope.taskId==undefined) $scope.taskId="0";
        $scope.fd.localVars.taskId=$scope.taskId;
        $scope.fd.localVars.resourceId=$scope.taskId;
        if ($scope.fd.localVars.resourceId=="0") $scope.fd.localVars.resourceId=$scope.resourceDefinition.id  

        $scope.fd.localVars.resourceDefinition = $scope.resourceDefinition
        $scope.fd.ParentDatasetDefId=$scope.fd.Related;
        $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
        $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;
        $scope.source_type=$scope.resourceDefinition.source_type;
        $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
        $scope.formDefinition = $scope.resourceDefinition.form_definition;
        $scope.fd.localVars.resourceRecordId=0;
        
        $scope.formDefinition = $scope.formDefinition || false
        $scope.taskInitiateId = $scope.taskInitiateId || 0
        $scope.taskExecuteId = $scope.taskExecuteId || 0
        $scope.prevTaskExeId = $scope.prevTaskExeId || 0
		
		$scope.resourceDefinition.parentWidgetUid = $scope.fd.UuidRef
    

    if ($scope.fd.Multiline) $scope.fd.localVars.dashboard.widgets = []
        
      //register widget 
      var out_fields = ['resourceId']
      if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
                
      let w_actions=[
                    {id:1,name:'addResourceRecord'},
                    {id:2,name:'addRecords'},
                    {id:3,name:'removeRecord'},
                    {id:4,name:'setRecords'},  
                ]

      var widgetDefinition = {DEI: [{'name':'resourceLink','displayName':'Dataset record id','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: w_actions,dataSource:true,widgetLabel: 'Add dataset record',widgetName: 'addResourceWidget',widgetId: $scope.fd.UuidRef,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resource_id:$scope.resourceDefinition.page_state_id,resourceDefId : $scope.fd.Related, output:out_fields,parentResourceId:$scope.fd.localVars.resourceDefinition.uid };
      
      $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
      $scope.fd.localVars.localId=$scope.fd.localVars.localWidgetId;
      $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
      
      if ($scope.resourceDefinition.showHidden==undefined) $scope.resourceDefinition.showHidden={}
	  
	  $scope.resourceDefinition.showHidden[$scope.fd.UuidRef] = true
      
      $scope.fd.localVars.showProperties=function(datasetMapperType,showPropertiesRight)
      {    
            if ($scope.fd.localVars.datasetMapperType==undefined) {
               $scope.fd.localVars.datasetMapperType = datasetMapperType;
            } else {
               if ($scope.fd.localVars.datasetMapperType==0 || $scope.fd.localVars.datasetMapperType!=datasetMapperType) 
                    $scope.fd.localVars.datasetMapperType = datasetMapperType;
               else 
                   $scope.fd.localVars.datasetMapperType=0;
            }
            if (showPropertiesRight) 	$scope.gsrvc.setFieldProperties($scope.fd);
            
      };
      
        
      
      $scope.fd.localVars.setField = function(form,name,value,msg)
      {
     				TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
      };
        
        
        let valueState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+'-'+$scope.fd.UuidRef,$scope.fd.PresentationId);
        let valueStateName = valueState.subject.name;
                

    let add_resource_record = function(data){
          
        let state = valueState.subject.getStateChanges
        if (state==undefined) state={}
        if (data?.action_index!=undefined) state['action_index'] = data.action_index
        valueState.subject.setStateChanges = state
        $scope.fd.localVars.AddResourceRecord(valueState,data?.action_index)
          
    };
      
    let action_add_resource_record = $scope.ksm.addAction(valueStateName,"addResourceRecord",add_resource_record);

    let add_record = function(data){
          
        let state = valueState.subject.getStateChanges
        if (state==undefined) state={}
        if (data?.action_index!=undefined) state['action_index'] = data.action_index
        valueState.subject.setStateChanges = state
        if ($scope.fd.Multiline)  $scope.fd.localVars.addRecordToMultiple(data.record)
          
    };
    let action_add_record = $scope.ksm.addAction(valueStateName,"addRecord",add_record);

    let remove_record = function(data){
          
            //find record to remove
            //splice from array
          
    };  
    let action_remove_record = $scope.ksm.addAction(valueStateName,"removeRecord",remove_record);


    
    let set_records = function(data){
        
        let recs,input_params,default_data
        if (data.in_data?.event_data?.state){
            recs = data.in_data?.event_data?.state
            input_params = data.in_data?.in_params
            
            if (typeof input_params == 'string') input_params = JSON.parse(input_params)
            else input_params = {}
            $scope.fd.localVars.dashboard.widgets.length=0
            $scope.formData[$scope.fd.UuidRef].length=0
            
            for (let i=0;i<recs.length;i++){
                default_data={}
               
                for (const [key, value] of Object.entries(input_params)) {
              
                        default_data[key] = recs[i][value]
                    
                }
                $scope.formData[$scope.fd.UuidRef].push([default_data])
                $scope.fd.localVars.dashboard.widgets.push({layout:[UtilityService.clone($scope.fd.FormDef[0])]})
            }
        }
        $scope.fd.localVars.start_widget()
          
    };
    let action_update_record = $scope.ksm.addAction(valueStateName,"setRecords",set_records);

    //add new record at the end of array
    $scope.fd.localVars.addRecordToMultiple = function(rec)  {
        if (Array.isArray($scope.formData[$scope.fd.UuidRef][0])){

            $scope.fd.localVars.dashboard.widgets.push({layout:[UtilityService.clone($scope.fd.FormDef[0])]})
            //here define the way and execute mapping of the selected record - ToDo (this not really working)
            $scope.formData[$scope.fd.UuidRef].push([{}])
            $scope.formData[$scope.fd.UuidRef][$scope.formData[$scope.fd.UuidRef].length-1][0][$scope.fd.Properties.FieldId]=rec.id
             
        }
    }
     $scope.fd.localVars.addManualRecordToMultiple = function()  {
        
            $scope.fd.localVars.dashboard.widgets.push({layout:[UtilityService.clone($scope.fd.FormDef[0])]})
            $scope.formData[$scope.fd.UuidRef].push([{}])
           
    }

         $scope.fd.localVars.removeManualRecordToMultiple = function(idx)  {
            
          /*
            for (const [key, value] of Object.entries($scope.fd.localVars.selectedRecords)) {
                if (value)
                    {
                        $scope.fd.localVars.dashboard.widgets.splice(key,1)
                        $scope.formData[$scope.fd.UuidRef].splice(key,1)
                    }
            }
           */
              $scope.fd.localVars.dashboard.widgets.splice(idx,1)
              $scope.formData[$scope.fd.UuidRef].splice(idx,1)
    }
    $scope.fd.localVars.setSelectedResource = function(id,saved)  {

            if ($scope.fd.localVars.selectedResourceItem==undefined) $scope.fd.localVars.selectedResourceItem={};
            let pos = $scope.fd.localVars.resourceList.map(function(e) { return e.id; }).indexOf($scope.fd.Related);
            if (pos>=0 && $scope.fd.localVars.selectedResourceItem.id===undefined) 
            {
                $scope.fd.localVars.selectedResourceItem = $scope.fd.localVars.resourceList[pos]
               
            } 

            $scope.fd.localVars.getPublishedResourceById(id,saved);
    }

    $scope.fd.localVars.getPublishedResourceById = function(id,saved) 
 
    {
            let pos
            if (saved && $scope.fd.FormDef!==undefined && $scope.fd.FormDef!==null)
              { 
                    pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                    if (pos>=0){
                        $scope.fd.localVars.selectedResourceItem.name = $scope.fd.localVars.publishedResourceList[pos].name;
                        $scope.fd.localVars.selectedDataset = $scope.fd.localVars.publishedResourceList[pos]
                    }
           
                    $scope.fd.localVars.selectedResourceItem_c=$scope.fd.localVars.selectedResourceItem;
                    if ($scope.formDefinition) $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
                    else if (!$scope.fd.Multiline) $scope.fd.localVars.dashboard.widgets.layout = UtilityService.clone($scope.fd.FormDef)
                    else $scope.fd.localVars.dashboard.widgets.push({layout:[UtilityService.clone($scope.fd.FormDef[0])]})
                    $scope.fd.localVars.formLoaded=true;

              }else{
                  pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                  if (pos>=0){
                    
                    ResourcesDataService.GetPublishedResourceById(id).then(function (data) {

                        let jsonFile=$scope.fd.Related+"-v"+data.data.Version+".json"
                        ResourcesDataService.fetchJsonFile(jsonFile).then(function (widgetDef) {

                            if (widgetDef.status)
                            {
                                $scope.fd.localVars.formLoaded=true;
                                MessagingService.addMessage(widgetDef.data,'error');
                            }else{

                                $scope.fd.localVars.selectedPublishedResource = $scope.fd.localVars.publishedResourceList[pos];
                                $scope.fd.FormDef = widgetDef.Form
                                if ($scope.formDefinition) $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
                                else if (!$scope.fd.Multiline) $scope.fd.localVars.dashboard.widgets.layout = UtilityService.clone($scope.fd.FormDef)
                                else $scope.fd.localVars.dashboard.widgets.push({layout:[UtilityService.clone($scope.fd.FormDef[0])]})
                                if ($scope.fd.localVars.selectedResourceItem_c!==undefined)
                                {
                                    $scope.fd.Parameters.PublishedResourceId=$scope.fd.localVars.selectedResourceItem_c.id;
                                    $scope.fd.Parameters.PublishedResourceVersion=$scope.fd.localVars.selectedResourceItem_c.Version;
                                
                                }else MessagingService.addMessage('Error - published dataset not selected ktTAskAdd','error')
              
                                $scope.fd.localVars.formLoaded=true;
                            }
                        },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                $scope.fd.localVars.formLoaded=true;
                   
                        }); 
                    },function(error){    
                          $scope.fd.localVars.formLoaded=true;
                          MessagingService.addMessage(error.msg,'error');
                    });

                }
            }
             
       
}
 

    if ($scope.fd.localVars.publishedResourceList==undefined) $scope.fd.localVars.publishedResourceList=[];
    
	var lang=$rootScope.globals.currentUser.lang;
                  
  
    if ($scope.fd.Related!="" && $scope.fd.Related!=undefined && $scope.fd.Related!=null)  {

            if ($scope.formDefinition) $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
            else if (!$scope.fd.Multiline) $scope.fd.localVars.dashboard.widgets.layout = UtilityService.clone($scope.fd.FormDef)
            else $scope.fd.localVars.dashboard.widgets.push({layout:[UtilityService.clone($scope.fd.FormDef[0])]})
            $scope.fd.localVars.formLoaded=true;
            
        }else $scope.fd.localVars.NoPublishedResourceMsg="Definition error --> Resource form not defined!"
  
              $scope.fd.localVars.prepareResourceData = function(resourceRecordId){

             $scope.fd.itemValue =  ResourcesDataService.prepareResourceWidgetData($scope.fd.localVars.dashboard.widgets.layout,resourceRecordId);
            }
          
           $scope.fd.localVars.processWidgetDependencies = function() { //-----  ktUploader  -----
              
           if ($scope.fd.tItemValue!=undefined) 
            for (var i=0;i< $scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=$scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = $scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<$scope.fd.tItemValue[i].DEI.length;j++) {
                        if (($scope.fd.tItemValue[i].DEI[j].name==linkedItem) && ($scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = $scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("view "+$scope.fd.PresentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             $scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj $scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                                for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    $scope.fd.localVars.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    $scope.resourceRecordId = $scope.fd.localVars.linkedResourceId;
                                  }
                                  if (data[k].name=='resourceId') $scope.fd.localVars.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                }
                          
     
                                    
                              }) //on_END
                        }//if
                    }//for j
                }//if

            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget

          if ($scope.fd.PresentationId==undefined || $scope.fd.PresentationId==null) $scope.fd.PresentationId=0;
          
          $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;

        $scope.fd.localVars.processTaskReturn = function(data)
        {
             if (data!=undefined){
                let rv
                if (Array.isArray(data))
                {
                 rv  = data
                }else rv =[data]

                  for(var i=0;i<rv.length;i++) {
                    
                    if ($scope.fd.PresentationId==rv[i].widgetId)
                    {
                      WidgetDataExchangeService.setData(rv[i]);
                      $scope.fd.localVars.setField($scope.fd.localVars.dashboard.widgets.layout,'ReadOnly',true); //set all elements read-only
                    }
                  }
            }
            
        }
        
        $scope.fd.localVars.ExtractIdFromRecord=function(record){

            let record_id

            if (record!==undefined)
            {   
                if (Array.isArray(record) && record.length>0)
                {
                    if ($scope.fd.localVars.TablePrefix+'_id' in record[0])
                    {
                        record_id=record[0][$scope.fd.localVars.TablePrefix+'_id']
                     
                    }else record_id = record[0].id

                }else{
                    if ($scope.fd.localVars.TablePrefix+'_id' in record)
                    {
                        record_id = record[$scope.fd.localVars.TablePrefix+'_id']
                     
                    }else record_id = record.id

                }
            }else record_id = null

            return record_id   
        }

        $scope.fd.localVars.processMappingData = function(){

            if ($scope.fd.localVars.mappingD2d){

                Object.keys($scope.fd.localVars.mappingD2d).forEach(function(key) {
                        
                        if ($scope.fd.Multiline){

                            for (let i=0;i<$scope.formData[$scope.fd.UuidRef].length;i++){
                                 $scope.formData[$scope.fd.UuidRef][i][0][key]=$scope.fd.localVars.mappingD2d[key]
                            }
                        }else{
                            $scope.formData[$scope.fd.UuidRef][0][key]=$scope.fd.localVars.mappingD2d[key]
                        }
                        
                    })
            }
        }

        $scope.fd.localVars.ProcessMapping = function(){

            let filter_data = {}
            if (!$scope.fd.localVars.mappingD2d){

                ResourcesDataService.processR2rMapping($scope.fd.UuidRef,$scope.resourceDefinition.uid,$scope.resourceDefinition.Version,$scope.fd.DatasetMapping,filter_data,$scope.resourceDefinition.page_instance_id,$scope.resourceDefinition.prev_page_instance_id).then(function(data) {
                    $scope.fd.localVars.mappingD2d = data.data

                    $scope.fd.localVars.processMappingData()

                

                    $scope.fd.localVars.widgetReady = true
                    
                },function(error){
                    MessagingService.addMessage(error.msg,'error');
                    $scope.fd.localVars.widgetReady = true
                });
            }else{
                 $scope.fd.localVars.processMappingData()
                 $scope.fd.localVars.widgetReady = true
            }
        }


      

        let wait_for_widget = function(data){

            $scope.fd.localVars.start_widget()
        }


        $scope.fd.localVars.start_widget = function()
        {
            if ($scope.fd.DatasetMapping?.length>0 && !$scope.formDefinition)
            {

              if (($scope.fd.Multiline && $scope.formData[$scope.fd.UuidRef].length) || !$scope.fd.Multiline) $scope.fd.localVars.ProcessMapping ()
            }else $scope.fd.localVars.widgetReady = true
        
        }



        if ($scope.fd.SrcWidgetId!=undefined && $scope.fd.SrcWidgetId!=null)
        
        {
           
                let dependent_field = "Field"+$scope.fd.UuidRef;
               // let subscribedSubject = $scope.fd.Parameters.SrcWidgetType+"ValueStateName"+$scope.fd.SrcWidgetId;
                let subscribedSubject = $scope.resourceDefinition.page_state_id+"-"+$scope.fd.SrcWidgetId;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",wait_for_widget);
            
        }else 

        {
            if (!$scope.fd.Parameters?.events?.length) $scope.fd.localVars.start_widget()
        }


        $scope.fd.localVars.AddResourceRecord = function(valueStateParam,act_idx){
            let fdata = $scope.formData[$scope.fd.UuidRef][0]

            if ($scope.fd.Multiline) fdata = $scope.formData[$scope.fd.UuidRef]
         
        ResourcesDataService.addResourceRecord($scope.resourceDefinition.uid,$scope.fd.UuidRef,fdata,$scope.resourceDefinition.ExeVersion,$scope.resourceDefinition.page_instance_id,$scope.resourceDefinition.prev_page_instance_id).then(function(data) {

                                let response = data.data
                                 let rmsg = response.ResponseMsg
                                if (!rmsg) rmsg="Record created successfuly!"
                                MessagingService.addMessage(rmsg,'success');

                                $scope.fd.localVars.resourceRecordId = $scope.fd.localVars.ExtractIdFromRecord(response.record)
                                //$scope.formData[$scope.fd.PresentationId][0] = response.record
                                WidgetDataExchangeService.setData({DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.fd.localVars.resourceRecordId}]}],
                                    actions: [{name:'PrepareData',status:false}],

                                    name: 'addResourceWidget',widgetId: $scope.fd.PresentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,

                                    taskId:  $scope.lTaskId,resource_id:$scope.resourceDefinition.page_state_id,resourceDefId : $scope.fd.Related, output:out_fields});
                                    
                                valueStateParam.subject.notifyObservers("addResourceRecord");
                                $scope.ksm.executeAction(valueStateName,"valueChanged", {datasetDefId:$scope.fd.Related,recordId:$scope.fd.localVars.resourceRecordId,record:$scope.formData[$scope.fd.UuidRef][0]});

                                        
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                   $scope.ksm.executeAction(valueStateName,"valueChanged", {error:true});

                                
        });
    } 


        $scope.processEvents = function(data)
        {

            UtilityService.process_events($scope.resourceDefinition.page_state_id,valueState,data,$scope.fd.Parameters.events,$scope.ksm)
        }
        $scope.parentWidget=""
        //process events and execute actions
        if (!$scope.formDefinition && $scope.fd.Parameters?.events?.length>0) UtilityService.subscribe_2_events($scope.resourceDefinition.page_state_id,$scope.parentWidget,$scope.fd.Parameters.events,$scope,$scope.ksm)


         $scope.$on('InitiateTaskPostProcess'+$scope.resourceDefinition.transaction_id,function(event, data){
            $scope.fd.localVars.processTaskReturn(data)
              
         });
            
        $scope.$on('ExecuteTaskPostProcess'+$scope.resourceDefinition.task_execute_id,function(event, data){
              
            $scope.fd.localVars.processTaskReturn(data)
              
          });

        $scope.$on('ProcessWidgetPostProcess'+$scope.resourceDefinition.page_state_id,function(event, data){
              
            $scope.fd.localVars.processTaskReturn(data)
              
          });


                  let template;
                if ($scope.formDefinition) template = $templateCache.get('ktdirectivetemplates/ktTaskAddResource.html');
                else template = $templateCache.get('ktdirectivetemplates/ktTaskAddResourceExe.html');
          
                $element.append($compile(template)($scope)); 
      }];

  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

           
            
                let widgetState= scope.ksm.addSubject('taskWidget'+scope.fd.PresentationId,scope.fd.PresentationId);
                let widgetStateName = widgetState.subject.name;
                
                let clear_form = function()
                {
                  //scope.fd.localVars.dashboard.widgets.layout=[]
                  scope.fd.localVars.formLoaded=false
                  
                  $timeout(function(){
                    scope.fd.localVars.formLoaded=true;
                    scope.fd.localVars.dashboard.widgets.layout = UtilityService.clone(scope.fd.FormDef);
                    scope.formData[scope.fd.UuidRef]= [{}]
                    widgetState.subject.setStateChanges = scope.fd.PresentationId
                    widgetState.subject.notifyObservers("clearform");
                  })  
                
                
                 
               
                } 
                let action_form_cleared = scope.ksm.addAction(widgetStateName,"clearform",clear_form);


       
            }     
        }
  }

'use strict';

//import {Chart} from 'chart';
//import ChartDataLabels from 'chartjs-plugin-datalabels';


export function ktTaskChart () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktTaskChart.html',

             controller: function($scope,$rootScope,$timeout,UserService,ResourcesDataService,TaskDataService,MessagingService,GridsterService, UtilityService) {
                 
                 const numFormat = new Intl.NumberFormat("de-DE", {
                      maximumFractionDigits:  $scope.fd.Parameters.chartFractionDigits || 2,
                      minimumFractionDigits:  $scope.fd.Parameters.chartFractionDigits || 2
                    });


                
                 $scope.gsrvc= GridsterService;
                 if (!Array.isArray($scope.fd.selectedTasks)) $scope.fd.selectedTasks=[];
                if ($scope.resourceDefinition!=undefined)  {
                  $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
                }
                if ($scope.localVars == undefined) $scope.localVars={};
                 
                $scope.localObj={loadedTasks : []};
                $scope.localVars.taskItem = null;   
                $scope.localVars.selectedTask = {};
                $scope.localVars.showMenu = false
                if ($scope.fd.localVars == undefined) $scope.fd.localVars={};
                
                $scope.fd.localVars.dashboard = {
                    id: '1',
                    name: 'Home',
                    widgets: {}
				} ;
                 $scope.fd.localVars.taskItem = null;
                 $scope.fd.localVars.selectedTask = {};
                
                //MIGOR - PREBACIO IZ TASK ADD RESOURCE, TODO - IZBACITI VISAK
                $scope.taskId=$scope.resourceDefinition.ResourceDefId;
                if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
                if ($scope.taskId==undefined) $scope.taskId=0;
                $scope.fd.localVars.taskId=$scope.taskId;
                $scope.fd.ParentDatasetDefId=$scope.fd.Related;
                $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
                $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;
                $scope.source_type=$scope.resourceDefinition.source_type;
                $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
                $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
                $scope.formDefinition = $scope.resourceDefinition.form_definition;
                $scope.fd.localVars.resourceRecordId=0;
				
				if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4();
				$scope.fd.Parameters.UuidRef = $scope.fd.UuidRef;
                
                $scope.formDefinition = $scope.formDefinition || false
                $scope.taskInitiateId = $scope.taskInitiateId || 0
                $scope.taskExecuteId = $scope.taskExecuteId || 0
                $scope.prevTaskExeId = $scope.prevTaskExeId || 0
                    

                let hsvtorgb = function (h,s,v)   {                              
                          let f= (n,k=(n+h/60)%6) => v - v*s*Math.max( Math.min(k,4-k,1), 0);     
                          return   "#" + Math.round(f(5) * 255).toString(16) +  Math.round(f(3) * 255).toString(16) + Math.round(f(1) * 255) .toString(16) 
                }  

                let HSV2RGB = function(h, s, v) {
                    var r, g, b, i, f, p, q, t;
                    if (arguments.length === 1) {
                        s = h.s, v = h.v, h = h.h;
                    }
                    i = Math.floor(h * 6);
                    f = h * 6 - i;
                    p = v * (1 - s);
                    q = v * (1 - f * s);
                    t = v * (1 - (1 - f) * s);
                    switch (i % 6) {
                        case 0: r = v, g = t, b = p; break;
                        case 1: r = q, g = v, b = p; break;
                        case 2: r = p, g = v, b = t; break;
                        case 3: r = p, g = q, b = v; break;
                        case 4: r = t, g = p, b = v; break;
                        case 5: r = v, g = p, b = q; break;
                    }
                 return    "#" + Math.round(r * 255).toString(16) +    Math.round(g * 255).toString(16) + Math.round(b * 255) .toString(16) 
                }


                $scope.fd.localVars.toggleDropdown = function(){
                    $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
                }
                
                
                $scope.fd.localVars.copyToClipboard = function(text){
                    $scope.fd.localVars.copyUuid = true;
                    navigator.clipboard.writeText(text).then( 
                        () => {
                            $timeout(function(){$scope.fd.localVars.copyUuid = false;},1000);
                        },
                        () => {    /* clipboard write failed */
                            MessagingService.addMessage('Copy to clipboard failed','error');
                            $timeout(function(){$scope.fd.localVars.copyUuid = false;},1000);
                    });                    
                }
        
                
                
                var  process_observed_data = function(data) // called by datasetList (via KSM)
                {     
                    $scope.fd.localVars.errormsg =''
                  
                    if (data==undefined || data?.state?.sharedData?.analytics==undefined)
                        return       
                    if ($scope.fd.Parameters.CalculateFunction?.name==undefined)  
                        $scope.fd.localVars.errormsg='Calculate Function not defined!'
      
                    if ($scope.fd.Parameters.chartType==undefined) 
                            $scope.fd.Parameters.chartType='counter'
                    
                    $scope.fd.localVars.SelectedChartAnalytics = $scope.fd.Parameters.SelectedChartAnalytics || 0     
                    $scope.fd.localVars.analytics =  data?.state?.sharedData?.analytics[$scope.fd.localVars.SelectedChartAnalytics][$scope.fd.Parameters.CalculateFunction.name]
                    let analytics =  $scope.fd.localVars.analytics 
                     
                    //find minvalue and maxvalue of current Anaytics data
                    $scope.fd.localVars.maxvalue=-1
                    $scope.fd.localVars.minvalue=-1
                    Object.keys(analytics).forEach(function(key,index) { //must use inverse logic (undefined == number is always false)
                            if (!( analytics[key] < analytics[$scope.fd.localVars.maxvalue]))   $scope.fd.localVars.maxvalue = key
                            if (!( analytics[key] > analytics[$scope.fd.localVars.minvalue]))   $scope.fd.localVars.minvalue = key      
                    })
 
        
                        
                        
                    $scope.fd.localVars.data = Object.values(analytics)
                    $scope.fd.localVars.labels = Object.keys(analytics)
                    
                    if ($scope.fd.Parameters?.chartType?.name == 'pie' || $scope.fd.Parameters?.chartType?.name == 'doughnut' || $scope.fd.Parameters?.chartType?.name == 'polarArea') { 
                            let colors=[] 
                            let golden_ratio = 0.618033988749895
                            let h = Math.random() // use random start value
                             
                            for (let item of $scope.fd.localVars.data) { 
                                 h += golden_ratio
                                 h %= 1  
                                 colors.push( HSV2RGB( h, 0.5, 0.95) )   
                            }  
                            //convert colors to array 
                            $scope.fd.localVars.chartColors = [   { backgroundColor: colors }        ]
                            $scope.fd.localVars.data =     [    $scope.fd.localVars.data    ]                                   
                    }
                    
                    if ($scope.fd.Parameters?.chartType?.name!=undefined) 
                        $scope.fd.localVars.chartType =  $scope.fd.Parameters.chartType.name 
                    else 
                        $scope.fd.localVars.chartType =  $scope.fd.Parameters.chartType //counter does not have .name
                  
                    
                    $scope.fd.localVars.chartLabel =  $scope.fd.Parameters.chartLabel
                    $scope.fd.localVars.sharedData = data?.sharedData
                    //summing all values for counter
                    $scope.fd.localVars.countAll = $scope.fd.localVars.data.reduce((partialSum, a) => partialSum + a, 0); 
					
					
					// **** JSONE SCRIPTING ***** //
					//var template = {a: {$eval: "foo.bar"}};
                    //var template = "${foo.bar}"
                    //var template = "${minvalue} ${analytics[minvalue]}"   
                    //var context = {foo: {bar: "zoo"}}    
                    //$scope.fd.localVars.testjsone  = jsone(template, $scope.fd.localVars)  
					
                    $scope.fd.localVars.scriptValue  = jsone($scope.fd.Parameters.script || '',  $scope.fd.localVars)
                
                }; 
    
            $scope.fd.localVars.formatNumber = function(num)  {
                  let newFormat , useGrouping;
                  
                  useGrouping = $scope.fd.Parameters.useGroupingSeparator ;         
                  if ($scope.fd.Parameters.chartFractionDigits)
                         newFormat = new Intl.NumberFormat("de-DE", { useGrouping: useGrouping,  maximumFractionDigits: $scope.fd.Parameters.chartFractionDigits ,  minimumFractionDigits: $scope.fd.Parameters.chartFractionDigits  });
                    else 
                       newFormat = new Intl.NumberFormat("de-DE", { useGrouping: useGrouping });               

               try {
                    if ($scope.fd.Parameters.disableFormatting) 
                        return num          
                      else  
                        return newFormat.format(num)
                    
                    } catch (err) {
                            MessagingService.addMessage(error.msg,'error');
                            return 'Error!'
                    }
                    
            }
            
    
            $scope.fd.localVars.setSelectedDataset = function(id,saved)  {
            //debugger
              if ($scope.fd.localVars.selectedResourceItem==undefined) $scope.fd.localVars.selectedResourceItem={}
              //pick orher parameters from database
              $scope.fd.localVars.getPublishedResourceById(id,saved);
              
		}
        
        
        $scope.fd.localVars.getPublishedResourceById = function(id,saved) 
        {
            let pos
            if (saved && $scope.fd.FormDef!==undefined && $scope.fd.FormDef!==null)
              { 
                    pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                    if (pos>=0){
                        $scope.fd.localVars.selectedResourceItem.name = $scope.fd.localVars.publishedResourceList[pos].name;
                        $scope.fd.localVars.selectedDataset = $scope.fd.localVars.publishedResourceList[pos]
                    }
                    $scope.fd.localVars.selectedResourceItem.id = id;
                    $scope.fd.localVars.selectedResourceItem.name_confirmed = $scope.fd.localVars.selectedResourceItem.name +' ('+$scope.fd.localVars.selectedResourceItem.id +')'
                    $scope.fd.localVars.selectedResourceItem_c=$scope.fd.localVars.selectedResourceItem;
                    $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
                    $scope.fd.localVars.formLoaded=true;

              }else{
                  pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                  if (pos>=0){
                    ResourcesDataService.GetPublishedResourceById(id).then(function (data) {

                            $scope.fd.localVars.selectedDataset = $scope.fd.localVars.publishedResourceList[pos];
                            $scope.fd.localVars.dashboard.widgets.layout = data.data.Form
                            $scope.fd.FormDef = $scope.fd.localVars.dashboard.widgets.layout
                            if ($scope.fd.localVars.selectedResourceItem_c!==undefined)
                            {
                                $scope.fd.Parameters.PublishedResourceId=$scope.fd.localVars.selectedResourceItem_c.id;
                                $scope.fd.Parameters.PublishedResourceVersion=$scope.fd.localVars.selectedResourceItem_c.Version;
                                $scope.fd.Related=$scope.fd.localVars.selectedResourceItem_c.ResourceDefId; 
                                $scope.fd.localVars.freshForm=angular.copy($scope.fd.localVars.selectedResourceItem_c.Form)
                                $scope.fd.Related = $scope.fd.localVars.publishedResourceList[pos].ResourceDefId

                            }else MessagingService.addMessage('Error - published dataset not selected ktTAskAdd','error')
          
                            $scope.fd.localVars.formLoaded=true;

                        },function(error){    
                          MessagingService.addMessage(error.msg,'error');
                    });

                }
            }
                   
}
       

       $scope.fd.localVars.calculateFunctions= [ {id:1,name:'sum'},{id:2,name:'mean'},{id:3,name:'min'},{id:4,name:'max'},{id:5,name:'count'} ]     


// options.plugins.legend :  true


         $scope.fd.localVars.chartOptions= {
                    scale: {
                        ticks: {
                          //precision:  defined as parameter
                        }
                      }  ,
                         plugins: {  
                                    legend: {
                                        display: true,
                                        position: 'bottom',
                                        labels: {
                                            color: 'rgb(255, 99, 132)'
                                        }
                                    },                           
                                      labels: {  
                                        render: 'label',  // render 'label', 'value', 'percentage', 'image' or custom function, default is 'percentage
                                        precision: 0,// precision for percentage, default is 0
                                        showZero: false, //  whether or not labels of value 0 are displayed, default is false  
                                        fontSize: 14,   
                                        fontColor: '#000',// font color, can be color array for each data or function for dynamic color, default is defaultFontColor
                                        fontStyle: 'normal',   // font style, default is defaultFontStyle
                                        fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",         // font family, default is defaultFontFamily                  
                                        textShadow: false, // draw text shadows under labels, default is false
                                      }
                        }        
          }
          
          
          if ($scope.fd.Parameters.chartPrecision!=undefined && $scope.fd.Parameters.chartPrecision!=null ) {     
               $scope.fd.localVars.chartOptions.scale.ticks.precision = $scope.fd.Parameters.chartPrecision
          }
             
        
        if ($scope.fd.Parameters?.chartType?.name  === 'bar'  || $scope.fd.Parameters?.chartType?.name   === 'line' || $scope.fd.Parameters?.chartType?.name   === 'radar' || $scope.fd.Parameters?.chartType?.name   === 'bubble')  {
            $scope.fd.localVars.chartOptions.plugins.legend.display= false
        }

               /* $scope.fd.localVars.chartTypes = [
                            {id:1,name:'line'},{id:2,name:'bar'},{id:3,name:'radar'},
                            {id:4,name:'doughnut'},{id:5,name:'pie'},{id:6,name:'polarArea'},
                            {id:7,name:'bubble'} ,{id:99,name:'counter'}, {id:100, name:'script' }
                ]*/
				
				
						
				$scope.fd.localVars.chartTypes = [ //removed radar, bubble and script
                            {id:1,name:'line'},{id:2,name:'bar'}, 
                            {id:4,name:'doughnut'},{id:5,name:'pie'},{id:6,name:'polarArea'},
                            {id:99,name:'counter'} ,{id:100, name:'script'}
							 //{id:3,name:'radar'},{id:7,name:'bubble'}
                ]
            
			if ($scope.fd.Parameters.chartType==undefined) 
                            $scope.fd.Parameters.chartType=$scope.fd.localVars.chartTypes[1] //default = bar
						
                $scope.localVars.toggleDropdown = function()
                {
                           $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
                }
                              
                $scope.$on('InlineTaskClosed',function(event,data){
                    var taskId=data;
                    var pos = $scope.localObj.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
                    if (pos>=0) {
                      $scope.localObj.loadedTasks.splice(pos,1);  
                    }
                });
               
                if ($scope.fd.selectedTasks===undefined || $scope.fd.selectedTasks===null) $scope.fd.selectedTasks = [];
                
                if ($scope.fd.FormDef!=null && $scope.fd.FormDef!==undefined) {
                    $scope.fd.selectedTasks = $scope.fd.FormDef;
                }else   {
                    $scope.fd.FormDef = [];  
                } 
                
                let initiate_task = function(data)
                {
                    let loadTask=false;
                    $scope.localVars.taskLoaded = false;
                    if ($scope.localObj.loadedTasks.length>0)  {
                        if ($scope.localObj.loadedTasks[0].taskId.id != data.taskId) {
                            $scope.localObj.loadedTasks.length=0;
                            loadTask=true;
                        }
                    } else loadTask=true;
                    
                    $scope.localObj.loadedTasks.splice(0,1);
                         
                    for (let j = 0;j<$scope.fd.selectedTasks.length;j++) {
                            if ($scope.fd.selectedTasks[j].taskId.id==data.taskId) {
                                $timeout(function(){
                                    $scope.localObj.loadedTasks.push(data);
                                    $scope.localVars.taskLoaded = true;
                                });
                            }
                        }
                }
                                
                  //subscribe to events - initially only refresh data    
                        
                  if ($scope.resourceDefinition.page_state_id && $scope.fd.Parameters.widgetReference ) {
                        let whoami ='chart'+ $scope.fd.UuidRef  // valueStateName           
                        let subscribedSubject = $scope.resourceDefinition.page_state_id + '-'+ $scope.fd.Parameters.widgetReference //odabraniUUIDnekogELEMENTA    
                        let observer = $scope.ksm.subscribe(subscribedSubject,whoami,"valueChanged",process_observed_data);   
                  }
                   
               
               let lang=$rootScope.globals.currentUser.lang;  
               
               /* ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {                                   
                                $scope.fd.taskList = data.data;
                                $scope.fd.tasksLoaded=true;   
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });*/
                            

                $scope.localVars.taskIsOpen = function(taskId)
                  {
                    var isOpenPos = $scope.localObj.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (isOpenPos>=0) return true;
                    else return false;
                  }
                 
                 $scope.fd.pasteFromClipboard = function(task){
                        
                        navigator.clipboard.readText().then( (data) => {
                            /* clipboard successfully read */
                            $timeout(function(){task.widgetId = data})
                        },
                        () => {
                            /* clipboard read failed */
                            MessagingService.addMessage('Paste from clipboard failed','error');
                        });
                       
                }

                  
                $scope.fd.AddTaskToList = function ()
                {
                    $scope.fd.selectedTasks.push({widgetId:null,taskId:null});
                }
                  
                $scope.fd.ConfirmTaskList = function ()
                {
                     $scope.fd.FormDef = $scope.fd.selectedTasks;
                     $scope.fd.showConfirmed=true;
                     $timeout(function(){$scope.fd.showConfirmed=false},5000);
                }
                
                $scope.fd.RemoveTaskFromList = function (index){
                  
                   if (index>=0){
                             $scope.fd.selectedTasks.splice(index,1);         
                   }    
                }
          
          
                 $scope.localVars.saveTaskToResource = function(tdid,tei,datasetDefId,datasetRecordId){
                          TaskDataService.saveTaskToResource(tei,datasetDefId,datasetRecordId,$scope.fd.presentationId).then(function(data) {
                                                    
                              $state.go('app.navbar.tasks.initiate',{id: tdid,fromStateName:$state.current.name,fromStateParams:$state.params,outcome_id:0,prev_task_execute_id:tei});
    
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
             }
             
             
           $scope.fd.localVars.showProperties = function(datasetMapperType,showPropertiesRight)
          {
               //debugger
                if ($scope.fd.localVars.datasetMapperType==undefined)
                {
                   $scope.fd.localVars.datasetMapperType = datasetMapperType;
                }else
                {
                   if ($scope.fd.localVars.datasetMapperType==0 || $scope.fd.localVars.datasetMapperType!=datasetMapperType) 
                        $scope.fd.localVars.datasetMapperType = datasetMapperType;
                   else 
                       $scope.fd.localVars.datasetMapperType=0;
                }
               
                 
                if (showPropertiesRight) $scope.gsrvc.setFieldProperties($scope.fd);
           
                if ($scope.fd.localVars.dashboard != undefined)  {
                    //debugger
                     $scope.fd.localVars.fieldsList = []
                     $scope.fd.localVars.getFieldNamesFromObject($scope.fd.localVars.dashboard, $scope.fd.localVars.fieldsList)
                    
                }
          };
          
          
 
       $scope.fd.localVars.getFieldNamesFromObject = function (obj, fieldsList)   // find FieldNames in given Dashboard object recursively 
     {// fieldsList  is return variable (used for multiple select)
        //debugger
        var o = {};
        Object.keys(obj).forEach(function(key) {
          
            if ( (typeof(obj[key]) === 'object') && obj[key]    && key != 'NameField')  { //Do NOT parse 'NameField'  (we need it as it is)
              $scope.fd.localVars.getFieldNamesFromObject(obj[key], fieldsList)
            } 
            else {          
                    if (key == 'FieldName'  ) {  
                        //debugger
                        o[key]= obj[key];
                        }
                  
                    if (key == 'PresentationId' ) {
                        o['id']= obj[key];
                    }    
                    if (key == 'Label' ) {
                        o['name']= obj[key];
                    }    
                }
            }) ; 
        
        if ( o['FieldName'] && Object.keys(o).length > 0 ) fieldsList.push(o)   
    }; 

                
         },
             link: function (scope, elem, attrs) {
                
               
        }       
              
    }
  
};


/*
 $scope.fd.localVars.newdata =  {
        labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
        datasets: [{
            label: '# of Votes',
            data: [12, 19, 3, 5, 2, 3],
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)'
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1
        }]
    }*/
    
    
            /*
            $scope.fd.localVars.chartOptions.plugins.labels.generateLabels(chart) {
                
                    const datasets = chart.data.datasets;
                    const {labels: {usePointStyle, pointStyle, textAlign, color}} = chart.legend.options;
                    
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = toPadding(style.borderWidth);
                    return {
                            text: datasets[meta.index].label,
                            fillStyle: style.backgroundColor,
                            fontColor: color,
                            hidden: !meta.visible,
                            lineCap: style.borderCapStyle,
                            lineDash: style.borderDash,
                            lineDashOffset: style.borderDashOffset,
                            lineJoin: style.borderJoinStyle,
                            lineWidth: (borderWidth.width + borderWidth.height) / 4,
                            strokeStyle: style.borderColor,
                            pointStyle: pointStyle || style.pointStyle,
                            rotation: style.rotation,
                            textAlign: textAlign || style.textAlign,
                            borderRadius: 0,
                            datasetIndex: meta.index
                        };
               
            }
            */
            
            
'use strict';

export function ktTaskContainer () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktTaskContainer.html',
             /*scope: {
                inputParameters: '=',
                //selectedItem: '=',
                inputArray: '=',
            },*/
             controller: function($scope,$rootScope,$timeout,UserService,ResourcesDataService,TaskDataService,MessagingService,GridsterService) {
                
                 $scope.gsrvc= GridsterService;
                 if (!Array.isArray($scope.fd.selectedTasks)) $scope.fd.selectedTasks=[];
                if ($scope.resourceDefinition!=undefined)
                {
                  $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
                }
                if ($scope.localVars == undefined) $scope.localVars={};
                $scope.localObj={loadedTasks : []};
                $scope.localVars.taskItem = null;
                $scope.localVars.selectedTask = {};
                $scope.localVars.showMenu = false
      
                $scope.localVars.toggleDropdown = function(){
                           $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
                }
                
                               
                $scope.$on('InlineTaskClosed',function(event,data){
                    //var index=data;
                    //$scope.localObj.loadedTasks.splice(index,1);
                    var taskId=data;
                    var pos = $scope.localObj.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (pos>=0)
                    {
                      $scope.localObj.loadedTasks.splice(pos,1);  
                    }
                });
               
                if ($scope.fd.selectedTasks===undefined || $scope.fd.selectedTasks===null) $scope.fd.selectedTasks = [];
                
                if ($scope.fd.FormDef!=null && $scope.fd.FormDef!==undefined) {
                 $scope.fd.selectedTasks = $scope.fd.FormDef;
                }else
                {
                $scope.fd.FormDef = [];
                
                } 
                
                let initiate_task = function(data)
                {
                    let loadTask=false;
                    $scope.localVars.taskLoaded = false;
                    if ($scope.localObj.loadedTasks.length>0)
                    
                    {
                        if ($scope.localObj.loadedTasks[0].taskId.id != data.taskId)
                        {
                            $scope.localObj.loadedTasks.length=0;
                            loadTask=true;
                        }
                    }else loadTask=true;
                    
                    
                  //  if (loadTask)
                    //{
                        $scope.localObj.loadedTasks.splice(0,1);
                         
                        for (let j = 0;j<$scope.fd.selectedTasks.length;j++)
                        {
                        
                            if ($scope.fd.selectedTasks[j].taskId.id==data.taskId)
                            {
                            
                                $timeout(function(){
                                $scope.localObj.loadedTasks.push(data);
                                $scope.localVars.taskLoaded = true;
                                });
                            }
                        }
                    //}
                }
                
                for (let i = 0;i<$scope.fd.selectedTasks.length;i++)
                {
                    let subscribedSubject = 'initiateTaskStateName'+$scope.fd.selectedTasks[i].widgetId;
                    let dependent_field = 'taskContainer'+$scope.fd.UuidRef+$scope.resourceDefinition.transaction_id;
                    $scope.ksm.subscribe(subscribedSubject,dependent_field,"taskInitiated",initiate_task);  
                
                }
                
                /*
                  $scope.localVars.LoadTask=function(taskId,outcomeId,previousTask,openTaskType)
                  {
                    
                   
                        $scope.localObj.loadedTasks.splice(0,0,{'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                        
                    
                    
                  }
                  
                 */
                let lang=$rootScope.globals.currentUser.lang;    
                ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
                                                    
                                $scope.fd.taskList = data.data;
                                $scope.fd.tasksLoaded=true;
                                
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });

                   $scope.localVars.taskIsOpen = function(taskId)
                  {
                    var isOpenPos = $scope.localObj.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (isOpenPos>=0) return true;
                    else return false;
                  }
                 
                   $scope.fd.pasteFromClipboard = function(task){
                        
                        navigator.clipboard.readText().then( (data) => {
                            /* clipboard successfully read */
                            $timeout(function(){task.widgetId = data})
                        },
                        () => {
                            /* clipboard read failed */
                            MessagingService.addMessage('Paste from clipboard failed','error');
                        });
                       
                }

                  
                $scope.fd.AddTaskToList = function (){
  
                    $scope.fd.selectedTasks.push({widgetId:null,taskId:null});
     
                }
                  
                   $scope.fd.ConfirmTaskList = function (){
                     $scope.fd.FormDef = $scope.fd.selectedTasks;
                     $scope.fd.showConfirmed=true;
                     $timeout(function(){$scope.fd.showConfirmed=false},5000);
                   }
                   $scope.fd.RemoveTaskFromList = function (index){
                 
                  
                   if (index>=0){
             
                             $scope.fd.selectedTasks.splice(index,1);
                                  
                   }
                            
                    
                 }
          
          
                 $scope.localVars.saveTaskToResource = function(tdid,tei,datasetDefId,datasetRecordId){
                          TaskDataService.saveTaskToResource(tei,datasetDefId,datasetRecordId,$scope.fd.presentationId).then(function(data) {
                                                    
                              $state.go('app.navbar.tasks.initiate',{id: tdid,fromStateName:$state.current.name,fromStateParams:$state.params,outcome_id:0,prev_task_execute_id:tei});
                                                             
                                
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
             }
             
                
                },
             link: function (scope, elem, attrs) {
                
               
        }       
              
    }
  
};
'use strict';

export function ktTaskDatasetList ($rootScope,MessagingService,TaskDataService,ResourcesDataService,$timeout,WidgetDataExchangeService,$q,KatalyoStateManager,UtilityService) {
   
    var controller = ['$scope', '$uibModal','$stateParams','$timeout','CodesService','ResourcesDataService','$rootScope','ProcessingService','WidgetDataExchangeService','GridsterService','UtilityService', 'MessagingService','CODES_CONST','TaskDataService','KatalyoStateManager','$q','$filter','$templateCache','$compile','$element',
                      function ($scope,$uibModal,$stateParams,$timeout,CodesService,ResourcesDataService,$rootScope,ProcessingService,WidgetDataExchangeService,GridsterService, UtilityService, MessagingService,CODES_CONST,TaskDataService,KatalyoStateManager,$q,$filter,$templateCache,$compile,$element) {
      
    if ($scope.fd.localVars===undefined) $scope.fd.localVars={}

    $scope.fd.localVars.datasetlistlinked= false
    $scope.CTRL='ktTaskDatasetList'
    $scope.gsrvc=GridsterService;
    $scope.fd.localVars.datasetMapperType=0;
    $scope.fd.localVars.InitialLoad=true;
    
    $scope.fd.localVars.tablePosition = $element
    
    $scope.fd.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_; 
    $scope.fd.localVars.searchFormDownloaded = false;
    $scope.fd.localVars.showSearchFilters=true;
    $scope.fd.localVars.resourceDataDownloaded = false;
    $scope.fd.localVars.hidePopulateMethod=true
    $scope.fd.PopulateMethod="M"
    $scope.fd.localVars.loadingParams = true
    $scope.fd.localVars.resourceTypesList=[{type:'dataset',name:'Dataset'},{type:'file',name:'File'},{type:'counter',name:'Counter'}]
    $scope.fd.localVars.widgetState={};
    $scope.fd.localVars.widgetState.selectedItems=[];
    $scope.taskId=$scope.resourceDefinition.uid;
    $scope.fd.localVars.taskId=$scope.resourceDefinition.uid;
	
	
    $scope.fd.localVars.parentResourceId=$scope.resourceDefinition.uid;
    if ($scope.fd.localVars.parentResourceId==undefined) $scope.fd.localVars.parentResourceId = $scope.resourceDefinition.pageId
    if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.uid;
    if ($scope.taskId==undefined) $scope.taskId="0"
    $scope.resourceDefinition.resourceVersion = $stateParams.version;
	
	$scope.resourceDefinition.parentWidgetUid = $scope.fd.UuidRef

    if ($scope.resourceDefinition.resourceVersion==undefined) $scope.resourceDefinition.resourceVersion = $scope.resourceDefinition.Version || 0

    $scope.fd.localVars.taskId=$scope.taskId;
    $scope.fd.localVars.widgetType = 4;
    $scope.fd.localVars.results = {}
    $scope.fd.localVars.formParams={formViewType:1,showGridNavigation:false};
    $scope.fd.localVars.sqFormParams = {formViewType:1,showGridNavigation:false};
    $scope.fd.localVars.cardLayoutParams={formViewType:1,showGridNavigation:false};

    $scope.fd.localVars.TablePrefix = 'resource'+$scope.fd.Related
               
    $scope.fd.localVars.parentDatasetDefId=$scope.fd.Related;
    $scope.fd.localVars.animationsEnabled = true;
    if ($scope.fd.Parameters==undefined)  $scope.fd.Parameters = {}
    if ($scope.fd.Parameters.table==undefined) $scope.fd.Parameters.table={} 
    if ($scope.fd.Parameters.Analytics==undefined)  $scope.fd.Parameters.Analytics=[]
    if ($scope.fd.Parameters.SelectedResourceType==undefined)   $scope.fd.Parameters.SelectedResourceType='dataset'

    
    if ($scope.fd.ParametersLang==undefined)  $scope.fd.ParametersLang = {}
    if ($scope.fd.ParametersLang.PagerLabel1==undefined)   $scope.fd.ParametersLang.PagerLabel1='items per page | Page:'
    if ($scope.fd.ParametersLang.PagerLabel2==undefined)   $scope.fd.ParametersLang.PagerLabel2='of'
    if ($scope.fd.ParametersLang.PagerLabel3==undefined)   $scope.fd.ParametersLang.PagerLabel3='items'
    
    $scope.fd.localVars[$scope.fd.id] = $scope.fd.localVars
    
    $scope.fd.localVars.ShowAdvancedProperties = true
    $scope.fd.Parameters.ShowAdvancedProperties = true
    
    $scope.fd.Parameters.PagerLabel1 = $scope.fd.ParametersLang.PagerLabel1
    $scope.fd.Parameters.PagerLabel2 = $scope.fd.ParametersLang.PagerLabel2
    $scope.fd.Parameters.PagerLabel3 = $scope.fd.ParametersLang.PagerLabel3
    $scope.fd.Parameters.NoDataMsg = $scope.fd.ParametersLang.NoDataMsg

    if ($scope.fd.Parameters.PresentationType==undefined || $scope.fd.Parameters.PresentationType==null) $scope.fd.Parameters.PresentationType='table';
    $scope.fd.localVars.gridsterType=$scope.fd.Parameters.SelectedResourceType;
    $scope.fd.localVars.widgetState.itemValue = {val:null};
    if ($scope.fd.Multiline) $scope.fd.localVars.widgetState.itemValue.val = []
    $scope.fd.Parameters.Multiline = $scope.fd.Multiline

    $scope.fd.localVars.isCollapsed = $scope.fd.Parameters.SearchFormCollapsed;
    if ($scope.fd.localVars.isCollapsed==undefined) $scope.fd.localVars.isCollapsed =false;
    if ($scope.fd.localVars.isCollapsedData==undefined) $scope.fd.localVars.isCollapsedData =true;
    if ($scope.fd.localVars.isCollapsedActions==undefined) $scope.fd.localVars.isCollapsedActions =false;
    $scope.fd.localVars.showRelatedResources=false
    $scope.fd.localVars.relatedResourcesPublishedList={}
    $scope.fd.localVars.relatedResourcesColumns={}
    $scope.fd.localVars.resourceDefinition = $scope.resourceDefinition;
    $scope.fd.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: {}
				} ;
        
    $scope.fd.localVars.dashboardCard = {
  				id: '1',
  				name: 'Home',
  				widgets: {}
				} ;
    $scope.fd.localVars.gridOptionsResourceData = {
        //  columnDefs: colDefs,
        //enableGridMenu: true,
        showGridFooter: true,
        showColumnFooter: true,
        enableRowSelection: true,
        multiSelect: $scope.fd.Multiline,
      //  enableHorizontalScrollbar : 1,
       // enableVerticalScrollbar : 2,
        enableFiltering: true,
        fontSize: 12,
        cellPadding:30,
        enableRowHeaderSelection: false,
        enableColumnResizing: true,
        enableColumnReordering: true,
        //useExternalPagination: false,
        paginationPageSizes: [10, 25, 50,100,200,500,1000,5000,10000],
       // enablePaginationControls: true,
    };

    if ($scope.fd.Parameters.printable == true) {
        $scope.fd.localVars.gridOptionsResourceData.showColumnFooter = false;
        $scope.fd.localVars.gridOptionsResourceData.showColumnFooter = false;
        $scope.fd.localVars.gridOptionsResourceData.showGridFooter = false;
        $scope.fd.localVars.gridOptionsResourceData.enablePaginationControls = false; 
        $scope.fd.localVars.gridOptionsResourceData.enableVerticalScrollbar = 0;  
        $scope.fd.localVars.gridOptionsResourceData.enableHorizontalScrollbar = 0;  
        $scope.fd.localVars.gridOptionsResourceData.enableFiltering = false;  
        
    }
      
    var paginationOptions = {
        pageNumber: 1,
        pageSize: 10,
        sort: null
      };
      
       $scope.paginationOptions = {
        pageNumber: 1,
        pageSize: 10,
        sort: null
    };
    
      $scope.fd.localVars.gridOptionsRelated = {
         //  columnDefs: colDefs,
          enableGridMenu: true,
          showGridFooter: true,
          showColumnFooter: true,
          enableRowSelection: false,
          multiSelect: false,
          enableHorizontalScrollbar : 2, 
          nableVerticalScrollbar : 2,
          enableFiltering: true,
          enableRowHeaderSelection: true,
          enableColumnResizing: true,
          minRowsToShow: 2,
      }
      
      //MIGORCHART
          $scope.fd.localVars.calculateFunction= [ {id:1,name:'sum'},{id:2,name:'mean'},{id:3,name:'min'},{id:4,name:'max'},{id:5,name:'count'} ]
          $scope.fd.localVars.chartOptions= {
                                scales: {
                                    y: {
                                        beginAtZero: true
                                    },
                                    x: {
                                        beginAtZero: true
                                    },
                                }
                            },
           //$scope.fd.localVars.chartTypes = [{id:1,name:'line'},{id:2,name:'bar'},{id:3,name:'radar'},{id:4,name:'doughnut'},{id:5,name:'pie'},{id:6,name:'polarArea'},{id:7,name:'bubble'}]
		   $scope.fd.localVars.chartTypes = [{id:1,name:'line'},{id:2,name:'bar'},{id:4,name:'doughnut'},{id:5,name:'pie'},{id:6,name:'polarArea'}]
            
            
            
      //$scope.fd.PopulateType=1;
      $scope.fd.ParentDatasetDefId=$scope.fd.Related;
      $scope.resourceDefinition.ParentDatasetDefId = $scope.fd.ParentDatasetDefId
      $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
      $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;
      $scope.fd.localVars.source_type=$scope.resourceDefinition.source_type;
      $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
      $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
      $scope.fd.localVars.formDefinition = $scope.resourceDefinition.form_definition;
      $scope.fd.localVars.resourceRecordId = 0;
      $scope.fd.ParentElementId = 0;
      if ($scope.fd.localVars.formDefinition==undefined) $scope.fd.localVars.formDefinition = false;
      if ($scope.taskInitiateId==undefined) $scope.taskInitiateId =0;
      if ($scope.taskExecuteId==undefined) $scope.taskExecuteId =0;
      if ($scope.prevTaskExeId==undefined) $scope.prevTaskExeId =0;
    
      $scope.fd.localVars.widgetState.datasetRecordSelected = false;
      $scope.fd.localVars.widgetState.selectedDatasetRecordId = 0;      
      var out_fields = ['resourceRecordId'];

      if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
      $scope.fd.Parameters.UuidRef = $scope.fd.UuidRef

         let w_actions=[
                    {id:1,name:'refreshData'},
                    {id:2,name:'countSelected'},
                    {id:3,name:'countRecords'},
                    {id:4,name:'setFilter'},
                    {id:5,name:'unselectItems'},
					 {id:6,name:'selectAllItems'}
                ]

      //resourceLink
      var widgetDefinition = {DEI: [{'name':'resourceLinkDatasetList','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: w_actions,dataSource:true,widgetName: 'resourceListWidget',widgetId: $scope.fd.UuidRef,taskId:  $scope.lTaskId,
      resourceDefId : $scope.fd.Related, widgetLabel:'Resource list',parentResourceId:$scope.fd.localVars.parentResourceId,
      resourceRecordId:$scope.fd.localVars.resourceRecordId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,pageId:$scope.fd.localVars.parentResourceId,resource_id:$scope.resourceDefinition.page_state_id, output:out_fields };
      $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
      $scope.fd.localVars.LocalId=$scope.fd.localVars.localWidgetId;
      $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;

      
      $scope.gsrvc.parentResource[$scope.fd.UuidRef] = $scope.fd
      if ($scope.fd.localVars.formDefinition && $scope.fd.localVars.formParams.formViewType==1) $scope.fd.Parameters.BuildMode = true
      else $scope.fd.Parameters.BuildMode = false

      $scope.fd.localVars.showMenu = false
      

   


    let template;
    if ($scope.resourceDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktTaskDatasetList.html');
    else template = $templateCache.get('ktdirectivetemplates/ktTaskDatasetListExe.html');
          
    $element.append($compile(template)($scope)); 
   
   
        
}]; //controler_END

  return {
            restrict: 'A',
            //templateUrl: 'ktdirectivetemplates/ktTaskDatasetList.html',
            controller: controller,
            link: function (scope, elem, attrs) {
                scope.fd.localVars.datasetlistlinked = true
           

              var paginationOptions = {
                pageNumber: 1,
                pageSize: 10,
                sort: null
            };     
       
        
       scope.fd.localVars.toggleDropdown = function(){
           scope.fd.localVars.showMenu =  scope.fd.localVars.showMenu ? false: true 
       }
       
       
        scope.fd.localVars.setField = function(form,name,value,msg)
        {
                    TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
        };
        
        
        
        
        if (scope.fd.Parameters==undefined) 
            scope.fd.Parameters= {
                table: {}, 
                PresentationType:'table', 
                Analytics:[]
         };
        
        const subjectName= scope.resourceDefinition.page_state_id+"-"+scope.fd.UuidRef

        let valueState= scope.ksm.addSubject(subjectName,scope.fd.localVars.widgetState);
        const valueStateName = valueState.subject.name;
     

    scope.fd.localVars.clearDropdown = {}
    
    scope.fd.localVars.callClearDropdownFn=function(){

        if (scope.fd.localVars.clearDropdown.clearItems) scope.fd.localVars.clearDropdown.clearItems();
    }

    

         //**********************************************************
      //           GET RESOURCE DATA PAGINATED
      //**********************************************************      
    scope.fd.localVars.getResourceDataPaginated = function (urlNext,urlPrev,newPage,pageSize,getChildren) {
        
        if (scope.fd.localVars.gridOptionsResourceData.data==undefined) scope.fd.localVars.gridOptionsResourceData.data = [];
        
      
        
        if (Math.ceil(scope.fd.localVars.totalCount/pageSize)<newPage)
        {
          newPage = Math.ceil(scope.fd.localVars.totalCount/pageSize);
        }
         
        var lang = $rootScope.globals.currentUser.lang;
          
        if (pageSize==undefined)
         
        {
          scope.fd.localVars.widgetState.pageSize = scope.paginationOptions.pageSize;
          pageSize= scope.fd.localVars.widgetState.pageSize;
        }
        
        if (scope.fd.PopulateMethod=='M')
        {
          
           
           scope.ksm.executeAction(valueStateName,"valueChanged", scope.fd.localVars.widgetState);
           scope["datasetListSearchForm" + scope.fd.PresentationId]?.$setSubmitted()
           let is_valid = scope["datasetListSearchForm" + scope.fd.PresentationId]?.$valid
           //let is_valid = scope.datasetListSearchForm?.$valid
           let child = {}
           if (getChildren)
           {
            child.is_child = getChildren
            child.parent_resource_id = scope.fd.ParentDatasetDefId
            child.parent_record_id = scope.fd.localVars.ParentRecordId

           }
           if (is_valid)
           {
                 
                //scope.fd.localVars.gridOptionsResourceData.data.length=0;
                if (scope.fd.Multiline && scope.fd.localVars.widgetState.itemValue?.val?.length) scope.fd.localVars.callClearDropdownFn() //scope.fd.localVars.widgetState.itemValue.val.length=0
                else if (!scope.fd.Multiline && scope.fd.Parameters.PresentationType=='dropdown') scope.fd.localVars.widgetState.itemValue.val = null 
                scope.fd.localVars.resourceDataDownloading = true
                //if (scope.fd.Parameters.PresentationType=='dropdown') scope.fd.localVars.setDropdown(scope.fd.Parameters.ClientSideFilter, scope.fd.localVars.gridOptionsResourceData)
                //  ktTaskDatasetListFilter (resourceId,presentationId,taskId,filter,form_layout,columns_for_query,uid,ver,child) {
                
                TaskDataService.ktTaskDatasetListFilter(scope.fd.Related, scope.fd.PresentationId,scope.fd.localVars.parentResourceId,  scope.fd.localVars.widgetState.formData, scope.fd.localVars.dashboard.widgets.layout, scope.fd.localVars.columnsForQuery,scope.fd.UuidRef,scope.fd.Parameters.PublishedResourceVersion,scope.resourceDefinition.resourceVersion,child).then(
				
						function(data) {
                 
                           
                                    scope.fd.localVars.gridOptionsResourceData.columnDefs = data.data.columns?.columnsDef;
                                    //debugger //ktTaskDatasetList
                                   
                                   
                                    //if (scope.fd.GridState?.columnsDef?.length > 0)  
                                    //       scope.fd.localVars.gridOptionsResourceData.columnDefs = scope.fd.GridState.columnsDef
                 
                                    scope.fd.localVars.widgetState.sharedData = data.data
                                    scope.ksm.executeAction(valueStateName,"valueChanged", scope.fd.localVars.widgetState);
                                    
                                    scope.fd.localVars.gridOptionsResourceData.data = data.data.data;
                                    if (scope.fd.Parameters.PresentationType=='card') {
											scope.fd.localVars.gridOptionsResourceData.data = scope.fd.localVars.TransformDataForCard(data.data.data);
											scope.fd.localVars.dashboardCard.widgets.layout = scope.fd.FormDefSearch?.CardForm //MIGOR dodao jer se ne prikazuju kartice u tabu
											scope.fd.localVars.cardLayoutLoaded = true //MIGOR dodao jer se ne prikazuju kartice u tabu
									}
                                    //scope.fd.localVars.restoreGridState();
                                    scope.fd.localVars.nextPage = data.data.data.next;
                                    scope.fd.localVars.previousPage = data.data.data.previous;
                                    scope.fd.localVars.totalCount=data.data.data.count;
                                    scope.fd.localVars.widgetState.currentPage=1;
                                    if (scope.fd.localVars.totalCount>0 && scope.fd.localVars.widgetState.currentPage==0) scope.fd.localVars.widgetState.currentPage=1;
                                    scope.fd.localVars.numPages = Math.ceil(scope.fd.localVars.totalCount/scope.fd.localVars.widgetState.pageSize);
                                    
                                    scope.fd.localVars.gridOptionsResourceData.totalItems=scope.fd.localVars.totalCount;
                                    if (!scope.fd.localVars.formLoaded) scope.fd.localVars.formLoaded=true
                                    scope.fd.localVars.resourceDataDownloaded = true
                                    scope.fd.localVars.resourceDataDownloading = false
                                    scope.fd.localVars.InitialLoad = false

                                    if (scope.fd.Parameters.PresentationType=='dropdown') scope.fd.localVars.setDropdown(scope.fd.Parameters.ClientSideFilter, data.data)
                                        
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error'); 
                                   scope.fd.localVars.resourceDataDownloading = false
                             });
                }else{
                 MessagingService.addMessage(scope.fd.ErrorMsg +'('+scope.fd.UuidRef+')','warning');
                 $timeout(function(){scope.fd.localVars.resourceDataDownloading = false});
                }
         }
         else if (scope.fd.PopulateMethod=='A')
         {
          var task_instance=0;  
          if (scope.fd.localVars.formType=='i') task_instance = scope.taskInitiateId;
          else task_instance = scope.taskExecuteId;
          scope.fd.localVars.gridOptionsResourceData.data.length=0
          //if (scope.fd.Parameters.PresentationType=='dropdown') scope.fd.localVars.setDropdown(scope.fd.Parameters.ClientSideFilter, scope.fd.localVars.gridOptionsResourceData)
          if (scope.fd.Multiline && scope.fd.localVars.widgetState.itemValue?.val?.length) scope.fd.localVars.widgetState.itemValue.val.length=0
          scope.fd.localVars.resourceDataDownloading = true
          ResourcesDataService.getResourceDataPaginatedAuto(scope.fd.localVars.selectedResourceId,urlNext,urlPrev,newPage,pageSize,lang,scope.fd.PresentationId,task_instance,scope.fd.localVars.formType).then(function(data) {
                                      
                                    scope.fd.localVars.gridOptionsResourceData.data = data.data;
                                    scope.fd.localVars.restoreGridState();
                                  
                                    scope.fd.localVars.resourceDataDownloaded = true;
                                    scope.fd.localVars.resourceDataDownloading = false;
                                    scope.fd.localVars.nextPage = data.data.next;
                                    scope.fd.localVars.previousPage = data.data.previous;
                                    scope.fd.localVars.totalCount=data.data.count;
                                    scope.fd.localVars.widgetState.currentPage=newPage;
                                    scope.fd.localVars.numPages = Math.ceil(scope.fd.localVars.totalCount/pageSize);
                                    scope.fd.localVars.widgetState.pageSize = pageSize;
                                    scope.fd.localVars.gridOptionsResourceData.totalItems=scope.fd.localVars.totalCount;
                                    scope.fd.localVars.InitialLoad = false
                                    WidgetDataExchangeService.setData({
                                    DEI: [{name:'resourceLink',value:[{name:'resourceId',value:scope.fd.Related},{name:'resourceRecordId',value:scope.fd.localVars.widgetState.selectedDatasetRecordId}
                                    ,{name:'resourceRecordIds',value: null},{name:'resourceRecordsAll',value:scope.fd.localVars.gridOptionsResourceData.data}]}],widgetId: scope.fd.UuidRef,parentResourceId:$scope.fd.localVars.parentResourceId,task_execute_id:scope.taskExecuteId});
            
                                    $rootScope.$broadcast("StartTask"+scope.fd.PresentationId+"Completed",scope.fd.localVars.gridOptionsResourceData.data);
                                    if (scope.fd.Parameters.PresentationType=='dropdown') scope.fd.localVars.setDropdown(scope.fd.Parameters.ClientSideFilter, scope.fd.localVars.gridOptionsResourceData)
                                   
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');
                                    scope.fd.localVars.resourceDataDownloading = false;
                             });
          
         }

        }
        
           /* Get children for parent*/
        scope.fd.localVars.GetResourceDataForParent = function () 
        {   
              scope.fd.localVars.resourceDataDownloading = true
              var lang = $rootScope.globals.currentUser.lang;
               scope.fd.localVars.dashboard.widgets.layout = scope.fd.FormDefSearch?.SearchForm
                
               scope.fd.localVars.getResourceDataPaginated(scope.fd.localVars.nextPage,scope.fd.localVars.previousPage,scope.fd.localVars.widgetState.currentPage,scope.fd.localVars.widgetState.pageSize,true)
                /*
                ResourcesDataService.getResourceDataM2mFilter(scope.fd.PresentationId,scope.fd.ParentDatasetDefId,scope.fd.Related,scope.fd.localVars.ParentRecordId,scope.fd.localVars.widgetState.formData, scope.fd.localVars.dashboard.widgets.layout,scope.taskId,0,lang).then(function(data) {
                     
                                scope.fd.localVars.gridOptionsResourceData.data = data.data
                                scope.fd.localVars.gridOptionsResourceData.columnDefs = data.columnsDef
                                scope.fd.localVars.resourceDataDownloaded = true
                                scope.fd.localVars.resourceDataDownloading = false 
                                scope.fd.localVars.InitialLoad = false
                                scope.fd.localVars.formLoaded=true
                                
                                scope.fd.localVars.widgetState.sharedData = data
                                
                                scope.ksm.executeAction(valueStateName,"valueChanged", scope.fd.localVars.widgetState);
                                           
                },function(error){    
                    MessagingService.addMessage(error.msg,'error');
                     scope.fd.localVars.resourceDataDownloading = false 
                    
                                    });              
            }*/
        }

        //*********************** get state if exists********************************************
        //***************************************************************************************
        if (valueState.subject.currentStateIndex>=0 && !scope.fd.AutoSearch)
        {
            scope.fd.localVars.loadFromState=true;
            scope.fd.localVars.widgetState = valueState.subject.getState;
            scope.fd.localVars.dashboard.widgets.layout=scope.fd.localVars.widgetState.widgets;
            scope.fd.fItemValue = scope.fd.localVars.dashboard.widgets.layout;
            scope.fd.localVars.searchFormDownloaded = true;
            //scope.fd.localVars.setField(scope.fd.fItemValue,'Required',false);
            scope.fd.localVars.formLoaded=true;
            //scope.fd.Search = scope.fd.localVars.widgetState.formData;
            //scope.formData[scope.fd.PresentationId]=scope.fd.Search;
        }else
        
        {
          scope.fd.localVars.widgetState.formData=[{}];  
        }
        
        let value_changed = function(data){
            valueState.subject.setStateChanges = data;
            valueState.subject.notifyObservers("valueChanged");
        };
        
        let action_value_changed = scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
       
        let selection_changed = function(data){
            valueState.subject.setStateChanges = data;
            valueState.subject.notifyObservers("selectionChanged");
        };
        
        let action_selection_changed = scope.ksm.addAction(valueStateName,"selectionChanged",selection_changed);

        let apply_value = function(data) {
            scope.fd.localVars.widgetState.itemValue.val = data.state;
        }; 
       
        if (scope.fd.Parameters.DependentFieldId!=undefined && scope.fd.Parameters.DependentFieldId!=null) {
            if (scope.fd.Parameters.DependentFieldId!="") {
                let dependent_field = scope.fd.Parameters.DependentFieldId;
                
                let subscribedSubject = scope.fd.Parameters.DependentFieldType+"ValueStateName"+scope.fd.Parameters.DependentFieldId;
                let observer = scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
            }
        }
        

        let default_refresh_data = function(data)
        {
            valueState.subject.setStateChanges = data
                
            scope.fd.localVars.GetDatasetDataClick()
         
            valueState.subject.notifyObservers("refreshData",data)
        }
        
        let action_refresh_data = scope.ksm.addAction(valueStateName,"refreshData",default_refresh_data)
       scope.refreshData = default_refresh_data

       
        let count_selected = function(data)
        {

            //valueState.subject.setStateChanges = data

            let result
            
            result = scope.fd.localVars.widgetState.selectedItems.length
            
            if (scope.fd.localVars.widgetState.selectedItems.length>0){
                //apply filter
                let key,val
                let in_params = data['in_data']['in_params']
                if (in_params==undefined) in_params = "{}"
                let input = JSON.parse(in_params)

              

                if (Object.keys(input).length>0)
                {
                    result = Object.entries(input).map( ([key, val] = item) => {
                                
                           if (val=='currentUser()') val = $rootScope.globals.currentUser.userid
                           return scope.fd.localVars.widgetState.selectedItems.reduce((count, item) => (item[key] == val ? count + 1 : count), 0)
                                
                    });
                } 

            }
            let state = valueState.subject.getState
            if (result!=undefined) state['countSelected'] = result
            else state['countSelected'] = null
            valueState.subject.setStateChanges = state

            scope.fd.Parameters.events[data.event_index].actions[data.action_index].completed = true
            scope.fd.Parameters.events[data.event_index].actions[data.action_index].result = state['countSelected']
            scope.processEvents(state,false)
            //notify
            valueState.subject.notifyObservers("countSelected")
        }
        let action_count_records= scope.ksm.addAction(valueStateName,"countSelected",count_selected);

       scope.fd.localVars.showProperties=function(datasetMapperType,showPropertiesRight,propertyType)
       {
            //debugger
            if ( !scope.fd.localVars.datasetMapperType ) //set if not defined or zero
            {
               scope.fd.localVars.datasetMapperType = datasetMapperType;
            } else if (propertyType=='basic') {
               if (scope.fd.localVars.datasetMapperType==0 || scope.fd.localVars.datasetMapperType!=datasetMapperType) 
                    scope.fd.localVars.datasetMapperType = datasetMapperType;
               else 
                   scope.fd.localVars.datasetMapperType=0;
            }
            if (showPropertiesRight) scope.gsrvc.setFieldProperties(scope.fd);
            
            scope.fd.localVars.PropertyType =propertyType
        };
          

    scope.fd.localVars.processTableAction = function(resource, actionId){
        let btn = scope.fd.FormDef[actionId]
        if (btn.ResourceType=='task'){

            let pageState =  scope.ksm.getState(scope.resourceDefinition.page_state_id)
            let prev_task_execute_id = pageState.state.previousTask?.task_execute_id
            scope.fd.localVars.LoadTask(btn.id,0,prev_task_execute_id,btn.OpenTaskType)

        }

        if (btn.ResourceType=='page'){
            scope.fd.localVars.OpenPage(btn)

        }
    }

    // ****  MAIN smart table function for preparation and pagination ****
    
    
      scope.fd.localVars.getDataSmartTable = function(tableState, pageNumber,pageSize){
       
            //debugger  //debug getDataSmartTable (zapravo ktRefresh u smarttable widgetu)
            let deferred = $q.defer();    
            scope.resourceLoading=true;
            var lang=$rootScope.globals.currentUser.lang;
            var newPage
           
            
            if (pageNumber==undefined) pageNumber = scope.paginationOptions.pageNumber;
            if (pageSize==undefined) pageSize = scope.paginationOptions.pageSize;
            
            if (scope.fd.localVars.gridOptionsResourceData.data) {
                    scope.totalCount= scope.fd.localVars.gridOptionsResourceData.data.length
                    scope.paginationOptions.totalItemCount=scope.fd.localVars.gridOptionsResourceData.data.length
                    scope.paginationOptions.numberOfPages = Math.ceil(scope.paginationOptions.totalItemCount/pageSize);
            }

            if (scope.totalCount>0){
                if (Math.ceil(scope.totalCount/pageSize)<pageNumber)
                    newPage = Math.ceil(scope.totalCount/pageSize);
            }
            
             if (scope.fd.localVars.gridOptionsResourceData.data) 
                    scope.fd.localVars.results = {results : scope.fd.localVars.gridOptionsResourceData.data.slice( (pageNumber -1) * pageSize, pageNumber * pageSize) }
             else 
                    scope.fd.localVars.results = {}     
             scope.fd.localVars.results.columns=scope.fd.localVars.gridOptionsResourceData.columnDefs
             //scope.nextPage = data.data.next;
             //scope.previousPage = data.data.previous;
             scope.fd.localVars.currentPage=pageNumber;
             scope.fd.localVars.results.pageSize = pageSize;
             scope.fd.localVars.results.numberOfPages = scope.paginationOptions.numberOfPages;
             scope.fd.localVars.results.count =   scope.totalCount
             
             scope.fd.localVars.widgetState.currentPage = scope.fd.localVars.currentPage;
             scope.fd.localVars.widgetState.pageSize = scope.fd.localVars.results.pageSize;
             
             //scope.ksm.executeAction(valueStateName,"valueChanged", scope.fd.localVars.widgetState); //TODO - provjeriti jel ovo treba otkomentirati
             if (!scope.fd.localVars.loadFromState) scope.fd.localVars.resetSelection();
             deferred.resolve({data: scope.fd.localVars.results});
            
            return deferred.promise;
      };

          //MIGOR TODO
        scope.fd.localVars.rowSelectionChanged = function (row) {


                scope.fd.localVars.widgetState.selectedDatasetRecordId = 0
                  
                  // find "selectedDatasetRecordId"
                let extDataSourceIdName, newselectedId
                extDataSourceIdName='id';
                 // find ID for clicked row
                  if (scope.fd.localVars.widgetState?.resourceWidgetDefinition?.Parameters?.extDataSourceLink != undefined) 
                        extDataSourceIdName = scope.fd.localVars.widgetState.resourceWidgetDefinition.Parameters.extDataSourceLink + "_id"
                  if (  row.hasOwnProperty(extDataSourceIdName) ) {
                       newselectedId = row[extDataSourceIdName]
                       if (newselectedId==null) 
                       {
                        newselectedId = row[scope.fd.localVars.TablePrefix+'_'+extDataSourceIdName]

                       }
                  }else{

                    newselectedId = row[scope.fd.localVars.TablePrefix+'_'+extDataSourceIdName]
                  }
                    
                  //debugger //ktTaskDatasetList
                 //already selected
                 if ( row.isSelected == false)    {
                       //unselect and remove from selection 
                       if ( newselectedId > 0  && scope.fd.Multiline) {        
                                let pos =  scope.fd.localVars.widgetState.selectedItems.indexOf(  newselectedId )
                                if (pos != -1)  scope.fd.localVars.widgetState.selectedItems.splice(pos,1)
                       }else if (!scope.fd.Multiline)  scope.fd.localVars.widgetState.selectedItems.length=0 
                 } else 
                     if (newselectedId) {
                        scope.fd.localVars.widgetState.selectedDatasetRecordId = newselectedId;
                        if (scope.fd.Multiline == true) scope.fd.localVars.widgetState.selectedItems.push(newselectedId)
                            else scope.fd.localVars.widgetState.selectedItems =[newselectedId]

                        //scope.fd.actionsPosition = "position:absolute;left:"+event.clientX+"px;top:"+event.clientY+"px"
     

                    }

                  scope.fd.localVars.widgetState.datasetRecordSelected = row.isSelected;
                  scope.fd.localVars.widgetState.selectedResourceRecord = row
                  scope.fd.localVars.prevTaskPackage ={resourceDefId:scope.fd.Related,records: scope.fd.localVars.widgetState.selectedItems}
            


                  WidgetDataExchangeService.setData({
                      DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:scope.fd.Related},{name:'resourceRecordId',value:scope.fd.localVars.widgetState.selectedDatasetRecordId}
                        //    ,{name:'resourceRecordIds',value:gridApi.selection.getSelectedRows()},{name:'resourceRecordsAll',value:scope.fd.localVars.gridOptionsResourceData.data}]}],
                          ,{name:'resourceRecordIds', value: scope.fd.localVars.widgetState.selectedItems},{name:'resourceRecordsAll',value:scope.fd.localVars.gridOptionsResourceData.data}]}],
                        
                            parentResourceId:scope.fd.localVars.parentResourceId,widgetId: scope.fd.UuidRef,resource_id:scope.resourceDefinition.page_state_id,task_execute_id:scope.taskExecuteId,resource_id:scope.resourceDefinition.page_state_id});
           

                  scope.ksm.executeAction(valueStateName,"selectionChanged", scope.fd.localVars.widgetState.selectedItems);
       };
    scope.fd.localVars.multipleSelect = function(row,selectAll,deselectAll){

        if (selectAll) {
            scope.fd.localVars.widgetState.selectedItems = angular.copy(scope.fd.localVars.gridOptionsResourceData.data)
               for(let i=0;i<scope.fd.localVars.gridOptionsResourceData.data.length;i++)
            {
                scope.fd.localVars.gridOptionsResourceData.data.isSelected=true
            }
        }
        else if (deselectAll)
        {
            scope.fd.localVars.widgetState.selectedItems.length=0
            for(let i=0;i<scope.fd.localVars.gridOptionsResourceData.data.length;i++)
            {
                scope.fd.localVars.gridOptionsResourceData.data.isSelected=false
            }

        }else{
              let extDataSourceIdName, newselectedId
                extDataSourceIdName='id';
                 // find ID for clicked row
                  if (scope.fd.localVars.widgetState?.resourceWidgetDefinition?.Parameters?.extDataSourceLink != undefined) 
                        extDataSourceIdName = scope.fd.localVars.widgetState.resourceWidgetDefinition.Parameters.extDataSourceLink + "_id"
                  if (  row.hasOwnProperty(extDataSourceIdName) ) {
                       newselectedId = row[extDataSourceIdName]
                       if (newselectedId==null) 
                       {
                        newselectedId = row[scope.fd.localVars.TablePrefix+'_'+extDataSourceIdName]

                       }
                  }else{

                    newselectedId = row[scope.fd.localVars.TablePrefix+'_'+extDataSourceIdName]
                }

            if (row.isSelected) scope.fd.localVars.widgetState.selectedItems.push(row)
            else if (row.isSelected===false) {
                const objWithIdIndex = scope.fd.localVars.widgetState.selectedItems.findIndex((x) =>  x[scope.fd.localVars.TablePrefix+'_'+extDataSourceIdName] === newselectedId)
                scope.fd.localVars.widgetState.selectedItems.splice(objWithIdIndex, 1);
            }
        }
        scope.ksm.executeAction(valueStateName,"selectionChanged", scope.fd.localVars.widgetState.selectedItems);
    }
    scope.fd.localVars.dropdownSelectionChanged = function (item,model) {

                                 
                scope.fd.localVars.widgetState.selectedDatasetRecordId = 0
                   
                scope.fd.localVars.widgetState.selectedItems=item
                    
                scope.fd.localVars.widgetState.datasetRecordSelected = true;
                scope.fd.localVars.widgetState.selectedResourceRecord = item
                scope.fd.localVars.prevTaskPackage ={resourceDefId:scope.fd.Related,records: scope.fd.localVars.widgetState.selectedItems}
                  
                WidgetDataExchangeService.setData({
                      DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:scope.fd.Related},{name:'resourceRecordId',value:scope.fd.localVars.widgetState.selectedDatasetRecordId}
                        //    ,{name:'resourceRecordIds',value:gridApi.selection.getSelectedRows()},{name:'resourceRecordsAll',value:scope.fd.localVars.gridOptionsResourceData.data}]}],
                          ,{name:'resourceRecordIds', value: scope.fd.localVars.widgetState.selectedItems},{name:'resourceRecordsAll',value:scope.fd.localVars.gridOptionsResourceData.data}]}],
                        
                            parentResourceId:scope.fd.localVars.parentResourceId,widgetId: scope.fd.UuidRef,resource_id:scope.resourceDefinition.page_state_id,task_execute_id:scope.taskExecuteId,resource_id:scope.resourceDefinition.page_state_id});
                
                scope.ksm.executeAction(valueStateName,"selectionChanged", scope.fd.localVars.widgetState);
       };

    
    
    scope.fd.localVars.resetSelection = function()
    {
         scope.fd.localVars.widgetState.selectedItems.length=0;
         scope.fd.localVars.widgetState.selectedDatasetRecordId = 0;
         scope.fd.localVars.widgetState.datasetRecordSelected = false;
        
    }
        
    let process_form_change = function(data)
    { 
        if (data.state!=undefined)
        {
            scope.fd.Search = scope.fd.localVars.widgetState.formData;
            if (scope.fd.Parameters.PresentationType=='dropdown') scope.fd.localVars.getDatasetDataList(scope.fd.Parameters.ClientSideFilter,true);
            else scope.fd.localVars.getResourceDataPaginated(scope.fd.localVars.nextPage,scope.fd.localVars.previousPage,1,scope.fd.localVars.widgetState.pageSize);               
        }             
    };
        
    //subscribe to events - initially only refresh data
   
    let dependent_field2 = "Field"+scope.fd.PresentationId;
    let subscribedSubject2 = "task"+scope.resourceDefinition.transaction_id;
    let observer2 = scope.ksm.subscribe(subscribedSubject2,dependent_field2,scope.fd.Parameters.EventName,process_form_change);

        
     scope.fd.localVars.ProcessSearchForm=function (form){0
            
           if (form!=undefined){
            for(var i=0;i<form.length;i++) {
                
                    if ('ElementType' in form[i])
                    {
                     if (form[i].Parameters!=undefined)
                        {
                            if (form[i].AutoSearch)
                            {
                              if (form[i].ElementType == 'resource')
                              {
                                var pos = scope.fd.localVars.childWidgets.map(function(e) { return e.widgetId; }).indexOf(form[i].UuidRef);
                                if (pos<0) scope.fd.localVars.childWidgets.push({widgetId:form[i].UuidRef,processed:false})
                              }
                              //subscribe to change
                             
                                  if (form[i].Parameters.DependentFieldId!=undefined && form[i].Parameters.DependentFieldId!=null)
              
                                  {
                                      if (form[i].Parameters.DependentFieldId!="")
                                      {
                                          let dependent_field = valueStateName
                                          let subscribedSubject = scope.resourceDefinition.page_state_id+"-"+form[i].UuidRef;
                                          let subject = scope.ksm.addSubject(subscribedSubject,null);
                                          let observer = scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",process_form_change);
                                          let val = scope.ksm.getState(subscribedSubject);
                                          if (val.state!=null && val.state!=undefined) process_form_change(val.state);
                                      }
                                  }
                              }
                              
                        }
                      
                     }
                      if ('layout' in form[i])
                      {
                           
                       scope.fd.localVars.ProcessSearchForm(form[i].layout);
                      }
              }
          } 
           
      };
      
      scope.fd.localVars.SearchFormProcessed=false;
      
        
        scope.fd.localVars.setPresentationType = function(itype)  {

            scope.fd.Parameters.PresentationType=itype

            scope.fd.localVars.setSelectedResource(scope.fd.Parameters.PublishedResourceId,false);
            if (scope.fd.Parameters.PresentationType=='dropdown') scope.fd.localVars.getFormFields()
        }      

        scope.fd.localVars.setSelectedResource = function(id,saved)  {

            if (scope.fd.localVars.selectedResourceItem==undefined) scope.fd.localVars.selectedResourceItem={};
            let pos = scope.fd.localVars.resourceList.map(function(e) { return e.id; }).indexOf(scope.fd.Related);
            if (pos>=0 && scope.fd.localVars.selectedResourceItem.id===undefined) scope.fd.localVars.selectedResourceItem = scope.fd.localVars.resourceList[pos]
            scope.fd.localVars.getPublishedResourceById(id,saved);
        }
     
        scope.fd.localVars.getPublishedResourceById = function(id,saved) 
 
        {
            let pos
            let old_publish_id = scope.fd.Parameters.PublishedResourceId
           
                   
            if (saved && scope.fd.FormDefSearch?.SearchForm!==undefined && scope.fd.FormDefSearch?.SearchForm!==null && scope.fd.FormDefSearch?.SearchForm.length>0)
              { 
                    pos = scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                    if (pos>=0){
                        scope.fd.localVars.selectedPublishedResource = scope.fd.localVars.publishedResourceList[pos];

                        scope.fd.localVars.selectedResourceItem.name_confirmed = scope.fd.localVars.selectedResourceItem.name
                    }
                    
                    scope.fd.localVars.dashboard.widgets.layout = scope.fd.FormDefSearch?.SearchForm
                    scope.fd.localVars.formLoaded=true
					
                    if (scope.fd.Parameters.PresentationType=='card') 
                        {
                            scope.fd.localVars.dashboardCard.widgets.layout = scope.fd.FormDefSearch?.CardForm
                            scope.fd.localVars.cardLayoutLoaded = true
                        }

                    if (scope.fd.localVars.formDefinition) 
                    {
                        scope.fd.localVars.resourceDataDownloaded =true
                        if (scope.fd.GridState?.columnsDef===undefined || old_publish_id!=id) scope.fd.localVars.getDefaultColumnsDef()
                        else scope.fd.localVars.restoreGridState()
                    }
                    if (scope.fd.localVars.fieldsList == undefined) scope.fd.localVars.fieldsList = []
                    else scope.fd.localVars.fieldsList.length=0
                    //FOR ANAYLTICS
                    scope.fd.localVars.fieldsList = scope.fd.GridState?.columnsDef?.reduce((acc, current) => {
                          const x = acc.find(item => item.id === current.id);
                          if (!x) {
                            return acc.concat([current]);
                          } else {
                            return acc;
                          }
                        }, []).map( x =>  { 
                                if ( x.name && x.name.includes('.name') )   
                                    return  {'id':x.id, 'FieldName':x.name.slice(0, -5), 'name':x.displayName}  
                                else 
                                    return {'id':x.id, 'FieldName':x.name, 'name':x.displayName} 
                        });
                       /*
                       scope.fd.localVars.fieldsList = scope.fd.GridState?.columnsDef?.map( 
                            x =>  { 
                                if ( x.name && x.name.includes('.name') )   
                                    return  {'id':x.id, 'FieldName':x.name.slice(0, -5), 'name':x.displayName}  
                                else 
                                    return {'id':x.id, 'FieldName':x.name, 'name':x.displayName} 
                        })*/
                     // scope.fd.localVars.getFieldNamesFromObject(scope.fd.localVars.dashboard, scope.fd.localVars.fieldsList)

              }else{
                  pos = scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  scope.fd.FormDefSearch={}
                  if (pos>=0){
                    ResourcesDataService.GetPublishedResourceById(id).then(function (data) {

                        let jsonFile=scope.fd.Related+"-v"+data.data.Version+".json"
                        ResourcesDataService.fetchJsonFile(jsonFile).then(function (widgetDef) {

                                if (widgetDef.status)
                                {
                                    scope.fd.localVars.formLoaded=true;
                                    MessagingService.addMessage(widgetDef.data,'error');
                                }else{

                                    scope.fd.localVars.selectedResourceItem.Form = widgetDef.Form
                                    scope.fd.localVars.selectedPublishedResource = scope.fd.localVars.publishedResourceList[pos];
                                    //scope.fd.localVars.selectedResourceItem_c=scope.fd.localVars.selectedResourceItem;
                                    
                                    scope.fd.localVars.selectedResourceItem.name_confirmed = scope.fd.localVars.selectedResourceItem.name
                                    if (scope.fd.localVars.selectedResourceItem_c!==undefined)
                                    {
                                        scope.fd.Parameters.PublishedResourceId=scope.fd.localVars.selectedResourceItem_c.id;
                                        scope.fd.Parameters.PublishedResourceVersion=scope.fd.localVars.selectedResourceItem_c.Version;
                                        scope.fd.Related=scope.fd.localVars.selectedResourceItem_c.ResourceDefUid; 
                                        scope.fd.localVars.freshForm=angular.copy(scope.fd.localVars.selectedResourceItem_c.Form)
                                    }
                                    scope.fd.localVars.dashboard.widgets.layout = widgetDef.Form

                                    
                                    if (scope.fd.Parameters.PresentationType=='card') {
        								scope.fd.localVars.dashboardCard.widgets.layout = widgetDef.Form		
        							}
                                  
                                    scope.fd.FormDefSearch['SearchForm'] = scope.fd.localVars.dashboard.widgets.layout
                                    if (scope.fd.Parameters.PresentationType=='card') 
                                        {
                                            scope.fd.FormDefSearch['CardForm'] = scope.fd.localVars.dashboardCard.widgets.layout
                                            scope.fd.localVars.cardLayoutLoaded = true

                                        }
                                    if (scope.fd.GridState?.columnsDef===undefined || old_publish_id!=id) 
                                        scope.fd.localVars.getDefaultColumnsDef()
                                    else scope.fd.localVars.resourceDataDownloaded =true
                                   
                                    scope.fd.localVars.formLoaded=true;
                                    
                                    //MIGORCHART
                                    
                                     scope.fd.localVars.fieldsList = []
           
                                     scope.fd.localVars.getFieldNamesFromObject(scope.fd.localVars.dashboard, scope.fd.localVars.fieldsList)//MIGORCHART
                              }

                          },   function(err){    
                            MessagingService.addMessage(err.msg,'error');
                            scope.fd.localVars.formLoaded=true;
                        });
                             
                        },function(error){    
                            MessagingService.addMessage(error.msg,'error');
                            scope.fd.localVars.formLoaded=true;
                });

            }
            }
             
       
}    
      
      //needed for ANAYLTICS
       scope.fd.localVars.getFieldNamesFromObject = function (obj, fieldsList, parent,path)   {      // find FieldNames in given Dashboard object recursively . fieldsList  is return variable 
            var o = {};
            Object.keys(obj).forEach(function(key) {        
                if ( (typeof(obj[key]) === 'object') && obj[key]   && key != 'FormDefSearch' && key != 'NameField' && key != 'Parameters' && key != 'localVars' && key != 'FormDef' && key != 'publishedDataset')  { //Do NOT parse 'NameField'  (we need it as it is)
                    scope.fd.localVars.getFieldNamesFromObject( obj[key], fieldsList, parent, path + '/' + key)
                } 
                else { 
                        if (key == 'DirectiveName') { parent = obj['Related'] } 
                        
                        if (key == 'name') { 
                            if ( obj[key] && obj[key].includes('.name') ) 
                                o['FieldName'] = obj[key].slice(0, -5);
                            else o['FieldName'] = obj[key];         
                        }  
          
                        if (key == 'displayName') {  o['name'] = obj[key]  }                            
                        if (key == 'ElementType' || key == 'id'  ) { 
                            o[key]= obj[key];
                        }   
                    }
            }); 
     
             o['parent'] = parent 
             //o['path'] = path
            // if (path.includes('Gridstate') && path.includes('columnsDef')) {
              if (  o['ElementType'] && o['name'] && Object.keys(o).length > 0 ) {
                     // delete  o['ElementType']
                      //  delete  o['FieldName']
                      //   delete  o['parent']
                  if (fieldsList.find(x => x.id === o.id)===undefined) fieldsList.push(o)   
              }
        
    }; 

  
  
      scope.fd.localVars.GetDatasetData=function(data)
      {
            fromWidget = data.widgetId;
            var allProcessed=true;
            var pos = scope.fd.localVars.childWidgets.map(function(e) { return e.widgetId; }).indexOf(fromWidget);
            //if (pos<0) scope.fd.childWidgets.push({widgetId:fromWidget,processed:true});
            for (var i=0;i<scope.fd.localVars.childWidgets.length;i++)
              {
                
                if (scope.fd.localVars.childWidgets[i].widgetId == fromWidget) scope.fd.localVars.childWidgets[i].processed = true;
                if (!scope.fd.localVars.childWidgets[i].processed) allProcessed = scope.fd.localVars.childWidgets[i].processed;
              }
              // if (!scope.SearchFormProcessed) $timeout(function() {scope.GetDatasetData(fromWidget);},1000);
              if((scope.fd.Parameters.AutoSearchClient || scope.fd.localVars.loadFromState) && allProcessed && scope.fd.localVars.SearchFormProcessed) {
                    scope.fd.localVars.selectedResourceId=scope.fd.Related;
                    if (scope.fd.Parameters!=null && scope.fd.Parameters!=undefined)
                    {
                      if (scope.fd.Parameters.PresentationType=='dropdown') scope.fd.localVars.getDatasetDataList(scope.fd.Parameters.ClientSideFilter,false);
                      else scope.fd.localVars.getResourceDataPaginated(scope.fd.localVars.nextPage,scope.fd.localVars.previousPage,scope.fd.localVars.widgetState.currentPage,scope.fd.localVars.widgetState.pageSize);               
                      
                    }                   
                }
      };
    
      if (scope.fd.localVars!=undefined) scope.fd.localVars.childWidgets = [];
      else scope.fd.localVars = {childWidgets : []};
     // scope.uncaughtWidgets = [];
      var fromWidget=0;
   
       let search_form_ready = function(data)
        {
            scope.fd.localVars.GetDatasetData(data); 
        };
        
        let action_search_form_ready = scope.ksm.addAction(valueStateName,"SearchFormReady"+scope.taskExecuteId+scope.resourceDefinition.transaction_id,search_form_ready);
      /*   
      scope.$on('SearchFormReady'+scope.taskExecuteId+scope.resourceDefinition.transaction_id,function(event, data){   
      });     
     */
   
   //**********************************************************
    //           GET DATASET RELATED RECORDS
    //**********************************************************      
        scope.fd.localVars.getDatasetRelatedRecords = function (relatedDatasetId,recordId,modelId) {
  
  
         var lang = $rootScope.globals.currentUser.lang;
        
         ResourcesDataService.getResourceDataRelated(scope.fd.Related,recordId,relatedDatasetId,0,modelId,lang).then(function(data) {
                                //debugger //getDatasetRelatedRecords
                                     scope.fd.localVars.gridOptionsRelated.data = data.data;
                                     scope.fd.localVars.gridOptionsRelated.columnDefs = data.columnsDef;
                                     scope.fd.localVars.showGrid=true;
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
    
     //**********************************************************
    //           SELECT CARD ITEM
    //**********************************************************  

    scope.fd.localVars.selectCardItem = function(index){
        let value
        scope.fd.localVars.selectedDatasetRecordId=0
        if (scope.fd.localVars.widgetState.selectedCardIndex!=index)
        {
            scope.fd.localVars.widgetState.selectedCardIndex=index;
            value=scope.fd.localVars.gridOptionsResourceData.data[scope.fd.localVars.widgetState.selectedCardIndex][0];
            scope.fd.localVars.selectedDatasetRecordId = scope.fd.localVars.gridOptionsResourceData.data[index][0][scope.fd.localVars.TablePrefix+"_id"]
        }
        else
        {
            scope.fd.localVars.widgetState.selectedCardIndex=null;
            value = null;
        }
        //send data to package
         WidgetDataExchangeService.setData({
                  DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:scope.fd.Related},{name:'resourceRecordId',value:scope.fd.localVars.selectedDatasetRecordId}
                        ,{name:'resourceRecordIds',value:value},{name:'resourceRecordsAll',value:scope.fd.localVars.gridOptionsResourceData.data}]}],widgetId: scope.fd.UuidRef,parentResourceId:scope.fd.localVars.parentResourceId,task_execute_id:scope.taskExecuteId});
            
     };
       
 //**********************************************************
    //           GET DATASET SINGLE RECORD
    //**********************************************************      
      scope.fd.localVars.getDatasetSingleRecord = function (relatedDatasetId,recordId) {
  
         var lang = $rootScope.globals.currentUser.lang;
        
         ResourcesDataService.getResourceDataDirectFilter(relatedDatasetId,{id: recordId},scope.fd.GridState['columnsQuery']).then(function(data) {
                                
                                     scope.fd.localVars.gridOptionsRelated.data = data.data;
                                     scope.fd.localVars.gridOptionsRelated.columnDefs = scope.fd.GridState['columnsDef']
                               
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
    
        scope.$on('SearchFormReady'+scope.taskExecuteId+scope.fd.PresentationId,function(event, data1){
      
                                        scope.fd.localVars.GetDatasetData(data1); 
            
        });
        
    scope.fd.localVars.TransformDataForCard = function(data)
    {
        let newData = [];
        let newElement = [];
        for (let i=0;i<data.length;i++)
        {
        
        newElement.push(data[i]);
        newData.push(newElement);
        
        newElement = [];
        }
        return newData; 
    };


        let stringToPath = function (path) {
                        // If the path isn't a string, return it
                        if (typeof path !== 'string') return path;
                        var output = []; 
                        path.split('.').forEach(function (item, index) {
                            // Split to an array with bracket notation
                            item.split(/\[([^}]+)\]/g).forEach(function (key) {
                                if (key.length > 0)    output.push(key);// Push to the new array
                            });
                        });
                        return output;
         };
         
         
      let get = function (obj, path, def) {
                        /**
                         * If the path is a string, convert it to an array
                         * @param  {String|Array} path The path
                         * @return {Array}             The path array           */
                          
                        path = stringToPath(path);// Get the path as an array
                        var current = obj;// Cache the current object
                        // For each item in the path, dig into the object
                        for (var i = 0; i < path.length; i++) {
                            // If the item isn't found, return the default (or null)
                            if ( current[path[i]] === undefined || current[path[i]] === null ) return def;
                            current = current[path[i]]; // Otherwise, update the current  value
                        }
                        return current;
         };
                    
      let getItem = function (column,item)
      {  
            
            let def = null
            let val = get(item,column.name,def) ;
            if (val===null) return "∅";
            //debugger //smarttable //getItem
            
            if (column.cellFilter) {
                if (column.cellFilter.substring(0,4).trim()=="date") 
                        val = $filter(column.cellFilter.substring(0,4))(val,column.cellFilter.substring(6,column.cellFilter.length).trim());
            }
            
            if (column.NoOfDecimals){
                    val=  (val).toLocaleString(    navigator.language,          { minimumFractionDigits: column.NoOfDecimals }  ); 
            }
            
           
            return val;
      };
                    
      
    scope.fd.localVars.executeDatasetList = function(){   
        var lang=$rootScope.globals.currentUser.lang;
        if (scope.fd.PresentationId==null) {
            scope.fd.PresentationId = 0;
        }
        if (scope.fd.localVars.selectedResourceId==undefined) scope.fd.localVars.selectedResourceId = scope.fd.Related;
        if (scope.fd.localVars.widgetState.pageSize==undefined) scope.fd.localVars.widgetState.pageSize = paginationOptions.pageSize

        if (scope.fd.Multiline && scope.fd.localVars.widgetState.itemValue?.val?.length) scope.fd.localVars.widgetState.itemValue.val.length=0
        else if (!scope.fd.Multiline) scope.fd.localVars.widgetState.itemValue.val = null
        scope.fd.localVars.resourceDataDownloading = true
        
        TaskDataService.ktTaskDatasetList(scope.fd.Related,scope.fd.PresentationId,scope.fd.localVars.parentResourceId,scope.fd.UuidRef,scope.fd.Parameters.PublishedResourceVersion,scope.resourceDefinition.resourceVersion).then(function(data) {
                 
                                    scope.fd.localVars.widgetState.resourceWidgetDefinition= data.data.resourceDefinition;
									
									 if (data.data.columns?.columnsDef?.length==0 ) {
										 MessagingService.addMessage('Did not receive columnDefs data for uuid: ' + scope.fd.UuidRef,'error')
										 console.log ('$scope.fd.localVars.executeDatasetList(): Did not receive columnDefs data for uuid: ' + scope.fd.UuidRef)
									 }										 
									 
                           
                                    scope.fd.localVars.gridOptionsResourceData.columnDefs = data.data.columns.columnsDef;
                                    //debugger //ktTaskDatasetList
                                     
                                    //if (scope.fd.GridState?.columnsDef?.length > 0)  
                                    //        scope.fd.localVars.gridOptionsResourceData.columnDefs = scope.fd.GridState.columnsDef
                                    // MIGOR TODO    KAD SE MIJENJA RESURS NA DATASET LISTI TREBA NULIRATI GRIDSTATE !
                                    
                                    //debugger  //prepare columnDefs //smarttable
                                    
                                    scope.fd.fItemValue=data.data.widgets;
                                    if (data.data.widgetsCard!=null)  {
                                        scope.fd.localVars.dashboardCard.widgets.layout =  data.data.widgetsCard;
                                    }
         
                                    scope.fd.localVars.dashboard.widgets.layout =  data.data.widgets;
                                    scope.fd.localVars.widgetState.widgets = scope.fd.localVars.dashboard.widgets.layout;
                                   
                                    scope.fd.localVars.widgetState.formData =  data.data.formData;
                                    scope.fd.Search = scope.fd.localVars.widgetState.formData;
                                    if (scope.fd.Search==undefined) scope.fd.Search={};

                                    scope.fd.localVars.widgetState.sharedData = data.data
                                    scope.ksm.executeAction(valueStateName,"valueChanged", scope.fd.localVars.widgetState);
                                    
                                    //setup data grid or card
                                    scope.fd.localVars.gridOptionsResourceData.data = data.data.data;
                                    if (scope.fd.Parameters.PresentationType=='card') { 
										scope.fd.localVars.gridOptionsResourceData.data = scope.fd.localVars.TransformDataForCard(data.data.data);
										
											//scope.fd.localVars.dashboardCard.widgets.layout = scope.fd.FormDefSearch?.CardForm //MIGOR TODO VIDJETI DA LI OVO TREBA 
											//scope.fd.localVars.cardLayoutLoaded = true //MIGOR dodao jer se ne prikazuju kartice  //MIGOR TODO VIDJETI DA LI OVO TREBA
											
									}
                                    //scope.fd.localVars.restoreGridState();
                                    scope.fd.localVars.nextPage = data.data.data.next;
                                    scope.fd.localVars.previousPage = data.data.data.previous;
                                    scope.fd.localVars.totalCount=data.data.data.count;
                                    scope.fd.localVars.widgetState.currentPage=1;
                                    if (scope.fd.localVars.totalCount>0 && scope.fd.localVars.widgetState.currentPage==0) scope.fd.localVars.widgetState.currentPage=1;
                                    scope.fd.localVars.numPages = Math.ceil(scope.fd.localVars.totalCount/scope.fd.localVars.widgetState.pageSize);
                                    
                                    scope.fd.localVars.gridOptionsResourceData.totalItems=scope.fd.localVars.totalCount;
                                    
                                    scope.fd.localVars.resourceDataDownloaded = true;
                                    scope.fd.localVars.resourceDataDownloading = false;
                                    scope.fd.localVars.InitialLoad = false;
                                    scope.fd.localVars.searchFormDownloaded = true;
                                    scope.fd.localVars.formLoaded=true;
                                    scope.fd.localVars.cardLayoutLoaded = true

                                    if (scope.fd.Parameters.PresentationType=='dropdown') scope.fd.localVars.setDropdown(scope.fd.Parameters.ClientSideFilter, data.data)
                                    
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error'); 
                                   scope.fd.localVars.resourceDataDownloading = false
                             });
                              
      };//getFormResource_END

      
  
    scope.fd.localVars.restoreGridState= function() {
        //debugger
        if (scope.fd['GridState']!==undefined && scope.fd['GridState']!==null)
        {
          

            if (scope.fd['GridState']['columnsDef']!==undefined && scope.fd['GridState']['columnsDef'].length) scope.fd.localVars.gridOptionsResourceData.columnDefs =  scope.fd['GridState']['columnsDef']
            if (scope.fd['GridState']['columnsQuery']!==undefined && scope.fd['GridState']['columnsQuery'].length) scope.fd.localVars.columnsForQuery =  scope.fd['GridState']['columnsQuery']
            if (scope.fd['GridState']['relatedResources']!==undefined && scope.fd['GridState']['relatedResources'].length) scope.fd.localVars.relatedResources =  scope.fd['GridState']['relatedResources']
            if (scope.fd.localVars.columnsForQuery===undefined) scope.fd.localVars.columnsForQuery=[]
        }
    };
    
      scope.fd.localVars.getResourceData = function () {

        // scope.activity.activityMessage = ProcessingService.setActivityMsg('Downloading resource data for '+scope.selectedResource);
        var lang = $rootScope.globals.currentUser.lang;
        scope.fd.localVars.resourceDataDownloading = true;
        if (scope.fd.localVars.widgetState.pageSize==undefined) scope.fd.localVars.widgetState.pageSize = paginationOptions.pageSize;
        ResourcesDataService.getResourceData(scope.fd.localVars.selectedResourceId,scope.taskId,scope.fd.localVars.formType,lang).then(function(data) {
                               
                                     scope.fd.localVars.gridOptionsResourceData.data = data.data;
                                     scope.fd.localVars.gridOptionsResourceData.columnDefs = data.columnsDef;
                                     //debugger //getResourceData() //smarttable
                                     scope.fd.localVars.restoreGridState();
                                     scope.fd.localVars.InitialLoad = false;
                                     scope.fd.localVars.resourceDataDownloaded = true;
                                     scope.fd.localVars.resourceDataDownloading = false;
                                    
                                 },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                   scope.fd.localVars.resourceDataDownloading = false;
                             });
        };

    //**********************************************************
    //           GET FORM FIELDS
    //**********************************************************      
            
          scope.fd.localVars.getFormFields = function(){
                 
              var lang=$rootScope.globals.currentUser.lang;
              scope.fd.localVars.peLoaded=false         
              ResourcesDataService.getFormFields(scope.fd.Related,lang).then(function(data) {
                                  scope.fd.localVars.PresentationElements= data.data;
                                  scope.fd.localVars.peLoaded=true
                                },function(error){
                                    scope.fd.localVars.peLoaded=true
                                   MessagingService.addMessage(error.msg,'error');
                             });         
          };
          
          
         /* 
         scope.$watch('localVars.widgetState.itemValue.val',function(newValue,oldValue){
                  if (newValue!=oldValue)
                  {
                   //send data to package
                   let newValueSingle,newValueMultiple;
                   if (scope.fd.Multiline)
                   {
                    newValueMultiple = newValue;
                    newValueSingle="";
                   }
                   else
                   {
                    newValueMultiple = {};
                    newValueSingle=newValue;
                   }
                   
                   scope.ksm.executeAction(valueStateName,"valueChanged", scope.fd.localVars.widgetState);
                   
                    WidgetDataExchangeService.setData({
                    DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:scope.fd.Related},{name:'resourceRecordId',value:newValueSingle}
                        ,{name:'resourceRecordIds',value:newValueMultiple},{name:'resourceRecordsAll',value:scope.fd.localVars.datasetItems}]}],widgetId: scope.fd.UuidRef,parentResourceId:scope.fd.localVars.parentResourceId,task_execute_id:scope.taskExecuteId});
           
                  }
      });
     */
       
       //**********************************************************
      //           GET DATASET DATA FOR DROPDOWN
      //**********************************************************
      var refresh_list_from_callback=function(data)
            {
                scope.fd.localVars.getDatasetDataList(true);
                
            }
        scope.filterOnClient = function(items)
        {
            let temp=[];
            let search;
            if (Array.isArray(scope.fd.Search) && scope.fd.Search.length>0) search = scope.fd.Search[0];
            else search = scope.fd.Search;
            for (let i=0;i<items.length;i++)
            {
  
                for (let key in search) {
                    
                    
                    if (search[key]!=undefined)
                    {
                        if (key in items[i])
                        {
                            if (items[i][key]==search[key].id || search[key]==null || search[key]==undefined || items[i][key]==undefined)  temp.push(items[i]);
                        }else if (key in items[i])
                        {
                            if (items[i][key]==search[key] || search[key]==null || search[key]==undefined || items[i][key]==undefined)  temp.push(items[i]);
                        }else temp.push(items[i]);
                    }else temp.push(items[i]);
                }
                
                
            }
            return temp;
            
        }
        scope.fd.localVars.getDatasetDataList = function(fromCache,clientSideFilter)
        {
                    if (fromCache==undefined) fromCache=true;
                    if (clientSideFilter==undefined) clientSideFilter=false;
                    var lang = $rootScope.globals.currentUser.lang;
                    scope.fd.localVars.datasetItems = null;
                    
                    ResourcesDataService.getResourceDataListAll(scope.fd.Related,scope.fd.PresentationId,lang,fromCache,refresh_list_from_callback,scope.fd.NameField).then(function(data) {
                   
                        if (clientSideFilter) scope.fd.localVars.datasetItems = scope.filterOnClient(data.data);
                        else scope.fd.localVars.datasetItems = data.data;
                        $timeout(function(){
                            
                            if (!scope.fd.Multiline)
                            {
                                if (scope.fd.localVars.widgetState.itemValue.val!=undefined)
                                {
                                
                                    let pos = scope.fd.localVars.datasetItems.map(function(e) { return e.id; }).indexOf(scope.fd.localVars.widgetState.itemValue.val.id);
                      
                                    if (pos<0){
                                        //scope.clearDropdown();
                                        scope.fd.localVars.widgetState.itemValue.val = null;
                                    }
                                    
                                }else scope.fd.localVars.widgetState.itemValue.val = null;
                            
                            }else if (scope.fd.localVars.widgetState.itemValue?.val?.length) scope.fd.localVars.widgetState.itemValue.val.length=0
                        });
                        
                    },function(error){    
                        MessagingService.addMessage(error.msg,'error');
                    });
              
            
        };
        
        scope.fd.localVars.setDropdown = function(clientSideFilter,data){
        
            //$timeout(function(){
                if (clientSideFilter) scope.fd.localVars.datasetItems = scope.filterOnClient(data.data);
                else scope.fd.localVars.datasetItems = data.data;
                
                    
                    if (!scope.fd.Multiline)
                    {
                        if (scope.fd.localVars.widgetState.itemValue.val!==undefined && scope.fd.localVars.widgetState.itemValue.val!==null)
                        {
                        
                            let pos = scope.fd.localVars.datasetItems.map(function(e) { return e.id; }).indexOf(scope.fd.localVars.widgetState.itemValue.val?.id);
              
                            if (pos<0){
                                //scope.clearDropdown();
                                scope.fd.localVars.widgetState.itemValue.val= null;
                            }
                            
                        }else scope.fd.localVars.widgetState.itemValue.val= null;
                    
                    }
            //});
                        
        }
        
        scope.fd.localVars.GetDatasetDataClick = function()
        {
           
                scope.fd.localVars.selectedResourceId=scope.fd.Related;
                if (scope.fd.HasParentDataset && scope.fd.PopulateParentMethod=='A')
                { 
                    
                    scope.fd.localVars.GetResourceDataForParent()
                    
                }else scope.fd.localVars.getResourceDataPaginated(scope.fd.localVars.nextPage,scope.fd.localVars.previousPage,1,scope.fd.localVars.widgetState.pageSize); 
            
        };    
  

   

    scope.fd.localVars.pageChanged = function(){
        
        scope.fd.localVars.getResourceDataPaginated(scope.fd.localVars.nextPage,scope.fd.localVars.previousPage,scope.fd.localVars.widgetState.currentPage,scope.fd.localVars.widgetState.pageSize);
    };
      
     
     
       scope.fd.localVars.gridData = function() {

           return scope.fd.localVars.gridOptionsResourceData.data
        }
      
      
      scope.fd.localVars.getDefaultColumnsDef = function () {

        
        ResourcesDataService.getResourceColumns(scope.fd.Parameters.PublishedResourceId,scope.fd.Parameters.SelectedResourceType,lang,scope.fd.Parameters.PublishedResourceVersion).then(function(data) {//MIGOR
                            
                                scope.fd.localVars.gridOptionsResourceData.columnDefs = data.data.columnsDef
                                scope.fd.localVars.gridOptionsResourceData.relatedResources = data.data.relatedResources
                                scope.fd.localVars.results.columns =  scope.fd.localVars.gridOptionsResourceData.columnDefs
                                scope.fd.localVars.resourceDataDownloaded = true;
                                
                                scope.fd.localVars.saveGridState(false)
                                
                                     
                        },function(error){
                                MessagingService.addMessage(error.msg,'error');
        });

      }
      
    scope.fd.localVars.RelatedResourceColumns = function(related_index,initial_load){


        let selected_related = scope.fd.GridState.relatedResources[related_index]
        if (selected_related.SelectVersionDirect===undefined) selected_related.SelectVersionDirect = false

        if ((!initial_load && !selected_related.Selected) || (initial_load && selected_related.Selected)){
            scope.fd.localVars.relatedResourcesPublishedList[selected_related.id] = []
            selected_related.LoadingColumns=true
            ResourcesDataService.GetPublishedResourcesByTypeId(selected_related.id,'form').then(
                function (data) {       
              
                    scope.fd.localVars.relatedResourcesPublishedList[selected_related.id] = data.data;

                    if (!selected_related.SelectVersionDirect){
                        let published = scope.fd.localVars.relatedResourcesPublishedList[selected_related.id][scope.fd.localVars.relatedResourcesPublishedList[selected_related.id].length-1]
                            
                        selected_related.PublishedResourceId = published.id
                        selected_related.PublishedResourceVersion = published.Version
                   
                        
                    }
                    if (!selected_related.SelectVersionDirect || (initial_load && selected_related.SelectVersionDirect)){
                        //get columns
                        selected_related.resourceType='dataset' //remove hardcoding later
                        scope.fd.localVars.relatedResourcesColumns[selected_related.id] = []

                        ResourcesDataService.getResourceColumns(selected_related.PublishedResourceId,selected_related.resourceType,lang,selected_related.PublishedResourceVersion).then(function(data) {//MIGOR
                                    
                                scope.fd.localVars.relatedResourcesColumns[selected_related.id] = data.data.columnsDef
                                scope.setColSelected(related_index)
                                selected_related.LoadingColumns=false      
                                             
                            },function(error){
                                MessagingService.addMessage(error.msg,'error');
                                 selected_related.LoadingColumns=false    
                        });
                    
                    }
                
               
               },function(error){    
                    MessagingService.addMessage(error.msg,'error');
                     selected_related.LoadingColumns=false    
            });
        
            
            

        }else{
            scope.fd.localVars.relatedResourcesColumns[selected_related.id]=[]

        }

    }
    scope.setColSelected = function(related_index){

        
                if (scope.fd.GridState.relatedResources[related_index].selectedCols==undefined) scope.fd.GridState.relatedResources[related_index].selectedCols=[]
                let related_id = scope.fd.GridState.relatedResources[related_index].id
                for (let j=0;j<scope.fd.localVars.relatedResourcesColumns[related_id].length;j++)
                {   
                    if (scope.fd.GridState.relatedResources[related_index].selectedCols.indexOf(scope.fd.localVars.relatedResourcesColumns[related_id][j].name)>=0) scope.fd.localVars.relatedResourcesColumns[related_id][j].selected= true
                }
    }
    
    scope.fd.localVars.RelatedResourceDirectColumns = function(published){

                        //get columns
                        //selected_related.resourceType='dataset' //remove hardcoding later

                        let pos = scope.fd.GridState.relatedResources.map(function(e) { return e.id; }).indexOf(published.ResourceDefUid)

                        if (pos>=0){
                            scope.fd.GridState.relatedResources[pos].LoadingColumns=true
                            scope.fd.GridState.relatedResources[pos].PublishedResourceId=published.id
                            scope.fd.GridState.relatedResources[pos].PublishedResourceVersion = published.Version
                        }
                        scope.fd.localVars.relatedResourcesColumns[published.ResourceDefUid] = []
                        published.ResourceType = 'dataset' //remove this after implementation on server

        ResourcesDataService.getResourceColumns(published.id,published.ResourceType,lang,published.Version).then(function(data) {//MIGOR
                                    
                                scope.fd.localVars.relatedResourcesColumns[published.ResourceDefUid] = data.data.columnsDef
                               scope.fd.GridState.relatedResources[pos].LoadingColumns=false  
                               scope.setColSelected(pos)              
                            },function(error){
                                MessagingService.addMessage(error.msg,'error');
                                 scope.fd.GridState.relatedResources[pos].LoadingColumns=false
        });
    }
    scope.fd.localVars.addRemoveColumn = function(col,related_id){

        
        let pos = scope.fd.GridState['columnsDef'].map(function(e) { return e.name; }).indexOf(col.name);
        let pos_rel = scope.fd.GridState['relatedResources'].map(function(e) { return e.id; }).indexOf(related_id);

        if (pos>0) {
           if (col.selected) 

            {
                scope.fd.GridState['columnsDef'].splice(pos,1)
                if (scope.fd.GridState.relatedResources[pos_rel].selectedCols==undefined) scope.fd.GridState.relatedResources[pos_rel].selectedCols=[]
                
                scope.fd.GridState.relatedResources[pos_rel].selectedCols.splice(col.name)
            }

        }else{
            if (!col.selected) 
                {
                    scope.fd.GridState['columnsDef'].push(col)
                    if (scope.fd.GridState.relatedResources[pos_rel].selectedCols==undefined) scope.fd.GridState.relatedResources[pos_rel].selectedCols=[]
                
                    scope.fd.GridState.relatedResources[pos_rel].selectedCols.push(col.name)
                }
        }

    }

    scope.fd.localVars.onSelectColumnsVersionCallback=function (item,model) {

         let pos = scope.fd.localVars.relatedResourcesPublishedList[item.ResourceDefUid].map(function(e) { return e.id; }).indexOf(item.id);

        if (pos>0) {

            scope.fd.localVars.RelatedResourceDirectColumns(scope.fd.localVars.relatedResourcesPublishedList[item.ResourceDefUid][pos])
           //scope.fd.localVars.relatedResourcesPublishedList[pos]
        }
    }
    scope.fd.localVars.getResourceDataFiltered = function () {

            scope.filter = {};
            var lang = $rootScope.globals.currentUser.lang;

           //scope.activity.activityMessage = ProcessingService.setActivityMsg('Retriving data '+scope.selectedResource);
          //scope.filter = ResourcesDataService.prepareResourceWidgetData(scope.dashboard.widgets,-1);
         
          if (scope.fd.localVars.selectedResourceId==null) {
            scope.fd.localVars.selectedResourceId = scope.fd.Related;
          }
          scope.fd.localVars.resourceDataDownloading = true;
            //  ResourcesDataService.getResourceDataFiltered(scope.fd.Related,lang,scope.filter).then(function(data) {//MIGOR
         ResourcesDataService.getResourceDataFiltered(scope.fd.localVars.selectedResourceId,scope.taskId,scope.fd.localVars.formType,lang,scope.fd.localVars.dashboard.data).then(function(data) {//MIGOR
                            
                                scope.fd.localVars.gridOptionsResourceData.data = data.data;
                                scope.fd.localVars.gridOptionsResourceData.columnDefs = data.columnsDef;
                             
                                scope.fd.localVars.resourceDataDownloaded = true;
                                scope.fd.localVars.resourceDataDownloading = false;
                                scope.fd.localVars.restoreGridState();
                                scope.fd.localVars.InitialLoad = false
                                 
                                 
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                                scope.fd.localVars.resourceDataDownloading = false;
                             });
        };
        
              
          scope.fd.localVars.showHideSearchForm = function()
        {
                    //if (scope.fd.ShowSearchForm) scope.fd.localVars.getFormResource();
        };
    
    //GET Published resources
     scope.fd.localVars.getPublishedResources=function()
        {
            scope.fd.localVars.publishedLoaded=false
                  
            ResourcesDataService.GetPublishedResourcesByTypeId(scope.fd.Related,'form').then(
                function (data) {       
              
                scope.fd.localVars.publishedResourceList = data.data;
                scope.fd.localVars.publishedLoaded=true

                if (!scope.fd.Parameters.SelectVersionDirect){
                    let published = scope.fd.localVars.publishedResourceList[scope.fd.localVars.publishedResourceList.length-1]
                        
                    scope.fd.localVars.selectedResourceItem_c = published
                    scope.fd.Parameters.PublishedResourceId = published?.id
                    scope.fd.Parameters.PublishedResourceVersion = published?.Version
                }

                if (scope.fd.Parameters.PublishedResourceId>0) scope.fd.localVars.setSelectedResource(scope.fd.Parameters.PublishedResourceId,true);
                
               
               },function(error){    
                    MessagingService.addMessage(error.msg,'error');
            });
            
        }         
           
    // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
    scope.fd.localVars.getResources = function()  {

            if (scope.fd.localVars.resourceList==undefined) scope.fd.localVars.resourceList=[];
          
            let lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,scope.fd.Parameters.SelectedResourceType).then(
                        function(data) {
                                        
                        scope.fd.localVars.resourceList = data.data;
                        if (scope.fd.Related!="" && scope.fd.Related!=undefined && scope.fd.Related!=null) {
                            let pos = scope.fd.localVars.resourceList.map(function(e) { return e.id; }).indexOf(scope.fd.Related);
                            if (pos>0) scope.fd.localVars.selectedResourceItem = scope.fd.localVars.resourceList[pos]
                        }
                        scope.fd.localVars.getPublishedResources()
                                             
                 },function(error){    
                    MessagingService.addMessage(error.msg,'error');
            });
    }

    //Load subquery form
    scope.fd.localVars.loadSubqueryForm = function(){

        let version = 0
        if (scope.fd.Parameters.SubQuery.SelectVersionDirect) version = scope.fd.Parameters.SubQuery.PublishedResourceVersion
        

        ResourcesDataService.GetPublishedResourceById(scope.fd.Parameters.SubQuery.PublishedResourceId).then(function (data) {

                           
                    scope.fd.Parameters.SubQuery.form = {layout:data.data.Form}
                    if (!scope.fd.Parameters.SubQuery.formData) scope.fd.Parameters.SubQuery.formData=[{}]
                    scope.fd.localVars.subqueryFormLoaded=true;

                     
                     
                },function(error){    
                    MessagingService.addMessage(error.msg,'error');
                    scope.fd.localVars.subqueryFormLoaded=true;
                     
        });

        
    }

    scope.fd.localVars.sqResourceDefinition = {uid:scope.fd.Parameters.SubQuery?.SelectedResource?.id,form_definition:true}
    if (scope.fd.Parameters.UseSubQuery && scope.fd.Parameters.SubQuery.PublishedResourceId && !scope.fd.Parameters.SubQuery.form?.layout?.length) scope.fd.localVars.loadSubqueryForm()
    else{

        if (!scope.fd.Parameters.SubQuery) scope.fd.Parameters.SubQuery={}
        if (!scope.fd.Parameters.SubQuery.formData) scope.fd.Parameters.SubQuery.formData=[{}]
        
        scope.fd.localVars.subqueryFormLoaded=true

    }
     //**********************************************************
     //           GET DATASET DIRECT FILTER
     //**********************************************************      
      scope.fd.localVars.getDatasetDirect = function (item) {

        let children = [item[scope.fd.localVars.TablePrefix+'_id']]
        scope.fd.localVars.resourceDataDownloading = true 
        ResourcesDataService.getResourceDataDirectFilter(scope.fd.Related,{id__in: children},scope.fd.GridState['columnsQuery']).then(function(data) {
                                    
                                    $timeout(function(){
                                        scope.fd.localVars.gridOptionsResourceData.data = data.data
                                        scope.fd.localVars.gridOptionsResourceData.columnDefs = scope.fd.GridState['columnsDef']
                                        scope.fd.localVars.resourceDataDownloaded = true
                                        scope.fd.localVars.resourceDataDownloading = false 
                                        scope.fd.localVars.InitialLoad = false
                                    })
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');     
                                    scope.fd.localVars.resourceDataDownloading = false           
                             });
        };


    
    
      
        let refresh_data=function(data)
        {
            let state = data.state
            let search_form = scope["datasetListSearchForm" + scope.fd.PresentationId]
            //if search form is undefined you can't get the data
            if (state!==undefined && search_form!=undefined && !scope.resourceDefinition.form_definition)
            {
                scope.fd.ParentDatasetDefId = state.datasetDefId
                scope.fd.localVars.ParentRecordId = state.recordId
                //if (scope.fd.Parameters.ParentRelationshipType==0) 
                scope.fd.localVars.GetResourceDataForParent()
                //else scope.fd.localVars.getDatasetDirect(state.record)
            }

        }
		
    if ( !scope.fd.localVars.formDefinition  &&  scope.fd.HasParentDataset && scope.fd.PopulateParentMethod=='A')
    {
        

        //setup here state manager
        let dependent_field = valueStateName
        let subscribedSubject = scope.resourceDefinition.page_state_id+'-'+scope.fd.SrcParentWidgetId;
        let subject = scope.ksm.addSubject(subscribedSubject,null);                          
        let observer = scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",refresh_data);
        let val = scope.ksm.getState(subscribedSubject);
        if (val.state!==undefined && val.state!==null)
        {   
            let parent_item  = val.state
            scope.fd.ParentDatasetDefId = parent_item.datasetDefId
            scope.fd.localVars.ParentRecordId = parent_item.recordId
            //if (scope.fd.Parameters.ParentRelationshipType==0) 
            scope.fd.localVars.GetResourceDataForParent()
            //else scope.fd.localVars.getDatasetDirect(parent_item.record)
    
        }
        
    }

    scope.fd.localVars.getPreviousTaskWidget  = function(linkType)
    {
      var pTaskData = WidgetDataExchangeService.getPrevTaskData(scope.prevTaskExeId);
            var datasetId=0,datasetRecordId=0;
            let action;
            for (let k=0;k<pTaskData.length;k++)
            {
                if (pTaskData[k].DEI!=undefined && pTaskData[k].DEI!=null)
                {
                for (var i=0;i<pTaskData[k].DEI.length;i++)
                {
                  if (pTaskData[k].DEI[i].name==linkType)
                  {
                    if (pTaskData[k].DEI[i].value!=undefined && pTaskData[k].DEI[i].value!=null)
                    {
                      //populate selected item
                     
                      for (var j=0;j<pTaskData[k].DEI[i].value.length;j++)
                      {
                       if (pTaskData[k].DEI[i].value[j].name=="resourceId" && pTaskData[k].DEI[i].value[j].value!=undefined) datasetId=pTaskData[k].DEI[i].value[j].value;
                       if (pTaskData[k].DEI[i].value[j].name=="resourceRecordId" && pTaskData[k].DEI[i].value[j].value!=undefined)
                       {
                            datasetRecordId=pTaskData[k].DEI[i].value[j].value;
                            if (scope.fd.Parameters.PresentationType == 'dropdown' && datasetId==scope.fd.Related && !scope.fd.Multiline)
                            {
                        
                                scope.fd.localVars.widgetState.itemValue.val = pTaskData[k].DEI[i].value[j].value;
                                action = scope.ksm.executeAction(valueStateName,"valueChanged", scope.fd.localVars.widgetState);
                            }
                       }
                       if (pTaskData[k].DEI[i].value[j].name=="resourceRecordIds" && pTaskData[k].DEI[i].value[j].value!=undefined)
                       {
                            datasetRecordId=pTaskData[k].DEI[i].value[j].value;
                            if (scope.fd.Parameters.PresentationType == 'dropdown' && datasetId==scope.fd.Related && scope.fd.Multiline)
                            {
                        
                                scope.fd.localVars.widgetState.itemValue.val = pTaskData[k].DEI[i].value[j].value;
                                action = scope.ksm.executeAction(valueStateName,"valueChanged", scope.fd.localVars.widgetState);
                            }
                       }
                        
                      }
                         
                        
                    }
                      
                  }
                    
                  }
                }
            }
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };


  scope.fd.localVars.previousTaskData=scope.fd.localVars.getPreviousTaskWidget("resourceLinkDatasetList");
 
 
  scope.fd.localVars.patchDashboard = function (obj, destId, patchData)     
     { // sample function for recursively patching dashboard object
        var o = {};
        Object.keys(obj).forEach(function(key) {
          
            if ( (typeof(obj[key]) === 'object') && obj[key]   )
            {       
              scope.fd.localVars.patchDashboard(obj[key], destId, patchData)
            } 
            else {     
                    if (key == 'AngularDirectiveName' || key == 'ContainerId' || key == 'ElementType' || key == 'FieldName' || key == 'Name'  || key == 'OriginalPresentationElementId') {  
                        o[key]= obj[key];
                        }
                    if ( key == 'NameField' ) {
                       //debugger
                        if (Array.isArray(obj[key]) ) o[key]= obj[key][0];
                        else o[key]= obj[key];
                    }   
                    if (key == 'PresentationId' ) {
                        o['id']= obj[key];
                    }    
                    
                }
            }) ; 
        
        //if (Object.keys(o).length > 0) ..do somoething with o   
    }; 


  scope.fd.localVars.saveGridState= function(show_message) {
               //debugger //ktTaskDatasetList smarttable
               let columnsDef = scope.fd.localVars.gridOptionsResourceData.columnDefs

               let columnsQuery = scope.fd.localVars.columnsForQuery
               let relatedResources = scope.fd.localVars.gridOptionsResourceData.relatedResources
               scope.fd['GridState']={'columnsDef':columnsDef,'columnsQuery': columnsQuery,'relatedResources':relatedResources}
                                
               //var destId=scope.fd.LocalId
                
                //find corresponding columns in Presentation elements
                /*
                for (let i=0; i < scope.fd.fItemValue[0].layout[0].layout.length;i++) {
                    for (let j=0; j< state.length;j++) {
                        if (state[j]['id'] == scope.fd.fItemValue[0].layout[0].layout[i]['id']) {
                                scope.fd.fItemValue[0].layout[0].layout[i]['Parameters']['GridState'] = state[j]
                        }
                        
                    }
   
                }
              */
               //var res = scope.fd.localVars.patchDashboard (s, scope.fd.LocalId, state)
              if (show_message)
               MessagingService.addMessage("To make changes stick please save form",'info');            
    };
    
    /*********************************** preview and dowlload files functions *************************/
    /*********************************** preview and dowlload files functions *************************/
    /*********************************** preview and dowlload files functions *************************/
     scope.fd.localVars.downloadFile = function(fileId,fileName){
                ResourcesDataService.downloadFile(scope.fd.Related,fileId).then(function(data) {
                               
                                    MessagingService.addMessage('File '+fileName+' downloaded','info');
                                    var url = URL.createObjectURL(new Blob([data.data]));
                                    var a = document.createElement('a');
                                    a.href = url;
                                    a.download = fileName;
                                    a.target = '_blank';
                                    a.click();
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
      };// dowload file END
      
      
       scope.fd.localVars.previewFile = function(fileId,fileName,fileType){
           
            ResourcesDataService.downloadFile(scope.fd.Related,fileId).then(function(data) {
                               
                                    var url = URL.createObjectURL(new Blob([data.data],{type:fileType}));
                                    let new_doc = window.open(url,"_blank");
                                  
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
      };// preview file END
     /*********************************** preview and dowlload files functions *************************/
      /*********************************** preview and dowlload files functions *************************/
       /*********************************** preview and dowlload files functions *************************/


     if (scope.fd.localVars.publishedResourceList==undefined) scope.fd.localVars.publishedResourceList=[];
    var lang=$rootScope.globals.currentUser.lang;

      /*        
      ResourcesDataService.GetPublishedResourcesByType(scope.fd.Parameters.SelectedResourceType,'form').then(
        function (data) {  
            if (scope.fd.localVars===undefined) scope.fd.localVars={}     
           scope.fd.localVars.publishedResourceList = data.data;
           //debugger  //GetPublishedResourcesByType   
                        
           if (scope.fd.Parameters.PublishedResourceId!=null) 
                                        scope.fd.localVars.setSelectedResource(scope.fd.Parameters.PublishedResourceId,true);   
           },function(error){    
                          MessagingService.addMessage(error.msg,'error');
    });
    
    */
    scope.fd.localVars.getFileTypes = function(){
          ResourcesDataService.getResourceDefListByType($rootScope.globals.currentUser.lang,'file').then(
                        function(data) {            
                            scope.fd.localVars.listOfFileTypes = data.data;
                         }
                        ,function(error){   MessagingService.addMessage(error.msg,'error')  }
            );
    
    }

    //check the purpose of this function
    if (scope.fd.localVars.formDefinition) scope.fd.localVars.getFileTypes()
        
      

        //&& !scope.fd.Parameters.DownloadAllRecord
        if (scope.fd.Related!=null &&  !scope.fd.localVars.formDefinition && !scope.fd.HasParentDataset) {
                  
                  if (!scope.fd.localVars.loadFromState && !scope.fd.Parameters.AutoSearchClient && scope.fd.AutoSearch) scope.fd.localVars.executeDatasetList();
                  else if  (scope.fd.localVars.loadFromState || (scope.fd.localVars.searchFormDownloaded && scope.fd.Parameters.AutoSearchClient))
                  {
                    scope.fd.localVars.getResourceDataPaginated(scope.fd.localVars.nextPage,scope.fd.localVars.previousPage,scope.fd.localVars.widgetState.currentPage,scope.fd.localVars.widgetState.pageSize);
                  }
                  else if  (!scope.fd.localVars.searchFormDownloaded && scope.fd.Parameters.AutoSearchClient)
                  {
                    scope.fd.localVars.showHideSearchForm();
                   
                  }

                  
        }else if (scope.fd.Related!=null  &&  !scope.fd.localVars.formDefinition && !scope.fd.localVars.searchFormDownloaded && scope.fd.Parameters.DownloadAllRecords  && !scope.fd.Parameters.AutoSearchClient)
        
        {
            scope.fd.localVars.getResourceDataPaginated(scope.fd.localVars.nextPage,scope.fd.localVars.previousPage,scope.fd.localVars.widgetState.currentPage,scope.fd.localVars.widgetState.pageSize);         
        }
        else if (scope.fd.Related!=null  && (scope.fd.localVars.datasetMapperType!=5 || scope.fd.Parameters.AutoSearchClient))
        {
           //if (scope.fd.Parameters.PresentationType=='card') scope.fd.localVars.getCardLayout();
           scope.fd.localVars.restoreGridState();
           scope.fd.localVars.showHideSearchForm();

        }
                  
                  
        if (scope.fd.localVars.formDefinition && scope.fd.Related!="" && scope.fd.Related!=undefined && scope.fd.Related!=null) 
        {
                scope.fd.localVars.getResources()
                if (scope.fd.Parameters.PresentationType=='dropdown') scope.fd.localVars.getFormFields()
                //setup related resources and columns
                if (scope.fd.GridState?.relatedResources!==undefined){
                for (let i=0;i<scope.fd.GridState?.relatedResources.length;i++)
                {
                    if (scope.fd.GridState?.relatedResources[i].Selected) scope.fd.localVars.RelatedResourceColumns(i,true)
                        
                }
            }
        } else if (scope.fd.Related!="" && scope.fd.Related!=undefined && scope.fd.Related!=null) scope.fd.localVars.loadingParams = false
        
   $rootScope.$broadcast("Widget"+scope.fd.PresentationId+"Ready",null);
   
   
   scope.fd.localVars.addAnalytics = function()
   {
        if ( scope.fd.Parameters.Analytics == undefined)   {
                scope.fd.Parameters.Analytics =   []
        }
        scope.fd.Parameters.Analytics.push( { CalculateFunction:'', AggregateField:'', CalculateField:'', Show:true })
       
   }
   scope.processEvents=function(data,newRound){

    UtilityService.process_events(scope.resourceDefinition.page_state_id,valueState,data,scope.fd.Parameters.events,scope.ksm,newRound)
   }

    //process events and execute actions
    if (!scope.fd.localVars.formDefinition && scope.fd.Parameters?.events?.length>0) UtilityService.subscribe_2_events(scope.resourceDefinition.page_state_id,scope.fd.UuidRef,scope.fd.Parameters.events,scope,scope.ksm)

            
    }
             
             
  } 
        
};
             
                                       
              
            
'use strict';

export function ktTaskDefDetails () {

        return {
            restrict: 'A',
            scope:{
              taskDefinition:'=',
              isCollapsed:'='
              },
             templateUrl: 'ktdirectivetemplates/ktTaskDefDetails.html',
             link: function (scope, elem, attrs) {

         
       
            }

    }
};
'use strict';

export function ktTaskDetails () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktTaskDetails.html',
               scope:{
              tName: "=",
              tInit:'=',
              tExe:'=',
             },
             controller: function(CodesService,$rootScope){},
             link: function (scope, elem, attrs) {

            
            
            scope.ti = scope.tInit;
            /*
            scope.getInitiateId = function(){
              
              if (scope.taskInitiateInstance != undefined)
              {
                return scope.taskInitiateInstance.id;
              }else
              
              {
                return scope.taskExecuteInstance.id;
                
              }
              
            }
            
            scope.getStatus = function(){
              if (scope.taskInitiateInstance != undefined)
              {
                return scope.taskInitiateInstance.Status.Name;
              }else
              
              {
                return scope.taskExecuteInstance.Status.Name;
                
              } 
              
            }
            */
       
            }

    }
};
'use strict';

export function ktTaskDropdown () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktTaskDropdown.html',
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService){    
                },
             link: function (scope, elem, attrs) {
                
                    
              }
        }
  
};
'use strict';

export function ktTaskDropdown2 () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktTaskDropdown2.html',
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService){    
                },
             link: function (scope, elem, attrs) {
                
                    
              }
        }
  
};
'use strict';

export function ktTaskExecuteOutcomes () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktTaskExecuteOutcomes.html',
              scope:{
                outcomes: '=',
                taskDefinition: '=',
                taskExe: '=',
                exeForm: '=',
                form: '=',
                formParams: '=',
                taskInitiateInstance: '=',
                localVars:'=',
                },
                controller: function($scope,CodesService,MessagingService,TaskDataService,$rootScope,$state)
                {
                   
                },
             link: function (scope, elem, attrs) {
              
              if (scope.localVars==undefined) scope.localVars={};
              
              scope.localVars.showInlineTask=false;
              scope.localVars.isInlineTask = false;
              
             if (scope.taskExe!=undefined) scope.taskExe.showInlineTask=false;
             else scope.taskExe = {showInlineTask:false};   
              
              scope.localVars.ProcessOutcome = function (outcome){
                
                for (var i=0;i<outcome.actions.length;i++) {
                  if (outcome.actions[i].type==1 || outcome.actions[i].type==2)
                  {
                     scope.localVars.InitiateTaskFromOutcome(outcome.actions[i].taskId,outcome.id1,outcome.actions[i].type,outcome.actions[i].actionParams);
                         
                  }
                 
                }
                if (outcome.actions.length==0)
                {
                    $rootScope.$broadcast('ExecuteTask'+scope.taskExe.id,{form:scope.form,outcomeId:outcome.id1});
                  
                }
                     
                 };
                 
                 
                 
              scope.localVars.InitiateTaskFromOutcome = function (taskDefId,outcomeId,type,actionParams){
                      //save task instance form for later processing
                      if (scope.taskExe!=undefined)
                      {
                      if (scope.taskExe.id!=undefined)
                      {
                      TaskDataService.saveTaskFormData(scope.taskExe.id,scope.exeForm).then(function(data) {
                               if (type==1)
                               {
                                
                                 scope.localVars.showInlineTask=true;
                                  scope.taskExe.showInlineTask=true;
                
                                  scope.localVars.isInlineTask=true;
                                  scope.localVars.fromOutcome=true;
                                  //scope.localVars.taskDefId=taskDefId;
                                  //scope.localVars.outcomeId=outcomeId;
                                  //scope.localVars.prevTaskId=scope.taskExe.id;
                                  if (taskDefId!=undefined &&  taskDefId>0) scope.localVars.StartTask(taskDefId,outcomeId,scope.taskExe.id);             
                              
                              
                                }
                                if (type==2)
                                {
                                      $state.go('app.navbar.tasks.proc',{id: taskDefId,fromStateName:$state.current.name,
                                      fromStateParams:$state.params,prev_task_execute_id:scope.taskExe.id,outcome_id:outcomeId,presentation_id:0});
                            
                                 }
                        },function(error){
                                   MessagingService.addMessage(error.msg,'error');

                        });

                      }
                        else{
                        
                        MessagingService.addMessage("Invalid task data --> Task execution id is undefined",'error');
                        }
                      }else
                      {
                         MessagingService.addMessage("Invalid task data --> Task execution object is undefined",'error');
                      }
                 }
                 
                
                
        }
    }
};
'use strict';

export function ktTaskFiles () {
       
     return {
        restrict: 'A', 
        templateUrl: 'ktdirectivetemplates/ktTaskFiles.html',
         controller: function ($scope, $rootScope,$uibModal,KatalyoStateManager,ResourcesDataService,ProcessingService,MessagingService,CODES_CONST,WidgetDataExchangeService,GridsterService,TaskDataService,$timeout,$q) {
				 
              $scope.fd.ReadOnly=false;
              $scope.animationsEnabled = true;
              
              $scope.gsrvc = GridsterService;
              
              if ($scope.fd.localVars==undefined)  $scope.fd.localVars = {datasetMapperType:0};
              
                $scope.fd.localVars.dashboard = {widgets:[]}
                $scope.fd.localVars.showMenu = false
                $scope.fd.localVars.widgetState={}
                $scope.fd.localVars.gridsterType = 'file'
                $scope.fd.localVars.TablePrefix = 'resource'+$scope.fd.Related+'_'+$rootScope.globals.currentUser.organisation.id
                $scope.fd.localVars.showSearchFilters = true
                $scope.fd.localVars.formParams={formViewType:1,showGridNavigation:true};
                $scope.fd.localVars.taskId=$scope.resourceDefinition.ResourceDefId;
                $scope.fd.localVars.InitialLoad = true
                if ($scope.resourceDefinition.form_definition && $scope.fd.localVars.formParams.formViewType==1) $scope.fd.Parameters.BuildMode = true
                else $scope.fd.Parameters.BuildMode = false

                $scope.fd.localVars.toggleDropdown = function(){
                           $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
                }
              
              if ($scope.fd.Parameters == null ||  $scope.fd.Parameters==undefined)  $scope.fd.Parameters = {};
              
                 $scope.fd.localVars.paginationOptions = {
                    pageNumber: 1,
                    pageSize: 10,
                    sort: null
                };
              
              $scope.showMetadata = function (fileId) {
            
                    
                  var modalInstance = $uibModal.open({
                  animation: $scope.animationsEnabled,
                  templateUrl: 'metadata_modal.html',
                  controller: 'FileMetadataModalInstanceCtrl',
                  size: 'lg',
                  resolve: {
                    retValue: function () {
                      return {file_id:fileId};
                    }
                  }
              });
           
                  modalInstance.result.then(function (retValue,windex,index) {
                    
            
                 }, function () {
             
                 });
          
       
            };
            


           $scope.fd.localVars.showProperties=function(datasetMapperType)
           {
            
               if ($scope.fd.localVars.datasetMapperType==undefined)
               {
                  $scope.fd.localVars.datasetMapperType = datasetMapperType;
               }else
               {
                  if ($scope.fd.localVars.datasetMapperType==0 || $scope.fd.localVars.datasetMapperType!=datasetMapperType) $scope.fd.localVars.datasetMapperType = datasetMapperType;
                  else $scope.fd.localVars.datasetMapperType=0;
               }
            
           };

        
        let valueState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+"-"+$scope.fd.ElementType+"ValueStateName-"+$scope.fd.PresentationId,$scope.fd.localVars.widgetState);
        let valueStateName = valueState.subject.name;
        

           //*********************** get state if exists********************************************
        //***************************************************************************************
        if (valueState.subject.currentStateIndex>=0 && !$scope.fd.AutoSearch)
        {
            $scope.fd.localVars.loadFromState=true;
            $scope.fd.localVars.widgetState = valueState.subject.getState;
            $scope.fd.localVars.dashboard.widgets.layout=$scope.fd.localVars.widgetState.widgets;
            $scope.fd.localVars.searchFormDownloaded = true;
            $scope.fd.localVars.formLoaded=true;
        }else
        
        {
          $scope.fd.localVars.widgetState.formData=[{}];  
        }

           /*
            $scope.fd.localVars.okFileConnector = function () {
                $timeout(function() {
                $scope.fd.tItemValue=$scope.fd.listOfConnectors;
                $scope.fd.localVars.showProperties(0);
                
                });
            };
            
             $scope.fd.localVars.cancelFileConnector = function () {
                $timeout(function() {
                //Can't copy! Making copies of Window or Scope instances is not supported
                $scope.fd.listOfConnectors=angular.copy($scope.fd.tItemValue);
                //$scope.fd.listOfConnectors=$scope.fd.tItemValue;
                $scope.fd.localVars.showProperties(0);
                
                });
            };
            */
          //   kt taskfiles - FILECONNECTOR  -  ista funkcija kao i za uploader!
          /*
		  $scope.fd.localVars.openFileConnector = function(){
             $scope.fd.localVars.showProperties(1);
             
             if ($scope.fd.localVars.datasetMapperType==1) {
				//POPUNI LISTU DATASETOVA 
                  var lang = $rootScope.globals.currentUser.lang;                          
                  ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
                               function(data) {
                                           $scope.fd.datasetList = data.data;
                                           //dodaj ime dataseta u konektore
                                           if ($scope.fd.listOfConnectors!=undefined) 
                                                      for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                            var p = $scope.fd.datasetList.map(function(e) { return e.id; }).indexOf($scope.fd.listOfConnectors[i].parentDatasetDefId);
                                                            if (p>=0) $scope.fd.listOfConnectors[i].parentDatasetName = $scope.fd.datasetList[p].name;  
                                                      }
                                           },function(error){  MessagingService.addMessage(error.msg,'error');
                  });
						
							
                  if ($scope.fd.tItemValue==undefined || $scope.fd.tItemValue[0]==null) $scope.fd.tItemValue = [];  
						 
                  //ovo je kt-taskFiles
                  $scope.fd.listOfConnectors= WidgetDataExchangeService.getRegisteredWidgets();//MIGOR  - uzmi sve registrirane widgete
                          
                            //Brisi sve koji se vec nalaze u tItemValue
						if ($scope.fd.listOfConnectors!=undefined) 
								  for (var i=0;i< $scope.fd.tItemValue.length ;i++) {
										 for (var j=0;j< $scope.fd.listOfConnectors.length;j++) {
                                              if ($scope.fd.tItemValue[i]!=null) {
                                                 if ($scope.fd.listOfConnectors[j].widgetId==$scope.fd.tItemValue[i].widgetId)  {
                                                     $scope.fd.listOfConnectors.splice(j,1);//brisi lokalni				   					    		
                                                 }
                                              }
                                         }
							    }
                                //dodaj sa servera
                                for (var i=0;i< $scope.fd.tItemValue.length ;i++) 
                                              if ($scope.fd.tItemValue[i]!=null) 
                                                  $scope.fd.listOfConnectors.push($scope.fd.tItemValue[i]);	
                                                  
							  
							  //Ostavi u listi konektora samo WIDGETE koji imaju "ResourceID" jer su to data widgeti
							  var newlist=[];
							   
								if ($scope.fd.listOfConnectors!=undefined){
									for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                     if ($scope.fd.listOfConnectors[i].DEI!=undefined)  
                                                         for (var j=0;j< $scope.fd.listOfConnectors[i].DEI.length;j++) {
                                                             if ($scope.fd.listOfConnectors[i].DEI[j].name=='resourceLink' || $scope.fd.listOfConnectors[i].DEI[j].name=='resourceLinkDatasetList') {
                                                                 //ako DEI nije true/false - resetiraj na false
                                                                 if ( ($scope.fd.listOfConnectors[i].DEI[j].value!=false) && ($scope.fd.listOfConnectors[i].DEI[j].value!=true) ) $scope.fd.listOfConnectors[i].DEI[j].value=false;
                                                                 //dodaj konektor u novu listu 
                                                                 newlist.push($scope.fd.listOfConnectors[i]);
                                                             };						 						  						   					      
                                                    }
                                               }
									}//if
							  $scope.fd.listOfConnectors=newlist; //konacna lista NOVIH dataset konektora (NE ukljucuje one u tItemValue koja se salje posebno)
 
						
             }//if
			}; // open FIleConnector - ktTaskFiles 
        */
        
        $scope.fd.fileListDownloaded = false;
        $scope.fd.isCollapsedFilesList = true;
       $scope.fd.localVars.hidePopulateMethod=true;

       $scope.fd.localVars.resourceType="file";
        
        
        $scope.taskId=$scope.resourceDefinition.ResourceDefId;

         if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
         if ($scope.taskId==undefined)  $scope.taskId=0;
       

        $scope.fd.localVars.setSelectedResource = function(id,saved)  {

              if ($scope.fd.localVars.selectedResourceItem==undefined) $scope.fd.localVars.selectedResourceItem={};
              $scope.fd.localVars.getPublishedResourceById(id,saved);

        }
     
        $scope.fd.localVars.getPublishedResourceById = function(id,saved) 
 
 {
    
            let pos
            let old_publish_id = $scope.fd.Parameters.PublishedResourceId
           
                   
            if (saved && $scope.fd.FormDef!==undefined && $scope.fd.FormDef!==null && $scope.fd.FormDef.length>0)
              { 
                    pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                    if (pos>=0){
                        $scope.fd.localVars.selectedResourceItem = $scope.fd.localVars.publishedResourceList[pos];
                        $scope.fd.localVars.selectedResource = $scope.fd.localVars.publishedResourceList[pos];

                        $scope.fd.localVars.selectedResourceItem.name_confirmed = $scope.fd.localVars.selectedResourceItem.name +' ('+$scope.fd.localVars.selectedResourceItem.id +')'
                    }
                    
                    $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
                   
                    if ($scope.resourceDefinition.form_definition) $scope.fd.fileListDownloaded =true
                    $scope.fd.localVars.formLoaded=true;

              }else{
                  pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  if (pos>=0){
                    ResourcesDataService.GetPublishedResourceById(id).then(function (data) {

                            $scope.fd.localVars.selectedResourceItem = $scope.fd.localVars.publishedResourceList[pos];
                            $scope.fd.localVars.selectedResourceItem.Form = data.data.Form
                            $scope.fd.localVars.selectedResource = $scope.fd.localVars.publishedResourceList[pos];
                            
                            $scope.fd.localVars.selectedResourceItem.name_confirmed = $scope.fd.localVars.selectedResourceItem.name +' ('+$scope.fd.localVars.selectedResourceItem.id +')'
                            if ($scope.fd.localVars.selectedResourceItem!==undefined)
                            {
                                $scope.fd.Parameters.PublishedResourceId=$scope.fd.localVars.selectedResourceItem.id;
                                $scope.fd.Parameters.PublishedResourceVersion=$scope.fd.localVars.selectedResourceItem.Version;
                                $scope.fd.Related=$scope.fd.localVars.selectedResourceItem.ResourceDefId; 
                                $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.localVars.selectedResourceItem.Form
                                $scope.fd.FormDef = $scope.fd.localVars.selectedResourceItem.Form
                                $scope.fd.localVars.freshForm=angular.copy($scope.fd.localVars.selectedResourceItem.Form)
                            }

                            if ($scope.fd.GridState?.columnsDef===undefined || old_publish_id!=id) $scope.fd.localVars.getColumnsDef()
                            else $scope.fd.fileListDownloaded =true
                            $scope.fd.localVars.formLoaded=true;

                        },function(error){    
                          MessagingService.addMessage(error.msg,'error');
                    });

                }
            }     
}      

   
  
        var out_fields = ['resourceId'];
        var widgetDefinition = { DEI: [{'name':'resourceLinkR','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'ktTaskFiles',widgetId: $scope.fd.PresentationId,taskId:  $scope.lTaskId,resourceDefId : $scope.selectedResource, output:out_fields, };
        $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
        $scope.fd.localVars.LocalId=$scope.fd.localVars.localWidgetId;
    
        $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
        
        $scope.ksm = KatalyoStateManager;
        
        $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;
        
      
        ResourcesDataService.GetPublishedResourcesByType('file','form').then(function (data) {       
           $scope.fd.localVars.publishedResourceList = data.data;
           //debugger  //GetPublishedResourcesByType   
           //$scope.fd.localVars.dashboard.widgets.layout = JSON.parse(data.data[0].Form)
                        
           if ($scope.fd.Parameters.PublishedResourceId!=null) $scope.fd.localVars.setSelectedResource($scope.fd.Parameters.PublishedResourceId,true);
           else {

              $scope.fd.localVars.formLoaded=true;
              $scope.fd.localVars.NoPublishedResourceMsg="Definition error --> Published dataset not defined!"
            }
             
           },function(error){    
                          MessagingService.addMessage(error.msg,'error');
    });



	   $scope.fd.downloadFile = function(fileId,fileName){
                ResourcesDataService.downloadFile($scope.fd.Related,fileId).then(function(data) {
                               
                                    MessagingService.addMessage('File '+fileName+' downloaded','info');
                                    var url = URL.createObjectURL(new Blob([data.data]));
                                    var a = document.createElement('a');
                                    a.href = url;
                                    a.download = fileName;
                                    a.target = '_blank';
                                    a.click();
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
      };// dowload file END
      
      
       $scope.fd.previewFile = function(fileId,fileName,fileType){
           
            ResourcesDataService.downloadFile($scope.fd.Related,fileId).then(function(data) {
                               
                                    var url = URL.createObjectURL(new Blob([data.data],{type:fileType}));
                                    let new_doc = window.open(url,"_blank");
                                  
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
      };// preview file END
   
      //kt TASK FILES
    
    $scope.fd.localVars.filesData = {data:[]};
    
    $scope.fd.localVars.fileSelectionChanged = function (item) {
       $scope.fd.fileSelected=item.isSelected;
       $scope.fd.SelectedFile = item;
     
    }

   
    $scope.fd.localVars.getFiles= function(tableState, pageNumber,pageSize){


        //taskExecuteId: 0   taskInitiateId: 0
        let deferred = $q.defer();    
        $scope.resourceLoading=true;
        var lang=$rootScope.globals.currentUser.lang;
        var newPage
       
        
        if (pageNumber==undefined) pageNumber = $scope.fd.localVars.paginationOptions.pageNumber;
        if (pageSize==undefined) pageSize = $scope.fd.localVars.paginationOptions.pageSize;
        
        if ($scope.fd.localVars.filesData!==undefined) {
                $scope.fd.localVars.totalCount= $scope.fd.localVars.filesData.data?.length
                $scope.fd.localVars.paginationOptions.totalItemCount=$scope.fd.localVars.filesData.data?.length
                $scope.fd.localVars.paginationOptions.numberOfPages = Math.ceil($scope.fd.localVars.paginationOptions.totalItemCount/pageSize);
        }

        if ($scope.fd.localVars.totalCount>0){
            if (Math.ceil($scope.fd.localVars.totalCount/pageSize)<pageNumber)
                newPage = Math.ceil($scope.fd.localVars.totalCount/pageSize);
        }
        
         if ($scope.fd.localVars.filesData) 
                $scope.fd.localVars.results = {results : $scope.fd.localVars.filesData.data.slice( (pageNumber -1) * pageSize, pageNumber * pageSize) }
         else 
                $scope.fd.localVars.results = {}     
         $scope.fd.localVars.results.columns=$scope.fd.GridState?.columnsDef

         $scope.fd.localVars.currentPage=pageNumber;
         $scope.fd.localVars.results.pageSize = pageSize;
         $scope.fd.localVars.results.numberOfPages = $scope.fd.localVars.paginationOptions.numberOfPages;
         $scope.fd.localVars.results.count =   $scope.fd.localVars.totalCount
         
         $scope.fd.localVars.widgetState.currentPage = $scope.fd.localVars.currentPage;
         $scope.fd.localVars.widgetState.pageSize = $scope.fd.localVars.results.pageSize;
         
         //$scope.ksm.executeAction(valueStateName,"valueChanged", $scope.fd.localVars.widgetState);
         //if (!$scope.fd.localVars.loadFromState) $scope.fd.localVars.resetSelection();
         
         deferred.resolve({data: $scope.fd.localVars.results});
         
      return deferred.promise;
    }

	$scope.fd.getFilesData = function (file_def_id,dataset_def_id) {
				
				$scope.filter = {};
				var lang = $rootScope.globals.currentUser.lang;
				//$scope.fd.linkedResourceId = resource_id; //MIGOR - mozda je visak (je)
				//$scope.fd.linkedResourceDefId = resource_def_id; //MIGOR - mozda je visak (je)
           if (file_def_id!=undefined)
           {
              
                    $scope.fd.localVars.filesData.data.length=0;
                    $scope.fd.fileSelected = false;
                    $scope.fd.localVars.resourceDataDownloading = true
                    ResourcesDataService.getFilesData($scope.fd.PresentationId,file_def_id,dataset_def_id,0).then(function(data) {
                                   
                         
                             
                        $scope.fd.localVars.filesData = data.data
                        
                        $scope.lastResourceDefId = file_def_id;
                        $scope.lastResourceId = dataset_def_id;
                        $scope.fd.fileListDownloaded = true;
                        $scope.fd.localVars.InitialLoad = false
                        $scope.fd.localVars.resourceDataDownloading = false
                    
                    }			
                    ,function(error){    
                         MessagingService.addMessage(error.msg,'error');	
                         $scope.fd.fileListDownloaded = true;
                         $scope.fd.localVars.resourceDataDownloading = false
                    });
            }
          
	};//getFilsData END

    $scope.fd.localVars.GetFilesClick = function()

    {
       
        
        $scope.fd.localVars.selectedResourceId=$scope.fd.Related;
        $scope.fd.localVars.GetFilesFilter($scope.fd.localVars.nextPage,$scope.fd.localVars.previousPage,1,$scope.fd.localVars.widgetState.pageSize); 
           

    }
          //**********************************************************
      //           GET RESOURCE DATA PAGINATED
      //**********************************************************      
    $scope.fd.localVars.GetFilesFilter = function (urlNext,urlPrev,newPage,pageSize) 
    {
        
        if ($scope.fd.localVars.filesData.data==undefined) $scope.fd.localVars.filesData.data = [];
        if (Math.ceil($scope.fd.localVars.totalCount/pageSize)<newPage) newPage = Math.ceil($scope.fd.localVars.totalCount/pageSize);
        const lang = $rootScope.globals.currentUser.lang;
        if (pageSize==undefined)
        {
          $scope.fd.localVars.widgetState.pageSize = paginationOptions.pageSize;
          pageSize= $scope.fd.localVars.widgetState.pageSize;
        }
          
           
        $scope.ksm.executeAction(valueStateName,"valueChanged", $scope.fd.localVars.widgetState);
        $scope["taskFilesSearchForm" + $scope.fd.PresentationId]?.$setSubmitted()
        const is_valid = $scope["taskFilesSearchForm" + $scope.fd.PresentationId]?.$valid
           //let is_valid = $scope.datasetListSearchForm?.$valid
           
        if (is_valid)
        {
                 $scope.fd.localVars.resourceDataDownloading = true;
                 $scope.fd.localVars.filesData.data.length=0;
        
                ResourcesDataService.getResourceDataPaginatedFilter($scope.fd.localVars.selectedResourceId,urlNext,urlPrev,newPage,pageSize,lang,$scope.fd.localVars.widgetState.formData, $scope.fd.localVars.dashboard.widgets.layout,$scope.fd.localVars.columnsForQuery).then(function(data) {
                                    
                                    
                                    //setup data grid or card
                                    $scope.fd.localVars.filesData.data = data.data;
                                    if ($scope.fd.Parameters.PresentationType=='card') $scope.fd.localVars.gridOptionsResourceData.data = $scope.fd.localVars.TransformDataForCard(data.data);
                                    $scope.fd.localVars.restoreGridState()
                                    
                                    $timeout(function(){
                                        $scope.fd.fileListDownloaded = true;
                                        $scope.fd.localVars.InitialLoad = false
                                        $scope.fd.localVars.resourceDataDownloading = false
                                       
                                        if (!$scope.fd.localVars.loadFromState) $scope.fd.localVars.widgetState.currentPage=1;
                                        if ($scope.fd.localVars.totalCount>0 && $scope.fd.localVars.widgetState.currentPage==0) $scope.fd.localVars.widgetState.currentPage=1;
                                        $scope.fd.localVars.numPages = Math.ceil($scope.fd.localVars.totalCount/$scope.fd.localVars.widgetState.pageSize);
                                        
                                        $scope.fd.localVars.filesData.totalItems=$scope.fd.localVars.totalCount;
                                        
                                        WidgetDataExchangeService.setData({
                                        DEI: [{name:'resourceLinkTaskFiles',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.fd.localVars.widgetState.selectedDatasetRecordId}
                                        ,{name:'resourceRecordIds',value: null},{name:'resourceRecordsAll',value:$scope.fd.localVars.filesData.data}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
                
                                        $scope.fd.localVars.loadFromState = false;
                                    })
                                   
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');
                                    $scope.fd.fileListDownloaded = true;
                                    $scope.fd.localVars.resourceDataDownloading = false
                             });
        }else{
                 MessagingService.addMessage($scope.fd.ErrorMsg,'warning');
                 $timeout(function(){ $scope.fd.fileListDownloaded = true;$scope.fd.localVars.resourceDataDownloading = false});
            }

    };
         


    $scope.fd.localVars.pageChanged = function(){
        
        $scope.ksm.executeAction(valueStateName,"valueChanged", $scope.fd.localVars.widgetState);
        $scope.fd.localVars.GetFilesFilter($scope.fd.localVars.nextPage,$scope.fd.localVars.previousPage,$scope.fd.localVars.widgetState.currentPage,$scope.fd.localVars.widgetState.pageSize);
         };

     //**********************************************************
     //           GET DATASET DIRECT FILTER
     //**********************************************************      
      $scope.fd.localVars.getDatasetDirect = function (item) {
        let lang = $rootScope.globals.currentUser.lang;             
        let children = [item[$scope.fd.Parameters.ParentDatasetFieldName]]
        $scope.fd.fileListDownloaded = false
        ResourcesDataService.getResourceDataDirectFilter($scope.fd.Related,$scope.fd.PresentationId,"i",lang,{id__in: children}).then(function(data) {
                                
                                    $scope.fd.localVars.filesData.data = data.data
                                    //$scope.fd.localVars.gridOptionsResourceData.columnDefs = data.columnsDef
                                    $scope.fd.localVars.restoreGridState()
                                    $scope.fd.fileListDownloaded = true
                                    $scope.fd.localVars.InitialLoad = false
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };

      /* Get children for parent*/
        $scope.fd.localVars.GetResourceDataForParent = function () 
        {
              var lang = $rootScope.globals.currentUser.lang;
              if ($scope.fd.localVars.ParentRecordId>0)
              {
                $scope.fd.fileListDownloaded = false
                ResourcesDataService.getResourceDataM2m($scope.fd.PresentationId,$scope.fd.ParentDatasetDefId,$scope.fd.Related,$scope.fd.localVars.ParentRecordId,$scope.taskId,0,lang).then(function(data) {
                            $scope.fd.localVars.filesData.data = data.data
                            //$scope.fd.localVars.gridOptionsResourceData.columnDefs = data.columnsDef
                            $scope.fd.localVars.restoreGridState()
                            $scope.fd.fileListDownloaded = true
                            $scope.fd.localVars.InitialLoad = false
                                           
                },function(error){    
                    MessagingService.addMessage(error.msg,'error');
                    
                                    });
            }              
        }

  $scope.fd.localVars.restoreGridState= function() {
        //debugger
        if ($scope.fd['GridState']!==undefined && $scope.fd['GridState']!==null)
        {
          
            if ($scope.fd['GridState']['columnsDef']!==undefined) $scope.fd.localVars.filesColumns =  $scope.fd['GridState']['columnsDef']
            if ($scope.fd['GridState']['columnsQuery']!==undefined) $scope.fd.localVars.columnsForQuery =  $scope.fd['GridState']['columnsQuery']

        }
    };
      $scope.fd.localVars.saveGridState= function(showMsg) {
               //debugger //ktTaskDatasetList smarttable
               let columnsDef = $scope.fd.localVars.filesColumns

               let columnsQuery = $scope.fd.localVars.columnsForQuery
               $scope.fd['GridState']={'columnsDef':columnsDef,'columnsQuery': columnsQuery}

               if (showMsg) MessagingService.addMessage("To make changes stick please save form",'info');            
    };

      $scope.fd.localVars.getColumnsDef = function () {

        let lang = $rootScope.globals.currentUser.lang;
        ResourcesDataService.getResourceColumns($scope.fd.Parameters.PublishedResourceId,'file',lang,$scope.fd.Parameters.PublishedResourceVersion).then(function(data) {//MIGOR
                            
                                  $scope.fd.localVars.filesColumns = data.data.columnsDef;
                                  //$scope.fd.localVars.columnsDownloaded = true;
                                  $scope.fd.fileListDownloaded = true
                                  $scope.fd.localVars.InitialLoad = false
                                  $scope.fd.localVars.saveGridState()
                                 
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                             });

      }

        //ktTaskFiles  - ProcessEvent
      $scope.fd.ProcessEvent=function(data)
      {
        for (var i=0;i<data.length;i++)
        {
         if (data[i].name=='resourceRecordId')
         {
               if (data[i].value!=undefined && typeof data[i].value =='object')
               {
                     $scope.fd.linkedResourceId = data[i].value.id;
               }else $scope.fd.linkedResourceId = data[i].value;

         }
         if (data[i].name=='resourceId')
          {
               
                if (data[i].value!=undefined && typeof data[i].value =='object')
               {
                     $scope.fd.linkedResourceDefId = data[i].value.id;
               }else $scope.fd.linkedResourceDefId = data[i].value;
          }
        }

      }; //ktTaskFiles  - ProcessEvent
      
        //ktTaskFiles  - pr0cessWidgetDependencies
        $scope.fd.ProcessWidgetDependencies = function() {
                                    
            if ($scope.fd.tItemValue!=undefined)
                for (var i=0;i< $scope.fd.tItemValue.length;i++) { // prolazim po DEI od vezanih widgeta
                    var linkedWidgetId=$scope.fd.tItemValue[i].widgetId;
                    if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                     //linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                        for (var j=0;j<$scope.fd.tItemValue[i].DEI.length;j++) {
                            if (($scope.fd.tItemValue[i].DEI[j].name==='resourceLink' || $scope.fd.tItemValue[i].DEI[j].name==='resourceLinkDatasetList') && ($scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                           
                               //console.log("kt-taskfiles " + $scope.fd.PresentationId+" vezani widgetid=" + linkedWidgetId);       
                               var linkedItem = $scope.fd.tItemValue[i].DEI[j].name;
                               
                               $scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj $scope.on
                                                 
                                 //    console.log("kt-taskfiles "+$scope.fd.PresentationId+", dobio event " + event.name);              
                                     //ktTASKfiles
                                                    
                                 $scope.fd.ProcessEvent(data);  
                                                 
                                }) //$on_END
                                 var data = WidgetDataExchangeService.getDataByWidgetId($scope.resourceDefinition.task_execute_id,$scope.resourceDefinition.task_initiate_id,$scope.resourceDefinition.prev_task_id,linkedWidgetId,linkedItem);
                                 $scope.fd.ProcessEvent(data);
                            }//if
                    }//for j
                   }//if   
                } //for i
        }// fn pr0cessWidgetDependencies

    let refresh_data=function(data)
    {
            let state = data.state

            if (state!=undefined)
            {
                $scope.fd.ParentDatasetDefId = state.datasetDefId
                $scope.fd.localVars.ParentRecordId = state.recordId
                if ($scope.fd.Parameters.ParentRelationshipType==0) $scope.fd.localVars.GetResourceDataForParent()
                else $scope.fd.localVars.getDatasetDirect(state.record)
            }

    }

    if ($scope.fd.HasParentDataset && $scope.fd.PopulateParentMethod=='A')
    {
        

        //setup here state manager
        let dependent_field = "Field"+$scope.fd.UuidRef;
        let subscribedSubject = $scope.resourceDefinition.page_state_id+'-'+$scope.fd.SrcParentWidgetId;
        let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
        let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",refresh_data);
        let val = $scope.ksm.getState(subscribedSubject);
        if (val.state!==undefined && val.state!==null)
        {   
            let parent_item  = val.state
            $scope.fd.ParentDatasetDefId = parent_item.datasetDefId
            $scope.fd.localVars.ParentRecordId = parent_item.recordId
            if ($scope.fd.Parameters.ParentRelationshipType==0) $scope.fd.localVars.GetResourceDataForParent()
            else $scope.fd.localVars.getDatasetDirect(parent_item.record)
    
        }
        
    }
   
      //TODO - vidjeti da li ovaj treba i zbog èega
       $scope.$on('InitiateTaskFilesUploaded',function(event, data){
             $scope.fd.getFilesData($scope.fd.linkedResourceDefId ,$scope.fd.linkedResourceId ); 
          });
		  
      
              
        //get files (first everything then filter by dataset)
        if (!$scope.resourceDefinition.form_definition && $scope.fd.AutoSearch && !$scope.fd.HasParentDataset) $scope.fd.getFilesData($scope.fd.Related,0);
        else if ($scope.fd.GridState?.columnsDef!==undefined) $scope.fd.fileListDownloaded = true
                                 
            //ILJU fetch from server tItemValue ktTaskFiles - not needed (widget dependencies will be depreated)
          $scope.formType=$scope.resourceDefinition.form_type;
          /*
          if ($scope.fd.PresentationId!=undefined && $scope.fd.PresentationId!=null) {
          TaskDataService.getWidgetDependencies($scope.taskId,$scope.fd.PresentationId,$scope.formType).then(function(data) {
                               
                                $scope.fd.tItemValue=data.data;
                                $scope.fd.ProcessWidgetDependencies();
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
       
          }*/
             
         },//ktTaskFile $CONTROLER
        link: function (scope, elem, attrs) {
          
      
		}//LINK ktTaskFiles
    }
}; //ktTaskFiles END
'use strict';

export function ktTaskForm () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktTaskForm.html',
             controller: function($scope,TaskDefinitionService,TaskDataService,MessagingService,GridsterService,WidgetRegisterService,ProcessingService,
              ResourcesDataService,KatalyoStateManager,WidgetDataExchangeService,dragulaService,$stateParams,$rootScope,$timeout){
                $scope.tds=TaskDefinitionService;
                
                $scope.resourceObject = $stateParams.resource;
                $scope.CTRL='ktTaskForm'
                $scope.formLoaded=false;
                $scope.formVersion={};
                $scope.resourceId=$stateParams.id;
                $scope.gsrvc = GridsterService;
                $scope.showFieldProperties = false;
                $scope.formType=$scope.tds.showTaskFormFn();

                $scope.taskDefinition.ResourceDefId_id=$scope.resourceId;
                $scope.taskDefinition.form_type=$scope.formType;
                $scope.taskDefinition.form_definition=true;

                $scope.gridsterType="task";
                $scope.refreshForm=false;
                $scope.dashboard = {'i':{},'e':{}};
                $scope.reloadTaskToolbox = false;
                if ($scope.localVars==undefined) $scope.localVars={};
                
                $scope.localVars.cbAutoExecuteChanged = false;
                $scope.localVars.cbAutoInitiateChanged = false;
                // $scope.gsrvc.destroyDragula('bag-columns');
                // $scope.gsrvc.destroyDragula('bag-rows-'+$scope.gridsterType);
                 
                 //$rootScope.$emit('RegisterTaskWidgets',null);
                 
                // WidgetRegisterService.ListenToEvents();
                // WidgetRegisterService.EmitRegisterTaskWidgetEvent();
                 
                 WidgetDataExchangeService.deRegisterAllWidgets();	
                 
                 $scope.hideTabIndex = true;
                 $scope.outcomes = {outcomeCodesDetails:[]};
                 $scope.outcomes.selectedOutcomeIndex=-1;
                 $scope.dashboardLocal ={widgets:{layout: GridsterService.getEmptyTaskForm(),data:{}}};
                 var lang=$rootScope.globals.currentUser.lang;
                
                $scope.ksm = KatalyoStateManager;

                var form_saved = function(data)
                    {
                        formDefinitionState.subject.setStateChanges = data;
                        formDefinitionState.subject.notifyObservers("formSaved");
                    };
                
               
                var formDefinitionState,formDefinitionStateName;   
                $scope.setupKatalyoStateManager = function()
                {
                    formDefinitionState= $scope.ksm.addSubject('formDefinitionState'+$scope.resourceId+$scope.taskDefinition.form_type,null);
                    formDefinitionStateName = formDefinitionState.subject.name;
                    
                    let action_value_changed = $scope.ksm.addAction(formDefinitionStateName,"formSaved",form_saved);
                    
                }
                 $scope.setupKatalyoStateManager();
                 
                $scope.ShowFormView = function(viewId,locked)
                {
                   //$timeout(function(){
                    if ($scope.taskDefinition.formParams===undefined) 
                    {
                       $scope.taskDefinition.formParams={} 
                    }
                       
                        $scope.taskDefinition.formParams.formViewType=viewId;
                        $scope.gsrvc.setFormViewType($scope.taskDefinition.formParams.formViewType);

                  //  })
                  
                         
                };
            
           
                $scope.showHideTaskForm = function(form_type)
                {
                        
                        $scope.tds.showHideTaskForm(form_type);
                        $scope.resourceDefinition.form_type=form_type;
                        $scope.ShowFormView(1,false);
                        $scope.setupKatalyoStateManager();
                        $scope.ksm.executeAction("taskDefinitionState"+$scope.resourceId,"formTypeChanged",form_type)
             
                };
                      
                $scope.showHideProperties = function(value)
                {
                        $scope.gsrvc.setFieldPropertiesOpened(value);
                        $scope.showFieldProperties=$scope.gsrvc.getFieldPropertiesOpened();
             
                };
            
            $scope.$watch('gsrvc.getFieldPropertiesOpened()',function(newValue,oldValue){
                    
                    if (newValue!=oldValue)
                    {
                     $scope.selectedField=$scope.gsrvc.getFieldProperties();
                     $scope.showFieldProperties = $scope.gsrvc.getFieldPropertiesOpened();
                    }
            });
            
            
             $scope.$watch('gsrvc.getFieldProperties()',function(newValue,oldValue){
                    
                    if (newValue!=oldValue)
                    {
                     $scope.selectedField=$scope.gsrvc.getFieldProperties();
                     $scope.showFieldProperties = $scope.gsrvc.getFieldPropertiesOpened();
                    }
            });
   
   
          
      //save task parameters
      /*
      $scope.saveTaskParameters = function(){
        
      
        
        TaskDataService.SaveTaskParameters($scope.taskDefinition.id,$scope.taskDefinition).then(function(data) {
 
                                  MessagingService.addMessage(data.msg,'success');
                                  $scope.taskDefinition = data.data;
                                  $scope.taskDefinition.form_type=$scope.formType;
                                  $scope.taskOriginal=angular.copy($scope.taskDefinition);
                                  $scope.localVars.cbAutoInitiateChanged = false;
                                  $scope.localVars.cbAutoExecuteChanged = false;
                            },function(error){     
                                  MessagingService.addMessage(error.msg,'error');   
                             });  
      };
         
      */

  
  
  /*
             $scope.getTaskParameters = function(){
                TaskDataService.GetTaskParameters($scope.resourceId).then(function(data) {
                                         //  $scope.ac.alerts = data.data;
                                      
                                      if (data.length>0) {
                                                                               
                                          $scope.taskDefinition = data[0];
                                          $scope.taskDefinition.form_type=$scope.formType;
                                          $scope.taskDefinition.form_definition=true;

                                          $scope.getResourceForm();

                                          if (!$scope.taskDefinition.InfiniteTask)
                                          {
                                                 //get Task Outcomes 
                                              if ($scope.taskDefinition.TaskOutcomeHeadId == null || $scope.taskDefinition.TaskOutcomeHeadId==undefined)
                                                  {
                                                   $scope.taskDefinition.TaskOutcomeHeadId=0; //vidjeti da li ovo treba MIGOR
                                                  }
                                         
                                            
                                              //TaskDataService.GetTaskCodesActionsById($scope.resourceId,lang,$scope.taskDefinition.TaskOutcomeHeadId).then(function(data) {
                                              if ($scope.form_type==="e")
                                              {
                                                TaskDataService.GetTaskOutcomes($scope.resourceId,$scope.taskDefinition.TaskOutcomeHeadId,lang).then(function(data) {            
                                                                        $scope.outcomes.outcomeCodesDetails = data.data;
                                                                        $scope.taskDefinition = {outcomes:{outcomeCodesDetails:data.data}};
                                                                        //prikazi defaultno detalje od prvog
                                                                       // if ($scope.outcomes.outcomeCodesDetails.length>0)   $scope.clickedOutcome = $scope.outcomes.outcomeCodesDetails[0];
                                                                        
                                                                  },function(error){
                                                                        MessagingService.addMessage(error.msg,'error');
                                                                    });
                                              }
                                          }
                                          
                                            
                                      }  
                                   },function(error){
                                    
                                    MessagingService.addMessage(error.msg,'error');
                                    });
                                     
                                  
             };
        */        
     

            $scope.formFromServerLoaded = {};
            
            $scope.localVars.getResourceForm = function (afterSave,afterSaveMsg) {
                  if (!$scope.formFromServerLoaded[$scope.formType])
                  {
                    ResourcesDataService.getResourceForm($scope.resourceId,$scope.formType,lang).then(function(data) {
                                      
                                         var resourceFormData = data.data
                                         $scope.resourceDefinition = resourceFormData.resourceDefinition
                                          ResourcesDataService.GetWidgetToolbox($scope.resourceDefinition.ResourceCode).then(
                                          
                                          function (widgetData) {
                                            
                                             if ($scope.gsrvc.taskToolboxItems==undefined || $scope.gsrvc.taskToolboxItems.length==0)   $scope.gsrvc.setTaskToolboxItems(widgetData.data);
                                                
                                                
                                              if (resourceFormData.widgets.length>0) {
                                                $scope.dashboard[$scope.formType]={widgets:{layout:resourceFormData.widgets}}
                                             }else {
                                              $scope.dashboard[$scope.formType] = {widgets:{layout:$scope.resourceDefinition.ResourceExtended.DefaultForm}}
                                             }
                                            
                                             $scope.formVersion [$scope.formType] = $scope.resourceDefinition.FormVersion;
                                            
                                             //$scope.gsrvc.setTaskFormVersion($scope.resourceDefinition.id+$scope.formType,$scope.formVersion[$scope.formType]); 
                                             $scope.gsrvc.setTaskFormVersion($scope.resourceDefinition.id + $scope.formType,{Version:$scope.resourceDefinition.Version,Published:$scope.resourceDefinition.Published,NewVersion:$scope.resourceDefinition.NewVersion});  
 
                                             $scope.resourceDefinition.formParams={formViewType:1,showGridNavigation:false};
                                             if ($scope.gsrvc.formLocked == true)   $scope.resourceDefinition.formParams.formViewType = 2;
                                            
                                           
                                             $scope.formLoaded=true;
                                             $scope.formFromServerLoaded[$scope.formType] = true;
                                             $scope.ShowFormView($scope.resourceDefinition.formParams.formViewType,false);
                                             //debugger; //getResourceForm migor
                                        
                                        
                                            
                                         },function(error){
                                             MessagingService.addMessage(error.msg,'error');  
                                         }); 
                                         
                                         
                        

                                         
                                         
                                         if (afterSave)
                                         {
                                           MessagingService.addMessage(afterSaveMsg,'success');
                                          
                                         }
                                      },function(error){
                                   
                                        
                                       MessagingService.addMessage(error.msg,'error');
                                      
                                      
                                   });
                  }
            };
        

    $scope.newVersion = function()
    {
        $scope.creatingNewVersion=true
        ResourcesDataService.SetNewResourceVersion($scope.resourceId)
                .then(function(data) {
                    if (data.status==200)
                    {
                    
                        $scope.resourceDefinition.NewVersion = data.data
                        $scope.resourceDefinition.Published=false
                        $scope.formVersion [$scope.formType] = {NewVersion:data.data,Published:false}
                        $scope.gsrvc.setTaskFormVersion($scope.resourceDefinition.id+$scope.formType,$scope.formVersion[$scope.formType]);
                    }else MessagingService.addMessage(data.data,'error');
                    $scope.creatingNewVersion=false
         
                   },function(error){
                                  MessagingService.addMessage(error.msg,'error');
                                  $scope.creatingNewVersion=false
                                 
                             });

    };
        
    $scope.get_published_resource_forms=function(){               
        ResourcesDataService.GetPublishedResources($scope.resourceId).then(function (data) {       
           $scope.publishedResources = data.data;
        });
    }
    $scope.get_published_resource_forms();   
        //**********************************************************
          //           SAVE TASK FORM DEFINITION
          //**********************************************************
     $scope.showSaveModal = function (p_type) {
       //POST publish-resource , resource_id, version i description
        //$scope.saveModal=true;
        $('#taskPublish').modal('show'); 
        $scope.saveOrPublish='save'
        $scope.newPublishVersion =  $scope.gsrvc.resourceFormVersion[$scope.resourceDefinition.id+$scope.formType].NewVersion

        
    }
        $scope.saveTaskForm = function (form) {

            if (form.$valid)
            {
               $scope.activity.activityMessage = ProcessingService.setActivityMsg('Saving task form for '+$scope.resourceId);
               $scope.savingTaskForm = true;
               $('#taskPublish').modal('hide') 
               ResourcesDataService.saveResourceForm($scope.dashboard[$scope.formType].widgets.layout,$scope.resourceId,$scope.formType,$scope.localVars.newDescription).then(function(data) {
                                        
                                        MessagingService.addMessage(data.msg,data.msgType);
                                        $scope.formVersion [$scope.formType] = {Version:data.version,Published:true}
                                        $scope.resourceDefinition.FormVersion={Version:data.version}
                                        $scope.gsrvc.setTaskFormVersion($scope.resourceDefinition.id+$scope.formType,$scope.formVersion[$scope.formType]); 
                                        $scope.ksm.executeAction(formDefinitionStateName,"formSaved",data.new_items);
                                        $scope.savingTaskForm = false;
                                        let rememberTaskFormFn = $scope.tds.showTaskFormFn()
                                        
                                        if (data.data.formData.length>0) {
                                            $scope.dashboard[$scope.formType]={widgets:{layout:data.data.formData}}
                                            $scope.tds.showHideTaskForm('')
                                            $timeout(function(){ 
                                                 $scope.tds.showHideTaskForm(rememberTaskFormFn)
                                            })
                                            
                                        }   
  
                                        $scope.formLoaded=true;
                                        $scope.formFromServerLoaded[$scope.formType] = true;
                                        $scope.get_published_resource_forms()
                                      //   $timeout(function(){ 
                                           
                                      //  })
                                        // $scope.ShowFormView($scope.resourceDefinition.formParams.formViewType,false);
                                         
        
                                   },function(error){
                                     
                                       $scope.savingTaskForm = false;
                                       MessagingService.addMessage(error.msg,'error');
                                    });
                                      
             }                     
        };

              
         //**********************************************************
          //           SAVE TASK BUTTONS
          //**********************************************************      
        $scope.saveTaskBtns = function () {
       
          
               //$scope.activity.activityMessage = ProcessingService.setActivityMsg('Saving task btns for '+$scope.resourceId);
               
               TaskDataService.SaveTaskBtns($scope.resourceDefinition.initTaskBtnDef,$scope.resourceId,lang).then(function(data) {
                                       
                                        
                                       MessagingService.addMessage(data.msg,'success');
                                  
                                   },function(error){
                                        
                                       MessagingService.addMessage(error.msg,'error');
                                      
                                    });
                                      
                                  
       
              };
              

             
                             
            $scope.$on('CtrlPBPressed',function(event,data){
                  
                var key=data;
                if (key=='b' || key=='B')
                {
                    if ($scope.resourceDefinition.formParams.formViewType!=1) $scope.ShowFormView(1);
            
                }
                if (key=='p' || key=='P')
                {
                    if ($scope.resourceDefinition.formParams.formViewType!=2) $scope.ShowFormView(2);
                }
                  
            });  
          
           //**********************************************************
          //           CALL FUNCTIONS FOR FETCHING TASK FORM, PARAMETERS, OUTCOMES
          //**********************************************************
          
           $scope.$watch('tds.showTaskFormFn()',function(newValue,oldValue){
                    
                     $scope.formType = newValue;
                     //$scope.ksm.executeAction("taskToolBox","toolboxLoaded",{widget_id:null,state:false});
                     
                     if ($scope.resourceId != undefined)
                        {
                            $timeout(function() {
                                $scope.localVars.getTaskParameters()
                            })
                            
                           
                        }
            
                        
                    
                  });
           
            
                
                },
             link: function (scope, elem, attrs) {
              
            
            
             
                  
                  
            }
        }
};
'use strict';

export function ktTaskformlayout () {
        return {
            restrict: 'A',
            
			controller: function ($scope,dragulaService,$rootScope,WidgetDataExchangeService,GridsterService,$compile,$element,$templateCache) {
                    
                $scope.CTRL="ktTaskformlayout"
				$scope.removeField = function (index){
						// console.log("REMOVE FIELD "+index);
						if (index > -1) {
                        
                            WidgetDataExchangeService.deRegisterWidget($scope.inputArray.layout[index].LocalId);
                            if ($scope.inputArray.layout[index].Saved==true && $scope.inputArray.layout[index].PresentationId!=null && $scope.inputArray.layout[index].PresentationId!=undefined) {
								
                                 $scope.inputArray.layout[index].Status="Deleted";
							 }else
                             {
                                $scope.inputArray.layout.splice(index,1);
                                
                             }
                             
						}

				};
                
       
                let template;
               if ($scope.resourceDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktTaskFormLayout.html');
               else template = $templateCache.get('ktdirectivetemplates/ktTaskFormLayoutExe.html');
          
               $element.append($compile(template)($scope));

			},
			 link: function (scope, elem, attrs) {

                if (scope.inputArray.layout==undefined || scope.inputArray.layout==null) scope.inputArray.layout = [];
          
            }
        };
};
'use strict';

export function ktTaskForPage () {
        var controller = ['$scope', '$stateParams','$state','$rootScope','GridsterService','WidgetDataExchangeService','ResourcesDataService','KatalyoStateManager','$templateCache','$compile','$element','TaskDefinitionService',
                               function ($scope,$stateParams,$state,$rootScope,GridsterService,WidgetDataExchangeService,ResourcesDataService,KatalyoStateManager,$templateCache,$compile,$element,TaskDefinitionService) {

        $scope.CTRL="ktTaskForPage"
        let lang = $rootScope.globals.currentUser.lang
        if ($scope.fd==undefined) $scope.fd={};
        if ($scope.fd.localVars==undefined) $scope.fd.localVars={};             
        if ($scope.resourceDefinition==undefined) $scope.resourceDefinition={};            
        if ($scope.fd.localVars.previousTask==undefined) $scope.fd.localVars.previousTask = 0;
        if ($scope.fd.localVars.outcomeId==undefined) $scope.fd.localVars.outcomeId = 0;
        $scope.fd.localVars.loadTaskDirect = true;
        $scope.fd.localVars.taskDefinition = {};
        $scope.fd.localVars.taskDefinition.page_state_id = $scope.resourceDefinition.page_state_id
        $scope.fd.localVars.taskId = $scope.fd.Parameters?.taskDefId?.id
        $scope.ksm = KatalyoStateManager
        $scope.tds = TaskDefinitionService
        $scope.gsrvc=GridsterService
        
        let widgetDefinition = {name: 'taskForPage',widgetId: $scope.fd.LocalId,taskId:  $scope.resourceDefinition.id };
        $scope.fd.LocalId=WidgetDataExchangeService.registerWidget(widgetDefinition);
        
        let dependent_field_pid = $scope.fd.LocalId;
        let subscribedSubjectPid = "formDefinitionState"+$scope.taskId+$scope.resourceDefinition.form_type;
        let dependent_field_pid2
             
        let update_presentation_id2 = function(data) {
            let presentation_id = angular.copy($scope.fd.PresentationId)
            if (data[presentation_id]!==undefined) {
                    $scope.fd.PresentationId = data[presentation_id];
                //unsubscribe here later after implementing unsubscribe - ToDo
                dependent_field_pid2 = $scope.fd.PresentationId
                let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
                }
        }
        
        let update_presentation_id = function(data) {
            if (data[$scope.fd.LocalId]>0 && $scope.fd.PresentationId==0 && data[$scope.fd.LocalId]!==undefined) $scope.fd.PresentationId = data[$scope.fd.LocalId];
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
            //unsubscribe here later after implementing unsubscribe - ToDo
        }
        
                

        $scope.fd.localVars.toggleDropdown = function(){
                $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
        }

        $scope.fd.localVars.showProperties=function(datasetMapperType,showPropertiesRight) {
                    
             if ($scope.fd.localVars.datasetMapperType==undefined) {
                $scope.fd.localVars.datasetMapperType = datasetMapperType;
             }else  {
                if ($scope.fd.localVars.datasetMapperType==0 || $scope.fd.localVars.datasetMapperType!=datasetMapperType) 
                     $scope.fd.localVars.datasetMapperType = datasetMapperType;
                else 
                    $scope.fd.localVars.datasetMapperType=0;
             }
             if (showPropertiesRight) $scope.gsrvc.setFieldProperties($scope.fd);            
         }  


        // **************  EXECUTE ON INIT ****************
        
        if ($scope.fd.PresentationId===null || $scope.fd.PresentationId===0) {
            let observerPid = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid,"formSaved",update_presentation_id);
        } else {
            dependent_field_pid2 = $scope.fd.PresentationId
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
        }

 
    
         let template;
         template = $templateCache.get('ktdirectivetemplates/ktTaskForPage.html');
             
          
         $element.append($compile(template)($scope));

       }];
          
          
        return {
            restrict: 'A',
            controller:controller,
             link: function (scope, elem, attrs) {
                 

              }
        }             
};
'use strict';

export function ktTaskIntegrationWidget () {
   
   var controller = ['$scope', '$uibModal', '$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','KatalyoStateManager','UtilityService','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,KatalyoStateManager,UtilityService,$templateCache,$compile,$element) {
     
      $scope.gsrvc = GridsterService;
      var lang=$rootScope.globals.currentUser.lang;
      $scope.localVars.widgetType = 5;
      $scope.fd.PopulateType = "4";
      $scope.localVars.formParams={formViewType:1,showGridNavigation:true};
      if ($scope.formData==undefined) $scope.formData={};
      if ($scope.formData[$scope.fd.PresentationId]==undefined) $scope.formData[$scope.fd.PresentationId]=[{}];
      
      $scope.localVars.datasetMapperType=0;
           
      $scope.localVars.gridsterType="resource";
          // $scope.gridsterOpts = GridsterService.getGridsterOptions();
    
    
        
      $scope.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: []
      } ;
      
       if ($scope.localVars == undefined) $scope.localVars={};
                
        $scope.localVars.showMenu = false
      
        $scope.localVars.toggleDropdown = function(){
                                       $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
         }
        
    
  
      //$scope.taskId=$stateParams.id;
      $scope.taskId=$scope.resourceDefinition.ResourceDefId;
      if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
      if ($scope.taskId==undefined) $scope.taskId=0;
      $scope.localVars.taskId=$scope.taskId;
      $scope.fd.ParentDatasetDefId=$scope.fd.Related;
      $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
      $scope.localVars.formType=$scope.resourceDefinition.form_type;
      $scope.source_type=$scope.resourceDefinition.source_type;
      $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
      $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
      $scope.formDefinition = $scope.resourceDefinition.form_definition;
      
       if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
      $scope.localVars.resourceRecordId=0;
      if ($scope.taskInitiateId==undefined)
      {
        $scope.taskInitiateId =0;
      
      }
      if ($scope.taskExecuteId==undefined)
      {
         $scope.taskExecuteId =0;  
      }
        if ($scope.prevTaskExeId==undefined)
        {
            $scope.prevTaskExeId =0;
        }
        
      //register widget 
      var out_fields = ['resourceId'];
      //if ($scope.fd.LocalId==undefined || $scope.fd.LocalId==null || $scope.fd.LocalId==0)
      //{
         var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'viewResourceWidget',widgetId: $scope.fd.PresentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resourceDefId : $scope.localVars.selectedResource, output:out_fields, };
         $scope.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
         $scope.localVars.LocalId=$scope.localVars.localWidgetId;
         $scope.fd.LocalId=$scope.localVars.localWidgetId;
         //$scope.fd.LocalId=UtilityService.uuidNow();
         
      //}
      $scope.ksm = KatalyoStateManager;
      
      let dependent_field_pid = $scope.fd.LocalId;
        let subscribedSubjectPid = "formDefinitionState"+$scope.taskId+$scope.resourceDefinition.form_type;
        let dependent_field_pid2
        let update_presentation_id2 = function(data) {
            let presentation_id = angular.copy($scope.fd.PresentationId)
            if (data[presentation_id]!==undefined)
            {
                $scope.fd.PresentationId = data[presentation_id];
            //unsubscribe here later after implementing unsubscribe - ToDo
            dependent_field_pid2 = $scope.fd.PresentationId
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
            }
        }
        let update_presentation_id = function(data) {
            if (data[$scope.fd.LocalId]>0 && $scope.fd.PresentationId==0 && data[$scope.fd.LocalId]!==undefined) $scope.fd.PresentationId = data[$scope.fd.LocalId];
          
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
            //unsubscribe here later after implementing unsubscribe - ToDo
        }
        
        
        if ($scope.fd.PresentationId===null || $scope.fd.PresentationId===0)
        {
            let observerPid = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid,"formSaved",update_presentation_id);
        } else{
            dependent_field_pid2 = $scope.fd.PresentationId
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
        }
             
      
       let apply_value = function(data)
        {
            let do_refresh=false;
            if (data!=undefined)
            {
               if (data != $scope.localVars.resourceRecordId)
               {
                  if (typeof data ==='number') $scope.localVars.resourceRecordId= data;
                  else if (Array.isArray(data))
                  {
                     if (data.length>0)
                     {
                      $scope.localVars.resourceRecordId= data[0].id  
                     }
                  }else
                  {
                     $scope.localVars.resourceRecordId = data.id;
                  }
                  do_refresh = true;
               }
            }
            //get selectedRecord
            if ($scope.localVars.resourceRecordId == null) $scope.localVars.resourceRecordId=0;
            
            if ($scope.localVars.resourceRecordId>0 && do_refresh) $scope.localVars.getFormResourceWithData();
            
            
        };
        
      
      if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
      
      if ($scope.fd.Parameters.RefreshOnIdChange)
      {
         
         //find 
         //subscribe observer
           
         let dependent_field = "Field"+$scope.fd.PresentationId;
         let subscribedSubject = "integrationValueStateName"+$scope.fd.Parameters.ResourceIdItemId+$scope.resourceDefinition.transaction_id;
         let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
         let val = $scope.ksm.getState(subscribedSubject);
         $scope.localVars.resourceRecordId= val.id;
            
            //get selectedRecord
         if ($scope.localVars.resourceRecordId == null) $scope.localVars.resourceRecordId=0;
            
         if ($scope.localVars.resourceRecordId>0) $scope.localVars.getFormResourceWithData();
      }
      
      
      //subscribe observer
      if ($scope.fd?.PopulateType?.toString().substr(0,1)=="4")
      {
           /**********************************************************************
         ****************** Sync data with State manager **********************
         ***********************************************************************/
       
       
        if ($scope.fd.SrcWidgetId!=undefined && $scope.fd.SrcWidgetId!=null)
        
        {
           
                let dependent_field = "Field"+$scope.fd.SrcWidgetId;
               // let subscribedSubject = $scope.fd.Parameters.SrcWidgetType+"ValueStateName"+$scope.fd.SrcWidgetId;
                let subscribedSubject = "integrationValueStateName"+$scope.fd.SrcWidgetId+$scope.resourceDefinition.transaction_id;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
            
        }  
         
      }
      
        // MIGOR DODAO 2.6.2021- PROVJERITI -POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
        $scope.fd.getResources = function()  {				
                if ($scope.localVars.resourceList==undefined) $scope.localVars.resourceList=[];
                var lang=$rootScope.globals.currentUser.lang;
                ResourcesDataService.getResourceDefListByType(lang,'integration').then(
                    function(data) {
                           $scope.localVars.resourceList = data.data;
                           $scope.localVars.resourcesLoaded = true;
                           $scope.localVars.setSelectedIntegration($scope.fd.Related);
                    },function(error){    
                            MessagingService.addMessage(error.msg,'error');
               });
			}
                                 
      $scope.fd.getResources();
      let refresh_widget_data = function()
      
      {
         $scope.localVars.getFormResourceWithData();    
         
      }
           
      $scope.localVars.showProperties=function(datasetMapperType)
      {
            
            if ($scope.localVars.datasetMapperType==undefined)
            {
               $scope.localVars.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.localVars.datasetMapperType==0 || $scope.localVars.datasetMapperType!=datasetMapperType) $scope.localVars.datasetMapperType = datasetMapperType;
               else $scope.localVars.datasetMapperType=0;
            }
            
      };
           
      $scope.localVars.setField = function(form,name,value,msg)
      {
         TaskDataService.setField(form,name,value);
         if (msg) MessagingService.addMessage(msg,'info');
      };  
      
       $scope.localVars.confirmIntegration = function()
      {
       //  $scope.localVars.selectedResourceItem.src_type_text = $scope.localVars.src_type_text[$scope.fd.RelatedPopulateType];
         $scope.localVars.name_confirmed = $scope.localVars.selectedResourceItem.name +' ('+$scope.localVars.selectedResourceItem.id +')'
         //$scope.fd.PopulateType=$scope.fd.RelatedPopulateType+$scope.fd.formPriority;
      
         $scope.fd.Related=$scope.localVars.selectedResourceItem.id;
         $scope.localVars.getFormResource();
         $scope.localVars.integrationConfirmed = true;
         $timeout(function(){
            $scope.localVars.integrationConfirmed = false;
         },2000);
      };  

      
      $scope.localVars.getFormResourceOriginal = function(){
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
               let datasetId = $scope.localVars.datasetFormParams.Parameters.dataset.id;
              ResourcesDataService.getResourceForm(datasetId,"i",lang).then(function(data) {
                            
                                $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                if (Array.isArray(data.data.widgets)) $scope.localVars.dashboard.widgets.layout =  data.data.widgets;
                                
                                $scope.fd.wItemValue=data.data.widgets;
                                
                       
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.fd.ResourceRecordId}]}]});
						
                                  $scope.localVars.searchFormDownloaded = true;
                                  $scope.localVars.formLoaded=true;
                                
                                
                               // $scope.localVars.setField($scope.localVars.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVars.setField($scope.localVars.dashboard.widgets.layout,'Required',false);     
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
        
        $scope.localVars.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
               $scope.localVars.formLoaded=false;
               if ($scope.fd.PresentationId==null)
               {
                    $scope.fd.PresentationId=0;
            
               }
               $scope.localVars.formLoading=true;
                
                let datasetId;
                //if ($scope.fd.Parameters.FormSaved)
                datasetId = $scope.fd.Related;
                //else  datasetId= $scope.localVars.datasetFormParams.Parameters.dataset.id;
              ResourcesDataService.getResourceFormExtended(datasetId,$scope.taskId,$scope.localVars.formType,$scope.fd.PresentationId,"w",lang).then(function(data) {
                               
                                  $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                  if (Array.isArray(data.data.widgets)) $scope.localVars.dashboard.widgets.layout =  data.data.widgets;
                               
                                $scope.fd.wItemValue=data.data.widgets;
                               
                                
                                  
                                $scope.localVars.searchFormDownloaded = true;
                                
                                $timeout(function(){    
                                   $scope.localVars.formLoaded=true;
                                   $scope.localVars.formLoading=false;
                                });
                                  
                               
                              //  $scope.localVars.setField($scope.localVars.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVars.setField($scope.localVars.dashboard.widgets.layout,'Required',false);
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 $scope.localVars.formLoading=false;
                                 
                                
                             });
                              
      };
      
              
        $scope.localVars.getFormResourceWithData = function(){
              var lang=$rootScope.globals.currentUser.lang;
              $scope.localVars.formLoaded=false;
              if ($scope.fd.PresentationId==null || $scope.fd.PresentationId==undefined)
              {
                $scope.fd.PresentationId = 0;
                
              }
              
              if ($scope.fd.ParentElementId==null || $scope.fd.ParentElementId==undefined)
              {
                $scope.fd.ParentElementId = 0;
                
              }
              
              
              
              
               if ($scope.localVars.resourceRecordId==undefined || $scope.localVars.resourceRecordId==0)
               {
                
                  if ($scope.localVars.previousTaskData['datasetRecordId']!=undefined && $scope.localVars.previousTaskData['datasetRecordId']!="" && $scope.localVars.previousTaskData['datasetId']==$scope.fd.Related) $scope.localVars.resourceRecordId = $scope.localVars.previousTaskData['datasetRecordId'];
                
               }
               if (typeof $scope.localVars.resourceRecordId !=='number' && typeof $scope.localVars.resourceRecordId !=='string')
               {
                  
                  if (Array.isArray($scope.localVars.resourceRecordId))
                  {
                     if ($scope.localVars.resourceRecordId.length>0)
                     {
                        $scope.localVars.resourceRecordId= $scope.localVars.resourceRecordId[0].id  
                     
                     }
                  }
                  else $scope.localVars.resourceRecordId = $scope.localVars.resourceRecordId.id;                 
               }
               //let datasetId = $scope.localVars.datasetFormParams.Parameters.dataset.id;
               let datasetId = $scope.fd.Related;
               
              ResourcesDataService.getResourceFormExtendedWithData(datasetId,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.PopulateType,$scope.fd.ParentElementId,$scope.fd.PresentationId,$scope.prevTaskExeId,$scope.localVars.formType,$scope.localVars.widgetType,$scope.localVars.resourceRecordId,"w",lang).then(function(data) {

                                  $scope.formData[$scope.fd.PresentationId] =  data.data.form_data;
                                  if ($scope.formData[$scope.fd.PresentationId]==undefined) $scope.formData[$scope.fd.PresentationId]=[];
                                  $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                  if (Array.isArray(data.data.widgets)) $scope.localVars.dashboard.widgets.layout =  data.data.widgets;
                                 
                                  if ($scope.formData[$scope.fd.PresentationId].length>0)
                                  {
                                    $scope.localVars.resourceRecordId = $scope.formData[$scope.fd.PresentationId][0]['id'];
                                  }
                                  $scope.localVars.datasetRecordId=$scope.localVars.resourceRecordId;
                                  
                                  $scope.localVars.formLoaded=true;
                                    
                                 $scope.localVars.formLoading=false;
                                 $scope.localVars.searchFormDownloaded = true;
                                      
                               
                                   
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - VIEW_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.resourceRecordId}]}]});
                                
                               // $scope.localVars.setField($scope.localVars.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVars.setField($scope.localVars.dashboard.widgets.layout,'Required',false);   
                                },function(error){
                                    MessagingService.addMessage(error.msg,'error');
                                    $scope.localVars.formLoaded=true;
                                    
                                    $scope.localVars.formLoading=false;
                                    $scope.localVars.searchFormDownloaded = true;
                             });
                              
      };
      
       $scope.localVars.callApi = function () {
         let apiEndPoint = $scope.localVars.datasetFormParams.Parameters.APIEndpoint;
         let method = $scope.localVars.datasetFormParams.Parameters.APIMethod;
         let form_data = $scope.formData[$scope.fd.PresentationId][0];
         ResourcesDataService.CallApiGeneric(apiEndPoint,method,form_data).then(function(data){
               MessagingService.addMessage(data.data.msg,'success');
            
            },function(error){
                                   MessagingService.addMessage(error.data.msg,'error');
                                
            });
       }
      $scope.getDatasetParams = function () {
            
            
            ResourcesDataService.getResourceDefAll($scope.fd.Related).then(function(data) {
                               
                             // MessagingService.addMessage(data.msg,'success');
                              $scope.localVars.datasetFormParams = data.data;
                              
                              if (!$scope.formDefinition && !$scope.localVars.searchFormDownloaded)
                                 {
                                     
                                     $scope.localVars.getFormResourceWithData();
                                   
                                 }else
                                 {
                                    $scope.localVars.getFormResource();
                                   
                                 } 
                               
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        };      
      
           $scope.localVars.setSelectedIntegration = function(id)  {
              
              if ($scope.localVars.selectedResourceItem==undefined) $scope.localVars.selectedResourceItem={};
              var pos = $scope.localVars.resourceList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVars.selectedResourceItem = $scope.localVars.resourceList[pos];

                $scope.localVars.name_confirmed = $scope.localVars.selectedResourceItem.name +' ('+$scope.localVars.selectedResourceItem.id +')';
                
                }
					}
  

$scope.localVars.getPreviousTaskWidget  = function(linkType)
    {
      var pTaskData;
      var pTaskDataRet = WidgetDataExchangeService.getPrevTaskData($scope.prevTaskExeId);
      if (Array.isArray(pTaskDataRet) && pTaskDataRet.length>0) pTaskData = pTaskDataRet[0];
            var datasetId=0,datasetRecordId=0;
            if (pTaskData!=undefined)
            {
               if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
               {
               for (var i=0;i<pTaskData.DEI.length;i++)
               {
                 if (pTaskData.DEI[i].name==linkType)
                 {
                   if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                   {
                     for (var j=0;j<pTaskData.DEI[i].value.length;j++)
                     {
                      if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined) datasetId=pTaskData.DEI[i].value[j].value;
                      if (pTaskData.DEI[i].value[j].name=="resourceRecordId" && pTaskData.DEI[i].value[j].value!=undefined) datasetRecordId=pTaskData.DEI[i].value[j].value;
                      
                       
                     }
                        
                       
                   }
                     
                 }
                   
                 }
               }
            }
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };


   
   
  $scope.localVars.previousTaskData=$scope.localVars.getPreviousTaskWidget("resourceLinkDatasetList");
 
  if ($scope.fd.Related!=null) $scope.getDatasetParams();
 
            let template;
            if ($scope.formDefinition) template = $templateCache.get('ktdirectivetemplates/ktTaskIntegrationWidget.html');
            else template = $templateCache.get('ktdirectivetemplates/ktTaskIntegrationWidget.html');
          
            $element.append($compile(template)($scope)); 

  
      }];

  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

            }     
  }
  
};
'use strict';

export function ktTaskListWidget () {
             var controller = ['$scope', '$stateParams','$state','UserService','ResourcesDataService','$rootScope','ProcessingService','$timeout','$cookies','CodesService','WidgetDataExchangeService','TaskDataService','MessagingService','GridsterService','KatalyoStateManager','$q','$templateCache','$compile','$element','TaskDefinitionService',
                               function ($scope,$stateParams,$state,UserService,ResourcesDataService,$rootScope,ProcessingService,$timeout,$cookies,CodesService,WidgetDataExchangeService,TaskDataService,MessagingService,GridsterService,KatalyoStateManager,$q,$templateCache,$compile,$element,TaskDefinitionService) {
          
             var lang=$rootScope.globals.currentUser.lang;
             $scope.CTRL = "ktTaskListWidget"   
             if ($scope.localVars==undefined) $scope.localVars = {};                      
             $scope.stateName=$state.current.name;
             $scope.stateParams = $state.current.params;
             $scope.task_initiate_id=$stateParams.task_initiate_id;
             $scope.task_execute_id=$stateParams.task_execute_id;
             $scope.tds=TaskDefinitionService
                             
              $scope.is_superuser =  $rootScope.globals.currentUser.is_superuser;
            
             $scope.gridOptions = {
               data:[],
             enableGridMenu: true,
             //showGridFooter: true,
             //showColumnFooter: true,
             enableRowSelection: true,
             multiSelect: false,
             enableHorizontalScrollbar : 0, 
             enableVerticalScrollbar : 2,
             //enableFiltering: true,
             enableRowHeaderSelection: false,
             enableColumnResizing: true,
             useExternalPagination: true,
             paginationPageSizes: [10, 25, 50,100,200,500,1000],
             enablePaginationControls: false,
             //paginationPageSize: 10,
             //useExternalSorting : true,
             //useExternalFiltering: true,
            // minRowsToShow : 3
            };
                    
                  var paginationOptions = {
                    pageNumber: 1,
                    pageSize: 10,
                    sort: null
                    };
                  
                  $timeout(function(){  
                           $scope.localVars.pageSize =  paginationOptions.pageSize;
                  });
                  $scope.localVars.firstTime = true;
                var columnDefsInitiate = [  
                  { name: 'TaskInitiationId.id', displayName: 'Task Start ID', type: 'number', width:'5%',enableHiding: false, visible: true },
                  { name: 'TaskInitiationId.InitiatorId.name', displayName: 'Started by'},
                  { name: 'TaskInitiationId.Status.CodesDetailLang[0].Value', displayName: 'Task status' },
                  { name: 'TaskInitiationId.Resourcedef.resourcedeflang_set[0].Name', displayName: 'Task name' },
                  { name: 'TaskInitiationId.Resourcedef.resourcedeflang_set[0].Description', displayName: 'Task description' },
                  { name: 'TaskInitiationId.Resourcedef.id', displayName: 'Task def id',enableHiding: false,visible: false },
                  { name: 'TaskInitiationId.CreatedDateTime', displayName: 'Date created',enableHiding: false,type: 'date', cellFilter: 'date:\'dd.MM.yyyy HH:mm:ss:sss\'' },
                  { name: 'TaskInitiationId.CreatedBy.name', displayName: 'Created by'},
                  { name: 'ForGroup.name', displayName: 'For group'},
                  ];
                    
                   var columnDefsExecute = [
                         { name: 'id', displayName: 'Task Execute ID', type: 'number', width:'10%',enableHiding: false, visible: true },
                         { name: 'resourcedef[0].Name', displayName: 'Task name' },
                         { name: 'resourcedef[0].Description', displayName: 'Task description' },
                         { name: 'actualOwner.name', displayName: 'Task Owner'},
                         { name: 'status[0].Value', displayName: 'Task status' },
                        // { name: 'outcome[0].Name', displayName: 'Task outcome' },
                         { name: 'resourcedef[0].id', displayName: 'Task def id',enableHiding: false,visible: false },
                         { name: 'CreatedDateTime', displayName: 'Date created',enableHiding: false,type: 'date', cellFilter: 'date:\'dd.MM.yyyy HH:mm:ss:sss\'' },
                         { name: 'createdBy.name', displayName: 'Created by'},
                         ];   
                   
                    if ($scope.task_execute_id==undefined) $scope.task_execute_id = 0;
                    if ($scope.task_initiate_id==undefined) $scope.task_initiate_id = 0;
                    $scope.localVars.detailsClicked=false;
                    
                                    
                    $scope.localVars.showMenu = false
      
                    $scope.localVars.toggleDropdown = function(){
                               $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
                    }

                    if ($scope.fd.Search===undefined || $scope.fd.Search===null) $scope.fd.Search = {};
             
             
                let widgetDefinition = {name: 'taskExecuteWidget',widgetId: $scope.fd.LocalId,task_initiate_id:$scope.task_initiate_id,task_execute_id:$scope.task_execute_id,taskId:  $scope.resourceDefinition.id };
                $scope.fd.LocalId=WidgetDataExchangeService.registerWidget(widgetDefinition);
                
                $scope.ksm = KatalyoStateManager;
      
                 let dependent_field_pid = $scope.fd.LocalId;
        let subscribedSubjectPid = "formDefinitionState"+$scope.taskId+$scope.resourceDefinition.form_type;
        let dependent_field_pid2
        let update_presentation_id2 = function(data) {
            let presentation_id = angular.copy($scope.fd.PresentationId)
            if (data[presentation_id]!==undefined)
            {
                $scope.fd.PresentationId = data[presentation_id];
            //unsubscribe here later after implementing unsubscribe - ToDo
            dependent_field_pid2 = $scope.fd.PresentationId
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
            }
        }
        let update_presentation_id = function(data) {
            if (data[$scope.fd.LocalId]>0 && $scope.fd.PresentationId==0 && data[$scope.fd.LocalId]!==undefined) $scope.fd.PresentationId = data[$scope.fd.LocalId];
          
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
            //unsubscribe here later after implementing unsubscribe - ToDo
        }
        
        
        if ($scope.fd.PresentationId===null || $scope.fd.PresentationId===0)
        {
            let observerPid = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid,"formSaved",update_presentation_id);
        } else{
            dependent_field_pid2 = $scope.fd.PresentationId
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
        }
                    $scope.filter=$scope.fd.Search;
                   //ovo treba prilagoditi
                   if ($scope.fd.Search.taskListType==undefined) $scope.fd.Search.taskListType="claim";
                      
                      
                    
                     $scope.gridOptions.onRegisterApi = function (gridApi) {
                        $scope.gridApi = gridApi;
                        gridApi.selection.on.rowSelectionChanged($scope,function(row){
                         $scope.localVars.taskSelected=row.isSelected
                       
                         if(row.isSelected){
                           
                             
                               if ($scope.fd.Search.taskListType=="execute")
                               {
                                $scope.selectedTask=row.entity.id
                                $scope.task_execute_id = $scope.selectedTask;
                                $scope.selectedTaskDefId=row.entity.resourcedef.id
                                $scope.selectedTaskObject = row.entity;  
                               }
                               else
                               {
                                $scope.selectedTask=row.entity.TaskInitiationId.id
                                $scope.task_initiate_id = $scope.selectedTask;
                                $scope.selectedTaskDefId=row.entity.TaskInitiationId.Resourcedef.id
                                $scope.selectedTaskObject = row.entity.TaskInitiationId;  
                               }
                               
                            }
                        });
                        
                        //external pagination
                      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                          paginationOptions.pageNumber = newPage;
                          paginationOptions.pageSize = pageSize;
                          $scope.fd.ExecuteAllListPaginatedFilter($scope.fd.Search.taskListType,1,false,"",$scope.localVars.nextPage,$scope.localVars.previousPage,newPage,pageSize,$scope.filter);
                      });
                      
                       gridApi.core.on.filterChanged($scope, function() {
                           // Set some $scope variable that both lists use for filtering
                          // $$scope.someFilterValueBothListsLookAt = ......
                       });
                
                      
                     }
                   
                   
                  $scope.localVars.showProperties=function(datasetMapperType)
                  {
                   
                   if ($scope.localVars.datasetMapperType==undefined)
                   {
                      $scope.localVars.datasetMapperType = datasetMapperType;
                   }else
                   {
                      if ($scope.localVars.datasetMapperType==0 || $scope.localVars.datasetMapperType!=datasetMapperType) $scope.localVars.datasetMapperType = datasetMapperType;
                      else $scope.localVars.datasetMapperType=0;
                   }
                   
                  };
                      
              /*
                    $scope.removeField = function (index){
						
                        if (index > -1) {
						 
                           $scope.inputArray.layout.splice(index, 1);
						 
                        }

                  }
                */
                    $scope.ClaimSelected = function(){
                              
                              
                            var lang=$rootScope.globals.currentUser.lang;
                             TaskDataService.ExecuteTaskAction($scope.selectedTask,0,'claim',lang).then(function(data) {
                       
                                                   
                                                    
                                                    //refresh liste task-ova za claim
                                                    $scope.ExecuteAllList($scope.fd.Search.taskListType,1,true,data.data.msg);
                                                   
                                              },function(error){
                                                
                                            
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                      } 
                    
                    $scope.ExecuteAllList = function(type,filter,afterClaim,msgAfter){
                      
                      var lang=$rootScope.globals.currentUser.lang;
                      
                      TaskDataService.getInitiatedTasks(type,filter).then(function(data) {
                                                
                                                  $scope.gridOptions.data = data.data.results;
                                                 if (afterClaim)
                                                 {
                                                   MessagingService.addMessage(msgAfter,'success');
                                                  
                                                 }
                                               },function(error){
                                                
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                    }
                    
                    
                  
                  $scope.ExecuteAllListPaginated = function(type,filter,afterClaim,msgAfter,urlNext,urlPrev,newPage,pageSize){
                      
                      $scope.localVars.dataLoaded = false;
                      var lang=$rootScope.globals.currentUser.lang;
                       if ($scope.localVars.totalCount>0)
                      {
                           if (Math.ceil($scope.totalCount/pageSize)<newPage)
                           {
                             newPage = Math.ceil($scope.totalCount/pageSize);
                           }
                      }
                      TaskDataService.getInitiatedTasksPaginated(type,filter,urlNext,urlPrev,newPage,pageSize).then(function(data) {
                                                
                                                  $scope.gridOptions.data = data.data.results;
                                                  $scope.nextPage = data.data.next;
                                                  $scope.previousPage = data.data.previous;
                                                  $scope.totalCount=data.data.count;
                                                  $scope.currentPage=newPage;
                                                  $scope.numPages = Math.ceil($scope.totalCount/pageSize);
                                                  $scope.pageSize = pageSize;
                                                  $scope.gridOptions.totalItems=$scope.totalCount;
                                                  $scope.localVars.dataLoaded = true;
                                                 if (afterClaim)
                                                 {
                                                   MessagingService.addMessage(msgAfter,'success');
                                                  
                                                 }
                                               },function(error){
                                                
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                    }
                    
                    $scope.fd.rowSelectionChanged=function(item)
                    {
                        $scope.localVars.taskSelected=item.isSelected;

                        if(item.isSelected){
                           
                             
                               if ($scope.fd.Search.taskListType=="execute")
                               {
                                $scope.selectedTask=item.id
                                $scope.task_execute_id = $scope.selectedTask;
                                $scope.selectedTaskDefId=item.resourcedef[0].id
                                $scope.selectedTaskObject = item;  
                               }
                               else
                               {
                                $scope.selectedTask=item.TaskInitiationId.id
                                $scope.task_initiate_id = $scope.selectedTask;
                                $scope.selectedTaskDefId=item.TaskInitiationId.Resourcedef.id
                                $scope.selectedTaskObject = item.TaskInitiationId;  
                               }
                               
                            }   
                    }
                    
                    $scope.fd.ExecuteAllListPaginatedFilter = function(type,filter,afterClaim,msgAfter,urlNext,urlPrev,newPage,pageSize,f_filter){
                      
                      var lang=$rootScope.globals.currentUser.lang;
                      var deferred = $q.defer()
                      $scope.localVars.dataLoaded = false;
                      
                      if ($scope.fd.Search.taskListType=="claim")
                      {
                        $scope.results = {columns : columnDefsInitiate};
                      }
                    
                         if ($scope.fd.Search.taskListType=="execute")
                      {
                        $scope.results = {columns : columnDefsExecute};
                      }
                    
                      
                      if ($scope.localVars.totalCount>0)
                      {
                           if (Math.ceil($scope.localVars.totalCount/pageSize)<newPage)
                           {
                             newPage = Math.ceil($scope.localVars.totalCount/pageSize);
                           }
                      }
                     // $scope.gridOptions.data.length=0;
                      
                      TaskDataService.getInitiatedTasksPaginatedFiltered(type,filter,urlNext,urlPrev,newPage,pageSize,f_filter).then(function(data) {
                                                
                                                  $scope.results.results = data.data.results;
                                                  $scope.localVars.nextPage = data.data.next;
                                                  $scope.localVars.previousPage = data.data.previous;
                                                  $scope.localVars.totalCount=data.data.count;
                                                  $scope.localVars.currentPage=newPage;
                                                  $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/pageSize);
                                                  $scope.localVars.pageSize = pageSize;
                                                  $scope.results.totalItems=$scope.localVars.totalCount;
                                                  $scope.localVars.firstTime = false;
                                                  $scope.localVars.dataLoaded = true;
                                                  
                                                  
                               
                                                    $scope.results.pageSize = pageSize;
                                                    $scope.results.numberOfPages = $scope.localVars.numPages;
                                                    $scope.results.count = data.data.count;
                                                    
                                                    if (deferred!=undefined) deferred.resolve({data: $scope.results});
                                                  
                                                  
                                                  
                                               /*   if ($scope.localVars.totalCount==1)
                                                  {
                                                        if (!$scope.localVars.detailsClicked)
                                                        {
                                                                if ($scope.fd.Search.taskListType=="execute")
                                                                {
                                                                $scope.task_execute_id = $scope.gridOptions.data[0].id;
                                                                 
                                                                }
                                                                else
                                                                {
                                                                $scope.task_initiate_id = $scope.gridOptions.data[0].TaskInitiationId.id;
                                                               
                                                                }
                                                        }*/
                                                  
                                                  $timeout(function(){
                                                      $rootScope.$broadcast('PageLoaded');
                                                  });
                                                 if (afterClaim)
                                                 {
                                                   MessagingService.addMessage(msgAfter,'success');
                                                  
                                                 }
                                               },function(error){
                                                  deferred.reject({data: $scope.results});
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                          return deferred.promise;
                    }
             $scope.fd.pageChanged = function(){
                        
                        $scope.directiveFnSmartTableRefresh(1,$scope.localVars.pageSize);
                        //$scope.fd.getTaskList(1,$scope.localVars.pageSize);
                       
             }
             
             $scope.setDirectiveFnRefreshData = function(directiveFn) {
                          $scope.directiveFnSmartTableRefresh = directiveFn;
             };
    
             $scope.fd.getTaskList = function(pageNumber,pageSize){
                          var dfrd = $q.defer();
                          $scope.localVars.dataLoaded = false;
                          $scope.fd.ExecuteAllListPaginatedFilter($scope.fd.Search.taskListType,1,false,"",
                                                                  $scope.localVars.nextPage,$scope.localVars.previousPage,
                                                                  pageNumber,pageSize,$scope.filter).then(function(data)
                                                                                                                            
                                                                 {
                                                                              dfrd.resolve(data);
                                                                 });
                          return dfrd.promise;
             };
                         
                         
                     
                     $scope.ExecuteListPrePaginated = function(listFilter){
                            $scope.ExecuteAllListPaginated($scope.fd.Search.taskListType,listFilter,false,"","","",paginationOptions.pageNumber,paginationOptions.pageSize);
                         }
                         
                       
                      $scope.fd.Search.headerLabel = "Select users or groups";
                      $scope.fd.Search.usersLabel ="Users";
                      $scope.fd.Search.groupsLabel = "Groups";
                      
                  $scope.$watch('fd.Search.taskDefIds',function(newValue,oldValue){
                    
                    if (newValue!=oldValue && newValue!=undefined)
                    {
                     $scope.filter.taskDefIds=$scope.fd.Search.taskDefIds;
                     
                    }
                  });
                   $scope.$watch('fd.Search.taskStatus',function(newValue,oldValue){
                    
                    if (newValue!=oldValue && newValue!=undefined)
                    {
                     $scope.filter.taskStatus=$scope.fd.Search.taskStatus;
                     
                    }
                  });
                      
                      //get task statuses
                      
                       CodesService.getCodesByName('taskstatuses',lang).then(function (data) {
                                $scope.localVars.taskStatuses = data.data;
                             });
             let template;
             if ($scope.resourceDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktTaskListWidget.html');
             else template = $templateCache.get('ktdirectivetemplates/ktTaskListWidgetExe.html');
          
             $element.append($compile(template)($scope));      
          
          }];
          
          
        return {
            restrict: 'A',
            controller:controller,
             link: function (scope, elem, attrs) {
                 
            
              }
        }             
};
'use strict';

export function ktTaskMessage () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskMessage.html',
             controller: function($scope,GridsterService,$sce){
                
                $scope.gsrvc= GridsterService;
                
                if ($scope.localVars == undefined) $scope.localVars={};
                
                 $scope.localVars.showMenu = false
      
                  $scope.localVars.toggleDropdown = function(){
                                       $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
                  }
      
                $scope.localVars.ResponseMsg = $sce.trustAsHtml($scope.fd.ResponseMsg);

                },
             
            link: function (scope, elem, attrs) {
                
              
        }       
              
    }
  
};
'use strict';

export function ktTaskProcDirective () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskProcDirective.html',
            scope: {
                fd: '=',
                localVars: '=',
                taskDefinition:'=',
            },
 
     controller: function($scope,MessagingService,TaskDataService,PublicTaskDataService,MenuService,$timeout,$rootScope,GridsterService,$stateParams,WidgetDataExchangeService,dragulaService,KatalyoStateManager)
     {
        $scope.CTRL = "ktTaskProcDirective"
        $scope.gsrvc = GridsterService;
        if ($scope.localVars==undefined) $scope.localVars={};
        if ($scope.fd==undefined) $scope.fd={};
        $scope.localVars.gridsterType = "task";
        $scope.gsrvc.showFooter=true;
        if ($scope.taskDefinition!=undefined && $scope.localVars.previousTask==undefined) $scope.localVars.previousTask= $scope.taskDefinition.task_execute_id;
        else if ($scope.localVars.previousTask==undefined)  $scope.localVars.previousTask=0;
        //if ($scope.taskDefinition==undefined) $scope.taskDefinition =  {};
        $scope.localVars.potentialOwners = {};
        $scope.localVars.potentialOwners.potentialOwnersUsers = [];
        $scope.localVars.potentialOwners.potentialOwnersGroups = [];
           
        $scope.localVars.backCloseIcon = "fa fa-close";
        $scope.localVars.cancelBackBtnTxt = "Cancel";
        $scope.localVars.inlineTaskDefinition={};
        $scope.localVars.inlineTask={};
                   
        $scope.localVars.inlineTask = {
                id: '1',
                name: 'Home',
                widgets: $scope.gsrvc.getEmptyColumn(),
                widgetsOriginal: $scope.gsrvc.getEmptyColumn(),
                data:{}
            };
            
       
      if ($scope.localVars.selectedTasks==undefined) $scope.localVars.selectedTasks = [];
       
      $scope.localVars.selectedTaskIndex=-1;
      if ($scope.fd.type!=undefined)
      {
          if ($scope.fd.type=='itask')
          {
            if ($scope.fd.wItemValue!=null) {
               $scope.localVars.selectedTasks = $scope.fd.wItemValue;
            }else
            {
              $scope.fd.wItemValue = [];
              
            }
          }
          else
          {
              if ($scope.fd.tItemValue!=null) {
               $scope.localVars.selectedTasks = $scope.fd.tItemValue;
              }else
              {
              $scope.fd.tItemValue = [];
              
              } 
              
          }
      }
       
       $scope.ProcessDataFromStartTask = function(data)
       {
        
                if (data.taskdef!=undefined)  $scope.localVars.inlineTaskDefinition = data.taskdef;
                if ($scope.taskDefinition!=undefined)
                {
                    if ($scope.taskDefinition.task_execute_id==undefined) $scope.taskDefinition.task_execute_id = $scope.localVars.previousTask;
                    $scope.localVars.inlineTaskDefinition.prev_task_id = $scope.taskDefinition.task_execute_id;
                    $scope.localVars.inlineTaskDefinition.prev_task_transaction_id = $scope.taskDefinition.transaction_id;
                    $scope.localVars.inlineTaskDefinition.prev_task_object = $scope.taskDefinition;

                }else{
                   
                    $scope.localVars.inlineTaskDefinition.prev_task_id = $scope.localVars.previousTask;
                }
                $scope.localVars.inlineTaskDefinition.proc_type = data.procType;
                $scope.localVars.inlineTaskDefinition.form_type = data.formType;
                $scope.localVars.inlineTaskDefinition.transaction_id = data.transactionId;
                $scope.localVars.inlineTaskDefinition.taskExecuteInstance = data.taskExecuteInstance;
                $scope.localVars.inlineTaskDefinition.taskInitiateInstance = data.taskInitiateInstance;
                $scope.localVars.inlineTaskDefinition.inline_task=$scope.localVars.isInlineTask;
                $scope.localVars.inlineTaskDefinition.source_type = $stateParams.src_type;
                $scope.localVars.inlineTaskDefinition.taskFormLoaded = false;
                $scope.localVars.inlineTaskDefinition.inlineInitiateFormLoaded = true; 
                if ($scope.localVars.inlineTaskDefinition.taskExecuteInstance!=undefined && $scope.localVars.inlineTaskDefinition.taskExecuteInstance.length>0) $scope.localVars.inlineTaskDefinition.task_execute_id = $scope.localVars.inlineTaskDefinition.taskExecuteInstance[0].id;
                if ($scope.localVars.inlineTaskDefinition.taskInitiateInstance!=undefined && $scope.localVars.inlineTaskDefinition.taskInitiateInstance.length>0) $scope.localVars.inlineTaskDefinition.task_initiate_id = $scope.localVars.inlineTaskDefinition.taskInitiateInstance[0].id;
                $scope.localVars.inlineTask.resourceDefinition=data.resourceDefinition;  
            
                $scope.localVars.inlineTask.data = data.form_data;
               
                if ($scope.localVars.inlineTask.data==undefined) $scope.localVars.inlineTask.data = {};
                $scope.localVars.inlineTask.widgets.layout= data.widgets;
                if ($scope.localVars.inlineTask.resourceDefinition==undefined) $scope.localVars.inlineTask.resourceDefinition = {};
                $scope.localVars.inlineTask.resourceDefinition.formParams = {formViewType:2,formLocked : true};
          
                $scope.gsrvc.setFormViewType($scope.localVars.inlineTask.resourceDefinition.formParams.formViewType)
                                        
                $scope.gsrvc.setTaskFormVersion($scope.localVars.inlineTask.resourceDefinition.id+$scope.localVars.inlineTaskDefinition.form_type,$scope.localVars.inlineTask.resourceDefinition.FormVersion)

                $scope.ksm = KatalyoStateManager;
                //define task_closed action from parent task if parent exists
                if ($scope.taskDefinition!=undefined)
                {
                    $scope.localVars.inlineTask.resourceDefinition.page_state_id = $scope.taskDefinition.page_state_id
                    
                    let taskParentState= $scope.ksm.getSubject("task"+$scope.taskDefinition.transaction_id);
                    let task_closed = function(data)
                    {
                        //textValueState.subject.setStateChanges = data;
                        taskParentState.notifyObservers("task_closed");
                    };
                    
                    let action_task_closed;
                    if (taskParentState!=undefined) action_task_closed = $scope.ksm.addAction(taskParentState.name,"task_closed",task_closed);        
                
                    //Register task with state manager
                    let taskState= $scope.ksm.addSubject('task'+$scope.localVars.inlineTaskDefinition.transaction_id,$scope.localVars.inlineTaskDefinition);
                    let taskStateName = taskState.subject.name;
                            
                    let task_started = function(data)
                    {
                        //textValueState.subject.setStateChanges = data;
                        taskState.subject.notifyObservers("task_started");
                    };
                            
                    let action_task_started = $scope.ksm.addAction(taskStateName,"task_started",task_started);
                    
                    $scope.ksm.executeAction(taskStateName,"task_started");
                    
                    let task_initiated = function(data)
                    {
                        //textValueState.subject.setStateChanges = data;
                        taskState.subject.notifyObservers("task_initiated");
                    };
                            
                    let action_task_initiated = $scope.ksm.addAction(taskStateName,"task_initiated",task_initiated);
                    
                    $scope.$on('RefreshTask'+$scope.localVars.inlineTaskDefinition.transaction_id,function(event,data){

                          $scope.localVars.StartNewTask();
                    });
                    
                    $timeout(function(){
                        $scope.localVars.initiateFormLoaded=true;
                        $scope.localVars.taskInitiated=false;
                        $scope.localVars.isCollapsed3=true;
                    },500);      
        
        
        
            }

        };
        $scope.localVars.ProcessMenuClick= function(menuId){
            var lang=$rootScope.globals.currentUser.lang;
          
          
           if (menuId!=0)
           {
              $scope.localVars.initiateFormLoaded=false;
              MenuService.ProcessMenuClick(menuId).then(function(data) {
                                
                                $scope.ProcessDataFromStartTask(data);                            
                                 
     
                              },function(error){
                                
                                  if (error.msg!=undefined) MessagingService.addMessage(error.msg,'error');
                                  else MessagingService.addMessage(error,'error');
                                  $scope.localVars.inlineTask.taskProcResponse = {status : error.status,msg:error.msg};
                                  
                            });
           }
        };
       
       $scope.localVars.GetExecuteTaskByExeId= function(task_execute_id,task_initiate_id){
            var lang=$rootScope.globals.currentUser.lang;
          
          
           if (task_execute_id>0)
           {
              
              TaskDataService.preExecuteTask(task_initiate_id,task_execute_id,lang).then(function(data) {
                                
                                $scope.ProcessDataFromStartTask(data.data);                            
                                 
     
                              },function(error){
                                
                                  if (error.msg!=undefined) MessagingService.addMessage(error.msg,'error');
                                  else MessagingService.addMessage(error,'error');
                                  $scope.localVars.inlineTask.taskProcResponse = {status : error.status,msg:error.msg};
                                  
                            });
           }
        };
         
       if ($scope.localVars.processMenuClicked) $scope.localVars.ProcessMenuClick($scope.localVars.menuId);
       
       
         $scope.localVars.StartTask = function(taskId,outcomeId,previousTaskId){
                var lang=$rootScope.globals.currentUser.lang;
                if (outcomeId==undefined || outcomeId=="") outcomeId=0;
                if (previousTaskId==undefined || previousTaskId=="") previousTaskId=0;
               
                if (taskId!=0)
                {
                    $scope.localVars.initiateFormLoaded=false;
                    
                    TaskDataService.StartTask(taskId,outcomeId,previousTaskId).then(function(data) {
                                
                                  
                                  if (Object.keys(data.data).length==0 || data.data==null || data.data==undefined)
                                  {
                                    MessagingService.addMessage('Task processing error. Task data is empty! --> Check task definition --> Task id = '+taskId,'error');
                                  }
                                  else
                                  {
                                    
                                    $scope.ProcessDataFromStartTask(data.data);
                                                                     }
                              },function(error){
                                
                            
                                  MessagingService.addMessage(error.msg.msg,'error');
                                  $scope.localVars.inlineTask.taskProcResponse = {status : error.status,msg:error.msg};
                                  
                            });
                }
          };
        
         $scope.localVars.StartPublicTask = function(organisationId,taskName,taskId,outcomeId,previousTaskId){
                if (organisationId==undefined || organisationId=="") organisationId=0;
                if (outcomeId==undefined || outcomeId=="") outcomeId=0;
                if (previousTaskId==undefined || previousTaskId=="") previousTaskId=0;
                if (taskId==undefined || taskId=="") taskId=0;
                if (taskName==undefined) taskName="";
                if ((taskId!=0 || taskName!="") && organisationId>0)
                {
                  PublicTaskDataService.StartTask(organisationId,taskName,taskId,outcomeId,previousTaskId).then(function(data) {
                                
                                   if (Object.keys(data.data).length==0 || data.data==null || data.data==undefined)
                                  {
                                    MessagingService.addMessage('Task processing error. Task data is empty! --> Check task definition --> Task id = '+taskId,'error');
                                  }
                                  else
                                  {
                                    
                                    $scope.ProcessDataFromStartTask(data.data);
                                  }

                                /*
                                 MessagingService.addMessage(error.msg,'error');
                                  $scope.localVars.inlineTask.taskProcResponse = {status : error.status,msg:error.msg};

                                  $scope.localVars.inlineTaskDefinition = data.data.taskdef[0];
                                  if ($scope.taskDefinition!=undefined) $scope.localVars.inlineTaskDefinition.prev_task_id = $scope.taskDefinition.task_execute_id;
                                  $scope.localVars.inlineTaskDefinition.proc_type = data.data.procType;
                                  $scope.localVars.inlineTaskDefinition.form_type = data.data.formType;
                                  $scope.localVars.inlineTaskDefinition.transaction_id = data.data.transactionId;
                                  $scope.localVars.inlineTaskDefinition.inline_task=$scope.localVars.isInlineTask;
                                  $scope.localVars.inlineTaskDefinition.source_type = $stateParams.src_type;
                                  $scope.localVars.inlineTaskDefinition.taskFormLoaded = false;
                                  $scope.localVars.inlineTaskDefinition.taskExecuteInstance = data.data.taskExecuteInstance;
                                  $scope.localVars.inlineTaskDefinition.taskInitiateInstance = data.data.taskInitiateInstance;
                                  $scope.localVars.inlineTaskDefinition.inlineInitiateFormLoaded = true;  
                                  
                                  if ($scope.localVars.inlineTaskDefinition.taskExecuteInstance!=undefined && $scope.localVars.inlineTaskDefinition.taskExecuteInstance.length>0) $scope.localVars.inlineTaskDefinition.task_execute_id = $scope.localVars.inlineTaskDefinition.taskExecuteInstance[0].id;
                                  if ($scope.localVars.inlineTaskDefinition.taskInitiateInstance!=undefined && $scope.localVars.inlineTaskDefinition.taskInitiateInstance.length>0) $scope.localVars.inlineTaskDefinition.task_initiate_id = $scope.localVars.inlineTaskDefinition.taskInitiateInstance[0].id;
                                  
                                  $scope.localVars.inlineTask.resourceDefinition=data.data.resourceDefinition;
                                  $scope.localVars.inlineTask.data = data.data.form_data;
                                  if ($scope.localVars.inlineTask.data==undefined) $scope.localVars.inlineTask.data = {};
                                  $scope.localVars.inlineTask.widgets.layout= data.data.widgets;
            
                                  $scope.localVars.inlineTask.resourceDefinition.formParams = {formViewType:2,formLocked : true};
                                  $scope.localVars.taskInitiated = false;                 
                                  
                                    $timeout(function(){
                                      $scope.localVars.initiateFormLoaded=true;
                                      $scope.localVars.isCollapsed3=true;
                                    },1);   

                                */

                                },function(error){
                            
                                  MessagingService.addMessage(error.msg,'error');
                                  $scope.localVars.inlineTask.taskProcResponse = {status : error.status,msg:error.msg};
                                  
                            });
                }
          };
        
          
        if ($scope.localVars.loadTaskDirect) $scope.localVars.StartTask($scope.localVars.taskId,$scope.localVars.outcomeId,$scope.localVars.previousTask);
          
        if ($scope.localVars.processStartTask || $scope.localVars.autoSearch) $scope.localVars.StartTask($scope.localVars.menuId,$scope.localVars.outcomeId,$scope.localVars.previousTask);
        
        if ($scope.localVars.publicTask) $scope.localVars.StartPublicTask($scope.localVars.organisationId,$scope.localVars.publicTaskName,$scope.localVars.publicTaskId,$scope.localVars.outcomeId,$scope.localVars.previousTask);
              
    },
            
             link: function (scope, elem, attrs) {
       
       
       
      
        }
      }
};
'use strict';

export function ktTaskProcExecute () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskProcExecute.html',
            scope:{
                   taskDefinition : "=",
                   dashboard: "=",
                   resourceDefinition:"=",
                   taskExecuteInstance: "=",
                   taskInitiateInstance: "=",
                   localVars: "=",
                   
      			},
                controller: function($scope,$stateParams,$cookies,$rootScope,TaskDataService,GridsterService,MessagingService,KatalyoStateManager){
                    
                $scope.CTRL ="ktTaskProcExecute"   
                if ($scope.fd==undefined) $scope.fd={};
                if ($scope.lVars==undefined) $scope.lVars={};
                $scope.gsrvc = GridsterService;
                 var lang=$rootScope.globals.currentUser.lang;
                 if ($scope.localVars==undefined) $scope.localVars={};
                 $scope.lVars.isCollapsed3=true;
                 $scope.taskOutcomes = $scope.localVars.taskOutcomes;   
                 $scope.executeTaskDataLoaded=false;
                 $scope.taskDefinition.page_state_id=$scope.localVars.page_state_id;

                 if ($scope.taskDefinition.page_state_id===undefined)  $scope.taskDefinition.page_state_id=$scope.resourceDefinition.page_state_id;
                 
                $scope.fromStateName=$stateParams.fromStateName;
                $scope.fromStateParams=$stateParams.fromStateParams;
                $scope.cookieFromStateName=$cookies.getObject('executeTaskFromStateName');
                $scope.cookieFromStateParams=$cookies.getObject('executeTaskFromStateParams');
                $scope.noBackbutton = false;
                $scope.backBtnFromCookie=false;
                $scope.ksm = KatalyoStateManager;
                

                let executeTaskState= $scope.ksm.addSubject('executeTaskStateName'+$scope.taskDefinition.transaction_id,$scope.taskDefinition.task_execute_id);
                let executeTaskStateName = executeTaskState.subject.name;

                 let task_executed = function(data)
                {
                    executeTaskState.subject.setStateChanges = data;
                    executeTaskState.subject.notifyObservers("task_executed");
                    
                };
                
                let action_task_executed = $scope.ksm.addAction(executeTaskStateName,"task_executed",task_executed);

               if ($scope.taskInitiateInstance.length>0)
               {
                $scope.task_initiate_id = $scope.taskInitiateInstance[0].id;
                $scope.taskDefinition.taskInitiateInstance = $scope.taskInitiateInstance[0];
               }
               else $scope.task_initiate_id = 0;
               
               if ($scope.taskExecuteInstance.length>0)
               {
                $scope.task_execute_id = $scope.taskExecuteInstance[0].id;
                $scope.taskDefinition.taskExecuteInstance = $scope.taskExecuteInstance[0];
               }
               else $scope.task_execute_id=0;
                if ($scope.fromStateName==undefined || $scope.fromStateName=="")
                {
                    if ($scope.cookieFromStateName==undefined || $scope.cookieFromStateName=="")
                    {
                      $scope.noBackButton = true;
                    }else
                    {
                      $scope.fromStateName =  $scope.cookieFromStateName;
                      $scope.backBtnFromCookie = true;
                    }
                    
                  
                }else{
                  $cookies.putObject('executeTaskFromStateName',$scope.fromStateName);
                  
                }
                
                if ($scope.fromStateParams==undefined)
                {
                    if ($scope.cookieFromStateParams!=undefined)
                    {
                        if ($scope.backBtnFromCookie)
                        {
                          $scope.fromStateParams =  $scope.cookieFromStateParams;
                        }
                    }
                    
                }else if ($scope.cookieFromStateParams==undefined)
                {
                  $cookies.putObject('executeTaskFromStateParams',$scope.fromStateParams);
                  
                }else
                {
                    if ($scope.backBtnFromCookie)
                    {
                  
                      $scope.fromStateParams =  $scope.cookieFromStateParams;
                  
                    }else
                    {
                        $cookies.putObject('executeTaskFromStateParams',$scope.fromStateParams);    
                    }
                }
                
                $scope.gridsterType="task";
                //$scope.gridsterExeFormOpts = GridsterService.getGridsterOptions();
                $scope.formType="e";
               
                $scope.isCollapsedTaskDetails=true;
                
                $scope.lVars.changeIsCollapsed3 = function()
                    {
                     if ($scope.lVars.isCollapsed3) $scope.lVars.isCollapsed3 = false;
                     else $scope.lVars.isCollapsed3 = true;
               
                    }
                
                
                $scope.setForm = function(form)
                    {
                        $scope.forma = form;
               
                    }
                
                $scope.FormLockUnlock = function()
                {
                  $scope.resourceDefinition.formParams.formLocked=!$scope.resourceDefinition.formParams.formLocked;
               
                }
                
                $scope.goBack = function(){
                                    $state.go($scope.fromStateName,$scope.fromStateParams);
                             
                };
                
                $scope.returnToPreviousTask = function(){
                
                    $scope.gsrvc.setOpenTaskInNewPage(false);
                             
                };
                
                
                $scope.fd.CancelClicked = function()
                {
                       $scope.taskDefinition.proc_type = 0;
                       $scope.taskDefinition.inlineInitiateFormLoaded=false;
                       $scope.taskDefinition.showInlineTask = false;
                       $scope.localVars.showInlineTask = false;
                       $scope.taskDefinition.inlineTaskInitiated = false;
                       $scope.$emit('InlineTaskClosed',$scope.localVars.taskId);
                };
            
                
                
                $scope.ExecuteTaskAction = function(action){
                     
                     
                        var lang=$rootScope.globals.currentUser.lang;
                      
                       TaskDataService.ExecuteTaskAction($scope.localVars.task_initiate_id,$scope.localVars.task_execute_id,action,lang).then(function(data) {
                 
                                             
                                              $scope.taskInitiateInstance =data.data.data.taskInitiateInstance[0];
                                              $scope.taskExecuteInstance =data.data.data.taskExecuteInstance[0];
                                              if ($scope.taskExecuteInstance!=undefined)
                                                {
                                                $scope.taskDefinition.task_execute_id = $scope.taskExecuteInstance.id;
                                             
                                                }
                                                
                                              if (action=="claim")
                                              
                                              {
                                                //$scope.pageChanged();
                                                $rootScope.$broadcast('RefreshData0',data.data.ret_value);
                                              }
                                              
                                              MessagingService.addMessage(data.data.msg,'success');
                                             
               
                                        },function(error){
                                          
                                      
                                            MessagingService.addMessage(error.msg,'error');
                                      });
                }
                
                
                 $scope.$on('ExecuteTask'+$scope.task_execute_id,function(event,data){
                        
                        let form = $scope.forma;
                        form.$setSubmitted()
                        //if (form.$submitted) $scope.localVars.setSubmitted(form);
                        $scope.localVars.ExecuteTask(data.outcomeId,form);
                    });
                
                
                
                
                $scope.localVars.ExecuteTask = function(outcomeId,form){
                        
                        
                    var lang=$rootScope.globals.currentUser.lang;
                   
                    if (form.$valid) {
                      
                      
                        TaskDataService.executeTask($scope.task_execute_id,$scope.dashboard.data,outcomeId,lang).then(function(data) {
                                      
                                if (data?.data?.msg!=="") MessagingService.addMessage(data.data.msg,'success');
                                $rootScope.$broadcast($scope.taskDefinition.page_state_id+'-'+"TaskPostProcess"+$scope.taskDefinition.transaction_id,data.data.ret_value);
                                $rootScope.$broadcast('ExecuteTaskPostProcess'+$scope.task_execute_id,data.data.ret_value);
                                  
                                   let taskStateName = "executeTaskStateName"+$scope.taskDefinition.transaction_id;
                                   $scope.ksm.executeAction(taskStateName,"task_executed",{task_id:$scope.taskDefinition.task_execute_id,action:'executetask'});

                                },function(error){
                                  
                                  MessagingService.addMessage(error.msg,'error');           
                                            
                        });
                          
                    } // if (isValid)
                    else
                    {
                      MessagingService.addMessage($scope.resourceDefinition.ParametersLang.InvalidFormMessage,'warning');
                      
                    }
                };
                   // 
               
               $scope.localVars.setSubmitted = function (form) {
                  angular.forEach(form, function(item) {
                  if(item && item.$$parentForm === form && item.$setSubmitted) {
                      $scope.localVars.setSubmitted(item);
                  }
                  });
                } 
                    
                    },
             link: function (scope, elem, attrs) {
                
                
              }
        }             
};
'use strict';

export function ktTaskProcInitiate () {
             var controller = ['$scope', '$stateParams','$state','UserService','ResourcesDataService','$rootScope','ProcessingService','$timeout','$cookies','CodesService','KatalyoStateManager',
              'WidgetDataExchangeService','TaskDataService','TaskProcService','MessagingService','GridsterService', '$window','$sce',
                               function ($scope,$stateParams,$state,UserService,ResourcesDataService,$rootScope,ProcessingService,$timeout,$cookies,CodesService,KatalyoStateManager,
              WidgetDataExchangeService,TaskDataService,TaskProcService,MessagingService,GridsterService, $window,$sce) {
            $scope.CTRL ="ktTaskProcInitiate"
                 if ($scope.localVars==undefined) $scope.localVars={};
          
          $scope.localVars.isCollapsed3=true;  
          //$scope.localVars = {dashboard:{}};
          $scope.localVars.autoInitiate=false;
          $scope.localVars.showTask = true;
          if ($scope.localVars.previousTask==undefined) $scope.localVars.previousTask = 0;
          var aParams = {};
          var pTaskPackage={};
          $scope.gsrvc = GridsterService;
          if ($scope.fd!=undefined)
          {
              $scope.$on('ProcessTask'+ $scope.fd.presentationId,function(event,data){
                  if ($scope.localVars.inlineTaskDefinition==undefined) $scope.localVars.inlineTaskDefinition={task_execute_id : data.task_execute_id};
                  else if ($scope.localVars.inlineTaskDefinition.task_execute_id==undefined) $scope.localVars.inlineTaskDefinition.task_execute_id = data.task_execute_id;
                  
                  $scope.localVars.StartTask(data.taskId,data.outcomeId);
              });
          }
          
         
              
                var lang=$rootScope.globals.currentUser.lang;
               
                $scope.localVars.initiateFormLoaded=false;
                $scope.isSaving=false;
                $scope.previousTask=$scope.taskDefinition.prev_task_id;
                $scope.previousTaskOutcomeId=$stateParams.outcome_id;
                $scope.previousTaskPackage=$stateParams.prev_task_package; 
                $scope.gridsterType="task";
                $scope.showSearchFilters=false;      
                //$scope.dashboard = {widgets : []};
                if ($scope.previousTaskOutcomeId=="") $scope.previousTaskOutcomeId = 0;
                
                $scope.fromStateName=$stateParams.fromStateName;
                $scope.fromStateParams=$stateParams.fromStateParams;
                $scope.cookieFromStateName=$cookies.getObject('initiateTaskFromStateName');
                $scope.cookieFromStateParams=$cookies.getObject('initiateTaskFromStateParams');
                $scope.noBackbutton = false;
                $scope.backBtnFromCookie=false;
      
      
  
                $scope.removeField = function (index){
						
                  if (index > -1) {
						 
                 $scope.inputArray.layout.splice(index, 1);
						 
                  }

                }   

 
 
    
          $scope.InititateAllList = function(){
      
            
              ResourcesDataService.getResourceDefByType(lang,'task').then(function(data) {
                                
                                  $scope.gridOptions.data = data.data;
                                   
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
          }
        
    
   
      $scope.InititateMyList = function(){
      
         
              ResourcesDataService.getResourceDefListByLangByTypeUser(lang,'task').then(function(data) {
                                
                                 $scope.gridOptions.data = data.data;
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
    
          
    };   
    
   
     
      
     
      if ($scope.fromStateName==undefined || $scope.fromStateName=="")
      {
          if ($scope.cookieFromStateName==undefined || $scope.cookieFromStateName=="")
          {
            $scope.noBackButton = true;
          }else
          {
            $scope.fromStateName =  $scope.cookieFromStateName;
            $scope.backBtnFromCookie = true;
          }
          
        
      }else{
        $cookies.putObject('initiateTaskFromStateName',$scope.fromStateName);
        
      }
      
      if ($scope.fromStateParams==undefined)
      {
          if ($scope.cookieFromStateParams!=undefined)
          {
              if ($scope.backBtnFromCookie)
              {
                $scope.fromStateParams =  $scope.cookieFromStateParams;
              }
          }
          
      }else if ($scope.cookieFromStateParams==undefined)
      {
        $cookies.putObject('initiateTaskFromStateParams',$scope.fromStateParams);
        
      }else
      {
          if ($scope.backBtnFromCookie)
          {
        
            $scope.fromStateParams =  $scope.cookieFromStateParams;
        
          }else
          {
              $cookies.putObject('initiateTaskFromStateParams',$scope.fromStateParams);    
          }
      }
      
      
       if ($scope.previousTask==undefined || $scope.previousTask=="")
          {
           // $state.go();
            
            $scope.previousTask = 0;
            
          }
      $scope.potentialOwners = {};
      

      
    //WidgetDataExchangeService.deRegisterAllWidgets();	//Migor - cistim taskwidgetRegistry 

      $scope.localTaskId=WidgetDataExchangeService.registerTask($scope.taskDefId);
      
     // $scope.taskDefinition ={};
      $scope.potentialOwners.potentialOwnersUsers = [];
      $scope.potentialOwners.potentialOwnersGroups = [];
      
         $scope.FormLockUnlock = function()
      {
        $scope.resourceDefinition.formParams.formLocked=!$scope.resourceDefinition.formParams.formLocked;

     
      };
     
      $scope.menuId = $stateParams.id;
      var lang=$rootScope.globals.currentUser.lang;
      
        $scope.localVars.NewTask = function(taskId)
        {
             $scope.localVars.inlineTask.widgets.layout=angular.copy($scope.localVars.inlineTask.widgetsOriginal);
             $scope.taskDefinition.inlineTaskInitiated=false;
        };
          
        $scope.localVars.StartNewTask = function()
        {
             $scope.localVars.StartTask($scope.taskDefinition.ResourceDefId_id,0,0);
             
        };
        
        $scope.returnToPreviousTask = function(){
             
             
             $scope.ksm=KatalyoStateManager;
             let taskStateName = "task"+$scope.taskDefinition.prev_task_transaction_id;
                         
             $scope.ksm.executeAction(taskStateName,"task_closed");
             
             $scope.gsrvc.setOpenTaskInNewPage(false);
                             
        };       
          $scope.localVars.CancelClicked = function()
          {
             if ($scope.localVars.fromOutcome  && !$scope.taskDefinition.inline_task)
             {
              $scope.localVars.executeTaskDataLoaded=false;
              if ($scope.localVars.pageChanged!=undefined) $scope.localVars.pageChanged();
             }
             $scope.taskDefinition.proc_type=0;
             $scope.taskDefinition.inlineInitiateFormLoaded=false;
             $scope.taskDefinition.showInlineTask = false;
             $scope.taskDefinition.inlineTaskInitiated = false;
            /*
             $scope.localVars.proc_type=0;
             $scope.localVars.inlineInitiateFormLoaded=false;
             $scope.localVars.showInlineTask = false;
             $scope.localVars.inlineTaskInitiated = false;
             */
             $scope.$emit('InlineTaskClosed',$scope.localVars.taskId);
             if (!$scope.taskDefinition.inline_task) $window.history.back();
          };
      
      
       $scope.localVars.AutoInitiateTask = function(){
        var lang=$rootScope.globals.currentUser.lang;
        //  if (isValid) {
        var parentDataset=$scope.localVars.getPreviousTaskWidget();
        if ($scope.previousTaskOutcomeId==undefined) $scope.previousTaskOutcomeId=0;
          
          TaskDataService.initiateTask($scope.taskDefinition.ResourceDefId_id,$scope.previousTask,$scope.previousTaskOutcomeId,[],$scope.potentialOwners,parentDataset['datasetId'],parentDataset['datasetRecordId'],lang).then(function(data) {
                                
                                    
                                    $scope.task_initiate_id = data.data.task_initiate_id;
                                    $scope.task_execute_id = data.data.task_execute_id;
                                    //$state.go('app.navbar.tasks.execute',{id: $scope.taskDefId,task_initiate_id:$scope.task_initiate_id,task_execute_id:$scope.task_execute_id,fromStateName:$scope.fromStateName,fromStateParams:$scope.fromStateParams,prev_task_package:$scope.previousTaskPackage,prev:$scope.taskExecuteId});
                                   
                                  
                              },function(error){
                                    
                                  MessagingService.addMessage(error.msg,'error');
                            });
         // }
      };
      
      $scope.$on('CloseTaskForm'+$scope.taskDefinition.transaction_id,function(event,data){
                  
                  $scope.localVars.showTask = false;
                  $scope.$emit('InlineTaskClosed',$scope.localVars.taskId);
       });
      
       $scope.localVars.InitiateTask = function(form){
        var f = $scope.forma;
        
        if (form.$submitted) $scope.localVars.setSubmitted(form);
        if (form.$valid) {
            
            //var initiateData={};
            $rootScope.$broadcast('ProcessTaskWidgets',{}); //svi widgeti slusaju ovaj event
            $scope.isSaving = true;
            var lang=$rootScope.globals.currentUser.lang;
            if ($scope.previousTaskOutcomeId==undefined) $scope.previousTaskOutcomeId=0;
            //ako je prethodni task imao listu povuci WidgetData
            var parentDataset=$scope.localVars.getPreviousTaskWidget("resourceLinkDatasetList");
      
            if (parentDataset['datasetId']==undefined || parentDataset['datasetId']=="") parentDataset['datasetId'] = 0;
            if (parentDataset['datasetRecordId']==undefined || parentDataset['datasetRecordId']=="") parentDataset['datasetRecordId'] = 0;
            let resource_def_id = $scope.taskDefinition.ResourceDefId;
            if (resource_def_id==undefined) resource_def_id = $scope.taskDefinition.ResourceDefId_id;
                TaskDataService.InitiateTask(resource_def_id,$scope.taskDefinition.transaction_id,$scope.dashboard.data,$scope.potentialOwners,parentDataset['datasetId'],parentDataset['datasetRecordId'],lang).then(function(data) {
                                
					
                                  MessagingService.addMessage(data.data.msg,'success');
                                  //$rootScope.$broadcast('InitiateTaskPostProcess'+$scope.taskDefinition.transaction_id,data.data);
                                  //ovo treba staviti u event InitiateTaskPostProcessFinished
                                   if (data.data.taskInitiateInstance!=undefined)
                                    {
                                    if (data.data.taskInitiateInstance.length>0)
                                        $scope.taskDefinition.taskInitiateInstance = data.data.taskInitiateInstance[0];
                                        $scope.taskDefinition.task_initiate_id = $scope.taskDefinition.taskInitiateInstance.id;
                                    }
                                    let r_val;
                                    if (data.data.ret_value!=undefined)
                                    {
                                       if(data.data.ret_value.length>0)
                                       {
                                                    if (data.data.ret_value[0].eosResponse!=null && data.data.ret_value[0].eosResponse!=undefined) $scope.eosResponse = JSON.stringify(data.data.ret_value[0].eosResponse,null,2);
                                                    if (data.data.ret_value[0].eosResponse2!=null && data.data.ret_value[0].eosResponse2!=undefined) $scope.eosResponse2 = JSON.stringify(data.data.ret_value[0].eosResponse2,null,2);
                                                    r_val = data.data.ret_value;
                                       }else r_val = {task_initiate_id:$scope.taskDefinition.task_initiate_id};
                                    }
                                    
                                                                        
                                    $rootScope.$broadcast($scope.taskDefinition.page_state_id+'-'+"TaskPostProcess"+$scope.taskDefinition.transaction_id,r_val);
                                 
                                  //execute action task_initiated
                                  $scope.ksm = KatalyoStateManager;
                                  let taskStateName = "task"+$scope.taskDefinition.transaction_id;
                                  $scope.ksm.executeAction(taskStateName,"task_initiated");
                                  
                                  if (data.data.restart_task!=null && data.data.restart_task!=undefined)
                                  
                                  {
                                       $scope.taskDefinition.transaction_id = data.data.restart_task.data.transactionId;
                                       
                                       $scope.$on('CloseTaskForm'+$scope.taskDefinition.transaction_id,function(event,data){
                  
                                                    $scope.localVars.showTask = false;
                                                    $scope.$emit('InlineTaskClosed',$scope.localVars.taskId);
                                       });
                                  }
                                                                  
                                  
                                  $scope.$emit('RefreshData'+ $scope.taskDefinition.prev_task_id,$scope.taskDefinition.ResourceDefId_id); 
                                  $scope.localVars.taskInitiated=true;
                                  if (data.data.task_execute_id>0)
                                  {
                                       if (data.data.taskdef.Parameters!=null && data.data.taskdef.Parameters!=undefined)
                                       {     
                                            if (data.data.taskdef.Parameters.AutoLoadExeForm)
                                            {
                                                         $scope.localVars.GetExecuteTaskByExeId(data.data.task_execute_id,data.data.task_initiate_id);  
                                            }
                                       }
                                  }
     
                              },function(error){
                                 // $scope.isSaving = false;    
                                  MessagingService.addMessage(error.msg,'error');

                                $scope.errorMsg = $sce.trustAsHtml(error.msg)
                            });
                          
                          $scope.isSaving = false;  
						
			
							
          } // if (isValid)
          else
          {
            MessagingService.addMessage("Please correct invalid entries",'warning');
            
          }
      };

    $scope.localVars.getPreviousTaskWidget  = function(deiType)
    {
      var pTaskPkg = WidgetDataExchangeService.getPrevTaskData($scope.taskDefinition.prev_task_id);
             var datasetId=0,datasetRecordId=0,pTaskData,pTaskDataArray;
             if (!Array.isArray(pTaskPkg))
             {
                          pTaskDataArray = [pTaskPkg];
             }else
             {
                          pTaskDataArray = pTaskPkg;        
             }
             for (let l=0;l<pTaskDataArray.length;l++)
             {
                          pTaskData = pTaskDataArray[l];
                          if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
                          {
                          for (var i=0;i<pTaskData.DEI.length;i++)
                          {
                            if (pTaskData.DEI[i].name==deiType)
                            {
                              if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                              {
                                for (var j=0;j<pTaskData.DEI[i].value.length;j++)
                                {
                                 if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined) datasetId=pTaskData.DEI[i].value[j].value;
                                 if (pTaskData.DEI[i].value[j].name=="resourceRecordId" && pTaskData.DEI[i].value[j].value!=undefined) datasetRecordId=pTaskData.DEI[i].value[j].value;
                                 
                                  
                                }
                                   
                                  
                              }
                                
                            }
                              
                            }
                          }
             }
            
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };
        $scope.localVars.setSubmitted = function (form) {
          form.$setSubmitted();
          angular.forEach(form, function(item) {
            if(item && item.$$parentForm === form && item.$setSubmitted) {
              $scope.localVars.setSubmitted(item);
            }
          });
        }     
          
          }];
          
          
        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskProcInitiate.html',
            scope:{
                   taskDefinition : "=",
                   dashboard: "=",
                   resourceDefinition:"=",
                   localVars: "=",
      			},
            controller:controller,
          
             link: function (scope, elem, attrs) {
                 
               
                    
       
             
    }
  }             
};
'use strict';

export function ktTaskProcList () {
             var controller = ['$scope', '$stateParams','$state','UserService','ResourcesDataService','$rootScope','ProcessingService','$timeout','$cookies','CodesService','WidgetDataExchangeService','TaskDataService','MessagingService','GridsterService',
                               function ($scope,$stateParams,$state,UserService,ResourcesDataService,$rootScope,ProcessingService,$timeout,$cookies,CodesService,WidgetDataExchangeService,TaskDataService,MessagingService,GridsterService) {
          
                  
          
          }];
          
          
        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskProcList.html',
            controller:controller,
             link: function (scope, elem, attrs) {
                 
             var lang=$rootScope.globals.currentUser.lang;
                
                    scope.localVars = {};                      
                    scope.stateName=$state.current.name;
                    scope.stateParams = $state.current.params;
                    scope.task_initiate_id=$stateParams.task_initiate_id;
                    scope.task_execute_id=$stateParams.task_execute_id;
                                    
                     scope.is_superuser =  $rootScope.globals.currentUser.is_superuser;
                   
                    scope.gridOptions = {
                      data:[],
                    enableGridMenu: true,
                    //showGridFooter: true,
                    //showColumnFooter: true,
                    enableRowSelection: true,
                    multiSelect: false,
                    enableHorizontalScrollbar : 0, 
                    enableVerticalScrollbar : 2,
                    //enableFiltering: true,
                    enableRowHeaderSelection: true,
                    enableColumnResizing: true,
                    useExternalPagination: true,
                    paginationPageSizes: [10, 25, 50,100,200,500,1000],
                    enablePaginationControls: false,
                    //paginationPageSize: 10,
                    //useExternalSorting : true,
                    //useExternalFiltering: true,
                   // minRowsToShow : 3
                   };
                    
                  var paginationOptions = {
                    pageNumber: 1,
                    pageSize: 10,
                    sort: null
                    };
                    
                    var columnDefsInitiate = [
                        { name: 'TaskInitiationId.id', displayName: 'ID', type: 'number', width:'5%',enableHiding: false, visible: true },
                        { name: 'TaskInitiationId.InitiatorId.name', displayName: 'Started by'},
                        { name: 'TaskInitiationId.Status.CodesDetailLang[0].Value', displayName: 'Task status' },
                        { name: 'TaskInitiationId.Resourcedef.resourcedeflang_set[0].Name', displayName: 'Task name' },
                        { name: 'TaskInitiationId.Resourcedef.resourcedeflang_set[0].Description', displayName: 'Task description' },
                        { name: 'TaskInitiationId.Resourcedef.id', displayName: 'Task def id',enableHiding: false,visible: false },
                        { name: 'TaskInitiationId.CreatedDateTime', displayName: 'Date created',enableHiding: false,type: 'date', cellFilter: 'date:\'dd.MM.yyyy HH:mm:ss:sss\'' },
                        { name: 'TaskInitiationId.CreatedBy.name', displayName: 'Created by'},
                        { name: 'ForGroup.name', displayName: 'For group'},
                        ];
                    
                   var columnDefsExecute = [
                         { name: 'id', displayName: 'Task Execute ID', type: 'number', width:'10%',enableHiding: false, visible: true },
                         { name: 'resourcedef.resourcedeflang_set[0].Name', displayName: 'Task name' },
                         { name: 'resourcedef.resourcedeflang_set[0].Description', displayName: 'Task description' },
                         { name: 'actualOwner.name', displayName: 'Task Owner'},
                         { name: 'status.CodesDetailLang[0].Value', displayName: 'Task status' },
                         { name: 'outcome.TaskOutcomesDetailLang_taskoutcomedetailid[0].DisplayName', displayName: 'Task outcome' },
                         { name: 'resourcedef.id', displayName: 'Task def id',enableHiding: false,visible: false },
                         { name: 'CreatedDateTime', displayName: 'Date created',enableHiding: false,type: 'date', cellFilter: 'date:\'dd.MM.yyyy HH:mm:ss:sss\'' },
                         { name: 'createdBy.name', displayName: 'Created by'},
                         ];   
                   
                    scope.task_execute_id = 0;
                   scope.task_initiate_id = 0;
                    
                    if (scope.fd===undefined) scope.fd={};
                    if (scope.fd.search===undefined || scope.fd.search===null) scope.fd.search = {};
                   //ovo treba prilagoditi
                   if (scope.fd.search.taskListType==undefined) scope.fd.search.taskListType="claim";
                      
                      
                    
                     scope.gridOptions.onRegisterApi = function (gridApi) {
                        scope.gridApi = gridApi;
                        gridApi.selection.on.rowSelectionChanged(scope,function(row){
                         scope.taskSelected=row.isSelected
                       
                         if(row.isSelected){
                           
                               if (scope.fd.search.taskListType=="execute")
                               {
                                scope.selectedTask=row.entity.id
                                scope.task_execute_id = scope.selectedTask;
                                scope.selectedTaskDefId=row.entity.resourcedef.id
                                scope.selectedTaskObject = row.entity;  
                               }
                               else
                               {
                                scope.selectedTask=row.entity.TaskInitiationId.id
                                scope.task_initiate_id = scope.selectedTask;
                                scope.selectedTaskDefId=row.entity.TaskInitiationId.Resourcedef.id
                                scope.selectedTaskObject = row.entity.TaskInitiationId;  
                               }
                               
                            }
                        });
                        
                        //external pagination
                      gridApi.pagination.on.paginationChanged(scope, function (newPage, pageSize) {
                          paginationOptions.pageNumber = newPage;
                          paginationOptions.pageSize = pageSize;
                          scope.ExecuteAllListPaginatedFilter(scope.fd.search.taskListType,1,false,"",scope.localVars.nextPage,scope.localVars.previousPage,newPage,pageSize,$scope.fd.search);
                      });
                      
                       gridApi.core.on.filterChanged(scope, function() {
                           // Set some scope variable that both lists use for filtering
                          // scope.someFilterValueBothListsLookAt = ......
                       });
                
                      
                     }
                      
                    scope.removeField = function (index){
						
                        if (index > -1) {
						 
                           scope.inputArray.layout.splice(index, 1);
						 
                        }

                  }
                
                    scope.ClaimSelected = function(){
                              
                              
                            var lang=$rootScope.globals.currentUser.lang;
                             TaskDataService.ExecuteTaskAction(scope.selectedTask,0,'claim',lang).then(function(data) {
                       
                                                   
                                                    
                                                    //refresh liste task-ova za claim
                                                    scope.ExecuteAllList(scope.fd.search.taskListType,1,true,data.data.msg);
                                                   
                                              },function(error){
                                                
                                            
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                      } 
                    
                    scope.ExecuteAllList = function(type,filter,afterClaim,msgAfter){
                      
                      var lang=$rootScope.globals.currentUser.lang;
                      
                      TaskDataService.getInitiatedTasks(type,filter).then(function(data) {
                                                
                                                  scope.gridOptions.data = data.data.results;
                                                 if (afterClaim)
                                                 {
                                                   MessagingService.addMessage(msgAfter,'success');
                                                  
                                                 }
                                               },function(error){
                                                
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                    }
                    
                    
                  
                  scope.ExecuteAllListPaginated = function(type,filter,afterClaim,msgAfter,urlNext,urlPrev,newPage,pageSize){
                      
                      var lang=$rootScope.globals.currentUser.lang;
                      
                      if (Math.ceil(scope.totalCount/pageSize)<newPage)
                      {
                        newPage = Math.ceil(scope.totalCount/pageSize);
                      }
                      TaskDataService.getInitiatedTasksPaginated(type,filter,urlNext,urlPrev,newPage,pageSize).then(function(data) {
                                                
                                                  scope.gridOptions.data = data.data.results;
                                                  scope.nextPage = data.data.next;
                                                  scope.previousPage = data.data.previous;
                                                  scope.totalCount=data.data.count;
                                                  scope.currentPage=newPage;
                                                  scope.numPages = Math.ceil(scope.totalCount/pageSize);
                                                  scope.pageSize = pageSize;
                                                  scope.gridOptions.totalItems=scope.totalCount;
                                                 if (afterClaim)
                                                 {
                                                   MessagingService.addMessage(msgAfter,'success');
                                                  
                                                 }
                                               },function(error){
                                                
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                    }
                    
                    
                    scope.ExecuteAllListPaginatedFilter = function(type,filter,afterClaim,msgAfter,urlNext,urlPrev,newPage,pageSize,f_filter){
                      
                      var lang=$rootScope.globals.currentUser.lang;
                      
                      
                      if (scope.fd.search.taskListType=="claim")
                      {
                        scope.gridOptions.columnDefs = columnDefsInitiate;
                      }
                    
                         if (scope.fd.search.taskListType=="execute")
                      {
                        scope.gridOptions.columnDefs = columnDefsExecute;
                      }
                    
                      
                      
                      if (Math.ceil(scope.localVars.totalCount/pageSize)<newPage)
                      {
                        newPage = Math.ceil(scope.localVars.totalCount/pageSize);
                      }
                      scope.gridOptions.data.length=0;
                      TaskDataService.getInitiatedTasksPaginatedFiltered(type,filter,urlNext,urlPrev,newPage,pageSize,f_filter).then(function(data) {
                                                
                                                  scope.gridOptions.data = data.data.results;
                                                  scope.localVars.nextPage = data.data.next;
                                                  scope.localVars.previousPage = data.data.previous;
                                                  scope.localVars.totalCount=data.data.count;
                                                  scope.localVars.currentPage=newPage;
                                                  scope.localVars.numPages = Math.ceil(scope.localVars.totalCount/pageSize);
                                                  scope.localVars.pageSize = pageSize;
                                                  scope.gridOptions.totalItems=scope.localVars.totalCount;
                                                  if (scope.localVars.totalCount==1)
                                                  {
                                                    if (scope.fd.search.taskListType=="execute")
                                                      {
                                                       scope.task_execute_id = scope.gridOptions.data[0].id;
                                                         
                                                      }
                                                      else
                                                      {
                                                       scope.task_initiate_id = scope.gridOptions.data[0].TaskInitiationId.id;
                                                       
                                                      }
                                                      scope.localVars.getTaskExecuteData(scope.task_initiate_id,scope.task_execute_id);
                                                  }
                                                  $timeout(function(){
                                                      $rootScope.$broadcast('PageLoaded');
                                                  });
                                                 if (afterClaim)
                                                 {
                                                   MessagingService.addMessage(msgAfter,'success');
                                                  
                                                 }
                                               },function(error){
                                                
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                    }
                     scope.localVars.pageChanged = function(){
                        scope.ExecuteAllListPaginatedFilter(scope.fd.search.taskListType,1,false,"",scope.localVars.nextPage,scope.localVars.previousPage,scope.localVars.currentPage,scope.localVars.pageSize,scope.fd.search);
                         }
                         
                         
                    //napuni grid s definicijama resursa
                     //scope.currentPage =  paginationOptions.pageNumber;
                     //scope.pageSize = paginationOptions.pageSize;
                      
                     scope.ExecuteAllListPaginatedFilter(scope.fd.search.taskListType,1,false,"","","",paginationOptions.pageNumber,paginationOptions.pageSize,scope.fd.search);
                     
                     scope.ExecuteListPrePaginated = function(listFilter){
                            scope.ExecuteAllListPaginated(scope.fd.search.taskListType,listFilter,false,"","","",paginationOptions.pageNumber,paginationOptions.pageSize);
                         }
                         
                          ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
                                                
                                                  scope.taskDefList = data.data;
                                                  
                                                
                                                 
                                               },function(error){
                                                
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                      //
                      scope.fd.search.headerLabel = "Select users or groups";
                      scope.fd.search.usersLabel ="Users";
                      scope.fd.search.groupsLabel = "Groups";
                      
                      //get task statuses
                      
                       CodesService.getCodesByName('taskstatuses',lang).then(function (data) {
                                scope.taskStatuses = data.data;
                             });
              
              }
        }             
};
'use strict';

export function ktTaskToolbox () {

        return {
                restrict: 'A',
                templateUrl: 'ktdirectivetemplates/ktTaskToolbox.html',
               
                controller: ['$scope','$rootScope','GridsterService','TaskDefinitionService','KatalyoStateManager','$timeout', function($scope,$rootScope,GridsterService,TaskDefinitionService,KatalyoStateManager,$timeout){
              
                        $scope.CTRL='ktTaskToolbox';
                        $scope.gsrvc = GridsterService;
                        $scope.toolboxItems = [];
                        $scope.tds = TaskDefinitionService;
                        $scope.collapsed={};
                        $scope.reloadingToolbox = true;
                        $scope.gsrvc.destroyDragula('bag-task');
                        
                        var widgetHandle = 'task-element-drag-handle';
        
                        var setupDragulaResult;
                        
                        $scope.gsrvc.setupDragula('bag-task','task-toolbox',widgetHandle);
                        $scope.taskToolboxItems= $scope.gsrvc.getTaskToolboxItems();
                        
                        //register to state manager
                        $scope.ksm = KatalyoStateManager;

                        let toolbox_loaded = function(data)
                        {
                            $scope.taskToolboxLoaded(data.state);
                        };
                        
                         let toolbox_reload = function(data)
                        {
                          $scope.taskToolboxLoaded(data);
                        };
                        
                        let toolboxState= $scope.ksm.addSubject("taskToolBox",null);
                        let toolboxStateName = toolboxState.subject.name;

                        let action_toolbox_loaded = $scope.ksm.addAction(toolboxStateName,"toolboxLoaded",toolbox_loaded);
                        
                        let action_toolbox_reload = $scope.ksm.addAction(toolboxStateName,"toolboxReload",toolbox_reload);
                        
                         $scope.setCollapse=function(value,element_type){
                            if (element_type=="toolboxgroup")
                            {
                                if ($scope.collapsed[value]===undefined) $scope.collapsed[value] = true
                                else
                                {
                                    if ($scope.collapsed[value]) $scope.collapsed[value] = false
                                    else $scope.collapsed[value] = true;
                                }
                            }
                        }

                        $scope.taskToolboxLoaded=function(value){ 
                                if (!value) {
                                    $scope.gsrvc.destroyDragula('bag-task'); 
                                }
                                else {
                                    $scope.taskToolboxItems.length=0
                                    angular.extend($scope.taskToolboxItems, $scope.gsrvc.getTaskToolboxItems())
                                    //$scope.taskToolboxItems= $scope.gsrvc.getTaskToolboxItems();
                                    //$timeout(function(){$scope.taskToolboxItems= $scope.gsrvc.getTaskToolboxItems();})   
                                    //$timeout(function(){$scope.gsrvc.SetTaskToolboxLoaded(value);$scope.reloadingToolbox = true;});
                                }
               
                        };
                        
                        $scope.toolboxStatus=function(value){
        
                         $scope.gsrvc.SetTaskToolboxLoaded(value);
                        };
             
             }],
             link: function (scope, elem, attrs) {
              
                       
              }
      }
};
'use strict';

export function ktTaskUpdateResource (ResourcesDataService,TaskDataService,KatalyoStateManager,$timeout) {
    var controller = ['$scope', '$uibModal', '$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','UtilityService','KatalyoStateManager','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,UtilityService,KatalyoStateManager,$templateCache,$compile,$element) {
   
      $scope.fd.localVars={};
      $scope.fd.localVars.searchFormDownloaded = false;
      $scope.fd.localVars.formLoaded=false;
      $scope.fd.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_;  
      $scope.fd.localVars.animationsEnabled = true;
      $scope.fd.localVars.widgetType = 2;
      $scope.gsrvc = GridsterService;
      $scope.fd.localVars.formParams={formViewType:1,showGridNavigation:false};
      $scope.fd.localVars.gridsterType="dataset";
      $scope.fd.localVars.resourceType="dataset";
      $scope.fd.localVars.resourceTypesList=[{type:'dataset',name:'Dataset'},{type:'file',name:'File'},{type:'counter',name:'Counter'}]
      $scope.fd.localVars.TablePrefix = 'resource'+$scope.fd.Related
      $scope.fd.localVars.ShowAdvancedProperties = true
      $scope.fd.localVars.showMenu = false
	  
      
      if ($scope.formData===undefined) {

        $scope.formData={}
        $scope.formData[$scope.fd.UuidRef]=[{}]
      } else if ($scope.formData[$scope.fd.UuidRef]===undefined || $scope.formData[$scope.fd.UuidRef]===null) 		
				$scope.formData[$scope.fd.UuidRef]=[{}]
 
	  
      $scope.fd.localVars.toggleDropdown = function(){
           $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
      }
         
       
    if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
    
    if ($scope.fd.ParametersLang===undefined || $scope.fd.ParametersLang===null) $scope.fd.ParametersLang={}

    $scope.fd.Parameters.ShowAdvancedProperties = true

    if ($scope.fd.ParametersLang?.CreatedByTemplate===undefined)  $scope.fd.ParametersLang.CreatedByTemplate='Created by {{user}} on {{date}} at {{time}}'
    if ($scope.fd.ParametersLang?.ChangedByTemplate===undefined)  $scope.fd.ParametersLang.ChangedByTemplate='Last changed by {{user}} on {{date}} at {{time}}'
    
    if ($scope.fd.PopulateType==undefined) $scope.fd.PopulateType="";

    $scope.fd.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: {layout: []},
				searchForm: {layout: []}
		} ;
      

        if ($scope.taskId==undefined) $scope.taskId="0";
        $scope.fd.localVars.taskId=$scope.taskId;
        
        $scope.fd.localVars.resourceDefinition = $scope.resourceDefinition
        $scope.fd.ParentDatasetDefId=$scope.fd.Related;
        $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
        $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;
        if ($scope.fd.localVars.formType==undefined) $scope.fd.localVars.formType='i'
        $scope.source_type=$scope.resourceDefinition.source_type;
        $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
        $scope.formDefinition = $scope.resourceDefinition.form_definition;
        $scope.fd.ParentResourceDefId=$scope.fd.Related

        if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
		
		$scope.resourceDefinition.parentWidgetUid = $scope.fd.UuidRef
			  
        
        $scope.fd.localVars.resourceRecordId=0;
		
        if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        
        
      //register widget 
      var out_fields = ['resourceId'];

   
        let w_actions=[
                    {id:1,name:'updateResourceRecord'},
                    {id:2,name:'addRecord'},
                    {id:3,name:'removeRecord'},
                    {id:4,name:'setRecords'},  
                    {id:5,name:'addRecordWithRefresh'},
                    {id:6,name:'setRecordsWithRefresh'}, 
                    {id:7,name:'setRecordId'},  
                ]
        if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
        let resource_uid = $scope.fd.localVars?.resourceDefinition?.uid 
        if (!resource_uid) resource_uid = $scope.fd.localVars?.resourceDefinition?.pageId
            
        var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: w_actions,dataSource:true, widgetLabel: 'Update resource record',widgetName: 'updateResourceWidget',
        widgetId: $scope.fd.UuidRef,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resource_id:$scope.resourceDefinition.page_state_id,resourceDefId : $scope.fd.Related, output:out_fields, parentResourceId:resource_uid};
        $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
        $scope.fd.localVars.LocalId=$scope.fd.localVars.localWidgetId;
        
        $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
       
        $scope.ksm = KatalyoStateManager;
        var valueState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+"-"+$scope.fd.UuidRef,$scope.fd.localVars.widgetState);
        var valueStateName = valueState.subject.name;
        
      //*********************** get state if exists ********************************************
      
      if (valueState.subject.currentStateIndex>=0)  {   
          $scope.fd.localVars.widgetState = valueState.subject.getState;
          $scope.fd.localVars.resourceRecordId = $scope.fd.localVars.widgetState.resourceRecordId;
          $scope.fd.localVars.loadFromState=true;
      } else {
        $scope.fd.localVars.widgetState={'resourceId':$scope.fd.Related,'resourceRecordId':0};
      }
      
      let value_changed = function(data){
          valueState.subject.setStateChanges = data;
          valueState.subject.notifyObservers("valueChanged");
      };
      
      let action_value_changed = $scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
      
      let update_record = function(data){
          
        let state = valueState.subject.getStateChanges
        if (state==undefined) valueState.subject.setStateChanges = data

        if ($scope.fd.Parameters.flowActions?.length>0)
        {
              for (let i=0;i<$scope.fd.Parameters.flowActions?.length;i++)
              {
                let condition={}
                let values={}
                if (!$scope.fd.Parameters.flowActions[i].NoCondition)
                {
                    condition = JSON.parse($scope.fd.Parameters.flowActions[i].Condition)
                }
                
                values = JSON.parse($scope.fd.Parameters.flowActions[i].Values)
                
                if (UtilityService.check_condition(condition?.operator,condition?.value,$scope.formData[$scope.fd.UuidRef][0][condition?.field]) || $scope.fd.Parameters.flowActions[i].NoCondition)
                {
                        for ( const property in values ) {
                             $scope.formData[$scope.fd.UuidRef][0][property] = values[property]
                        }

                        $scope.fd.localVars.UpdateResourceRecord()
                }
                
              }
        }else  $scope.fd.localVars.UpdateResourceRecord()
         
          //valueState.subject.notifyObservers("updateResourceRecord");
      };
      
      let action_update_record = $scope.ksm.addAction(valueStateName,"updateResourceRecord",update_record);
       
       
       let apply_value = function(data)
        {
            let do_refresh=false;
            if (data!=undefined)
            {
               
                  if (typeof data ==='number') $scope.fd.localVars.resourceRecordId= data;
                  else if (Array.isArray(data))
                  {
                    if (data.length>0)
                    {
                        if ($scope.fd.localVars.TablePrefix+'_id' in data)
                        {
                            $scope.fd.localVars.resourceRecordId= data[0][$scope.fd.localVars.TablePrefix+'_id']
                        }else $scope.fd.localVars.resourceRecordId= data[0].id

                     }
                }else
                    {
                    if ($scope.fd.localVars.TablePrefix+'_id' in data)
                    {
                        $scope.fd.localVars.resourceRecordId= data[$scope.fd.localVars.TablePrefix+'_id']
                    }else $scope.fd.localVars.resourceRecordId= data.id
                     
                  }
                  do_refresh = true;
               
            }
            //get selectedRecord
            if ($scope.fd.localVars.resourceRecordId == null) $scope.fd.localVars.resourceRecordId=0;
            
            if ($scope.fd.localVars.resourceRecordId>0 && do_refresh) $scope.fd.localVars.GetRecordForUpdate($scope.fd.ParentDatasetDefId,$scope.fd.localVars.resourceRecordId)
            
            
        };
        
      
        if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
      
        let dependent_field,subscribedSubject,subject ,observer , val
        dependent_field = "Field"+$scope.fd.UuidRef
        /*
        if ($scope.fd.Parameters.RefreshOnIdChange)
        {
         
         //find 
         //subscribe observer
         
            subscribedSubject = "resourceidValueStateName"+$scope.fd.Parameters.ResourceIdItemId+$scope.resourceDefinition.transaction_id;
            subject = $scope.ksm.addSubject(subscribedSubject,null);                          
            observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
            val = $scope.ksm.getState(subscribedSubject);
            if ($scope.fd.localVars.TablePrefix+'_id' in val) $scope.fd.localVars.resourceRecordId= val.state[$scope.fd.localVars.TablePrefix+'_id']
            else $scope.fd.localVars.resourceRecordId= val.id
            
            //get selectedRecord
            if ($scope.fd.localVars.resourceRecordId == null) $scope.fd.localVars.resourceRecordId=0;
            
            if ($scope.fd.localVars.resourceRecordId>0) $scope.fd.localVars.GetRecordForUpdate($scope.fd.ParentDatasetDefId,$scope.fd.localVars.resourceRecordId);
        }
        */

  $scope.fd.localVars.showProperties=function(datasetMapperType,showPropertiesRight)
      {
            
            if ($scope.fd.localVars.datasetMapperType==undefined)
            {
               $scope.fd.localVars.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.fd.localVars.datasetMapperType==0 || $scope.fd.localVars.datasetMapperType!=datasetMapperType) 
                    $scope.fd.localVars.datasetMapperType = datasetMapperType;
               else 
                   $scope.fd.localVars.datasetMapperType=0;
            }
            if (showPropertiesRight) $scope.gsrvc.setFieldProperties($scope.fd);
            
      };
        

        $scope.fd.localVars.addAction=function()
        {
            if ($scope.fd.Parameters.flowActions==undefined) $scope.fd.Parameters.flowActions=[]
            $scope.fd.Parameters.flowActions.push({})   
        }

        $scope.fd.localVars.insertAction=function(index)
        {
            if ($scope.fd.Parameters.flowActions==undefined) $scope.fd.Parameters.flowActions=[]
            $scope.fd.Parameters.flowActions.splice(index,0,{})   
        }
         $scope.fd.localVars.delAction=function(index)
        {
            if ($scope.fd.Parameters.flowActions==undefined) $scope.fd.Parameters.flowActions=[]
            if ($scope.fd.Parameters.flowActions.length>index)  $scope.fd.Parameters.flowActions.splice(index,1)   
        }          
       $scope.fd.localVars.ExtractIdFromRecord=function(record){

        let record_id

        if (record!==undefined)
        {   
            if (Array.isArray(record) && record.length>0)
            {
                if ($scope.fd.localVars.TablePrefix+'_id' in record[0])
                {
                    record_id=record[0][$scope.fd.localVars.TablePrefix+'_id']
                 
                }else record_id = record[0].id

            }else{
                if ($scope.fd.localVars.TablePrefix+'_id' in record)
                {
                    record_id = record[$scope.fd.localVars.TablePrefix+'_id']
                 
                }else record_id = record.id

            }
        }else record_id = null

        return record_id   
    }

    $scope.fd.localVars.ProcessAuditInfo = function(record)
    {

        $scope.fd.localVars.CreatedByLabel = $scope.fd.ParametersLang.CreatedByTemplate.replace('{{user}}',record[$scope.fd.localVars.TablePrefix+'_CreatedBy.name'])
        $scope.fd.localVars.CreatedByLabel = $scope.fd.localVars.CreatedByLabel.replace('{{date}}',new Date(record[$scope.fd.localVars.TablePrefix+'_CreatedDateTime']).toLocaleDateString())
        $scope.fd.localVars.CreatedByLabel = $scope.fd.localVars.CreatedByLabel.replace('{{time}}',new Date(record[$scope.fd.localVars.TablePrefix+'_CreatedDateTime']).toLocaleTimeString())
        if (record[$scope.fd.localVars.TablePrefix+'_ChangedBy.name']!==null)
        {
            $scope.fd.localVars.ChangedByLabel = $scope.fd.ParametersLang.ChangedByTemplate.replace('{{user}}',record[$scope.fd.localVars.TablePrefix+'_ChangedBy.name'])
            $scope.fd.localVars.ChangedByLabel = $scope.fd.localVars.ChangedByLabel.replace('{{date}}',new Date(record[$scope.fd.localVars.TablePrefix+'_ChangedDateTime']).toLocaleDateString())
            $scope.fd.localVars.ChangedByLabel = $scope.fd.localVars.ChangedByLabel.replace('{{time}}',new Date(record[$scope.fd.localVars.TablePrefix+'_ChangedDateTime']).toLocaleTimeString())
            $scope.fd.localVars.HasChangedBy=true
        } 
    }

    $scope.fd.localVars.UpdateResourceRecord = function(datasetDefId,datasetRecordId){
         
        if (datasetRecordId===undefined) datasetRecordId=$scope.fd.localVars.resourceRecordId
        if (datasetDefId===undefined) datasetDefId=$scope.fd.ParentDatasetDefId
        let resource_id =  $scope.resourceDefinition.pageId
        let rversion = $scope.resourceDefinition.ExeVersion

        ResourcesDataService.updateResourceRecord(resource_id,$scope.fd.UuidRef,$scope.formData[$scope.fd.UuidRef][0],rversion).then(function(data) {



                                 let response = data.data
                                let rmsg = response.ResponseMsg
                                if (!rmsg) rmsg="Record updated successfuly!"
                                MessagingService.addMessage(rmsg,'success');

                                $scope.fd.localVars.resourceRecordId = $scope.fd.localVars.ExtractIdFromRecord(response.record)
                                //$scope.formData[$scope.fd.UuidRef][0] = response.record
                                WidgetDataExchangeService.setData({DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.fd.localVars.resourceRecordId}]}],
                                    actions: [{name:'PrepareData',status:false}],

                                    name: 'updateResourceWidget',widgetId: $scope.fd.UuidRef,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,

                                    taskId:  $scope.lTaskId,resource_id:$scope.resourceDefinition.page_state_id,resourceDefId : $scope.fd.Related, output:out_fields});
                                    
                                valueState.subject.notifyObservers("updateResourceRecord");
                                $scope.ksm.executeAction(valueStateName,"valueChanged", {datasetDefId:$scope.fd.Related,recordId:$scope.fd.localVars.resourceRecordId,record:$scope.formData[$scope.fd.UuidRef][0]});



                                        
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                   $scope.ksm.executeAction(valueStateName,"valueChanged", {error:true});
                                
        });
    } 

    $scope.fd.localVars.GetRecordForUpdate = function(datasetDefId,datasetRecordId){

         if (datasetRecordId===undefined) datasetRecordId=0
         if (datasetDefId===undefined) datasetDefId=0
         $scope.fd.localVars.resourceRecordId = datasetRecordId
         $scope.fd.ParentDatasetDefId = datasetDefId
         if ($scope.fd.ParentDatasetDefId==undefined || $scope.fd.ParentDatasetDefId==0) 
            {
                $scope.fd.ParentDatasetDefId=$scope.fd.Related
                datasetDefId=$scope.fd.ParentDatasetDefId
            }
         if ($scope.resourceDefinition.pageId==undefined) $scope.resourceDefinition.pageId=0

            let pageid = $scope.resourceDefinition.pageId
            let rinstance = $scope.resourceDefinition.page_instance_id
            let prev_resource_id = $scope.taskExecuteId
         if ($scope.fd.PopulateType.toString().substr(0,1)=='3')
         {
            //pageid = $scope.resourceDefinition.prev_page_id
            prev_resource_id = $scope.resourceDefinition.prev_page_instance_id
         
         }
         if (prev_resource_id==undefined) prev_resource_id=0

            TaskDataService.GetTaskUpdateResource($scope.fd.UuidRef,pageid,$scope.taskId,prev_resource_id,rinstance,$scope.fd.localVars.formType,datasetDefId,datasetRecordId,$scope.fd.Parameters.PublishedResourceVersion).then(function(data) {

                
            //TaskDataService.GetTaskUpdateResource($scope.fd.UuidRef,$scope.taskId,$scope.taskExecuteId,$scope.fd.localVars.formType,datasetDefId,datasetRecordId).then(function(data) {

                                  let dataset_record
                                  if (Array.isArray(data.data.data))
                                    {
                                      if  (data.data.length>0) dataset_record  = data.data.data[0]
                                      else dataset_record={}
                                    }
                                  else dataset_record  = data.data.data
                                  $scope.formData[$scope.fd.UuidRef][0] =  dataset_record
                                $scope.fd.localVars.resourceRecordId = $scope.fd.localVars.ExtractIdFromRecord(dataset_record)
                                   WidgetDataExchangeService.setData({DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:datasetDefId},{name:'resourceRecordId',value:$scope.fd.localVars.resourceRecordId}]}],
                                    actions: [{name:'PrepareData',status:false}],

                                    name: 'updateResourceWidget',widgetId: $scope.fd.UuidRef,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,

                                    taskId:  $scope.lTaskId,resource_id:$scope.resourceDefinition.page_state_id,resourceDefId : $scope.fd.Related, output:out_fields});
                                    

                                    $scope.ksm.executeAction(valueStateName,"valueChanged", {datasetDefId:datasetDefId,recordId:$scope.fd.localVars.resourceRecordId,record:$scope.formData[$scope.fd.UuidRef][0]});

                                    if ($scope.fd.Parameters.ShowAuditInfo) $scope.fd.localVars.ProcessAuditInfo(dataset_record)
                                        
                                  $scope.fd.localVars.dataDownloaded = true
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
      }    
    
      
      $scope.fd.localVars.GetRecordFilter = function(filter_data){

            $scope.fd.localVars.formLoaded = false
          ResourcesDataService.getDatasetData($scope.fd.Parameters.PublishedResourceId,filter_data).then(function(data) {

                                  let dataset_record
                                  if (Array.isArray(data.data))
                                    {
                                      if  (data.data.length>0) dataset_record  = data.data[0]
                                      else dataset_record={}
                                    }
                                  else dataset_record  = data.data
                                  $scope.formData[$scope.fd.UuidRef][0] =  dataset_record
                                  $scope.fd.localVars.formLoaded = true

                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                   $scope.fd.localVars.formLoaded = true
                             });
      }
              
       
      
      /*      
       $scope.fd.localVars.setReadOnly = function(form,readOnly)
        {
          if (form!=undefined){
     					for(var i=0;i<form.length;i++) {
                
                    if ('readOnly' in form[i])
                    {
                      form[i].readOnly = readOnly;
                     }
                      if ('layout' in form[i])
                      {
                           
                         $scope.fd.localVars.setReadOnly(form[i].layout,readOnly);
                      }
              }
          }
        }
       $scope.fd.localVars.setRequired = function(form,required)
        {
          if (form!=undefined){
     					for(var i=0;i<form.length;i++) {
                
                    if ('required' in form[i])
                    {
                      form[i].required = required;
                     }
                      if ('layout' in form[i])
                      {
                           
                         $scope.fd.localVars.setRequired(form[i].layout,required);
                      }
              }
          }
        }
        */
         $scope.fd.localVars.processTaskReturn = function(data)
        {

             if (data!=undefined){
                let rv
                if (Array.isArray(data))
                {
                 rv  = data
                }else rv =[data]

                  for(var i=0;i<rv.length;i++) {
                    
                    if ($scope.fd.UuidRef==rv[i].widgetId)
                    {
                      WidgetDataExchangeService.setData(rv[i]);
                      //$scope.fd.localVars.setField($scope.fd.localVars.dashboard.widgets.layout,'ReadOnly',true); //set all elements read-only
                    }
                  }
            }
            
        }

             $scope.fd.localVars.setSelectedResource = function(id,saved)  {
              //debugger //setSelectedDataset
              if ($scope.fd.localVars.selectedResourceItem==undefined) 
                                $scope.fd.localVars.selectedResourceItem={};
              $scope.fd.localVars.getPublishedResourceById(id,saved);

              
            }  
            
       
    $scope.fd.localVars.getPublishedResourceById = function(id,saved) 
 
    {
    
            let pos
            if (saved && $scope.fd.FormDef!==undefined && $scope.fd.FormDef!==null)
              { 
                    pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                    if (pos>=0){
                        $scope.fd.localVars.selectedResourceItem.name = $scope.fd.localVars.publishedResourceList[pos].name;
                        $scope.fd.localVars.selectedDataset = $scope.fd.localVars.publishedResourceList[pos]
                    }
                    $scope.fd.localVars.selectedResourceItem.id = id;
                    $scope.fd.localVars.selectedResourceItem.name_confirmed = $scope.fd.localVars.selectedResourceItem.name +' ('+$scope.fd.localVars.selectedResourceItem.id +')'
                    $scope.fd.localVars.selectedResourceItem_c=$scope.fd.localVars.selectedResourceItem;
                    $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
                    $scope.fd.localVars.dashboard.searchForm.layout=angular.copy($scope.fd.FormDef)
                    $scope.fd.localVars.formLoaded=true;

              }else{
                  pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                   
                  if (pos>=0){

                    
                    $scope.fd.localVars.selectedResourceItem = $scope.fd.localVars.publishedResourceList[pos]
               
                    
                    ResourcesDataService.GetPublishedResourceById(id).then(function (data) {
                        let jsonFile=$scope.fd.Related+"-v"+data.data.Version+".json"
                        ResourcesDataService.fetchJsonFile(jsonFile).then(function (widgetDef) {

                            if (widgetDef.status)
                            {
                                $scope.fd.localVars.formLoaded=true;
                                MessagingService.addMessage(widgetDef.data,'error');
                            }else{


                                $scope.fd.localVars.selectedResourceItem.Form = widgetDef.Form
                                $scope.fd.localVars.selectedDataset = $scope.fd.localVars.publishedResourceList[pos];
                                $scope.fd.localVars.dashboard.widgets.layout = widgetDef.Form
                                $scope.fd.localVars.selectedResourceItem_c=$scope.fd.localVars.selectedResourceItem
                                $scope.fd.localVars.selectedResourceItem.name_confirmed = $scope.fd.localVars.selectedResourceItem.name
                                if ($scope.fd.localVars.selectedResourceItem_c!==undefined)
                                {
                                    $scope.fd.Parameters.PublishedResourceId=$scope.fd.localVars.selectedResourceItem_c.id;
                                    $scope.fd.Parameters.PublishedResourceVersion=$scope.fd.localVars.selectedResourceItem_c.Version;
                                    $scope.fd.Related=$scope.fd.localVars.selectedResourceItem_c.ResourceDefUid; 
                                    $scope.fd.localVars.dashboard.searchForm.layout=angular.copy($scope.fd.localVars.selectedResourceItem_c.Form)
                                    $scope.fd.localVars.freshForm=angular.copy($scope.fd.localVars.selectedResourceItem_c.Form)
                                    $scope.fd.Related = $scope.fd.localVars.publishedResourceList[pos].ResourceDefUid

                                }else MessagingService.addMessage('Error - published dataset not selected','error')
                                
                                $scope.fd.FormDef = $scope.fd.localVars.dashboard.widgets.layout
                                $scope.fd.localVars.formLoaded=true;
                            }
                        },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                $scope.fd.localVars.formLoaded=true;
                   
                        }); 
                        
                        },function(error){    
                          MessagingService.addMessage(error.msg,'error');
                          $scope.fd.localVars.formLoaded=true;
                    });
                    
                }
            }
             
       
}

    if ($scope.fd.localVars.publishedResourceList==undefined) $scope.fd.localVars.publishedResourceList=[];
   var lang=$rootScope.globals.currentUser.lang;
                
   ResourcesDataService.GetPublishedResourcesByType('dataset','form').then(
        function (data) {       
           $scope.fd.localVars.publishedResourceList = data.data;
            $scope.fd.localVars.formLoaded = true
           //debugger  //GetPublishedResourcesByType   
           //$scope.fd.localVars.dashboard.widgets.layout = JSON.parse(data.data[0].Form)
                        
             if ($scope.fd.Parameters.PublishedResourceId!=null) 
                                        $scope.fd.localVars.setSelectedResource($scope.fd.Parameters.PublishedResourceId,true);
             
           },function(error){    
                          MessagingService.addMessage(error.msg,'error');
    });
 

   
       $scope.fd.localVars.setField = function(form,name,value,msg)
        {
     				TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
        };  
   
  
    let get_resource_record = function(data)
    {
        let rec = data.state?.itemValue?.val?.id

        if (!rec) rec = data.state

        if (rec) $scope.fd.localVars.GetRecordForUpdate($scope.fd.Related,rec)
    }

    $scope.fd.localVars.getThisResourceWidget  = function()
    {

        //register here to ksm
        let dependent_field = "Field"+$scope.fd.UuidRef;
        let subscribedSubject =$scope.resourceDefinition.page_state_id+'-'+$scope.fd.SrcWidgetId
        let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
        let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",get_resource_record);
        let val = $scope.ksm.getState(subscribedSubject)
        if (val.status=='ok' && val.state && !$scope.formDefinition) get_resource_record(val.state)
    }

    $scope.fd.localVars.getPreviousResourceWidget  = function(linkType)
    {
        var pTaskData;

        let pageState =  $scope.ksm.getState($scope.resourceDefinition.page_state_id)
        let prev_task_execute_id = pageState.state.previousTask?.task_execute_id
        let prev_page_id = $scope.resourceDefinition.prev_page_id
        let pTaskDataRet
        //pTaskDataRet = WidgetDataExchangeService.getPrevTaskData(prev_task_execute_id);
        pTaskDataRet = WidgetDataExchangeService.getPrevResourceData(prev_task_execute_id,$scope.resourceDefinition.prev_page_state_id,prev_page_id);

        if (Array.isArray(pTaskDataRet) && pTaskDataRet.length>0)
        {      
                var datasetId=0,datasetRecordId=0;
                for (let k=0;k<pTaskDataRet.length;k++)
                {
                   pTaskData = pTaskDataRet[k];
                   if (pTaskData!=undefined)
                   {
                      if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
                      {
                      for (var i=0;i<pTaskData.DEI.length;i++)
                      {
                        if ((pTaskData.DEI[i].name==linkType) || linkType==undefined)
                        {
                          if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                          {
                            
                            for (let j=0;j<pTaskData.DEI[i].value.length;j++)
                            {

                             if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined && pTaskData.DEI[i].value[j].value===$scope.fd.Related) 

                            {   
                                datasetId=pTaskData.DEI[i].value[j].value;
                                for (let k=0;k<pTaskData.DEI[i].value.length;k++)
                                {
                                    if (pTaskData.DEI[i].value[k].name=="resourceRecordId" && pTaskData.DEI[i].value[k].value!=undefined && datasetId!="0" && datasetId!="" && pTaskData.DEI[i].value[k].value>0) datasetRecordId=pTaskData.DEI[i].value[k].value;
                                }
                            }
                             
                              
                            }
                               
                              
                          }
                            
                        }
                          
                        }
                      }
                   }
                }
        }
        return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
        
    };
   
   
    if (!$scope.resourceDefinition.form_definition && $scope.fd.PopulateMethod=='A' && ($scope.fd.PopulateType.toString().substr(0,1)=='3' || $scope.fd.PopulateType.toString().substr(0,1)=='4'))  

    {
        $scope.fd.localVars.previousTaskData=$scope.fd.localVars.getPreviousResourceWidget();

        if ($scope.fd.localVars.previousTaskData===undefined)
        {
           $scope.fd.localVars.previousTaskData = {datasetRecordId:0,datasetId:$scope.fd.Related} 
        }

        if ($scope.fd.Related!=null && $scope.fd.Related!=undefined) $scope.fd.localVars.GetRecordForUpdate($scope.fd.localVars.previousTaskData?.datasetId,$scope.fd.localVars.previousTaskData?.datasetRecordId)

    }else if (!$scope.resourceDefinition.form_definition  && $scope.fd.PopulateType.toString().substr(0,1)=='2')
    {
          $scope.fd.localVars.getThisResourceWidget()
    }
    
    if (!$scope.resourceDefinition.form_definition && $scope.fd.PopulateMethod=='A' && $scope.fd.PopulateType.toString().substr(0,1)=='2')  

    {

        //subscribe to value_changed event
        let widgetIdFrom = $scope.resourceDefinition.page_state_id+'-'+$scope.fd.SrcWidgetId
        observer = $scope.ksm.subscribe(widgetIdFrom,dependent_field,"valueChanged",apply_value);
        let st = $scope.ksm.getState(widgetIdFrom)

        if (st.status=='ok')
        {
            val = st.state?.record
            if (val!=undefined)
            {
                if ($scope.fd.localVars.TablePrefix+'_id' in val) $scope.fd.localVars.resourceRecordId= val[$scope.fd.localVars.TablePrefix+'_id']
                else $scope.fd.localVars.resourceRecordId= val.id
            
                if ($scope.fd.localVars.resourceRecordId == null) $scope.fd.localVars.resourceRecordId=0;
            
                if ($scope.fd.localVars.resourceRecordId>0) $scope.fd.localVars.GetRecordForUpdate($scope.fd.ParentDatasetDefId,$scope.fd.localVars.resourceRecordId);
            }
        }

    }


         $scope.$on('InitiateTaskPostProcess'+$scope.resourceDefinition.transaction_id,function(event, data){
            $scope.fd.localVars.processTaskReturn(data)
              
         });
            
        $scope.$on('ExecuteTaskPostProcess'+$scope.resourceDefinition.task_execute_id,function(event, data){
              
            $scope.fd.localVars.processTaskReturn(data)
              
          });

        $scope.$on('ProcessWidgetPostProcess'+$scope.resourceDefinition.page_state_id,function(event, data){
              
            $scope.fd.localVars.processTaskReturn(data)
              
          });
        
  
    let template;
    if ($scope.formDefinition) template = $templateCache.get('ktdirectivetemplates/ktTaskUpdateResource.html');
    else template = $templateCache.get('ktdirectivetemplates/ktTaskUpdateResourceExe.html');
          
    $element.append($compile(template)($scope)); 
  
  
}];
  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

            

               let widgetState= scope.ksm.addSubject(scope.resourceDefinition.page_state_id+'-'+scope.fd.UuidRef,scope.fd.UuidRef);
                let widgetStateName = widgetState.subject.name;
                
                let clear_form = function()
                {
                  //scope.fd.localVars.dashboard.widgets.layout=[]
                  scope.fd.localVars.formLoaded=false
                  
                  $timeout(function(){
                    scope.fd.localVars.formLoaded=true;
                    //scope.fd.localVars.dashboard.widgets.layout = angular.copy(scope.fd.localVars.freshForm);
                    scope.formData[scope.fd.UuidRef]= [{}]
                    widgetState.subject.setStateChanges = scope.fd.UuidRef
                    widgetState.subject.notifyObservers("clearform");
                  })  
                
                
                 
               
                } 
                let action_form_cleared = scope.ksm.addAction(widgetStateName,"clearform",clear_form);


            scope.fd.localVars.resourceData = {};
            
            scope.fd.localVars.prepareResourceData = function(resourceRecordId){
           
     
                scope.fd.itemValue =  ResourcesDataService.prepareResourceWidgetData(scope.fd.localVars.dashboard.widgets.layout,resourceRecordId);
  
          }
          
          
           scope.fd.localVars.processWidgetDependencies = function() { //-----  ktUploader  -----
              
           if (scope.fd.tItemValue!=undefined) 
            for (var i=0;i< scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<scope.fd.tItemValue[i].DEI.length;j++) {
                        if ((scope.fd.tItemValue[i].DEI[j].name==linkedItem) && (scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("view "+scope.fd.PresentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                               // console.log("view "+ scope.fd.PresentationId+" dobio event " + event.name);
                                for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    scope.fd.localVars.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    scope.fd.localVars.resourceRecordId = scope.fd.localVars.linkedResourceId;
                                  }
                                  if (data[k].name=='resourceId') scope.fd.localVars.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                }
                          
                              //get selectedRecord
                              //scope.getFormResourceWithData();
                                
                                    //	data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId}
                                    
                              }) //on_END
                        }//if
                    }//for j
                }//if

             // else {  scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget

          if (scope.fd.PresentationId==undefined || scope.fd.PresentationId==null) scope.fd.PresentationId=0;
          
          scope.fd.localVars.formType=scope.resourceDefinition.form_type;
          /*
          TaskDataService.getWidgetDependencies(scope.taskId,scope.fd.PresentationId,scope.fd.localVars.formType).then(function(data) {
                               
                                scope.fd.tItemValue=data.data;
                                scope.fd.localVars.processWidgetDependencies();
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                                */
          
  
        }
  } 
        
};
'use strict';

export function ktTaskViewPdf () {
   
    var controller = ['$scope', '$uibModal','$stateParams','$timeout','CodesService','ResourcesDataService','$rootScope','ProcessingService','WidgetDataExchangeService','GridsterService','MessagingService','CODES_CONST','TaskDataService','KatalyoStateManager',
                      function ($scope,$uibModal,$stateParams,$timeout,CodesService,ResourcesDataService,$rootScope,ProcessingService,WidgetDataExchangeService,GridsterService,MessagingService,CODES_CONST,TaskDataService,KatalyoStateManager) {
      
      
    
    $scope.localVars={};
    $scope.gsrvc=GridsterService;
    $scope.localVars.datasetMapperType=0;
    $scope.fd.initialLoad=true;
    $scope.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_; 
    $scope.localVars.searchFormDownloaded = false;
    $scope.localVars.showSearchFilters=true;
    $scope.localVars.resourceDataDownloaded = false;
    $scope.localVars.selectedItems=[];
    $scope.taskId=$scope.resourceDefinition.ResourceDefId;
    if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
    if ($scope.taskId==undefined) $scope.taskId=0
    $scope.localVars.taskId=$scope.taskId;
    $scope.localVars.widgetType = 4;
    $scope.localVars.formParams={formViewType:1,showGridNavigation:true};
    $scope.localVars.cardLayoutParams={formViewType:1,showGridNavigation:true};
    //$scope.gsrvc.setFormViewType($scope.localVars.formParams={formViewType));
    $scope.localVars.parentDatasetDefId=$scope.fd.Related;
    $scope.localVars.animationsEnabled = true;
    if ($scope.fd.Parameters==undefined) $scope.fd.Parameters = {PresentationType:'table'};
    if ($scope.fd.Parameters.PresentationType==undefined || $scope.fd.Parameters.PresentationType==null) $scope.fd.Parameters.PresentationType='table';
    $scope.localVars.gridsterType="resource";
    $scope.itemValue = {val:null};
    $scope.localVars.isCollapsed = $scope.fd.Parameters.SearchFormCollapsed;
    if ($scope.localVars.isCollapsed==undefined) $scope.localVars.isCollapsed =true;
    if ($scope.fd.AutoSearch) $scope.localVars.resourceDataDownloading = true;

     $scope.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: {}
				} ;
        
         $scope.localVars.dashboardCard = {
  				id: '1',
  				name: 'Home',
  				widgets: {}
				} ;
       $scope.localVars.gridOptionsResourceData = {
           //  columnDefs: colDefs,
        //enableGridMenu: true,
        showGridFooter: true,
        showColumnFooter: true,
        enableRowSelection: true,
        multiSelect: $scope.fd.Multiline,
      //  enableHorizontalScrollbar : 1,
       // enableVerticalScrollbar : 2,
        enableFiltering: true,
        enableRowHeaderSelection: false,
        enableColumnResizing: true,
        enableColumnReordering: true,
        //useExternalPagination: false,
        paginationPageSizes: [10, 25, 50,100,200,500,1000,5000,10000],
       // enablePaginationControls: true,
      };

  var paginationOptions = {
    pageNumber: 1,
    pageSize: 10,
    sort: null
    };
    
    
       $scope.localVars.gridOptionsRelated = {
      //  columnDefs: colDefs,
       enableGridMenu: true,
       showGridFooter: true,
       showColumnFooter: true,
       enableRowSelection: false,
       multiSelect: false,
       enableHorizontalScrollbar : 2, 
       nableVerticalScrollbar : 2,
       enableFiltering: true,
       enableRowHeaderSelection: true,
       enableColumnResizing: true,
       minRowsToShow: 2,
      
   }
    
        $scope.taskId=$scope.resourceDefinition.ResourceDefId;
        if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
        if ($scope.taskId==undefined) $scope.taskId=0;
        
        //$scope.fd.PopulateType=1;
        $scope.fd.ParentDatasetDefId=$scope.fd.Related;
        $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
        $scope.localVars.formType=$scope.resourceDefinition.form_type;
        $scope.localVars.source_type=$scope.resourceDefinition.source_type;
        $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
        $scope.formDefinition = $scope.resourceDefinition.form_definition;
        if  ($scope.formDefinition==undefined)
        {
          
          $scope.formDefinition = false;
        }
        
        
        
        
          if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        
        $scope.localVars.resourceRecordId = 0;
        $scope.fd.ParentElementId = 0;
      
      var out_fields = ['resourceRecordId'];
      //resourceLink
      var widgetDefinition = {
            DEI: [{'name':'resourceLinkDatasetList','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],
            actions: [{name:'PrepareData',status:false}],
            name: 'datasetListWidget',
            widgetId: $scope.fd.PresentationId,
            taskId:  $scope.lTaskId,
            resourceDefId : $scope.fd.Related, //resourceDefId : $scope.selectedResource
            resourceRecordId:$scope.localVars.resourceRecordId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId, output:out_fields 
      };
      $scope.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
      $scope.localVars.LocalId=$scope.localVars.localWidgetId;
      $scope.fd.LocalId=$scope.localVars.localWidgetId;
          
       
         /**********************************************************************
         ****************** Sync data with State manager **********************
         ***********************************************************************/
        
        let dependent_field_pid = $scope.fd.LocalId;
        let subscribedSubjectPid = "formDefinitionState"+$scope.taskId+$scope.resourceDefinition.form_type;
        let dependent_field_pid2
        let update_presentation_id2 = function(data) {
            let presentation_id = angular.copy($scope.fd.PresentationId)
            if (data[presentation_id]!==undefined)
            {
                $scope.fd.PresentationId = data[presentation_id];
            //unsubscribe here later after implementing unsubscribe - ToDo
            dependent_field_pid2 = $scope.fd.PresentationId
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
            }
        }
        let update_presentation_id = function(data) {
            if (data[$scope.fd.LocalId]>0 && $scope.fd.PresentationId==0 && data[$scope.fd.LocalId]!==undefined) $scope.fd.PresentationId = data[$scope.fd.LocalId];
          
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
            //unsubscribe here later after implementing unsubscribe - ToDo
        }
        
        
        if ($scope.fd.PresentationId===null || $scope.fd.PresentationId===0)
        {
            let observerPid = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid,"formSaved",update_presentation_id);
        } else{
            dependent_field_pid2 = $scope.fd.PresentationId
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
        }
        
        if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
       
        
        let valueState= $scope.ksm.addSubject($scope.fd.ElementType+"ValueStateName"+$scope.fd.PresentationId+$scope.resourceDefinition.transaction_id,$scope.itemValue.val);
        let valueStateName = valueState.subject.name;
        
        let value_changed = function(data)
        {
            valueState.subject.setStateChanges = data;
            valueState.subject.notifyObservers("valueChanged");
        };
        
        let action_value_changed = $scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
       
        let apply_value = function(data)
        {
            $scope.itemValue.val = data;
        }; 
       
        if ( $scope.fd.Parameters.DependentFieldId!=undefined     && $scope.fd.Parameters.DependentFieldId!=null     && $scope.fd.Parameters.DependentFieldId!="" )
            {
                let dependent_field = "Field"+$scope.fd.Parameters.DependentFieldId;
                let subscribedSubject = $scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
            }
 
        
           $scope.localVars.showProperties = function(datasetMapperType)  {
            
           // if ($scope.localVars.datasetMapperType==undefined)
           // {
           //    $scope.localVars.datasetMapperType = datasetMapperType;
           // }else
           // {
           //    if ($scope.localVars.datasetMapperType==0 || $scope.localVars.datasetMapperType!=datasetMapperType) $scope.localVars.datasetMapperType = datasetMapperType;
           //    else $scope.localVars.datasetMapperType=0;
           // } 
           
                $scope.localVars.datasetMapperType = (datasetMapperType == $scope.localVars.datasetMapperType) ? 0: datasetMapperType;
            
           };
           
      $scope.localVars.gridOptionsResourceData.onRegisterApi = function (gridApi) {
        //set gridApi on scope
        $scope.localVars.gridApi = gridApi;
         if ($scope.restoreGridState) $scope.localVars.gridApi.saveState.restore($scope,$scope.fd.GridState);
          gridApi.selection.on.rowSelectionChanged($scope,function(row){

            $scope.localVars.datasetRecordSelected=row.isSelected;
            if ($scope.localVars.datasetRecordSelected)
              {
                if (row.entity.id!=$scope.localVars.selectedDatasetRecordId)
                {
                  $scope.localVars.selectedDatasetRecordId = row.entity.id;
                }
              }else
              {
                $scope.localVars.selectedDatasetRecordId = 0;
                
              }
              $scope.localVars.gridOptionsRelated.columnDefs=[];
              $scope.localVars.gridOptionsRelated.data=[];
              $scope.localVars.showGrid=false;
              $scope.localVars.prevTaskPackage ={resourceDefId:$scope.fd.Related,records:gridApi.selection.getSelectedRows()}
              
              
              $scope.localVars.selectedItems = gridApi.selection.getSelectedRows();
                
              //$rootScope.$broadcast('EventresourceLink'+$scope.fd.PresentationId,$scope.selectedDatasetRecordId);
            WidgetDataExchangeService.setData({
                  DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                        ,{name:'resourceRecordIds',value:gridApi.selection.getSelectedRows()},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
            
              
              
            });
          
            //external pagination
        /*
          gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
            paginationOptions.pageNumber = newPage;
            paginationOptions.pageSize = pageSize;
            $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,newPage,pageSize);
          });
      */
           gridApi.selection.on.rowSelectionChangedBatch($scope,function(row){

              $scope.localVars.prevTaskPackage ={resourceDefId:$scope.fd.Related,records:gridApi.selection.getSelectedRows()}
              
          });
     }
     
        
    let process_form_change = function(data)
    { 
        $scope.fd.Search = $scope.formData[$scope.fd.PresentationId];
        if ($scope.fd.Parameters.PresentationType=='table') $scope.localVars.getResourceColumns(true);
        else if ($scope.fd.Parameters.PresentationType=='dropdown') $scope.localVars.getDatasetDataList($scope.fd.Parameters.ClientSideFilter,true);
        else $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,1,$scope.localVars.pageSize);               
                      
    };
    
    
    //subscribe to events - initially only refresh data
   
    let dependent_field2 = "Field"+$scope.fd.PresentationId;
    let subscribedSubject2 = "task"+$scope.resourceDefinition.transaction_id;
    let observer2 = $scope.ksm.subscribe(subscribedSubject2,dependent_field2,$scope.fd.Parameters.EventName,process_form_change);

        
     $scope.localVars.ProcessSearchForm=function (form){
            
           if (form!=undefined){
            for(var i=0;i<form.length;i++) {
                
                    if ('ElementType' in form[i])
                    {
                      if (form[i].AutoSearch)
                      {
                        if (form[i].ElementType == 'resource')
                        {
                        var pos = $scope.localVars.childWidgets.map(function(e) { return e.widgetId; }).indexOf(form[i].PresentationId);
                        if (pos<0) $scope.localVars.childWidgets.push({widgetId:form[i].PresentationId,processed:false})
                        }
                        //subscribe to change
                        if (form[i].Parameters!=undefined)
                        {
                            if (form[i].Parameters.DependentFieldId!=undefined && form[i].Parameters.DependentFieldId!=null)
        
                            {
                                if (form[i].Parameters.DependentFieldId!="")
                                {
                                    let dependent_field = "Field"+$scope.fd.PresentationId;
                                    let subscribedSubject = form[i].ElementType+"ValueStateName"+form[i].ItemId+$scope.resourceDefinition.transaction_id;
                                    let subject = $scope.ksm.addSubject(subscribedSubject,null);
                                    let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",process_form_change);
                                }
                            }
                        }
                        
                      }
                      
                     }
                      if ('layout' in form[i])
                      {   
                       $scope.localVars.ProcessSearchForm(form[i].layout);
                      }
              }
          } 
           
      };
      
      $scope.localVars.SearchFormProcessed=false;


       $scope.localVars.setSelectedDataset = function(id)  {
              
              if ($scope.localVars.selectedResourceItem==undefined) $scope.localVars.selectedResourceItem={};
              var pos = $scope.localVars.datasetList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVars.selectedResourceItem.id = $scope.localVars.datasetList[pos].id;
                $scope.localVars.selectedResourceItem.name = $scope.localVars.datasetList[pos].name;
                $scope.localVars.selectedDataset = $scope.localVars.datasetList[pos];
                $scope.localVars.selectedResourceItem.name_confirmed = $scope.localVars.selectedResourceItem.name +' ('+$scope.localVars.selectedResourceItem.id +')'
                $scope.localVars.selectedResourceItem_c=$scope.localVars.selectedResourceItem;
                }
					};
          
       // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
           $scope.localVars.getDatasets = function()  {
						
                       if ($scope.localVars.datasetList==undefined) $scope.localVars.datasetList=[];
          
                       var lang=$rootScope.globals.currentUser.lang;
                       ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
                       
                      function(data) {
										
                                 $scope.localVars.datasetList = data.data;
                                  if ($scope.fd.Related!=null)
                                  {
                                   $scope.localVars.setSelectedDataset($scope.fd.Related);
                                   }     		 
                      },function(error){    
                       MessagingService.addMessage(error.msg,'error');
                      });
	};
            
      $scope.localVars.GetDatasetData=function(data)

      {
            fromWidget = data.widgetId;
            var allProcessed=true;
            var pos = $scope.localVars.childWidgets.map(function(e) { return e.widgetId; }).indexOf(fromWidget);

            for (var i=0;i<$scope.localVars.childWidgets.length;i++)
              {
                
                if ($scope.localVars.childWidgets[i].widgetId == fromWidget) $scope.localVars.childWidgets[i].processed = true;
                if (!$scope.localVars.childWidgets[i].processed) allProcessed = $scope.localVars.childWidgets[i].processed;
              }

              if($scope.fd.AutoSearch && allProcessed && $scope.localVars.SearchFormProcessed) {
                    $scope.localVars.selectedResource=$scope.fd.Related;
                    if ($scope.fd.Parameters!=null && $scope.fd.Parameters!=undefined)
                    {
                      if ($scope.fd.Parameters.PresentationType=='table') $scope.localVars.getResourceColumns(true);
                      else if ($scope.fd.Parameters.PresentationType=='dropdown') $scope.localVars.getDatasetDataList($scope.fd.Parameters.ClientSideFilter,false);
                      else $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,1,$scope.localVars.pageSize);               
                         
                    }                   
                }
      };
    
      if ($scope.localVars!=undefined) $scope.localVars.childWidgets = [];
      else $scope.localVars = {childWidgets : []};
      var fromWidget=0;

      let search_form_ready = function(data)
        {
            $scope.localVars.GetDatasetData(data); 
        };
        
        let action_search_form_ready = $scope.ksm.addAction(valueStateName,"SearchFormReady"+$scope.taskExecuteId+$scope.resourceDefinition.transaction_id,search_form_ready);
       
       
   
   //**********************************************************
	//           GET DATASET RELATED RECORDS
	//**********************************************************      
        $scope.localVars.getDatasetRelatedRecords = function (relatedDatasetId,recordId,modelId) {
  
  
         var lang = $rootScope.globals.currentUser.lang;
        
         ResourcesDataService.getResourceDataRelated($scope.fd.Related,recordId,relatedDatasetId,0,modelId,lang).then(
                function(data) {       
                                     $scope.localVars.gridOptionsRelated.data = data.data;
                                     $scope.localVars.gridOptionsRelated.columnDefs = data.columnsDef;
                                     $scope.localVars.showGrid=true;
                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
        
        
    //**********************************************************
	//           GET DATASET SINGLE RECORD
	//**********************************************************      
      $scope.localVars.getDatasetSingleRecord = function (relatedDatasetId,recordId) {
  
  
         var lang = $rootScope.globals.currentUser.lang;
        
         ResourcesDataService.getResourceDataDirectFilter(relatedDatasetId,0,lang,{id: recordId}).then(
         
                    function(data) {        
                                     $scope.localVars.gridOptionsRelated.data = data.data;
                                     $scope.localVars.gridOptionsRelated.columnDefs = data.columnsDef;
                               
                    },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
    
        $scope.$on('SearchFormReady'+$scope.taskExecuteId+$scope.fd.PresentationId,function(event, data1){
      
                                        $scope.localVars.GetDatasetData(data1); 
            
        });
        
    $scope.localVars.getFormResource = function(){   
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null) {
                $scope.fd.PresentationId = 0;
              }
               
               
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.Related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.PopulateType,$scope.fd.ParentElementId,$scope.fd.PresentationId,$scope.prevTaskExeId,$scope.localVars.formType,$scope.localVars.widgetType,$scope.localVars.resourceRecordId,"f",lang).then(function(data) {
                 
                                    $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                
                                    $scope.localVars.selectedResourceItem_c = {'name':$scope.localVars.resourceWidgetDefinition.name,'id':$scope.fd.Related,'relatedId':$scope.fd.Related,'presentationId':$scope.fd.PresentationId,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
                              
                                    $scope.fd.fItemValue=data.data.widgets;

                                    $scope.localVars.searchFormDownloaded = true;
                                    $scope.localVars.setField($scope.fd.fItemValue,'Required',false);
                                    $scope.localVars.formLoaded=true;
                                   //prepare search form
                                    $scope.localVars.ProcessSearchForm($scope.fd.fItemValue);
                                    $scope.localVars.SearchFormProcessed = true;
                                    if ($scope.localVars.childWidgets.length>0)
                                    {
                                      WidgetDataExchangeService.registerSearch({widgetId:$scope.fd.PresentationId,taskExecuteId:$scope.taskExecuteId,prevTaskExeId:$scope.prevTaskExeId,childWidgets:$scope.localVars.childWidgets});
                                    }
                                    else
                                    {
                                       $scope.ksm.executeAction(valueStateName,"SearchFormReady"+$scope.taskExecuteId+$scope.resourceDefinition.transaction_id, {widgetId:$scope.fd.PresentationId});
                                    }
                                    $scope.localVars.dashboard.widgets.layout =  data.data.widgets;
                                    if ($scope.formData == undefined) $scope.formData={};
                                    $scope.formData[$scope.fd.PresentationId] =  data.data.form_data;
                                    $scope.fd.Search = $scope.formData[$scope.fd.PresentationId];
                                    if ($scope.fd.Search==undefined) $scope.fd.Search={};
               
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error'); 
                             });
                              
      };//getFormResource_END
      
    $scope.localVars.executeDatasetList = function(){   
            var lang=$rootScope.globals.currentUser.lang;
            if ($scope.fd.PresentationId==null) {
                $scope.fd.PresentationId = 0;
            }
            if ($scope.localVars.selectedResource==undefined) $scope.localVars.selectedResource = $scope.fd.Related;
            if ($scope.localVars.pageSize==undefined) $scope.localVars.pageSize = paginationOptions.pageSize;
                   
            TaskDataService.ktTaskDatasetList($scope.fd.Related,$scope.fd.PresentationId,$scope.localVars.taskId,$scope.localVars.formType,lang).then(
        
                function(data) {
                 
                                    $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                 
                                    $scope.localVars.gridOptionsResourceData.columnDefs = data.data.columns;
                                    $scope.fd.fItemValue=data.data.widgets;
                                    if (data.data.widgetsCard!=null)
                                    {
                                        $scope.fd.wItemValue=data.data.widgets;
                                        $scope.localVars.dashboardCard.widgets.layout =  data.data.widgetsCard;
                                    }
                                    $scope.localVars.searchFormDownloaded = true;
                                    $scope.localVars.setField($scope.fd.fItemValue,'Required',false);
                                    $scope.localVars.formLoaded=true;
                                   
                                    $scope.localVars.dashboard.widgets.layout =  data.data.widgets;
                                    if ($scope.formData == undefined) $scope.formData={};
                                    $scope.formData[$scope.fd.PresentationId] =  data.data.formData;
                                    $scope.fd.Search = $scope.formData[$scope.fd.PresentationId];
                                    if ($scope.fd.Search==undefined) $scope.fd.Search={};
                                    
                                    //setup data grid or card
                                    $scope.localVars.gridOptionsResourceData.data = data.data.data;
                                    if ($scope.fd.Parameters.PresentationType=='card')
                                    $scope.localVars.gridOptionsResourceData.data = $scope.TransformDataForCard(data.data.data);
                                    $scope.localVars.restoreGridState();
                                    $scope.fd.initialLoad = false;
                                    $scope.localVars.resourceDataDownloaded = true;
                                    $scope.localVars.resourceDataDownloading = false;
                                    $scope.localVars.nextPage = data.data.data.next;
                                    $scope.localVars.previousPage = data.data.data.previous;
                                    $scope.localVars.totalCount=data.data.data.count;
                                    $scope.localVars.currentPage=1;
                                    if ($scope.localVars.totalCount>0 && $scope.localVars.currentPage==0) $scope.localVars.currentPage=1;
                                    $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/$scope.localVars.pageSize);
                                    
                                    $scope.localVars.gridOptionsResourceData.totalItems=$scope.localVars.totalCount;
               
                 },function(error){
                                   MessagingService.addMessage(error.msg,'error'); 
                             });
                              
      };//getFormResource_END

      
    
  $scope.localVars.getFormResourceOriginal = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
              ResourcesDataService.getResourceForm($scope.fd.Related,"i",lang).then(
               
                function(data) {
                            
                                $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                $scope.localVars.dashboard.widgets.layout=data.data.widgets;
                                 $scope.localVars.selectedResourceItem_c = {'name':$scope.localVars.resourceWidgetDefinition.name,'id':$scope.fd.Related,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
                            
                             
                                $scope.fd.fItemValue=data.data.widgets;
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.resourceRecordId}]}]});
						
                                 $scope.localVars.searchFormDownloaded = true;
                                 $timeout(function() {
                                            $scope.localVars.formLoaded=true;
                                 });
           
                                 if ($scope.formData == undefined) $scope.formData={};
                                 $scope.formData[$scope.fd.PresentationId] = [{}];
                                 $scope.fd.Search = $scope.formData[$scope.fd.PresentationId];
                            },
                 function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
   
     $scope.localVars.getDatasetCardLayoutOriginal = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
              ResourcesDataService.getResourceForm($scope.fd.Related,"i",lang).then(function(data) {
                            
                     $scope.localVars.resourceDefinitionCard= data.data.resourceDefinition;
                     $scope.localVars.dashboardCard.widgets.layout=data.data.widgets;
                     
                     $scope.fd.wItemValue=data.data.widgets;
                      
                      $timeout(function() {
                                $scope.localVars.cardLayoutLoaded = true;
                          
                      });
           
                      if ($scope.formDataCard == undefined) $scope.formDataCard={};
                         
               }, function(error){
                        MessagingService.addMessage(error.msg,'error');
                  });
                              
      };
      
      
     $scope.localVars.getCardLayout = function(){   
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null) {
                $scope.fd.PresentationId = 0;
              }
                
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.Related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.PopulateType,$scope.fd.ParentElementId,$scope.fd.PresentationId,$scope.prevTaskExeId,$scope.localVars.formType,$scope.localVars.widgetType,$scope.localVars.resourceRecordId,"w",lang).then(function(data) {
                 
                                    $scope.localVars.resourceDefinitionCard= data.data.resourceDefinition;
                               
                                    $scope.fd.wItemValue=data.data.widgets;
                                    $scope.localVars.dashboardCard.widgets.layout =  data.data.widgets;
                                    
                                    $scope.formDataCard =  data.data.form_data;
                                    if ($scope.formDataCard == undefined) $scope.formDataCard={};
                                   
                                    $timeout(function() {
                                           $scope.localVars.cardLayoutLoaded = true;
                                     
                                    });
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error'); 
                             });
                              
      };//getCardlayout_END

     $scope.localVars.selectCardItem = function(index){
        let value;
        if ($scope.localVars.selectedCardIndex!=index)
        {
            $scope.localVars.selectedCardIndex=index;
            value=$scope.localVars.gridOptionsResourceData.data[$scope.localVars.selectedCardIndex][0];
        }
        else
        {
            $scope.localVars.selectedCardIndex=null;
            value = null;
        }
        //send data to package
         WidgetDataExchangeService.setData({
                  DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                        ,{name:'resourceRecordIds',value:value},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
            
     };
      
   $scope.localVars.datasetRecordSelected = false;
   $scope.localVars.selectedDatasetRecordId = 0;
 
    $scope.localVars.restoreGridState= function() {
        if ($scope.fd.GridState!=null)
        {
           if ($scope.localVars.gridApi!=undefined)
           {
            $scope.localVars.gridApi.saveState.restore($scope,$scope.fd.GridState);
           }
           else
           {
            $scope.restoreGridState=true;
           }
        }
    };
      $scope.localVars.getResourceData = function () {

        var lang = $rootScope.globals.currentUser.lang;
        $scope.localVars.resourceDataDownloading = true;
        if ($scope.localVars.pageSize==undefined) $scope.localVars.pageSize = paginationOptions.pageSize;
        ResourcesDataService.getResourceData($scope.localVars.selectedResource,$scope.taskId,$scope.localVars.formType,lang).then(function(data) {
                               
                                     $scope.localVars.gridOptionsResourceData.data = data.data;
                                     $scope.localVars.gridOptionsResourceData.columnDefs = data.columnsDef;
                                     $scope.localVars.restoreGridState();
                                     $scope.fd.initialLoad = false;
                                     $scope.localVars.resourceDataDownloaded = true;
                                     $scope.localVars.resourceDataDownloading = false;
                                    
                                 },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                   $scope.localVars.resourceDataDownloading = false;
                             });
        };

    //**********************************************************
    //           GET FORM FIELDS
    //**********************************************************      
            
          $scope.localVars.getFormFields = function(){
              
              var lang=$rootScope.globals.currentUser.lang;
                      
              ResourcesDataService.getFormFields($scope.fd.Related,lang).then(function(data) {
                               
                                  $scope.localVars.PresentationElements= data.data;
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 
                             });
                              
          };
          
          
          $scope.$watch('itemValue.val',function(newValue,oldValue){
                  if (newValue!=oldValue)
                  {
                   //send data to package
                   let newValueSingle,newValueMultiple;
                   if ($scope.fd.Multiline)
                   {
                    newValueMultiple = newValue;
                    newValueSingle="";
                   }
                   else
                   {
                    newValueMultiple = {};
                    newValueSingle=newValue;
                   }
                   
                   $scope.ksm.executeAction(valueStateName,"valueChanged", newValue);
                   
                    WidgetDataExchangeService.setData({
                    DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:newValueSingle}
                        ,{name:'resourceRecordIds',value:newValueMultiple},{name:'resourceRecordsAll',value:$scope.localVars.datasetItems}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
           
                  }
      });
        
       
       //**********************************************************
      //           GET DATASET DATA FOR DROPDOWN
      //**********************************************************
      var refresh_list_from_callback=function(data)
            {
                $scope.localVars.getDatasetDataList(true);  
            }
        $scope.filterOnClient = function(items)
        {
            let temp=[];
            let search;
            if (Array.isArray($scope.fd.Search) && $scope.fd.Search.length>0) search = $scope.fd.Search[0];
            else search = $scope.fd.Search;
            for (let i=0;i<items.length;i++)
            {
                for (let key in search) {
                         
                    if (search[key]!=undefined)
                    {
                        if (key in items[i])
                        {
                            if (items[i][key]==search[key].id || search[key]==null || search[key]==undefined || items[i][key]==undefined)  temp.push(items[i]);
                        }else if (key in items[i])
                        {
                            if (items[i][key]==search[key] || search[key]==null || search[key]==undefined || items[i][key]==undefined)  temp.push(items[i]);
                        }else temp.push(items[i]);
                    }else temp.push(items[i]);
                }
                
                
            }
            return temp;
            
        }
        $scope.localVars.getDatasetDataList = function(fromCache,clientSideFilter)
        {
                    if (fromCache==undefined) fromCache=true;
                    if (clientSideFilter==undefined) clientSideFilter=false;
                    var lang = $rootScope.globals.currentUser.lang;
                    $scope.localVars.datasetItems = null;
                    ResourcesDataService.getResourceDataListAll($scope.fd.Related,$scope.fd.PresentationId,lang,fromCache,refresh_list_from_callback).then(function(data) {
                   
                        if (clientSideFilter) $scope.localVars.datasetItems = $scope.filterOnClient(data.data);
                        else $scope.localVars.datasetItems = data.data;
                        $timeout(function(){
                            
                            if ($scope.itemValue.val!=undefined)
                            {
                            let pos = $scope.localVars.datasetItems.map(function(e) { return e.id; }).indexOf($scope.itemValue.val.id);
                  
                                if (pos<0){
                                    $scope.itemValue.val = null;
                                }
                            }else
                            
                            {
                                $scope.itemValue.val = null;
                            }
                        });
                        
                    },function(error){    
                        MessagingService.addMessage(error.msg,'error');
                    });
              
            
        };
        
        $scope.localVars.GetDatasetDataClick = function()
        {
            if ($scope.fd.Parameters.PresentationType=='dropdown')
            {
               $scope.localVars.getDatasetDataList(); 
            }else
            {
                $scope.localVars.selectedResource=$scope.fd.Related;
                $scope.localVars.getResourceColumns(true);
            }
        };    
           
	$scope.TransformDataForCard = function(data)
    {
        let newData = [];
        let newElement = [];
        for (let i=0;i<data.length;i++)
        {
        
        newElement.push(data[i]);
        newData.push(newElement);
        
        newElement = [];
        }
        return newData; 
    };
      //**********************************************************
      //           GET RESOURCE DATA PAGINATED
      //**********************************************************      
    $scope.localVars.getResourceDataPaginated = function (urlNext,urlPrev,newPage,pageSize) {
        
        
        $scope.localVars.resourceDataDownloaded = false;        
        if (Math.ceil($scope.localVars.totalCount/pageSize)<newPage)
        {
          newPage = Math.ceil($scope.localVars.totalCount/pageSize);
        }
         
         var lang = $rootScope.globals.currentUser.lang;
          
         if (pageSize==undefined)
         
         {
          $scope.localVars.pageSize = paginationOptions.pageSize;
          pageSize= $scope.localVars.pageSize;
         }
         $scope.localVars.selectedItems.length=0;
         if ($scope.fd.PopulateMethod=='M')
         {
           $scope.localVars.resourceDataDownloading = true;
          
          ResourcesDataService.getResourceDataPaginatedFilter($scope.localVars.selectedResource,urlNext,urlPrev,newPage,pageSize,lang,$scope.fd.Search, $scope.localVars.dashboard.widgets.layout).then(function(data) {
                                    
                                    
                                    $scope.localVars.gridOptionsResourceData.data = data.data;
                                    if ($scope.fd.Parameters.PresentationType=='card')
                                    $scope.localVars.gridOptionsResourceData.data = $scope.TransformDataForCard(data.data);
                                    $scope.localVars.restoreGridState();
                                    $scope.fd.initialLoad = false;
                                    $scope.localVars.resourceDataDownloaded = true;
                                    $scope.localVars.resourceDataDownloading = false;
                                    $scope.localVars.nextPage = data.data.next;
                                    $scope.localVars.previousPage = data.data.previous;
                                    $scope.localVars.totalCount=data.data.count;
                                    $scope.localVars.currentPage=newPage;
                                    if ($scope.localVars.totalCount>0 && $scope.localVars.currentPage==0) $scope.localVars.currentPage=1;
                                    $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/pageSize);
                                    $scope.localVars.pageSize = pageSize;
                                    $scope.localVars.gridOptionsResourceData.totalItems=$scope.localVars.totalCount;
                                    
                                    WidgetDataExchangeService.setData({
                                    DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                                    ,{name:'resourceRecordIds',value: null},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
            
                                    $rootScope.$broadcast("StartTask"+$scope.fd.PresentationId+"Completed",$scope.localVars.gridOptionsResourceData.data);
                                   
                                   
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');
                                    $scope.localVars.resourceDataDownloading = false;
                             });
         }
         else if ($scope.fd.PopulateMethod=='A')
         {
          var task_instance=0;  
          if ($scope.localVars.formType=='i') task_instance = $scope.taskInitiateId;
          else task_instance = $scope.taskExecuteId;
           $scope.localVars.resourceDataDownloading = true;
          ResourcesDataService.getResourceDataPaginatedAuto($scope.localVars.selectedResource,urlNext,urlPrev,newPage,pageSize,lang,$scope.fd.PresentationId,task_instance,$scope.localVars.formType).then(function(data) {
                                      
                                    $scope.localVars.gridOptionsResourceData.data = data.data;
                                    $scope.localVars.restoreGridState();
                                    $scope.fd.initialLoad = false;
                                    $scope.localVars.resourceDataDownloaded = true;
                                    $scope.localVars.resourceDataDownloading = false;
                                    $scope.localVars.nextPage = data.data.next;
                                    $scope.localVars.previousPage = data.data.previous;
                                    $scope.localVars.totalCount=data.data.count;
                                    $scope.localVars.currentPage=newPage;
                                    $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/pageSize);
                                    $scope.localVars.pageSize = pageSize;
                                    $scope.localVars.gridOptionsResourceData.totalItems=$scope.localVars.totalCount;
                                    
                                    WidgetDataExchangeService.setData({
                                    DEI: [{name:'resourceLink',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                                    ,{name:'resourceRecordIds',value: null},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
            
                                    $rootScope.$broadcast("StartTask"+$scope.fd.PresentationId+"Completed",$scope.localVars.gridOptionsResourceData.data);
                                   
                                   
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');
                                    $scope.localVars.resourceDataDownloading = false;
                             });
          
         }
        };


    $scope.localVars.pageChanged = function(){ 
        $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,$scope.localVars.currentPage,$scope.localVars.pageSize);
         };
         
   //**********************************************************
	//           GET RESOURCE COLUMNS
	//**********************************************************      
  $scope.localVars.getResourceColumns = function (getData) {
     var lang = $rootScope.globals.currentUser.lang;
     if ($scope.localVars.selectedResource==undefined) $scope.localVars.selectedResource = $scope.fd.Related;
     
     if ($scope.localVars.selectedResource!=undefined && $scope.localVars.selectedResource!=null)
     {
           taskId = $scope.taskId;
           if ($scope.fd.PresentationId==undefined || $scope.fd.PresentationId==null || $scope.fd.PresentationId==0)
           {
              var taskId = 0;        
           }
      $scope.localVars.resourceDataDownloading = true;

     ResourcesDataService.getResourceColumns($scope.localVars.selectedResource,taskId,$scope.localVars.formType,lang).then(function(data) {
                                
                $scope.localVars.gridOptionsResourceData.columnDefs = data.data;
                if ($scope.localVars.currentPage==undefined) $scope.localVars.currentPage=1;
                if (getData && !$scope.formDefinition) $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,1,$scope.localVars.pageSize);               
                else
                {
                      $scope.localVars.restoreGridState();
                      $scope.fd.initialLoad = false;
                      $scope.localVars.resourceDataDownloaded = true;
                      $scope.localVars.resourceDataDownloading = false;
                }
                 },function(error){
                                    MessagingService.addMessage(error.msg,'error');
                                    $scope.localVars.resourceDataDownloading = false;
                             });
               
     }
  };
     
     $scope.localVars.getResourceDataFiltered = function () {

            $scope.filter = {};
            var lang = $rootScope.globals.currentUser.lang;

         
          if ($scope.localVars.selectedResource==null) {
            $scope.localVars.selectedResource = $scope.fd.Related;
          }
          $scope.localVars.resourceDataDownloading = true;
          
         ResourcesDataService.getResourceDataFiltered($scope.localVars.selectedResource,$scope.taskId,$scope.localVars.formType,lang,$scope.localVars.dashboard.data).then(function(data) {//MIGOR
                            
                         $scope.localVars.gridOptionsResourceData.data = data.data;
                         $scope.localVars.gridOptionsResourceData.columnDefs = data.columnsDef;
                         
                           $timeout(function(){
                             $scope.fd.initialLoad = false;
                             $scope.localVars.resourceDataDownloaded = true;
                             $scope.localVars.resourceDataDownloading = false;
                             $scope.localVars.restoreGridState();
                           });
                        
                            
                         },function(error){
                       MessagingService.addMessage(error.msg,'error');
                       $scope.localVars.resourceDataDownloading = false;
                    });
        };
		
       $scope.localVars.setField = function(form,name,value,msg)
        {
     				TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
        };
        
          $scope.localVars.showHideSearchForm = function()
        {
     				if ($scope.fd.ShowSearchForm) $scope.localVars.getFormResource();
        };
       
       
       
    $scope.localVars.getPreviousTaskWidget  = function(linkType)
    {
      var pTaskData = WidgetDataExchangeService.getPrevTaskData($scope.prevTaskExeId);
            var datasetId=0,datasetRecordId=0;
            let action;
            for (let k=0;k<pTaskData.length;k++)
            {
                if (pTaskData[k].DEI!=undefined && pTaskData[k].DEI!=null)
                {
                for (var i=0;i<pTaskData[k].DEI.length;i++)
                {
                  if (pTaskData[k].DEI[i].name==linkType)
                  {
                    if (pTaskData[k].DEI[i].value!=undefined && pTaskData[k].DEI[i].value!=null)
                    {
                      //populate selected item
                     
                      for (var j=0;j<pTaskData[k].DEI[i].value.length;j++)
                      {
                       if (pTaskData[k].DEI[i].value[j].name=="resourceId" && pTaskData[k].DEI[i].value[j].value!=undefined) datasetId=pTaskData[k].DEI[i].value[j].value;
                       if (pTaskData[k].DEI[i].value[j].name=="resourceRecordId" && pTaskData[k].DEI[i].value[j].value!=undefined)
                       {
                            datasetRecordId=pTaskData[k].DEI[i].value[j].value;
                            if ($scope.fd.Parameters.PresentationType == 'dropdown' && datasetId==$scope.fd.Related && !$scope.fd.Multiline)
                            {
                        
                                $scope.itemValue.val = pTaskData[k].DEI[i].value[j].value;
                                action = $scope.ksm.executeAction(valueStateName,"valueChanged", $scope.itemValue.val);
                            }
                       }
                       if (pTaskData[k].DEI[i].value[j].name=="resourceRecordIds" && pTaskData[k].DEI[i].value[j].value!=undefined)
                       {
                            datasetRecordId=pTaskData[k].DEI[i].value[j].value;
                            if ($scope.fd.Parameters.PresentationType == 'dropdown' && datasetId==$scope.fd.Related && $scope.fd.Multiline)
                            {
                        
                                $scope.itemValue.val = pTaskData[k].DEI[i].value[j].value;
                                action = $scope.ksm.executeAction(valueStateName,"valueChanged", $scope.itemValue.val);
                            }
                       }
                        
                      }
                         
                        
                    }
                      
                  }
                    
                  }
                }
            }
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };


   
  $scope.localVars.previousTaskData=$scope.localVars.getPreviousTaskWidget("resourceLinkDatasetList");
 
        
       $scope.localVars.saveGridState= function() {
       var state = $scope.localVars.gridApi.saveState.save();
       $scope.fd.GridState = state;
       MessagingService.addMessage("To make changes stick please save form",'info');
             
    };
  
                if ($scope.fd.Related!=null &&  !$scope.formDefinition && !$scope.localVars.searchFormDownloaded && !$scope.fd.Parameters.DownloadAllRecords)
                {
                  
                  $scope.localVars.executeDatasetList();
                  
                }else if ($scope.fd.Related!=null &&  !$scope.formDefinition && !$scope.localVars.searchFormDownloaded && $scope.fd.Parameters.DownloadAllRecords)
                {
                  if ($scope.fd.Parameters.PresentationType=='table') $scope.localVars.getResourceColumns(true);
                  if ($scope.fd.Parameters.PresentationType=='dropdown')
                  {
                    $scope.localVars.getDatasetDataList(true,$scope.fd.Parameters.ClientSideFilter);
                    $scope.localVars.getFormResource();
                  }
                  if ($scope.fd.Parameters.PresentationType=='card') $scope.localVars.getCardLayout();
                
                }
                else if ($scope.fd.Related!=null && ($scope.localVars.datasetMapperType==2 || $scope.fd.AutoSearch))
                {
                   $scope.localVars.getFormResource();
                   $scope.localVars.getDatasets();
                   if ($scope.fd.Parameters.PresentationType=='table') $scope.localVars.getResourceColumns(false);
                   else if ($scope.fd.Parameters.PresentationType=='card') $scope.localVars.getCardLayout();
                  
                }else if($scope.localVars.datasetMapperType!=5)
                {
                   $scope.localVars.showHideSearchForm();
                   $scope.localVars.getResourceColumns(false);
                   $scope.localVars.getDatasets();
                  
                }
                  
                  if ($scope.fd.Parameters!=null && $scope.fd.Parameters!=undefined)
                   {
                     if ($scope.fd.Parameters.PresentationType=="dropdown") $scope.localVars.getFormFields(); 
                   }
  
   $rootScope.$broadcast("Widget"+$scope.fd.PresentationId+"Ready",null);
        
}]; //controler_END

  return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskViewPdf.html',
            controller: controller,
            link: function (scope, elem, attrs) {
             }
             
             
  } 
        
};
'use strict';

export function ktTaskViewResource () {
   
   var controller = ['$scope', '$uibModal', '$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','KatalyoStateManager','UtilityService','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,KatalyoStateManager,UtilityService,$templateCache,$compile,$element) {
     

    var lang=$rootScope.globals.currentUser.lang;
    $scope.CTRL="ktTaskViewResource"
    

    $scope.fd.localVars = {
          showMenu: false,
          searchFormDownloaded: false,
          formLoaded: true,
          src_type_text: CODES_CONST._POPULATE_TYPE_,
          animationsEnabled: true,
          formParams: {formViewType:1, showGridNavigation:false},
          widgetType: 3,
          gridsterType: "dataset",
          resourceType:"dataset",
          datasetMapperType:0,
          searchFilter:[{}],
          resourceTypesList:[{type:'dataset',name:'Dataset'},{type:'file',name:'File'},{type:'counter',name:'Counter'}]
      }
      
    $scope.fd.localVars.TablePrefix = 'resource'+$scope.fd.Related
       $scope.fd.localVars.toggleDropdown = function(){
           $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
    }
    $scope.fd.localVars.ShowFormType='data'


    $scope.fd.localVars.searchFilter={}

    $scope.gsrvc = GridsterService;
    if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
    
    $scope.gsrvc.parentResource[$scope.fd.UuidRef] = $scope.fd

    $scope.fd.Parameters.ShowAdvancedProperties = true
    $scope.fd.localVars.ShowAdvancedProperties = true
    if (!$scope.fd.Parameters.SearchFormDependencies)  $scope.fd.Parameters.SearchFormDependencies = []
    if ($scope.formData===undefined)
    {

        $scope.formData={}

        $scope.formData[$scope.fd.UuidRef]=[{}]
        $scope.formData[$scope.fd.UuidRef+'-search']=[{}]

    }else
    {
        if ($scope.formData[$scope.fd.UuidRef]===undefined || $scope.formData[$scope.fd.UuidRef]===null) 
            {
                $scope.formData[$scope.fd.UuidRef]=[{}]
                $scope.formData[$scope.fd.UuidRef+'-search']=[{}]

            }
    }

      if ($scope.fd.PopulateType==undefined) $scope.fd.PopulateType="";
      
        
      $scope.fd.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: {},
                searchForm:{}
      } ;
      if ($scope.fd.ParametersLang===undefined || $scope.fd.ParametersLang===null) $scope.fd.ParametersLang={}

      if ($scope.fd.ParametersLang?.CreatedByTemplate===undefined)  $scope.fd.ParametersLang.CreatedByTemplate='Created by {{user}} on {{date}} at {{time}}'
      if ($scope.fd.ParametersLang?.ChangedByTemplate===undefined)  $scope.fd.ParametersLang.ChangedByTemplate='Last changed by {{user}} on {{date}} at {{time}}'

      $scope.taskId=$scope.resourceDefinition.ResourceDefUid;
      $scope.fd.localVars.resourceDefinition = $scope.resourceDefinition
      
      if ($scope.taskId==undefined) $scope.taskId=0;
      $scope.fd.localVars.taskId=$scope.taskId;
      $scope.fd.localVars.resourceId=$scope.taskId;
        
      if ($scope.fd.localVars.resourceId==0) $scope.fd.localVars.resourceId=$scope.resourceDefinition.id  
      $scope.fd.ParentResourceDefId=$scope.fd.Related;
      $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
      $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;
      if ($scope.fd.localVars.formType==undefined) $scope.fd.localVars.formType='i'
      $scope.source_type=$scope.resourceDefinition.source_type;
      $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
      $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
      $scope.formDefinition = $scope.resourceDefinition.form_definition;
      if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
      $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
	  
	  $scope.resourceDefinition.parentWidgetUid = $scope.fd.UuidRef
      

      $scope.fd.localVars.setField = function(form,name,value,msg)
      {
         TaskDataService.setField(form,name,value);
         if (msg) MessagingService.addMessage(msg,'info');
      };  
      
      $scope.fd.localVars.getFields = function(form,requiredFields,msg)
      {
         let resultProperties =  TaskDataService.getFields(form, requiredFields);
         if (msg) MessagingService.addMessage(msg,'info');
         return resultProperties
      }; 


      if ($scope.fd.PopulateMethod=='M')
      {

        $scope.fd.localVars.dashboard.searchForm = {layout:$scope.fd.FormDefSearch}
        //$scope.fd.localVars.setField($scope.fd.localVars.dashboard.searchForm.layout,"ReadOnly",false)
        $scope.fd.localVars.searchFormLoaded=true
      }    
      $scope.fd.localVars.resourceRecordId=0;
      if ($scope.taskInitiateId==undefined)
            $scope.taskInitiateId =0;
      if ($scope.taskExecuteId==undefined)
            $scope.taskExecuteId =0;  
      if ($scope.prevTaskExeId==undefined)
            $scope.prevTaskExeId =0;

      //register widget 
      var out_fields = ['resourceId'];
      var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{id:1,name:'refreshRecord'},{id:2,name:'reloadWidget'},{id:3,name:'setRecordId'}],widgetName: 'viewResourceWidget',dataSource:true,widgetLabel:'View resource record',fd:$scope.fd,parentResourceId:$scope.resourceDefinition.uid,widgetId: $scope.fd.UuidRef,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resource_id:$scope.resourceDefinition.page_state_id,resourceDefId : $scope.fd.Related, output:out_fields, };
      $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
      $scope.fd.localVars.LocalId=$scope.fd.localVars.localWidgetId;
      $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
      if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
      $scope.ksm = KatalyoStateManager;
      $scope.fd.localVars.widgetState = null;
       
      var valueState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+"-"+$scope.fd.UuidRef,$scope.fd.localVars.widgetState);
      var valueStateName = valueState.subject.name;
        
      //*********************** get state if exists ********************************************
      
      if (valueState.subject.currentStateIndex>=0)  {   
          $scope.fd.localVars.widgetState = valueState.subject.getState;
          $scope.fd.localVars.resourceRecordId = $scope.fd.localVars.widgetState.resourceRecordId;
          $scope.fd.localVars.loadFromState=true;
      } else {
        $scope.fd.localVars.widgetState={'resourceId':$scope.fd.Related,'resourceRecordId':0};
      }
      
      let value_changed = function(data){
          valueState.subject.setStateChanges = data;
          valueState.subject.notifyObservers("valueChanged");
      };
      
      let action_value_changed = $scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
       
       
       let apply_value = function(data)
        {
            let do_refresh=false;
            let state=data.state
            if (state!=undefined)
            {
               
                  if (typeof state ==='number') $scope.fd.localVars.resourceRecordId= state;
                  else if (Array.isArray(state))
                  {
                    if (state.length>0)
                    {
                        if ($scope.fd.localVars.TablePrefix+'_id' in state)
                        {
                            $scope.fd.localVars.resourceRecordId= state[0][$scope.fd.localVars.TablePrefix+'_id']
                        }else $scope.fd.localVars.resourceRecordId= state[0].id

                     }
                }else
                    {
                    if ($scope.fd.localVars.TablePrefix+'_id' in state)
                    {
                        $scope.fd.localVars.resourceRecordId= state[$scope.fd.localVars.TablePrefix+'_id']
                    }else $scope.fd.localVars.resourceRecordId= state.id
                     
                  }
                  do_refresh = true;
               
            }
            //get selectedRecord
            if ($scope.fd.localVars.resourceRecordId == null) $scope.fd.localVars.resourceRecordId=0;
            
            if ($scope.fd.localVars.resourceRecordId>0 && do_refresh) $scope.fd.localVars.GetRecordForView($scope.fd.ParentDatasetDefId,$scope.fd.localVars.resourceRecordId)
            
            
        };
        
      
     
      
      if ($scope.fd.Parameters.RefreshOnIdChange)
      {
         
         //find 
         //subscribe observer
           
         let dependent_field = "Field"+$scope.fd.UuidRef;
         let subscribedSubject = "resourceidValueStateName"+$scope.fd.Parameters.ResourceIdItemId+$scope.resourceDefinition.transaction_id;
         let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
         let val = $scope.ksm.getState(subscribedSubject);
         if ($scope.fd.localVars.TablePrefix+'_id' in val)
        {
            $scope.fd.localVars.resourceRecordId= val[$scope.fd.localVars.TablePrefix+'_id']
        }else $scope.fd.localVars.resourceRecordId= val.id
            
            //get selectedRecord
         if ($scope.fd.localVars.resourceRecordId == null) $scope.fd.localVars.resourceRecordId=0;
            
         if ($scope.fd.localVars.resourceRecordId>0) $scope.fd.localVars.GetRecordForView($scope.fd.ParentDatasetDefId,$scope.fd.localVars.resourceRecordId);
      }
      
      //subscribe observer
      if ($scope.fd.PopulateType.toString().substr(0,1)=="4")
      {
           /**********************************************************************
         ****************** Sync data with State manager **********************
         ***********************************************************************/
       
        if ($scope.fd.SrcWidgetId!=undefined && $scope.fd.SrcWidgetId!=null)
        
        {
           
                let dependent_field = "Field"+$scope.fd.SrcWidgetId;
               // let subscribedSubject = $scope.fd.Parameters.SrcWidgetType+"ValueStateName"+$scope.fd.SrcWidgetId;
                let subscribedSubject = "rlistValueStateName"+$scope.fd.SrcWidgetId+$scope.resourceDefinition.transaction_id;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
            
        }  
         
      }
      
      let refresh_widget_data = function()
      
      {
         $scope.fd.localVars.GetRecordForView($scope.fd.ParentDatasetDefId,$scope.fd.localVars.resourceRecordId)    
         
      }
      if ($scope.fd.Parameters.EventName!=undefined)
      {
         if ($scope.fd.Parameters.EventName!="")
         {
            let dependent_field2 = "Field"+$scope.fd.PresentationId;
            let subscribedSubject2 = "task"+$scope.resourceDefinition.transaction_id;
            let observer2 = $scope.ksm.subscribe(subscribedSubject2,dependent_field2,$scope.fd.Parameters.EventName,refresh_widget_data);
         }
      }
      
      
      $scope.fd.localVars.showProperties=function(datasetMapperType,showPropertiesRight)
      {
            
            if ($scope.fd.localVars.datasetMapperType==undefined)
            {
               $scope.fd.localVars.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.fd.localVars.datasetMapperType==0 || $scope.fd.localVars.datasetMapperType!=datasetMapperType) 
                    $scope.fd.localVars.datasetMapperType = datasetMapperType;
               else 
                   $scope.fd.localVars.datasetMapperType=0;
            }
            if (showPropertiesRight) $scope.gsrvc.setFieldProperties($scope.fd);
            
      };
   
      $scope.fd.openModal = function(modalId)
      {
        $(modalId).modal();
      }

      $scope.fd.localVars.addWidgetDep = function()
      {

        if ($scope.fd.localVars.DepSearchWidgetId){

            $scope.fd.Parameters.SearchFormDependencies.push({widget:$scope.fd.localVars.DepSearchWidgetId,processed:false})
            $scope.fd.localVars.DepSearchWidgetId=""
        }
      }

      $scope.fd.localVars.removeWidgetDep = function(idx)
      {

            $scope.fd.Parameters.SearchFormDependencies.splice(idx,1)
        
      }

    //process search form dependencies
      
    let process_search_form_ready = function(data)
    {   
        if (!$scope.fd.Parameters.SearchFormDependencies.length) return
        let widget = data?.state?.widget
        if (widget){
            let pos = $scope.fd.Parameters.SearchFormDependencies.map(function(e) { return e.widget; }).indexOf(widget)
     
            if (pos>=0 && data?.state?.processed)
            {
                $scope.fd.Parameters.SearchFormDependencies.splice(pos,1)
            }
        }
        
        if (!$scope.fd.Parameters.SearchFormDependencies.length && $scope.fd.AutoSearch && $scope.fd.PopulateMethod=='M' && !$scope.formDefinition) $scope.fd.localVars.GetRecord()

    }

    for (let i=0;i<$scope.fd.Parameters.SearchFormDependencies.length;i++){

            let dep_field = "Field"+$scope.fd.UuidRef
            let subSubject = $scope.resourceDefinition.page_state_id+'-'+$scope.fd.UuidRef+'-'+$scope.fd.Parameters.SearchFormDependencies[i].widget+'-widgetReady'
            let subj = $scope.ksm.addSubject(subSubject,null)
            let observer = $scope.ksm.subscribe(subSubject,dep_field,"widgetReady",process_search_form_ready)
            let val = $scope.ksm.getState(subSubject)
            if (val?.status=="ok" && val?.state) process_search_form_ready(val)
         
    } 
    

        $scope.fd.localVars.GetFormArray = function(position){

                $scope.fd.localVars.currentRecordIndex = $scope.fd.localVars.currentRecordIndex +position
                $scope.formData[$scope.fd.UuidRef][0] = $scope.fd.localVars.recordsArray[$scope.fd.localVars.currentRecordIndex]
        }
      
         $scope.fd.localVars.GetRecord = function(){

            let resourceVersion = 0
            if ($scope.fd.Parameters.PublishedResourceVersion) resourceVersion = $scope.fd.Parameters.PublishedResourceVersion

            if (!$scope.fd.Parameters.SelectVersionDirect) resourceVersion=0

         ResourcesDataService.getDatasetData($scope.fd.Related,$scope.formData[$scope.fd.UuidRef+'-search'][0],resourceVersion).then(function(data) {
             //ResourcesDataService.getTaskViewResource($scope.fd.PresentationId,$scope.taskId,$scope.fd.localVars.formType,$scope.fd.Related,).then(function(data) {

                                  let dataset_record
                                  if (Array.isArray(data.data))
                                    {
                                      if  (data.data.length>1) 
                                        {
                                            
                                            dataset_record  = data.data[0]
                                            $scope.fd.localVars.recordsArray = data.data
                                            $scope.fd.localVars.currentRecordIndex = 0
                                            $scope.fd.localVars.isMultipleRecords = true
                                        
                                        }else if (data.data.length==1){
                                            
                                            dataset_record  = data.data[0]
                                            $scope.fd.localVars.isMultipleRecords = false
                                        }
                                      else 
                                        {
                                            dataset_record={}
                                            $scope.fd.localVars.isMultipleRecords = false
                                        }
                                    }
                                  else 
                                    {
                                        dataset_record  = data.data
                                        $scope.fd.localVars.isMultipleRecords = false
                                    }
                                  $scope.formData[$scope.fd.UuidRef][0] =  dataset_record
                                $scope.fd.localVars.dataDownloaded = true
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                $scope.fd.localVars.isMultipleRecords = false
                             });
      }


    $scope.fd.localVars.ProcessAuditInfo = function(record)
    {

        $scope.fd.localVars.CreatedByLabel = $scope.fd.ParametersLang.CreatedByTemplate.replace('{{user}}',record[$scope.fd.localVars.TablePrefix+'_CreatedBy.name'])
        $scope.fd.localVars.CreatedByLabel = $scope.fd.localVars.CreatedByLabel.replace('{{date}}',new Date(record[$scope.fd.localVars.TablePrefix+'_CreatedDateTime']).toLocaleDateString())
        $scope.fd.localVars.CreatedByLabel = $scope.fd.localVars.CreatedByLabel.replace('{{time}}',new Date(record[$scope.fd.localVars.TablePrefix+'_CreatedDateTime']).toLocaleTimeString())
        if (record[$scope.fd.localVars.TablePrefix+'_ChangedBy.name']!==null)
        {
            $scope.fd.localVars.ChangedByLabel = $scope.fd.ParametersLang.ChangedByTemplate.replace('{{user}}',record[$scope.fd.localVars.TablePrefix+'_ChangedBy.name'])
            $scope.fd.localVars.ChangedByLabel = $scope.fd.localVars.ChangedByLabel.replace('{{date}}',new Date(record[$scope.fd.localVars.TablePrefix+'_ChangedDateTime']).toLocaleDateString())
            $scope.fd.localVars.ChangedByLabel = $scope.fd.localVars.ChangedByLabel.replace('{{time}}',new Date(record[$scope.fd.localVars.TablePrefix+'_ChangedDateTime']).toLocaleTimeString())
            $scope.fd.localVars.HasChangedBy=true
        } 
    }

    $scope.fd.localVars.ExtractIdFromRecord=function(record){

        let record_id

        if (record!==undefined)
        {   
            if (Array.isArray(record) && record.length>0)
            {
                if ($scope.fd.localVars.TablePrefix+'_id' in record[0])
                {
                    record_id=record[0][$scope.fd.localVars.TablePrefix+'_id']
                 
                }else record_id = record[0].id

            }else{
                if ($scope.fd.localVars.TablePrefix+'_id' in record)
                {
                    record_id = record[$scope.fd.localVars.TablePrefix+'_id']
                 
                }else record_id = record.id

            }
        }else record_id = null

        return record_id   
    }
          
     
      $scope.fd.localVars.GetRecordForView = function(datasetDefId,datasetRecordId){
         
         if (datasetRecordId===undefined) datasetRecordId=0
         if (datasetDefId===undefined) datasetDefId=0
         $scope.fd.localVars.resourceRecordId = datasetRecordId
         $scope.fd.ParentDatasetDefId = datasetDefId
         if ($scope.resourceDefinition.pageId==undefined) $scope.resourceDefinition.pageId=0

            let pageid = $scope.resourceDefinition.pageId
            let rinstance = $scope.resourceDefinition.page_instance_id
            let prev_resource_id = $scope.taskExecuteId
         if ($scope.fd.PopulateType.toString().substr(0,1)=='3')
         {
            //pageid = $scope.resourceDefinition.prev_page_id
            prev_resource_id = $scope.resourceDefinition.prev_page_instance_id
         
         }
         if (prev_resource_id==undefined) prev_resource_id=0

          TaskDataService.GetTaskViewResource($scope.fd.UuidRef,pageid,$scope.taskId,prev_resource_id,rinstance,$scope.fd.localVars.formType,datasetDefId,datasetRecordId,$scope.fd.Parameters.PublishedResourceVersion).then(function(data) {

                                  let dataset_record
                                  if (Array.isArray(data.data.data))
                                    {
                                      if  (data.data.length>0) dataset_record  = data.data.data[0]
                                      else dataset_record={}
                                    }
                                  else dataset_record  = data.data.data
                                  $scope.formData[$scope.fd.UuidRef][0] =  dataset_record
                                    $scope.fd.localVars.resourceRecordId = $scope.fd.localVars.ExtractIdFromRecord(dataset_record)
                                   WidgetDataExchangeService.setData({DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:datasetDefId},{name:'resourceRecordId',value:$scope.fd.localVars.resourceRecordId}]}],
                                    actions: [{name:'PrepareData',status:false}],

                                    name: 'viewResourceWidget',widgetId: $scope.fd.UuidRef,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,

                                    taskId:  $scope.lTaskId,resource_id:$scope.resourceDefinition.page_state_id, resourceDefId : $scope.fd.Related, output:out_fields})

                                    $scope.ksm.executeAction(valueStateName,"valueChanged", {datasetDefId:datasetDefId,recordId:$scope.fd.localVars.resourceRecordId,record:$scope.formData[$scope.fd.UuidRef][0]});
                                    
                                    if ($scope.fd.Parameters.ShowAuditInfo) $scope.fd.localVars.ProcessAuditInfo(dataset_record)

                                  $scope.fd.localVars.dataDownloaded = true
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
      }  

let get_resource_record = function(data)
{
    let rec = data.state?.itemValue?.val?.id

    if (!rec) rec = data.state

    if (rec) $scope.fd.localVars.GetRecordForView($scope.fd.Related,rec)
}

$scope.fd.localVars.getThisResourceWidget  = function()
{

    //register here to ksm
    let dependent_field = "Field"+$scope.fd.UuidRef;
    let subscribedSubject =$scope.resourceDefinition.page_state_id+'-'+$scope.fd.SrcWidgetId
    let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
    let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",get_resource_record);
    let val = $scope.ksm.getState(subscribedSubject)
    if (val.status=='ok' && val.state) get_resource_record(val.state)
}
$scope.fd.localVars.getPreviousTaskWidget  = function(linkType)
    {
        var pTaskData;

        let pageState =  $scope.ksm.getState($scope.resourceDefinition.page_state_id)
        let prev_task_execute_id = pageState.state.previousTask?.task_execute_id
        let prev_page_id = $scope.resourceDefinition.prev_page_id
        let pTaskDataRet
        //pTaskDataRet = WidgetDataExchangeService.getPrevTaskData(prev_task_execute_id);
        pTaskDataRet = WidgetDataExchangeService.getPrevResourceData(prev_task_execute_id,$scope.resourceDefinition.prev_page_state_id,prev_page_id);

        if (Array.isArray(pTaskDataRet) && pTaskDataRet.length>0)
        {      
                var datasetId=0,datasetRecordId=0;
                for (let k=0;k<pTaskDataRet.length;k++)
                {
                   pTaskData = pTaskDataRet[k];
                   if (pTaskData!=undefined)
                   {
                      if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
                      {
                      for (var i=0;i<pTaskData.DEI.length;i++)
                      {
                        if ((pTaskData.DEI[i].name==linkType) || linkType==undefined)
                        {
                          if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                          {
                            
                            for (let j=0;j<pTaskData.DEI[i].value.length;j++)
                            {

                             if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined && pTaskData.DEI[i].value[j].value===$scope.fd.Related) 

                            {   
                                datasetId=pTaskData.DEI[i].value[j].value;
                                for (let k=0;k<pTaskData.DEI[i].value.length;k++)
                                {
                                    if (pTaskData.DEI[i].value[k].name=="resourceRecordId" && pTaskData.DEI[i].value[k].value!=undefined && datasetId!="0" && datasetId!="" && pTaskData.DEI[i].value[k].value>0) datasetRecordId=pTaskData.DEI[i].value[k].value;
                                }
                            }
                             
                              
                            }
                               
                              
                          }
                            
                        }
                          
                        }
                      }
                   }
                }
        }
        return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
        
    };


   
 if (!$scope.resourceDefinition.form_definition && $scope.fd.PopulateMethod=='A' && $scope.fd.PopulateType.toString().substr(0,1)=='3') 

    {
        $scope.fd.localVars.previousTaskData=$scope.fd.localVars.getPreviousTaskWidget();

        if ($scope.fd.localVars.previousTaskData===undefined)
        {
           $scope.fd.localVars.previousTaskData = {datasetRecordId:0,datasetId:$scope.fd.Related} 
        }

    }else if ($scope.fd.PopulateType.toString().substr(0,1)=='2')
    {
          $scope.fd.localVars.getThisResourceWidget()
    }

    // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
    $scope.fd.localVars.getResources = function()  {

            if ($scope.fd.localVars.resourceList==undefined) $scope.fd.localVars.resourceList=[];
          
            let lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,$scope.fd.Parameters.SelectedResourceType).then(
                        function(data) {
                                        
                        $scope.fd.localVars.resourceList = data.data;
                        if ($scope.fd.Related!="" && $scope.fd.Related!=undefined && $scope.fd.Related!=null) {
                            let pos = $scope.fd.localVars.resourceList.map(function(e) { return e.id; }).indexOf($scope.fd.Related);
                            if (pos>=0) $scope.fd.localVars.selectedResourceItem = $scope.fd.localVars.resourceList[pos]
                        }
                        //$scope.fd.localVars.getPublishedResources()
                                             
                 },function(error){    
                    MessagingService.addMessage(error.msg,'error');
            });
    }

        $scope.fd.localVars.setSelectedResource = function(id,saved)  {

            if ($scope.fd.localVars.selectedResourceItem==undefined) $scope.fd.localVars.selectedResourceItem={};
            let pos = $scope.fd.localVars.resourceList.map(function(e) { return e.id; }).indexOf($scope.fd.Related);
            if (pos>=0 && $scope.fd.localVars.selectedResourceItem.id===undefined) 
            {
                $scope.fd.localVars.selectedResourceItem = $scope.fd.localVars.resourceList[pos]
               
            }
            $scope.fd.localVars.getPublishedResourceById(id,saved);
               
            if ($scope.fd.AutoSearch && $scope.fd.PopulateMethod=='M' && !$scope.formDefinition && !$scope.fd.Parameters.SearchFormDependencies.length) $scope.fd.localVars.GetRecord()

              
        }
     


        $scope.fd.localVars.getPublishedResourceById = function(id,saved){
            let pos
            let old_publish_id = $scope.fd.Parameters.PublishedResourceId
           
                   
            if (saved && $scope.fd.FormDef)
              { 
                    pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                    if (pos>=0){
                        $scope.fd.localVars.selectedPublishedResource = $scope.fd.localVars.publishedResourceList[pos];
                    }
                    
                    $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
                    $scope.fd.localVars.formLoaded=true

                    if ($scope.fd.PopulateMethod=='M')
                    {

                        $scope.fd.localVars.dashboard.searchForm.layout = $scope.fd.FormDefSearch
                        $scope.fd.localVars.searchFormLoaded=true;

                      
                    }

              }else{
                  pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  $scope.fd.FormDef={}
                  if (pos>=0){
                   
                    
                    ResourcesDataService.GetPublishedResourceById(id).then(function (data) {

                            let jsonFile=$scope.fd.Related+"-v"+data.data.Version+".json"
                            ResourcesDataService.fetchJsonFile(jsonFile).then(function (widgetDef) {
                                
                                 if (widgetDef.status)
                                {
                                     MessagingService.addMessage(widgetDef.data,'error');
                                    $scope.fd.localVars.formLoaded=true;
                                    $scope.fd.localVars.searchFormLoaded=true;
                                }else{

                                    $scope.fd.localVars.selectedResourceItem.Form = widgetDef.Form
                                    $scope.fd.localVars.selectedPublishedResource = $scope.fd.localVars.publishedResourceList[pos];
                                  
                                    
                                    if ($scope.fd.localVars.selectedResourceItem_c!==undefined)
                                    {
                                        $scope.fd.Parameters.PublishedResourceId=$scope.fd.localVars.selectedResourceItem_c.id;
                                        $scope.fd.Parameters.PublishedResourceVersion=$scope.fd.localVars.selectedResourceItem_c.Version;
                                        $scope.fd.Related=$scope.fd.localVars.selectedResourceItem_c.ResourceDefUid; 
                                        $scope.fd.localVars.freshForm=angular.copy($scope.fd.localVars.selectedResourceItem_c.Form)
                                    }
                                    $scope.fd.localVars.dashboard.widgets.layout = widgetDef.Form
                                  
                                    $scope.fd.FormDef = $scope.fd.localVars.dashboard.widgets.layout
                                    $scope.fd.localVars.formLoaded=true;

                                    
                                    $scope.fd.FormDefSearch = angular.copy($scope.fd.localVars.dashboard.widgets.layout)
                                    $scope.fd.localVars.dashboard.searchForm.layout = $scope.fd.FormDefSearch
                                    $scope.fd.localVars.searchFormLoaded=true;
                                }
                            },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                $scope.fd.localVars.formLoaded=true;
                                $scope.fd.localVars.searchFormLoaded=true;
                   
                        });      
                        },function(error){    
                            MessagingService.addMessage(error.msg,'error');
                            $scope.fd.localVars.formLoaded=true;
                            $scope.fd.localVars.searchFormLoaded=true;
                    });
                    
                }
            }
             
       
    }    
    
if ($scope.fd.localVars.resourceList==undefined) $scope.fd.localVars.resourceList=[];
if ($scope.fd.localVars.publishedResourceList==undefined) $scope.fd.localVars.publishedResourceList=[];
var lang=$rootScope.globals.currentUser.lang;
  
           
  ResourcesDataService.GetPublishedResourcesByType('dataset','form').then(
        function (data) {       
           $scope.fd.localVars.publishedResourceList = data.data;
           //debugger  //GetPublishedResourcesByType   
           //$scope.fd.localVars.dashboard.widgets.layout = JSON.parse(data.data[0].Form)
                        
           if ($scope.fd.Parameters.PublishedResourceId!=null) 
                                        $scope.fd.localVars.setSelectedResource($scope.fd.Parameters.PublishedResourceId,true);
             
           },function(error){    
                          MessagingService.addMessage(error.msg,'error');
    });
    
    //if ($scope.resourceDefinition.form_definition) $scope.fd.localVars.getResources();
   
  if ($scope.fd.Related!=null &&  !$scope.resourceDefinition.form_definition && !$scope.fd.localVars.searchFormDownloaded)
  { 
     if ($scope.fd.PopulateMethod=='A' && $scope.fd.PopulateType.toString().substr(0,1)=='3') $scope.fd.localVars.GetRecordForView($scope.fd.Related,$scope.fd.localVars.previousTaskData?.datasetRecordId)
   
  }

       
        $scope.fd.localVars.processWidgetDependencies = function() { //-----                
           if ($scope.fd.tItemValue!=undefined) 
            for (var i=0;i< $scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=$scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = $scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<$scope.fd.tItemValue[i].DEI.length;j++) {
                        if (($scope.fd.tItemValue[i].DEI[j].name==linkedItem) && ($scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = $scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("view "+$scope.fd.PresentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             $scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj $scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                              //  console.log("view "+ $scope.fd.PresentationId+" dobio event " + event.name);
                                for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    $scope.fd.localVars.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    $scope.fd.localVars.resourceRecordId = $scope.fd.localVars.linkedResourceId;
                                  }
                                  if (data[k].name=='resourceId') $scope.fd.localVars.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                }
                          
                              //get selectedRecord
                              $scope.fd.localVars.GetRecordForView($scope.fd.ParentDatasetDefId,$scope.fd.localVars.resourceRecordId)

                                    //	data: {resource_def_id:$scope.fd.linkedResourceDefId,resource_id:$scope.fd.linkedResourceId}
                                    
                              }) //on_END
                        }//if
                    }//for j
                }//if

             // else {  $scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget

          if ($scope.fd.PresentationId==undefined || $scope.fd.PresentationId==null)    $scope.fd.PresentationId=0;

          

          
          /*

          TaskDataService.getWidgetDependencies($scope.taskId,$scope.fd.PresentationId,$scope.fd.localVars.formType).then(function(data) {
                               
                                $scope.fd.tItemValue=data.data;
                                $scope.fd.localVars.processWidgetDependencies();
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                        */      
            
            $scope.fd.verify_blockchain_data = function () {
               
                
               ResourcesDataService.getBlockchainDatasetRecords($scope.fd.Related,'dataset','kataly1.code',1,$scope.formData[$scope.fd.UuidRef][0].BChainRecId,lang).then(function(data) {
                               
                                $scope.formData[$scope.fd.UuidRef][0].formDataBlockchain= JSON.parse(data.data.data.rows[0].datasetData);
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                
            };
            $scope.fd.get_transaction = function () {
               
                
               ResourcesDataService.getBlockchainTransaction($scope.formData[$scope.fd.UuidRef][0].TrxId,$scope.formData[$scope.fd.UuidRef][0].BlockId).then(function(data) {
                               
                               // let ret_val = {'block_num':data.data.block_num,'block_time':data.data.block_num,
                               // 'id':data.data.id,'traces':data.data.traces,'trx':data.data.trx};
                                let ret_val = data.data;
                                $scope.fd.BlockChainTransaction = JSON.stringify(ret_val,null,2);
                                $scope.fd.showTransaction = true;
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                
            };

           
    
            let template;
            if ($scope.formDefinition) template = $templateCache.get('ktdirectivetemplates/ktTaskViewResource.html');
            else template = $templateCache.get('ktdirectivetemplates/ktTaskViewResourceExe.html');
          
            $element.append($compile(template)($scope)); 

            $scope.fd.localVars.setField($scope.fd.localVars.dashboard.widgets.layout,"ReadOnly",true)

  
      }];

  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

              

        }     
  }
  
};
'use strict';

export function ktTaskWidget ($timeout) {
             var controller = ['$scope', '$stateParams','$state','$rootScope','GridsterService','$templateCache','$compile','$element',
                               function ($scope,$stateParams,$state,$rootScope,GridsterService,$templateCache,$compile,$element) {

             
             if ($scope.localVars==undefined) $scope.localVars={};
             if ($scope.fd==undefined) $scope.fd={};
             if ($scope.taskDefinition==undefined) $scope.taskDefinition={};
                   
             $scope.localVars.taskId = $scope.taskId;
             if ($scope.localVars.previousTask==undefined) $scope.localVars.previousTask = 0;
             if ($scope.localVars.outcomeId==undefined) $scope.localVars.outcomeId = 0;
             $scope.localVars.loadTaskDirect = true;
             
            $scope.localVars.ReloadTask=false;
            
             $scope.gsrvc=GridsterService;
             $scope.openedTaskInNewPage={localVars:{page_state_id:$scope.localVars.page_state_id},taskDefinition:null};

             $scope.gsrvc.setOpenTaskType("current");
   
             $scope.openTaskInNewPage=function(){
        
                          $scope.openedTaskInNewPage = $scope.gsrvc.getTaskDataInNewPage();
           
        
             };
                   
             let template;
             template = $templateCache.get('ktdirectivetemplates/ktTaskWidget.html');
             
          
             $element.append($compile(template)($scope));

          }];
          
          
        return {
            restrict: 'A',
            controller:controller,
            scope:{
             taskId: '=',
             fd: '=',
             localVars: '=?',
            },
             link: function (scope, elem, attrs) {
                 
                scope.$on('RefreshTask'+scope.localVars.taskId,function(event,data){

                      scope.localVars.ReloadTask=true;
                      $timeout(function(){ scope.localVars.ReloadTask=false;})
                });

              }
        }             
};
'use strict';

export function ktTextbox () {
        return {
            restrict: 'A',
            controller: function ($scope,$rootScope,GridsterService,KatalyoStateManager,CodesService,$templateCache,$compile,$element) {
                        
                if ($scope.localVars==undefined) $scope.localVars={};
                $scope.fd.localVars={};
                $scope[$scope.fd.id]  = {'fd': $scope.fd, 'localvars':$scope.fd.localVars}
                
                $scope.localVars.showBasic = true;
                $scope.localVars.showSize = true;
                $scope.localVars.showStyle = true;
                $scope.localVars.showGeneral = true;
                $scope.localVars.showAdvanced = true;
                $scope.myscope = $scope	    
                $scope.gsrvc = GridsterService;
                $scope.toggleMe = true;
                $scope.ksm = KatalyoStateManager;
                var lang=$rootScope.globals.currentUser.lang;
				

				
                CodesService.getCodesByName('usertags',lang).then(function (data) {
                       //debugger // CodesService.getCodesByName
                        $scope.fd.tagList = data.data;
                        
                         var pos = $scope.fd.tagList.map(function(e) { return e.id; }).indexOf($scope.fd.UniqueId);

                           if (pos>=0){
                               $scope.fd.UniqueIdObj=$scope.fd.tagList[pos];
                              
                           }
                     });
                
                $scope.searchFilter={};
                $scope.searchFilter[$scope.fd.PresentationId] = {};
                $scope.fd.localVars.search=[
                    {id:1,filter:'begins',code_name:'begins',name:"Begins with",icon:"fa fa-chevron-right"},
                    {id:2,filter:'contains',code_name:'contains',name:"Contains",icon:"fa fa-expand"},
                    {id:3,filter:'ends',code_name:'ends',name:"Ends with",icon:"fa fa-chevron-left"},
                    {id:4,filter:'eq',code_name:'eq',name:"Equals",icon:"fa fa-bars"} ];
                
                $scope.fd.localVars.processFilters = function(filterList)
                {
                    for (let i=0;i< $scope[$scope.fd.id]['fd'].localVars.search.length;i++)
                    {
                        let pos = filterList.map(function(e) { return e.id; }).indexOf( $scope[$scope.fd.id]['fd'].localVars.search[i].code_name);
                        if (pos>=0)  $scope[$scope.fd.id]['fd'].localVars.search[i].name = filterList[pos].name
                    }
                   
                    
                    if ($scope.fd.Search===undefined || $scope.fd.Search===null)   $scope.fd.Search= $scope[$scope.fd.id]['fd'].localVars.search[1];//initialize to equals
                    if ($scope.fd.Search)  $scope.fd.Search.Value=$scope.formData[0][$scope.fd.FieldName]; 

                    $scope[$scope.fd.id]['fd'].localVars.filterReady=true
                }

                if ($scope.showSearchFilters || $scope.resourceDefinition.form_definition)
                {
                    CodesService.getCodesByName('search_filters',lang).then(function (data) {
                                //debugger;
                                try {
                                    //$scope.fd.localVars.processFilters(data.data)
                                    $scope[$scope.fd.id]['fd'].localVars.processFilters(data.data) 
                                    //$scope.fd.localVars = $scope[$scope.fd.id]['fd'].localVars
                                } catch (err) { 
                                    console.log(err)
                                    debugger
                                }                                
                    });
                }
                if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
                let textValue = null;
                if ($scope.formData!=undefined)
                {
                        if (!$scope.formData.length) $scope.formData=[{}];
                        textValue=$scope.formData[0][$scope.fd.FieldName]
                        
                }else $scope.formData=[{}];
                
                let parentWidgetUid = ''

                if ($scope.parentWidget!=undefined) parentWidgetUid = $scope.parentWidget+'-'

                let textValueState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+'-'+parentWidgetUid+$scope.fd.UuidRef,textValue);
                let textValueStateName = textValueState.subject.name;
                
                
                let value_changed = function(data)
                {
                    textValueState.subject.setStateChanges = data;
                    textValueState.subject.notifyObservers("valueChanged");
                    $scope.localVars.refreshSearchValue();
                };
                
                let action_value_changed = $scope.ksm.addAction(textValueStateName,"valueChanged",value_changed);
               
                $scope.on_blur_action=function()
                {
                        
                        $scope.ksm.executeAction(textValueStateName,"valueChanged", $scope.formData[0][$scope.fd.FieldName]);
                        //$scope.fd.DefaultValue = $scope.formData[0][$scope.fd.FieldName];
                };
               
                
                
                let apply_value = function(data) {
                        if (data!=undefined) $scope.formData[0][$scope.fd.FieldName] = data;
                };
                
                if ($scope.fd?.Parameters?.DependentFieldId!=undefined && $scope.fd?.Parameters?.DependentFieldId!=null)   
                {
                    if ($scope.fd.Parameters.DependentFieldId!="")
                    {
                        let dependent_field = "Field"+$scope.fd.PresentationId;
                        let subscribedSubject = $scope.resourceDefinition.page_state_id+'-'+$scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId;
                        let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
                        let state = $scope.ksm.getState(subscribedSubject);
                        if (state.status=="ok") $scope.formData[0][$scope.fd.FieldName] = state.state;
                    }
                }
                
                $scope.localVars.refreshSearchValue = function() {
                    if ($scope.fd.Search) $scope.fd.Search.Value=$scope.formData[0][$scope.fd.FieldName];      
                };
                
                $scope.fd.SetDefault = function()
                {
                    $scope.fd.DefaultValue = {value:$scope.formData[0][$scope.fd.FieldName]};
                }
             
                $scope.fd.onSelectUnique = function(item,model)
                {    
                    $scope.fd.UniqueId=item.id;
                }
               
                let template;
                if ($scope.resourceDefinition.form_definition)  template = $templateCache.get('ktdirectivetemplates/ktTextbox.html');
                else template = $templateCache.get('ktdirectivetemplates/ktTextboxExe.html');
              
                $element.append($compile(template)($scope));  
                
                if (textValueState.subject.currentStateIndex>=0 && $scope.fd.Parameters.LoadFromState)
                {
                       
                        $scope.formData[0][$scope.fd.FieldName] = textValueState.subject.getState;
            
                }   
                
                if ($scope.formData[0][$scope.fd.FieldName]!=undefined) $scope.ksm.executeAction(textValueStateName,"valueChanged", $scope.formData[0][$scope.fd.FieldName]);
                
            },
       
            link: function (scope, elem, attrs) {
                
                                
                scope.applyTextFilters = function(index) {
                    scope.fd.Search=scope.fd.localVars.search[index];
                    if (scope.fd.Search && scope.formData!=undefined && scope.formData.length>0) {
                            scope.fd.Search.Value=scope.formData[0][scope.fd.FieldName]; 
                    }
                    if (scope.fd.Search.Value==undefined) scope.fd.Search.Value = "";
                };

                
             
                scope.showProperties = function(event) {
					scope.gsrvc.setFieldProperties(scope.fd, scope.inputArray); //inputArray is first parent of the element
                };
                
               if (scope.fd.UpdateWithDefault && !scope.fd.NoUpdate) scope.formData[0][scope.fd.FieldName] = scope.fd.DefaultValue?.value

                
                
              
            }
        };
};
'use strict';

export function ktTime () {
        return {
                restrict: 'A',
                controller: function ($scope,GridsterService,KatalyoStateManager,$templateCache,$element,$compile) {
                        
                        $scope.gsrvc = GridsterService;
                         $scope.showProperties = function()
                          {
                             //$scope.gsrvc.setFieldProperties($scope.fd);
							 $scope.gsrvc.setFieldProperties($scope.fd, $scope.inputArray);
							
                          };
                      
                        let template;
                        if ($scope.resourceDefinition.form_definition)  template = $templateCache.get('ktdirectivetemplates/ktTime.html');
                        else template = $templateCache.get('ktdirectivetemplates/ktTimeExe.html');
                        
                         $element.append($compile(template)($scope));  

                        },
        link: function (scope, elem, attrs,ngModelController) {
				
                  if (scope.formData===undefined) scope.formData = [{'Field':0}];
                  if (scope.formParams===undefined) scope.formParams = {formViewType:1};
                  if (scope.formParamsParent===undefined) scope.formParamsParent = {formViewType:1};
                  if (scope.fd.LabelLength === undefined) scope.fd.labelLength= 14;
                  if (scope.fd.localVars===undefined) scope.fd.localVars={}
                  if (scope.fd.ParametersLang===undefined) scope.fd.ParametersLang={format1:'HH:mm'};
                  
                     
                  scope.fd.timeFormatList = [{id:1,name:'HH:mm',mask:'99:99'},{id:2,name:'HH:mm:ss',mask:'99:99:99'},{id:3,name:'HH:mm'},{id:4,name:'HH:mm:ss:sss'}];
                  
                  if (scope.fd.ParametersLang!=undefined && scope.fd.ParametersLang!=null)
                  {
                     
                      var posFormatTime = scope.fd.timeFormatList.map(function(e) { return e.name.toString(); }).indexOf(scope.fd.ParametersLang.format1);
                          
                      if (posFormatTime>=0){
                         
                        scope.fd.ParametersLang.format1=scope.fd.timeFormatList[posFormatTime];
                                              
                      }
                         
                      scope.fd.localVars.format = scope.fd.ParametersLang.format1           

                  }  else scope.fd.localVars.format = scope.fd.timeFormatList[0]



                scope.search=[                    
                {id:1,filter:'gt',name:"From <time>",icon:"fa fa-chevron-right"},
                {id:2,filter:'lt',name:"To <time>",icon:"fa fa-chevron-left"},
                {id:3,filter:'eq',name:"On <time>",icon:"fa fa-bars"},      
                {id:4,filter:'between',name:"Between <time1> and <time2>",icon:"fa fa-expand"} ];
 
    
 
                if (scope.showSearchFilters)  {
                        if (scope.fd.Search===undefined || scope.fd.Search===null)   scope.fd.Search=scope.search[2];//initialize to equals
                        if (scope.fd.Search)  scope.fd.Search.value=scope.formData[0][scope.fd.FieldName]; 
                }
                scope.CTRL='ktTime';

        
                scope.refreshSearchValue = function() {
                        
                          if (scope.fd.Search && scope.formData!=undefined && scope.formData.length>0) {
                                    scope.fd.Search.value=scope.formData[0][scope.fd.FieldName]; 
                            }    
                } 
        
                scope.applyTimeFilters = function(index) {

                  scope.fd.Search = scope.search[index]
                  if (scope.fd.Search && scope.formData!=undefined && scope.formData.length>0) {
                            scope.fd.Search.value=scope.formData[0][scope.fd.FieldName]; 
                  }
                  if (scope.fd.Search.Value==undefined) scope.fd.Search.Value = "";

                  var i=scope.search[index].id; 

                  if (scope.search[index].id==4) scope.search.showSecondTime=true  
                  else  scope.search.showSecondTime=false
                                
                };

                
        }

   }

}

export function ktTimeParser () {
        return {
                restrict: 'A',
                require:'ngModel',
       
        link: function (scope, elem, attrs,ngModelController) {

                function formatInputTime(value){

                        let model_value

                        if (typeof value ==="string") model_value = new Date(value)
                        else model_value = value


                        return model_value

                }


                ngModelController.$formatters.push(formatInputTime)

            
        }

   }


}

'use strict';

export function ktToolbox () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktToolbox.html',
             /* scope:{
                	 form : '=',
            },*/
             controller: ['$scope','dragulaService','$rootScope','GridsterService','KatalyoStateManager',
          
            function($scope,dragulaService,$rootScope,GridsterService,KatalyoStateManager){
               
                $scope.gsrvc = GridsterService;      
                var widgetHandle = 'element-drag-handle';
                $scope.collapsed={};
                var setupDragula = $scope.gsrvc.setupDragula('bag-'+$scope.gridsterType,'resource-toolbox',widgetHandle);
                $scope.toolboxItems= $scope.gsrvc.getWidgetToolboxItems($scope.gridsterType);
                 //register to state manager
                        $scope.ksm = KatalyoStateManager;

                        let toolbox_loaded = function(data)
                        {
                            $scope.resourceToolboxLoaded(data.state);
                        };
                        
                         let toolbox_reload = function(data)
                        {
                          $scope.resourceToolboxLoaded(data);
                        };
                        
                        let toolboxState= $scope.ksm.addSubject($scope.gridsterType+"ToolBox",null);
                        let toolboxStateName = toolboxState.subject.name;

                        let action_toolbox_loaded = $scope.ksm.addAction(toolboxStateName,"toolboxLoaded",toolbox_loaded);
                        
                        let action_toolbox_reload = $scope.ksm.addAction(toolboxStateName,"toolboxReload",toolbox_reload);
                        
                        $scope.setCollapse=function(value,element_type){
                            if (element_type=="toolboxgroup")
                            {
                                if ($scope.collapsed[value]===undefined) $scope.collapsed[value] = true
                                else
                                {
                                    if ($scope.collapsed[value]) $scope.collapsed[value] = false
                                    else $scope.collapsed[value] = true;
                                }
                            }
                        }
                        
                        $scope.resourceToolboxLoaded=function(value){
                                
                                
                                if (!value)
                                {
                                    $scope.gsrvc.destroyDragula('bag-'+$scope.gridsterType);
                                   
                                }
                                else
                                {
                                    $scope.toolboxItems= $scope.gsrvc.getWidgetToolboxItems($scope.gridsterType);
                                   
                                }
                            }
               
                        
            
            }],
            
             link: function (scope, elem, attrs) {

              
              
        }
    }
};
'use strict';


export function ktTreeView() {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktTreeView.html',

             controller: function($scope,$rootScope,$timeout,WidgetDataExchangeService,MessagingService,GridsterService, UtilityService) {
                 
                
                $scope.gsrvc= GridsterService;
                
				if (!Array.isArray($scope.fd.selectedTasks)) $scope.fd.selectedTasks=[];
                if ($scope.resourceDefinition!=undefined)  {
                  $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
                }
                if ($scope.localVars == undefined) $scope.localVars={}
				 if ($scope.fd.localVars == undefined) $scope.fd.localVars={}
				 
				$scope.fd.localVars.ShowAdvancedProperties = true
				
				$scope.fd.localVars.chartTypes = [ 
                            {id:1,name:'line'},{id:2,name:'bar'}, 
                            {id:4,name:'doughnut'},{id:5,name:'pie'},{id:6,name:'polarArea'},
                            {id:99,name:'counter'}
                 ]
                $scope.localObj={loadedTasks : []};
                $scope.localVars.taskItem = null;   
                $scope.localVars.selectedTask = {};
                $scope.localVars.showMenu = false

                
                $scope.fd.localVars.dashboard = {
                    id: '1',
                    name: 'Home',
                    widgets: {}
				} ;
                 $scope.fd.localVars.taskItem = null;
                 $scope.fd.localVars.selectedTask = {};
                
                //MIGOR - PREBACIO IZ TASK ADD RESOURCE, TODO - IZBACITI VISAK
                $scope.taskId=$scope.resourceDefinition.ResourceDefId;
                if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
                if ($scope.taskId==undefined) $scope.taskId=0;
                $scope.fd.localVars.taskId=$scope.taskId;
                $scope.fd.ParentDatasetDefId=$scope.fd.Related;
                $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
                $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;
                $scope.source_type=$scope.resourceDefinition.source_type;
                $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
                $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
                $scope.formDefinition = $scope.resourceDefinition.form_definition;
                $scope.fd.localVars.resourceRecordId=0;
				
				if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4();
				$scope.fd.Parameters.UuidRef = $scope.fd.UuidRef;
                
                $scope.formDefinition = $scope.formDefinition || false
                $scope.taskInitiateId = $scope.taskInitiateId || 0
                $scope.taskExecuteId = $scope.taskExecuteId || 0
                $scope.prevTaskExeId = $scope.prevTaskExeId || 0
                let actions = [{id:1,name:"clear"},{id:2,name:"refreshSelected"}]
                var widgetDefinition = {DEI: [],actions: actions,widgetName: 'treeViewWidget',dataSource:true,widgetLabel:'Tree view',fd:$scope.fd,parentResourceId:$scope.resourceDefinition.uid,widgetId: $scope.fd.UuidRef,resource_id:$scope.resourceDefinition.page_state_id };
                $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
                $scope.fd.localVars.LocalId=$scope.fd.localVars.localWidgetId;
                $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
                if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
     
                
                $scope.fd.localVars.toggleDropdown = function(){
                    $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
                }
                
                
                $scope.fd.localVars.copyToClipboard = function(text){
                    $scope.fd.localVars.copyUuid = true;
                    navigator.clipboard.writeText(text).then( 
                        () => {
                            $timeout(function(){$scope.fd.localVars.copyUuid = false;},1000);
                        },
                        () => {    /* clipboard write failed */
                            MessagingService.addMessage('Copy to clipboard failed','error');
                            $timeout(function(){$scope.fd.localVars.copyUuid = false;},1000);
                    });                    
                }
        
                
                
                var  process_observed_data = function(data) // called by datasetList (via KSM)
                {     
                    $scope.fd.localVars.errormsg =''
                  
                    if (data==undefined || data?.state?.sharedData?.analytics==undefined)
                        return       
                    if ($scope.fd.Parameters.CalculateFunction?.name==undefined)  
                        $scope.fd.localVars.errormsg='Calculate Function not defined!'
      
                    if ($scope.fd.Parameters.treeType==undefined) 
                            $scope.fd.Parameters.treeType='basic'
                    
                    $scope.fd.localVars.SelectedChartAnalytics = $scope.fd.Parameters.SelectedChartAnalytics || 0     
                    $scope.fd.localVars.analytics =  data?.state?.sharedData?.analytics[$scope.fd.localVars.SelectedChartAnalytics][$scope.fd.Parameters.CalculateFunction.name]
                    let analytics =  $scope.fd.localVars.analytics 
                     
                    //find minvalue and maxvalue of current Anaytics data
                    $scope.fd.localVars.maxvalue=-1
                    $scope.fd.localVars.minvalue=-1
                    Object.keys(analytics).forEach(function(key,index) { //must use inverse logic (undefined == number is always false)
                            if (!( analytics[key] < analytics[$scope.fd.localVars.maxvalue]))   $scope.fd.localVars.maxvalue = key
                            if (!( analytics[key] > analytics[$scope.fd.localVars.minvalue]))   $scope.fd.localVars.minvalue = key      
                    })
 
        
                        
                        
                    $scope.fd.localVars.data = Object.values(analytics)
                    $scope.fd.localVars.labels = Object.keys(analytics)
                    
                    if (   $scope.fd.Parameters?.chartType?.name == 'pie' 
						|| $scope.fd.Parameters?.chartType?.name == 'doughnut' 
						|| $scope.fd.Parameters?.chartType?.name == 'polarArea') { 
                                     
                            $scope.fd.localVars.data =     [    $scope.fd.localVars.data    ]                                   
                    }
                    
                    if ($scope.fd.Parameters?.chartType?.name!=undefined) 
                        $scope.fd.localVars.chartType =  $scope.fd.Parameters.chartType.name 
                    else 
                        $scope.fd.localVars.chartType =  $scope.fd.Parameters.chartType //counter does not have .name
                  
                    
                    $scope.fd.localVars.chartLabel =  $scope.fd.Parameters.chartLabel
                    $scope.fd.localVars.sharedData = data?.sharedData
                    //summing all values for counter
                    $scope.fd.localVars.countAll = $scope.fd.localVars.data.reduce((partialSum, a) => partialSum + a, 0); 
					 
					
                    $scope.fd.localVars.scriptValue  = jsone($scope.fd.Parameters.script || '',  $scope.fd.localVars)
                
                }; 
 
            
    
            $scope.fd.localVars.setSelectedDataset = function(id,saved)  {
            //debugger
              if ($scope.fd.localVars.selectedResourceItem==undefined) $scope.fd.localVars.selectedResourceItem={}
              //pick orher parameters from database
              $scope.fd.localVars.getPublishedResourceById(id,saved);
              
		}
        
        
        $scope.fd.localVars.getPublishedResourceById = function(id,saved) 
        {
            let pos
            if (saved && $scope.fd.FormDef!==undefined && $scope.fd.FormDef!==null)
              { 
                    pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                    if (pos>=0){
                        $scope.fd.localVars.selectedResourceItem.name = $scope.fd.localVars.publishedResourceList[pos].name;
                        $scope.fd.localVars.selectedDataset = $scope.fd.localVars.publishedResourceList[pos]
                    }
                    $scope.fd.localVars.selectedResourceItem.id = id;
                    $scope.fd.localVars.selectedResourceItem.name_confirmed = $scope.fd.localVars.selectedResourceItem.name +' ('+$scope.fd.localVars.selectedResourceItem.id +')'
                    $scope.fd.localVars.selectedResourceItem_c=$scope.fd.localVars.selectedResourceItem;
                    $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
                    $scope.fd.localVars.formLoaded=true;

              }else{
                  pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                  if (pos>=0){
                    ResourcesDataService.GetPublishedResourceById(id).then(function (data) {

                            $scope.fd.localVars.selectedDataset = $scope.fd.localVars.publishedResourceList[pos];
                            $scope.fd.localVars.dashboard.widgets.layout = data.data.Form
                            $scope.fd.FormDef = $scope.fd.localVars.dashboard.widgets.layout
                            if ($scope.fd.localVars.selectedResourceItem_c!==undefined)
                            {
                                $scope.fd.Parameters.PublishedResourceId=$scope.fd.localVars.selectedResourceItem_c.id;
                                $scope.fd.Parameters.PublishedResourceVersion=$scope.fd.localVars.selectedResourceItem_c.Version;
                                $scope.fd.Related=$scope.fd.localVars.selectedResourceItem_c.ResourceDefId; 
                                $scope.fd.localVars.freshForm=angular.copy($scope.fd.localVars.selectedResourceItem_c.Form)
                                $scope.fd.Related = $scope.fd.localVars.publishedResourceList[pos].ResourceDefId

                            }else MessagingService.addMessage('Error - published dataset not selected ktTAskAdd','error')
          
                            $scope.fd.localVars.formLoaded=true;

                        },function(error){    
                          MessagingService.addMessage(error.msg,'error');
                    });

                }
            }
                   
}
       

       $scope.fd.localVars.calculateFunctions= [ {id:1,name:'sum'},{id:2,name:'mean'},{id:3,name:'min'},{id:4,name:'max'},{id:5,name:'count'} ]     



         $scope.fd.localVars.treeOptions= {
         
          }
          
             
        
      
		
            

						
                $scope.localVars.toggleDropdown = function()
                {
                           $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
                }
                              
                $scope.$on('InlineTaskClosed',function(event,data){
                    var taskId=data;
                    var pos = $scope.localObj.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
                    if (pos>=0) {
                      $scope.localObj.loadedTasks.splice(pos,1);  
                    }
                });
               
                if ($scope.fd.selectedTasks===undefined || $scope.fd.selectedTasks===null) $scope.fd.selectedTasks = [];
                
                if ($scope.fd.FormDef!=null && $scope.fd.FormDef!==undefined) {
                    $scope.fd.selectedTasks = $scope.fd.FormDef;
                }else   {
                    $scope.fd.FormDef = [];  
                } 
                
             /*   let initiate_task = function(data)
                {
                    let loadTask=false;
                    $scope.localVars.taskLoaded = false;
                    if ($scope.localObj.loadedTasks.length>0)  {
                        if ($scope.localObj.loadedTasks[0].taskId.id != data.taskId) {
                            $scope.localObj.loadedTasks.length=0;
                            loadTask=true;
                        }
                    } else loadTask=true;
                    
                    $scope.localObj.loadedTasks.splice(0,1);
                         
                    for (let j = 0;j<$scope.fd.selectedTasks.length;j++) {
                            if ($scope.fd.selectedTasks[j].taskId.id==data.taskId) {
                                $timeout(function(){
                                    $scope.localObj.loadedTasks.push(data);
                                    $scope.localVars.taskLoaded = true;
                                });
                            }
                        }
                }*/
                                
                  //subscribe to events - initially only refresh data    
                        
                  if ($scope.resourceDefinition.page_state_id && $scope.fd.Parameters.widgetReference ) {
                        let whoami ='chart'+ $scope.fd.UuidRef  // valueStateName           
                        let subscribedSubject = $scope.resourceDefinition.page_state_id + '-'+ $scope.fd.Parameters.widgetReference //odabraniUUIDnekogELEMENTA    
                        let observer = $scope.ksm.subscribe(subscribedSubject,whoami,"valueChanged",process_observed_data);   
                  }
                   
               
               let lang=$rootScope.globals.currentUser.lang;  
               

                $scope.localVars.taskIsOpen = function(taskId)
                  {
                    var isOpenPos = $scope.localObj.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (isOpenPos>=0) return true;
                    else return false;
                  }
                 
                 $scope.fd.pasteFromClipboard = function(task){
                        
                        navigator.clipboard.readText().then( (data) => {
                            /* clipboard successfully read */
                            $timeout(function(){task.widgetId = data})
                        },
                        () => {
                            /* clipboard read failed */
                            MessagingService.addMessage('Paste from clipboard failed','error');
                        });
                       
                }

                  

 
             
          $scope.fd.localVars.showProperties = function(datasetMapperType,showPropertiesRight)
          {
               //debugger
                if ($scope.fd.localVars.datasetMapperType==undefined)
                {
                   $scope.fd.localVars.datasetMapperType = datasetMapperType;
                }else
                {
                   if ($scope.fd.localVars.datasetMapperType==0 || $scope.fd.localVars.datasetMapperType!=datasetMapperType) 
                        $scope.fd.localVars.datasetMapperType = datasetMapperType;
                   else 
                       $scope.fd.localVars.datasetMapperType=0;
                }
               
                 
                if (showPropertiesRight) $scope.gsrvc.setFieldProperties($scope.fd);
           
                if ($scope.fd.localVars.dashboard != undefined)  {
                    //debugger
                     $scope.fd.localVars.fieldsList = []
                     $scope.fd.localVars.getFieldNamesFromObject($scope.fd.localVars.dashboard, $scope.fd.localVars.fieldsList)
                    
                }
          };
          
          
 
       $scope.fd.localVars.getFieldNamesFromObject = function (obj, fieldsList)   // find FieldNames in given Dashboard object recursively 
     {// fieldsList  is return variable (used for multiple select)
        //debugger
        var o = {};
        Object.keys(obj).forEach(function(key) {
          
            if ( (typeof(obj[key]) === 'object') && obj[key]    && key != 'NameField')  { //Do NOT parse 'NameField'  (we need it as it is)
              $scope.fd.localVars.getFieldNamesFromObject(obj[key], fieldsList)
            } 
            else {          
                    if (key == 'FieldName'  ) {  
                        //debugger
                        o[key]= obj[key];
                        }
                  
                    if (key == 'PresentationId' ) {
                        o['id']= obj[key];
                    }    
                    if (key == 'Label' ) {
                        o['name']= obj[key];
                    }    
                }
            }) ; 
        
        if ( o['FieldName'] && Object.keys(o).length > 0 ) fieldsList.push(o)   
    }; 

                
         },
             link: function (scope, elem, attrs) {
                
               
        }       
              
    }
  
};



    
    
     
            
            
'use strict';

export function ktUiForm ($timeout,UtilityService) {
   
   var controller = ['$scope', '$uibModal', '$state','$stateParams','dragularService','$timeout','CodesService','ResourcesDataService','UtilityService','$rootScope','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','CODES_CONST','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$state,$stateParams,dragularService,$timeout,CodesService,ResourcesDataService,UtilityService,$rootScope,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,CODES_CONST,$templateCache,$compile,$element) {
      
      $scope.fd.localVars = {};
      $scope.fd.localVars.searchFormDownloaded = false;

      $scope.fd.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_;
      $scope.fd.localVars.animationsEnabled = true;
      $scope.fd.localVars.widgetType = 1;
      $scope.fd.localVars.hidePopulateMethod = true;
      $scope.fd.localVars.datasetMapperType=0;      
      $scope.fd.localVars.formParams={formViewType:1,showGridNavigation:false};
      $scope.fd.localVars.showMenu = false
      $scope.fd.localVars.widgetReady=false
      $scope.gsrvc = GridsterService
      $scope.fd.localVars.ShowAdvancedProperties = true
      //$scope.fd.localVars.resourceTypesList=[{type:'form',name:'UI form'}]
	  $scope.gsrvc.parentResource[$scope.fd.UuidRef] = $scope.fd

      if ($scope.fd.Parameters===null || $scope.fd.Parameters===undefined) $scope.fd.Parameters = {}
      if ($scope.formData===undefined)  $scope.formData={}
      $scope.formData[$scope.fd.UuidRef]= [{}]
      if ($scope.fd.Multiline) $scope.formData[$scope.fd.UuidRef]= [[{}]]
      $scope.fd.Parameters.SelectedResourceType='form'

      $scope.fd.Parameters.ShowAdvancedProperties = true
      $scope.fd.localVars.selectedRecords={}

      $scope.fd.localVars.toggleDropdown = function(){
           $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
       }
       
      
      $scope.formParamsParent=$scope.formParams;
      
      if ($scope.fd!=undefined){
           $scope.fd.PopulateMethod = "M";
      } else {
           $scope.fd={PopulateMethod : "M"};
      }
	  
      if (typeof($scope.fd.DatasetMapping)=='string') $scope.fd.DatasetMapping=[];
        
        $scope.fd.localVars.gridsterType="dataset";
        $scope.fd.localVars.resourceType="form";
    
          
        $scope.fd.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: {}
		} ;
       
        
        $scope.taskId=$scope.resourceDefinition.ResourceDefUid;
        if ($scope.taskId==undefined) $scope.taskId="0";
        $scope.fd.localVars.taskId=$scope.taskId;
        $scope.fd.localVars.resourceId=$scope.taskId;
        if ($scope.fd.localVars.resourceId=="0") $scope.fd.localVars.resourceId=$scope.resourceDefinition.id  

        $scope.fd.localVars.resourceDefinition = $scope.resourceDefinition
        $scope.fd.ParentDatasetDefId=$scope.fd.Related;
        $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
        $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;
        $scope.source_type=$scope.resourceDefinition.source_type;
        $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
        $scope.formDefinition = $scope.resourceDefinition.form_definition;
        $scope.fd.localVars.resourceRecordId=0;
        
        $scope.formDefinition = $scope.formDefinition || false
        $scope.taskInitiateId = $scope.taskInitiateId || 0
        $scope.taskExecuteId = $scope.taskExecuteId || 0
        $scope.prevTaskExeId = $scope.prevTaskExeId || 0
		
		$scope.resourceDefinition.parentWidgetUid = $scope.fd.UuidRef
    

    if ($scope.fd.Multiline) $scope.fd.localVars.dashboard.widgets = []
        
      //register widget 
      var out_fields = ['resourceId']
      if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
                
      let w_actions=[
                    {id:1,name:'clearForm'},
                    {id:2,name:'setFormData'},
                    {id:3,name:'loadDataFromDatasource'},
                   // {id:4,name:'setRecords'},  
                ]

      var widgetDefinition = {DEI: [],actions: w_actions,widgetLabel: 'UI form',widgetName: 'uiForm',dataSource:true,widgetId: $scope.fd.UuidRef,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resource_id:$scope.resourceDefinition.page_state_id,resourceDefId : $scope.fd.Related, output:out_fields,parentResourceId:$scope.fd.localVars.resourceDefinition.uid };
      
      $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
      $scope.fd.localVars.localId=$scope.fd.localVars.localWidgetId;
      $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
      
      if ($scope.resourceDefinition.showHidden==undefined) $scope.resourceDefinition.showHidden={}
	  
	  $scope.resourceDefinition.showHidden[$scope.fd.UuidRef] = true
      
      $scope.fd.localVars.showProperties=function(datasetMapperType,showPropertiesRight)
      {    
            if ($scope.fd.localVars.datasetMapperType==undefined) {
               $scope.fd.localVars.datasetMapperType = datasetMapperType;
            } else {
               if ($scope.fd.localVars.datasetMapperType==0 || $scope.fd.localVars.datasetMapperType!=datasetMapperType) 
                    $scope.fd.localVars.datasetMapperType = datasetMapperType;
               else 
                   $scope.fd.localVars.datasetMapperType=0;
            }
            if (showPropertiesRight) 	$scope.gsrvc.setFieldProperties($scope.fd);
            
      };
      
        
      
      $scope.fd.localVars.setField = function(form,name,value,msg)
      {
     				TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
      };
        
        
        let valueState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+'-'+$scope.fd.UuidRef,$scope.fd.PresentationId);
        let valueStateName = valueState.subject.name;
                

    $scope.fd.localVars.setSelectedResource = function(id,saved)  {

            if ($scope.fd.localVars.selectedResourceItem==undefined) $scope.fd.localVars.selectedResourceItem={};
            let pos = $scope.fd.localVars.resourceList.map(function(e) { return e.id; }).indexOf($scope.fd.Related);
            if (pos>=0 && $scope.fd.localVars.selectedResourceItem.id===undefined) 
            {
                $scope.fd.localVars.selectedResourceItem = $scope.fd.localVars.resourceList[pos]
               
            } 

            $scope.fd.localVars.getPublishedResourceById(id,saved);
    }

    $scope.fd.localVars.getPublishedResourceById = function(id,saved) 
 
    {
            let pos
            
            /*
            if (saved && $scope.fd.FormDef!==undefined && $scope.fd.FormDef!==null)
              { 
                    pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                    if (pos>=0){
                        $scope.fd.localVars.selectedResourceItem.name = $scope.fd.localVars.publishedResourceList[pos].name;
                        $scope.fd.localVars.selectedDataset = $scope.fd.localVars.publishedResourceList[pos]
                    }
           
                    $scope.fd.localVars.selectedResourceItem_c=$scope.fd.localVars.selectedResourceItem;
                    if ($scope.formDefinition) $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
                    else if (!$scope.fd.Multiline) $scope.fd.localVars.dashboard.widgets.layout = UtilityService.clone($scope.fd.FormDef)
                    else $scope.fd.localVars.dashboard.widgets.push({layout:[UtilityService.clone($scope.fd.FormDef[0])]})
                    $scope.fd.localVars.formLoaded=true;

              }else{
            */
                  pos = $scope.fd.localVars.publishedResourceList.map(function(e) { return e.id; }).indexOf(id);
                  
                  if (pos>=0){
                    ResourcesDataService.GetPublishedResourceById(id).then(function (data) {
                               let jsonFile=$scope.fd.Related+"-v"+data.data.Version+".json"
                            ResourcesDataService.fetchJsonFile(jsonFile).then(function (widgetDef) {
                                
                                 if (widgetDef.status)
                                {
                                     MessagingService.addMessage(widgetDef.data,'error');
                                    $scope.fd.localVars.formLoaded=true;
                                }
                                else{
                                        $scope.fd.localVars.selectedPublishedResource = $scope.fd.localVars.publishedResourceList[pos];
                                        $scope.fd.FormDef = widgetDef.Form
                                        if ($scope.formDefinition) $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
                                        else if (!$scope.fd.Multiline) $scope.fd.localVars.dashboard.widgets.layout = UtilityService.clone($scope.fd.FormDef)
                                        else $scope.fd.localVars.dashboard.widgets.push({layout:[UtilityService.clone($scope.fd.FormDef[0])]})
                                        if ($scope.fd.localVars.selectedResourceItem_c!==undefined)
                                        {
                                            $scope.fd.Parameters.PublishedResourceId=$scope.fd.localVars.selectedResourceItem_c.id;
                                            $scope.fd.Parameters.PublishedResourceVersion=$scope.fd.localVars.selectedResourceItem_c.Version;
                                        
                                        }else MessagingService.addMessage('Error - published dataset not selected ktUiForm','error')
                      
                                        $scope.fd.localVars.formLoaded=true;
                                }
                            },function(err){    
                                    MessagingService.addMessage(err.msg,'error');
                                    $scope.fd.localVars.formLoaded=true;
                            });
                        },function(error){    
                          MessagingService.addMessage(error.msg,'error');
                           $scope.fd.localVars.formLoaded=true;
                    });

                }
            //}
             
       
}
 
    $scope.fd.localVars.deleteForm = function(idx) 
    {
       $scope.fd.DataSourceMapping.splice(idx,1)
    }


    $scope.fd.localVars.deleteField = function(map,idx) 
    {
       map.splice(idx,1)
    }
   $scope.fd.localVars.addField = function(map) 
    {
        if (!Array.isArray(map) || !map) map=[]
        map.push({id:map.length,FieldName:'',ValueFormula:''})
    }
    $scope.fd.localVars.addForm = function() 
    {
        if (!Array.isArray($scope.fd.DataSourceMapping) || !$scope.fd.DataSourceMapping) $scope.fd.DataSourceMapping=[]
        $scope.fd.DataSourceMapping.push({id:$scope.fd.DataSourceMapping.length,Map:[]})
    }

    if ($scope.fd.localVars.publishedResourceList==undefined) $scope.fd.localVars.publishedResourceList=[];
    
	var lang=$rootScope.globals.currentUser.lang;
                  
  
    if ($scope.fd.Related!="" && $scope.fd.Related!=undefined && $scope.fd.Related!=null)  {

            if ($scope.formDefinition) $scope.fd.localVars.dashboard.widgets.layout = $scope.fd.FormDef
            else if (!$scope.fd.Multiline) $scope.fd.localVars.dashboard.widgets.layout = UtilityService.clone($scope.fd.FormDef)
            else $scope.fd.localVars.dashboard.widgets.push({layout:[UtilityService.clone($scope.fd.FormDef[0])]})
            $scope.fd.localVars.formLoaded=true;
            
        }else $scope.fd.localVars.NoPublishedResourceMsg="Definition error --> Resource form not defined!"
  
              $scope.fd.localVars.prepareResourceData = function(resourceRecordId){

             $scope.fd.itemValue =  ResourcesDataService.prepareResourceWidgetData($scope.fd.localVars.dashboard.widgets.layout,resourceRecordId);
            }
          
           $scope.fd.localVars.processWidgetDependencies = function() { //-----  ktUploader  -----
              
           if ($scope.fd.tItemValue!=undefined) 
            for (var i=0;i< $scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=$scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = $scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<$scope.fd.tItemValue[i].DEI.length;j++) {
                        if (($scope.fd.tItemValue[i].DEI[j].name==linkedItem) && ($scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = $scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("view "+$scope.fd.PresentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             $scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj $scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                                for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    $scope.fd.localVars.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    $scope.resourceRecordId = $scope.fd.localVars.linkedResourceId;
                                  }
                                  if (data[k].name=='resourceId') $scope.fd.localVars.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                }
                          
     
                                    
                              }) //on_END
                        }//if
                    }//for j
                }//if

            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget

          if ($scope.fd.PresentationId==undefined || $scope.fd.PresentationId==null) $scope.fd.PresentationId=0;
          
          $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;

      
                  let template;
                if ($scope.formDefinition) template = $templateCache.get('ktdirectivetemplates/ktUiForm.html');
                else template = $templateCache.get('ktdirectivetemplates/ktUiForm.html');
          
                $element.append($compile(template)($scope)); 
      }];

  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

           
            
      
       
            }     
        }
  }

'use strict';

export function ktUploader ($timeout,uiUploader,WidgetDataExchangeService,ResourcesDataService,TaskDataService,$cookies,$rootScope) {
        return {
        restrict: 'A', 
             templateUrl: 'ktdirectivetemplates/ktUploader.html',
             controller: function ($scope, $element,$rootScope,$uibModal,MessagingService,ProcessingService,$log,GridsterService,$timeout,$stateParams) {

                //console.log("U kontroleru");
                $scope.gsrvc = GridsterService;
                $scope.fd.ReadOnly=false;
                $scope.animationsEnabled = true;
                $scope.showFileMetaData=false;
                $scope.taskId=$scope.resourceDefinition.ResourceDefId;
                if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
                if ($scope.taskId==undefined) $scope.taskId=0;  
                if ($scope.localVars==undefined)  $scope.localVars = {datasetMapperType:0};
                $scope.files = [];              
                $scope.localVars.showProperties=function(datasetMapperType)
                {
                 
                 if ($scope.localVars.datasetMapperType==undefined)
                 {
                    $scope.localVars.datasetMapperType = datasetMapperType;
                 }else
                 {
                    if ($scope.localVars.datasetMapperType==0 || $scope.localVars.datasetMapperType!=datasetMapperType) $scope.localVars.datasetMapperType = datasetMapperType;
                    else $scope.localVars.datasetMapperType=0;
                 }
                 
                };
            
            
             $scope.localVars.okFileConnector = function () {
                $timeout(function() {
                $scope.fd.tItemValue=$scope.fd.listOfConnectors;
                $scope.localVars.showProperties(0);
                
                });
            };
            
             $scope.localVars.cancelFileConnector = function () {
                $timeout(function() {
                $scope.fd.listOfConnectors=angular.copy($scope.fd.tItemValue);
                $scope.localVars.showProperties(0);
                
                });
            };

            
		  $scope.okModal = function (windex,index) {
			$timeout(function() {$scope.showFileMetaData=false; });
		  };

		  $scope.cancelModal = function () {
			$timeout(function() {$scope.showFileMetaData=false; });
		  };
		  
       
        
		 $scope.showMetadata = function(fileIndex,fileId){ 
		 
				   var lang=$rootScope.globals.currentUser.lang;
				   var file_resource_type = "file";
				    $scope.taskId=$stateParams.id;
				   
				    //ResourcesDataService.getResourceFormextended(id resursa ,task-id, i, $scope.fd.presentationId,lang)
					
				   ResourcesDataService.getResourceForm(fileId,"i",lang).then(function(data) {
                               
                                 var sc=$scope;
                                  //$scope.gridOptions.data = data.data;
								  //$scope.files[fileIndex].dashboard=[];
								  $scope.files[fileIndex].dashboard=data.data;
								  //files[$index].dashboard.widgets
								  
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
						});
                            
		

			  };
     
           
			// OPEN MODAL filehelper
			 $scope.openModal = function (size,fileIndex) {
                  var modalInstance = $uibModal.open({
                  animation: $scope.animationsEnabled,
                  templateUrl: 'filehelper.html',
                  controller: 'FileModalInstanceCtrl',
                  size: size,
                  resolve: {
                    retValue: function () {
                      return {resourceId:$scope.resourceId,fileIndex:fileIndex,files:$scope.files,headline:'Enter file metadata'};
                    }
                  }
            });
			
			
            modalInstance.result.then(function (retValue,windex,index) {
             // $scope.getResourceForm ();
             
         
          }, function () {
          //$log.info('Modal dismissed at: ' + new Date());
          });
       
		};
        
      
      //novi FILE CONNECTOR - UPLOADER
      $scope.localVars.openFileConnector  = function(){
             //$scope.fd.showFileConnector= !$scope.fd.showFileConnector;
            $scope.localVars.showProperties(1);
             if ($scope.localVars.datasetMapperType==1) {
                           
                 //POPUNI LISTU DATASETOVA            
                  ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
                                function(data) {
                                                  $scope.datasetList = data.data;
                                                  //dodaj ime dataseta u konektore
                                                  if ($scope.fd.listOfConnectors!=undefined) 
                                                             for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                                   //var p = $scope.datasetList.map(function(e) { return e.id; }).indexOf($scope.fd.listOfConnectors[i].parentDatasetDefId);
                                                                   var p = $scope.datasetList.map(function(e) { return e.id; }).indexOf($scope.fd.listOfConnectors[i].parentDatasetDefId);
                                                                   if (p>=0) $scope.fd.listOfConnectors[i].parentDatasetName = $scope.datasetList[p].name;  
                                                             }
                                                  
                                                  },function(error){    
                                        MessagingService.addMessage(error.msg,'error');
                                                 });
                                                 
                                                 
 							if ($scope.fd.tItemValue==undefined || $scope.fd.tItemValue[0]==null)  $scope.fd.tItemValue = []; 
							// ovo je  Kt-UPLOADER
							  $scope.fd.listOfConnectors= WidgetDataExchangeService.getRegisteredWidgets();//MIGOR  - uzmi sve registrirane widgete
							  
							  //Brisi sve koji se vec nalaze u tItemValue
							   if ($scope.fd.listOfConnectors!=undefined) 
								  for (var i=0;i< $scope.fd.tItemValue.length ;i++) {
										 for (var j=0;j< $scope.fd.listOfConnectors.length;j++) {
                                              if ($scope.fd.tItemValue[i]!=null) {
                                                 if ($scope.fd.listOfConnectors[j].widgetId==$scope.fd.tItemValue[i].widgetId)  {
                                                     $scope.fd.listOfConnectors.splice(j,1);//brisi lokalni				   					    		
                                                 }
                                              }
                                         }
							    }
                                //dodaj sa servera
                                for (var i=0;i< $scope.fd.tItemValue.length ;i++) 
                                              if ($scope.fd.tItemValue[i]!=null) 
                                                  $scope.fd.listOfConnectors.push($scope.fd.tItemValue[i]);		
                                

							  //Ostavi u listi konektora samo WIDGETE koji imaju "ResourceID" jer su to data widgeti
							  var newlist=[];
                              
							    if ($scope.fd.listOfConnectors!=undefined){
                 
                                 for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                     if ($scope.fd.listOfConnectors[i].DEI!=undefined)  
                                                         for (var j=0;j< $scope.fd.listOfConnectors[i].DEI.length;j++) {
                                                             if ($scope.fd.listOfConnectors[i].DEI[j].name=='resourceLink') {
                                                                 //ako DEI.value nije true/false - resetiraj na false (znaci NIJE POVEZAN još)
                                                                 if ( ($scope.fd.listOfConnectors[i].DEI[j].value!=false) && ($scope.fd.listOfConnectors[i].DEI[j].value!=true) ) $scope.fd.listOfConnectors[i].DEI[j].value=false;
                                                                 //dodaj konektor u novu listu 
                                                                 newlist.push($scope.fd.listOfConnectors[i]);
                                                             };						 						  						   					      
                                                    }
                                               }
                                }//if
							  $scope.fd.listOfConnectors=newlist; //konacna lista NOVIH dataset konektora 
 
							  //return {selectedItemFromServer:$scope.fd.tItemValue,listOfConnectors: $scope.fd.listOfConnectors,headline:'Choose required interfaces',selectedFileConnector:$scope.selectedFileConnector};
						
				  
				/* interfaceModal.result.then(function (selectedItem) { 
							//$scope.fd.tItemValue=selectedItem; // //MIGOR TODO vidjet da li treba angular.copy(selectedItem);
                            $scope.fd.tItemValue=angular.copy(selectedItem); // MIGOR TODO - TEST SA ANGULAR COPY
                            
                            
							// MIGOR  TODO -
							//selektirani widget ima "resourceID" interface" -  registriramo se na njegov "event"
							
							$scope.$on('resourceId:'+selectedItem,
								function(event, data){
									console.log('resourceID uhvacen u ktUploader! data:' +  data);
							})
							
							//$scope.fd.listOfConnectors= WidgetDataExchangeService.getRegisteredInterfaces(selectedItem); 
							
							
				}*/
	
            } //if showfileconnetor  
		}; // open FILECONNECTOR - UPLOADER
                    
      
					
				 	// FUNCTION ONSELECT CALLBACK II
					$scope.onSelectCallback2 = function (item, model,fileIndex){
						var eventResultId=item.id;
						$scope.eventResultName=item.Name;
						
						 //console.log("onSelectCallback II:" +  $scope.eventResultName+ ' ' + eventResultId);

						  $scope.resourceId=eventResultId;
						  $scope.isResourceSelected=true;
						 	
								$scope.fd.filetype=$scope.resourceId; 						
					}//onSelectCallback II
				 
				 
				 
				 
					// FUNCTION - ON_SELECT_FILETYPE 
					// NAKON TO SE ZA POJEDINAÈNI FILE ODABERE FILE-TYPE  --> $scope.resourceId
					
					$scope.onSelectFileType = function (item,fileIndex){
						var selectedFileTypeId=item.id;
						$scope.resourceId=selectedFileTypeId;
						 $scope.isResourceSelected=true;
			             if ($scope.files[fileIndex].fileResourceID!=selectedFileTypeId) {
			              $scope.files[fileIndex].fileResourceID = selectedFileTypeId;
			              $scope.files[fileIndex].formLoaded = false;
			             }
					
					
						 
						console.log("onSelectFileType :" + selectedFileTypeId);
		
						$scope.fileIndex=fileIndex;
						
								//if ($scope.files[fileIndex].fileResourceID== undefined) {
								//	$scope.getResourceForm ();
								//	}
									
								//if ($scope.resourceId != undefined) {	
									//$scope.getResourceForm ();
								//}
						 		
						//$scope.fd.related=$scope.resourceId; // ovo viska??? MIGOR
						
						$scope.showMetadata(fileIndex,$scope.files[fileIndex].fileResourceID );
						
						var err=$scope.testRules();
				
					}//onSelectFileType
				 
				 
				    
				var lang = $rootScope.globals.currentUser.lang;
				var type="file"; // PROMJENITI - ZASAD JE HARD-CODED !!!!! MIGOR
					 
					 
					// poziva se iz ktUploader.html
					$scope.remove = function (index) {
						
						$scope.fd.MetaData.splice(index,1);
						$scope.isOpen=true;
						var err=$scope.testRules();	
					}
					 
					 
			// POPUNI LISTU  lIST OF FILE TYPES
            ResourcesDataService.getResourceDefByType(lang,type).then(
						function(data) {
											  $scope.listOfFileTypes = data.data;
											 
							},function(error){
											 MessagingService.addMessage(error.msg,'error');
							
						});
                	            
            
	
      
     
			 },// controler_ktUploader_END
			

			//  ***************************************************  KT- UPLOADER   LINK FUNKCIJA *****************************
			require: '^form', // MIGOR  - NOVO DODAO 
			link: function (scope, elem, attrs,formCtrl) { //MIGOR NOVO
                        

                                 scope.fd.uiUploader = uiUploader;
                                 if (scope.fd.PresentationId!=undefined) scope.fd.uiUploader.createUploader(scope.fd.PresentationId);
                                
                                				
                                //MIGOR TODO - prilagoditi widgetdefinition za uploader da salje i povezani related dataset
                                var out_fields = ['resourceId'];
                                var widgetDefinition = {DEI: [{'name':'resourceLinkR','value':[{name:'resourceId',value:scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'ktUploader',localWidgetId:scope.fd.LocalId,widgetId: scope.fd.PresentationId,taskId:  scope.lTaskId,resourceDefId : scope.selectedResource, output:out_fields, };
                                //var widgetDefinition = {DEI: [{'name':'resourceLinkR','value':false}],actions: [{name:'PrepareData',status:false}],name: 'ktUploader',localWidgetId:scope.fd.localId,widgetId: scope.fd.presentationId,taskId:  scope.lTaskId,resourceDefId : scope.selectedResource, output:out_fields, };
		  
                                scope.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition); //zamijeniti gdje se sve pojavljujue i staviti LOCAL TODO
                                scope.fd.LocalId=scope.localWidgetId;         
      
                                scope.fd.uiUploader.removeAll(scope.fd.PresentationId); //MIGOR TEMP- TREBA nekako obrisati inicijalne fajlove kod reigstracija ali ovdje ne radi !!!
                                //console.log(element.files);

                      
                                var element = elem[0].getElementsByClassName('fileElement');
            
                                element[0].addEventListener('change', function(e) {
                
                                        $timeout(function() {
                                                var files = e.target.files;
                                                scope.fd.uiUploader.addFiles(files,scope.fd.PresentationId);				
                                                scope.files =scope.fd.uiUploader.getFiles(scope.fd.PresentationId);  
                          
                                                var err=scope.testRules();
                                        });
                                });    
    	
        
        var fileCounter = 0;
			//scope.rules=[];
			if (scope.fd.MetaData==undefined)  scope.fd.MetaData=[];        
			scope.rules =  scope.fd.MetaData;
				
				// ADD RULE DEFINITION - poziva se iz ktUploader.html
				scope.addRuleDefinition=function(name,min,max,minTotal){
					
					if (min==undefined) min=0;			
					
					for (var i=1, l=scope.rules.length; i<l; i++) 
								if (scope.rules[i].name==name) name='';
							
					if (name!=undefined && name != '') {
						scope.rules.push({'name':name,'min':min,'max':max});
						//scope.rules.minTotal=minTotal;	
					}
				}
            
                scope.btn_remove = function(index,file) {
                                
                        //$log.info('deleting=' + file);
                        //var s=scope;
                        //var f=formCtrl;
                        scope.fd.uiUploader.removeFile(file,scope.fd.PresentationId);
                        var err=scope.testRules();
                                
                };      
			

                scope.btn_clean = function() {
                   scope.fd.uiUploader.removeAll(scope.fd.PresentationId);
                };


        scope.testRules = function(){
					
                var errMsg=null;
                for (var i=1; i < scope.rules.length; i++) { //search rules
                        var filesFound=0;
                        for(var j = 0; j < scope.files.length; j++ ) {//search files
                                if (scope.files[j].fileResourceID == scope.rules[i].name) filesFound=filesFound+1;
                        }
                        
                        if (filesFound < scope.rules[i].min) {formCtrl.uploaderForm.$setValidity('Not enough file types', false);
                        }	 else formCtrl.uploaderForm.$setValidity('Not enough file types', true);
                        
                        if (filesFound > scope.rules[i].max) {formCtrl.uploaderForm.$setValidity('Too many file types', false);
                                }	 else formCtrl.uploaderForm.$setValidity('Too many file types', true);
                 
                }
					
		if (scope.rules.length>0) {
                        if (scope.files.length < scope.rules[0].min) formCtrl.uploaderForm.$setValidity('Minimum files needed', false); 
                        else formCtrl.uploaderForm.$setValidity('Minimum files needed', true); }
  
					//errMsg=null; // samo za test !!!     MAKNUTI KASNIJEEE !!!!     <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
                return errMsg;
					
         }//test_RULES
               
		
     	//*******************************************************************************************************
		// 											 kt-UPLOADER BTN_UPLOAD
		//*******************************************************************************************************
        scope.btn_upload = function() {
            				
			// CHECK THE RULES FIRST
			var errMsg=scope.testRules();
			errMsg=null; // samo za test !!!     MAKNUTI KASNIJEEEE !!!!     <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
						
			if (errMsg==null) {
        		var csrf_token = $cookies.get('csrftoken'); //'miro';//$cookieStore.get('csrftoken');
				
        		// ZA svaki FAJL pojedinaèno !
        		scope.fd.uiUploader.startUpload(scope.fd.PresentationId,{  
				url: '../api/file-upload/', 
				headers: {'X-CSRFToken' : csrf_token },
					concurrency: 3,
					// u data napuniti podatke vezane za fajl - fileType , ID resursa
					data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId},
					onProgress: function(file) {
									$timeout(function() { file.status='Uploading...'; });
                                  },
					onCompleted: function(file, response,status) {
                                 response=JSON.parse(response); //convertiram string u JSON objekt
								
						if (status==201) {
								// NAKON SMO USPJESNO UPLOADALI FILE , POTREBAN METADATA UPLOAD

                                            // response.... ID fajla
                                             // file.fileResourceID ... je file_type 
                                               // scope.resourceData .. spremljeni meta podaci
								
                                         $timeout(function() { file.uploadSuccess=true;  });
									
                        				//OUTPUT: data.savedResourceId .. ID meta-resursa koji je pridruen fajlu (unutar 11-ice ili 12-ice)
									
                                        		 file.resourceData={};
									
                                                        //PRIPREMA scope.resourceData  ZA UPLOAD 
                                                        if (file.dashboard!=undefined)
                                                        {
                                                                var fieldId="";
                                                                var sc=scope;
                                                                          
                                                                for (var i=0;i<file.dashboard.widgets.length;i++) {//idem po gridROW
                                                                        for (var j=0;j<file.dashboard.widgets[i].layout.length;j++)
                                                                                for (var k=0;k<file.dashboard.widgets[i].layout[j].layout.length;k++)	
                                                                                {
                                                                                        fieldId='Field'+file.dashboard.widgets[i].layout[j].layout[k].itemId;
                                                                                        if (file.dashboard.widgets[i].layout[j].layout[k].dbtype=='id') {
                                                                                                fieldId=fieldId+'_id'//code
                                                                                                fieldId='id'//code
                                                                                        }
                                                                                        file.resourceData[fieldId] = file.dashboard.widgets[i].layout[j].layout[k].sItemValue	
                                                                                }
                                                                }//for
                                                                
                                                                                                                 
                                                                //  ********************************* METAUPLOAD ************************
                                                                if (file.resourceData)
                                                                {
                                                                        // ovdje je sve i update modela i insert meta pddataka - napravljena posebna DRF funkcija
                                                                        file.metaStatus='Saving metadata...'
                                                                        ResourcesDataService.fileMetaUpload(response,file.fileResourceID,scope.fd.linkedResourceId,scope.fd.linkedResourceDefId, file.dashboard.widgets)
																		.then(                                 
                                                                                function(data) {                                                               
                                                                                                file.metaSuccess=true;
                                                                                                scope.showFileMetaData=false;                                                
                                                                                },function(error){
                                                                                        file.metaError=true;
                                                                                        file.metaStatus = error.msg;
                                                                                                                                                                                                                                                 
                                                                                });
                                                                } //IF
                                                        }
                                                        else
                                                        {
                                                                $timeout(function() {
                                                                        file.noMeta = true;
                                                                });
                                                        }
 
                                                        fileCounter++;
                                                        if (scope.files.length == fileCounter){ //MIGOR -Ovaj se okida a onaj drugi na 123 izgleda na
                                                           $rootScope.$broadcast('InitiateTaskFilesUploaded',{'resource_id':scope.fd.linkedResourceId,'resource_def_id': scope.fd.linkedResourceDefId})
                                                        }
                                                
                                    }    else { 
                                               //if file upload error
                                                $timeout(function() {
                                                                file.uploadError=true;
                                                                file.status=response;
                                                 });
                                                                                                                 
                                       }
                                                                   
                                                        
                                    }//on_completed
                          }); //startUpload
		} else {
              //if test errored          
		}
        }; // FUNCTION b.n_up1oad

     
      
      scope.ProcessEvent=function(data)
      {
         for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId') scope.fd.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                  if (data[k].name=='resourceId') scope.fd.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                  if (scope.fd.linkedResourceDefId>0 && scope.fd.linkedResourceId>0) scope.fd.uploadReady = true;
                                }
                          
         
         if (scope.files.length>0 && scope.fd.uploadReady) scope.btn_upload();  // poziva UPLOAD - MIGOR TODO - upload treba samo ako ima fajl !!!
                                
        
      };
            
        
        	
      			
	
     	  // ne znam da li ce u ovoj link funkciji widget vec imati resource_id
        
          
          scope.formType=scope.resourceDefinition.form_type;
          /*
          if (scope.fd.PresentationId!=undefined && scope.fd.PresentationId!=null)   {
          TaskDataService.getWidgetDependencies(scope.taskId,scope.fd.PresentationId,scope.formType).then(function(data) {
                               
                                scope.fd.tItemValue=data.data;

                                  //ovo je da trenutno radi
                                scope.processWidgetDependencies();
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                              
    
          }
          */
          //MIGOR - pocisti fajlove kad dobijes InitateTask event
		  scope.$on('ProcessTaskWidgets',function(event, data){
           //scope.btn_clean(); // MIGOR - PRIVREMENO MAKNUO JER CE BITI VISAK KAD PRORADI OVO GORE
           if (scope.files.length>0 && scope.fd.uploadReady) scope.btn_upload();
          });

		  
		  
		  //MIGOR NOVO TODO
		  scope.interfaceHandler= function (event,data) {
							scope.test=0;
				
			 // scope.fd.linkedResourceId = data.resource_id;
			   //scope.fd.linkedResourceDefId = data.resource_def_id;
			  
			   //scope.btn_upload();  
		  }
		  
                        
        
                               
       
     } //link directive 'ktUploader'
    };
};
'use strict';

export function ktUploadFile ($timeout,uiUploader,MessagingService,WidgetDataExchangeService,ResourcesDataService,TaskDataService,UtilityService,$cookies,$rootScope,KatalyoStateManager,$sce, $location) {
        return {
        restrict: 'A', 
             templateUrl: 'ktdirectivetemplates/ktUploadFile.html',
             controller: function ($scope, $element,$rootScope,$uibModal,MessagingService,ProcessingService,$log,GridsterService,WidgetDataExchangeService,UtilityService,KatalyoStateManager,$timeout,$stateParams) {

                //console.log("U kontroleru");
                $scope.gsrvc = GridsterService
                $scope.animationsEnabled = true;
                if ($scope.fd.localVars==undefined)  $scope.fd.localVars = {datasetMapperType:0};
                $scope.fd.localVars.files = [];
                $scope.fd.localVars.hideAll=true
                $scope.fd.uploadReady = true
				$scope.CTRL="ktUploadFIle"

                $scope.gsrvc.parentResource[$scope.fd.UuidRef] = $scope.fd

                $scope.fd.localVars.showMenu = false
                
                 $scope.fd.localVars.ShowUploadFile = true
                
                $scope.fd.localVars.showAll= function(x) {
                    //debugger
                    // $scope.fd.localVars.hideAll = x
                      for (const f of $scope.fd.localVars.files) {
                              f.hideForm = x
                          }   
                }

            $scope.fd.localVars.getPublishedResourceById = function(id,index) 
 
            {
    
                let pos
				
				
				if ($scope.fd.Parameters.rules[index].FormDef) $scope.FormLoaded
				
				
                if ($scope.fd.Parameters.rules[index].FormDef===undefined || $scope.fd.Parameters.rules[index].FormDef===null)
                {
                
                  pos = $scope.fd.listOfFileTypes.map(function(e) { return e.id; }).indexOf(id);  				
					
					if (pos>=0){
                    ResourcesDataService.GetPublishedResourceById(id).then(function (data) {
						
						$scope.fd.Related = $scope.fd.Parameters.rules[index].fileType.ResourceDefUid
                        let jsonFile=  $scope.fd.Related+"-v"+data.data.Version+".json"
						
                        ResourcesDataService.fetchJsonFile(jsonFile).then(function (widgetDef) {
							
							$scope.fd.Parameters.rules[index].FormDef = widgetDef.Form    

						})
					})
					}

             
       
                }
            }

               
                $scope.taskId=$scope.resourceDefinition.ResourceDefUid;
                if ($scope.taskId==undefined) $scope.taskId=0;
                $scope.fd.localVars.taskId=$scope.taskId;
                //$scope.fd.ParentDatasetDefId=$scope.fd.Related;
                $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
                $scope.fd.localVars.formType=$scope.resourceDefinition.form_type;
                $scope.source_type=$scope.resourceDefinition.source_type;
                $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
                $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
                $scope.formDefinition = $scope.resourceDefinition.form_definition;
                $scope.fd.localVars.resourceRecordId=0;
                $scope.fd.localVars.resourceDefinition = $scope.resourceDefinition
                $scope.formDefinition = $scope.formDefinition || false
                $scope.taskInitiateId = $scope.taskInitiateId || 0
                $scope.taskExecuteId = $scope.taskExecuteId || 0
                $scope.prevTaskExeId = $scope.prevTaskExeId || 0
				if ($scope.fd.localVars==undefined)  $scope.fd.localVars={}
 
                $scope.fd.localVars.toggleDropdown = function(){
                           $scope.fd.localVars.showMenu =  $scope.fd.localVars.showMenu ? false: true 
                }
                  
                if ($scope.resourceDefinition.form_type=='i')  {
                         $scope.fd.taskInstanceId = $scope.resourceDefinition.task_initiate_id;
                   }else {
                        $scope.fd.taskInstanceId = $scope.resourceDefinition.task_execute_id;
                   }

            $scope.fd.localVars.showProperties=function(datasetMapperType,showPropertiesRight)
            {
                if ($scope.fd.localVars.datasetMapperType==undefined)
                {
                   $scope.fd.localVars.datasetMapperType = datasetMapperType;
                }else
                {
                   if ($scope.fd.localVars.datasetMapperType==0 || $scope.fd.localVars.datasetMapperType!=datasetMapperType) 
                        $scope.fd.localVars.datasetMapperType = datasetMapperType;
                   else 
                       $scope.fd.localVars.datasetMapperType=0;
                }
                if (showPropertiesRight) $scope.gsrvc.setFieldProperties($scope.fd);
            
            };
      
			if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
			
			//****  REGISTER WIDGET ******/ 
			var out_fields = ['resourceId']
			
						
			let w_actions=[
							{id:1,name:'uploadFile'},
						]

			var widgetDefinition = {DEI: [{'name':'ktUploadFileWidget','displayName':'Dataset record id','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: w_actions,widgetLabel: 'Upload file',widgetName: 'uploadFile',widgetId: $scope.fd.UuidRef,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resource_id:$scope.resourceDefinition.page_state_id,resourceDefId : $scope.fd.Related, output:out_fields,parentResourceId:$scope.fd.localVars.resourceDefinition.uid };
			  
			$scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
			$scope.fd.localVars.localId=$scope.fd.localVars.localWidgetId;
			$scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
			  
			//END REGISTER//
			  
		      
      
            $scope.ksm = KatalyoStateManager;
            let dependent_field_pid = $scope.fd.LocalId;
            let subscribedSubjectPid = "formDefinitionState"+$scope.taskId+$scope.resourceDefinition.form_type;
            let dependent_field_pid2
          
                

		
        let valueState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+'-'+$scope.fd.UuidRef,$scope.fd.PresentationId);
        let valueStateName = valueState.subject.name;
                

         let upload_action = function(data){
          
          let state = valueState.subject.getStateChanges
          if (state==undefined) state={}
          if (data?.action_index!=undefined) state['action_index'] = data.action_index
          valueState.subject.setStateChanges = state
          $scope.btn_upload(valueState,data?.action_index)
          
      };
      
      let action_upload = $scope.ksm.addAction(valueStateName,"uploadFile",upload_action);

        $scope.fd.showMetadata = function(fileIndex,fileId,form_definition){ 

                                        $scope.fd.localVars.files[fileIndex].formParams = {formViewType:2};
                                        $scope.fd.localVars.files[fileIndex].gridsterType = "file"
                                        if ($scope.fd.localVars.files[fileIndex].dashboard===undefined) $scope.fd.localVars.files[fileIndex].dashboard={}
                                        if (!$scope.fd.localVars.files[fileIndex].uploadSuccess || !$scope.fd.localVars.files[fileIndex].metaSuccess)
                                        {
                                            $scope.fd.localVars.files[fileIndex].dashboard.formData=[{}];
					                        
                                        }else{
                                           
                                            $scope.fd.localVars.files[fileIndex].hideForm = true
                                            
                                        }
                                        $scope.fd.localVars.files[fileIndex].dashboard.widgets={layout:form_definition}
                                        $scope.fd.localVars.files[fileIndex].formLoaded = true;
                                        

			  };
      
      				
                        // FUNCTION ONSELECT CALLBACK II
                $scope.fd.onSelectCallback2 = function (item, model){
                        $scope.fd.selectedFileName=item.name
                        $scope.fd.selectedFileType=item

                }//onSelectCallback II
                 
				 
				 $scope.fd.addFilesClick = function()

                 {

                    document.getElementById('fileWidget'+$scope.fd.PresentationId).click()
                 }
				 
                // FUNCTION - ON_SELECT_FILETYPE 
                // NAKON STO SE ZA POJEDINAcNI FILE ODABERE FILE-TYPE  --> $scope.resourceId
                
                $scope.fd.onSelectFileType = function (item,fileIndex){
                        var selectedFileTypeId=item.ResourceDefUid;
                        let form_def
                       
                         $scope.isResourceSelected=true;
                        if ($scope.fd.localVars.files[fileIndex].fileResourceID!=selectedFileTypeId) {
                         $scope.fd.localVars.files[fileIndex].fileResourceID = selectedFileTypeId;
                         $scope.fd.localVars.files[fileIndex].filePublishId = item.id;
                         $scope.fd.localVars.files[fileIndex].widgetId = $scope.fd.PresentationId;
                         $scope.fd.localVars.files[fileIndex].formLoaded = false;
                         $scope.fd.localVars.files[fileIndex].fileTypeSelected = true;
                         //form_def = item.Form -- form is not here
                        }
                
                        $scope.fileIndex=fileIndex;
                        
                                        
                        
                        $scope.fd.showMetadata(fileIndex,$scope.fd.localVars.files[fileIndex].fileResourceID,form_def );
                        
                        var err=$scope.fd.testRules();
        
                }//onSelectFileType
				 
				 
				    
				var lang = $rootScope.globals.currentUser.lang;
				var type="file"; // PROMJENITI - ZASAD JE HARD-CODED !!!!! MIGOR
					 
				
                    // poziva se iz ktUploadFile.html
                    $scope.fd.loadForm = function (index) {
                         
                        $scope.fd.selectedRuleIndex = null
                        $scope.fd.Parameters.rules[index].formData=[{}];
                        $scope.fd.LoadedForm = {layout:$scope.fd.Parameters.rules[index].FormDef}
                        $scope.fd.Parameters.rules[index].gridsterType = "file"
                        $scope.fd.Parameters.rules[index].formParams = {formViewType:1,showGridNavigation:true};

                       $timeout(function(){ 
                            $scope.fd.selectedRuleIndex = index
                            $scope.fd.Parameters.rules[index].formLoaded = true;
                       })
                    }

					// poziva se iz ktUploadFile.html
					$scope.fd.remove = function (index) {
						
						$scope.fd.Parameters.rules.splice(index,1);
						$scope.isOpen=true;
						var err=$scope.fd.testRules();	
					}


                    // POPUNI LISTU  lIST OF PUBLISHED FILE TYPES
                    ResourcesDataService.GetPublishedResourcesByType(type,'form').then(
                        function (data) {       
                            $scope.fd.listOfFileTypes = data.data;

                            if ($scope.fd.Parameters.rules.length>1) 
								$scope.fd.showFileSelect = true
                            else if ($scope.fd.Parameters.rules.length==1){
                                $scope.fd.showFileSelect = false
                                $scope.fd.Related = $scope.fd.Parameters.rules[0].ResourceDefID
                                $scope.fd.PublishId = $scope.fd.Parameters.rules[0].id
                                if (!$scope.fd.PublishId) 
									$scope.fd.localVars.getPublishedResourceById($scope.fd.PublishId,0)
								else 
									$scope.fd.loadForm(0)
                            } 
                                     
                        },function(error){    
                            MessagingService.addMessage(error.msg,'error');
                        });
                	            
     $scope.fd.getPreviousTaskWidget  = function(deiType)
    {
      var pTaskPkg = WidgetDataExchangeService.getPrevTaskData($scope.resourceDefinition.prev_task_id);
             var datasetId=0,datasetRecordId=0,pTaskData,pTaskDataArray;
             if (!Array.isArray(pTaskPkg))
             {
                          pTaskDataArray = [pTaskPkg];
             }else
             {
                          pTaskDataArray = pTaskPkg;        
             }
             for (let l=0;l<pTaskDataArray.length;l++)
             {
                          pTaskData = pTaskDataArray[l];
                          if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
                          {
                          for (var i=0;i<pTaskData.DEI.length;i++)
                          {
                            if (pTaskData.DEI[i].name==deiType)
                            {
                              if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                              {
                                for (var j=0;j<pTaskData.DEI[i].value.length;j++)
                                {
                                 if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined) datasetId=pTaskData.DEI[i].value[j].value;
                                 if (pTaskData.DEI[i].value[j].name=="resourceRecordId" && pTaskData.DEI[i].value[j].value!=undefined) datasetRecordId=pTaskData.DEI[i].value[j].value;
                                 
                                  
                                }
                                   
                                  
                              }
                                
                            }
                              
                            }
                          }
             }
            
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };
	
    $scope.fd.localVars.ResetUpload = function() 
 
    {
        $scope.fd.localVars.files=[]
        $scope.fd.localVars.ShowUploadFile = true
        $scope.fd.localVars.setupFileElement()
    }
    
    $scope.fd.localVars.processTaskReturn = function(data)
    {

             if (data!=undefined){
                let rv
                if (Array.isArray(data))
                {
                 rv  = data
                }else rv =[data]

                  for(var i=0;i<rv.length;i++) {
                    
                    if ($scope.fd.PresentationId==rv[i].widgetId)
                    {
                      WidgetDataExchangeService.setData(rv[i]);
                     // $scope.fd.localVars.setField($scope.fd.localVars.dashboard.widgets.layout,'ReadOnly',true); //set all elements read-only
                    }
                  }
            }
            
        }


         $scope.$on('InitiateTaskPostProcess'+$scope.resourceDefinition.transaction_id,function(event, data){
            $scope.fd.localVars.processTaskReturn(data)
              
         });
            
        $scope.$on('ExecuteTaskPostProcess'+$scope.resourceDefinition.task_execute_id,function(event, data){
              
            $scope.fd.localVars.processTaskReturn(data)
            $scope.fd.localVars.ShowUploadFile = false
              
          });
     
			 },// controler_ktUploadFile_END
			

			//  ***************************************************  KT-UPLOAD-FILE   LINK FUNKCIJA *****************************
			require: '^form', 
			link: function (scope, elem, attrs,formCtrl) { 
                        
                    
                    if (scope.fd.localVars==undefined)  scope.fd.localVars = {datasetMapperType:0};
                
                    scope.fd.localVars.ShowUploadFile = true
                

                                if (scope.fd.Parameters==undefined || scope.fd.Parameters==null) scope.fd.Parameters={};
                                if (scope.fd.Parameters.rules==undefined || scope.fd.Parameters.rules==null) scope.fd.Parameters.rules=[];
                                
                                scope.fd.uiUploader = uiUploader;
                                if (scope.fd.PresentationId!=undefined) scope.fd.uiUploader.createUploader(scope.fd.PresentationId);
                                
                                				
                                //MIGOR TODO - prilagoditi widgetdefinition za uploader da salje i povezani related dataset
                                var out_fields = ['resourceId'];
                                var widgetDefinition = {DEI: [{'name':'resourceLinkR','value':[{name:'resourceId',value:scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'ktUploader',localWidgetId:scope.fd.LocalId,widgetId: scope.fd.PresentationId,taskId:  scope.lTaskId,resourceDefId : scope.selectedResource, output:out_fields, };
                                //var widgetDefinition = {DEI: [{'name':'resourceLinkR','value':false}],actions: [{name:'PrepareData',status:false}],name: 'ktUploader',localWidgetId:scope.fd.localId,widgetId: scope.fd.presentationId,taskId:  scope.lTaskId,resourceDefId : scope.selectedResource, output:out_fields, };
		  
                                scope.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition); //zamijeniti gdje se sve pojavljujue i staviti LOCAL TODO
                                scope.fd.LocalId=scope.localWidgetId;         
      
                                scope.fd.uiUploader.removeAll(scope.fd.PresentationId); //MIGOR TEMP- TREBA nekako obrisati inicijalne fajlove kod reigstracija ali ovdje ne radi !!!
                                //console.log(element.fd.localVars.files);
                                
                                scope.fd.localVars.setupFileElement = function()
                                {
                                    
									/*
									var element

                                    $timeout(function(){
                                        element = elem[0].getElementsByClassName('fileElement');
                
                                        element[0].addEventListener('change', function(e) {
                                            $timeout(function(){
                                                    var files = e.target.files;
                                                    scope.fd.uiUploader.addFiles(files,scope.fd.PresentationId);				
                                                    scope.fd.localVars.files =scope.fd.uiUploader.getFiles(scope.fd.PresentationId); 
                                                    //let fileIndex =  scope.fd.localVars.files.length -1
                                                    if (!scope.fd.showFileSelect) 
                                                    {
                                                        let form_def = scope.fd.Parameters.rules[0].FormDef
                                                        for(let fileIndex=0; fileIndex < scope.fd.localVars.files.length; fileIndex++) {
                                                            scope.fd.localVars.files[fileIndex].fileResourceID = scope.fd.Parameters.rules[0].fileType.ResourceDefUid;
                                                            scope.fd.localVars.files[fileIndex].filePublishId = scope.fd.Parameters.rules[0].fileType;
                                                            scope.fd.localVars.files[fileIndex].widgetId = scope.fd.PresentationId;
                                                            scope.fd.localVars.files[fileIndex].formLoaded = false;
                                                            scope.fd.localVars.files[fileIndex].fileTypeSelected = true;
                                
                                                            scope.fd.showMetadata(fileIndex,scope.fd.localVars.files[fileIndex].fileResourceID,form_def);
                                                        }
                                                    }
                                                    var err=scope.fd.testRules();
                                            });
                                        });

                                    });*/
                                }    
    	
                                scope.fd.localVars.setupFileElement()
                        var fileCounter = 0;
			
			
			if (scope.fd.MetaData==undefined)  scope.fd.MetaData=[];        
			
					
				/*
						
					if (name!=undefined && name != '') {
						scope.rules.push({'name':name,'min':min,'max':max});	
						scope.fd.Related =  scope.rules[0].fileType?.ResourceDefUid //Only first rule is considered parent/related (for now) !!
					}
					
					
				}*/
				
				
				// ADD RULE DEFINITION - poziva se iz ktUploader.html
				scope.fd.addRuleDefinition=function(name,min,max,minTotal){
					
					if (min==undefined) min=0;			
					
					for (var i=1, l=scope.fd.Parameters.rules.length; i<l; i++) 
								if (scope.fd.Parameters.rules[i].name==name) name='';
							
					if (name!=undefined && name != '') {
                           
						scope.fd.Parameters.rules.push({'fileType':scope.fd.selectedFileType,'min':min,'max':max});
                        scope.fd.localVars.getPublishedResourceById(scope.fd.selectedFileType.id,scope.fd.Parameters.rules.length-1)
						scope.fd.Related =  scope?.rules?.[0]?.fileType?.ResourceDefUid //Only first rule is considered parent/related (for now) !!
					}
				}
            
                scope.btn_remove = function(index,file) {
                       
                        scope.fd.uiUploader.removeFile(file,scope.fd.PresentationId);
                        var err=scope.fd.testRules();
                                
                };      
			

                scope.btn_clean = function() {
                   scope.fd.uiUploader.removeAll(scope.fd.PresentationId);
                };

              scope.convertToHtml = function(msg){
               return $sce.trustAsHtml(msg);
            };
        scope.fd.testRules = function(){
		  // debugger
                var errMsg=null;
                for (var i=0; i < scope.fd.Parameters.rules.length; i++) { //search rules
                        
                      /*  
                        var filesFound=0;
                        for(var j = 0; j < scope.fd.localVars.files.length; j++ ) {//search files
                                if (scope.fd.localVars.files[j].fileResourceID == scope.fd.Parameters.rules[i].name) filesFound=filesFound+1;
                        }
                        
                        NISAM SIGURAN STO SAM HTIO S OVIM POSTICI*/
                        let filesFound = scope.fd.localVars.files.length
                        
                        if (scope.fd.Parameters.rules[i].min!=undefined)
                            if (filesFound < scope.fd.Parameters.rules[i].min) {
                                formCtrl['uploadFileForm'+scope.fd.PresentationId].$setValidity('NotEnoughFiles', false);
                                scope.fd.ErrorMsg = scope.fd.Parameters?.ErrorNotEnoughFiles || ('You need to select at least '  + scope.fd.Parameters.rules[i].min + ' file!')                              
                            }	  else {
                                formCtrl['uploadFileForm'+scope.fd.PresentationId].$setValidity('NotEnoughFiles', true);  
                            }
                        
                        
                        if (scope.fd.Parameters.rules[i].max!=undefined )
                            if (filesFound > scope.fd.Parameters.rules[i].max) {
                                formCtrl['uploadFileForm'+scope.fd.PresentationId].$setValidity('TooManyFiles', false);
                                 scope.fd.ErrorMsg = scope.fd.Parameters?.ErrorTooManyFiles || ('More than '  + scope.fd.Parameters.rules[i].max + ' file(s) selected!')
                            }	else    {  formCtrl['uploadFileForm'+scope.fd.PresentationId].$setValidity('TooManyFiles', true);
                            }
                 
                }
					
		//if (scope.fd.Parameters.rules.length>0)
                       // if (scope.fd.localVars.files.length < scope.fd.Parameters.rules[0].min) formCtrl['uploadFileForm'+scope.fd.PresentationId].$setValidity('MinimumFilesNeeded', false); 
                        //else formCtrl['uploadFileForm'+scope.fd.PresentationId].$setValidity('MinimumFilesNeeded', true); }
  
		
                return errMsg;
					
         }//test_RULES
               
	scope.verify_files = function(){
        
                                 
                var csrf_token = $cookies.get('csrftoken'); 
			
                // ZA svaki FAJL pojedinaèno !
                scope.fd.uiUploader.startUpload(scope.fd.PresentationId,{  
                        url: 'api/verify-file/', 
                        headers: {'X-CSRFToken' : csrf_token },
                                //concurrency: 3,
                                // u data napuniti podatke vezane za fajl - fileType , ID resursa
                                //data: {form_data:file.form_data,resource_id:file.fileResourceID},
                                //data: {form_data:scope.form_data},
                                onProgress: function(file) {
                                        //$log.info(file.name + '=' + file.humanSize);
                                        $timeout(function() { file.status='Uploading...'; });
                                },
                                onCompleted: function(file, response,status) {
                                        
                                       
                                       if (status==200) {
                                                response = JSON.parse(response);
                                                file.uploadSuccess=true;
                                                if (response.jsonResponseEOS.rows.length>0)
                                                {
                                                        file.blockchainHash = response.jsonResponseEOS.rows[0].hash;
                                                        file.fileFound=true;
                                                }
                                                
                                                else
                                                {
                                                        MessagingService.addMessage("File not found!",'warning');
                                                        file.blockchainHash="";
                                                }
                                                file.eosResponse2 = JSON.stringify(response.jsonResponseEOS,null,2);
                                                file.fileHash = response.fileHash;
                                                
                                                
                                                    
                                        }
                                        else file.uploadSuccess=false;
                                }//on_completed
                        }); //startUpload                                                
                                                              
        }
     	//*******************************************************************************************************
	// 				kt-upload-file BTN_UPLOAD
	//*******************************************************************************************************
        scope.btn_upload = function() {
            				
        // CHECK THE RULES FIRST
         
		var errMsg=scope.fd.testRules();
        let upload_form = formCtrl['uploadFileForm'+scope.fd.PresentationId]
        upload_form.$setSubmitted()

		if (errMsg==null && upload_form.$valid) {
	
        		var csrf_token = $cookies.get('csrftoken'); //'miro';//$cookieStore.get('csrftoken');
			    let url_var = 'api/upload-file/'+scope.fd.PresentationId+'/'
                url_var+= url_var.indexOf('?') >= 0 ?  '&' : '?'
			    let env_from_url = $location.search().env 
                //url_var+= "env=" + sessionStorage.getItem("environment")
        		url_var+= "env=" + env_from_url
				// ZA svaki FAJL pojedinaèno !
        		scope.fd.uiUploader.startUpload(scope.fd.PresentationId,{  
				url: url_var,
				headers: {'X-CSRFToken' : csrf_token,'Authorization':$rootScope.globals.currentUser.authdata },
					//concurrency: 3,
					// u data napuniti podatke vezane za fajl - fileType , ID resursa
					//data: {form_data:file.form_data,resource_id:file.fileResourceID},
                                        //data: {form_data:scope.form_data},
					onProgress: function(file) {
						//$log.info(file.name + '=' + file.humanSize);
                                                $timeout(function() { file.status='Uploading...'; });
                                        },
					onCompleted: function(file, response,status) {
                                                
                                              
                                               if (status==201) {
                                                
                                                        response = JSON.parse(response);
                                                        let file_id=response.file_id; 
                                                        
                                                        $timeout(function() { file.uploadSuccess=true;  });
                                                        file.eosResponse = JSON.stringify(response.jsonResponseEOS,null,2);
                                                        file.eosResponse2 = JSON.stringify(response.jsonResponseEOS2,null,2);
                                                        
                                                        if (file.dashboard.formData && (!scope.fd.Parameters.NoMeta || scope.fd.HasParentDataset))
                                                        {
                                                                var parentDataset=scope.fd.getPreviousTaskWidget("resourceLinkDatasetList");
      
                                                                if (parentDataset['datasetId']==undefined || parentDataset['datasetId']=="") parentDataset['datasetId'] = 0;
                                                                if (parentDataset['datasetRecordId']==undefined || parentDataset['datasetRecordId']=="") parentDataset['datasetRecordId'] = 0;
                                                                file.metaStatus='Saving metadata...'
                                                                let instance_id=scope.fd.taskInstanceId
                                                                if (instance_id==0 || instance_id==undefined) instance_id = scope.resourceDefinition.page_instance_id
                                                                let prev_resource_id = scope.resourceDefinition.prev_task_id
                                                                if (prev_resource_id==0 || prev_resource_id==undefined) prev_resource_id = scope.resourceDefinition.prev_page_id
                                                                //                  fileMetaUpdate (fileId,       fileMetaDefId,         publishId,taskInstanceId,prevTaskId,parentDatasetDefId,parentDatasetId,fileResourceData,fd,page_id) {
                                                                ResourcesDataService.fileMetaUpdate(file_id,file.fileResourceID,file.filePublishId,instance_id,prev_resource_id,parentDataset['datasetId'],parentDataset['datasetRecordId'],file.dashboard.formData,scope.fd,scope.resourceDefinition.uid).then(
                                                                                        
                                                                        function(data) {
                                                                                                                                                
                                                                                MessagingService.addMessage(data.data.msg,'success');
                                                                                file.metaSuccess=true;
                                                                        },function(error){
                                                                                MessagingService.addMessage(error.msg,'error');
                                                                                file.metaError=true;
                                                                                file.metaStatus = error.msg;
                                                                                                                                                
                                                                                                                                                                 
                                                                        });
                                                        } //IF
                                                            
                                                }else 

                                                {
                                                         $timeout(function() { 
                                                                file.uploadSuccess=false;        
                                                               
                                                        })
                                                }
                                        }//on_completed
                                }); //startUpload
		} else {
            MessagingService.addMessage(scope.fd.ErrorMsg,'warning');
		}
        }; // FUNCTION b.n_up1oad
        
        let process_upload = function(data)
        {
           if (scope.resourceDefinition.form_type=='i')
           {
                scope.fd.taskInstanceId = data.task_initiate_id;
           }else
           {
                scope.fd.taskInstanceId = data.task_execute_id;  
           }
           if (scope.fd.localVars.files.length>0 && scope.fd.Parameters.VerifyOnly) scope.verify_files();
           else scope.btn_upload();
           
        }  
        
        scope.ksm = KatalyoStateManager;
        let dependent_field = "Field"+scope.fd.PresentationId;
        let subscribedSubject = scope.resourceDefinition.page_state_id+'-'+"TaskPostProcess";
        let observer = scope.ksm.subscribe(subscribedSubject,dependent_field,"TaskPostProcess",process_upload);
        let state = scope.ksm.getState(subscribedSubject);
        

        let subscribedSubjectPage = "processWidgetsStateName"+scope.resourceDefinition.page_state_id
        let observer_page = scope.ksm.subscribe(subscribedSubjectPage,dependent_field,"widgets_processed",process_upload);
        
        // replaced broadcast with state manager
        scope.$on(scope.resourceDefinition.page_state_id+'-'+"TaskPostProcess"+scope.resourceDefinition.transaction_id,function(event, data){
           
           if (scope.resourceDefinition.form_type=='i')
           {
                scope.fd.taskInstanceId = data.task_initiate_id;
                if (scope.fd.taskInstanceId === undefined) scope.fd.taskInstanceId = scope.resourceDefinition.task_initiate_id;
           }else
           {
                scope.fd.taskInstanceId = data.task_execute_id;
                if (scope.fd.taskInstanceId === undefined) scope.fd.taskInstanceId = scope.resourceDefinition.task_execute_id;
           }
           if (scope.fd.localVars.files.length>0 && scope.fd.Parameters.VerifyOnly) scope.verify_files();
           else scope.btn_upload();
          });
          
          
         

     } //LINK_END 'ktUploadFile'
 

 };
};

export function ktFileDropzone(){
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var checkSize, isTypeValid, processDragOverOrEnter, validMimeTypes;
      
      processDragOverOrEnter = function(event) {
        if (event != null) {
          event.preventDefault();
        }
        event.dataTransfer.effectAllowed = 'copy';
        return false;
      };
      validMimeTypes = attrs.fileDropzone;

      checkSize = function(size) {
        var _ref;

        if (((_ref = attrs.maxFileSize) === (void 0) || _ref === '') || (size / 1024) / 1024 < attrs.maxFileSize) {
          return true;
        } else {
          return false;
        }
      };

      isTypeValid = function(type) {
        if ((validMimeTypes === (void 0) || validMimeTypes === '') || validMimeTypes.indexOf(type) > -1) {
          return true;
        } else {
          alert("Invalid file type.  File must be one of following types " + validMimeTypes);
          return false;
        }
      };

      element.bind('dragover', processDragOverOrEnter);
      element.bind('dragenter', processDragOverOrEnter);

      return element.bind('drop', function(event) {
        var file, name, reader, size, type;
        if (event != null) {
          event.preventDefault();
        }
        reader = new FileReader();
        reader.onload = function(evt) {
          if (checkSize(size) && isTypeValid(type)) {
            return scope.$apply(function() {
              scope.file = evt.target.result;
              if (angular.isString(scope.fileName)) {
                return scope.fileName = name;
              }
            });
          }
        };
        file = event.dataTransfer.files[0];
        name = file.name;
        type = file.type;
        size = file.size;
        reader.readAsDataURL(file);
        return false;
      });
    }
  }
}

'use strict';

export function ktUser () {

        return {
            restrict: 'A',
            controller: function ($scope, $element,$timeout,UserService,ResourcesDataService,$rootScope,ProcessingService,GridsterService,CodesService,$templateCache,$compile){
                $scope.gsrvc = GridsterService;
                $scope.localVars={};
                var lang=$rootScope.globals.currentUser.lang;
                $scope[$scope.fd.id]  = {'fd': $scope.fd}
				if ($scope.fd.searchList) delete $scope.fd.searchList
				
				
				if ( $scope.fd.localVars==undefined) $scope.fd.localVars={}

                if  ($scope.formData==undefined ||  !Array.isArray($scope.formData)) {
                    $scope.formData=[{}]
                }

                if (!$scope.formData[0][$scope.fd.FieldName]) $scope.fd.noValue = true
                let parentWidgetUid = ''

                if ($scope.parentWidget!=undefined) parentWidgetUid = $scope.parentWidget+'-'

                let userValueState= $scope.ksm.addSubject($scope.resourceDefinition.page_state_id+'-'+parentWidgetUid+$scope.fd.UuidRef+"-widgetReady",{widget:$scope.fd.UuidRef,processed:false});
                let userValueStateName = userValueState.subject.name;
                
                
                let widget_ready = function(data)
                {
                    userValueState.subject.setStateChanges = data;
                    userValueState.subject.notifyObservers("widgetReady");
                   
                };
                
                let action_widget_ready = $scope.ksm.addAction(userValueStateName,"widgetReady",widget_ready);

                CodesService.getCodesByName('usertags',lang).then(function (data) {
                        $scope.fd.tagList = data.data; 
                        var pos = $scope.fd.tagList.map(function(e) { return e.id; }).indexOf($scope.fd.UniqueId);
                        if (pos>=0) {
                               $scope.fd.UniqueIdObj=$scope.fd.tagList[pos];
                         }
                     });
                     
                $scope.fd.localVars.searchList=[
                            {id:1,filter:'onlist',code_name:'onlist',name:"On list",icon:"fa fa-check"},
                            {id:2,filter:'notonlist',code_name:'notonlist',name:"Not on list",icon:"fa fa-times"},
                ];
                       

						
                      
                $scope.fd.processFilters = function(filterList)  // get search filter in correct language
                {
                    for (let i=0;i<$scope.fd.localVars.searchList.length;i++)  {
                         let pos = filterList.map(function(e) { return e.id; }).indexOf($scope.fd.localVars.searchList[i].code_name);
                         if (pos>=0) $scope.fd.localVars.searchList[i].name = filterList[pos].name
                    }   
                    if ($scope.fd.Search===undefined || $scope.fd.Search===null)  {
                             $scope.fd.Search=$scope.fd.localVars.searchList[0];  //  initialize to onlist
                    }  
                    if ($scope.fd.Search)  $scope.fd.Search.Value = $scope.formData[0][$scope.fd.FieldName]; 
                    $scope.fd.filterReady=true
                }
                        
                        
                if ($scope.showSearchFilters || $scope.resourceDefinition.form_definition)  {
                         CodesService.getCodesByName('search_filters',lang).then(function (data) {
                              try {
                                    $scope[$scope.fd.id]['fd'].processFilters(data.data) 
                               } catch (err) {
                                       console.log(err)
                               }           
                            });
                }


                $scope.fd.applyListFilters = function(index) {  
                      $scope.fd.Search = $scope.fd.localVars.searchList[index];
                      if( typeof $scope.formData[0][$scope.fd.FieldName] === 'string' ) {
                                $scope.fd.Search.value = [ {'id':$scope.formData[0][$scope.fd.FieldName]} ];
                      }   
                };
                         
                $scope.showProperties = function(event) {
                      $scope.gsrvc.setFieldProperties($scope.fd,event);
                }; 
                
				
                
                if ($scope.fd.PopulateType==null) 
                    $scope.fd.PopulateType=1;
    
                $scope.selectedUsr={};
                $scope.userItem = { selectedUser : null };
                
                $scope.setUser = function (user_id) 
                {      
                   if  ($scope.formData==undefined ||  !Array.isArray($scope.formData)) {
                    $scope.formData=[{}]
                   }
                   let pos = $scope.userList.map(function(e) { return e.id; }).indexOf(user_id);
                   if (pos>=0){
                              $scope.formData[0][$scope.fd.FieldName]=$scope.userList[pos]
                              $scope.fd.Search.Value = [ $scope.formData[0][$scope.fd.FieldName] ];
                              
                   }    
                } 

             
   
                $scope.getUsers = function () 
                {
                  UserService.getUsersGroups('users').then(
                        function(data){
                          $scope.userList = data.data;
                          $scope.localVars.userList = data.data;
                         
                          
                          if ($scope.fd.PopulateType.toString()=='2') {
                                    $scope.setUser($rootScope.globals.currentUser.userid);
                          } else if ($scope.formData!=undefined && $scope.formData.length) {
                                if ($scope.formData[0][$scope.fd.FieldName]!=null && $scope.formData[0][$scope.fd.FieldName]!=undefined && Number($scope.formData[0][$scope.fd.FieldName])!=NaN) {
                                      $scope.setUser($scope.formData[0][$scope.fd.FieldName])
                                }
                                else if ($scope.formData[0][$scope.fd.FieldName]!=null && $scope.formData[0][$scope.fd.FieldName]!=undefined && Array.isArray($scope.formData[0][$scope.fd.FieldName])) {
                                    if ($scope.formData[0][$scope.fd.FieldName].length>0)     
                                        $scope.setUser($scope.formData[0][$scope.fd.FieldName][0])
                                }
                          }
                        $scope.usersLoaded=true
                         
                        $scope.ksm.executeAction(userValueStateName,"widgetReady", {widget:$scope.fd.UuidRef,processed:true});
                    });
                }
          
                $scope.clear = function(event,select) 
                {
                  $scope.formData[0][$scope.fd.FieldName] = null;
                  $scope.fd.Search.value = null;
                  $scope.userItem.selectedUser = null;
                }
                /*
                $scope.$watch('userItem.selectedUser', function(newValue,oldValue){
                    //debugger
                    if ($scope.formData && newValue)  $scope.formData[0][$scope.fd.FieldName]=newValue.id;
                });*/
                let template;
                if ($scope.resourceDefinition.form_definition)
                    template = $templateCache.get('ktdirectivetemplates/ktUser.html');
                else 
                    template = $templateCache.get('ktdirectivetemplates/ktUserExe.html');
                $element.append($compile(template)($scope));  
                
                
                 if ($scope?.fd?.Search==undefined) {
                     if ($scope?.fd?.localVars?.searchList?.length)   $scope.fd.Search = $scope?.fd?.localVars?.searchList[0];  //  initialize to onlist
                  }
        
  				$scope.getUsers();
          

            },
       link: function (scope, elem, attrs) {
           }
        }
  
};
'use strict';

export function ktUserInvite () {
        return {
            restrict: 'A',
		
             templateUrl: 'ktdirectivetemplates/ktUserInvite.html',
             controller: function($scope,GridsterService,WidgetDataExchangeService,UtilityService){
				 
			
				$scope.fd.localVars = {
					calculateFunctions :[ {id:1,name:'sum'},{id:2,name:'mean'},{id:3,name:'min'},{id:4,name:'max'},{id:5,name:'count'} ] ,
					gsrvc: GridsterService,
					ShowAdvancedProperties: true
				}    

                
                //$scope.gsrvc = GridsterService;
				
				
				
                
				if ($scope.fd.localVars==undefined)  $scope.fd.localVars={}
				$scope.fd.localVars.resourceDefinition = $scope.resourceDefinition
				
				$scope.localVars = {gsrvc:GridsterService} //because kt-delete-element
			
				if ($scope.fd.localVars.parentResourceId==undefined) $scope.fd.localVars.parentResourceId = $scope.resourceDefinition.pageId ?? $scope.resourceDefinition.uid // if directly on page 

                $scope.showProperties = function(event)
                {
                  $scope.fd.localVars.gsrvc.setFieldProperties($scope.fd,event);
                }
				
				
				
				  //register widget 
				  var out_fields = ['resourceId']
				  if ($scope.fd.UuidRef==undefined) $scope.fd.UuidRef=UtilityService.uuidv4()
							
				  let w_actions=[]

				  var widgetDefinition = {
					  DEI: [{'name':'resourceLink','displayName':'Dataset record id','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],
						actions: w_actions,
						widgetLabel: 'Label',
						widgetName: 'ktLabel',
						widgetId: $scope.fd.UuidRef,
						task_initiate_id:$scope.taskInitiateId,
						task_execute_id:$scope.taskExecuteId,
						taskId:  $scope.lTaskId,
						resource_id:$scope.resourceDefinition.page_state_id,
						resourceDefId : $scope.fd.Related, 
						output:out_fields,
						parentResourceId:$scope.fd.localVars?.parentResourceId
					}
				  
				  $scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
				  $scope.fd.localVars.localId=$scope.fd.localVars.localWidgetId;
				  $scope.fd.LocalId=$scope.fd.localVars.localWidgetId;
				
				
				
                },//end controler
				
             link: function (scope, elem, attrs) {
              
              if (scope.fd) {
                  if (scope.fd.Parameters == null) scope.fd.Parameters = {} //null or undefined !
                 
                  scope.fd.isLabelStyle = true;
				  scope.fd.Parameters.HideElementProperties = false 
				  
				  //if (scope.fd.Parameters.widgetReference)
							//scope.fd.Parameters.HideElementProperties = false 
				  //else 
					//  scope.fd.Parameters.HideElementProperties = true //hide value properties
						
				  
              }
            
            
           
            }
        };
};
'use strict';

export function ktUsersGroupsSelect ($timeout) {
  
  return {
            restrict: 'A',
            scope:{
                  selectedUsers:'=',
                  selectedGroups:'=',
                  headerLabel:'=?',
                  usersLabel:'=?',
                  groupsLabel:'=?', 
                  updateOnChange:'=?'
             },
           templateUrl: 'ktdirectivetemplates/ktUsersGroupsSelect.html',
           controller: function($scope, $rootScope){
               $scope.CTRL='ktUsersGroupSelect'
               
           },
           
           link: function (scope, elem, attrs) {
                 /* 
                if (scope.selectedUsers==undefined) scope.selectedUsers = [];
                 if (scope.selectedGroups==undefined) scope.selectedGroups = [];
                
                scope.selected = {users:scope.selectedUsers,groups:scope.selectedGroups};
                
              
                scope.$watch('selected.users',function(newValue,oldValue){ 
                    if (newValue!=oldValue && newValue!==undefined)     scope.selectedUsers=newValue;  
                });
             
                scope.$watch('selected.groups',function(newValue,oldValue){
                  if (newValue!=oldValue && newValue!==undefined)       scope.selectedGroups=newValue; 
                });
             
                scope.$watch('selectedUsers',function(newValue,oldValue){
                  if (newValue!=oldValue && newValue!==undefined)        scope.selected.users=newValue;
                });
             
                scope.$watch('selectedGroups',function(newValue,oldValue){
                  if (newValue!=oldValue && newValue!==undefined)         scope.selected.groups=newValue;
                });
               */
       
    
      }
    }
  
};
'use strict';

export function ktVideo ($rootScope,$sce,GridsterService,ResourcesDataService,KatalyoStateManager,WidgetDataExchangeService) {
 return {
      restrict: 'A',
	  controller: function ($scope)
	  {          
      
      
 
 
   },
   
     templateUrl: 'ktdirectivetemplates/ktVideo.html',
     link: function (scope, elem, attrs) {      
      
          if (scope.fd.localVars==undefined) scope.fd.localVars={};
        
        scope.fd.localVars.showMenu = false
      
      
        scope.taskId = scope.resourceDefinition.ResourceDefId;
        scope.fd.localVars.prevTaskExeId =  scope.resourceDefinition.prev_task_id;
        scope.fd.localVars.formType=scope.resourceDefinition.form_type;
        scope.fd.localVars.source_type=scope.resourceDefinition.source_type;
        scope.fd.localVars.taskInitiateId = scope.resourceDefinition.task_initiate_id;
        scope.fd.localVars.taskExecuteId = scope.resourceDefinition.task_execute_id;
        scope.fd.localVars.formDefinition = scope.resourceDefinition.form_definition;
        scope.fd.localVars.resourceRecordId = 0;
        scope.fd.ParentElementId = 0;
        if (scope.fd.localVars.formDefinition==undefined) scope.fd.localVars.formDefinition = false;
        if (scope.fd.localVars.taskInitiateId==undefined) scope.fd.localVars.taskInitiateId =0;
        if (scope.fd.localVars.taskExecuteId==undefined) scope.fd.localVars.taskExecuteId =0;
        if (scope.fd.localVars.prevTaskExeId==undefined) scope.fd.localVars.prevTaskExeId =0;
        if (scope.fd.localVars==undefined)  scope.fd.localVars={}

        var widgetDefinition = {name: 'ktVideo',widgetId: scope.fd.PresentationId,taskId:  scope.taskId,
        task_initiate_id:scope.fd.localVars.taskInitiateId,task_execute_id:scope.fd.localVars.taskExecuteId};
        scope.fd.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
        scope.fd.localVars.LocalId=scope.fd.localVars.localWidgetId;
        scope.fd.LocalId=scope.fd.localVars.localWidgetId;
        
        
        scope.fd.localVars.showMenu = false
        
         scope.fd.localVars.toggleDropdown = function(){
             scope.fd.localVars.showMenu =  scope.fd.localVars.showMenu ? false: true 
         }
         
         
        scope.fd.localVars.setField = function(form,name,value,msg)
        {
            TaskDataService.setField(form,name,value);
             if (msg) MessagingService.addMessage(msg,'info');
        };
                    
        scope.ksm=KatalyoStateManager
                    
    
        
        

        scope.gsrvc= GridsterService;
        
        scope.fd.localVars.setVideoSrc = function(){
             let autoplay = scope.fd.Parameters.AutoPlay ? 1 : 0
        
            scope.videoSrc=$sce.trustAsResourceUrl(scope.fd.Parameters.Url+scope.fd.Parameters.VideoId+'?autoplay='+autoplay+'&mute='+autoplay+'&origin='+scope.fd.Parameters.Origin)
        }
         scope.fd.localVars.setVideoSrc() 
        //https://www.youtube.com/embed/M7lc1UVf-VE?autoplay=1&origin=http://example.com

     }
   };
};
'use strict';

export function ktWeb3Wallet () {
   
   var controller = ['$scope', '$uibModal', '$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','KatalyoStateManager','UtilityService','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,KatalyoStateManager,UtilityService,$templateCache,$compile,$element) {
         
        if ($scope.localVars == undefined) $scope.localVars={};
                
        $scope.localVars.showMenu = false
      
        $scope.localVars.toggleDropdown = function(){
                                       $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
         }
         
         $scope.fd.copyToClipboard = function(text){
            var input = document.getElementById("web3"+$scope.fd.PresentationId);
            input.value = text;
            input.focus();
            input.select();
            document.execCommand('copy');
            $scope.fd.copyAddress = true;
            $timeout(function(){$scope.fd.copyAddress = false;},1000);
          }
         
         
         $scope.fd.linkWeb3Wallet = function()
         {
                $scope.fd.connectingToWallet = true;
                $scope.fd.web3Connected = false;
                $scope.fd.eth_address=null;
                if (window.ethereum) {
                  $scope.fd.web3Exists = true;
                  var web3 = new Web3(window.ethereum);
                                    
                  ethereum.send('eth_requestAccounts').then(function (result) {
                      $timeout(function(){
                           $scope.fd.eth_address = result.result[0];
                           $scope.fd.connectingToWallet = false;
                           if ($scope.fd.eth_address!=null)
                           {
                              $scope.fd.web3Connected = true;
                              web3.eth.net.getNetworkType().then(function(result){$scope.fd.connected_network=result});
                           /*
                              var wei;
                           
                              web3.eth.getBalance($scope.eth_address, function (error, wei) {
                                 if (!error) {
                                    var balance = web3.utils.fromWei(wei, 'ether');
                                    $scope.balance = balance + " ETH";
                                     $scope.fd.balanceChecked = true;
                                 }
                              });
                              */
                           
                           }else  $scope.fd.web3Connected = false;
                      });
                  },function(error){
                        $timeout(function(){
                           $scope.fd.connectingToWallet = false;
                           $scope.fd.web3Connected = false;
                           $scope.fd.error_msg = error.message;
                           
                        });
                  });
                          
                 
                }else                $scope.fd.web3Exists = false;
         }     
        
        // $scope.fd.linkWeb3Wallet();
         
         
      // Unpkg imports
      const Web3Modal = window.Web3Modal?.default;
      const WalletConnectProvider = window.WalletConnectProvider?.default;
      const EvmChains = window.evmChains;
      const Fortmatic = window.Fortmatic;
      
      // Web3modal instance
      var web3Modal;
      
      // Chosen wallet provider given by the dialog window
      var provider;
      
      /**
       * Setup the orchestra
       */
      $scope.fd.init = function () {
         
         
        console.log("WalletConnectProvider is", WalletConnectProvider);
        console.log("Fortmatic is", Fortmatic);
      
        // Tell Web3modal what providers we have available.
        // Built-in web browser provider (only one can exist as a time)
        // like MetaMask, Brave or Opera is added automatically by Web3modal
        const providerOptions = {
          walletconnect: {
            package: WalletConnectProvider,
            options: {
              // Ktlyo key
              infuraId: "d5619a41905a41f88c5e742e4180ef3c",
            }
          },
      
          /* add later ILJ
          fortmatic: {
            package: Fortmatic,
            options: {
              // Mikko's TESTNET api key
              key: "pk_test_391E26A3B43A3350"
            }
          }
          */
        };
        if (Web3Modal!==undefined)
        {
          web3Modal = new Web3Modal({
            cacheProvider: false, // optional
            providerOptions, // required
          });
        }else $scope.fd.error_msg='Error connecting to web3 provider'
      }


      /**
       * Kick in the UI action after Web3modal dialog has chosen a provider
       */
      $scope.fd.fetchAccountData= function () {
         
         $scope.fd.connectingToWallet = true;
         $scope.fd.web3Connected = false;
         $rootScope.globals.web3Connected=$scope.fd.web3Connected;
         $scope.fd.eth_address=null;
        // Get a Web3 instance for the wallet
        const web3 = new Web3(provider);
      
        console.log("Web3 instance is", web3);
         window.web3 = web3;
        // Get connected chain id from Ethereum node
        web3.eth.getChainId().then(function(data){
          $scope.fd.chainId = data;
           $scope.fd.chainData=EvmChains.getChain($scope.fd.chainId);//.then(function(data){
           $scope.fd.connected_network = $scope.fd.chainData.name;
           // $scope.fd.chainData = data;
           // });
         },function(error){
                  $scope.fd.connectingToWallet=false;
                  
            });
        // Load chain information over an HTTP API
       
        
        //set chain name
        //document.querySelector("#network-name").textContent = chainData.name;
      
        // Get list of accounts of the connected wallet
        web3.eth.getAccounts().then(function(data){
            let accounts = data;
            // MetaMask does not give you all accounts, only the selected account
            console.log("Got accounts", accounts);
            //select account here
            $timeout(function(){
               if (accounts.length>0)
               {
                  $scope.fd.eth_address = accounts[0];
                  $scope.fd.web3Connected=true;
                  $rootScope.globals.web3Connected=$scope.fd.web3Connected;
               }
               $scope.fd.connectingToWallet=false;
              
               },function(error){
                  $scope.fd.connectingToWallet=false;
                  
            });
         });
      
        
        
      
      
        // Because rendering account does its own RPC commucation
        // with Ethereum node, we do not want to display any results
        // until data for all accounts is loaded
        
        //don't really understand this
        //await Promise.all(rowResolvers);
      
      }



      /**
       * Fetch account data for UI when
       * - User switches accounts in wallet
       * - User switches networks in wallet
       * - User connects wallet initially
       */
      $scope.fd.refreshAccountData = function () {
       
        $scope.fd.fetchAccountData(provider);

      }


      /**
       * Connect wallet button pressed.
       */
      //async function onConnect() {
         
       $scope.fd.connectWeb3Wallet = function(){  
      
        console.log("Opening a dialog", web3Modal);
        try {
          web3Modal.connect().then(function(data){
            provider = data;
            $rootScope.globals.web3Provider=provider;
             // Subscribe to accounts change
            provider.on("accountsChanged", (accounts) => {
              $scope.fd.fetchAccountData();
            });
       
            // Subscribe to chainId change
            provider.on("chainChanged", (chainId) => {
               $scope.fd.chainId = chainId;
              $scope.fd.fetchAccountData();
            });
       
         // Subscribe to networkId change
         provider.on("networkChanged", (networkId) => {
            $scope.fd.networkId=networkId;
           $scope.fd.fetchAccountData();
         });
       
         $scope.fd.refreshAccountData();
       
            });
        } catch(e) {
          console.log("Could not get a wallet connection", e);
          return;
        }

       }

      /**
       * Disconnect wallet button pressed.
       */
      $scope.fd.disconnectWallet = function () {
      
        console.log("Killing the wallet connection", provider);
      
                  // TODO: Which providers have close method?
                  if(provider.close) {
                    provider.close().then(function(data){
                        
                        
                     });
                
                    // If the cached provider is not cleared,
                    // WalletConnect will default to the existing session
                    // and does not allow to re-scan the QR code with a new wallet.
                    // Depending on your use case you may want or want not his behavir.
                   
                  }
                  $scope.fd.web3Connected = false;
                  $rootScope.globals.web3Connected=$scope.fd.web3Connected;
                  $scope.fd.eth_address=null;
                  web3Modal.clearCachedProvider();
                  provider = null;
                  
                }

         $scope.fd.init();
         //$scope.fd.connectWeb3Wallet();  
         let template
         template = $templateCache.get('ktdirectivetemplates/ktWeb3Wallet.html');
         $element.append($compile(template)($scope)); 

   
  
  
      }];

  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

            }     
  }
  
};
'use strict';

export function ktWidgetDataSourceDef (WidgetDataExchangeService) {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktWidgetDataSourceDef.html',
             controller: function($scope,WidgetDataExchangeService){
                
                },
             link: function (scope, elem, attrs) {
                
                if (!scope.fd) scope.fd={}

                if (!scope.fd.localVars) scope.fd.localVars={}
                scope.fd.localVars.wdes = WidgetDataExchangeService
                if (!scope.fd.localVars.resourceDefinition && scope.resourceDefinition) scope.fd.localVars.resourceDefinition=scope.resourceDefinition
                
                if (!scope.fd.Parameters) scope.fd.Parameters = {}
                if(!scope.fd.Parameters?.DataSources) scope.fd.Parameters.DataSources = []
                scope.fd.localVars.addDataSource=function(widget){
                    let dsName='widget'
                    if (scope.fd.localVars.dsName) dsName = scope.fd.localVars.dsName
                    if (widget) scope.fd.Parameters.DataSources.push({widgetId:widget.id,widgetName:widget.name,srcName:dsName+(scope.fd.Parameters.DataSources.length+1)})
                }
              
                  scope.fd.localVars.delDataSource=function(idx){
                    scope.fd.Parameters.DataSources.splice(idx,1)
                }
              
            }
        }
  
};
'use strict';

export function ktWidgetDataSourceDefWScope (WidgetDataExchangeService) {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktWidgetDataSourceDefWScope.html',
            scope:{
                    
                    localVars : '='
            },
             controller: function($scope,WidgetDataExchangeService){
                
                },
             link: function (scope, elem, attrs) {
                
                scope.wdes = WidgetDataExchangeService

                if (!scope.localVars.resourceDefinition?.Parameters?.DataSources) scope.localVars.resourceDefinition.Parameters.DataSources=[]
                
                scope.addDataSource=function(widget,pWidget,widgetIdx){
                    let dsName='ds'
                    if (scope.localVars.dsName) dsName = scope.localVars.dsName
                    if (widget) scope.localVars.resourceDefinition.Parameters.DataSources.push({widgetId:widget.id,parentWidget:pWidget,widgetIndex:widgetIdx,widgetName:widget.name,srcName:dsName+(scope.localVars.resourceDefinition.Parameters.DataSources.length+1)})
                }
              
                  scope.delDataSource=function(idx){
                    scope.localVars.resourceDefinition.Parameters.DataSources.splice(idx,1)
                }
              
            }
        }
  
};
'use strict';

export function ktWidgetToolbox () {

        return {
                restrict: 'A',
                templateUrl: 'ktdirectivetemplates/ktWidgetToolbox.html',
               
                controller: ['$scope','$rootScope','GridsterService','TaskDefinitionService','KatalyoStateManager','$timeout', function($scope,$rootScope,GridsterService,TaskDefinitionService,KatalyoStateManager,$timeout){
              
                        //$scope.CTRL='ktWidgetToolbox';
                        $scope.gsrvc = GridsterService;
                        $scope.toolboxItems = [];
                        $scope.tds = TaskDefinitionService;
                        $scope.collapsed={};
                        $scope.reloadingToolbox = true;
                        $scope.dragula_bag='bag-'+$scope.gridsterType
                        $scope.gsrvc.destroyDragula($scope.dragula_bag);
                        
                        var widgetHandle = $scope.gridsterType+'-element-drag-handle';
        
                        var setupDragulaResult;
                        
                          $timeout(function(){
                                $('#wizard').hide(400)
                            },6000);
        
                        $scope.gsrvc.setupDragula($scope.dragula_bag,$scope.gridsterType+'-toolbox',widgetHandle);
                        $scope.widgetToolboxItems= $scope.gsrvc.getWidgetToolboxItems($scope.gridsterType);
                        $scope.not_toolbox_group_class='item '+$scope.gridsterType+'-element-drag-handle'
                        //register to state manager
                        $scope.ksm = KatalyoStateManager;

                        let toolbox_loaded = function(data)
                        {
                            $scope.widgetToolboxLoaded(data.state);
                        };
                        
                         let toolbox_reload = function(data)
                        {
                          $scope.widgetToolboxLoaded(data);
                        };
                        
                        let toolboxState= $scope.ksm.addSubject($scope.gridsterType+"ToolBox",null);
                        let toolboxStateName = toolboxState.subject.name;

                        let action_toolbox_loaded = $scope.ksm.addAction(toolboxStateName,"toolboxLoaded",toolbox_loaded);
                        
                        let action_toolbox_reload = $scope.ksm.addAction(toolboxStateName,"toolboxReload",toolbox_reload);
                        
                         $scope.setCollapse=function(value,element_type){
                            if (element_type=="toolboxgroup")
                            {
                                if ($scope.collapsed[value]===undefined) $scope.collapsed[value] = true
                                else
                                {
                                    if ($scope.collapsed[value]) $scope.collapsed[value] = false
                                    else $scope.collapsed[value] = true;
                                }
                            }
                        }

                        $scope.widgetToolboxLoaded=function(value){
                                
                               
                                if (!value)
                                {
                                    $scope.gsrvc.destroyDragula('bag-'+$scope.gridsterType);
                                  
                                }
                                else
                                {
                                    $scope.widgetToolboxItems= $scope.gsrvc.getWidgetToolboxItems($scope.gridsterType);
                                }
               
                        };
                        
                        $scope.toolboxStatus=function(value){
        
                         $scope.gsrvc.SetWidgetToolboxLoaded(value,$scope.gridsterType);
                        };
             
             }],
             link: function (scope, elem, attrs) {
              
                       
              }
      }
};
'use strict';

export function ktWriteSmartContract () {
   
   var controller = ['$scope', '$uibModal','$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','KatalyoStateManager','UtilityService','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,KatalyoStateManager,UtilityService,$templateCache,$compile,$element) {
     
      $scope.localVarsWidget = {};
      //$scope.fd = {};
      $scope.localVarsWidget.searchFormDownloaded = false;
      $scope.localVarsWidget.formLoaded=false;
      $scope.localVarsWidget.src_type_text=CODES_CONST._POPULATE_TYPE_;
      $scope.localVarsWidget.animationsEnabled = true;
      $scope.localVarsWidget.widgetType = 3;
      $scope.gsrvc = GridsterService;
      $scope.localVarsWidget.formParams={formViewType:1,showGridNavigation:true};
      $scope.fd.contractDatasets = true;
      if ($scope.formData==undefined) $scope.formData={};
      if ($scope.formData[$scope.fd.PresentationId]==undefined) $scope.formData[$scope.fd.PresentationId]=[];
      $scope.fd.msgs={};
      $scope.localVarsWidget.datasetMapperType=0;
      $scope.fd.ShowTab=1;
      if ($scope.fd.PopulateType==undefined) $scope.fd.PopulateType="";
      $scope.fd.token1Contract="0x24E3794605C84E580EEA4972738D633E8a7127c8";
      $scope.fd.token1ContractAbi=[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}];;
      $scope.fd.token2Contract="0x1DE5e000C41C8d35b9f1f4985C23988f05831057";
      $scope.fd.token2ContractAbi=[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}];;
      $scope.fd.stakingContract="0x8C05bA21557936E3e0713dCE4F9C3bfc974f4C8E";
      $scope.fd.stakingContractAbi=[{"inputs":[{"internalType":"address","name":"_token1","type":"address"},{"internalType":"address","name":"_token2","type":"address"},{"internalType":"uint256","name":"_apy","type":"uint256"},{"internalType":"uint256","name":"_duration","type":"uint256"},{"internalType":"uint256","name":"_tokenRatio","type":"uint256"},{"internalType":"uint256","name":"_maxStakeAmt1","type":"uint256"},{"internalType":"uint256","name":"_rewardAmt1","type":"uint256"},{"internalType":"address","name":"_owner","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"sentDate","type":"uint256"}],"name":"AddedToBlackList","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"token1","type":"address"},{"indexed":false,"internalType":"address","name":"token2","type":"address"},{"indexed":false,"internalType":"uint256","name":"apy","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"duration","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"maxStakeAmt1","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"maxStakeAmt2","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"rewardAmt1","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"rewardAmt2","type":"uint256"},{"indexed":false,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"uint256","name":"createdAt","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"interestRate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"tokenRatio","type":"uint256"}],"name":"CreatedContract","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"redeemedDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"EarlyRedeemed","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"redeemedDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount2","type":"uint256"}],"name":"EarlyRedeemedAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Received","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"redeemedDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount2","type":"uint256"}],"name":"Redeemed","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"redeemedDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount2","type":"uint256"}],"name":"RedeemedAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"sentDate","type":"uint256"}],"name":"RemovedFromBlackList","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Reverted","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"address","name":"tokenCtr","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Staked","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"startDate","type":"uint256"}],"name":"StartStaking","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"stopDate","type":"uint256"}],"name":"StopStaking","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"sentDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"TransferBackReward","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"sentDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"TransferReward","type":"event"},{"stateMutability":"payable","type":"fallback"},{"inputs":[],"name":"activate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"apy","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"addressList","type":"address[]"},{"internalType":"bool","name":"blStatus","type":"bool"}],"name":"blackList","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"createdAt","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"deActivate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"duration","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"}],"name":"getBlackListedStatus","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getMyInfo","outputs":[{"components":[{"internalType":"address","name":"wallet","type":"address"},{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"createdAt","type":"uint256"},{"internalType":"bool","name":"redeemed","type":"bool"},{"internalType":"uint256","name":"rewardAmt1","type":"uint256"},{"internalType":"uint256","name":"rewardAmt2","type":"uint256"},{"internalType":"uint256","name":"redeemedAt","type":"uint256"},{"internalType":"uint256","name":"stakeEnd","type":"uint256"}],"internalType":"struct KtlyoStaking.Transaction[]","name":"","type":"tuple[]"},{"components":[{"internalType":"uint256","name":"limit1","type":"uint256"},{"internalType":"uint256","name":"limit2","type":"uint256"}],"internalType":"struct KtlyoStaking.MaxLimit","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getMyLimits","outputs":[{"components":[{"internalType":"uint256","name":"limit1","type":"uint256"},{"internalType":"uint256","name":"limit2","type":"uint256"}],"internalType":"struct KtlyoStaking.MaxLimit","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getMyStakings","outputs":[{"components":[{"internalType":"address","name":"wallet","type":"address"},{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"createdAt","type":"uint256"},{"internalType":"bool","name":"redeemed","type":"bool"},{"internalType":"uint256","name":"rewardAmt1","type":"uint256"},{"internalType":"uint256","name":"rewardAmt2","type":"uint256"},{"internalType":"uint256","name":"redeemedAt","type":"uint256"},{"internalType":"uint256","name":"stakeEnd","type":"uint256"}],"internalType":"struct KtlyoStaking.Transaction[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getRewardsInfo","outputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getStakeRewardAmounts","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"}],"name":"getStakings","outputs":[{"components":[{"internalType":"address","name":"wallet","type":"address"},{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"createdAt","type":"uint256"},{"internalType":"bool","name":"redeemed","type":"bool"},{"internalType":"uint256","name":"rewardAmt1","type":"uint256"},{"internalType":"uint256","name":"rewardAmt2","type":"uint256"},{"internalType":"uint256","name":"redeemedAt","type":"uint256"},{"internalType":"uint256","name":"stakeEnd","type":"uint256"}],"internalType":"struct KtlyoStaking.Transaction[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"info","outputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxStakeAmt1","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxStakeAmt2","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"indexId","type":"uint256"}],"name":"redeem","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"redeemAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"indexId","type":"uint256"}],"name":"redeemEarly","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"redeemEarlyAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"rewardAmt1","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"rewardAmt2","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"tokenContract","type":"address"},{"internalType":"uint256","name":"amt","type":"uint256"}],"name":"stake","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"token1","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"token2","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"reward_amount","type":"uint256"}],"name":"transferBackReward","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"reward_amount","type":"uint256"}],"name":"transferReward","outputs":[],"stateMutability":"nonpayable","type":"function"},{"stateMutability":"payable","type":"receive"}];
     
     if ($scope.localVars == undefined)  $scope.localVars= {} 
      $scope.localVars.showMenu = false
      
       $scope.localVars.toggleDropdown = function(){
                           $scope.localVars.showMenu =  $scope.localVars.showMenu ? false: true 
       }
    
     
      $scope.localVarsWidget.gridsterType="resource";
          // $scope.gridsterOpts = GridsterService.getGridsterOptions();
    
    
        
      $scope.localVarsWidget.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: []
      } ;
        
    
  
      //$scope.taskId=$stateParams.id;
      $scope.taskId=$scope.resourceDefinition.ResourceDefId;
      if ($scope.taskId==undefined)  $scope.taskId=$scope.resourceDefinition.ResourceDefId_id;
      if ($scope.taskId==undefined) $scope.taskId=0;
      $scope.localVarsWidget.taskId=$scope.taskId;
      $scope.fd.ParentDatasetDefId=$scope.fd.Related;
      $scope.prevTaskExeId =  $scope.resourceDefinition.prev_task_id;
      $scope.localVarsWidget.formType=$scope.resourceDefinition.form_type;
      $scope.source_type=$scope.resourceDefinition.source_type;
      $scope.taskInitiateId = $scope.resourceDefinition.task_initiate_id;
      $scope.taskExecuteId = $scope.resourceDefinition.task_execute_id;
      $scope.formDefinition = $scope.resourceDefinition.form_definition;
        
      if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
      $scope.localVarsWidget.resourceRecordId=0;
      if ($scope.taskInitiateId==undefined)
      {
        $scope.taskInitiateId =0;
      
      }
      if ($scope.taskExecuteId==undefined)
      {
         $scope.taskExecuteId =0;  
      }
        if ($scope.prevTaskExeId==undefined)
        {
            $scope.prevTaskExeId =0;
        }
        
      //register widget 
      var out_fields = ['resourceId'];
      //if ($scope.fd.LocalId==undefined || $scope.fd.LocalId==null || $scope.fd.LocalId==0)
      //{
         var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'viewResourceWidget',widgetId: $scope.fd.PresentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resourceDefId : $scope.localVarsWidget.selectedResource, output:out_fields, };
         $scope.localVarsWidget.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
         $scope.localVarsWidget.LocalId=$scope.localVarsWidget.localWidgetId;
         $scope.fd.LocalId=$scope.localVarsWidget.localWidgetId;
         //$scope.fd.LocalId=UtilityService.uuidNow();
         
      //}
      $scope.ksm = KatalyoStateManager;
      
       let dependent_field_pid = $scope.fd.LocalId;
        let subscribedSubjectPid = "formDefinitionState"+$scope.taskId+$scope.resourceDefinition.form_type;
        let dependent_field_pid2
        let update_presentation_id2 = function(data) {
            let presentation_id = angular.copy($scope.fd.PresentationId)
            if (data[presentation_id]!==undefined)
            {
                $scope.fd.PresentationId = data[presentation_id];
            //unsubscribe here later after implementing unsubscribe - ToDo
            dependent_field_pid2 = $scope.fd.PresentationId
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
            }
        }
        let update_presentation_id = function(data) {
            if (data[$scope.fd.LocalId]>0 && $scope.fd.PresentationId==0 && data[$scope.fd.LocalId]!==undefined) $scope.fd.PresentationId = data[$scope.fd.LocalId];
          
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
            //unsubscribe here later after implementing unsubscribe - ToDo
        }
        
        
        if ($scope.fd.PresentationId===null || $scope.fd.PresentationId===0)
        {
            let observerPid = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid,"formSaved",update_presentation_id);
        } else{
            dependent_field_pid2 = $scope.fd.PresentationId
            let observerPid2 = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid2,"formSaved",update_presentation_id2);
        }
      
       let apply_value = function(data)
        {
            let do_refresh=false;
            if (data!=undefined)
            {
               if (data != $scope.localVarsWidget.resourceRecordId)
               {
                  if (typeof data ==='number') $scope.localVarsWidget.resourceRecordId= data;
                  else if (Array.isArray(data))
                  {
                     if (data.length>0)
                     {
                      $scope.localVarsWidget.resourceRecordId= data[0].id  
                     }
                  }else
                  {
                     $scope.localVarsWidget.resourceRecordId = data.id;
                  }
                  do_refresh = true;
               }
            }
            //get selectedRecord
            if ($scope.localVarsWidget.resourceRecordId == null) $scope.localVarsWidget.resourceRecordId=0;
            
            if ($scope.localVarsWidget.resourceRecordId>0 && do_refresh) $scope.localVarsWidget.getFormResourceWithData();
            
            
        };
        
      
      if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
      
      if ($scope.fd.Parameters.RefreshOnIdChange)
      {
         
         //find 
         //subscribe observer
           
         let dependent_field = "Field"+$scope.fd.PresentationId;
         let subscribedSubject = "resourceidValueStateName"+$scope.fd.Parameters.ResourceIdItemId+$scope.resourceDefinition.transaction_id;
         let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
         let val = $scope.ksm.getState(subscribedSubject);
         $scope.localVarsWidget.resourceRecordId= val.id;
            
            //get selectedRecord
         if ($scope.localVarsWidget.resourceRecordId == null) $scope.localVarsWidget.resourceRecordId=0;
            
         if ($scope.localVarsWidget.resourceRecordId>0) $scope.localVarsWidget.getFormResourceWithData();
      }
      
      //subscribe observer
      if ($scope.fd.PopulateType.toString().substr(0,1)=="4")
      {
           /**********************************************************************
         ****************** Sync data with State manager **********************
         ***********************************************************************/
        
       
        if ($scope.fd.SrcWidgetId!=undefined && $scope.fd.SrcWidgetId!=null)
        
        {
           
                let dependent_field = "Field"+$scope.fd.SrcWidgetId;
               // let subscribedSubject = $scope.fd.Parameters.SrcWidgetType+"ValueStateName"+$scope.fd.SrcWidgetId;
                let subscribedSubject = "rlistValueStateName"+$scope.fd.SrcWidgetId+$scope.resourceDefinition.transaction_id;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
            
        }  
         
      }
      
      let refresh_widget_data = function()
      
      {
         $scope.localVarsWidget.getFormResourceWithData();    
         
      }
      if ($scope.fd.Parameters.EventName!=undefined)
      {
         if ($scope.fd.Parameters.EventName!="")
         {
            let dependent_field2 = "Field"+$scope.fd.PresentationId;
            let subscribedSubject2 = "task"+$scope.resourceDefinition.transaction_id;
            let observer2 = $scope.ksm.subscribe(subscribedSubject2,dependent_field2,$scope.fd.Parameters.EventName,refresh_widget_data);
         }
      }
      
      $scope.localVarsWidget.showProperties=function(datasetMapperType)
      {
            
            if ($scope.localVarsWidget.datasetMapperType==undefined)
            {
               $scope.localVarsWidget.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.localVarsWidget.datasetMapperType==0 || $scope.localVarsWidget.datasetMapperType!=datasetMapperType) $scope.localVarsWidget.datasetMapperType = datasetMapperType;
               else $scope.localVarsWidget.datasetMapperType=0;
            }
            
      };
           
      $scope.localVarsWidget.setField = function(form,name,value,msg)
      {
         TaskDataService.setField(form,name,value);
         if (msg) MessagingService.addMessage(msg,'info');
      };  
      
      $scope.localVarsWidget.getResourceAll = function () {
          
            ResourcesDataService.getResourceDefAll($scope.fd.Related).then(function(data) {
                               
                             // MessagingService.addMessage(data.msg,'success');
                              $scope.fd.resource = data.data;
                              $scope.localVarsWidget.resourceLoaded = true;
                              
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        };
      //$scope.localVarsWidget.getResourceAll();
      
        
      $scope.localVarsWidget.getFormResourceOriginal = function(datasetId){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
              $scope.localVarsWidget.formLoaded=false;
              ResourcesDataService.getResourceForm(datasetId,"i",lang).then(function(data) {
                            
                                $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                
                                if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                $scope.fd.wItemValue=data.data.widgets;
                                
                           /*
                                var container = $element.children().eq(0);
                                GridsterService.setupDragular($scope.fd.wItemValue,container,'rows-'+$scope.fd.PresentationId,'row-'+$scope.localVarsWidget.gridsterType+'-hadle',true);
                             */   
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.fd.ResourceRecordId}]}]});
						
                                  $scope.localVarsWidget.searchFormDownloaded = true;
                                  //$timeout(function(){$scope.localVarsWidget.formLoaded=true});
                                  $scope.localVarsWidget.formLoaded=true;
                                
                               // $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);     
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      
      $scope.fd.openStakeScreen=function(token){
         
         $scope.fd.ShowTab=2;
         if (token=='BNF') $scope.fd.ShowTab=3;
         $scope.fd.currentTokenTicker=token;
         $scope.fd.confirmation1 = null;
         $scope.fd.transactionHash1 = null;
         $scope.fd.errorMessage1 = null;
         $scope.fd.confirmation2 = null;
         $scope.fd.transactionHash2 = null;
         $scope.fd.errorMessage2 = null;
         
         if ($scope.fd.eth_address==undefined)
         {
            web3.eth.getAccounts().then(function (result) {
                      $timeout(function(){
                           $scope.fd.eth_address = result[0];
                            $scope.fd.getAllowance($scope.fd.eth_address,token);
                           $scope.fd.getMyLimits(token);
                      });
            });
         
         } else
         {
           $scope.fd.getAllowance($scope.fd.eth_address,token);
         $scope.fd.getMyLimits(token); 
            
         }
        
       
      }
      
      $scope.fd.getAllowance = function(wallet,token){
                  
                   var tokenAddress;
                   var tokenABI;
                   var contractAddress = $scope.fd.stakingContract;
                   if (token=="KTLYO")
                   {
                     tokenAddress= $scope.fd.token1Contract;
                     tokenABI = $scope.fd.token1ContractAbi;
                   }else
                   {
                     tokenAddress= $scope.fd.token2Contract;
                     tokenABI = $scope.fd.token2ContractAbi;
                     
                     
                   }
                  
            let web3;       
            if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to web3 wallet!",'error');
            }
                     
               if (web3!=null)
               {
                                var tokenInst = new web3.eth.Contract(tokenABI,tokenAddress);
                                
        
                                tokenInst.methods.allowance(wallet,contractAddress).call().then(function (allowance_raw) {
                                var bal = web3.utils.fromWei(allowance_raw, 'ether');
                                
                                $timeout(function(){$scope.fd.allowance = bal;});
                                });
                  }    
                 
      }
      
         $scope.fd.setAllowance = function(){
                  
                  $scope.fd.confirmation1 = null;
                  $scope.fd.transactionHash1 = null;
                  $scope.fd.errorMessage1 = null;
                   let web3;
                   var tokenAddress,tokenABI;
                   var spender = $scope.fd.stakingContract;
                   var owner = $scope.fd.eth_address;
                   var token = $scope.fd.currentTokenTicker;
                   if (token=="KTLYO")
                   {
                     tokenAddress= $scope.fd.token1Contract;
                     tokenABI = $scope.fd.token1ContractAbi;
                   }else
                   {
                     tokenAddress= $scope.fd.token2Contract;
                     tokenABI = $scope.fd.token2ContractAbi;
                     
                     
                   }
                   if (window.ethereum)
                     {
                      web3= new Web3(window.ethereum);  
                     }else if (window.web3)
                     {
                        web3= new Web3(window.web3); 
                     }else
                     {
                        web3 = null;
                        MessagingService.addMessage("Error connecting to wallet!",'error');
                     }
                              
                        if (web3!=null)
                        {
                                var tokenInst = new web3.eth.Contract(tokenABI,tokenAddress);
                                
                                tokenInst.options.from = owner;
                                let amount_wei = web3.utils.toWei($scope.fd.ApproveAmount.toString(), 'ether');
                                
                                tokenInst.methods.approve(spender,amount_wei).send()
                                .on('transactionHash', function(hash){
                                 
                                    $timeout(function(){$scope.fd.transactionHash1=hash;
                                              $scope.fd.pending1=true;});
                                    
                                 })
                                 .on('confirmation', function(confirmationNumber, receipt){
                                    if (confirmationNumber>0)
                                    {
                                    $timeout(function(){$scope.fd.confirmation1=confirmationNumber;
                                              $scope.fd.pending1=false;
                                             
                                              });
                                     $scope.fd.getAllowance($scope.fd.eth_address,$scope.fd.currentTokenTicker);
                                    }
                                 })
                                 .on('receipt', function(receipt){
                                $timeout(function(){$scope.fd.trxReceipt1=receipt;
                                         $scope.fd.status1=receipt.status;  
                                         });
                                  
                                  //console.log(receipt);

                                 })
                              .on('error', function(error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.
                                  $timeout(function(){$scope.fd.errorMessage1=error.message;
                                 if (receipt!=undefined)  $scope.fd.status1=receipt.status;  
                                  });
                              });
                                
                               
                  } else MessagingService.addMessage("Error connecting to wallet!",'error');     
                 
      }
      
       $scope.fd.stake = function(){
                  
                   var tokenAddress,tokenABI;
                   var contractAddress = $scope.fd.stakingContract;
                   var contractABI = $scope.fd.stakingContractAbi;
                   var owner = $scope.fd.eth_address;
                   var token = $scope.fd.currentTokenTicker;
                   $scope.fd.confirmation2 = null;
                  $scope.fd.transactionHash2 = null;
                  $scope.fd.errorMessage2 = null;
                  let web3;
                   if (token=="KTLYO")
                   {
                     tokenAddress= $scope.fd.token1Contract;
                     tokenABI = $scope.fd.token1ContractAbi;
                   }else
                   {
                     tokenAddress= $scope.fd.token2Contract;
                     tokenABI = $scope.fd.token2ContractAbi;
                     
                     
                   }
                  if (window.ethereum)
                  {
                   web3= new Web3(window.ethereum);  
                  }else if (window.web3)
                  {
                     web3= new Web3(window.web3); 
                  }else
                  {
                     web3 = null;
                     MessagingService.addMessage("Error connecting to web3 wallet!",'error');
                  }
                     
               if (web3!=null)
               {
                  
                               
                                var contractInst = new web3.eth.Contract(contractABI,contractAddress);
                                
                                contractInst.options.from = owner;
                                let amount_wei = web3.utils.toWei($scope.fd.StakeAmount.toString(), 'ether');
                                contractInst.methods.stake(tokenAddress,amount_wei).send()
                                .on('transactionHash', function(hash){
                                 
                                    $timeout(function(){$scope.fd.transactionHash2=hash;
                                              $scope.fd.pending2=true;});
                                    
                                 })
                                 .on('confirmation', function(confirmationNumber, receipt){
                                    if (confirmationNumber>0)
                                    {
                                     $timeout(function(){$scope.fd.confirmation2=confirmationNumber;
                                               $scope.fd.pending2=false;
                                               });
                                    }
                                 })
                                 .on('receipt', function(receipt){
                                 $timeout(function(){$scope.fd.trxReceipt2=receipt;
                                          $scope.fd.status2=receipt.status;  
                                          });
                                  $scope.fd.getAllowance($scope.fd.eth_address,token);
                                  //console.log(receipt);

                                 })
                              .on('error', function(error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.
                                 $timeout(function(){$scope.fd.errorMessage2=error.message;
                                  $scope.fd.pending2=false;
                                  if (receipt!=undefined) $scope.fd.status2=receipt.status;
                                  });
                              });

                              /*
                                  contractInst.methods.stake(tokenAddress,amount_wei).send().then(function (trx) {
                                
                                    MessagingService.addMessage(trx,'success');
                                
                                },function(error){
                                 MessagingService.addMessage(error.message,'error');     
                                 });
                                 */
                  } else MessagingService.addMessage("Error connecting to wallet!",'error');     
                 
      }
      
      $scope.fd.Redeem = function(early,index){
            
            var web3;
            
            if ($scope.fd.msgs[index]==undefined) $scope.fd.msgs[index] = {confirmation : null,transactionHash : null,errorMessage : null,pending:null,trxReceipt:null,status : null};
            else
            {
               $scope.fd.msgs[index].confirmation=null;
               $scope.fd.msgs[index].transactionHash = null;
               $scope.fd.msgs[index].errorMessage = null;
               $scope.fd.msgs[index].trxReceipt = null;
               $scope.fd.msgs[index].pending = null;
               $scope.fd.msgs[index].status = null;
            
            }
            
            $scope.fd.currectIndex=index;      
            
            if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to web3 wallet!",'error');
            }
                     
               if (web3!=null)
               {
                        var contractAddress = $scope.fd.stakingContract;
                        var contractABI = $scope.fd.stakingContractAbi;
                        
                        var contractInst = new web3.eth.Contract(contractABI,contractAddress);
                         
                        web3.eth.getAccounts().then(function (result) { 
                              $scope.fd.eth_address = result[0];
                              
                              contractInst.options.from = $scope.fd.eth_address;
                               
                           if (early)
                           {
                              contractInst.methods.redeemEarly(index).send()
                               .on('transactionHash', function(hash){
                           
                                    $timeout(function(){$scope.fd.msgs[index].transactionHash=hash;
                                       $scope.fd.msgs[index].pending=true;
                                       });
                              
                              })
                              .on('confirmation', function(confirmationNumber, receipt){
                                 if (confirmationNumber>0)
                                    {
                                       $timeout(function(){$scope.fd.msgs[index].confirmation=confirmationNumber;
                                          $scope.fd.msgs[index].pending=false;
                                          
                                          });
                                    }
                              })
                              .on('receipt', function(receipt){
                                 $timeout(function(){
                                       $scope.fd.msgs[index].trxReceipt=receipt;
                                       $scope.fd.msgs[index].status=receipt.status;  
                                        
                                           
                                 });
                               
                                 $scope.fd.getMyStakings();
                                 

                              })
                              .on('error', function(error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.
                                  $timeout(function(){$scope.fd.msgs[index].errorMessage=error.message;
                                          if (receipt!=undefined) $scope.fd.msgs[index].status=receipt.status;
                                           $scope.fd.msgs[index].pending=false;});
                              });
                             
                           }
                           else{
                                 contractInst.methods.redeem(index).send()
                                 .on('transactionHash', function(hash){
                           
                                    $timeout(function(){$scope.fd.msgs[index].transactionHash=hash;
                                             $scope.fd.msgs[index].pending=true;});
                                    
                                 })
                                 .on('confirmation', function(confirmationNumber, receipt){
                                    if (confirmationNumber>0)
                                    {
                                    $timeout(function(){
                                       $scope.fd.msgs[index].confirmation=confirmationNumber;
                                             $scope.fd.msgs[index].pending=false;});
                                    }
                                 })
                                 .on('receipt', function(receipt){
                                    
                                $timeout(function(){
                                 
                                         $scope.fd.msgs[index].trxReceipt=receipt;
                                         $scope.fd.msgs[index].status=receipt.status; 
                                         
                                         
                                         });
                                  $scope.fd.getMyStakings();
                                 

                                 })
                              .on('error', function(error, receipt) { // If the transaction was rejected by the network with a receipt, the second parameter will be the receipt.
                                  $timeout(function(){
                                          $scope.fd.msgs[index].errorMessage=error.message;
                                    
                                          if (receipt!=undefined)  $scope.fd.msgs[index].status=receipt.status;
                                           $scope.fd.msgs[index].pending=false;});
                                 
                              });
                        
                           }
               });
      
            } 
                 
      };
      
      $scope.fd.getBalance = function(token){
                  
                  let web3;
                   var tokenAddress,tokenABI;
                   
                   if (token=="KTLYO")
                   {
                     tokenAddress= $scope.fd.token1Contract;
                     tokenABI = $scope.fd.token1ContractAbi;
                   }else
                   {
                     tokenAddress= $scope.fd.token2Contract;
                     tokenABI = $scope.fd.token2ContractAbi;
                     
                     
                   }
           if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to web3 wallet!",'error');
            }
                     
               if (web3!=null)
               {
                                var tokenInst = new web3.eth.Contract(tokenABI,tokenAddress);
                                          
        
                                tokenInst.methods.balanceOf($scope.fd.eth_address).call().then(function (bal_raw) {
                                var bal = web3.utils.fromWei(bal_raw, 'ether');
                                if (bal<=100)
                                {
                                        $scope.ktlyo_balance_ok = false;
                                        $scope.ktlyo_balance_msg = "Insufficient balance";
                                }else $scope.ktlyo_balance_ok = true;
                                $timeout(function(){$scope.balance_ktlyo = bal+ " KTLYO";});
                                });
                    }   
               };
        
        
         
          $scope.fd.formatNumber = function(input_string){
            let number;
            
           if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to web3 wallet!",'error');
            }
                     
               if (web3!=null)
               {
                  
              
               number = Number(web3.utils.fromWei(input_string, 'ether')).toLocaleString(undefined, { maximumFractionDigits: 18 });
                               
               }
            
            /*
           let decimals = ("000000000000000000" + input_string.substr(input_string.length - 18)).slice(-18);
           if (input_string.length<19) number= "0."+decimals;
           else number = input_string.substring(0,input_string.length - 18)+"."+decimals;
           */
           return number;
          }
          
          
          $scope.fd.getAmount = function(token,forToken,amount,amountReward){
            let number,numberReward;
            
            let tokenTicker = $scope.fd.getTokenTicker(token);
            if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to wallet!",'error');
            }
                     
               if (web3!=null)
               {
               
               number = Number(web3.utils.fromWei(amount, 'ether'));
               numberReward = Number(web3.utils.fromWei(amountReward, 'ether'));
               if (tokenTicker==forToken) number = number+numberReward;
               else number = numberReward;
               number = number.toLocaleString(undefined, { maximumFractionDigits: 4 });
                               
            }
           
           return number;
          }
          
          $scope.fd.isReleased = function(stake){
            
              if (stake.stakeEnd>=$scope.fd.currentDate) return false;
              else return true;
           }
          
         
          
          
          $scope.fd.formatDate = function(input_timestamp){
            let date_var;
            let options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',hour: '2-digit', minute:'2-digit',second:'2-digit',hour12:false };
            date_var = new Date(input_timestamp*1000).toLocaleDateString(undefined,options);
          
           return date_var;
          }
        
        $scope.fd.getTokenTicker = function(tokenAddress){
        
         let tokenTicker;
         if (tokenAddress.toLowerCase()== $scope.fd.token1Contract.toLowerCase())
         {
            tokenTicker="KTLYO";
         }else
         {
            tokenTicker="BNF";
                     
         }
         return tokenTicker;
        }
        
        $scope.fd.setMax = function(){
         
         if ($scope.fd.remainStakeLimit > $scope.fd.allowance) $scope.fd.StakeAmount = $scope.fd.allowance;
         else $scope.fd.StakeAmount = $scope.fd.remainStakeLimit;
         
         
        };
        $scope.fd.setMaxAllowance = function(){
         
         $scope.fd.ApproveAmount = $scope.fd.remainStakeLimit;
         
        };
        $scope.fd.getMyLimits = function(token){
              var lang=$rootScope.globals.currentUser.lang;
             
             if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to wallet!",'error');
            }
                     
               if (web3!=null)
               {                 
                  web3.eth.getAccounts().then(function (result) {
                      $timeout(function(){
                           $scope.fd.eth_address = result[0];
                           if ($scope.fd.eth_address!=null)
                           {
                              
                              //get address and abi
                              var contractAddress = $scope.fd.stakingContract;
                              var contractABI = $scope.fd.stakingContractAbi;
                               
                              var contractInst = new web3.eth.Contract(contractABI,contractAddress);
                                
                                contractInst.options.from = $scope.fd.eth_address;
        
                                contractInst.methods.getMyLimits().call().then(function (data) {
                                    
                                    if (token=="KTLYO") $scope.fd.spentStakeLimit=web3.utils.fromWei(data.limit1,'ether');
                                    else $scope.fd.spentStakeLimit=web3.utils.fromWei(data.limit2,'ether');
                                    
                                    
                                     contractInst.methods.getStakeRewardAmounts().call().then(function (data) {
                                    
                                    $timeout(function(){
                                       if (token=="KTLYO") $scope.fd.maxStakeLimit=web3.utils.fromWei(data[4],'ether');
                                       else $scope.fd.maxStakeLimit=web3.utils.fromWei(data[5],'ether');
                                       $scope.fd.maxStakeLimitPrint = Number($scope.fd.maxStakeLimit).toLocaleString(undefined, { maximumFractionDigits: 18 });
                                       $scope.fd.remainStakeLimit = $scope.fd.maxStakeLimit - $scope.fd.spentStakeLimit;
                                       $scope.fd.remainStakeLimitPrint = Number($scope.fd.remainStakeLimit).toLocaleString(undefined, { maximumFractionDigits: 18 });
                                    })
                                 },
                                function(error){
                                    MessagingService.addMessage(error.message,'error')
                                 });
                                
                                },
                                function(error){
                                    MessagingService.addMessage(error.message,'error')
                                 });
                                
                                contractInst.methods.getStakeRewardAmounts().call().then(function (data) {
                                    
                                    if (token=="KTLYO") $scope.fd.maxStakeLimit=data.maxStakeAmt1;  
                                    else $scope.fd.maxStakeLimit=data.maxStakeAmt2;
                                
                                },
                                function(error){
                                    MessagingService.addMessage(error.message,'error')
                                 });
                             
                              
                           
                           }else MessagingService.addMessage("Error connecting to wallet!",'error') ;
                      });
                  },function(error){
                        $timeout(function(){
                          
                           $scope.fd.error_msg = error.message;
                           
                        });
                  });
                          
                 
                }

        }
         
   
          
          
        $scope.fd.getMyStakings = function(){
              var lang=$rootScope.globals.currentUser.lang;
              $scope.fd.afterQuery=false;
              //$scope.fd.myStakes=[];
            
            if (window.ethereum)
            {
             web3= new Web3(window.ethereum);  
            }else if (window.web3)
            {
               web3= new Web3(window.web3); 
            }else
            {
               web3 = null;
               MessagingService.addMessage("Error connecting to wallet!",'error');
            }
                     
               if (web3!=null)
               {
                  

                                    
                  web3.eth.getAccounts().then(function (result) {
                      
                           $scope.fd.eth_address = result[0];
                           if ($scope.fd.eth_address!=null)
                           {
                              
                              //get address and abi
                              var contractAddress = $scope.fd.stakingContract;
                              var contractABI = $scope.fd.stakingContractAbi;
                               
                              var contractInst = new web3.eth.Contract(contractABI,contractAddress);
                                
                                contractInst.options.from = $scope.fd.eth_address;
        
                                contractInst.methods.getMyStakings().call().then(function (data) {
                                    
                                    $scope.fd.currentDate = Math.floor(Date.now() / 1000);
                                
                                    $timeout(function(){ $scope.fd.myStakes = data;$scope.fd.afterQuery=true;});
                                
                                },
                                function(error){
                                    MessagingService.addMessage(error.message,'error')
                                 });
                             
                              
                           
                           }else MessagingService.addMessage("Error connecting to wallet!",'error') ;
                     
                  },function(error){
                        $timeout(function(){
                          
                           $scope.fd.error_msg = error.message;
                           
                        });
                  });
                          
                 
                }

        }
        
        
        
        //$scope.fd.getMyStakings();
        
        $scope.localVarsWidget.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
               $scope.localVarsWidget.formLoaded=false;
               if ($scope.fd.PresentationId==null)
               {
                    $scope.fd.PresentationId=0;
            
               }
               $scope.localVarsWidget.formLoading=true;
                         
              ResourcesDataService.getResourceFormExtended($scope.fd.Related,$scope.taskId,$scope.localVarsWidget.formType,$scope.fd.PresentationId,"w",lang).then(function(data) {
                               
                                  $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                  if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                  
                                 if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                              
                                $scope.fd.wItemValue=data.data.widgets;
                               
                                
                                  
                                $scope.localVarsWidget.searchFormDownloaded = true;
                                
                                $timeout(function(){    
                                   $scope.localVarsWidget.formLoaded=true;
                                   $scope.localVarsWidget.formLoading=false;
                                });
                                  
                               
                              //  $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 $scope.localVarsWidget.formLoading=false;
                                 
                                
                             });
                              
      };
      
              
        $scope.localVarsWidget.getFormResourceWithData = function(){
              var lang=$rootScope.globals.currentUser.lang;
              $scope.localVarsWidget.formLoaded=false;
              if ($scope.fd.PresentationId==null || $scope.fd.PresentationId==undefined)
              {
                $scope.fd.PresentationId = 0;
                
              }
              
              if ($scope.fd.ParentElementId==null || $scope.fd.ParentElementId==undefined)
              {
                $scope.fd.ParentElementId = 0;
                
              }
              
              
              
              
               if ($scope.localVarsWidget.resourceRecordId==undefined || $scope.localVarsWidget.resourceRecordId==0)
               {
                
                  if ($scope.localVarsWidget.previousTaskData['datasetRecordId']!=undefined && $scope.localVarsWidget.previousTaskData['datasetRecordId']!="" && $scope.localVarsWidget.previousTaskData['datasetId']==$scope.fd.Related) $scope.localVarsWidget.resourceRecordId = $scope.localVarsWidget.previousTaskData['datasetRecordId'];
                
               }
               if (typeof $scope.localVarsWidget.resourceRecordId !=='number' && typeof $scope.localVarsWidget.resourceRecordId !=='string')
               {
                  
                  if (Array.isArray($scope.localVarsWidget.resourceRecordId))
                  {
                     if ($scope.localVarsWidget.resourceRecordId.length>0)
                     {
                        $scope.localVarsWidget.resourceRecordId= $scope.localVarsWidget.resourceRecordId[0].id  
                     
                     }
                  }
                  else $scope.localVarsWidget.resourceRecordId = $scope.localVarsWidget.resourceRecordId.id;                 
               }
               
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.Related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.PopulateType,$scope.fd.ParentElementId,$scope.fd.PresentationId,$scope.prevTaskExeId,$scope.localVarsWidget.formType,$scope.localVarsWidget.widgetType,$scope.localVarsWidget.resourceRecordId,"w",lang).then(function(data) {

                                  $scope.formData[$scope.fd.PresentationId] =  data.data.form_data;
                                  if ($scope.formData[$scope.fd.PresentationId]==undefined) $scope.formData[$scope.fd.PresentationId]=[];
                                  $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                  if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                 
                                  if ($scope.formData[$scope.fd.PresentationId].length>0)
                                  {
                                    $scope.localVarsWidget.resourceRecordId = $scope.formData[$scope.fd.PresentationId][0]['id'];
                                  }
                                  $scope.localVarsWidget.datasetRecordId=$scope.localVarsWidget.resourceRecordId;
                                  if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                    //$scope.fd.wItemValue=data.data.widgets;
                               
                                  // $timeout(function() {
                                     $scope.localVarsWidget.formLoaded=true;
                                    // $scope.localVarsWidget.initiateFormLoaded=true;
                                     $scope.localVarsWidget.formLoading=false;
                                     $scope.localVarsWidget.searchFormDownloaded = true;
                                      
                                  //  });   
                                  
                                   
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - VIEW_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVarsWidget.resourceRecordId}]}]});
                                
                               // $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      
      
           $scope.localVarsWidget.setSelectedDataset = function(id)  {
              
              if ($scope.localVarsWidget.selectedResourceItem==undefined) $scope.localVarsWidget.selectedResourceItem={};
              var pos = $scope.localVarsWidget.resourceList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVarsWidget.selectedResourceItem.id = $scope.localVarsWidget.resourceList[pos].id;
                $scope.localVarsWidget.selectedResourceItem.name = $scope.localVarsWidget.resourceList[pos].name;
                $scope.localVarsWidget.selectedDataset = $scope.localVarsWidget.resourceList[pos];
                $scope.localVarsWidget.selectedResourceItem.name_confirmed = $scope.localVarsWidget.selectedResourceItem.name +' ('+$scope.localVarsWidget.selectedResourceItem.id +')'
                $scope.localVarsWidget.selectedResourceItem_c=$scope.localVarsWidget.selectedResourceItem;
                }
					}
          
                  
          // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
	$scope.localVarsWidget.getResources = function()  {
						
            if ($scope.localVarsWidget.resourceList==undefined) $scope.localVarsWidget.resourceList=[];
          
            var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'smartcontract').then(
						function(data) {
										
											  $scope.localVarsWidget.resourceList = data.data;
                       if ($scope.fd.Related!=null)
                       {
                        $scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
                
                        }     
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					}
   
         
  if ($scope.fd.Related!=null &&  !$scope.formDefinition && !$scope.localVarsWidget.searchFormDownloaded)
  {
    
    // $scope.localVarsWidget.getFormResourceWithData();
    // $scope.localVarsWidget.getDatasets();
    // $scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
    
  }else if ($scope.fd.Related!=null)
  {
     //$scope.localVarsWidget.getFormResource();
     //$scope.localVarsWidget.getResources();
     //$scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
    
  } 

    


       
     
                              
    
            let template
            template = $templateCache.get('ktdirectivetemplates/ktWriteSmartContract.html');
            $element.append($compile(template)($scope)); 

  
      }];

  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

            }     
  }
  
};